const curtainsList1 = [
	{
		"id": 8780116885754,
		"title": "Cronin Linen Look Blackout Custom Curtain",
		"handle": "cronin-linen-look-blackout-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Blackout<br>Weight: Regular (280g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Bleach Safe</p><p>Do Not Dry</p><p>Do Not Iron</p><p>Dry Clean Allowed</p></div>`,
		"description": "<p>Crafted from a soft, tactile texture, Cronin curtains combine elegance with practicality. The 100% blackout design shields your space from the outside world.</p>",
		"published_at": "2025-05-07T16:27:52+08:00",
		"created_at": "2025-05-07T16:27:52+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Black Friday",
			"Blackout",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains",
			"Custom Blackout Curtains > Blackout Curtains",
			"Cyber Monday",
			"Easter Sale",
			"Extra 10%",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"New Year's Day",
			"Sale",
			"Sale > All Curtain Sale",
			"sale top 10",
			"Search blackout",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"ships in 3 days",
			"Soundproof & Blackout Curtains",
			"Spring Time Sale",
			"summer best seller",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10500,
		"price_min": 10500,
		"price_max": 10500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319453925626,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-51-SD-Natural",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011398103290,
					"product_id": 8780116885754,
					"position": 1,
					"created_at": "2025-05-19T19:22:34+08:00",
					"updated_at": "2025-09-01T14:26:07+08:00",
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Living_Room.jpg?v=1756707967",
					"variant_ids": [
						47319453925626
					]
				},
				"available": true,
				"name": "Cronin Linen Look Blackout Custom Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"id": 36055755522298,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Living_Room.jpg?v=1756707967"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Close-up_1024x1024.jpg?v=1756707818"
			},
			{
				"id": 47319453794554,
				"title": "Sliver Grey",
				"option1": "Sliver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-51-SD-Sliver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011399119098,
					"product_id": 8780116885754,
					"position": 3,
					"created_at": "2025-05-19T19:22:48+08:00",
					"updated_at": "2025-09-01T14:26:07+08:00",
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Living_Room.jpg?v=1756707967",
					"variant_ids": [
						47319453794554
					]
				},
				"available": true,
				"name": "Cronin Linen Look Blackout Custom Curtain - Sliver Grey",
				"public_title": "Sliver Grey",
				"options": [
					"Sliver Grey"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"id": 36055756275962,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Living_Room.jpg?v=1756707967"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Close-up_1024x1024.jpg?v=1756707967"
			},
			{
				"id": 47319453827322,
				"title": "Sage Green",
				"option1": "Sage Green",
				"option2": null,
				"option3": null,
				"sku": "THC-51-SD-Sage Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011398463738,
					"product_id": 8780116885754,
					"position": 8,
					"created_at": "2025-05-19T19:22:39+08:00",
					"updated_at": "2025-09-01T14:26:07+08:00",
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Living_Room.jpg?v=1756707967",
					"variant_ids": [
						47319453827322
					]
				},
				"available": true,
				"name": "Cronin Linen Look Blackout Custom Curtain - Sage Green",
				"public_title": "Sage Green",
				"options": [
					"Sage Green"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"id": 36055755653370,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Living_Room.jpg?v=1756707967"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Close-up_1024x1024.jpg?v=1756707967"
			},
			{
				"id": 47319453991162,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-51-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011396563194,
					"product_id": 8780116885754,
					"position": 17,
					"created_at": "2025-05-19T19:22:16+08:00",
					"updated_at": "2025-09-01T14:23:38+08:00",
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Living_Room.jpg?v=1756707818",
					"variant_ids": [
						47319453991162
					]
				},
				"available": true,
				"name": "Cronin Linen Look Blackout Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"id": 36055754408186,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Living_Room.jpg?v=1756707818"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Close-up_1024x1024.jpg?v=1756707818"
			},
			{
				"id": 47319454023930,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-51-SD-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011397546234,
					"product_id": 8780116885754,
					"position": 22,
					"created_at": "2025-05-19T19:22:27+08:00",
					"updated_at": "2025-09-01T14:23:38+08:00",
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Living_Room.jpg?v=1756707818",
					"variant_ids": [
						47319454023930
					]
				},
				"available": true,
				"name": "Cronin Linen Look Blackout Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"id": 36055755227386,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Living_Room.jpg?v=1756707818"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Close-up_1024x1024.jpg?v=1756707818"
			},
			{
				"id": 47319454056698,
				"title": "Camel",
				"option1": "Camel",
				"option2": null,
				"option3": null,
				"sku": "THC-51-SD-Camel",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011397251322,
					"product_id": 8780116885754,
					"position": 27,
					"created_at": "2025-05-19T19:22:21+08:00",
					"updated_at": "2025-09-01T14:23:38+08:00",
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Living_Room.jpg?v=1756707818",
					"variant_ids": [
						47319454056698
					]
				},
				"available": true,
				"name": "Cronin Linen Look Blackout Custom Curtain - Camel",
				"public_title": "Camel",
				"options": [
					"Camel"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
					"id": 36055754670330,
					"position": 27,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Living_Room.jpg?v=1756707818"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Close-up_1024x1024.jpg?v=1756707818"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Living_Room.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-natural.jpg?v=1761212257",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Living_Room.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Front.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Puddle.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-sivergrey.jpg?v=1761212257",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Close-up.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Living_Room.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Front.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Puddle.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-sagegreen.jpg?v=1761212257",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Close-up.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Front.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Puddle.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Fabric.jpg?v=1756707967",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Close-up.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Living_Room.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Front.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Puddle.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-beige.jpg?v=1761212257",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Close-up.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Living_Room.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Front.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Puddle.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-ivory.jpg?v=1761212257",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Close-up.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Living_Room.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Front.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Puddle.jpg?v=1756707818",
			"//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-camel.jpg?v=1761212257",
			"//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Close-up.jpg?v=1756707818"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Living_Room_1024x1024.jpg?v=1756707967",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755522298,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Living_Room.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Living_Room.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36700343533818,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-natural.jpg?v=1761212257"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-natural.jpg?v=1761212257",
				"width": 3072
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055756275962,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Living_Room.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Living_Room.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055756243194,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Front.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Front.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055756308730,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Puddle.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Puddle.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36700343238906,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-sivergrey.jpg?v=1761212257"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-sivergrey.jpg?v=1761212257",
				"width": 3072
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055756341498,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Close-up.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sliver_Grey_Close-up.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755653370,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Living_Room.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Living_Room.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755686138,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Front.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Front.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755718906,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Puddle.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Puddle.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36700343402746,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-sagegreen.jpg?v=1761212257"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-sagegreen.jpg?v=1761212257",
				"width": 3072
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755620602,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Close-up.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Sage_Green_Close-up.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755456762,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Front.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Front.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755587834,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Puddle.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Puddle.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755489530,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Fabric.jpg?v=1756707967"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Fabric.jpg?v=1756707967",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755555066,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Close-up.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Natural_Close-up.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754408186,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Living_Room.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Living_Room.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754506490,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Front.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Front.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754440954,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Puddle.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Puddle.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36700343501050,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-beige.jpg?v=1761212257"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-beige.jpg?v=1761212257",
				"width": 3072
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754473722,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Close-up.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Beige_Close-up.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755227386,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Living_Room.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Living_Room.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755260154,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Front.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Front.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755292922,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Puddle.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Puddle.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36700343369978,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-ivory.jpg?v=1761212257"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-ivory.jpg?v=1761212257",
				"width": 3072
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055755194618,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Close-up.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Ivory_Close-up.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754670330,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Living_Room.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Living_Room.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754604794,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Front.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Front.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754637562,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Puddle.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Puddle.jpg?v=1756707818",
				"width": 2000
			},
			{
				"alt": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36700343795962,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-camel.jpg?v=1761212257"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cronin-linen-look-custom-curtain-camel.jpg?v=1761212257",
				"width": 3072
			},
			{
				"alt": "Cronin Linen Look Blackout Custom Curtain - TheHues",
				"id": 36055754572026,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Close-up.jpg?v=1756707818"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cronin_Linen_Look_Custom_Curtain_Camel_Close-up.jpg?v=1756707818",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Crafted from a soft, tactile texture, Cronin curtains combine elegance with practicality. The 100% blackout design shields your space from the outside world.</p>",
		"url": "/products/cronin-linen-look-blackout-custom-curtain",
		"regular_price": "$105.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-blackout-curtains",
				"title": "Advert Blackout Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-curtains",
				"title": "Blackout Curtains"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/frontpage",
				"title": "Home page"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780117442810,
		"title": "Zoe Linen Look Soft Custom Curtain",
		"handle": "zoe-linen-look-soft-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Light Filtering<br>Weight: Regular (325g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>With a timeless linen look, Zoe curtains bring effortless elegance to any room. Simple yet sophisticated, their clean lines and understated beauty create a serene backdrop</p>",
		"published_at": "2025-05-07T16:28:15+08:00",
		"created_at": "2025-05-07T16:28:15+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Black Friday",
			"Blackout available",
			"CHANGEHOVER",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"New Year's Day",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat",
			"ship in 3 days",
			"ships in 3 days",
			"Spring Time Sale",
			"Summer Collection"
		],
		"price": 9900,
		"price_min": 9900,
		"price_max": 9900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319393730810,
				"title": "Silver White",
				"option1": "Silver White",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Silver White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046874509562,
					"product_id": 8780117442810,
					"position": 1,
					"created_at": "2025-05-23T11:54:41+08:00",
					"updated_at": "2025-09-01T14:51:27+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2-1_resolution-standardv2-2x_1949aa5c-4b49-48a1-81f5-131ad31a7d43.jpg?v=1756709487",
					"variant_ids": [
						47319393730810
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Silver White",
				"public_title": "Silver White",
				"options": [
					"Silver White"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36076852740346,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2-1_resolution-standardv2-2x_1949aa5c-4b49-48a1-81f5-131ad31a7d43.jpg?v=1756709487"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250523-Asilver-white-3_1__resolution-standardv2-2x_05998c96-0756-4067-bf6e-f980b072d937_1024x1024.jpg?v=1758093362"
			},
			{
				"id": 47319393698042,
				"title": "Ivory White",
				"option1": "Ivory White",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Ivory White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011464655098,
					"product_id": 8780117442810,
					"position": 3,
					"created_at": "2025-05-19T19:37:29+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-1_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393698042
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Ivory White",
				"public_title": "Ivory White",
				"options": [
					"Ivory White"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055801266426,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-1_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aivory-white-1_resolution-highfidelityv2-2x_1024x1024.jpg?v=1758093362"
			},
			{
				"id": 47319393763578,
				"title": "Haze Blue",
				"option1": "Haze Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Haze Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011464491258,
					"product_id": 8780117442810,
					"position": 11,
					"created_at": "2025-05-19T19:37:28+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ahaze-blue-1_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393763578
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Haze Blue",
				"public_title": "Haze Blue",
				"options": [
					"Haze Blue"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055800742138,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ahaze-blue-1_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ahaze-blue-1_2__resolution-highfidelityv2-2x_1024x1024.jpg?v=1758093362"
			},
			{
				"id": 47319393796346,
				"title": "Navy Blue",
				"option1": "Navy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Navy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011464917242,
					"product_id": 8780117442810,
					"position": 16,
					"created_at": "2025-05-19T19:37:33+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393796346
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Navy Blue",
				"public_title": "Navy Blue",
				"options": [
					"Navy Blue"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055801528570,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-highfidelityv2-2x_1024x1024.jpg?v=1758093362"
			},
			{
				"id": 47319393829114,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011459674362,
					"product_id": 8780117442810,
					"position": 21,
					"created_at": "2025-05-19T19:36:42+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abrown-2-2-1_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393829114
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055798022394,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abrown-2-2-1_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319393861882,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011463016698,
					"product_id": 8780117442810,
					"position": 26,
					"created_at": "2025-05-19T19:37:17+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agrey-2-3_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393861882
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055800512762,
					"position": 26,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agrey-2-3_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319393894650,
				"title": "Caramel",
				"option1": "Caramel",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Caramel",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011460493562,
					"product_id": 8780117442810,
					"position": 31,
					"created_at": "2025-05-19T19:36:53+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Acaramel-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393894650
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Caramel",
				"public_title": "Caramel",
				"options": [
					"Caramel"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055798710522,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Acaramel-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319393927418,
				"title": "Angora",
				"option1": "Angora",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Angora",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44407350100218,
					"product_id": 8780117442810,
					"position": 36,
					"created_at": "2025-07-02T11:42:13+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Aangora-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47319393927418
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Angora",
				"public_title": "Angora",
				"options": [
					"Angora"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36305900241146,
					"position": 36,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Aangora-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319393960186,
				"title": "Straw Brown",
				"option1": "Straw Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Straw Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046875590906,
					"product_id": 8780117442810,
					"position": 84,
					"created_at": "2025-05-23T11:54:48+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-2_resolution-standardv2-2x_2790ceda-b7bf-4d36-9550-1efe0ddfab95.jpg?v=1758093362",
					"variant_ids": [
						47319393960186
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Straw Brown",
				"public_title": "Straw Brown",
				"options": [
					"Straw Brown"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36076853068026,
					"position": 84,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-2_resolution-standardv2-2x_2790ceda-b7bf-4d36-9550-1efe0ddfab95.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319393992954,
				"title": "Silver Grey",
				"option1": "Silver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Silver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046874345722,
					"product_id": 8780117442810,
					"position": 74,
					"created_at": "2025-05-23T11:54:39+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_resolution-standardv2-2x_11906100-051d-4d46-b251-45dae76b2746.jpg?v=1758093362",
					"variant_ids": [
						47319393992954
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Silver Grey",
				"public_title": "Silver Grey",
				"options": [
					"Silver Grey"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36076852609274,
					"position": 74,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_resolution-standardv2-2x_11906100-051d-4d46-b251-45dae76b2746.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328925057274,
				"title": "Dark Rose",
				"option1": "Dark Rose",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Dark Rose",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011461214458,
					"product_id": 8780117442810,
					"position": 56,
					"created_at": "2025-05-19T19:37:04+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Adark-rose-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47328925057274
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Dark Rose",
				"public_title": "Dark Rose",
				"options": [
					"Dark Rose"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055798972666,
					"position": 56,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Adark-rose-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328925090042,
				"title": "Sage Green",
				"option1": "Sage Green",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Sage Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046873985274,
					"product_id": 8780117442810,
					"position": 69,
					"created_at": "2025-05-23T11:54:35+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-2_resolution-standardv2-2x_aa851e21-1fbb-49bd-9674-52d0c2ec99fb.jpg?v=1758093362",
					"variant_ids": [
						47328925090042
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Sage Green",
				"public_title": "Sage Green",
				"options": [
					"Sage Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36076852445434,
					"position": 69,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-2_resolution-standardv2-2x_aa851e21-1fbb-49bd-9674-52d0c2ec99fb.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250523-Asage-green-3-1_11__resolution-standardv2-2x_96a6b2a9-b019-4ea5-9716-6c3251d5fede_1024x1024.jpg?v=1758093362"
			},
			{
				"id": 47328925122810,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046875001082,
					"product_id": 8780117442810,
					"position": 79,
					"created_at": "2025-05-23T11:54:47+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-2_resolution-standardv2-2x_df4cc88f-2e8d-4ec9-a39b-ee5b457e80de.jpg?v=1758093362",
					"variant_ids": [
						47328925122810
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36076852871418,
					"position": 79,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-2_resolution-standardv2-2x_df4cc88f-2e8d-4ec9-a39b-ee5b457e80de.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328925155578,
				"title": "Forest Green",
				"option1": "Forest Green",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Forest Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011461902586,
					"product_id": 8780117442810,
					"position": 51,
					"created_at": "2025-05-19T19:37:09+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Aforest-green-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47328925155578
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Forest Green",
				"public_title": "Forest Green",
				"options": [
					"Forest Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055799595258,
					"position": 51,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Aforest-green-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328925188346,
				"title": "Oatmeal",
				"option1": "Oatmeal",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Oatmeal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046873755898,
					"product_id": 8780117442810,
					"position": 64,
					"created_at": "2025-05-23T11:54:32+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_resolution-standardv2-2x_fbfd3d61-4ef9-4d39-b153-82ed456561ef.jpg?v=1758093362",
					"variant_ids": [
						47328925188346
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Oatmeal",
				"public_title": "Oatmeal",
				"options": [
					"Oatmeal"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36076851888378,
					"position": 64,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_resolution-standardv2-2x_fbfd3d61-4ef9-4d39-b153-82ed456561ef.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328925221114,
				"title": "Dark Green",
				"option1": "Dark Green",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Dark Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011460722938,
					"product_id": 8780117442810,
					"position": 46,
					"created_at": "2025-05-19T19:37:00+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Adark-green-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47328925221114
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Dark Green",
				"public_title": "Dark Green",
				"options": [
					"Dark Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055798874362,
					"position": 46,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Adark-green-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328925253882,
				"title": "Golden Brown",
				"option1": "Golden Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-58-SD-Golden Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011462066426,
					"product_id": 8780117442810,
					"position": 41,
					"created_at": "2025-05-19T19:37:15+08:00",
					"updated_at": "2025-09-17T15:16:02+08:00",
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agolden-brown-2_resolution-standardv2-2x.jpg?v=1758093362",
					"variant_ids": [
						47328925253882
					]
				},
				"available": true,
				"name": "Zoe Linen Look Soft Custom Curtain - Golden Brown",
				"public_title": "Golden Brown",
				"options": [
					"Golden Brown"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
					"id": 36055799824634,
					"position": 41,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agolden-brown-2_resolution-standardv2-2x.jpg?v=1758093362"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250523-Asilver-white-2-1_resolution-standardv2-2x_1949aa5c-4b49-48a1-81f5-131ad31a7d43.jpg?v=1756709487",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-silverwhite_261afa35-276c-4489-8db2-803a0ad63af0.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Ahoneyview_114-1_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-ivorywhite.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/A1-layer-1-scaled_2__resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aivory-white-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Ahoneyview_114-4_6__resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aivory-white-3_5__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Ahoneyview_114-5_7__resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Ahaze-blue-1_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Ahaze-blue-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-hazeblue.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Ahaze-blue-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Ahaze-blue-3_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Anavy-blue-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Anavy-blue-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-navyblue.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Anavy-blue-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Abrown-2-2-1_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-brown.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Abrown-2_5__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Abrown-3-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Agrey-2-3_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Agrey-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-grey.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Agrey-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Agrey-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Acaramel-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Acaramel-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-caramel.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Acaramel-2_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Acaramel-3_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aangora-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aangora-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-angora.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Aangora-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aangora-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Agolden-brown-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Agolden-brown-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-goldenbrown.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Agolden-brown-3-1_16__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Agolden-brown-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Adark-green-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Adark-green-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-darkgreen.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Adark-green-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Adark-green-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aforest-green-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aforest-green-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-forestgreen.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Aforest-green-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aforest-green-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Adark-rose-2_resolution-standardv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Adark-rose-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-darkrose.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/Adark-rose-2_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Adark-rose-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asilver-white-2_1__resolution-standardv2-2x_6691b26d-a980-42de-8a03-659201b6028d.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asilver-white-3_1__resolution-standardv2-2x_05998c96-0756-4067-bf6e-f980b072d937.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asilver-white-1_3__resolution-standardv2-2x_c1096d1c-537a-4306-9b78-987f68381b13.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_resolution-standardv2-2x_fbfd3d61-4ef9-4d39-b153-82ed456561ef.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_1__resolution-standardv2-2x_8c691447-7516-43cf-ae40-bc0a7278c820.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Aoatmeal-3-2_14__resolution-standardv2-2x_8863422b-720c-4d22-8083-7825e41e46da.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Aoatmeal-1_3__resolution-standardv2-2x_6b3487c7-d9be-4ca0-b354-565315f04b46.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-zoe_oatmeal.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/20250523-Asage-green-2_resolution-standardv2-2x_aa851e21-1fbb-49bd-9674-52d0c2ec99fb.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asage-green-2_1__resolution-standardv2-2x_f16a5dd1-7fc7-42ab-bb59-fddc14bbf736.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-sagegreen.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/20250523-Asage-green-3-1_11__resolution-standardv2-2x_96a6b2a9-b019-4ea5-9716-6c3251d5fede.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asage-green-1_3__resolution-standardv2-2x_1dd82796-350c-4e59-b65f-c11967019455.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_resolution-standardv2-2x_11906100-051d-4d46-b251-45dae76b2746.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_1__resolution-standardv2-2x_6ea5d97c-d88b-4a9a-aac8-e81a4e94bff6.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-sivergrey.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/20250523-Asilver-grey-3_2__resolution-standardv2-2x_5506bce0-9deb-4e84-8df9-b75cc46b3152.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Asilver-grey-1_3__resolution-standardv2-2x_7b09e470-3f2e-4cc0-9629-ac2ba618ba8e.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Astone-blue-2_resolution-standardv2-2x_df4cc88f-2e8d-4ec9-a39b-ee5b457e80de.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Astone-blue-3_1__resolution-standardv2-2x_0bddddeb-0ff7-49cb-81be-7be4002419a2.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-stoneblue.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/20250523-Astone-blue-2_2__resolution-standardv2-2x_91d32186-1851-4fab-83f8-7ceb747c2e40.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Astone-blue-1_3__resolution-standardv2-2x_b36374dc-0e31-412b-b705-1d60ee760e21.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Astraw-brown-2_resolution-standardv2-2x_2790ceda-b7bf-4d36-9550-1efe0ddfab95.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Astraw-brown-3-2_1__resolution-standardv2-2x_df9bfc9c-6a52-4cab-821a-d9575f6a8f5d.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-strawbrown.jpg?v=1761212543",
			"//thehues.com/cdn/shop/files/20250523-Astraw-brown-2-2_8__resolution-standardv2-2x_2b8aa8d0-a34d-4232-84f2-77953574ddb8.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/20250523-Astraw-brown-1-2_3__resolution-standardv2-2x_bec66911-68be-46fc-830b-435ea3784bde.jpg?v=1758093362",
			"//thehues.com/cdn/shop/files/Aivory-white-1_resolution-highfidelityv2-2x.jpg?v=1758093362"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2-1_resolution-standardv2-2x_1949aa5c-4b49-48a1-81f5-131ad31a7d43_1024x1024.jpg?v=1756709487",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36076852740346,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2-1_resolution-standardv2-2x_1949aa5c-4b49-48a1-81f5-131ad31a7d43.jpg?v=1756709487"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2-1_resolution-standardv2-2x_1949aa5c-4b49-48a1-81f5-131ad31a7d43.jpg?v=1756709487",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36828477948154,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1800,
					"width": 1200,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-silverwhite_261afa35-276c-4489-8db2-803a0ad63af0.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 1800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-silverwhite_261afa35-276c-4489-8db2-803a0ad63af0.jpg?v=1761212543",
				"width": 1200
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055801266426,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-1_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-1_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413952250,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-ivorywhite.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-ivorywhite.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055801659642,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055801626874,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A1-layer-1-scaled_2__resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A1-layer-1-scaled_2__resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055801430266,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory-white-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory-white-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055801299194,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-4_6__resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-4_6__resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055801463034,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory-white-3_5__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory-white-3_5__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055801364730,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-5_7__resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahoneyview_114-5_7__resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055800742138,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahaze-blue-1_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahaze-blue-1_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055800643834,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahaze-blue-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahaze-blue-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413919482,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-hazeblue.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-hazeblue.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055800709370,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahaze-blue-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahaze-blue-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055800676602,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahaze-blue-3_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahaze-blue-3_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055801528570,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055801495802,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413526266,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-navyblue.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-navyblue.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055801561338,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055801594106,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055798022394,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-2-2-1_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-2-2-1_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798087930,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413886714,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-brown.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-brown.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055797989626,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-2_5__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-2_5__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798055162,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-3-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-3-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055800512762,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-2-3_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-2-3_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055800578298,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413493498,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-grey.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-grey.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055800545530,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055800479994,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055798710522,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acaramel-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798644986,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acaramel-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-1_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700414050554,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-caramel.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-caramel.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798677754,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acaramel-2_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-2_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798743290,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acaramel-3_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-3_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36305900241146,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aangora-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aangora-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055797891322,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aangora-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aangora-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413657338,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-angora.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-angora.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055797924090,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aangora-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aangora-3_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055797858554,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aangora-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aangora-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055799824634,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agolden-brown-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agolden-brown-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799791866,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agolden-brown-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agolden-brown-2_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700414017786,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-goldenbrown.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-goldenbrown.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799726330,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agolden-brown-3-1_16__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agolden-brown-3-1_16__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799759098,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agolden-brown-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agolden-brown-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055798874362,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-green-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-green-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798907130,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-green-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-green-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413559034,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-darkgreen.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-darkgreen.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798808826,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-green-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-green-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055798841594,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-green-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-green-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055799595258,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aforest-green-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aforest-green-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799628026,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aforest-green-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aforest-green-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413788410,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-forestgreen.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-forestgreen.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799660794,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aforest-green-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aforest-green-1_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799693562,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aforest-green-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aforest-green-2_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36055798972666,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-rose-2_resolution-standardv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-rose-2_resolution-standardv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799005434,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-rose-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-rose-3_1__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413853946,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-darkrose.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-darkrose.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799070970,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-rose-2_2__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-rose-2_2__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055799038202,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-rose-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-rose-1_3__resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852707578,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2_1__resolution-standardv2-2x_6691b26d-a980-42de-8a03-659201b6028d.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-2_1__resolution-standardv2-2x_6691b26d-a980-42de-8a03-659201b6028d.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852773114,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-3_1__resolution-standardv2-2x_05998c96-0756-4067-bf6e-f980b072d937.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-3_1__resolution-standardv2-2x_05998c96-0756-4067-bf6e-f980b072d937.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852674810,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-1_3__resolution-standardv2-2x_c1096d1c-537a-4306-9b78-987f68381b13.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-white-1_3__resolution-standardv2-2x_c1096d1c-537a-4306-9b78-987f68381b13.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36076851888378,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_resolution-standardv2-2x_fbfd3d61-4ef9-4d39-b153-82ed456561ef.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_resolution-standardv2-2x_fbfd3d61-4ef9-4d39-b153-82ed456561ef.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076851855610,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_1__resolution-standardv2-2x_8c691447-7516-43cf-ae40-bc0a7278c820.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-2_1__resolution-standardv2-2x_8c691447-7516-43cf-ae40-bc0a7278c820.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076851921146,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-3-2_14__resolution-standardv2-2x_8863422b-720c-4d22-8083-7825e41e46da.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-3-2_14__resolution-standardv2-2x_8863422b-720c-4d22-8083-7825e41e46da.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076851822842,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-1_3__resolution-standardv2-2x_6b3487c7-d9be-4ca0-b354-565315f04b46.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Aoatmeal-1_3__resolution-standardv2-2x_6b3487c7-d9be-4ca0-b354-565315f04b46.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700402417914,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-zoe_oatmeal.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-zoe_oatmeal.jpg?v=1761212543",
				"width": 1365
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36076852445434,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-2_resolution-standardv2-2x_aa851e21-1fbb-49bd-9674-52d0c2ec99fb.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-2_resolution-standardv2-2x_aa851e21-1fbb-49bd-9674-52d0c2ec99fb.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852412666,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-2_1__resolution-standardv2-2x_f16a5dd1-7fc7-42ab-bb59-fddc14bbf736.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-2_1__resolution-standardv2-2x_f16a5dd1-7fc7-42ab-bb59-fddc14bbf736.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413821178,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-sagegreen.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-sagegreen.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852478202,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-3-1_11__resolution-standardv2-2x_96a6b2a9-b019-4ea5-9716-6c3251d5fede.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-3-1_11__resolution-standardv2-2x_96a6b2a9-b019-4ea5-9716-6c3251d5fede.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852510970,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-1_3__resolution-standardv2-2x_1dd82796-350c-4e59-b65f-c11967019455.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asage-green-1_3__resolution-standardv2-2x_1dd82796-350c-4e59-b65f-c11967019455.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36076852609274,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_resolution-standardv2-2x_11906100-051d-4d46-b251-45dae76b2746.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_resolution-standardv2-2x_11906100-051d-4d46-b251-45dae76b2746.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852576506,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_1__resolution-standardv2-2x_6ea5d97c-d88b-4a9a-aac8-e81a4e94bff6.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-2_1__resolution-standardv2-2x_6ea5d97c-d88b-4a9a-aac8-e81a4e94bff6.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413755642,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-sivergrey.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-sivergrey.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852642042,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-3_2__resolution-standardv2-2x_5506bce0-9deb-4e84-8df9-b75cc46b3152.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-3_2__resolution-standardv2-2x_5506bce0-9deb-4e84-8df9-b75cc46b3152.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852543738,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-1_3__resolution-standardv2-2x_7b09e470-3f2e-4cc0-9629-ac2ba618ba8e.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Asilver-grey-1_3__resolution-standardv2-2x_7b09e470-3f2e-4cc0-9629-ac2ba618ba8e.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36076852871418,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-2_resolution-standardv2-2x_df4cc88f-2e8d-4ec9-a39b-ee5b457e80de.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-2_resolution-standardv2-2x_df4cc88f-2e8d-4ec9-a39b-ee5b457e80de.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852904186,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-3_1__resolution-standardv2-2x_0bddddeb-0ff7-49cb-81be-7be4002419a2.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-3_1__resolution-standardv2-2x_0bddddeb-0ff7-49cb-81be-7be4002419a2.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413722874,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-stoneblue.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-stoneblue.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852838650,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-2_2__resolution-standardv2-2x_91d32186-1851-4fab-83f8-7ceb747c2e40.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-2_2__resolution-standardv2-2x_91d32186-1851-4fab-83f8-7ceb747c2e40.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076852805882,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-1_3__resolution-standardv2-2x_b36374dc-0e31-412b-b705-1d60ee760e21.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astone-blue-1_3__resolution-standardv2-2x_b36374dc-0e31-412b-b705-1d60ee760e21.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe Linen Look Soft Custom Curtain - TheHues",
				"id": 36076853068026,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-2_resolution-standardv2-2x_2790ceda-b7bf-4d36-9550-1efe0ddfab95.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-2_resolution-standardv2-2x_2790ceda-b7bf-4d36-9550-1efe0ddfab95.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076853133562,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-3-2_1__resolution-standardv2-2x_df9bfc9c-6a52-4cab-821a-d9575f6a8f5d.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-3-2_1__resolution-standardv2-2x_df9bfc9c-6a52-4cab-821a-d9575f6a8f5d.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36700413690106,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-strawbrown.jpg?v=1761212543"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zoe-linen-look-soft-custom-curtain-strawbrown.jpg?v=1761212543",
				"width": 3034
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076853100794,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-2-2_8__resolution-standardv2-2x_2b8aa8d0-a34d-4232-84f2-77953574ddb8.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-2-2_8__resolution-standardv2-2x_2b8aa8d0-a34d-4232-84f2-77953574ddb8.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36076853035258,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-1-2_3__resolution-standardv2-2x_bec66911-68be-46fc-830b-435ea3784bde.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Astraw-brown-1-2_3__resolution-standardv2-2x_bec66911-68be-46fc-830b-435ea3784bde.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": "Zoe 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36055801397498,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory-white-1_resolution-highfidelityv2-2x.jpg?v=1758093362"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory-white-1_resolution-highfidelityv2-2x.jpg?v=1758093362",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36409784959226,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/8b0929ed0f4544dbbd8f22674558de12.thumbnail.0000000000.jpg?v=1753086058"
				},
				"aspect_ratio": 0.563,
				"duration": 23190,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8b0929ed0f4544dbbd8f22674558de12/8b0929ed0f4544dbbd8f22674558de12.SD-480p-0.9Mbps-51613912.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8b0929ed0f4544dbbd8f22674558de12/8b0929ed0f4544dbbd8f22674558de12.HD-1080p-2.5Mbps-51613912.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8b0929ed0f4544dbbd8f22674558de12/8b0929ed0f4544dbbd8f22674558de12.HD-720p-1.6Mbps-51613912.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8b0929ed0f4544dbbd8f22674558de12/8b0929ed0f4544dbbd8f22674558de12.m3u8?v=0",
						"width": 606
					}
				]
			},
			{
				"alt": null,
				"id": 36094215487738,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/886be085df1b42a690d02c3f42bbf661.thumbnail.0000000000.jpg?v=1748330278"
				},
				"aspect_ratio": 0.563,
				"duration": 15540,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/886be085df1b42a690d02c3f42bbf661/886be085df1b42a690d02c3f42bbf661.SD-480p-1.5Mbps-48293199.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/886be085df1b42a690d02c3f42bbf661/886be085df1b42a690d02c3f42bbf661.HD-1080p-7.2Mbps-48293199.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/886be085df1b42a690d02c3f42bbf661/886be085df1b42a690d02c3f42bbf661.HD-720p-4.5Mbps-48293199.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/886be085df1b42a690d02c3f42bbf661/886be085df1b42a690d02c3f42bbf661.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With a timeless linen look, Zoe curtains bring effortless elegance to any room. Simple yet sophisticated, their clean lines and understated beauty create a serene backdrop</p>",
		"url": "/products/zoe-linen-look-soft-custom-curtain",
		"regular_price": "$99.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/frontpage",
				"title": "Home page"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8780115673338,
		"title": "Classic Velvet Custom Curtain",
		"handle": "classic-velvet-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Materia: 100% Polyester<br>Features: Unique Textured Fabric<br>Weight: Regular (295g/m²)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Do Not Iron</p><p>Dry Clean Allowed</p><p></p></div>`,
		"description": "<p>Classic velvet curtains, a symphony of softness and sheen, drape like poetry in motion. Their plush texture invites touch, while their presence exudes an effortless grandeur.</p>",
		"published_at": "2025-05-07T16:27:04+08:00",
		"created_at": "2025-05-07T16:27:04+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Blackout available",
			"CHANGEHOVER",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Solid Velvet Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"New Year's Day",
			"Oeko",
			"sale top 10",
			"Search curtains",
			"Search Pinch pleat",
			"Search velvet",
			"ship in 3 days",
			"Spring Time Sale",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 9500,
		"price_min": 9500,
		"price_max": 9500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319456809210,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011279745274,
					"product_id": 8780115673338,
					"position": 7,
					"created_at": "2025-05-19T18:56:29+08:00",
					"updated_at": "2025-08-26T16:34:12+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/black-1-7.jpg?v=1756197252",
					"variant_ids": [
						47319456809210
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055674224890,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/black-1-7.jpg?v=1756197252"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/black_8ac241e8-d61d-4bc2-bb4d-907bc19141c8_1024x1024.jpg?v=1756197261"
			},
			{
				"id": 47319456841978,
				"title": "Blush Beige",
				"option1": "Blush Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Blush Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011284005114,
					"product_id": 8780115673338,
					"position": 1,
					"created_at": "2025-05-19T18:56:42+08:00",
					"updated_at": "2025-08-26T16:34:11+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_blush_beige_front.jpg?v=1756197251",
					"variant_ids": [
						47319456841978
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Blush Beige",
				"public_title": "Blush Beige",
				"options": [
					"Blush Beige"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055676354810,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_blush_beige_front.jpg?v=1756197251"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ablushbeige_2__resolution-highfidelityv2-2x_1024x1024.jpg?v=1756197267"
			},
			{
				"id": 47319456874746,
				"title": "Dark Green",
				"option1": "Dark Green",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Dark Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011289673978,
					"product_id": 8780115673338,
					"position": 16,
					"created_at": "2025-05-19T18:57:06+08:00",
					"updated_at": "2025-08-26T16:34:13+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/green-1-1.jpg?v=1756197253",
					"variant_ids": [
						47319456874746
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Dark Green",
				"public_title": "Dark Green",
				"options": [
					"Dark Green"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055679697146,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/green-1-1.jpg?v=1756197253"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Adarkgreen_5__resolution-highfidelityv2-2x_1024x1024.jpg?v=1756197268"
			},
			{
				"id": 47319456907514,
				"title": "Gold Brown",
				"option1": "Gold Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Gold Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011287314682,
					"product_id": 8780115673338,
					"position": 22,
					"created_at": "2025-05-19T18:57:00+08:00",
					"updated_at": "2025-08-26T16:34:13+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_Gold_Brown_Front.jpg?v=1756197253",
					"variant_ids": [
						47319456907514
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Gold Brown",
				"public_title": "Gold Brown",
				"options": [
					"Gold Brown"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055678189818,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_Gold_Brown_Front.jpg?v=1756197253"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Agoldbrown_5__resolution-highfidelityv2-2x_1024x1024.jpg?v=1756197268"
			},
			{
				"id": 47319456940282,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011290984698,
					"product_id": 8780115673338,
					"position": 28,
					"created_at": "2025-05-19T18:57:13+08:00",
					"updated_at": "2025-08-26T16:34:14+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/grey-1-5.jpg?v=1756197254",
					"variant_ids": [
						47319456940282
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055680614650,
					"position": 28,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/grey-1-5.jpg?v=1756197254"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319456973050,
				"title": "Ivory White",
				"option1": "Ivory White",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Ivory White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011291476218,
					"product_id": 8780115673338,
					"position": 33,
					"created_at": "2025-05-19T18:57:19+08:00",
					"updated_at": "2025-08-26T16:34:14+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/lvory-1.jpg?v=1756197254",
					"variant_ids": [
						47319456973050
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Ivory White",
				"public_title": "Ivory White",
				"options": [
					"Ivory White"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055680909562,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/lvory-1.jpg?v=1756197254"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457005818,
				"title": "Light Grey",
				"option1": "Light Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Light Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011292623098,
					"product_id": 8780115673338,
					"position": 38,
					"created_at": "2025-05-19T18:57:28+08:00",
					"updated_at": "2025-08-26T16:34:14+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/silver-grey-1-5.jpg?v=1756197254",
					"variant_ids": [
						47319457005818
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Light Grey",
				"public_title": "Light Grey",
				"options": [
					"Light Grey"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055681695994,
					"position": 38,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/silver-grey-1-5.jpg?v=1756197254"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457038586,
				"title": "Navy Blue",
				"option1": "Navy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Navy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011295736058,
					"product_id": 8780115673338,
					"position": 43,
					"created_at": "2025-05-19T18:57:52+08:00",
					"updated_at": "2025-08-26T16:34:15+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/navy-blue-1-1.jpg?v=1756197255",
					"variant_ids": [
						47319457038586
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Navy Blue",
				"public_title": "Navy Blue",
				"options": [
					"Navy Blue"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055683694842,
					"position": 43,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/navy-blue-1-1.jpg?v=1756197255"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457071354,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011297439994,
					"product_id": 8780115673338,
					"position": 49,
					"created_at": "2025-05-19T18:58:08+08:00",
					"updated_at": "2025-08-26T16:34:15+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/stone-blue-1-4.jpg?v=1756197255",
					"variant_ids": [
						47319457071354
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055684940026,
					"position": 49,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/stone-blue-1-4.jpg?v=1756197255"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457104122,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011296522490,
					"product_id": 8780115673338,
					"position": 55,
					"created_at": "2025-05-19T18:58:01+08:00",
					"updated_at": "2025-08-26T16:34:16+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/red-1-2.jpg?v=1756197256",
					"variant_ids": [
						47319457104122
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055684022522,
					"position": 55,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/red-1-2.jpg?v=1756197256"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457136890,
				"title": "Teal Blue",
				"option1": "Teal Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Teal Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011298554106,
					"product_id": 8780115673338,
					"position": 61,
					"created_at": "2025-05-19T18:58:20+08:00",
					"updated_at": "2025-08-26T16:34:16+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/teal-blue-1-6.jpg?v=1756197256",
					"variant_ids": [
						47319457136890
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Teal Blue",
				"public_title": "Teal Blue",
				"options": [
					"Teal Blue"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055685562618,
					"position": 61,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/teal-blue-1-6.jpg?v=1756197256"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457169658,
				"title": "Warm Gold",
				"option1": "Warm Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Warm Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011299930362,
					"product_id": 8780115673338,
					"position": 67,
					"created_at": "2025-05-19T18:58:26+08:00",
					"updated_at": "2025-08-26T16:34:17+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/warm-gold-1.jpg?v=1756197257",
					"variant_ids": [
						47319457169658
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Warm Gold",
				"public_title": "Warm Gold",
				"options": [
					"Warm Gold"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055686152442,
					"position": 67,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/warm-gold-1.jpg?v=1756197257"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457267962,
				"title": "Moss Green",
				"option1": "Moss Green",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Moss Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011293671674,
					"product_id": 8780115673338,
					"position": 85,
					"created_at": "2025-05-19T18:57:42+08:00",
					"updated_at": "2025-08-26T16:34:18+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 800,
					"height": 800,
					"src": "//thehues.com/cdn/shop/files/moss-greem-1.jpg?v=1756197258",
					"variant_ids": [
						47319457267962
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Moss Green",
				"public_title": "Moss Green",
				"options": [
					"Moss Green"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055682253050,
					"position": 85,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 800,
						"width": 800,
						"src": "//thehues.com/cdn/shop/files/moss-greem-1.jpg?v=1756197258"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457300730,
				"title": "Chestnut",
				"option1": "Chestnut",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Chestnut",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011355242746,
					"product_id": 8780115673338,
					"position": 91,
					"created_at": "2025-05-19T19:11:50+08:00",
					"updated_at": "2025-08-26T16:34:19+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Achestnut-11_resolution-standardv2-2x.jpg?v=1756197259",
					"variant_ids": [
						47319457300730
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Chestnut",
				"public_title": "Chestnut",
				"options": [
					"Chestnut"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055725474042,
					"position": 91,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Achestnut-11_resolution-standardv2-2x.jpg?v=1756197259"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457333498,
				"title": "Wild Rose",
				"option1": "Wild Rose",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Wild Rose",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011364253946,
					"product_id": 8780115673338,
					"position": 97,
					"created_at": "2025-05-19T19:13:18+08:00",
					"updated_at": "2025-08-26T16:34:19+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Awild-rose-1_resolution-standardv2-2x.jpg?v=1756197259",
					"variant_ids": [
						47319457333498
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Wild Rose",
				"public_title": "Wild Rose",
				"options": [
					"Wild Rose"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055731437818,
					"position": 97,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Awild-rose-1_resolution-standardv2-2x.jpg?v=1756197259"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319457366266,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-5-SD-Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011298062586,
					"product_id": 8780115673338,
					"position": 103,
					"created_at": "2025-05-19T18:58:14+08:00",
					"updated_at": "2025-08-26T16:34:20+08:00",
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"width": 1000,
					"height": 1000,
					"src": "//thehues.com/cdn/shop/files/taupe-5.jpg?v=1756197260",
					"variant_ids": [
						47319457366266
					]
				},
				"available": true,
				"name": "Classic Velvet Custom Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 9500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Classic Velvet Custom Curtain - TheHues",
					"id": 36055685169402,
					"position": 103,
					"preview_image": {
						"aspect_ratio": 1,
						"height": 1000,
						"width": 1000,
						"src": "//thehues.com/cdn/shop/files/taupe-5.jpg?v=1756197260"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_blush_beige_front.jpg?v=1756197251",
			"//thehues.com/cdn/shop/files/blushbeige_5.jpg?v=1756197251",
			"//thehues.com/cdn/shop/files/blush-beige-3_3.jpg?v=1756197251",
			"//thehues.com/cdn/shop/files/silver-grey-2_1.jpg?v=1756197251",
			"//thehues.com/cdn/shop/files/grey-15_4.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/lvory-4_2.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/black-1-7.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/black-2-1_1.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/black-3-6_2.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/black-4-3_3.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/black-5-1_5.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/black-8_6.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/blush-beige-1_1.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/blush-beige-4_2.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/blush-beige-5_4.jpg?v=1756197252",
			"//thehues.com/cdn/shop/files/green-1-1.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/green-1-2_1.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/green-1-3_2.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/green-1-4_3.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/green-1-5_4.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/darkgreen_5.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_Gold_Brown_Front.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/gold-brown-11_1.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/gold-brown-12_2.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/gold-brown-13_3.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/gold-brown-14_4.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/goldbrown_5.jpg?v=1756197253",
			"//thehues.com/cdn/shop/files/grey-1-5.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/grey-12_1.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/grey-13_2.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/grey-14_3.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/grey_7.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/lvory-1.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/lvory-5_1.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/lvory-3_3.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/lvory-2_4.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/ivory_1.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/silver-grey-1-5.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/silver-grey-3_2.jpg?v=1756197254",
			"//thehues.com/cdn/shop/files/silver-grey-5_3.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/silver-grey-6_4.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/lightgrey_5.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/navy-blue-1-1.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/navy-blue-2-1_1.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/navy-blue-3_2.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/navy-blue-4_3.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/navy-blue-5_4.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/navyblue_6.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/stone-blue-1-4.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/stone-blue-5_1.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/stone-blue-4_2.jpg?v=1756197255",
			"//thehues.com/cdn/shop/files/stone-blue-3-4_3.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/stone-blue-2_4.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/stoneblue_3.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/red-1-2.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/red-1-1-1_1.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/red-1-3_2.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/red-1-4_3.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/red-1-5_4.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/red-5_5.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/teal-blue-1-6.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/teal-blue-1-2_1.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/teal-blue-1-3_2.jpg?v=1756197256",
			"//thehues.com/cdn/shop/files/teal-blue-1-1_3.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/teal-blue-1-4_4.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/tealblue_5.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/warm-gold-1.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/warm-gold-15_1.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/warm-gold-14_2.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/warm-gold-13_3.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/warm-gold-2_4.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/warmgold_8.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/light-pink-1-2.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/light-pink-1-3_1.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/light-pink-1-1_2.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/light-pink-1-4_3.jpg?v=1756197257",
			"//thehues.com/cdn/shop/files/light-pink-1-5_4.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/lightpink_5.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/burgundy-1.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/burgundy-12_1.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/burgundy-13_2.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/burgundy-14_3.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/burgundy-15_4.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/burgundy_13.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/moss-greem-1.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/moss-greem-5_1.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/moss-greem-4_2.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/moss-greem-3_3.jpg?v=1756197258",
			"//thehues.com/cdn/shop/files/moss-greem-2_4.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/mossgreen_5.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Achestnut-11_resolution-standardv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/chestnut-2_1.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Achestnut-3_2__resolution-standardv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Achestnut-4_3__resolution-standardv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Achestnut-5_4__resolution-highfidelityv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Acoffee_5__resolution-highfidelityv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Awild-rose-1_resolution-standardv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-13_resolution-standardv2-2x.jpg?v=1756197259",
			"//thehues.com/cdn/shop/files/Awild-rose-3_2__resolution-standardv2-2x.jpg?v=1756197260",
			"//thehues.com/cdn/shop/files/Awild-rose-4_3__resolution-standardv2-2x.jpg?v=1756197260",
			"//thehues.com/cdn/shop/files/Awild-rose-15_4__resolution-highfidelityv2-2x.jpg?v=1756197260",
			"//thehues.com/cdn/shop/files/Awildrose_5__resolution-highfidelityv2-2x.jpg?v=1756197260",
			"//thehues.com/cdn/shop/files/taupe-5.jpg?v=1756197260",
			"//thehues.com/cdn/shop/files/taupe-1-1_1_93b15b7f-60b3-4b14-8eda-5bb9d38bda31.jpg?v=1756197260",
			"//thehues.com/cdn/shop/files/taupe-2-1_2_9783c27b-d3d6-4eba-8e01-4122b8121952.jpg?v=1756197261",
			"//thehues.com/cdn/shop/files/taupe-4-1_3.jpg?v=1756197261",
			"//thehues.com/cdn/shop/files/taupe-5-1_4.jpg?v=1756197261",
			"//thehues.com/cdn/shop/files/taupe_14.jpg?v=1756197261",
			"//thehues.com/cdn/shop/files/black_8ac241e8-d61d-4bc2-bb4d-907bc19141c8.jpg?v=1756197261",
			"//thehues.com/cdn/shop/files/blushbeige_2.jpg?v=1756197261",
			"//thehues.com/cdn/shop/files/burgundy_5.jpg?v=1756197262",
			"//thehues.com/cdn/shop/files/chestnut-4_3.jpg?v=1756197262",
			"//thehues.com/cdn/shop/files/chestnut-5_4.jpg?v=1756197262",
			"//thehues.com/cdn/shop/files/coffee_5.jpg?v=1756197262",
			"//thehues.com/cdn/shop/files/chestnut-1.jpg?v=1756197262",
			"//thehues.com/cdn/shop/files/chestnut-3_2.jpg?v=1756197262",
			"//thehues.com/cdn/shop/files/goldbrown_15.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/grey-2_5.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/navyblue-2_5.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/red_10.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/stoneblue_5.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/taupe-4_5.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/tealblue_12.jpg?v=1756197263",
			"//thehues.com/cdn/shop/files/warmgold_5.jpg?v=1756197264",
			"//thehues.com/cdn/shop/files/wild-rose-1.jpg?v=1756197264",
			"//thehues.com/cdn/shop/files/wild-rose-2_1.jpg?v=1756197264",
			"//thehues.com/cdn/shop/files/wild-rose-3_2.jpg?v=1756197264",
			"//thehues.com/cdn/shop/files/wild-rose-4_3.jpg?v=1756197264",
			"//thehues.com/cdn/shop/files/wild-rose-15_4.jpg?v=1756197264",
			"//thehues.com/cdn/shop/files/wildrose_5.jpg?v=1756197265",
			"//thehues.com/cdn/shop/files/wildrose_16.jpg?v=1756197265",
			"//thehues.com/cdn/shop/files/Ablack-3-6_2__resolution-standardv2-2x.jpg?v=1756197265",
			"//thehues.com/cdn/shop/files/Ablack-4-3_3__resolution-standardv2-2x.jpg?v=1756197265",
			"//thehues.com/cdn/shop/files/Ablack-5-1_5__resolution-highfidelityv2-2x.jpg?v=1756197265",
			"//thehues.com/cdn/shop/files/Ablack-8_6__resolution-highfidelityv2-2x.jpg?v=1756197265",
			"//thehues.com/cdn/shop/files/Ablack-1-71_resolution-standardv2-2x.jpg?v=1756197266",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1__resolution-standardv2-2x.jpg?v=1756197266",
			"//thehues.com/cdn/shop/files/Ablush-beige-3_3__resolution-standardv2-2x.jpg?v=1756197266",
			"//thehues.com/cdn/shop/files/Ablush-beige-4_2__resolution-standardv2-2x.jpg?v=1756197266",
			"//thehues.com/cdn/shop/files/Ablush-beige-5_4__resolution-highfidelityv2-2x.jpg?v=1756197266",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-1_resolution-standardv2-2x.jpg?v=1756197266",
			"//thehues.com/cdn/shop/files/Ablushbeige_2__resolution-highfidelityv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Ablush-beige-21_resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Aburgundy-11_resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Aburgundy-13_2__resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Aburgundy-14_3__resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Aburgundy-15_4__resolution-highfidelityv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-8_resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Aburgundy_5__resolution-highfidelityv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Agreen-1-3_2__resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Agreen-1-4_3__resolution-standardv2-2x.jpg?v=1756197267",
			"//thehues.com/cdn/shop/files/Agreen-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Ablack-2-2_1_-1_resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Adarkgreen_5__resolution-highfidelityv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agreen-1-1_resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agold-brown-13_3__resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agold-brown-14_4__resolution-highfidelityv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Awqarm-2-1_1__resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agoldbrown_5__resolution-highfidelityv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agold-brown-1_resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agold-brown-12_2__resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agrey-13_2__resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agrey-14_3__resolution-standardv2-2x.jpg?v=1756197268",
			"//thehues.com/cdn/shop/files/Agrey-15_4__resolution-highfidelityv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Ablack-22-1_1_-2_resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Agrey-1-5_resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Agrey-2_5__resolution-highfidelityv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Alvory-2_4__resolution-highfidelityv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Alvory-3_3__resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Alvory-4_2__resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-3_resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Aivory_1__resolution-highfidelityv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Alvory-1_resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Alight-pink-1-1_2__resolution-standardv2-2x.jpg?v=1756197269",
			"//thehues.com/cdn/shop/files/Alight-pink-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-5_resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Alightpink_5__resolution-highfidelityv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Amoss-greem-3_3__resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Amoss-greem-4_2__resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Amossgreen_5__resolution-highfidelityv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-6_resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Amoss-greem-1_resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Amoss-greem-2_4__resolution-highfidelityv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Anavy-blue-4_3__resolution-standardv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Anavy-blue-5_4__resolution-highfidelityv2-2x.jpg?v=1756197270",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-7_resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Anavyblue_6__resolution-highfidelityv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Anavy-blue-1-1_resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Ared-1-4_3__resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Ared-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Ared-5_5__resolution-highfidelityv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-2_resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Ared-1-2_resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Ared-1-3_2__resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Asilver-grey-1-5_resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Asilver-grey-3_2__resolution-standardv2-2x.jpg?v=1756197271",
			"//thehues.com/cdn/shop/files/Asilver-grey-5_3__resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Asilver-grey-6_4__resolution-highfidelityv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-4_resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Alightgrey_5__resolution-highfidelityv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Astone-blue-2_4__resolution-highfidelityv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Astone-blue-3-4_3__resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Astone-blue-4_2__resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-9_resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Astoneblue_3__resolution-highfidelityv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Astone-blue-1-4_resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Ataupe-4-1_3__resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Ataupe-5_resolution-standardv2-2x.jpg?v=1756197272",
			"//thehues.com/cdn/shop/files/Ataupe-5-1_4__resolution-highfidelityv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-10_resolution-standardv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ataupe_14__resolution-highfidelityv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ataupe-2-1_2__resolution-standardv2-2x_df1bed90-869e-4686-a47f-0866d8dd96de.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ateal-blue-1-3_2__resolution-standardv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ateal-blue-1-4_4__resolution-highfidelityv2-2x.jpg?v=1761213065",
			"//thehues.com/cdn/shop/files/Ateal-blue-1-6_resolution-standardv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-11_resolution-standardv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Atealblue_5__resolution-highfidelityv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Ateal-blue-1-1_3__resolution-standardv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Awarm-gold-2_4__resolution-highfidelityv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Awarm-gold-13_3__resolution-standardv2-2x.jpg?v=1756197273",
			"//thehues.com/cdn/shop/files/Awarm-gold-14_2__resolution-standardv2-2x.jpg?v=1756197274",
			"//thehues.com/cdn/shop/files/Ablack-2-1_1_-12_resolution-standardv2-2x.jpg?v=1756197274",
			"//thehues.com/cdn/shop/files/Awarmgold_5__resolution-highfidelityv2-2x.jpg?v=1756197274",
			"//thehues.com/cdn/shop/files/Awarm-gold-1_resolution-standardv2-2x.jpg?v=1756197274"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_blush_beige_front_1024x1024.jpg?v=1756197251",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676354810,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_blush_beige_front.jpg?v=1756197251"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_blush_beige_front.jpg?v=1756197251",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676289274,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blushbeige_5.jpg?v=1756197251"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blushbeige_5.jpg?v=1756197251",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676387578,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blush-beige-3_3.jpg?v=1756197251"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blush-beige-3_3.jpg?v=1756197251",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681728762,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/silver-grey-2_1.jpg?v=1756197251"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/silver-grey-2_1.jpg?v=1756197251",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680549114,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey-15_4.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey-15_4.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680811258,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lvory-4_2.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lvory-4_2.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674224890,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black-1-7.jpg?v=1756197252"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black-1-7.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674257658,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black-2-1_1.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black-2-1_1.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674290426,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black-3-6_2.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black-3-6_2.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674323194,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black-4-3_3.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black-4-3_3.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674355962,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black-5-1_5.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black-5-1_5.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674388730,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black-8_6.jpg?v=1756197252"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black-8_6.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676322042,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blush-beige-1_1.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blush-beige-1_1.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676420346,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blush-beige-4_2.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blush-beige-4_2.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676453114,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blush-beige-5_4.jpg?v=1756197252"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blush-beige-5_4.jpg?v=1756197252",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055679697146,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/green-1-1.jpg?v=1756197253"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/green-1-1.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055679729914,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/green-1-2_1.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/green-1-2_1.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055679566074,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/green-1-3_2.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/green-1-3_2.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055679598842,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/green-1-4_3.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/green-1-4_3.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055679631610,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/green-1-5_4.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/green-1-5_4.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055679664378,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/darkgreen_5.jpg?v=1756197253"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/darkgreen_5.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678189818,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_Gold_Brown_Front.jpg?v=1756197253"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Classic_Velvet_Custom_Curtain_Gold_Brown_Front.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678255354,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/gold-brown-11_1.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/gold-brown-11_1.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678320890,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/gold-brown-12_2.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/gold-brown-12_2.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678386426,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/gold-brown-13_3.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/gold-brown-13_3.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678451962,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/gold-brown-14_4.jpg?v=1756197253"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/gold-brown-14_4.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678517498,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/goldbrown_5.jpg?v=1756197253"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/goldbrown_5.jpg?v=1756197253",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680614650,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey-1-5.jpg?v=1756197254"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey-1-5.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680450810,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey-12_1.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey-12_1.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680483578,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey-13_2.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey-13_2.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680516346,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey-14_3.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey-14_3.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680581882,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey_7.jpg?v=1756197254"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey_7.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680909562,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lvory-1.jpg?v=1756197254"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lvory-1.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680844026,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lvory-5_1.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lvory-5_1.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680975098,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lvory-3_3.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lvory-3_3.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680942330,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lvory-2_4.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lvory-2_4.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680876794,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/ivory_1.jpg?v=1756197254"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ivory_1.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681695994,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/silver-grey-1-5.jpg?v=1756197254"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/silver-grey-1-5.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681761530,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/silver-grey-3_2.jpg?v=1756197254"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/silver-grey-3_2.jpg?v=1756197254",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681597690,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/silver-grey-5_3.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/silver-grey-5_3.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681630458,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/silver-grey-6_4.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/silver-grey-6_4.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681663226,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lightgrey_5.jpg?v=1756197255"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lightgrey_5.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683694842,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navy-blue-1-1.jpg?v=1756197255"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navy-blue-1-1.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683498234,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navy-blue-2-1_1.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navy-blue-2-1_1.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683563770,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navy-blue-3_2.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navy-blue-3_2.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683596538,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navy-blue-4_3.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navy-blue-4_3.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683629306,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navy-blue-5_4.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navy-blue-5_4.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683662074,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navyblue_6.jpg?v=1756197255"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navyblue_6.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684940026,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stone-blue-1-4.jpg?v=1756197255"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stone-blue-1-4.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684841722,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stone-blue-5_1.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stone-blue-5_1.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684808954,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stone-blue-4_2.jpg?v=1756197255"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stone-blue-4_2.jpg?v=1756197255",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684776186,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stone-blue-3-4_3.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stone-blue-3-4_3.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684743418,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stone-blue-2_4.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stone-blue-2_4.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684874490,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stoneblue_3.jpg?v=1756197256"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stoneblue_3.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684022522,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red-1-2.jpg?v=1756197256"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red-1-2.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684219130,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red-1-1-1_1.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red-1-1-1_1.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684055290,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red-1-3_2.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red-1-3_2.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684088058,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red-1-4_3.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red-1-4_3.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684120826,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red-1-5_4.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red-1-5_4.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684153594,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red-5_5.jpg?v=1756197256"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red-5_5.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685562618,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/teal-blue-1-6.jpg?v=1756197256"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/teal-blue-1-6.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685431546,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/teal-blue-1-2_1.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/teal-blue-1-2_1.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685497082,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/teal-blue-1-3_2.jpg?v=1756197256"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/teal-blue-1-3_2.jpg?v=1756197256",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685398778,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/teal-blue-1-1_3.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/teal-blue-1-1_3.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685529850,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/teal-blue-1-4_4.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/teal-blue-1-4_4.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685595386,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/tealblue_5.jpg?v=1756197257"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/tealblue_5.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055686152442,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warm-gold-1.jpg?v=1756197257"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warm-gold-1.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055686054138,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warm-gold-15_1.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warm-gold-15_1.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055686021370,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warm-gold-14_2.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warm-gold-14_2.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685988602,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warm-gold-13_3.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warm-gold-13_3.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685955834,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warm-gold-2_4.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warm-gold-2_4.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055686119674,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warmgold_8.jpg?v=1756197257"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warmgold_8.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682023674,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/light-pink-1-2.jpg?v=1756197257"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/light-pink-1-2.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682056442,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/light-pink-1-3_1.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/light-pink-1-3_1.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681990906,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/light-pink-1-1_2.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/light-pink-1-1_2.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681892602,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/light-pink-1-4_3.jpg?v=1756197257"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/light-pink-1-4_3.jpg?v=1756197257",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681925370,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/light-pink-1-5_4.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/light-pink-1-5_4.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055681958138,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/lightpink_5.jpg?v=1756197258"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lightpink_5.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677337850,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy-1.jpg?v=1756197258"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy-1.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677370618,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy-12_1.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy-12_1.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677403386,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy-13_2.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy-13_2.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677436154,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy-14_3.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy-14_3.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677468922,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy-15_4.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy-15_4.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677305082,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy_13.jpg?v=1756197258"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy_13.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682253050,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/moss-greem-1.jpg?v=1756197258"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/moss-greem-1.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682384122,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/moss-greem-5_1.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/moss-greem-5_1.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682351354,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/moss-greem-4_2.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/moss-greem-4_2.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682318586,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/moss-greem-3_3.jpg?v=1756197258"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/moss-greem-3_3.jpg?v=1756197258",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682285818,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/moss-greem-2_4.jpg?v=1756197259"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/moss-greem-2_4.jpg?v=1756197259",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055682220282,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/mossgreen_5.jpg?v=1756197259"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/mossgreen_5.jpg?v=1756197259",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725474042,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achestnut-11_resolution-standardv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achestnut-11_resolution-standardv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677698298,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/chestnut-2_1.jpg?v=1756197259"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chestnut-2_1.jpg?v=1756197259",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725506810,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achestnut-3_2__resolution-standardv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achestnut-3_2__resolution-standardv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725375738,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achestnut-4_3__resolution-standardv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achestnut-4_3__resolution-standardv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725408506,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achestnut-5_4__resolution-highfidelityv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achestnut-5_4__resolution-highfidelityv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725441274,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acoffee_5__resolution-highfidelityv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acoffee_5__resolution-highfidelityv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731437818,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awild-rose-1_resolution-standardv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awild-rose-1_resolution-standardv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731372282,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-13_resolution-standardv2-2x.jpg?v=1756197259"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-13_resolution-standardv2-2x.jpg?v=1756197259",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731273978,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awild-rose-3_2__resolution-standardv2-2x.jpg?v=1756197260"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awild-rose-3_2__resolution-standardv2-2x.jpg?v=1756197260",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731306746,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awild-rose-4_3__resolution-standardv2-2x.jpg?v=1756197260"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awild-rose-4_3__resolution-standardv2-2x.jpg?v=1756197260",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731339514,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awild-rose-15_4__resolution-highfidelityv2-2x.jpg?v=1756197260"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awild-rose-15_4__resolution-highfidelityv2-2x.jpg?v=1756197260",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731405050,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awildrose_5__resolution-highfidelityv2-2x.jpg?v=1756197260"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awildrose_5__resolution-highfidelityv2-2x.jpg?v=1756197260",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685169402,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1000,
					"width": 1000,
					"src": "//thehues.com/cdn/shop/files/taupe-5.jpg?v=1756197260"
				},
				"aspect_ratio": 1,
				"height": 1000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe-5.jpg?v=1756197260",
				"width": 1000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685267706,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/taupe-1-1_1_93b15b7f-60b3-4b14-8eda-5bb9d38bda31.jpg?v=1756197260"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe-1-1_1_93b15b7f-60b3-4b14-8eda-5bb9d38bda31.jpg?v=1756197260",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685071098,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/taupe-2-1_2_9783c27b-d3d6-4eba-8e01-4122b8121952.jpg?v=1756197261"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe-2-1_2_9783c27b-d3d6-4eba-8e01-4122b8121952.jpg?v=1756197261",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685136634,
				"position": 106,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/taupe-4-1_3.jpg?v=1756197261"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe-4-1_3.jpg?v=1756197261",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685202170,
				"position": 107,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/taupe-5-1_4.jpg?v=1756197261"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe-5-1_4.jpg?v=1756197261",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685234938,
				"position": 108,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/taupe_14.jpg?v=1756197261"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe_14.jpg?v=1756197261",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055674192122,
				"position": 109,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/black_8ac241e8-d61d-4bc2-bb4d-907bc19141c8.jpg?v=1756197261"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black_8ac241e8-d61d-4bc2-bb4d-907bc19141c8.jpg?v=1756197261",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055676256506,
				"position": 110,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blushbeige_2.jpg?v=1756197261"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blushbeige_2.jpg?v=1756197261",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677272314,
				"position": 111,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/burgundy_5.jpg?v=1756197262"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/burgundy_5.jpg?v=1756197262",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677567226,
				"position": 112,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/chestnut-4_3.jpg?v=1756197262"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chestnut-4_3.jpg?v=1756197262",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677599994,
				"position": 113,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/chestnut-5_4.jpg?v=1756197262"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chestnut-5_4.jpg?v=1756197262",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677632762,
				"position": 114,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/coffee_5.jpg?v=1756197262"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/coffee_5.jpg?v=1756197262",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677665530,
				"position": 115,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/chestnut-1.jpg?v=1756197262"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chestnut-1.jpg?v=1756197262",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055677731066,
				"position": 116,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/chestnut-3_2.jpg?v=1756197262"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chestnut-3_2.jpg?v=1756197262",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055678583034,
				"position": 117,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/goldbrown_15.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/goldbrown_15.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055680647418,
				"position": 118,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/grey-2_5.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey-2_5.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055683727610,
				"position": 119,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/navyblue-2_5.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/navyblue-2_5.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684186362,
				"position": 120,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/red_10.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/red_10.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055684907258,
				"position": 121,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/stoneblue_5.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/stoneblue_5.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685103866,
				"position": 122,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/taupe-4_5.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe-4_5.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055685628154,
				"position": 123,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/tealblue_12.jpg?v=1756197263"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/tealblue_12.jpg?v=1756197263",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055686086906,
				"position": 124,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/warmgold_5.jpg?v=1756197264"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/warmgold_5.jpg?v=1756197264",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687364858,
				"position": 125,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wild-rose-1.jpg?v=1756197264"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wild-rose-1.jpg?v=1756197264",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687397626,
				"position": 126,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wild-rose-2_1.jpg?v=1756197264"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wild-rose-2_1.jpg?v=1756197264",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687430394,
				"position": 127,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wild-rose-3_2.jpg?v=1756197264"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wild-rose-3_2.jpg?v=1756197264",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687463162,
				"position": 128,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wild-rose-4_3.jpg?v=1756197264"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wild-rose-4_3.jpg?v=1756197264",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687495930,
				"position": 129,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 828,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wild-rose-15_4.jpg?v=1756197264"
				},
				"aspect_ratio": 0.966,
				"height": 828,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wild-rose-15_4.jpg?v=1756197264",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687528698,
				"position": 130,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wildrose_5.jpg?v=1756197265"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wildrose_5.jpg?v=1756197265",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055687561466,
				"position": 131,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 800,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/wildrose_16.jpg?v=1756197265"
				},
				"aspect_ratio": 1,
				"height": 800,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wildrose_16.jpg?v=1756197265",
				"width": 800
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055723704570,
				"position": 132,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-3-6_2__resolution-standardv2-2x.jpg?v=1756197265"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-3-6_2__resolution-standardv2-2x.jpg?v=1756197265",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055723737338,
				"position": 133,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-4-3_3__resolution-standardv2-2x.jpg?v=1756197265"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-4-3_3__resolution-standardv2-2x.jpg?v=1756197265",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055723770106,
				"position": 134,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-5-1_5__resolution-highfidelityv2-2x.jpg?v=1756197265"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-5-1_5__resolution-highfidelityv2-2x.jpg?v=1756197265",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055723802874,
				"position": 135,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-8_6__resolution-highfidelityv2-2x.jpg?v=1756197265"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-8_6__resolution-highfidelityv2-2x.jpg?v=1756197265",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055723835642,
				"position": 136,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-1-71_resolution-standardv2-2x.jpg?v=1756197266"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-1-71_resolution-standardv2-2x.jpg?v=1756197266",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055723868410,
				"position": 137,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1__resolution-standardv2-2x.jpg?v=1756197266"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1__resolution-standardv2-2x.jpg?v=1756197266",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724491002,
				"position": 138,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablush-beige-3_3__resolution-standardv2-2x.jpg?v=1756197266"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablush-beige-3_3__resolution-standardv2-2x.jpg?v=1756197266",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724523770,
				"position": 139,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablush-beige-4_2__resolution-standardv2-2x.jpg?v=1756197266"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablush-beige-4_2__resolution-standardv2-2x.jpg?v=1756197266",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724556538,
				"position": 140,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablush-beige-5_4__resolution-highfidelityv2-2x.jpg?v=1756197266"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablush-beige-5_4__resolution-highfidelityv2-2x.jpg?v=1756197266",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724589306,
				"position": 141,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-1_resolution-standardv2-2x.jpg?v=1756197266"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-1_resolution-standardv2-2x.jpg?v=1756197266",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724622074,
				"position": 142,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablushbeige_2__resolution-highfidelityv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablushbeige_2__resolution-highfidelityv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724654842,
				"position": 143,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablush-beige-21_resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablush-beige-21_resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724687610,
				"position": 144,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aburgundy-11_resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aburgundy-11_resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724720378,
				"position": 145,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aburgundy-13_2__resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aburgundy-13_2__resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724753146,
				"position": 146,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aburgundy-14_3__resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aburgundy-14_3__resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724785914,
				"position": 147,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aburgundy-15_4__resolution-highfidelityv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aburgundy-15_4__resolution-highfidelityv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724818682,
				"position": 148,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-8_resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-8_resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055724851450,
				"position": 149,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aburgundy_5__resolution-highfidelityv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aburgundy_5__resolution-highfidelityv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725572346,
				"position": 150,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-1-3_2__resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-1-3_2__resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725605114,
				"position": 151,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-1-4_3__resolution-standardv2-2x.jpg?v=1756197267"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-1-4_3__resolution-standardv2-2x.jpg?v=1756197267",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725637882,
				"position": 152,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725670650,
				"position": 153,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-2_1_-1_resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-2_1_-1_resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725703418,
				"position": 154,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adarkgreen_5__resolution-highfidelityv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adarkgreen_5__resolution-highfidelityv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055725736186,
				"position": 155,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-1-1_resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-1-1_resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726162170,
				"position": 156,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agold-brown-13_3__resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agold-brown-13_3__resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726194938,
				"position": 157,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agold-brown-14_4__resolution-highfidelityv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agold-brown-14_4__resolution-highfidelityv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726227706,
				"position": 158,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awqarm-2-1_1__resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awqarm-2-1_1__resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726260474,
				"position": 159,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agoldbrown_5__resolution-highfidelityv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agoldbrown_5__resolution-highfidelityv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726293242,
				"position": 160,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agold-brown-1_resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agold-brown-1_resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726326010,
				"position": 161,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agold-brown-12_2__resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agold-brown-12_2__resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726915834,
				"position": 162,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-13_2__resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-13_2__resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726948602,
				"position": 163,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-14_3__resolution-standardv2-2x.jpg?v=1756197268"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-14_3__resolution-standardv2-2x.jpg?v=1756197268",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055726981370,
				"position": 164,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-15_4__resolution-highfidelityv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-15_4__resolution-highfidelityv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727014138,
				"position": 165,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-22-1_1_-2_resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-22-1_1_-2_resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727046906,
				"position": 166,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-1-5_resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-1-5_resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727079674,
				"position": 167,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-2_5__resolution-highfidelityv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-2_5__resolution-highfidelityv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727112442,
				"position": 168,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alvory-2_4__resolution-highfidelityv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alvory-2_4__resolution-highfidelityv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727145210,
				"position": 169,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alvory-3_3__resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alvory-3_3__resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727177978,
				"position": 170,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alvory-4_2__resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alvory-4_2__resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727210746,
				"position": 171,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-3_resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-3_resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727243514,
				"position": 172,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory_1__resolution-highfidelityv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory_1__resolution-highfidelityv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727276282,
				"position": 173,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alvory-1_resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alvory-1_resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727374586,
				"position": 174,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-pink-1-1_2__resolution-standardv2-2x.jpg?v=1756197269"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-pink-1-1_2__resolution-standardv2-2x.jpg?v=1756197269",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727407354,
				"position": 175,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-pink-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-pink-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727440122,
				"position": 176,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-5_resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-5_resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055727472890,
				"position": 177,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alightpink_5__resolution-highfidelityv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alightpink_5__resolution-highfidelityv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728029946,
				"position": 178,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-greem-3_3__resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-greem-3_3__resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728062714,
				"position": 179,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-greem-4_2__resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-greem-4_2__resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728095482,
				"position": 180,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amossgreen_5__resolution-highfidelityv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amossgreen_5__resolution-highfidelityv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728128250,
				"position": 181,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-6_resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-6_resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728161018,
				"position": 182,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-greem-1_resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-greem-1_resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728193786,
				"position": 183,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-greem-2_4__resolution-highfidelityv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-greem-2_4__resolution-highfidelityv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728324858,
				"position": 184,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-3_2__resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728357626,
				"position": 185,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-4_3__resolution-standardv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-4_3__resolution-standardv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728390394,
				"position": 186,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-5_4__resolution-highfidelityv2-2x.jpg?v=1756197270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-5_4__resolution-highfidelityv2-2x.jpg?v=1756197270",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728423162,
				"position": 187,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-7_resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-7_resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728455930,
				"position": 188,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavyblue_6__resolution-highfidelityv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavyblue_6__resolution-highfidelityv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728488698,
				"position": 189,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-1-1_resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-1-1_resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728554234,
				"position": 190,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-1-4_3__resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-1-4_3__resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728587002,
				"position": 191,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-1-5_4__resolution-highfidelityv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728619770,
				"position": 192,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-5_5__resolution-highfidelityv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-5_5__resolution-highfidelityv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728652538,
				"position": 193,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-2_resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-2_resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728685306,
				"position": 194,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-1-2_resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-1-2_resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055728718074,
				"position": 195,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-1-3_2__resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-1-3_2__resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729340666,
				"position": 196,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-grey-1-5_resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-grey-1-5_resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729406202,
				"position": 197,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-grey-3_2__resolution-standardv2-2x.jpg?v=1756197271"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-grey-3_2__resolution-standardv2-2x.jpg?v=1756197271",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729438970,
				"position": 198,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-grey-5_3__resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-grey-5_3__resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729471738,
				"position": 199,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-grey-6_4__resolution-highfidelityv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-grey-6_4__resolution-highfidelityv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729504506,
				"position": 200,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-4_resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-4_resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729537274,
				"position": 201,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alightgrey_5__resolution-highfidelityv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alightgrey_5__resolution-highfidelityv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729799418,
				"position": 202,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-2_4__resolution-highfidelityv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-2_4__resolution-highfidelityv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729832186,
				"position": 203,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-3-4_3__resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-3-4_3__resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729864954,
				"position": 204,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-4_2__resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-4_2__resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729897722,
				"position": 205,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-9_resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-9_resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729930490,
				"position": 206,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astoneblue_3__resolution-highfidelityv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astoneblue_3__resolution-highfidelityv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055729963258,
				"position": 207,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-1-4_resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-1-4_resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730127098,
				"position": 208,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-4-1_3__resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-4-1_3__resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730159866,
				"position": 209,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-5_resolution-standardv2-2x.jpg?v=1756197272"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-5_resolution-standardv2-2x.jpg?v=1756197272",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730192634,
				"position": 210,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-5-1_4__resolution-highfidelityv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-5-1_4__resolution-highfidelityv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730225402,
				"position": 211,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-10_resolution-standardv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-10_resolution-standardv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730258170,
				"position": 212,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe_14__resolution-highfidelityv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe_14__resolution-highfidelityv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730290938,
				"position": 213,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-2-1_2__resolution-standardv2-2x_df1bed90-869e-4686-a47f-0866d8dd96de.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-2-1_2__resolution-standardv2-2x_df1bed90-869e-4686-a47f-0866d8dd96de.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730782458,
				"position": 214,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-3_2__resolution-standardv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-3_2__resolution-standardv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730815226,
				"position": 215,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-4_4__resolution-highfidelityv2-2x.jpg?v=1761213065"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-4_4__resolution-highfidelityv2-2x.jpg?v=1761213065",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730847994,
				"position": 216,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-6_resolution-standardv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-6_resolution-standardv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730880762,
				"position": 217,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-11_resolution-standardv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-11_resolution-standardv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730913530,
				"position": 218,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Atealblue_5__resolution-highfidelityv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Atealblue_5__resolution-highfidelityv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055730946298,
				"position": 219,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-1_3__resolution-standardv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-blue-1-1_3__resolution-standardv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731044602,
				"position": 220,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awarm-gold-2_4__resolution-highfidelityv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awarm-gold-2_4__resolution-highfidelityv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731077370,
				"position": 221,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awarm-gold-13_3__resolution-standardv2-2x.jpg?v=1756197273"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awarm-gold-13_3__resolution-standardv2-2x.jpg?v=1756197273",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731110138,
				"position": 222,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awarm-gold-14_2__resolution-standardv2-2x.jpg?v=1756197274"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awarm-gold-14_2__resolution-standardv2-2x.jpg?v=1756197274",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731142906,
				"position": 223,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-12_resolution-standardv2-2x.jpg?v=1756197274"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-1_1_-12_resolution-standardv2-2x.jpg?v=1756197274",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731175674,
				"position": 224,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awarmgold_5__resolution-highfidelityv2-2x.jpg?v=1756197274"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awarmgold_5__resolution-highfidelityv2-2x.jpg?v=1756197274",
				"width": 2000
			},
			{
				"alt": "Classic Velvet Custom Curtain - TheHues",
				"id": 36055731208442,
				"position": 225,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awarm-gold-1_resolution-standardv2-2x.jpg?v=1756197274"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awarm-gold-1_resolution-standardv2-2x.jpg?v=1756197274",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Classic velvet curtains, a symphony of softness and sheen, drape like poetry in motion. Their plush texture invites touch, while their presence exudes an effortless grandeur.</p>",
		"url": "/products/classic-velvet-custom-curtain",
		"regular_price": "$95.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780116525306,
		"title": "Yarn Linen Look Sheer Custom Curtain",
		"handle": "yarn-linen-look-sheer-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Sheer<br>Weight: Sheer (110g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>A sheer with the soul of linen, its slubbed texture tells a story of quiet sophistication. Each thread adds depth, letting natural light dance through while wrapping your room in gentle elegance.</p>",
		"published_at": "2025-05-07T16:27:39+08:00",
		"created_at": "2025-05-07T16:27:39+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Black Friday",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"New Year's Day",
			"sale top 10",
			"Search curtains",
			"Search sheer",
			"Spring Time Sale",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 11500,
		"price_min": 11500,
		"price_max": 11500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319395500282,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165095162,
					"product_id": 8780116525306,
					"position": 1,
					"created_at": "2025-06-30T15:52:05+08:00",
					"updated_at": "2025-08-26T16:32:44+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_white.jpg?v=1756197164",
					"variant_ids": [
						47319395500282
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36295999914234,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_white.jpg?v=1756197164"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250515-Awhite-9_resolution-standardv2-2x_1024x1024.jpg?v=1756197174"
			},
			{
				"id": 47319395533050,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165160698,
					"product_id": 8780116525306,
					"position": 5,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:45+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_beige.jpg?v=1756197165",
					"variant_ids": [
						47319395533050
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000012538,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_beige.jpg?v=1756197165"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ayarn-beige_1024x1024.jpg?v=1751350627"
			},
			{
				"id": 47319395631354,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Natural",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165226234,
					"product_id": 8780116525306,
					"position": 15,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:46+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_natyual.jpg?v=1756197166",
					"variant_ids": [
						47319395631354
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000045306,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_natyual.jpg?v=1756197166"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/natural-9_44d3ad34-55c2-45b3-af10-74d7d1d1d3e4_1024x1024.jpg?v=1754472385"
			},
			{
				"id": 47319395696890,
				"title": "Camel",
				"option1": "Camel",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Camel",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165127930,
					"product_id": 8780116525306,
					"position": 26,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:47+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_camel.jpg?v=1756197167",
					"variant_ids": [
						47319395696890
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Camel",
				"public_title": "Camel",
				"options": [
					"Camel"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36295999947002,
					"position": 26,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_camel.jpg?v=1756197167"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/camel-5_73d3e875-eb2c-4a95-acf3-c67d3fa271cc_1024x1024.jpg?v=1754472385"
			},
			{
				"id": 47319395762426,
				"title": "Blush",
				"option1": "Blush",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Blush",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165357306,
					"product_id": 8780116525306,
					"position": 37,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:48+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_blush.jpg?v=1756197168",
					"variant_ids": [
						47319395762426
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Blush",
				"public_title": "Blush",
				"options": [
					"Blush"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000110842,
					"position": 37,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_blush.jpg?v=1756197168"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319395795194,
				"title": "Sea Mist",
				"option1": "Sea Mist",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Sea Mist",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165390074,
					"product_id": 8780116525306,
					"position": 48,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:49+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_seamist.jpg?v=1756197169",
					"variant_ids": [
						47319395795194
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Sea Mist",
				"public_title": "Sea Mist",
				"options": [
					"Sea Mist"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000143610,
					"position": 48,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_seamist.jpg?v=1756197169"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319395827962,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165455610,
					"product_id": 8780116525306,
					"position": 54,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:49+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_grey.jpg?v=1756197169",
					"variant_ids": [
						47319395827962
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000176378,
					"position": 54,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_grey.jpg?v=1756197169"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319395860730,
				"title": "Charcoal Grey",
				"option1": "Charcoal Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Charcoal Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165324538,
					"product_id": 8780116525306,
					"position": 60,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:50+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_charcoal.jpg?v=1756197170",
					"variant_ids": [
						47319395860730
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Charcoal Grey",
				"public_title": "Charcoal Grey",
				"options": [
					"Charcoal Grey"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000209146,
					"position": 60,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_charcoal.jpg?v=1756197170"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319395664122,
				"title": "Dark Blue",
				"option1": "Dark Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Dark Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44393165422842,
					"product_id": 8780116525306,
					"position": 20,
					"created_at": "2025-06-30T15:52:06+08:00",
					"updated_at": "2025-08-26T16:32:46+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ayarn_navy.jpg?v=1756197166",
					"variant_ids": [
						47319395664122
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Dark Blue",
				"public_title": "Dark Blue",
				"options": [
					"Dark Blue"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36296000274682,
					"position": 20,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ayarn_navy.jpg?v=1756197166"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319395598586,
				"title": "Olive Green",
				"option1": "Olive Green",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Olive Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44542194680058,
					"product_id": 8780116525306,
					"position": 9,
					"created_at": "2025-07-18T09:43:34+08:00",
					"updated_at": "2025-08-26T16:32:45+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/yarn_1_green_d7da02cc-e801-4984-a778-f1ca8100924c.jpg?v=1756197165",
					"variant_ids": [
						47319395598586
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Olive Green",
				"public_title": "Olive Green",
				"options": [
					"Olive Green"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36396631097594,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/yarn_1_green_d7da02cc-e801-4984-a778-f1ca8100924c.jpg?v=1756197165"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ayarn-olive-green_1024x1024.jpg?v=1751350627"
			},
			{
				"id": 47319395565818,
				"title": "Terracotta",
				"option1": "Terracotta",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Terracotta",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44542194548986,
					"product_id": 8780116525306,
					"position": 42,
					"created_at": "2025-07-18T09:43:34+08:00",
					"updated_at": "2025-08-26T16:32:48+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/yarn_1_terracotta_ac584bf2-a823-47cc-8466-5f57149160cf.jpg?v=1756197168",
					"variant_ids": [
						47319395565818
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Terracotta",
				"public_title": "Terracotta",
				"options": [
					"Terracotta"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36396630900986,
					"position": 42,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/yarn_1_terracotta_ac584bf2-a823-47cc-8466-5f57149160cf.jpg?v=1756197168"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ayarn-terracotta_1024x1024.jpg?v=1751350627"
			},
			{
				"id": 47319395729658,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-18-SD-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44542194450682,
					"product_id": 8780116525306,
					"position": 31,
					"created_at": "2025-07-18T09:43:34+08:00",
					"updated_at": "2025-08-26T16:32:47+08:00",
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/yarn_1_black_22e8c647-779b-4504-9f60-d9bd76b17b0c.jpg?v=1756197167",
					"variant_ids": [
						47319395729658
					]
				},
				"available": true,
				"name": "Yarn Linen Look Sheer Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
					"id": 36396630769914,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/yarn_1_black_22e8c647-779b-4504-9f60-d9bd76b17b0c.jpg?v=1756197167"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Ayarn_white.jpg?v=1756197164",
			"//thehues.com/cdn/shop/files/white_2.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/yarn_1_white_6b255ede-cb2d-4230-a18d-08794f58c6db.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/white_3.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/Ayarn_beige.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/yarn_1_beige_eff15fe9-61f2-4c14-99e0-26c7e916a204.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/beige_1.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/beige_2.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/yarn_1_green_d7da02cc-e801-4984-a778-f1ca8100924c.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen2-1_3__resolution-standardv2-2x.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen4-1_5__resolution-standardv2-2x.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen1-1_4__resolution-standardv2-2x.jpg?v=1756197165",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen3-1_6__resolution-standardv2-2x.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/Ayarn_olive.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/Ayarn_natyual.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/yarn_1_nnatual_9fe9e42f-ba8c-4c25-a58b-2e332a6b0224.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-natural-10-1_3__resolution-standardv2-2x.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-natural-9-1_5__resolution-standardv2-2x.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-natural2-1_6__resolution-standardv2-2x.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/Ayarn_navy.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/yarn_1_darkblue_31dc21dc-bb04-46d9-bd4c-11a077b95dfb.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue2-1_3__resolution-standardv2-2x.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue3-1_6__resolution-standardv2-2x.jpg?v=1756197166",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-darkblu4-1_5__resolution-standardv2-2x.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue1-1_4__resolution-standardv2-2x.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/Ayarn_camel.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/yarn_1_camel_c68c5ae5-3592-4c4b-bde6-ef3121022957.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/camel_1.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/camel_2.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/camel_3.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/yarn_1_black_22e8c647-779b-4504-9f60-d9bd76b17b0c.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-black2-1_3__resolution-standardv2-2x.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-black3-1_6__resolution-standardv2-2x.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-black1-1_4__resolution-standardv2-2x.jpg?v=1756197167",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-black4-1_5__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/Ayarn_black.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/Ayarn_blush.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/yarn_1_pink_420cd39f-c73d-4ff2-8bc0-b7a610bf2e45.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-blush3-1_6__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-blush4-1_5__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-blush1-1_4__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/yarn_1_terracotta_ac584bf2-a823-47cc-8466-5f57149160cf.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta2-1_3__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta3-1_6__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta1-1_4__resolution-standardv2-2x.jpg?v=1756197168",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta4-1_5__resolution-standardv2-2x.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/Ayarn_terracotta.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/Ayarn_seamist.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/yarn_1_seamist_62d779c5-f67f-413c-ab7c-8253db316b9c.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-seamist2-1_3__resolution-standardv2-2x.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-seamist3-1_6__resolution-standardv2-2x.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-seamist5-1_5__resolution-standardv2-2x.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-seamist1-1_4__resolution-standardv2-2x.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/Ayarn_grey.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/yarn_1_grey_0f3b36da-2063-4174-8e71-1602aa3dbca2.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-grey2-1_3__resolution-standardv2-2x.jpg?v=1756197169",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-grey3-1_6__resolution-standardv2-2x.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-grey4-1_5__resolution-standardv2-2x.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-grey1-1_4__resolution-standardv2-2x.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/Ayarn_charcoal.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/yarn_1_charcoal_27568dc3-e7e6-4f27-8552-a2a6c005d199.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/charcoal-grey_3.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/charcoal-grey.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/charcoal-grey_2.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-white2-1_3__resolution-standardv2-2x.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-white1-1_4__resolution-standardv2-2x.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/white_1.jpg?v=1756197170",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-beig-2-1_3__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-beige-1-1_4__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/beige_3.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-natural1-1_4__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-camel2-1_4__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-camel-1_5__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-blush2-1_3__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey4-1_4__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey3-1_3__resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-AFrame19_resolution-standardv2-2x.jpg?v=1756197171",
			"//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x_a47b42fd-3039-45bd-b289-ec0e052d8069.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-beige-3-1_6__resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-beige-4-1_5__resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-AFrame39_resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-AAyarn-natural-7-11_resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-AFrame46_resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-AFrame16_resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-camel3-1_7__resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-camel4-1_6__resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-AFrame32_resolution-standardv2-2x.jpg?v=1756197172",
			"//thehues.com/cdn/shop/files/20250515-AFrame48_resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-AFrame26_resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-AFrame37_resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey5-1_6__resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey1-1_5__resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-white3-1_6__resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-white4-1_5__resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-AFrame33_resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-AAyarn-grey1-11-11_resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197173",
			"//thehues.com/cdn/shop/files/20250515-AFrame34_resolution-standardv2-2x.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-grey1-11-11_resolution-standardv2-2x.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/20250515-Awhite-9_resolution-standardv2-2x.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/20250515-Aterracotta-7_2__resolution-standardv2-2x.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-natural-7-11_resolution-standardv2-2x.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/20250515-Ayarn-natural-7-11_resolution-standardv2-2x-2.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/natural_1.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/natural_2.jpg?v=1756197174",
			"//thehues.com/cdn/shop/files/natural_3.jpg?v=1756197174"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Ayarn_white_1024x1024.jpg?v=1756197164",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36295999914234,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_white.jpg?v=1756197164"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_white.jpg?v=1756197164",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396597674234,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/white_2.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/white_2.jpg?v=1756197165",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630671610,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_white_6b255ede-cb2d-4230-a18d-08794f58c6db.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_white_6b255ede-cb2d-4230-a18d-08794f58c6db.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396597805306,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/white_3.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/white_3.jpg?v=1756197165",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000012538,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_beige.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_beige.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630737146,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_beige_eff15fe9-61f2-4c14-99e0-26c7e916a204.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_beige_eff15fe9-61f2-4c14-99e0-26c7e916a204.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598001914,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/beige_1.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/beige_1.jpg?v=1756197165",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396597969146,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/beige_2.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/beige_2.jpg?v=1756197165",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396631097594,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_green_d7da02cc-e801-4984-a778-f1ca8100924c.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_green_d7da02cc-e801-4984-a778-f1ca8100924c.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987561210,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen2-1_3__resolution-standardv2-2x.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen2-1_3__resolution-standardv2-2x.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987626746,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen4-1_5__resolution-standardv2-2x.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen4-1_5__resolution-standardv2-2x.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987528442,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen1-1_4__resolution-standardv2-2x.jpg?v=1756197165"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen1-1_4__resolution-standardv2-2x.jpg?v=1756197165",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987593978,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen3-1_6__resolution-standardv2-2x.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-olivegreen3-1_6__resolution-standardv2-2x.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000241914,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_olive.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_olive.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000045306,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_natyual.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_natyual.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630704378,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_nnatual_9fe9e42f-ba8c-4c25-a58b-2e332a6b0224.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_nnatual_9fe9e42f-ba8c-4c25-a58b-2e332a6b0224.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988249338,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-10-1_3__resolution-standardv2-2x.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-10-1_3__resolution-standardv2-2x.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988216570,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-9-1_5__resolution-standardv2-2x.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-9-1_5__resolution-standardv2-2x.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988118266,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural2-1_6__resolution-standardv2-2x.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural2-1_6__resolution-standardv2-2x.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000274682,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_navy.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_navy.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630835450,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_darkblue_31dc21dc-bb04-46d9-bd4c-11a077b95dfb.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_darkblue_31dc21dc-bb04-46d9-bd4c-11a077b95dfb.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986774778,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue2-1_3__resolution-standardv2-2x.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue2-1_3__resolution-standardv2-2x.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986807546,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue3-1_6__resolution-standardv2-2x.jpg?v=1756197166"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue3-1_6__resolution-standardv2-2x.jpg?v=1756197166",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986709242,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblu4-1_5__resolution-standardv2-2x.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblu4-1_5__resolution-standardv2-2x.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986742010,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue1-1_4__resolution-standardv2-2x.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-darkblue1-1_4__resolution-standardv2-2x.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36295999947002,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_camel.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_camel.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396631032058,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_camel_c68c5ae5-3592-4c4b-bde6-ef3121022957.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_camel_c68c5ae5-3592-4c4b-bde6-ef3121022957.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598296826,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/camel_1.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/camel_1.jpg?v=1756197167",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396597936378,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/camel_2.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/camel_2.jpg?v=1756197167",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598100218,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/camel_3.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/camel_3.jpg?v=1756197167",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630769914,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_black_22e8c647-779b-4504-9f60-d9bd76b17b0c.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_black_22e8c647-779b-4504-9f60-d9bd76b17b0c.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058973602042,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black2-1_3__resolution-standardv2-2x.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black2-1_3__resolution-standardv2-2x.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058973667578,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black3-1_6__resolution-standardv2-2x.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black3-1_6__resolution-standardv2-2x.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058973536506,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black1-1_4__resolution-standardv2-2x.jpg?v=1756197167"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black1-1_4__resolution-standardv2-2x.jpg?v=1756197167",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058973733114,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black4-1_5__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-black4-1_5__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36295999979770,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_black.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_black.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000110842,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_blush.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_blush.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396631064826,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_pink_420cd39f-c73d-4ff2-8bc0-b7a610bf2e45.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_pink_420cd39f-c73d-4ff2-8bc0-b7a610bf2e45.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982285562,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush3-1_6__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush3-1_6__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982318330,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush4-1_5__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush4-1_5__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982220026,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush1-1_4__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush1-1_4__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630900986,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_terracotta_ac584bf2-a823-47cc-8466-5f57149160cf.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_terracotta_ac584bf2-a823-47cc-8466-5f57149160cf.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987954426,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta2-1_3__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta2-1_3__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987987194,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta3-1_6__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta3-1_6__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987921658,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta1-1_4__resolution-standardv2-2x.jpg?v=1756197168"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta1-1_4__resolution-standardv2-2x.jpg?v=1756197168",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988019962,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta4-1_5__resolution-standardv2-2x.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-terracotta4-1_5__resolution-standardv2-2x.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000078074,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_terracotta.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_terracotta.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000143610,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_seamist.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_seamist.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630999290,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_seamist_62d779c5-f67f-413c-ab7c-8253db316b9c.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_seamist_62d779c5-f67f-413c-ab7c-8253db316b9c.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987757818,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist2-1_3__resolution-standardv2-2x.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist2-1_3__resolution-standardv2-2x.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987790586,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist3-1_6__resolution-standardv2-2x.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist3-1_6__resolution-standardv2-2x.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987823354,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist5-1_5__resolution-standardv2-2x.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist5-1_5__resolution-standardv2-2x.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987725050,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist1-1_4__resolution-standardv2-2x.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-seamist1-1_4__resolution-standardv2-2x.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000176378,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_grey.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_grey.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630868218,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_grey_0f3b36da-2063-4174-8e71-1602aa3dbca2.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_grey_0f3b36da-2063-4174-8e71-1602aa3dbca2.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986053882,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey2-1_3__resolution-standardv2-2x.jpg?v=1756197169"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey2-1_3__resolution-standardv2-2x.jpg?v=1756197169",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986086650,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey3-1_6__resolution-standardv2-2x.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey3-1_6__resolution-standardv2-2x.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986119418,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey4-1_5__resolution-standardv2-2x.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey4-1_5__resolution-standardv2-2x.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986152186,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey1-1_4__resolution-standardv2-2x.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey1-1_4__resolution-standardv2-2x.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36296000209146,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ayarn_charcoal.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ayarn_charcoal.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396630802682,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/yarn_1_charcoal_27568dc3-e7e6-4f27-8552-a2a6c005d199.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/yarn_1_charcoal_27568dc3-e7e6-4f27-8552-a2a6c005d199.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598165754,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/charcoal-grey_3.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/charcoal-grey_3.jpg?v=1756197170",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396597772538,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/charcoal-grey.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/charcoal-grey.jpg?v=1756197170",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598034682,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/charcoal-grey_2.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/charcoal-grey_2.jpg?v=1756197170",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987102458,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white2-1_3__resolution-standardv2-2x.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white2-1_3__resolution-standardv2-2x.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987069690,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white1-1_4__resolution-standardv2-2x.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white1-1_4__resolution-standardv2-2x.jpg?v=1756197170",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598198522,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/white_1.jpg?v=1756197170"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/white_1.jpg?v=1756197170",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058970652922,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beig-2-1_3__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beig-2-1_3__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058970685690,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beige-1-1_4__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beige-1-1_4__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598231290,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/beige_3.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/beige_3.jpg?v=1756197171",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988085498,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural1-1_4__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural1-1_4__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982547706,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel2-1_4__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel2-1_4__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982514938,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel-1_5__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel-1_5__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982252794,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush2-1_3__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-blush2-1_3__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985398522,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey4-1_4__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey4-1_4__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985365754,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey3-1_3__resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey3-1_3__resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987004154,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame19_resolution-standardv2-2x.jpg?v=1756197171"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame19_resolution-standardv2-2x.jpg?v=1756197171",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058970620154,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x_a47b42fd-3039-45bd-b289-ec0e052d8069.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x_a47b42fd-3039-45bd-b289-ec0e052d8069.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058970718458,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beige-3-1_6__resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beige-3-1_6__resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058970751226,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beige-4-1_5__resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-beige-4-1_5__resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987495674,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame39_resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame39_resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988052730,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AAyarn-natural-7-11_resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AAyarn-natural-7-11_resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986676474,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame46_resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame46_resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982482170,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame16_resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame16_resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982580474,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel3-1_7__resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel3-1_7__resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982613242,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel4-1_6__resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-camel4-1_6__resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058973503738,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame32_resolution-standardv2-2x.jpg?v=1756197172"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame32_resolution-standardv2-2x.jpg?v=1756197172",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058982187258,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame48_resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame48_resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987856122,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame26_resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame26_resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987692282,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame37_resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame37_resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985431290,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey5-1_6__resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey5-1_6__resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985332986,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey1-1_5__resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-charcoalgrey1-1_5__resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987135226,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white3-1_6__resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white3-1_6__resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987167994,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white4-1_5__resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-white4-1_5__resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985267450,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame33_resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame33_resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985234682,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AAyarn-grey1-11-11_resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197173"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AAyarn-grey1-11-11_resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197173",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058985300218,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame34_resolution-standardv2-2x.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame34_resolution-standardv2-2x.jpg?v=1756197174",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058986021114,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey1-11-11_resolution-standardv2-2x.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-grey1-11-11_resolution-standardv2-2x.jpg?v=1756197174",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987036922,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-9_resolution-standardv2-2x.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-9_resolution-standardv2-2x.jpg?v=1756197174",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058987888890,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aterracotta-7_2__resolution-standardv2-2x.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aterracotta-7_2__resolution-standardv2-2x.jpg?v=1756197174",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988151034,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-7-11_resolution-standardv2-2x.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-7-11_resolution-standardv2-2x.jpg?v=1756197174",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36058988183802,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-7-11_resolution-standardv2-2x-2.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ayarn-natural-7-11_resolution-standardv2-2x-2.jpg?v=1756197174",
				"width": 2000
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396597838074,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/natural_1.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/natural_1.jpg?v=1756197174",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598067450,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/natural_2.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/natural_2.jpg?v=1756197174",
				"width": 1638
			},
			{
				"alt": "Yarn Linen Look Sheer Custom Curtain - TheHues",
				"id": 36396598132986,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/natural_3.jpg?v=1756197174"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/natural_3.jpg?v=1756197174",
				"width": 1638
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>A sheer with the soul of linen, its slubbed texture tells a story of quiet sophistication. Each thread adds depth, letting natural light dance through while wrapping your room in gentle elegance.</p>",
		"url": "/products/yarn-linen-look-sheer-custom-curtain",
		"regular_price": "$115.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780115640570,
		"title": "Hussein OEKO Certified Custom Curtain",
		"handle": "hussein-oeko-certified-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Materia: 100% Polyester<br>Features: Room Darkening<br>Weight: Light Weight (230g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>With its textured charm and triple-duty performance soundproof, thermal, and 100% blackout the Laborien Curtain envelops your space in serenity, warmth, and undisturbed darkness.</p>",
		"published_at": "2025-05-07T16:27:02+08:00",
		"created_at": "2025-05-07T16:27:02+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Black Friday",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"Friendly",
			"indoor curtain",
			"New Content",
			"New Year's Day",
			"Oeko",
			"sale top 10",
			"Search curtains",
			"Search Pinch pleat",
			"ship in 3 days",
			"ships in 3 days",
			"Spring Time Sale",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 11000,
		"price_min": 11000,
		"price_max": 11000,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319441834234,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Beige",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 43996839051514,
					"product_id": 8780115640570,
					"position": 1,
					"created_at": "2025-05-17T17:46:32+08:00",
					"updated_at": "2025-08-26T16:34:37+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABeige-3-7-1_resolution-standard_v2-2x.jpg?v=1756197277",
					"variant_ids": [
						47319441834234
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046622327034,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABeige-3-7-1_resolution-standard_v2-2x.jpg?v=1756197277"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abeige-ok_5__resolution-standard_v2-2x_1024x1024.jpg?v=1754968282"
			},
			{
				"id": 47319442161914,
				"title": "Light Beige",
				"option1": "Light Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Light Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996914090234,
					"product_id": 8780115640570,
					"position": 59,
					"created_at": "2025-05-17T17:53:49+08:00",
					"updated_at": "2025-08-26T16:34:42+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ALight-Beige-5-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
					"variant_ids": [
						47319442161914
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Light Beige",
				"public_title": "Light Beige",
				"options": [
					"Light Beige"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046670495994,
					"position": 59,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ALight-Beige-5-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alight-beige-ok_13__resolution-standard_v2-2x_1024x1024.jpg?v=1754968282"
			},
			{
				"id": 47319441768698,
				"title": "Greyish White",
				"option1": "Greyish White",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Greyish White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996912451834,
					"product_id": 8780115640570,
					"position": 19,
					"created_at": "2025-05-17T17:53:25+08:00",
					"updated_at": "2025-08-26T16:34:38+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGreyish-White-4-2_resolution-standard_v2-2x.jpg?v=1756197278",
					"variant_ids": [
						47319441768698
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Greyish White",
				"public_title": "Greyish White",
				"options": [
					"Greyish White"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046668792058,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGreyish-White-4-2_resolution-standard_v2-2x.jpg?v=1756197278"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Agrayish-white-ok_2__resolution-standard_v2-2x_7af60ca7-c4c1-42df-b7b1-6a4bad574da5_1024x1024.jpg?v=1754968368"
			},
			{
				"id": 47319441998074,
				"title": "Pure White",
				"option1": "Pure White",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Pure White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996935815418,
					"product_id": 8780115640570,
					"position": 8,
					"created_at": "2025-05-17T17:55:21+08:00",
					"updated_at": "2025-08-26T16:34:37+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/APure-White-3-3-1_resolution-standard_v2-2x.jpg?v=1756197277",
					"variant_ids": [
						47319441998074
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Pure White",
				"public_title": "Pure White",
				"options": [
					"Pure White"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046683439354,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/APure-White-3-3-1_resolution-standard_v2-2x.jpg?v=1756197277"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apure-white-ok_resolution-standard_v2-2x_1024x1024.jpg?v=1754968368"
			},
			{
				"id": 47319441539322,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996913729786,
					"product_id": 8780115640570,
					"position": 3,
					"created_at": "2025-05-17T17:53:43+08:00",
					"updated_at": "2025-08-26T16:34:37+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGrey-3-3_resolution-standard_v2-2x.jpg?v=1756197277",
					"variant_ids": [
						47319441539322
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046670135546,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGrey-3-3_resolution-standard_v2-2x.jpg?v=1756197277"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442358522,
				"title": "Silver Grey",
				"option1": "Silver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Silver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996951314682,
					"product_id": 8780115640570,
					"position": 69,
					"created_at": "2025-05-17T17:57:04+08:00",
					"updated_at": "2025-08-26T16:34:43+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ASilver-Grey-1-4_resolution-standard_v2-2x.jpg?v=1756197283",
					"variant_ids": [
						47319442358522
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Silver Grey",
				"public_title": "Silver Grey",
				"options": [
					"Silver Grey"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046693728506,
					"position": 69,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ASilver-Grey-1-4_resolution-standard_v2-2x.jpg?v=1756197283"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442391290,
				"title": "Vintage blue",
				"option1": "Vintage blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Vintage blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996962849018,
					"product_id": 8780115640570,
					"position": 74,
					"created_at": "2025-05-17T17:57:58+08:00",
					"updated_at": "2025-08-26T16:34:43+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AVintage-Blue-4-1_resolution-standard_v2-2x.jpg?v=1756197283",
					"variant_ids": [
						47319442391290
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Vintage blue",
				"public_title": "Vintage blue",
				"options": [
					"Vintage blue"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046700970234,
					"position": 74,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AVintage-Blue-4-1_resolution-standard_v2-2x.jpg?v=1756197283"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442096378,
				"title": "Navy Blue",
				"option1": "Navy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Navy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996923232506,
					"product_id": 8780115640570,
					"position": 31,
					"created_at": "2025-05-17T17:54:24+08:00",
					"updated_at": "2025-08-26T16:34:39+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ANavy-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197279",
					"variant_ids": [
						47319442096378
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Navy Blue",
				"public_title": "Navy Blue",
				"options": [
					"Navy Blue"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046676001018,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ANavy-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197279"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442260218,
				"title": "Burgundy Red",
				"option1": "Burgundy Red",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Burgundy Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996880568570,
					"product_id": 8780115640570,
					"position": 119,
					"created_at": "2025-05-17T17:49:47+08:00",
					"updated_at": "2025-08-26T16:34:47+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287",
					"variant_ids": [
						47319441604858,
						47319442260218
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Burgundy Red",
				"public_title": "Burgundy Red",
				"options": [
					"Burgundy Red"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046648738042,
					"position": 119,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Burgundy_Red_Color_Thumbnail_1024x1024.jpg?v=1758101076"
			},
			{
				"id": 47319442587898,
				"title": "Light Pink",
				"option1": "Light Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Light Pink",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996922380538,
					"product_id": 8780115640570,
					"position": 79,
					"created_at": "2025-05-17T17:54:12+08:00",
					"updated_at": "2025-08-26T16:34:44+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ALight-Pink-4-1_resolution-standard_v2-2x.jpg?v=1756197284",
					"variant_ids": [
						47319442587898
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Light Pink",
				"public_title": "Light Pink",
				"options": [
					"Light Pink"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046675149050,
					"position": 79,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ALight-Pink-4-1_resolution-standard_v2-2x.jpg?v=1756197284"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442292986,
				"title": "Brick Red",
				"option1": "Brick Red",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Brick Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996844163322,
					"product_id": 8780115640570,
					"position": 83,
					"created_at": "2025-05-17T17:47:00+08:00",
					"updated_at": "2025-08-26T16:34:44+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABrick-Red-4-3_resolution-standard_v2-2x.jpg?v=1756197284",
					"variant_ids": [
						47319442292986
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Brick Red",
				"public_title": "Brick Red",
				"options": [
					"Brick Red"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046625931514,
					"position": 83,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABrick-Red-4-3_resolution-standard_v2-2x.jpg?v=1756197284"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442522362,
				"title": "Eggplant Purple",
				"option1": "Eggplant Purple",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Eggplant Purple",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44046711226618,
					"product_id": 8780115640570,
					"position": 115,
					"created_at": "2025-05-23T10:48:34+08:00",
					"updated_at": "2025-08-26T16:34:47+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 4000,
					"height": 5000,
					"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-4-2_resolution-standardv2-2x.jpg?v=1756197287",
					"variant_ids": [
						47319442522362
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Eggplant Purple",
				"public_title": "Eggplant Purple",
				"options": [
					"Eggplant Purple"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36076716294394,
					"position": 115,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5000,
						"width": 4000,
						"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-4-2_resolution-standardv2-2x.jpg?v=1756197287"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441899770,
				"title": "Olive Green",
				"option1": "Olive Green",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Olive Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996935651578,
					"product_id": 8780115640570,
					"position": 54,
					"created_at": "2025-05-17T17:55:19+08:00",
					"updated_at": "2025-08-26T16:34:41+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AOlive-Green-2-1_resolution-standard_v2-2x.jpg?v=1756197281",
					"variant_ids": [
						47319441899770
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Olive Green",
				"public_title": "Olive Green",
				"options": [
					"Olive Green"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046683078906,
					"position": 54,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AOlive-Green-2-1_resolution-standard_v2-2x.jpg?v=1756197281"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442325754,
				"title": "Tender Cyan",
				"option1": "Tender Cyan",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Tender Cyan",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996962521338,
					"product_id": 8780115640570,
					"position": 110,
					"created_at": "2025-05-17T17:57:53+08:00",
					"updated_at": "2025-08-26T16:34:46+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ATender-Cyan-4-1_resolution-standard_v2-2x.jpg?v=1756197286",
					"variant_ids": [
						47319442325754
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Tender Cyan",
				"public_title": "Tender Cyan",
				"options": [
					"Tender Cyan"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046700708090,
					"position": 110,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ATender-Cyan-4-1_resolution-standard_v2-2x.jpg?v=1756197286"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442194682,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996959310074,
					"product_id": 8780115640570,
					"position": 46,
					"created_at": "2025-05-17T17:57:25+08:00",
					"updated_at": "2025-08-26T16:34:41+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AStone-Blue-1-3_resolution-standard_v2-2x.jpg?v=1756197281",
					"variant_ids": [
						47319442194682
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046698479866,
					"position": 46,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AStone-Blue-1-3_resolution-standard_v2-2x.jpg?v=1756197281"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442456826,
				"title": "Blue Green",
				"option1": "Blue Green",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Blue Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996843311354,
					"product_id": 8780115640570,
					"position": 102,
					"created_at": "2025-05-17T17:46:44+08:00",
					"updated_at": "2025-08-26T16:34:46+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABlue-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197286",
					"variant_ids": [
						47319442456826
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Blue Green",
				"public_title": "Blue Green",
				"options": [
					"Blue Green"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046625145082,
					"position": 102,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABlue-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197286"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442555130,
				"title": "Sea Blue",
				"option1": "Sea Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Sea Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996937781498,
					"product_id": 8780115640570,
					"position": 106,
					"created_at": "2025-05-17T17:55:54+08:00",
					"updated_at": "2025-08-26T16:34:46+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ASea-Blue-3-1_resolution-standard_v2-2x.jpg?v=1756197286",
					"variant_ids": [
						47319442555130
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Sea Blue",
				"public_title": "Sea Blue",
				"options": [
					"Sea Blue"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046685372666,
					"position": 106,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ASea-Blue-3-1_resolution-standard_v2-2x.jpg?v=1756197286"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442129146,
				"title": "Hunter Green",
				"option1": "Hunter Green",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Hunter Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996914155770,
					"product_id": 8780115640570,
					"position": 64,
					"created_at": "2025-05-17T17:53:49+08:00",
					"updated_at": "2025-08-26T16:34:42+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
					"variant_ids": [
						47319442129146
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Hunter Green",
				"public_title": "Hunter Green",
				"options": [
					"Hunter Green"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046670463226,
					"position": 64,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AHunter-Green-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442620666,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996937191674,
					"product_id": 8780115640570,
					"position": 98,
					"created_at": "2025-05-17T17:55:42+08:00",
					"updated_at": "2025-08-26T16:34:45+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ASand-4-2_resolution-standard_v2-2x.jpg?v=1756197285",
					"variant_ids": [
						47319442620666
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046684717306,
					"position": 98,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ASand-4-2_resolution-standard_v2-2x.jpg?v=1756197285"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442063610,
				"title": "Yellow",
				"option1": "Yellow",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Yellow",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996963242234,
					"product_id": 8780115640570,
					"position": 36,
					"created_at": "2025-05-17T17:58:03+08:00",
					"updated_at": "2025-08-26T16:34:40+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AYellow-5-1_resolution-standard_v2-2x.jpg?v=1756197280",
					"variant_ids": [
						47319442063610
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Yellow",
				"public_title": "Yellow",
				"options": [
					"Yellow"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046701265146,
					"position": 36,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AYellow-5-1_resolution-standard_v2-2x.jpg?v=1756197280"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319442030842,
				"title": "Sea Teal",
				"option1": "Sea Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Sea Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996949938426,
					"product_id": 8780115640570,
					"position": 50,
					"created_at": "2025-05-17T17:56:47+08:00",
					"updated_at": "2025-08-26T16:34:41+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ASea-Teal-5-1_resolution-standard_v2-2x.jpg?v=1756197281",
					"variant_ids": [
						47319442030842
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Sea Teal",
				"public_title": "Sea Teal",
				"options": [
					"Sea Teal"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046692516090,
					"position": 50,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ASea-Teal-5-1_resolution-standard_v2-2x.jpg?v=1756197281"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441932538,
				"title": "Deep Purple",
				"option1": "Deep Purple",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Deep Purple",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996903375098,
					"product_id": 8780115640570,
					"position": 88,
					"created_at": "2025-05-17T17:52:13+08:00",
					"updated_at": "2025-08-26T16:34:44+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ADeep-Purple-4-2-1_resolution-standard_v2-2x.jpg?v=1756197284",
					"variant_ids": [
						47319441932538
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Deep Purple",
				"public_title": "Deep Purple",
				"options": [
					"Deep Purple"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046663057658,
					"position": 88,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ADeep-Purple-4-2-1_resolution-standard_v2-2x.jpg?v=1756197284"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441801466,
				"title": "Cappuccino",
				"option1": "Cappuccino",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Cappuccino",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996880601338,
					"product_id": 8780115640570,
					"position": 23,
					"created_at": "2025-05-17T17:49:47+08:00",
					"updated_at": "2025-08-26T16:34:39+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-4-2_resolution-standard_v2-2x.jpg?v=1756197279",
					"variant_ids": [
						47319441801466
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Cappuccino",
				"public_title": "Cappuccino",
				"options": [
					"Cappuccino"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046648770810,
					"position": 23,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ACappuccino-4-2_resolution-standard_v2-2x.jpg?v=1756197279"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441703162,
				"title": "Teal Blue",
				"option1": "Teal Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Teal Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996962390266,
					"product_id": 8780115640570,
					"position": 41,
					"created_at": "2025-05-17T17:57:51+08:00",
					"updated_at": "2025-08-26T16:34:40+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ATeal-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197280",
					"variant_ids": [
						47319441703162
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Teal Blue",
				"public_title": "Teal Blue",
				"options": [
					"Teal Blue"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046700577018,
					"position": 41,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ATeal-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197280"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441670394,
				"title": "Coffee",
				"option1": "Coffee",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Coffee",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996880699642,
					"product_id": 8780115640570,
					"position": 93,
					"created_at": "2025-05-17T17:49:47+08:00",
					"updated_at": "2025-08-26T16:34:45+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ACoffee-4-3_resolution-standard_v2-2x.jpg?v=1756197285",
					"variant_ids": [
						47319441670394
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Coffee",
				"public_title": "Coffee",
				"options": [
					"Coffee"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046648836346,
					"position": 93,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ACoffee-4-3_resolution-standard_v2-2x.jpg?v=1756197285"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441637626,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996840624378,
					"product_id": 8780115640570,
					"position": 13,
					"created_at": "2025-05-17T17:46:35+08:00",
					"updated_at": "2025-08-26T16:34:38+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABlack-1-6-2_resolution-standard_v2-2x.jpg?v=1756197278",
					"variant_ids": [
						47319441637626
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046622949626,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABlack-1-6-2_resolution-standard_v2-2x.jpg?v=1756197278"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319441604858,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-1-SD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996880568570,
					"product_id": 8780115640570,
					"position": 119,
					"created_at": "2025-05-17T17:49:47+08:00",
					"updated_at": "2025-08-26T16:34:47+08:00",
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287",
					"variant_ids": [
						47319441604858,
						47319442260218
					]
				},
				"available": true,
				"name": "Hussein OEKO Certified Custom Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 11000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
					"id": 36046648738042,
					"position": 119,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ABeige-3-7-1_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Beige_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AGrey-3-3_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/AGrey-1-3_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/AGrey-4-3_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x_0a87ee6d-e312-438d-81b0-56671bd426c0.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Grey_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/APure-White-3-3-1_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/APure-White-1-3-1_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/APure-White-2-4-1_resolution-standard_v2-2x.jpg?v=1756197277",
			"//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x_f46f4b2c-a5b6-4d54-bfd5-4873c77edaa6.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Pure_White_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ABlack-1-6-2_resolution-standard_v2-2x.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/ABlack-4-6-1_resolution-standard_v2-2x.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/ABlack-5-4-1_resolution-standard_v2-2x.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x_cbafa779-355f-4844-8ecf-16ce79cd3258.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Black_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/Ablack-ok_1__resolution-standard_v2-2x_3f2a5e7a-2ffc-4d57-b8af-ba7684559c37.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/AGreyish-White-4-2_resolution-standard_v2-2x.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/AGreyish-White-2-2_resolution-standard_v2-2x.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x_f0b66cd4-76cd-4e9f-993a-853713cd6e38.jpg?v=1756197278",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Greyish_White_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ACappuccino-4-2_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/ACappuccino-1-2_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/ACappuccino-2-3_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x_594e04f5-69f4-4c38-ad7b-b7839cb1d965.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Cappuccino_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ABeige-4-9-1_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/AFrame_1_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Red_Color_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ANavy-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/ANavy-Blue-1-3-1_resolution-standard_v2-2x.jpg?v=1756197279",
			"//thehues.com/cdn/shop/files/ANavy-Blue-2-3-1_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/AFrame_13_resolution-standard_v2-2x_a6052f60-d11e-43d2-9d57-1c38d885b0fa.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Navy_Blue_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AYellow-5-1_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/AYellow-1-1_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/AYellow-2-1_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/AFrame_19_resolution-standard_v2-2x_04d264ba-da3f-40bb-8713-b6c12da8ce76.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Yellow_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ATeal-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/ATeal-Blue-1-4-1_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/ATeal-Blue-1-5-1_resolution-standard_v2-2x.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/AFrame_18_resolution-standard_v2-2x_89077a87-310e-4db0-8ee4-2d5eb49a3511.jpg?v=1756197280",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Teal_Blue_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AStone-Blue-1-3_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/AStone-Blue-2-3_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/AFrame_17_resolution-standard_v2-2x_2e3d807d-8512-4377-9dc0-bad136d7a1c1.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Stone_Blue_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ASea-Teal-5-1_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/ASea-Teal-1-1_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/ASea-Teal-2-1_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sea_Teal_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AOlive-Green-2-1_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/AOlive-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197281",
			"//thehues.com/cdn/shop/files/AOlive-Green-4-1-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x_801db226-8b39-4e2c-9f6c-b6ab6c899c26.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/hussein-custom-curtain-olivegreen.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ALight-Beige-5-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/ALight-Beige-1-4-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/ALight-Beige-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x-1.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Light_Beige_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AHunter-Green-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/AHunter-Green-1-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/AHunter-Green-2-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
			"//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x_50560933-c249-42d7-965a-3927a10b3f92.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Hunter_Green_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ASilver-Grey-1-4_resolution-standard_v2-2x.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/ASilver-Grey-3-3_resolution-standard_v2-2x.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/ASilver-Grey-4-3_resolution-standard_v2-2x.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/AFrame_16_resolution-standard_v2-2x_0d5772dc-17ca-405e-b977-a72bee42da54.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Silver_Grey_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AVintage-Blue-4-1_resolution-standard_v2-2x.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/AVintage-Blue-1-1_resolution-standard_v2-2x.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/AVintage-Blue-2-1_resolution-standard_v2-2x.jpg?v=1756197283",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Vintage_Blue_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Burgundy_Red_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ALight-Pink-4-1_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/ALight-Pink-1-1_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/ALight-Pink-2-1_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Light_Pink_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ABrick-Red-4-3_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/ABrick-Red-1-2_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/ABrick-Red-2-2_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x_8b5644f8-f03f-42f3-a3a2-9a3fdca68c94.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Brick_Red_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ADeep-Purple-4-2-1_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/ADeep-Purple-1-3-1_resolution-standard_v2-2x.jpg?v=1756197284",
			"//thehues.com/cdn/shop/files/ADeep-Purple-2-2_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x_714b928b-d33f-45e8-8972-22961141e42e.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Deep_Purple_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ACoffee-4-3_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/ACoffee-1-3_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/ACoffee-2-3_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x_d3481954-1579-465b-a90e-eda943956a04.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Coffee_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ASand-4-2_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/ASand-1-2_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/ASand-2-2_resolution-standard_v2-2x.jpg?v=1756197285",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sand_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ABlue-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/ABlue-Green-3-2_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/ABlue-Green-4-2_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Blue_Green_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ASea-Blue-3-1_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/ASea-Blue-1-1_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/ASea-Blue-5-1_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sea_Blue_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ATender-Cyan-4-1_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/ATender-Cyan-1-2_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/ATender-Cyan-2-1_resolution-standard_v2-2x.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/AFrame_14_resolution-standard_v2-2x_31ecf3ff-00b5-4845-86b2-2d1fc3a169e2.jpg?v=1756197286",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Tender_Cyan_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/AEggplant-Purple-4-2_resolution-standardv2-2x.jpg?v=1756197287",
			"//thehues.com/cdn/shop/files/AEggplant-Purple-1-2_resolution-standardv2-2x.jpg?v=1756197287",
			"//thehues.com/cdn/shop/files/AEggplant-Purple-3-2_resolution-standardv2-2x.jpg?v=1756197287",
			"//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Eggplant_Purple_Close-up.jpg?v=1761213367",
			"//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287",
			"//thehues.com/cdn/shop/files/ABurgundy-Red-1-2-1_resolution-standard_v2-2x.jpg?v=1756197287",
			"//thehues.com/cdn/shop/files/ABurgundy-Red-3-1_resolution-standard_v2-2x.jpg?v=1756197287",
			"//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x-1.jpg?v=1756197287"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ABeige-3-7-1_resolution-standard_v2-2x_1024x1024.jpg?v=1756197277",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046622327034,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABeige-3-7-1_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABeige-3-7-1_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480433914,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Beige_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Beige_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670135546,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-3-3_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-3-3_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670201082,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-1-3_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-1-3_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670070010,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-4-3_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-4-3_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670102778,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x_0a87ee6d-e312-438d-81b0-56671bd426c0.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x_0a87ee6d-e312-438d-81b0-56671bd426c0.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480073466,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Grey_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Grey_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683439354,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-3-3-1_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-3-3-1_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683472122,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-1-3-1_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-1-3-1_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683504890,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-2-4-1_resolution-standard_v2-2x.jpg?v=1756197277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-2-4-1_resolution-standard_v2-2x.jpg?v=1756197277",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683373818,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x_f46f4b2c-a5b6-4d54-bfd5-4873c77edaa6.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x_f46f4b2c-a5b6-4d54-bfd5-4873c77edaa6.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480368378,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Pure_White_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Pure_White_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046622949626,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-1-6-2_resolution-standard_v2-2x.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-1-6-2_resolution-standard_v2-2x.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046623015162,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-4-6-1_resolution-standard_v2-2x.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-4-6-1_resolution-standard_v2-2x.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046622982394,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-5-4-1_resolution-standard_v2-2x.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-5-4-1_resolution-standard_v2-2x.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046622916858,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x_cbafa779-355f-4844-8ecf-16ce79cd3258.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x_cbafa779-355f-4844-8ecf-16ce79cd3258.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529479876858,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Black_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Black_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046622687482,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-ok_1__resolution-standard_v2-2x_3f2a5e7a-2ffc-4d57-b8af-ba7684559c37.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-ok_1__resolution-standard_v2-2x_3f2a5e7a-2ffc-4d57-b8af-ba7684559c37.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046668792058,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-White-4-2_resolution-standard_v2-2x.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-White-4-2_resolution-standard_v2-2x.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046668529914,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-White-2-2_resolution-standard_v2-2x.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-White-2-2_resolution-standard_v2-2x.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046668202234,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x_f0b66cd4-76cd-4e9f-993a-853713cd6e38.jpg?v=1756197278"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x_f0b66cd4-76cd-4e9f-993a-853713cd6e38.jpg?v=1756197278",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480532218,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Greyish_White_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Greyish_White_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648770810,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-4-2_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACappuccino-4-2_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648967418,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-1-2_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACappuccino-1-2_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648803578,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-2-3_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACappuccino-2-3_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648869114,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x_594e04f5-69f4-4c38-ad7b-b7839cb1d965.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x_594e04f5-69f4-4c38-ad7b-b7839cb1d965.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480204538,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Cappuccino_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Cappuccino_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046621999354,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABeige-4-9-1_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABeige-4-9-1_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046621868282,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_1_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_1_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529479942394,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Red_Color_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Red_Color_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046676001018,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANavy-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANavy-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046676066554,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANavy-Blue-1-3-1_resolution-standard_v2-2x.jpg?v=1756197279"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANavy-Blue-1-3-1_resolution-standard_v2-2x.jpg?v=1756197279",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046676033786,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANavy-Blue-2-3-1_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANavy-Blue-2-3-1_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046675476730,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_13_resolution-standard_v2-2x_a6052f60-d11e-43d2-9d57-1c38d885b0fa.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_13_resolution-standard_v2-2x_a6052f60-d11e-43d2-9d57-1c38d885b0fa.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480139002,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Navy_Blue_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Navy_Blue_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046701265146,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-5-1_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-5-1_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046701297914,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-1-1_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-1-1_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046701232378,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-2-1_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-2-1_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046701330682,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_19_resolution-standard_v2-2x_04d264ba-da3f-40bb-8713-b6c12da8ce76.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_19_resolution-standard_v2-2x_04d264ba-da3f-40bb-8713-b6c12da8ce76.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480499450,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Yellow_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Yellow_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700577018,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-Blue-4-3_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700544250,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-Blue-1-4-1_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-Blue-1-4-1_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700151034,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-Blue-1-5-1_resolution-standard_v2-2x.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-Blue-1-5-1_resolution-standard_v2-2x.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046685438202,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_18_resolution-standard_v2-2x_89077a87-310e-4db0-8ee4-2d5eb49a3511.jpg?v=1756197280"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_18_resolution-standard_v2-2x_89077a87-310e-4db0-8ee4-2d5eb49a3511.jpg?v=1756197280",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480728826,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Teal_Blue_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Teal_Blue_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046698479866,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AStone-Blue-1-3_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AStone-Blue-1-3_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046698545402,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AStone-Blue-2-3_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AStone-Blue-2-3_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046697988346,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_17_resolution-standard_v2-2x_2e3d807d-8512-4377-9dc0-bad136d7a1c1.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_17_resolution-standard_v2-2x_2e3d807d-8512-4377-9dc0-bad136d7a1c1.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480270074,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Stone_Blue_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Stone_Blue_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046692516090,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASea-Teal-5-1_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASea-Teal-5-1_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046692548858,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASea-Teal-1-1_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASea-Teal-1-1_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046692483322,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASea-Teal-2-1_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASea-Teal-2-1_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480564986,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sea_Teal_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sea_Teal_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683078906,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOlive-Green-2-1_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOlive-Green-2-1_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683013370,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOlive-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOlive-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197281",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046683046138,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOlive-Green-4-1-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOlive-Green-4-1-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046682980602,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x_801db226-8b39-4e2c-9f6c-b6ab6c899c26.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x_801db226-8b39-4e2c-9f6c-b6ab6c899c26.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529479975162,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/hussein-custom-curtain-olivegreen.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/hussein-custom-curtain-olivegreen.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670495994,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ALight-Beige-5-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ALight-Beige-5-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670561530,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ALight-Beige-1-4-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ALight-Beige-1-4-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670528762,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ALight-Beige-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ALight-Beige-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670266618,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x-1.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x-1.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480630522,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Light_Beige_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Light_Beige_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670463226,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHunter-Green-4-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670594298,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-1-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHunter-Green-1-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670430458,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-2-3-1_resolution-standard_v2-2x.jpg?v=1756197282"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHunter-Green-2-3-1_resolution-standard_v2-2x.jpg?v=1756197282",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046670168314,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x_50560933-c249-42d7-965a-3927a10b3f92.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x_50560933-c249-42d7-965a-3927a10b3f92.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480007930,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Hunter_Green_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Hunter_Green_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046693728506,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASilver-Grey-1-4_resolution-standard_v2-2x.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASilver-Grey-1-4_resolution-standard_v2-2x.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046693531898,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASilver-Grey-3-3_resolution-standard_v2-2x.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASilver-Grey-3-3_resolution-standard_v2-2x.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046693695738,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASilver-Grey-4-3_resolution-standard_v2-2x.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASilver-Grey-4-3_resolution-standard_v2-2x.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046693761274,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_16_resolution-standard_v2-2x_0d5772dc-17ca-405e-b977-a72bee42da54.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_16_resolution-standard_v2-2x_0d5772dc-17ca-405e-b977-a72bee42da54.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480335610,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Silver_Grey_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Silver_Grey_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700970234,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AVintage-Blue-4-1_resolution-standard_v2-2x.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AVintage-Blue-4-1_resolution-standard_v2-2x.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046701101306,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AVintage-Blue-1-1_resolution-standard_v2-2x.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AVintage-Blue-1-1_resolution-standard_v2-2x.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700839162,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AVintage-Blue-2-1_resolution-standard_v2-2x.jpg?v=1756197283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AVintage-Blue-2-1_resolution-standard_v2-2x.jpg?v=1756197283",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480597754,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Vintage_Blue_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Vintage_Blue_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529479909626,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Burgundy_Red_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Burgundy_Red_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046675149050,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ALight-Pink-4-1_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ALight-Pink-4-1_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046675214586,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ALight-Pink-1-1_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ALight-Pink-1-1_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046675181818,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ALight-Pink-2-1_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ALight-Pink-2-1_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480663290,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Light_Pink_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Light_Pink_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625931514,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrick-Red-4-3_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrick-Red-4-3_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625997050,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrick-Red-1-2_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrick-Red-1-2_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625964282,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrick-Red-2-2_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrick-Red-2-2_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625898746,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x_8b5644f8-f03f-42f3-a3a2-9a3fdca68c94.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x_8b5644f8-f03f-42f3-a3a2-9a3fdca68c94.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480237306,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Brick_Red_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Brick_Red_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046663057658,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADeep-Purple-4-2-1_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADeep-Purple-4-2-1_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046663287034,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADeep-Purple-1-3-1_resolution-standard_v2-2x.jpg?v=1756197284"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADeep-Purple-1-3-1_resolution-standard_v2-2x.jpg?v=1756197284",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046662893818,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADeep-Purple-2-2_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADeep-Purple-2-2_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046661976314,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x_714b928b-d33f-45e8-8972-22961141e42e.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x_714b928b-d33f-45e8-8972-22961141e42e.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480171770,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Deep_Purple_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Deep_Purple_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648836346,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACoffee-4-3_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACoffee-4-3_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648901882,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACoffee-1-3_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACoffee-1-3_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648934650,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACoffee-2-3_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACoffee-2-3_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046649000186,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x_d3481954-1579-465b-a90e-eda943956a04.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x_d3481954-1579-465b-a90e-eda943956a04.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529479844090,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Coffee_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Coffee_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046684717306,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-4-2_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-4-2_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046684651770,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-1-2_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-1-2_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046684553466,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-2-2_resolution-standard_v2-2x.jpg?v=1756197285"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-2-2_resolution-standard_v2-2x.jpg?v=1756197285",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480302842,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sand_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sand_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625145082,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-Green-1-2_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625210618,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-Green-3-2_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-Green-3-2_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046625243386,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-Green-4-2_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-Green-4-2_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480466682,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Blue_Green_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Blue_Green_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046685372666,
				"position": 106,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASea-Blue-3-1_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASea-Blue-3-1_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046685405434,
				"position": 107,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASea-Blue-1-1_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASea-Blue-1-1_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046685339898,
				"position": 108,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASea-Blue-5-1_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASea-Blue-5-1_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480696058,
				"position": 109,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sea_Blue_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Sea_Blue_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700708090,
				"position": 110,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATender-Cyan-4-1_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATender-Cyan-4-1_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700740858,
				"position": 111,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATender-Cyan-1-2_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATender-Cyan-1-2_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700609786,
				"position": 112,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATender-Cyan-2-1_resolution-standard_v2-2x.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATender-Cyan-2-1_resolution-standard_v2-2x.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046700806394,
				"position": 113,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_14_resolution-standard_v2-2x_31ecf3ff-00b5-4845-86b2-2d1fc3a169e2.jpg?v=1756197286"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_14_resolution-standard_v2-2x_31ecf3ff-00b5-4845-86b2-2d1fc3a169e2.jpg?v=1756197286",
				"width": 2000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480401146,
				"position": 114,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Tender_Cyan_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Tender_Cyan_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36076716294394,
				"position": 115,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-4-2_resolution-standardv2-2x.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-4-2_resolution-standardv2-2x.jpg?v=1756197287",
				"width": 4000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36076716392698,
				"position": 116,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-1-2_resolution-standardv2-2x.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-1-2_resolution-standardv2-2x.jpg?v=1756197287",
				"width": 4000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36076716261626,
				"position": 117,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-3-2_resolution-standardv2-2x.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AEggplant-Purple-3-2_resolution-standardv2-2x.jpg?v=1756197287",
				"width": 4000
			},
			{
				"alt": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain - TheHues",
				"id": 36529480106234,
				"position": 118,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Eggplant_Purple_Close-up.jpg?v=1761213367"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Hussein_Custom_Curtain_Eggplant_Purple_Close-up.jpg?v=1761213367",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648738042,
				"position": 119,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-5-1_resolution-standard_v2-2x.jpg?v=1756197287",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648705274,
				"position": 120,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-1-2-1_resolution-standard_v2-2x.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-1-2-1_resolution-standard_v2-2x.jpg?v=1756197287",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648639738,
				"position": 121,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-3-1_resolution-standard_v2-2x.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABurgundy-Red-3-1_resolution-standard_v2-2x.jpg?v=1756197287",
				"width": 2000
			},
			{
				"alt": "Hussein OEKO Certified Custom Curtain - TheHues",
				"id": 36046648606970,
				"position": 122,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x-1.jpg?v=1756197287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x-1.jpg?v=1756197287",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With its textured charm and triple-duty performance soundproof, thermal, and 100% blackout the Laborien Curtain envelops your space in serenity, warmth, and undisturbed darkness.</p>",
		"url": "/products/hussein-oeko-certified-custom-curtain",
		"regular_price": "$110.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780115804410,
		"title": "Tehreem Textured Sheer Custom Curtain",
		"handle": "tehreem-textured-sheer-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Sheer<br>Weight: Sheer (180g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Whispers elegance with its sheer, slub-textured weave. Each delicate imperfection tells a story, casting soft light and shadows that transform any room into a serene retreat.</p>",
		"published_at": "2025-05-07T16:27:07+08:00",
		"created_at": "2025-05-07T16:27:07+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Black Friday",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"New Year's Day",
			"sale top 10",
			"Search curtains",
			"Search sheer",
			"Spring Time Sale",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10600,
		"price_min": 10600,
		"price_max": 10600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319404347642,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778690298,
					"product_id": 8780115804410,
					"position": 1,
					"created_at": "2025-07-11T19:38:16+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404347642
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124461818,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1-300x300-1_resolution-standardv2-2x_1024x1024.jpg?v=1756197245"
			},
			{
				"id": 47319404413178,
				"title": "Light Beige",
				"option1": "Light Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-Light Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778886906,
					"product_id": 8780115804410,
					"position": 24,
					"created_at": "2025-07-11T19:38:20+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404413178
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - Light Beige",
				"public_title": "Light Beige",
				"options": [
					"Light Beige"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124658426,
					"position": 24,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DM_20250729162523_001_1024x1024.jpg?v=1753778673"
			},
			{
				"id": 47319404478714,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778919674,
					"product_id": 8780115804410,
					"position": 37,
					"created_at": "2025-07-11T19:38:20+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404478714
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124625658,
					"position": 37,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DM_20250729162721_001_1024x1024.jpg?v=1753778673"
			},
			{
				"id": 47319404314874,
				"title": "Silver Grey",
				"option1": "Silver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-Silver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778723066,
					"product_id": 8780115804410,
					"position": 13,
					"created_at": "2025-07-11T19:38:17+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404314874
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - Silver Grey",
				"public_title": "Silver Grey",
				"options": [
					"Silver Grey"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124494586,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Thumbnail_1024x1024.jpg?v=1756197240"
			},
			{
				"id": 47319404380410,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778821370,
					"product_id": 8780115804410,
					"position": 19,
					"created_at": "2025-07-11T19:38:18+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404380410
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124527354,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Thumbnail_1024x1024.jpg?v=1756197239"
			},
			{
				"id": 47319404445946,
				"title": "Dark Blue",
				"option1": "Dark Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-Dark Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778854138,
					"product_id": 8780115804410,
					"position": 30,
					"created_at": "2025-07-11T19:38:19+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404445946
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - Dark Blue",
				"public_title": "Dark Blue",
				"options": [
					"Dark Blue"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124592890,
					"position": 30,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319404282106,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-13-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44477778788602,
					"product_id": 8780115804410,
					"position": 7,
					"created_at": "2025-07-11T19:38:19+08:00",
					"updated_at": "2025-10-01T19:46:44+08:00",
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Side.jpg?v=1759319204",
					"variant_ids": [
						47319404282106
					]
				},
				"available": true,
				"name": "Tehreem Textured Sheer Custom Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 10600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
					"id": 36355124560122,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Side.jpg?v=1759319204"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Thumbnail_1024x1024.jpg?v=1756197239"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Close-up_Float.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Close-up_Float.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Close-up_Float.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Close-up_Float.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up_sunroom.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up_Float.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Side.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Front.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Close-up_Float.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Fabric.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Fabric_Close-up.jpg?v=1759319204",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Close-up.jpg?v=1761207349",
			"//thehues.com/cdn/shop/files/20250515-Ataupe-5_6__resolution-standardv2-2x.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/20250515-Ataupe-6_4__resolution-standardv2-2x.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/20250515-Ataupe-3_5__resolution-standardv2-2x.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Thumbnail.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Thumbnail.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Thumbnail.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-3_4__resolution-standardv2-2x.jpg?v=1756197239",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-2_5__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Thumbnail.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-3-1_5__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-5_4__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Thumbnail.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-4_5__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-5_4__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Thumbnail.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Adark-blue3_6__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Abeige-3_5__resolution-standardv2-2x.jpg?v=1756197240",
			"//thehues.com/cdn/shop/files/20250515-Abeige-4_4__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Frame13.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey-1_5__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey4_2__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey2_3__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey1_4__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Frame15.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise_5__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise4_2__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise1_4__resolution-standardv2-2x.jpg?v=1756197241",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise2_3__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Frame14.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1_5__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-5_2__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-2_4__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-3_3__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Frame11.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-dark-grey-1_5__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-3_2__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-4_3__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-2_4__resolution-standardv2-2x.jpg?v=1756197242",
			"//thehues.com/cdn/shop/files/20250522-20250521-Ablack-2-1_2__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-black-1_5__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Ablack-1-2_3__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Ablack-4-1_4__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Frame10.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Abeige-7_5__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Abeige-4-1_2__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Abeige-3-1_3__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Abeige-1-1_4__resolution-standardv2-2x.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Frame12.jpg?v=1756197243",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory_5__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-1_2__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-3_4__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-4_3__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-Awhite-2-1_2__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-1_1__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-1-1_1__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-Ataupe-2_1__resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-AFrame7_resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-AAdark-blue2_1__resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197244",
			"//thehues.com/cdn/shop/files/20250515-AAdark-blue4_2__resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250515-AFrame5_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250515-AFrame6_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-beige-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-black-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-dark-grey-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250522-20250521-Alight-grey-3-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
			"//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Side_1024x1024.jpg?v=1759319204",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124461818,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124691194,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058844266746,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Close-up_Float.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Close-up_Float.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449729708282,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449729282298,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730494714,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124560122,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124822266,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058842693882,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Close-up_Float.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Close-up_Float.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731019002,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730887930,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730330874,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124494586,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124887802,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058841579770,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Close-up_Float.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Close-up_Float.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449729970426,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449729937658,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730953466,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124527354,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124789498,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731182842,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731150074,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731248378,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124658426,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124756730,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058839154938,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Close-up_Float.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Close-up_Float.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730461946,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730396410,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730625786,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124592890,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124855034,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058837549306,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up_sunroom.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up_sunroom.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058837680378,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up_Float.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up_Float.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730724090,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731313914,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731412218,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124625658,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Side.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Side.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36355124920570,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Front.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Front.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058834993402,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Close-up_Float.jpg?v=1759319204"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Close-up_Float.jpg?v=1759319204",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730789626,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Fabric.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Fabric.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449730756858,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Fabric_Close-up.jpg?v=1759319204"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Fabric_Close-up.jpg?v=1759319204",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36449731379450,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Close-up.jpg?v=1761207349"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Beige_Close-up.jpg?v=1761207349",
				"width": 1365
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058843283706,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-5_6__resolution-standardv2-2x.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-5_6__resolution-standardv2-2x.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058843316474,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-6_4__resolution-standardv2-2x.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-6_4__resolution-standardv2-2x.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058843414778,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-3_5__resolution-standardv2-2x.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-3_5__resolution-standardv2-2x.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058843349242,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Thumbnail.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Taupe_Thumbnail.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058844168442,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Thumbnail.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_White_Thumbnail.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058842726650,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Thumbnail.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Stone_Blue_Thumbnail.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058842824954,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-3_4__resolution-standardv2-2x.jpg?v=1756197239"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-3_4__resolution-standardv2-2x.jpg?v=1756197239",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058842792186,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-2_5__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-2_5__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058841645306,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Thumbnail.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Silver_Grey_Thumbnail.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058841776378,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-3-1_5__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-3-1_5__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058841809146,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-5_4__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-5_4__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058840105210,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Thumbnail.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Light_Beige_Thumbnail.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058839187706,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-4_5__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-4_5__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058839220474,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-5_4__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-5_4__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058837451002,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Thumbnail.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tehreem_Textured_Sheer_Custom_Curtain_Dark_Blue_Thumbnail.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058837614842,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Adark-blue3_6__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Adark-blue3_6__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058834698490,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-3_5__resolution-standardv2-2x.jpg?v=1756197240"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-3_5__resolution-standardv2-2x.jpg?v=1756197240",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Cafe Curtain - TheHues",
				"id": 36058834829562,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-4_4__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-4_4__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208438522,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame13.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame13.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208504058,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey-1_5__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey-1_5__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208602362,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey4_2__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey4_2__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208536826,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey2_3__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey2_3__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208471290,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey1_4__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alightgrey1_4__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134209618170,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame15.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame15.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134209454330,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise_5__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise_5__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134209552634,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise4_2__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise4_2__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134209487098,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise1_4__resolution-standardv2-2x.jpg?v=1756197241"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise1_4__resolution-standardv2-2x.jpg?v=1756197241",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134209519866,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise2_3__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-turquoise2_3__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208798970,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame14.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame14.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208831738,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1_5__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1_5__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208766202,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-5_2__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-5_2__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208700666,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-2_4__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-2_4__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208733434,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-3_3__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-3_3__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206898426,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame11.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame11.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207029498,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-dark-grey-1_5__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-dark-grey-1_5__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206963962,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-3_2__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-3_2__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206996730,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-4_3__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-4_3__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206931194,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-2_4__resolution-standardv2-2x.jpg?v=1756197242"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Adarkgrey-2_4__resolution-standardv2-2x.jpg?v=1756197242",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206341370,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Ablack-2-1_2__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Ablack-2-1_2__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206406906,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-black-1_5__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-black-1_5__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206308602,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Ablack-1-2_3__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Ablack-1-2_3__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206374138,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Ablack-4-1_4__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Ablack-4-1_4__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206111994,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame10.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame10.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206243066,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-7_5__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-7_5__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206210298,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-4-1_2__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-4-1_2__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206177530,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-3-1_3__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-3-1_3__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206144762,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-1-1_4__resolution-standardv2-2x.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Abeige-1-1_4__resolution-standardv2-2x.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207258874,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame12.jpg?v=1756197243"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Frame12.jpg?v=1756197243",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207291642,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory_5__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory_5__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207324410,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-1_2__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-1_2__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207389946,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-3_4__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-3_4__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207422714,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-4_3__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-4_3__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058844201210,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-2-1_2__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-2-1_2__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058842759418,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-1_1__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-1_1__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058841710842,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-1-1_1__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-1-1_1__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058843382010,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-2_1__resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Ataupe-2_1__resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058839286010,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame7_resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame7_resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058837483770,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AAdark-blue2_1__resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197244"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AAdark-blue2_1__resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197244",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058837516538,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AAdark-blue4_2__resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AAdark-blue4_2__resolution-standardv2-2x_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058834534650,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame5_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame5_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36058834632954,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame6_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame6_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206079226,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-beige-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-beige-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206275834,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-black-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-black-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134206865658,
				"position": 106,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-dark-grey-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-dark-grey-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134207357178,
				"position": 107,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-ivory-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208569594,
				"position": 108,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alight-grey-3-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Alight-grey-3-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": "Tehreem Textured Sheer Custom Curtain - TheHues",
				"id": 36134208667898,
				"position": 109,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250521-Avoile-pure-white-1-300x300-1_resolution-standardv2-2x.jpg?v=1756197245",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36111300821242,
				"position": 110,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/cfec95155f91418f9ef1ef35ca98735c.thumbnail.0000000000.jpg?v=1748573711"
				},
				"aspect_ratio": 0.563,
				"duration": 13630,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/cfec95155f91418f9ef1ef35ca98735c/cfec95155f91418f9ef1ef35ca98735c.SD-480p-0.9Mbps-48492079.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/cfec95155f91418f9ef1ef35ca98735c/cfec95155f91418f9ef1ef35ca98735c.HD-1080p-2.5Mbps-48492079.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/cfec95155f91418f9ef1ef35ca98735c/cfec95155f91418f9ef1ef35ca98735c.HD-720p-1.6Mbps-48492079.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/cfec95155f91418f9ef1ef35ca98735c/cfec95155f91418f9ef1ef35ca98735c.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Whispers elegance with its sheer, slub-textured weave. Each delicate imperfection tells a story, casting soft light and shadows that transform any room into a serene retreat.</p>",
		"url": "/products/tehreem-textured-sheer-custom-curtain",
		"regular_price": "$106.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780117967098,
		"title": "Voy Linen Look Custom Curtain",
		"handle": "voy-linen-look-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Light Filtering<br>Weight: Regular (312g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p></div>`,
		"description": "<p>Voy thick linen curtains bring a bold, timeless presence to your room. Their substantial texture, rich with depth, adds an air of understated luxury, offering both warmth and sophistication to your space.</p>",
		"published_at": "2025-05-07T16:28:34+08:00",
		"created_at": "2025-05-07T16:28:34+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Black Friday",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"indoor curtain",
			"New Content",
			"New Year's Day",
			"Sale",
			"Sale > All Curtain Sale",
			"sale top 10",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"ships in 3 days",
			"summer best seller",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10400,
		"price_min": 10400,
		"price_max": 10400,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319396811002,
				"title": "Light Beige",
				"option1": "Light Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-63-SD-Light Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44016375496954,
					"product_id": 8780117967098,
					"position": 10,
					"created_at": "2025-05-20T14:16:09+08:00",
					"updated_at": "2025-08-26T16:31:32+08:00",
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-3-2_2__resolution-standardv2-2x.jpg?v=1756197092",
					"variant_ids": [
						47319396811002
					]
				},
				"available": true,
				"name": "Voy Linen Look Custom Curtain - Light Beige",
				"public_title": "Light Beige",
				"options": [
					"Light Beige"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"id": 36058849771770,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-3-2_2__resolution-standardv2-2x.jpg?v=1756197092"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avoy_lightbeige_1024x1024.png?v=1751335727"
			},
			{
				"id": 47319396778234,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-63-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44016374644986,
					"product_id": 8780117967098,
					"position": 3,
					"created_at": "2025-05-20T14:16:02+08:00",
					"updated_at": "2025-08-26T16:31:31+08:00",
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-3-3_2__resolution-standardv2-2x.jpg?v=1756197091",
					"variant_ids": [
						47319396778234
					]
				},
				"available": true,
				"name": "Voy Linen Look Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"id": 36058849575162,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Abeige-3-3_2__resolution-standardv2-2x.jpg?v=1756197091"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avoy_beige_1024x1024.png?v=1751335726"
			},
			{
				"id": 47319396843770,
				"title": "Pure White",
				"option1": "Pure White",
				"option2": null,
				"option3": null,
				"sku": "THC-63-SD-Pure White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44018035785978,
					"product_id": 8780117967098,
					"position": 15,
					"created_at": "2025-05-20T19:59:15+08:00",
					"updated_at": "2025-08-26T16:31:32+08:00",
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-3-3_2__resolution-standardv2-2x.jpg?v=1756197092",
					"variant_ids": [
						47319396843770
					]
				},
				"available": true,
				"name": "Voy Linen Look Custom Curtain - Pure White",
				"public_title": "Pure White",
				"options": [
					"Pure White"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"id": 36059788869882,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Awhite-3-3_2__resolution-standardv2-2x.jpg?v=1756197092"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avoy_purewhite_1024x1024.png?v=1751335726"
			},
			{
				"id": 47319396876538,
				"title": "Silver Gray",
				"option1": "Silver Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-63-SD-Silver Gray",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44018028806394,
					"product_id": 8780117967098,
					"position": 22,
					"created_at": "2025-05-20T19:58:23+08:00",
					"updated_at": "2025-08-26T16:31:33+08:00",
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-8-1_2__resolution-standardv2-2x.jpg?v=1756197093",
					"variant_ids": [
						47319396876538
					]
				},
				"available": true,
				"name": "Voy Linen Look Custom Curtain - Silver Gray",
				"public_title": "Silver Gray",
				"options": [
					"Silver Gray"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"id": 36059782938874,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-8-1_2__resolution-standardv2-2x.jpg?v=1756197093"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avoy_silvergray_1024x1024.png?v=1751335726"
			},
			{
				"id": 47319396909306,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-63-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44018035392762,
					"product_id": 8780117967098,
					"position": 29,
					"created_at": "2025-05-20T19:59:14+08:00",
					"updated_at": "2025-08-26T16:31:34+08:00",
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame9_resolution-standardv2-2x.jpg?v=1756197094",
					"variant_ids": [
						47319396909306
					]
				},
				"available": true,
				"name": "Voy Linen Look Custom Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Voy Linen Look Custom Curtain - TheHues",
					"id": 36059788706042,
					"position": 29,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-AFrame9_resolution-standardv2-2x.jpg?v=1756197094"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x.jpg?v=1756197091",
			"//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-lightbeige.jpg?v=1761207522",
			"//thehues.com/cdn/shop/files/20250515-Abeige-3-3_2__resolution-standardv2-2x.jpg?v=1756197091",
			"//thehues.com/cdn/shop/files/20250515-AFrame14_resolution-standardv2-2x.jpg?v=1756197091",
			"//thehues.com/cdn/shop/files/20250515-Abeige-5-2_4__resolution-standardv2-2x.jpg?v=1756197091",
			"//thehues.com/cdn/shop/files/20250515-Abeige-4-3_3__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-beige.jpg?v=1761207522",
			"//thehues.com/cdn/shop/files/20250515-Abeige-7-2_6__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Abeige-6-2_7__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-3-2_2__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-5-2_4__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-4-3_3__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-1-2_6__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-7-1_7__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Awhite-3-3_2__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-AFrame12_resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Awhite-4-3_3__resolution-standardv2-2x.jpg?v=1756197092",
			"//thehues.com/cdn/shop/files/20250515-Awhite-5-4_4__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-purewhite.jpg?v=1761207522",
			"//thehues.com/cdn/shop/files/20250515-Awhite-7-3_6__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-Awhite-8-1_7__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-8-1_2__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-AFrame10_resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-7-2_3__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-6-2_4__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-silvergrey.jpg?v=1761207522",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-4-2_6__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-3-3_7__resolution-standardv2-2x.jpg?v=1756197093",
			"//thehues.com/cdn/shop/files/20250515-AFrame9_resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-3-3_4__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-2-2_3__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-stoneblue.jpg?v=1761207522",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-6-2_7__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-5-2_6__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Abeige-8-1_5__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-8-1_5__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Awhite-6-4_5__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Asilver-grey-5-2_5__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Abeige-2-3_8__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Alight-beige-2-2-1_8__resolution-standardv2-2x.jpg?v=1756197094",
			"//thehues.com/cdn/shop/files/20250515-Astone-blue-4-2_5__resolution-standardv2-2x.jpg?v=1756197095"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x_1024x1024.jpg?v=1756197091",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849935610,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x.jpg?v=1756197091"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame13_resolution-standardv2-2x.jpg?v=1756197091",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36639633178874,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3768,
					"width": 3015,
					"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-lightbeige.jpg?v=1761207522"
				},
				"aspect_ratio": 0.8,
				"height": 3768,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-lightbeige.jpg?v=1761207522",
				"width": 3015
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849575162,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-3-3_2__resolution-standardv2-2x.jpg?v=1756197091"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-3-3_2__resolution-standardv2-2x.jpg?v=1756197091",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849509626,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame14_resolution-standardv2-2x.jpg?v=1756197091"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame14_resolution-standardv2-2x.jpg?v=1756197091",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849378554,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-5-2_4__resolution-standardv2-2x.jpg?v=1756197091"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-5-2_4__resolution-standardv2-2x.jpg?v=1756197091",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849345786,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-4-3_3__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-4-3_3__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36639633244410,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3768,
					"width": 3015,
					"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-beige.jpg?v=1761207522"
				},
				"aspect_ratio": 0.8,
				"height": 3768,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-beige.jpg?v=1761207522",
				"width": 3015
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849444090,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-7-2_6__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-7-2_6__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849411322,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-6-2_7__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-6-2_7__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849771770,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-3-2_2__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-3-2_2__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849837306,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-5-2_4__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-5-2_4__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849804538,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-4-3_3__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-4-3_3__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849706234,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-1-2_6__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-1-2_6__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36058849870074,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-7-1_7__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-7-1_7__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788869882,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-3-3_2__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-3-3_2__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059789066490,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame12_resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame12_resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788902650,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-4-3_3__resolution-standardv2-2x.jpg?v=1756197092"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-4-3_3__resolution-standardv2-2x.jpg?v=1756197092",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788935418,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-5-4_4__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-5-4_4__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36639633113338,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3768,
					"width": 3015,
					"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-purewhite.jpg?v=1761207522"
				},
				"aspect_ratio": 0.8,
				"height": 3768,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-purewhite.jpg?v=1761207522",
				"width": 3015
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059789000954,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7-3_6__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7-3_6__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059789033722,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-8-1_7__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-8-1_7__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059782938874,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-8-1_2__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-8-1_2__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059782971642,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame10_resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame10_resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059782906106,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-7-2_3__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-7-2_3__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059782873338,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-6-2_4__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-6-2_4__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36639633146106,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3768,
					"width": 3015,
					"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-silvergrey.jpg?v=1761207522"
				},
				"aspect_ratio": 0.8,
				"height": 3768,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-silvergrey.jpg?v=1761207522",
				"width": 3015
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059782807802,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-4-2_6__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-4-2_6__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059782775034,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-3-3_7__resolution-standardv2-2x.jpg?v=1756197093"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-3-3_7__resolution-standardv2-2x.jpg?v=1756197093",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788706042,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-AFrame9_resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-AFrame9_resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788771578,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-3-3_4__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-3-3_4__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788738810,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-2-2_3__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-2-2_3__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36639633211642,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3768,
					"width": 3015,
					"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-stoneblue.jpg?v=1761207522"
				},
				"aspect_ratio": 0.8,
				"height": 3768,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/voy-linen-look-custom-curtain-stoneblue.jpg?v=1761207522",
				"width": 3015
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788640506,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-6-2_7__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-6-2_7__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy Linen Look Custom Curtain - TheHues",
				"id": 36059788837114,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-5-2_6__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-5-2_6__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36058849476858,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-8-1_5__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-8-1_5__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36058849902842,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-8-1_5__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-8-1_5__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36059788968186,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-6-4_5__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-6-4_5__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36059782840570,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-5-2_5__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asilver-grey-5-2_5__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36058849542394,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Abeige-2-3_8__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Abeige-2-3_8__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36058849739002,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-2-2-1_8__resolution-standardv2-2x.jpg?v=1756197094"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Alight-beige-2-2-1_8__resolution-standardv2-2x.jpg?v=1756197094",
				"width": 2000
			},
			{
				"alt": "Voy 100% Blackout Linen Look Custom Curtain - TheHues",
				"id": 36059788804346,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-4-2_5__resolution-standardv2-2x.jpg?v=1756197095"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Astone-blue-4-2_5__resolution-standardv2-2x.jpg?v=1756197095",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Voy thick linen curtains bring a bold, timeless presence to your room. Their substantial texture, rich with depth, adds an air of understated luxury, offering both warmth and sophistication to your space.</p>",
		"url": "/products/voy-linen-look-custom-curtain",
		"regular_price": "$104.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780116459770,
		"title": "Laborien Linen Look Textured Custom Curtain",
		"handle": "laborien-linen-look-textured-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Room Darkening<br>Weight: Light Weight (240g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Offering the perfect balance of light control and sophistication, Laborien curtains transform your space. The sleek, linen-inspired texture enhances the room, while their room-darkening quality ensures quiet, serene moments.</p>",
		"published_at": "2025-05-07T16:27:36+08:00",
		"created_at": "2025-05-07T16:27:36+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"indoor curtain",
			"New Content",
			"sale top 10",
			"Search cotton",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"ships in 3 days",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10000,
		"price_min": 10000,
		"price_max": 10000,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319434559738,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996703817978,
					"product_id": 8780116459770,
					"position": 1,
					"created_at": "2025-05-17T17:33:22+08:00",
					"updated_at": "2025-08-26T16:32:57+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x.jpg?v=1756197177",
					"variant_ids": [
						47319434559738
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046541914362,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x.jpg?v=1756197177"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abeige-6-7_6__resolution-standard_v2-2x_1024x1024.jpg?v=1756197179"
			},
			{
				"id": 47329766277370,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": null,
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996705718522,
					"product_id": 8780116459770,
					"position": 22,
					"created_at": "2025-05-17T17:33:43+08:00",
					"updated_at": "2025-08-26T16:32:59+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x.jpg?v=1756197179",
					"variant_ids": [
						47329766277370
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046543487226,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x.jpg?v=1756197179"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alaborien_grey_1024x1024.jpg?v=1751339389"
			},
			{
				"id": 47319434494202,
				"title": "Grey-Blue",
				"option1": "Grey-Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-Grey-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996705882362,
					"product_id": 8780116459770,
					"position": 16,
					"created_at": "2025-05-17T17:33:51+08:00",
					"updated_at": "2025-08-26T16:32:58+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_8_resolution-standard_v2-2x.jpg?v=1756197178",
					"variant_ids": [
						47319434494202
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Grey-Blue",
				"public_title": "Grey-Blue",
				"options": [
					"Grey-Blue"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046543651066,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_8_resolution-standard_v2-2x.jpg?v=1756197178"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alaborien_greyblue_1024x1024.jpg?v=1751339389"
			},
			{
				"id": 47319434625274,
				"title": "Lake-Blue",
				"option1": "Lake-Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-Lake-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996706341114,
					"product_id": 8780116459770,
					"position": 6,
					"created_at": "2025-05-17T17:34:03+08:00",
					"updated_at": "2025-08-26T16:32:57+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x.jpg?v=1756197177",
					"variant_ids": [
						47319434625274
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Lake-Blue",
				"public_title": "Lake-Blue",
				"options": [
					"Lake-Blue"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046544077050,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x.jpg?v=1756197177"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alaborien_lakeblue_1024x1024.jpg?v=1751339389"
			},
			{
				"id": 47319434395898,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996713484538,
					"product_id": 8780116459770,
					"position": 3,
					"created_at": "2025-05-17T17:34:24+08:00",
					"updated_at": "2025-08-26T16:32:57+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x.jpg?v=1756197177",
					"variant_ids": [
						47319434395898
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046547878138,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x.jpg?v=1756197177"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319434428666,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996710600954,
					"product_id": 8780116459770,
					"position": 19,
					"created_at": "2025-05-17T17:34:16+08:00",
					"updated_at": "2025-08-26T16:32:58+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x.jpg?v=1756197178",
					"variant_ids": [
						47319434428666
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046546436346,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x.jpg?v=1756197178"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319434526970,
				"title": "Coffee",
				"option1": "Coffee",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-Coffee",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996705292538,
					"product_id": 8780116459770,
					"position": 13,
					"created_at": "2025-05-17T17:33:37+08:00",
					"updated_at": "2025-08-26T16:32:58+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x.jpg?v=1756197178",
					"variant_ids": [
						47319434526970
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Coffee",
				"public_title": "Coffee",
				"options": [
					"Coffee"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046543126778,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x.jpg?v=1756197178"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319434592506,
				"title": "Navy Blue",
				"option1": "Navy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-26-SD-Navy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996706439418,
					"product_id": 8780116459770,
					"position": 9,
					"created_at": "2025-05-17T17:34:06+08:00",
					"updated_at": "2025-08-26T16:32:57+08:00",
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x.jpg?v=1756197177",
					"variant_ids": [
						47319434592506
					]
				},
				"available": true,
				"name": "Laborien Linen Look Textured Custom Curtain - Navy Blue",
				"public_title": "Navy Blue",
				"options": [
					"Navy Blue"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
					"id": 36046544240890,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x.jpg?v=1756197177"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-beige.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-7_resolution-standard_v2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-white.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-4_resolution-standard_v2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-lakeblue.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-5_resolution-standard_v2-2x.jpg?v=1756197177",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-navyblue.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1__resolution-standardv2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-1_resolution-standard_v2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-coffee.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/AFrame_8_resolution-standard_v2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-3_resolution-standard_v2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-greyblue.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-6_resolution-standard_v2-2x.jpg?v=1756197178",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-red.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Abeige-6-copy_1_-2_resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-grey.jpg?v=1761207648",
			"//thehues.com/cdn/shop/files/Ahoneyview_116-8_9__resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Ahoneyview_116-7_8__resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Abeige-6-7_6__resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Acoffee-6-1_5__resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Alaborien-1_1_resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Alaborien-4_resolution-standard_v2-2x.jpg?v=1756197179",
			"//thehues.com/cdn/shop/files/Alabronain-navy-blue_3_1_resolution-standard_v2-2x.jpg?v=1756197180",
			"//thehues.com/cdn/shop/files/Alaborien-7_resolution-standardv2-2x.jpg?v=1756197180",
			"//thehues.com/cdn/shop/files/Alaborien-3_1_resolution-standard_v2-2x.jpg?v=1756197180",
			"//thehues.com/cdn/shop/files/Alaborien-5_1_resolution-standard_v2-2x.jpg?v=1756197180",
			"//thehues.com/cdn/shop/files/Alaborien-2_1_resolution-standard_v2-2x.jpg?v=1756197180"
		],
		"featured_image": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x_1024x1024.jpg?v=1756197177",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046541914362,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529517003002,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-beige.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-beige.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046547878138,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_12_resolution-standard_v2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046547845370,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-7_resolution-standard_v2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-7_resolution-standard_v2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529517035770,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-white.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-white.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544077050,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_10_resolution-standard_v2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544044282,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-4_resolution-standard_v2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-4_resolution-standard_v2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529516970234,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-lakeblue.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-lakeblue.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544240890,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_9_resolution-standard_v2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544208122,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-5_resolution-standard_v2-2x.jpg?v=1756197177"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-5_resolution-standard_v2-2x.jpg?v=1756197177",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529516937466,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-navyblue.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-navyblue.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046541881594,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1__resolution-standardv2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1__resolution-standardv2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543126778,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_6_resolution-standard_v2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543094010,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-1_resolution-standard_v2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-1_resolution-standard_v2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529516871930,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-coffee.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-coffee.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543651066,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_8_resolution-standard_v2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_8_resolution-standard_v2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543585530,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-3_resolution-standard_v2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-3_resolution-standard_v2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529517068538,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-greyblue.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-greyblue.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046546436346,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_11_resolution-standard_v2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046546370810,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-6_resolution-standard_v2-2x.jpg?v=1756197178"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-6_resolution-standard_v2-2x.jpg?v=1756197178",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529516904698,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-red.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-red.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543487226,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_7_resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543454458,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-2_resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-copy_1_-2_resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36529517101306,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-grey.jpg?v=1761207648"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/laborien-linen-textured-custom-curtain-grey.jpg?v=1761207648",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544011514,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahoneyview_116-8_9__resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahoneyview_116-8_9__resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544109818,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahoneyview_116-7_8__resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahoneyview_116-7_8__resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046566850810,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/Abeige-6-7_6__resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-6-7_6__resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2001
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046567244026,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/Acoffee-6-1_5__resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acoffee-6-1_5__resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2001
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046547812602,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alaborien-1_1_resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alaborien-1_1_resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544142586,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alaborien-4_resolution-standard_v2-2x.jpg?v=1756197179"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alaborien-4_resolution-standard_v2-2x.jpg?v=1756197179",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046544175354,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alabronain-navy-blue_3_1_resolution-standard_v2-2x.jpg?v=1756197180"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alabronain-navy-blue_3_1_resolution-standard_v2-2x.jpg?v=1756197180",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046541979898,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alaborien-7_resolution-standardv2-2x.jpg?v=1756197180"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alaborien-7_resolution-standardv2-2x.jpg?v=1756197180",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543061242,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alaborien-3_1_resolution-standard_v2-2x.jpg?v=1756197180"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alaborien-3_1_resolution-standard_v2-2x.jpg?v=1756197180",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046543618298,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alaborien-5_1_resolution-standard_v2-2x.jpg?v=1756197180"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alaborien-5_1_resolution-standard_v2-2x.jpg?v=1756197180",
				"width": 2000
			},
			{
				"alt": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain - TheHues",
				"id": 36046546403578,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alaborien-2_1_resolution-standard_v2-2x.jpg?v=1756197180"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alaborien-2_1_resolution-standard_v2-2x.jpg?v=1756197180",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36094301569274,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/c7de8ea4d30d42f0bca908b9f7bb4cd0.thumbnail.0000000000.jpg?v=1748331325"
				},
				"aspect_ratio": 0.563,
				"duration": 5920,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c7de8ea4d30d42f0bca908b9f7bb4cd0/c7de8ea4d30d42f0bca908b9f7bb4cd0.SD-480p-0.9Mbps-48294005.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c7de8ea4d30d42f0bca908b9f7bb4cd0/c7de8ea4d30d42f0bca908b9f7bb4cd0.HD-1080p-2.5Mbps-48294005.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c7de8ea4d30d42f0bca908b9f7bb4cd0/c7de8ea4d30d42f0bca908b9f7bb4cd0.HD-720p-1.6Mbps-48294005.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c7de8ea4d30d42f0bca908b9f7bb4cd0/c7de8ea4d30d42f0bca908b9f7bb4cd0.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Offering the perfect balance of light control and sophistication, Laborien curtains transform your space. The sleek, linen-inspired texture enhances the room, while their room-darkening quality ensures quiet, serene moments.</p>",
		"url": "/products/laborien-linen-look-textured-custom-curtain",
		"regular_price": "$100.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780119900410,
		"title": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain",
		"handle": "jazlynn-4-layers-linen-look-heavyweight-soundproof-thermal-100-blackout-anti-dust-velvet-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester</p><p>Features: Blackout &amp; Insulating</p><p>Weight: Heavy Weight (713g/㎡)</p><p>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not bleach</p><p>Do Not Iron</p><p>Dry Clean Allowed</p><p>If curtains require cleaning — taking off lining is recommended</p></div>`,
		"description": "<p>With 100% blackout, soundproofing, and thermal insulation, they redefine comfort and sophistication. Draped in a Classic velvet.</p>",
		"published_at": "2025-06-05T09:20:59+08:00",
		"created_at": "2025-05-07T16:29:21+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"4 layer",
			"All Curtains",
			"Bestseller",
			"Blackout",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Solid Velvet Curtains",
			"Curtains > Room Darkening Curtains",
			"Custom Blackout Curtains",
			"Custom Blackout Curtains > Blackout Curtains",
			"Custom Blackout Curtains > Dustproof Curtains",
			"Custom Blackout Curtains > Soundproof Curtains",
			"Easter Sale",
			"Factory products",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"Oeko",
			"Sale",
			"Sale > All Curtain Sale",
			"Search blackout",
			"Search curtains",
			"Search soundproof",
			"Search thermal",
			"Search velvet",
			"Soundproof",
			"Soundproof & Blackout Curtains",
			"Thermal Curtains"
		],
		"price": 11900,
		"price_min": 11900,
		"price_max": 11900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319438360826,
				"title": "Coffee",
				"option1": "Coffee",
				"option2": null,
				"option3": null,
				"sku": "THVC-RP-4-Coffee",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44125448339706,
					"product_id": 8780119900410,
					"position": 29,
					"created_at": "2025-06-05T09:17:16+08:00",
					"updated_at": "2025-09-01T18:14:34+08:00",
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-1-2-gigapixel-standardv2-2500h.jpg?v=1756721674",
					"variant_ids": [
						47319438360826
					]
				},
				"available": true,
				"name": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - Coffee",
				"public_title": "Coffee",
				"options": [
					"Coffee"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"id": 36133332287738,
					"position": 29,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20240202-Coffee-1-2-gigapixel-standardv2-2500h.jpg?v=1756721674"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Coffee-6-290x300_1024x1024.jpg?v=1751357423"
			},
			{
				"id": 47319438393594,
				"title": "Ginger",
				"option1": "Ginger",
				"option2": null,
				"option3": null,
				"sku": "THVC-RP-4-Ginger",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44125451223290,
					"product_id": 8780119900410,
					"position": 22,
					"created_at": "2025-06-05T09:18:06+08:00",
					"updated_at": "2025-09-01T18:14:34+08:00",
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250219-ginger-yellow-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
					"variant_ids": [
						47319438393594
					]
				},
				"available": true,
				"name": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - Ginger",
				"public_title": "Ginger",
				"options": [
					"Ginger"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"id": 36133334352122,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250219-ginger-yellow-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ginger-yellow-4-290x300_1024x1024.jpg?v=1751357423"
			},
			{
				"id": 47319438426362,
				"title": "Ink Blue",
				"option1": "Ink Blue",
				"option2": null,
				"option3": null,
				"sku": "THVC-RP-4-Ink Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44125450436858,
					"product_id": 8780119900410,
					"position": 15,
					"created_at": "2025-06-05T09:18:02+08:00",
					"updated_at": "2025-09-01T18:14:34+08:00",
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250219-Ink-blue-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
					"variant_ids": [
						47319438426362
					]
				},
				"available": true,
				"name": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - Ink Blue",
				"public_title": "Ink Blue",
				"options": [
					"Ink Blue"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"id": 36133333827834,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250219-Ink-blue-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ink-blue-4-290x300_1024x1024.jpg?v=1751357423"
			},
			{
				"id": 47319438459130,
				"title": "Silver Gray",
				"option1": "Silver Gray",
				"option2": null,
				"option3": null,
				"sku": "THVC-RP-4-Silver Gray",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44125451485434,
					"product_id": 8780119900410,
					"position": 1,
					"created_at": "2025-06-05T09:18:06+08:00",
					"updated_at": "2025-09-01T18:14:34+08:00",
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250219-silver-gray-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
					"variant_ids": [
						47319438459130
					]
				},
				"available": true,
				"name": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - Silver Gray",
				"public_title": "Silver Gray",
				"options": [
					"Silver Gray"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"id": 36133334548730,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250219-silver-gray-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/silver-gray-3-290x300_1024x1024.jpg?v=1751357423"
			},
			{
				"id": 47319438491898,
				"title": "Olive Green",
				"option1": "Olive Green",
				"option2": null,
				"option3": null,
				"sku": "THVC-RP-4-Olive Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44125451682042,
					"product_id": 8780119900410,
					"position": 8,
					"created_at": "2025-06-05T09:18:07+08:00",
					"updated_at": "2025-09-01T18:14:34+08:00",
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250219-olive-green-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
					"variant_ids": [
						47319438491898
					]
				},
				"available": true,
				"name": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - Olive Green",
				"public_title": "Olive Green",
				"options": [
					"Olive Green"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"id": 36133334745338,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250219-olive-green-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319438524666,
				"title": "Dusty Rose",
				"option1": "Dusty Rose",
				"option2": null,
				"option3": null,
				"sku": "THVC-RP-4-Dusty Rose",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44125449519354,
					"product_id": 8780119900410,
					"position": 36,
					"created_at": "2025-06-05T09:17:40+08:00",
					"updated_at": "2025-09-01T18:14:34+08:00",
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250219-dustyrose-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
					"variant_ids": [
						47319438524666
					]
				},
				"available": true,
				"name": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - Dusty Rose",
				"public_title": "Dusty Rose",
				"options": [
					"Dusty Rose"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
					"id": 36133333303546,
					"position": 36,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250219-dustyrose-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250219-silver-gray-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-silvergray.jpg?v=1761207461",
			"//thehues.com/cdn/shop/files/20240301-silver-gray-3-gigapixel-standardv2-2500h.jpg?v=1756721686",
			"//thehues.com/cdn/shop/files/20240301-silver-gray-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-silver-gray-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-silver-gray-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-silver-gray-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-olive-green-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-olive-green-6-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-green.jpg?v=1761207461",
			"//thehues.com/cdn/shop/files/20240228-olive-green-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-olive-green-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-olive-green-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-olive-green-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-Ink-blue-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-Ink-blue-4-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-blue.jpg?v=1761207461",
			"//thehues.com/cdn/shop/files/20240228-Ink-blue-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-Ink-blue-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-Ink-blue-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-Ink-blue-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-ginger-yellow-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-ginger-yellow-4-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-ginger.jpg?v=1761207461",
			"//thehues.com/cdn/shop/files/20240301-ginger-yellow-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-ginger-yellow-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240301-ginger-yellow-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-ginger-yellow-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240202-Coffee-1-2-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240202-Coffee-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-brown.jpg?v=1761207461",
			"//thehues.com/cdn/shop/files/20240202-Coffee-2-2-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240202-Coffee-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240202-Coffee-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240202-Coffee-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20250219-dustyrose-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-gray-pink-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-dustyrose.jpg?v=1761207461",
			"//thehues.com/cdn/shop/files/20250219-dustyrose-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-dustyrose-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-dustyrose-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
			"//thehues.com/cdn/shop/files/20240228-dustyrose-4-gigapixel-standardv2-2500h.jpg?v=1756721674"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250219-silver-gray-1-gigapixel-standardv2-2500h_1024x1024.jpg?v=1756721674",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334548730,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-silver-gray-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-silver-gray-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36701625286906,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 4210,
					"width": 3368,
					"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-silvergray.jpg?v=1761207461"
				},
				"aspect_ratio": 0.8,
				"height": 4210,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-silvergray.jpg?v=1761207461",
				"width": 3368
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334417658,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-3-gigapixel-standardv2-2500h.jpg?v=1756721686"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-3-gigapixel-standardv2-2500h.jpg?v=1756721686",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334450426,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-4-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334483194,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-5-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334515962,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-6-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-silver-gray-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334384890,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-silver-gray-7-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-silver-gray-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334745338,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-olive-green-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-olive-green-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334712570,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-olive-green-6-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-olive-green-6-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36701603594490,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 4210,
					"width": 3368,
					"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-green.jpg?v=1761207461"
				},
				"aspect_ratio": 0.8,
				"height": 4210,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-green.jpg?v=1761207461",
				"width": 3368
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334614266,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-olive-green-3-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-olive-green-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334679802,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-olive-green-5-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-olive-green-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334647034,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-olive-green-4-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-olive-green-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334581498,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-olive-green-7-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-olive-green-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333827834,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-Ink-blue-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-Ink-blue-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333696762,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-Ink-blue-4-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-Ink-blue-4-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36701604544762,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 4210,
					"width": 3368,
					"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-blue.jpg?v=1761207461"
				},
				"aspect_ratio": 0.8,
				"height": 4210,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-blue.jpg?v=1761207461",
				"width": 3368
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333729530,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-Ink-blue-5-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-Ink-blue-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333795066,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-Ink-blue-6-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-Ink-blue-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333762298,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-Ink-blue-3-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-Ink-blue-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333663994,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-Ink-blue-7-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-Ink-blue-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334352122,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-ginger-yellow-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-ginger-yellow-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334253818,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-4-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-4-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36701623353594,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 4210,
					"width": 3368,
					"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-ginger.jpg?v=1761207461"
				},
				"aspect_ratio": 0.8,
				"height": 4210,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-ginger.jpg?v=1761207461",
				"width": 3368
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334286586,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-5-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334319354,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-6-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334221050,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-3-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240301-ginger-yellow-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133334188282,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-ginger-yellow-7-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-ginger-yellow-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133332287738,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-1-2-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240202-Coffee-1-2-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133332254970,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-6-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240202-Coffee-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36701619421434,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 4210,
					"width": 3368,
					"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-brown.jpg?v=1761207461"
				},
				"aspect_ratio": 0.8,
				"height": 4210,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-brown.jpg?v=1761207461",
				"width": 3368
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133332320506,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-2-2-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240202-Coffee-2-2-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133332386042,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-4-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240202-Coffee-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133332353274,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-3-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240202-Coffee-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133332418810,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240202-Coffee-5-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240202-Coffee-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333303546,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-dustyrose-1-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-dustyrose-1-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333270778,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-gray-pink-6-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-gray-pink-6-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36701625155834,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 4210,
					"width": 3368,
					"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-dustyrose.jpg?v=1761207461"
				},
				"aspect_ratio": 0.8,
				"height": 4210,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/jazlynn-4-layers-linen-patterend-velvet-heavyweight-custom-curtain-dustyrose.jpg?v=1761207461",
				"width": 3368
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333106938,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250219-dustyrose-7-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250219-dustyrose-7-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333238010,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-dustyrose-5-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-dustyrose-5-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333139706,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-dustyrose-3-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-dustyrose-3-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			},
			{
				"alt": "Jazlynn 4 Layers Linen Patterened Velvet Heavyweight Custom Curtain - TheHues",
				"id": 36133333172474,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240228-dustyrose-4-gigapixel-standardv2-2500h.jpg?v=1756721674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240228-dustyrose-4-gigapixel-standardv2-2500h.jpg?v=1756721674",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With 100% blackout, soundproofing, and thermal insulation, they redefine comfort and sophistication. Draped in a Classic velvet.</p>",
		"url": "/products/jazlynn-4-layers-linen-look-heavyweight-soundproof-thermal-100-blackout-anti-dust-velvet-custom-curtain",
		"regular_price": "$119.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-blackout-curtains",
				"title": "Advert Blackout Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/advert-soundproof-curtains",
				"title": "Advert Soundproof Curtains"
			},
			{
				"url": "/collections/advert-thermal-curtains",
				"title": "Advert Thermal Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-curtains",
				"title": "Blackout Curtains"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/soundproof-curtains",
				"title": "Soundproof Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thermal-curtains",
				"title": "Thermal Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780129698042,
		"title": "Sally Linen Blend Custom Curtain",
		"handle": "sally-linen-blend-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 20% Linen &amp; 10% Cotton &amp; 70% Polyester<br>Features: Room Darkening<br>Weight: Regular (323g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Cold</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p></div>`,
		"description": "<p>Timeless yet never dull, Sally's linen blend and subtle texture make it a trusted companion to interiors of every mood.</p>",
		"published_at": "2025-05-07T16:34:02+08:00",
		"created_at": "2025-05-07T16:34:02+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"sale top 10",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 12000,
		"price_min": 12000,
		"price_max": 12000,
		"available": true,
		"price_varies": false,
		"compare_at_price": 14900,
		"compare_at_price_min": 14900,
		"compare_at_price_max": 14900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319408181498,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44812425724154,
					"product_id": 8780129698042,
					"position": 1,
					"created_at": "2025-08-15T14:00:41+08:00",
					"updated_at": "2025-08-26T16:23:44+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 3272,
					"height": 4363,
					"src": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-1_07ee31bf-9b6f-408c-aaeb-72992c02dd8e.jpg?v=1756196624",
					"variant_ids": [
						47319408181498
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36553611051258,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.75,
						"height": 4363,
						"width": 3272,
						"src": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-1_07ee31bf-9b6f-408c-aaeb-72992c02dd8e.jpg?v=1756196624"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asally_beige_1024x1024.jpg?v=1751276418"
			},
			{
				"id": 47319408148730,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255534330,
					"product_id": 8780129698042,
					"position": 9,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:45+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_sand.jpg?v=1756196625",
					"variant_ids": [
						47319408148730
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207059894522,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_sand.jpg?v=1756196625"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asally_sand_1024x1024.jpg?v=1751276418"
			},
			{
				"id": 47319408115962,
				"title": "Sage",
				"option1": "Sage",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255632634,
					"product_id": 8780129698042,
					"position": 24,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:46+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_sage.jpg?v=1756196626",
					"variant_ids": [
						47319408115962
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Sage",
				"public_title": "Sage",
				"options": [
					"Sage"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207059861754,
					"position": 24,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_sage.jpg?v=1756196626"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asally_sage_1024x1024.jpg?v=1751276418"
			},
			{
				"id": 47319408083194,
				"title": "Sea Foam",
				"option1": "Sea Foam",
				"option2": null,
				"option3": null,
				"sku": "THC-138-SNAKE5-6M-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255796474,
					"product_id": 8780129698042,
					"position": 15,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:46+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_seafoam.jpg?v=1756196626",
					"variant_ids": [
						47319408083194
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Sea Foam",
				"public_title": "Sea Foam",
				"options": [
					"Sea Foam"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207059960058,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_seafoam.jpg?v=1756196626"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asally_seafoam_1024x1024.jpg?v=1751276418"
			},
			{
				"id": 47319408214266,
				"title": "Lavender Blush",
				"option1": "Lavender Blush",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-9-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255599866,
					"product_id": 8780129698042,
					"position": 56,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:49+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_lavender.jpg?v=1756196629",
					"variant_ids": [
						47319408214266
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Lavender Blush",
				"public_title": "Lavender Blush",
				"options": [
					"Lavender Blush"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207059796218,
					"position": 56,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_lavender.jpg?v=1756196629"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319408247034,
				"title": "Baby Blue",
				"option1": "Baby Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-11-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255862010,
					"product_id": 8780129698042,
					"position": 48,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:48+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_babyblue.jpg?v=1756196628",
					"variant_ids": [
						47319408247034
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Baby Blue",
				"public_title": "Baby Blue",
				"options": [
					"Baby Blue"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207060058362,
					"position": 48,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_babyblue.jpg?v=1756196628"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319408279802,
				"title": "Denim",
				"option1": "Denim",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-12-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255829242,
					"product_id": 8780129698042,
					"position": 40,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:48+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_denium.jpg?v=1756196628",
					"variant_ids": [
						47319408279802
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Denim",
				"public_title": "Denim",
				"options": [
					"Denim"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207059763450,
					"position": 40,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_denium.jpg?v=1756196628"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319408312570,
				"title": "Moss",
				"option1": "Moss",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH1105-13-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246255730938,
					"product_id": 8780129698042,
					"position": 32,
					"created_at": "2025-06-17T15:54:35+08:00",
					"updated_at": "2025-08-26T16:23:47+08:00",
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sally_moss.jpg?v=1756196627",
					"variant_ids": [
						47319408312570
					]
				},
				"available": true,
				"name": "Sally Linen Blend Custom Curtain - Moss",
				"public_title": "Moss",
				"options": [
					"Moss"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": 14900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sally Linen Blend Custom Curtain - TheHues",
					"id": 36207059828986,
					"position": 32,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sally_moss.jpg?v=1756196627"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-1_07ee31bf-9b6f-408c-aaeb-72992c02dd8e.jpg?v=1756196624",
			"//thehues.com/cdn/shop/files/20250522-20250520-A4M-1_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-2_3f9b2219-1c80-4198-aa0e-81f50223e954.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02396copy_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02340copy_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02409copy_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-A4M-2_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-A4M-3_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/sally_sand.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/1jpgcopy.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/2jpgcopy.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-A5M-6_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-A5M-2_resolution-standardv2-2x.jpg?v=1756196625",
			"//thehues.com/cdn/shop/files/20250522-20250520-A5M-3_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/sally_seafoam.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/sally1seafoam.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/2sally_seafoam.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/20250522-20250520-A6M-2_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/20250522-20250520-A6M-1_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/20250522-20250520-A6M-5_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/20250522-20250520-A6M-6_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/20250522-20250520-A6M-7_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/20250522-20250520-A6M-4_resolution-standardv2-2x.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/sally_sage.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/sally1sage.jpg?v=1756196626",
			"//thehues.com/cdn/shop/files/2sally_sage.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A7M-1copy_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A7M-2_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A7M-7_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A7M-5_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A7M-4_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/sally_moss.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/sally1moss.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A15M-6_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A15M-7_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A15M-3_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A15M-4_resolution-standardv2-2x.jpg?v=1756196627",
			"//thehues.com/cdn/shop/files/20250522-20250520-A15M-1copy_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A15M-2_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/sally_denium.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/sally1denim.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A14M-6_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A14M-7_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A14M-4_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A14M-3_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A14M-2_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/20250522-20250520-A14M-1_resolution-standardv2-2x.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/sally_babyblue.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/sally1babyblue.jpg?v=1756196628",
			"//thehues.com/cdn/shop/files/2sally_babyblue.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-6_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-7_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-4_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-1copy_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-3_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/sally_lavender.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/sally1lavenderblush.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/2sally_lavender.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A8M-6_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A8M-7_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A8M-3_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A8M-2_resolution-standardv2-2x.jpg?v=1756196629",
			"//thehues.com/cdn/shop/files/20250522-20250520-A8M-4_resolution-standardv2-2x.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/20250522-20250520-A8M-1copy_resolution-standardv2-2x.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/1753861238426_sally_bed_2x_copy.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally_beige.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally1beige.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/2sally_beige.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally1sand.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/2sally_sand.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/20250522-20250520-A5M-5_resolution-standardv2-2x.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally2beige.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally2sand.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally2seafoam.jpg?v=1756196630",
			"//thehues.com/cdn/shop/files/sally2sage.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/sally2moss.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/sally2denim.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/sally2babyblue.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/sally2blush.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/SALLYFAMILY1.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-__resolution-standardv2-2x.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-1_resolution-standardv2-2x.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A11M-2_resolution-standardv2-2x.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A4M-4_resolution-standardv2-2x.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A4M-5_resolution-standardv2-2x.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A4M-6_resolution-standardv2-2x.jpg?v=1756196631",
			"//thehues.com/cdn/shop/files/20250522-20250520-A5M-1copy_resolution-standardv2-2x.jpg?v=1756196632",
			"//thehues.com/cdn/shop/files/20250522-20250520-A7M-6_resolution-standardv2-2x.jpg?v=1756196632"
		],
		"featured_image": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-1_07ee31bf-9b6f-408c-aaeb-72992c02dd8e_1024x1024.jpg?v=1756196624",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36553611051258,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 4363,
					"width": 3272,
					"src": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-1_07ee31bf-9b6f-408c-aaeb-72992c02dd8e.jpg?v=1756196624"
				},
				"aspect_ratio": 0.75,
				"height": 4363,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-1_07ee31bf-9b6f-408c-aaeb-72992c02dd8e.jpg?v=1756196624",
				"width": 3272
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805681914,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-1_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-1_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36553611084026,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 4541,
					"width": 3406,
					"src": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-2_3f9b2219-1c80-4198-aa0e-81f50223e954.jpg?v=1756196625"
				},
				"aspect_ratio": 0.75,
				"height": 4541,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally-linen-blend-custom-curtain-beige-2_3f9b2219-1c80-4198-aa0e-81f50223e954.jpg?v=1756196625",
				"width": 3406
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805550842,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02396copy_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02396copy_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally 100% Blackout Linen Blend Custom Curtain - TheHues",
				"id": 36071805518074,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02340copy_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02340copy_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805583610,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02409copy_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02409copy_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805714682,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-2_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-2_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071805747450,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-3_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-3_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059894522,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_sand.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_sand.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36265755771130,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1jpgcopy.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1jpgcopy.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36265755934970,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2jpgcopy.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2jpgcopy.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806566650,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-6_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-6_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806664954,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-2_resolution-standardv2-2x.jpg?v=1756196625"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-2_resolution-standardv2-2x.jpg?v=1756196625",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806697722,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-3_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-3_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059960058,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_seafoam.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_seafoam.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806927098,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1seafoam.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1seafoam.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36214661447930,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sally_seafoam.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sally_seafoam.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807025402,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-2_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-2_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806992634,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-1_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-1_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806828794,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-5_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-5_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806861562,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-6_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-6_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806894330,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-7_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-7_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806763258,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-4_resolution-standardv2-2x.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A6M-4_resolution-standardv2-2x.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059861754,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_sage.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_sage.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807189242,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1sage.jpg?v=1756196626"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1sage.jpg?v=1756196626",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36214661316858,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sally_sage.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sally_sage.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807254778,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-1copy_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-1copy_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807287546,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-2_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-2_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807156474,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-7_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-7_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807090938,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-5_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-5_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807058170,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-4_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-4_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059828986,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_moss.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_moss.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806402810,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1moss.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1moss.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806337274,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-6_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-6_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806370042,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-7_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-7_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806271738,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-3_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-3_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806304506,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-4_resolution-standardv2-2x.jpg?v=1756196627"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-4_resolution-standardv2-2x.jpg?v=1756196627",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806468346,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-1copy_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-1copy_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806501114,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-2_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A15M-2_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059763450,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_denium.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_denium.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806140666,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1denim.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1denim.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806075130,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-6_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-6_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806107898,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-7_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-7_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806042362,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-4_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-4_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806009594,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-3_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-3_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071806238970,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-2_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-2_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806206202,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-1_resolution-standardv2-2x.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A14M-1_resolution-standardv2-2x.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207060058362,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_babyblue.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_babyblue.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805059322,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1babyblue.jpg?v=1756196628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1babyblue.jpg?v=1756196628",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36214663348474,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sally_babyblue.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sally_babyblue.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071804928250,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-6_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-6_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071804961018,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-7_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-7_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071804895482,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-4_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-4_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805124858,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-1copy_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-1copy_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805223162,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-3_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-3_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059796218,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_lavender.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_lavender.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807418618,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1lavenderblush.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1lavenderblush.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36214661251322,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sally_lavender.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sally_lavender.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807353082,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-6_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-6_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807385850,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-7_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-7_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807549690,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-3_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-3_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807516922,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-2_resolution-standardv2-2x.jpg?v=1756196629"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-2_resolution-standardv2-2x.jpg?v=1756196629",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807320314,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-4_resolution-standardv2-2x.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-4_resolution-standardv2-2x.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071807484154,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-1copy_resolution-standardv2-2x.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A8M-1copy_resolution-standardv2-2x.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36455638204666,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1753861238426_sally_bed_2x_copy.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1753861238426_sally_bed_2x_copy.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36207059730682,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally_beige.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally_beige.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805616378,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1beige.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1beige.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36214661185786,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sally_beige.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sally_beige.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806599418,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally1sand.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally1sand.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36214661415162,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sally_sand.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sally_sand.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806533882,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-5_resolution-standardv2-2x.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-5_resolution-standardv2-2x.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805649146,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2beige.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2beige.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806632186,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2sand.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2sand.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806959866,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2seafoam.jpg?v=1756196630"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2seafoam.jpg?v=1756196630",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807222010,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2sage.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2sage.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806435578,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2moss.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2moss.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071806173434,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2denim.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2denim.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805092090,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2babyblue.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2babyblue.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807451386,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sally2blush.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sally2blush.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally 100% Blackout Linen Blend Custom Curtain - TheHues",
				"id": 36071806730490,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SALLYFAMILY1.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SALLYFAMILY1.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805026554,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-__resolution-standardv2-2x.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-__resolution-standardv2-2x.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805157626,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-1_resolution-standardv2-2x.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-1_resolution-standardv2-2x.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071805190394,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-2_resolution-standardv2-2x.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A11M-2_resolution-standardv2-2x.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805780218,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-4_resolution-standardv2-2x.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-4_resolution-standardv2-2x.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805812986,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-5_resolution-standardv2-2x.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-5_resolution-standardv2-2x.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Cafe Curtain - TheHues",
				"id": 36071805845754,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-6_resolution-standardv2-2x.jpg?v=1756196631"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A4M-6_resolution-standardv2-2x.jpg?v=1756196631",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071805878522,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-1copy_resolution-standardv2-2x.jpg?v=1756196632"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A5M-1copy_resolution-standardv2-2x.jpg?v=1756196632",
				"width": 2000
			},
			{
				"alt": "Sally Linen Blend Custom Curtain - TheHues",
				"id": 36071807123706,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-6_resolution-standardv2-2x.jpg?v=1756196632"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A7M-6_resolution-standardv2-2x.jpg?v=1756196632",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36374391324922,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/ba27e73583cb4130939c33141d9c6e46.thumbnail.0000000000.jpg?v=1752459322"
				},
				"aspect_ratio": 0.563,
				"duration": 18020,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ba27e73583cb4130939c33141d9c6e46/ba27e73583cb4130939c33141d9c6e46.SD-480p-0.9Mbps-51167433.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ba27e73583cb4130939c33141d9c6e46/ba27e73583cb4130939c33141d9c6e46.HD-1080p-2.5Mbps-51167433.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ba27e73583cb4130939c33141d9c6e46/ba27e73583cb4130939c33141d9c6e46.HD-720p-1.6Mbps-51167433.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ba27e73583cb4130939c33141d9c6e46/ba27e73583cb4130939c33141d9c6e46.m3u8?v=0",
						"width": 606
					}
				]
			},
			{
				"alt": null,
				"id": 36133963890938,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1080,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/ece00239f5944545b13f92f4a92218a9.thumbnail.0000000000.jpg?v=1749095941"
				},
				"aspect_ratio": 1,
				"duration": 7240,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ece00239f5944545b13f92f4a92218a9/ece00239f5944545b13f92f4a92218a9.SD-480p-1.5Mbps-48849079.mp4?v=0",
						"width": 480
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ece00239f5944545b13f92f4a92218a9/ece00239f5944545b13f92f4a92218a9.HD-1080p-7.2Mbps-48849079.mp4?v=0",
						"width": 1080
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ece00239f5944545b13f92f4a92218a9/ece00239f5944545b13f92f4a92218a9.HD-720p-4.5Mbps-48849079.mp4?v=0",
						"width": 720
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ece00239f5944545b13f92f4a92218a9/ece00239f5944545b13f92f4a92218a9.m3u8?v=0",
						"width": 1080
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Timeless yet never dull, Sally's linen blend and subtle texture make it a trusted companion to interiors of every mood.</p>",
		"url": "/products/sally-linen-blend-custom-curtain",
		"regular_price": "$120.00",
		"sale_price": "$149.00",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780129566970,
		"title": "Sunveil Linen Sheer Custom Curtain",
		"handle": "sunveil-linen-sheer-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Materia: 92% Fancy Yarn 8% Linen<br>Features: Sheer<br>Weight: Sheer (150g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p></div>`,
		"description": "<p>Sunveil filters sunlight through its linen-like threads, drawing soft shadows with its natural patterns and whisper-light fabric made from breathable decorative yarn.</p>",
		"published_at": "2025-05-07T16:33:58+08:00",
		"created_at": "2025-05-07T16:33:58+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"flash_categories",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"Search curtains",
			"Search sheer",
			"Summer Collection"
		],
		"price": 8900,
		"price_min": 8900,
		"price_max": 8900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 11900,
		"compare_at_price_min": 11900,
		"compare_at_price_max": 11900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319405625594,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-BL-540-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44275894321402,
					"product_id": 8780129566970,
					"position": 1,
					"created_at": "2025-06-19T17:53:43+08:00",
					"updated_at": "2025-08-26T16:23:57+08:00",
					"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_25_a7413bd6-d580-489f-8a4f-b3148356d292.jpg?v=1756196637",
					"variant_ids": [
						47319405625594
					]
				},
				"available": true,
				"name": "Sunveil Linen Sheer Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 8900,
				"weight": 0,
				"compare_at_price": 11900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
					"id": 36224507150586,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_25_a7413bd6-d580-489f-8a4f-b3148356d292.jpg?v=1756196637"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asunveil_beige_1024x1024.jpg?v=1751277511"
			},
			{
				"id": 47319405592826,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-138-SNAKE6-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246391849210,
					"product_id": 8780129566970,
					"position": 3,
					"created_at": "2025-06-17T15:58:39+08:00",
					"updated_at": "2025-08-26T16:23:57+08:00",
					"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/sunveil_WHITE.jpg?v=1756196637",
					"variant_ids": [
						47319405592826
					]
				},
				"available": true,
				"name": "Sunveil Linen Sheer Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 8900,
				"weight": 0,
				"compare_at_price": 11900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
					"id": 36207144075514,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/sunveil_WHITE.jpg?v=1756196637"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asunveil_white_1024x1024.jpg?v=1751277511"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/FotoJet_25_a7413bd6-d580-489f-8a4f-b3148356d292.jpg?v=1756196637",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC40-3copy_resolution-standardv2-2x.jpg?v=1756196637",
			"//thehues.com/cdn/shop/files/sunveil_WHITE.jpg?v=1756196637",
			"//thehues.com/cdn/shop/files/2sunveil_white.jpg?v=1756196637",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC25-2copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC25-1copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC25-3copy_resolution-standardv2-2x.jpg?v=1761203970",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC25-4copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC25-5copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/FotoJet_26.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01953copy2_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01970copy2_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01828copy32_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC40-4copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC40-5copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC40-2copy_resolution-standardv2-2x.jpg?v=1756196638",
			"//thehues.com/cdn/shop/files/20250522-20250520-AC40-1copy_resolution-standardv2-2x.jpg?v=1761203970",
			"//thehues.com/cdn/shop/files/2sunveil_beige.jpg?v=1756196639",
			"//thehues.com/cdn/shop/files/sunveil_beige.jpg?v=1756196639",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01978copy2_resolution-standardv2-2x.jpg?v=1756196639",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01813copy2_resolution-standardv2-2x.jpg?v=1756196639"
		],
		"featured_image": "//thehues.com/cdn/shop/files/FotoJet_25_a7413bd6-d580-489f-8a4f-b3148356d292_1024x1024.jpg?v=1756196637",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36224507150586,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_25_a7413bd6-d580-489f-8a4f-b3148356d292.jpg?v=1756196637"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_25_a7413bd6-d580-489f-8a4f-b3148356d292.jpg?v=1756196637",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071903494394,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-3copy_resolution-standardv2-2x.jpg?v=1756196637"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-3copy_resolution-standardv2-2x.jpg?v=1756196637",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36207144075514,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sunveil_WHITE.jpg?v=1756196637"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sunveil_WHITE.jpg?v=1756196637",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36207144042746,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sunveil_white.jpg?v=1756196637"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sunveil_white.jpg?v=1756196637",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071904346362,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-2copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-2copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071904313594,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-1copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-1copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071904379130,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-3copy_resolution-standardv2-2x.jpg?v=1761203970"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-3copy_resolution-standardv2-2x.jpg?v=1761203970",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071904215290,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-4copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-4copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071904280826,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-5copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC25-5copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36224507085050,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_26.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_26.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071918633210,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01953copy2_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01953copy2_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071918665978,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01970copy2_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01970copy2_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071918600442,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01828copy32_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01828copy32_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071903527162,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-4copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-4copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071903559930,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-5copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-5copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071903625466,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-2copy_resolution-standardv2-2x.jpg?v=1756196638"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-2copy_resolution-standardv2-2x.jpg?v=1756196638",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071903592698,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-1copy_resolution-standardv2-2x.jpg?v=1761203970"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AC40-1copy_resolution-standardv2-2x.jpg?v=1761203970",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36207143682298,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sunveil_beige.jpg?v=1756196639"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sunveil_beige.jpg?v=1756196639",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36207143747834,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sunveil_beige.jpg?v=1756196639"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sunveil_beige.jpg?v=1756196639",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071918698746,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01978copy2_resolution-standardv2-2x.jpg?v=1756196639"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01978copy2_resolution-standardv2-2x.jpg?v=1756196639",
				"width": 2000
			},
			{
				"alt": "Sunveil Linen Sheer Custom Curtain - TheHues",
				"id": 36071918567674,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01813copy2_resolution-standardv2-2x.jpg?v=1756196639"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01813copy2_resolution-standardv2-2x.jpg?v=1756196639",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36133914542330,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1080,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/ff1f19f18b3745ea8219343d2e09a328.thumbnail.0000000000.jpg?v=1749095307"
				},
				"aspect_ratio": 1,
				"duration": 7690,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ff1f19f18b3745ea8219343d2e09a328/ff1f19f18b3745ea8219343d2e09a328.SD-480p-1.5Mbps-48848771.mp4?v=0",
						"width": 480
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ff1f19f18b3745ea8219343d2e09a328/ff1f19f18b3745ea8219343d2e09a328.HD-1080p-7.2Mbps-48848771.mp4?v=0",
						"width": 1080
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ff1f19f18b3745ea8219343d2e09a328/ff1f19f18b3745ea8219343d2e09a328.HD-720p-4.5Mbps-48848771.mp4?v=0",
						"width": 720
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ff1f19f18b3745ea8219343d2e09a328/ff1f19f18b3745ea8219343d2e09a328.m3u8?v=0",
						"width": 1080
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Sunveil filters sunlight through its linen-like threads, drawing soft shadows with its natural patterns and whisper-light fabric made from breathable decorative yarn.</p>",
		"url": "/products/sunveil-linen-sheer-custom-curtain",
		"regular_price": "$89.00",
		"sale_price": "$119.00",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780122816762,
		"title": "Glimmer Linen Blend Lightweight Textured Custom Curtain",
		"handle": "glimmer-linen-blend-lightweight-textured-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 95% polyester 5% linen<br>Features: Unique Printed Fabric<br>Weight: Regular (260g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p></div>`,
		"description": "<p>A delicate shimmer weaves through natural fibers, enhancing the raw beauty and texture of this curtain, making it the perfect blend of rustic charm and refined elegance for any room.</p>",
		"published_at": "2025-05-07T16:30:28+08:00",
		"created_at": "2025-05-07T16:30:28+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > Solid Curtains",
			"All Curtains > Textured Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Extra 10%",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10500,
		"price_min": 10500,
		"price_max": 10500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319447666938,
				"title": "Glimmer",
				"option1": "Glimmer",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-BD4202-C",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011407573242,
					"product_id": 8780122816762,
					"position": 1,
					"created_at": "2025-05-19T19:24:43+08:00",
					"updated_at": "2025-08-26T16:27:51+08:00",
					"alt": "Glimmer Linen Blend Lightweight Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-3_1__resolution-standardv2-2x.jpg?v=1756196871",
					"variant_ids": [
						47319447666938
					]
				},
				"available": true,
				"name": "Glimmer Linen Blend Lightweight Textured Custom Curtain - Glimmer",
				"public_title": "Glimmer",
				"options": [
					"Glimmer"
				],
				"price": 10500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Glimmer Linen Blend Lightweight Textured Custom Curtain - TheHues",
					"id": 36055761944826,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Aglimmer-2-3_1__resolution-standardv2-2x.jpg?v=1756196871"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aglimmer-color_resolution-highfidelityv2-2x_1024x1024.jpg?v=1756196872"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Aglimmer-2-3_1__resolution-standardv2-2x.jpg?v=1756196871",
			"//thehues.com/cdn/shop/files/Aglimmer-2-2_2__resolution-standardv2-2x.jpg?v=1756196871",
			"//thehues.com/cdn/shop/files/Aglimmer-2-1-1_3__resolution-standardv2-2x.jpg?v=1756196871",
			"//thehues.com/cdn/shop/files/Aglimmer-2-2-1_5__resolution-standardv2-2x.jpg?v=1756196871",
			"//thehues.com/cdn/shop/files/Aglimmer-2-3_4__resolution-standardv2-2x.jpg?v=1756196872",
			"//thehues.com/cdn/shop/files/Aglimmer-2-4_6__resolution-standardv2-2x.jpg?v=1756196872",
			"//thehues.com/cdn/shop/files/Aglimmer-color_resolution-highfidelityv2-2x.jpg?v=1756196872",
			"//thehues.com/cdn/shop/files/Aglimmer-1_resolution-standardv2-2x.jpg?v=1756196872",
			"//thehues.com/cdn/shop/files/Aglimmer-2-1_7__resolution-standardv2-2x.jpg?v=1756196872"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Aglimmer-2-3_1__resolution-standardv2-2x_1024x1024.jpg?v=1756196871",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Glimmer Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055761944826,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-3_1__resolution-standardv2-2x.jpg?v=1756196871"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-3_1__resolution-standardv2-2x.jpg?v=1756196871",
				"width": 2000
			},
			{
				"alt": "Glimmer 100% Blackout Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055761879290,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-2_2__resolution-standardv2-2x.jpg?v=1756196871"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-2_2__resolution-standardv2-2x.jpg?v=1756196871",
				"width": 2000
			},
			{
				"alt": "Glimmer 100% Blackout Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055762141434,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-1-1_3__resolution-standardv2-2x.jpg?v=1756196871"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-1-1_3__resolution-standardv2-2x.jpg?v=1756196871",
				"width": 2000
			},
			{
				"alt": "Glimmer 100% Blackout Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055761912058,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-2-1_5__resolution-standardv2-2x.jpg?v=1756196871"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-2-1_5__resolution-standardv2-2x.jpg?v=1756196871",
				"width": 2000
			},
			{
				"alt": "Glimmer 100% Blackout Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055761977594,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-3_4__resolution-standardv2-2x.jpg?v=1756196872"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-3_4__resolution-standardv2-2x.jpg?v=1756196872",
				"width": 2000
			},
			{
				"alt": "Glimmer 100% Blackout Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055762010362,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-4_6__resolution-standardv2-2x.jpg?v=1756196872"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-4_6__resolution-standardv2-2x.jpg?v=1756196872",
				"width": 2000
			},
			{
				"alt": "Glimmer Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055762043130,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-color_resolution-highfidelityv2-2x.jpg?v=1756196872"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-color_resolution-highfidelityv2-2x.jpg?v=1756196872",
				"width": 2000
			},
			{
				"alt": "Glimmer Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055762075898,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-1_resolution-standardv2-2x.jpg?v=1756196872"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-1_resolution-standardv2-2x.jpg?v=1756196872",
				"width": 2000
			},
			{
				"alt": "Glimmer Linen Blend Lightweight Textured Custom Curtain - TheHues",
				"id": 36055762108666,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aglimmer-2-1_7__resolution-standardv2-2x.jpg?v=1756196872"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aglimmer-2-1_7__resolution-standardv2-2x.jpg?v=1756196872",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>A delicate shimmer weaves through natural fibers, enhancing the raw beauty and texture of this curtain, making it the perfect blend of rustic charm and refined elegance for any room.</p>",
		"url": "/products/glimmer-linen-blend-lightweight-textured-custom-curtain",
		"regular_price": "$105.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780126617850,
		"title": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain",
		"handle": "victoria-100-blackout-oeko-linen-look-heavyweight-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: OEKO-TEX Certified Safe Fabric<br>Weight: Heavy Weight (410g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Do not dry clean</p></div>`,
		"description": "<p>Victoria blackout curtains offer a luxurious linen-look finish with a heavyweight texture, perfect for creating a grounded, elegant space.</p>",
		"published_at": "2025-05-07T16:32:32+08:00",
		"created_at": "2025-05-07T16:32:32+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Bestseller",
			"Blackout",
			"can't memory",
			"indoor curtain",
			"july sale",
			"Soundproof & Blackout Curtains"
		],
		"price": 12900,
		"price_min": 12900,
		"price_max": 12900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319398023418,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011439685882,
					"product_id": 8780126617850,
					"position": 1,
					"created_at": "2025-05-19T19:32:25+08:00",
					"updated_at": "2025-08-26T16:24:40+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame10_resolution-standardv2-2x.jpg?v=1756196680",
					"variant_ids": [
						47319398023418
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055784784122,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame10_resolution-standardv2-2x.jpg?v=1756196680"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avictoria_ivory_1024x1024.jpg?v=1751279314"
			},
			{
				"id": 47319398056186,
				"title": "Silver White",
				"option1": "Silver White",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Silver White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011442176250,
					"product_id": 8780126617850,
					"position": 33,
					"created_at": "2025-05-19T19:33:02+08:00",
					"updated_at": "2025-08-26T16:24:43+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige7_resolution-standardv2-2x.jpg?v=1756196683",
					"variant_ids": [
						47319398056186
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Silver White",
				"public_title": "Silver White",
				"options": [
					"Silver White"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055786422522,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige7_resolution-standardv2-2x.jpg?v=1756196683"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avictoria_silverwhite_1024x1024.jpg?v=1751279314"
			},
			{
				"id": 47319398088954,
				"title": "Pink",
				"option1": "Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Pink",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011440898298,
					"product_id": 8780126617850,
					"position": 3,
					"created_at": "2025-05-19T19:32:44+08:00",
					"updated_at": "2025-08-26T16:24:40+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame13_resolution-standardv2-2x_9ab5baac-687d-495c-a430-ecaf65a922ce.jpg?v=1756196680",
					"variant_ids": [
						47319398088954
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Pink",
				"public_title": "Pink",
				"options": [
					"Pink"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055785636090,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame13_resolution-standardv2-2x_9ab5baac-687d-495c-a430-ecaf65a922ce.jpg?v=1756196680"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avictoria_pink_1024x1024.jpg?v=1751279314"
			},
			{
				"id": 47319398121722,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011438178554,
					"product_id": 8780126617850,
					"position": 30,
					"created_at": "2025-05-19T19:32:06+08:00",
					"updated_at": "2025-08-26T16:24:42+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige1_resolution-standardv2-2x.jpg?v=1756196682",
					"variant_ids": [
						47319398121722
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055783801082,
					"position": 30,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige1_resolution-standardv2-2x.jpg?v=1756196682"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Avictoria_beige_1024x1024.jpg?v=1751279314"
			},
			{
				"id": 47319398154490,
				"title": "Oat",
				"option1": "Oat",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Oat",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011440111866,
					"product_id": 8780126617850,
					"position": 21,
					"created_at": "2025-05-19T19:32:35+08:00",
					"updated_at": "2025-08-26T16:24:42+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame12_resolution-standardv2-2x.jpg?v=1756196682",
					"variant_ids": [
						47319398154490
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Oat",
				"public_title": "Oat",
				"options": [
					"Oat"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055785013498,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame12_resolution-standardv2-2x.jpg?v=1756196682"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398187258,
				"title": "Hazelnut",
				"option1": "Hazelnut",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Hazelnut",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011439325434,
					"product_id": 8780126617850,
					"position": 9,
					"created_at": "2025-05-19T19:32:18+08:00",
					"updated_at": "2025-08-26T16:24:41+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame9_resolution-standardv2-2x.jpg?v=1756196681",
					"variant_ids": [
						47319398187258
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Hazelnut",
				"public_title": "Hazelnut",
				"options": [
					"Hazelnut"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055784161530,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame9_resolution-standardv2-2x.jpg?v=1756196681"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398220026,
				"title": "Moss",
				"option1": "Moss",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Moss",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011439882490,
					"product_id": 8780126617850,
					"position": 19,
					"created_at": "2025-05-19T19:32:31+08:00",
					"updated_at": "2025-08-26T16:24:42+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame11_resolution-standardv2-2x.jpg?v=1756196682",
					"variant_ids": [
						47319398220026
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Moss",
				"public_title": "Moss",
				"options": [
					"Moss"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055784947962,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame11_resolution-standardv2-2x.jpg?v=1756196682"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398252794,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Ash",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011437523194,
					"product_id": 8780126617850,
					"position": 11,
					"created_at": "2025-05-19T19:31:59+08:00",
					"updated_at": "2025-08-26T16:24:41+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x_bc59ef23-7ab6-4ab9-8d78-5037db3d8279.jpg?v=1756196681",
					"variant_ids": [
						47319398252794
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055783178490,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x_bc59ef23-7ab6-4ab9-8d78-5037db3d8279.jpg?v=1756196681"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398285562,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011442929914,
					"product_id": 8780126617850,
					"position": 13,
					"created_at": "2025-05-19T19:33:23+08:00",
					"updated_at": "2025-08-26T16:24:41+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame16_resolution-standardv2-2x.jpg?v=1756196681",
					"variant_ids": [
						47319398285562
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055787274490,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame16_resolution-standardv2-2x.jpg?v=1756196681"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398318330,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011442471162,
					"product_id": 8780126617850,
					"position": 45,
					"created_at": "2025-05-19T19:33:19+08:00",
					"updated_at": "2025-08-26T16:24:44+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige2_resolution-standardv2-2x.jpg?v=1756196684",
					"variant_ids": [
						47319398318330
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055787110650,
					"position": 45,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige2_resolution-standardv2-2x.jpg?v=1756196684"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398351098,
				"title": "Blue Grey",
				"option1": "Blue Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Blue Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011438702842,
					"product_id": 8780126617850,
					"position": 25,
					"created_at": "2025-05-19T19:32:13+08:00",
					"updated_at": "2025-08-26T16:24:42+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige4_resolution-standardv2-2x.jpg?v=1756196682",
					"variant_ids": [
						47319398351098
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Blue Grey",
				"public_title": "Blue Grey",
				"options": [
					"Blue Grey"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055784030458,
					"position": 25,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige4_resolution-standardv2-2x.jpg?v=1756196682"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398383866,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011441357050,
					"product_id": 8780126617850,
					"position": 15,
					"created_at": "2025-05-19T19:32:53+08:00",
					"updated_at": "2025-08-26T16:24:41+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige8_resolution-standardv2-2x.jpg?v=1756196681",
					"variant_ids": [
						47319398383866
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055785898234,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige8_resolution-standardv2-2x.jpg?v=1756196681"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398416634,
				"title": "Purple",
				"option1": "Purple",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Purple",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011441094906,
					"product_id": 8780126617850,
					"position": 39,
					"created_at": "2025-05-19T19:32:48+08:00",
					"updated_at": "2025-08-26T16:24:43+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige6_resolution-standardv2-2x.jpg?v=1756196683",
					"variant_ids": [
						47319398416634
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Purple",
				"public_title": "Purple",
				"options": [
					"Purple"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055785767162,
					"position": 39,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige6_resolution-standardv2-2x.jpg?v=1756196683"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319398449402,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1803-SD-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011438440698,
					"product_id": 8780126617850,
					"position": 17,
					"created_at": "2025-05-19T19:32:08+08:00",
					"updated_at": "2025-08-26T16:24:41+08:00",
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame7_resolution-standardv2-2x.jpg?v=1756196681",
					"variant_ids": [
						47319398449402
					]
				},
				"available": true,
				"name": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
					"id": 36055783899386,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame7_resolution-standardv2-2x.jpg?v=1756196681"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/AFrame10_resolution-standardv2-2x.jpg?v=1756196680",
			"//thehues.com/cdn/shop/files/Aivory-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame13_resolution-standardv2-2x_9ab5baac-687d-495c-a430-ecaf65a922ce.jpg?v=1756196680",
			"//thehues.com/cdn/shop/files/Apink-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame6_resolution-standardv2-2x_bb79478c-a69e-47ce-98e4-c29381d0b48d.jpg?v=1756196680",
			"//thehues.com/cdn/shop/files/Abeige-3-1_2__resolution-highfidelityv2-2x.jpg?v=1756196680",
			"//thehues.com/cdn/shop/files/AFrame14_resolution-standardv2-2x_6d941c9d-c8ee-4b05-b96e-719a16884ad4.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/Asilver-white-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame9_resolution-standardv2-2x.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/Ahazelnut-3-copy_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x_bc59ef23-7ab6-4ab9-8d78-5037db3d8279.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/Aash-3_1__resolution-highfidelityv2-2x.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/AFrame16_resolution-standardv2-2x.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/Ateal-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/Abeige8_resolution-standardv2-2x.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/Ared-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame7_resolution-standardv2-2x.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/Ablue-3-1_1__resolution-highfidelityv2-2x.jpg?v=1756196681",
			"//thehues.com/cdn/shop/files/AFrame11_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Amoss-3_3__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame12_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Aoat-3-1_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/AFrame15_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Ataupe-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/Abeige4_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Aivory.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Abeige3_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Abeige5_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Apink.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Abeige1_resolution-standardv2-2x.jpg?v=1756196682",
			"//thehues.com/cdn/shop/files/Abluegrey-2_1__resolution-highfidelityv2-2x.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Abeige_c1614bbd-7f10-4179-b233-c60e6c25421e.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Abeige7_resolution-standardv2-2x.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Asilverwhite.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Ahazelnut.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Aash.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Ateal_f3bc4b7f-83ea-426a-820e-1df6ea88bad6.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Ared.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Abeige6_resolution-standardv2-2x.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Apurple-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
			"//thehues.com/cdn/shop/files/Apurple_90d73072-311c-4d25-9228-8ea46bcac658.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Ablue.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Amoss.jpg?v=1756196683",
			"//thehues.com/cdn/shop/files/Aoat_9234bf31-8d3e-4f53-abc0-00c3c772a60b.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Abeige2_resolution-standardv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Ataupe.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Abluegrey_76cdfb77-f956-46fd-9e1c-3485b55ee915.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Aash_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Abeige-4-1-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Ablue_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Abluegrey_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Ahazelnut-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Aivory-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Amoss-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Aoat-4-1-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
			"//thehues.com/cdn/shop/files/Apink-4_resolution-highfidelityv2-2x.jpg?v=1756196685",
			"//thehues.com/cdn/shop/files/Apurple_resolution-highfidelityv2-2x.jpg?v=1756196685",
			"//thehues.com/cdn/shop/files/Ared_resolution-highfidelityv2-2x.jpg?v=1756196685",
			"//thehues.com/cdn/shop/files/Asilver-white-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196685",
			"//thehues.com/cdn/shop/files/Ataupe_resolution-highfidelityv2-2x.jpg?v=1756196685",
			"//thehues.com/cdn/shop/files/Ateal_resolution-highfidelityv2-2x.jpg?v=1756196685",
			"//thehues.com/cdn/shop/files/ash.jpg?v=1756196685"
		],
		"featured_image": "//thehues.com/cdn/shop/files/AFrame10_resolution-standardv2-2x_1024x1024.jpg?v=1756196680",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784784122,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame10_resolution-standardv2-2x.jpg?v=1756196680"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame10_resolution-standardv2-2x.jpg?v=1756196680",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784816890,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785636090,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame13_resolution-standardv2-2x_9ab5baac-687d-495c-a430-ecaf65a922ce.jpg?v=1756196680"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame13_resolution-standardv2-2x_9ab5baac-687d-495c-a430-ecaf65a922ce.jpg?v=1756196680",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785668858,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apink-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apink-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783768314,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame6_resolution-standardv2-2x_bb79478c-a69e-47ce-98e4-c29381d0b48d.jpg?v=1756196680"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame6_resolution-standardv2-2x_bb79478c-a69e-47ce-98e4-c29381d0b48d.jpg?v=1756196680",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783833850,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3-1_2__resolution-highfidelityv2-2x.jpg?v=1756196680"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3-1_2__resolution-highfidelityv2-2x.jpg?v=1756196680",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055786455290,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame14_resolution-standardv2-2x_6d941c9d-c8ee-4b05-b96e-719a16884ad4.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame14_resolution-standardv2-2x_6d941c9d-c8ee-4b05-b96e-719a16884ad4.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055786488058,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-white-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-white-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784161530,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame9_resolution-standardv2-2x.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame9_resolution-standardv2-2x.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784194298,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahazelnut-3-copy_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahazelnut-3-copy_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783178490,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x_bc59ef23-7ab6-4ab9-8d78-5037db3d8279.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame5_resolution-standardv2-2x_bc59ef23-7ab6-4ab9-8d78-5037db3d8279.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783244026,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash-3_1__resolution-highfidelityv2-2x.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash-3_1__resolution-highfidelityv2-2x.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787274490,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame16_resolution-standardv2-2x.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame16_resolution-standardv2-2x.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787241722,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785898234,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige8_resolution-standardv2-2x.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige8_resolution-standardv2-2x.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785865466,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783899386,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame7_resolution-standardv2-2x.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame7_resolution-standardv2-2x.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783964922,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablue-3-1_1__resolution-highfidelityv2-2x.jpg?v=1756196681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablue-3-1_1__resolution-highfidelityv2-2x.jpg?v=1756196681",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784947962,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame11_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame11_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784882426,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-3_3__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-3_3__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785013498,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame12_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame12_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785046266,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat-3-1_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat-3-1_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787012346,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame15_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame15_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787077882,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784030458,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige4_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige4_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847685882,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784751354,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige3_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige3_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785603322,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige5_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige5_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847784186,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apink.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apink.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783801082,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige1_resolution-standardv2-2x.jpg?v=1756196682"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige1_resolution-standardv2-2x.jpg?v=1756196682",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783997690,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abluegrey-2_1__resolution-highfidelityv2-2x.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abluegrey-2_1__resolution-highfidelityv2-2x.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847554810,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige_c1614bbd-7f10-4179-b233-c60e6c25421e.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige_c1614bbd-7f10-4179-b233-c60e6c25421e.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055786422522,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige7_resolution-standardv2-2x.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige7_resolution-standardv2-2x.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847423738,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilverwhite.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilverwhite.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847653114,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahazelnut.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahazelnut.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847522042,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847489274,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal_f3bc4b7f-83ea-426a-820e-1df6ea88bad6.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal_f3bc4b7f-83ea-426a-820e-1df6ea88bad6.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847325434,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785767162,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige6_resolution-standardv2-2x.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige6_resolution-standardv2-2x.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785734394,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apurple-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apurple-3_2__resolution-highfidelityv2-2x.jpg?v=1761205416",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847816954,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apurple_90d73072-311c-4d25-9228-8ea46bcac658.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apurple_90d73072-311c-4d25-9228-8ea46bcac658.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847587578,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablue.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablue.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847718650,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss.jpg?v=1756196683"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss.jpg?v=1756196683",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847751418,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat_9234bf31-8d3e-4f53-abc0-00c3c772a60b.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat_9234bf31-8d3e-4f53-abc0-00c3c772a60b.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787110650,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige2_resolution-standardv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige2_resolution-standardv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847456506,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847620346,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abluegrey_76cdfb77-f956-46fd-9e1c-3485b55ee915.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abluegrey_76cdfb77-f956-46fd-9e1c-3485b55ee915.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783211258,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783866618,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-4-1-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-4-1-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055783932154,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablue_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablue_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784063226,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abluegrey_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abluegrey_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784128762,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ahazelnut-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ahazelnut-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784718586,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aivory-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784915194,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055784980730,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat-4-1-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat-4-1-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196684",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785570554,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apink-4_resolution-highfidelityv2-2x.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apink-4_resolution-highfidelityv2-2x.jpg?v=1756196685",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785799930,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apurple_resolution-highfidelityv2-2x.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apurple_resolution-highfidelityv2-2x.jpg?v=1756196685",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055785931002,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared_resolution-highfidelityv2-2x.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared_resolution-highfidelityv2-2x.jpg?v=1756196685",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055786389754,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-white-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-white-4-300x300-2_resolution-highfidelityv2-2x.jpg?v=1756196685",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787045114,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe_resolution-highfidelityv2-2x.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe_resolution-highfidelityv2-2x.jpg?v=1756196685",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36055787208954,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal_resolution-highfidelityv2-2x.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal_resolution-highfidelityv2-2x.jpg?v=1756196685",
				"width": 2000
			},
			{
				"alt": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain - TheHues",
				"id": 36156847390970,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1200,
					"width": 960,
					"src": "//thehues.com/cdn/shop/files/ash.jpg?v=1756196685"
				},
				"aspect_ratio": 0.8,
				"height": 1200,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ash.jpg?v=1756196685",
				"width": 960
			},
			{
				"alt": null,
				"id": 36409816449274,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/873f282d54284bc9bbef16d9e3a4eb4c.thumbnail.0000000000.jpg?v=1753087133"
				},
				"aspect_ratio": 0.563,
				"duration": 14880,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/873f282d54284bc9bbef16d9e3a4eb4c/873f282d54284bc9bbef16d9e3a4eb4c.SD-480p-0.9Mbps-51614643.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/873f282d54284bc9bbef16d9e3a4eb4c/873f282d54284bc9bbef16d9e3a4eb4c.HD-1080p-2.5Mbps-51614643.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/873f282d54284bc9bbef16d9e3a4eb4c/873f282d54284bc9bbef16d9e3a4eb4c.HD-720p-1.6Mbps-51614643.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/873f282d54284bc9bbef16d9e3a4eb4c/873f282d54284bc9bbef16d9e3a4eb4c.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Victoria blackout curtains offer a luxurious linen-look finish with a heavyweight texture, perfect for creating a grounded, elegant space.</p>",
		"url": "/products/victoria-100-blackout-oeko-linen-look-heavyweight-custom-curtain",
		"regular_price": "$129.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780116427002,
		"title": "Latvian Linen Blend Lightweight Custom Curtain",
		"handle": "latvian-linen-blend-lightweight-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 30% Linen &amp; 70% Polyester<br>Features: Room Darkening<br>Weight: Light Weight (150g/㎡)<br>Softness: Soft<br><br></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p></div>`,
		"description": "<p>The soft, lightweight texture of Latvian curtains whispers elegance. A perfect linen blend that adds a touch of organic grace to your windows, letting light dance freely.</p>",
		"published_at": "2025-05-07T16:27:35+08:00",
		"created_at": "2025-05-07T16:27:35+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Factory products",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"sale top 10",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319432954106,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037128618234,
					"product_id": 8780116427002,
					"position": 1,
					"created_at": "2025-05-22T17:33:24+08:00",
					"updated_at": "2025-08-26T16:33:02+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-AGrey-1-2-1_resolution-standardv2-2x.jpg?v=1756197182",
					"variant_ids": [
						47319432954106
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071372062970,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-AGrey-1-2-1_resolution-standardv2-2x.jpg?v=1756197182"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alatvian_grey_a153bc48-62f9-4c4f-952b-b9e75bbdcd06_1024x1024.png?v=1751348912"
			},
			{
				"id": 47319432921338,
				"title": "Shell",
				"option1": "Shell",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Shell",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037128716538,
					"product_id": 8780116427002,
					"position": 24,
					"created_at": "2025-05-22T17:33:24+08:00",
					"updated_at": "2025-08-26T16:33:04+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-AShell-1_resolution-standardv2-2x.jpg?v=1756197184",
					"variant_ids": [
						47319432921338
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Shell",
				"public_title": "Shell",
				"options": [
					"Shell"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071372259578,
					"position": 24,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-AShell-1_resolution-standardv2-2x.jpg?v=1756197184"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alatvian_shell_1024x1024.jpg?v=1751348912"
			},
			{
				"id": 47319432888570,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Natural",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037127864570,
					"product_id": 8780116427002,
					"position": 10,
					"created_at": "2025-05-22T17:33:24+08:00",
					"updated_at": "2025-08-26T16:33:03+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-ANatural-1_resolution-standardv2-2x.jpg?v=1756197183",
					"variant_ids": [
						47319432888570
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071372161274,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-ANatural-1_resolution-standardv2-2x.jpg?v=1756197183"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alatvian_natural_1024x1024.jpg?v=1751348912"
			},
			{
				"id": 47319432986874,
				"title": "Brick Red",
				"option1": "Brick Red",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Brick Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037129175290,
					"product_id": 8780116427002,
					"position": 4,
					"created_at": "2025-05-22T17:33:25+08:00",
					"updated_at": "2025-08-26T16:33:02+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-1-1_resolution-standardv2-2x.jpg?v=1756197182",
					"variant_ids": [
						47319432986874
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Brick Red",
				"public_title": "Brick Red",
				"options": [
					"Brick Red"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071373570298,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-1-1_resolution-standardv2-2x.jpg?v=1756197182"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alatvian_brickred_5727bd52-cf24-413d-bec9-5268991833e5_1024x1024.png?v=1751348912"
			},
			{
				"id": 47319433019642,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037128192250,
					"product_id": 8780116427002,
					"position": 7,
					"created_at": "2025-05-22T17:33:25+08:00",
					"updated_at": "2025-08-26T16:33:02+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-1-3_resolution-standardv2-2x.jpg?v=1756197182",
					"variant_ids": [
						47319433019642
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071372357882,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-1-3_resolution-standardv2-2x.jpg?v=1756197182"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319433052410,
				"title": "Burlap",
				"option1": "Burlap",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Burlap",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037127831802,
					"product_id": 8780116427002,
					"position": 21,
					"created_at": "2025-05-22T17:33:25+08:00",
					"updated_at": "2025-08-26T16:33:04+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-1_resolution-standardv2-2x.jpg?v=1756197184",
					"variant_ids": [
						47319433052410
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Burlap",
				"public_title": "Burlap",
				"options": [
					"Burlap"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071373275386,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-1_resolution-standardv2-2x.jpg?v=1756197184"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319433085178,
				"title": "Angora",
				"option1": "Angora",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Angora",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037128356090,
					"product_id": 8780116427002,
					"position": 17,
					"created_at": "2025-05-22T17:33:25+08:00",
					"updated_at": "2025-08-26T16:33:03+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-AAngora-1-1-2_resolution-standardv2-2x.jpg?v=1756197183",
					"variant_ids": [
						47319433085178
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Angora",
				"public_title": "Angora",
				"options": [
					"Angora"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071373504762,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-AAngora-1-1-2_resolution-standardv2-2x.jpg?v=1756197183"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319433117946,
				"title": "Terracotta",
				"option1": "Terracotta",
				"option2": null,
				"option3": null,
				"sku": "THC-38-SD-Terracotta",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037127995642,
					"product_id": 8780116427002,
					"position": 13,
					"created_at": "2025-05-22T17:33:25+08:00",
					"updated_at": "2025-08-26T16:33:03+08:00",
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-1_resolution-standardv2-2x.jpg?v=1756197183",
					"variant_ids": [
						47319433117946
					]
				},
				"available": true,
				"name": "Latvian Linen Blend Lightweight Custom Curtain - Terracotta",
				"public_title": "Terracotta",
				"options": [
					"Terracotta"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
					"id": 36071372456186,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-1_resolution-standardv2-2x.jpg?v=1756197183"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250207-AGrey-1-2-1_resolution-standardv2-2x.jpg?v=1756197182",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-grey-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250207-AGrey-2-3-1_resolution-standardv2-2x.jpg?v=1756197182",
			"//thehues.com/cdn/shop/files/20250207-ABrick-Red-1-1_resolution-standardv2-2x.jpg?v=1756197182",
			"//thehues.com/cdn/shop/files/20250207-ABrick-Red-2-2_resolution-standardv2-2x.jpg?v=1756197182",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-brickred-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250207-AStone-Blue-1-3_resolution-standardv2-2x.jpg?v=1756197182",
			"//thehues.com/cdn/shop/files/20250207-AStone-Blue-2-4_resolution-standardv2-2x.jpg?v=1756197182",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-stone-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250207-ANatural-1_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/20250207-ANatural-2_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-natural-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250207-ATerracotta-1_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/20250207-ATerracotta-2_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/20250516-ATerracotta-9_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-terracotta-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250207-AAngora-1-1-2_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/20231206-AAngora-2-1-2_resolution-standardv2-2x.jpg?v=1756197183",
			"//thehues.com/cdn/shop/files/20250516-AAngora-7-2_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-angora-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250116-ABurlap-1_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/20250116-ABurlap-2_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-burlap-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250207-AShell-1_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/20250207-AShell-2_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-shell-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/20250516-AHoneyview_111-7_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/20250207-AGrey-3-3-1_resolution-standardv2-2x.jpg?v=1756197184",
			"//thehues.com/cdn/shop/files/20250207-ABrick-Red-3-2_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250207-AStone-Blue-3-4_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250207-ANatural-3_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250207-ATerracotta-3_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250516-ATerracotta-4_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20231206-AAngora-3-1-2_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250516-AAngora-3-2_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250116-ABurlap-3_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250207-AShell-3_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/20250516-AHoneyview_111-8_resolution-standardv2-2x.jpg?v=1756197185",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-shell-2.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-stone-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-angora-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-grey-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-natural-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-burlap-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-terracotta-1.jpg?v=1761212107",
			"//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-brickred-2.jpg?v=1761212107"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250207-AGrey-1-2-1_resolution-standardv2-2x_1024x1024.jpg?v=1756197182",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372062970,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AGrey-1-2-1_resolution-standardv2-2x.jpg?v=1756197182"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AGrey-1-2-1_resolution-standardv2-2x.jpg?v=1756197182",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094011130,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-grey-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-grey-2.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372095738,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AGrey-2-3-1_resolution-standardv2-2x.jpg?v=1756197182"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AGrey-2-3-1_resolution-standardv2-2x.jpg?v=1756197182",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373570298,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-1-1_resolution-standardv2-2x.jpg?v=1756197182"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-1-1_resolution-standardv2-2x.jpg?v=1756197182",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373635834,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-2-2_resolution-standardv2-2x.jpg?v=1756197182"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-2-2_resolution-standardv2-2x.jpg?v=1756197182",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094437114,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-brickred-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-brickred-1.jpg?v=1761212107",
				"width": 2001
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372357882,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-1-3_resolution-standardv2-2x.jpg?v=1756197182"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-1-3_resolution-standardv2-2x.jpg?v=1756197182",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372390650,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-2-4_resolution-standardv2-2x.jpg?v=1756197182"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-2-4_resolution-standardv2-2x.jpg?v=1756197182",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094207738,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-stone-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-stone-2.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372161274,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ANatural-1_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ANatural-1_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372194042,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ANatural-2_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ANatural-2_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094174970,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-natural-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-natural-2.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372456186,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-1_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-1_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372488954,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-2_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-2_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373046010,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ATerracotta-9_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ATerracotta-9_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094469882,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-terracotta-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-terracotta-2.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373504762,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AAngora-1-1-2_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AAngora-1-1-2_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373111546,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20231206-AAngora-2-1-2_resolution-standardv2-2x.jpg?v=1756197183"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20231206-AAngora-2-1-2_resolution-standardv2-2x.jpg?v=1756197183",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372718330,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AAngora-7-2_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AAngora-7-2_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094371578,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-angora-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-angora-2.jpg?v=1761212107",
				"width": 2001
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373275386,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-1_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-1_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373340922,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-2_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-2_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094600954,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-burlap-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-burlap-2.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372259578,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AShell-1_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AShell-1_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372292346,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AShell-2_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AShell-2_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589093978362,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-shell-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-shell-1.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372783866,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AHoneyview_111-7_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AHoneyview_111-7_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372128506,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AGrey-3-3-1_resolution-standardv2-2x.jpg?v=1756197184"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AGrey-3-3-1_resolution-standardv2-2x.jpg?v=1756197184",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372030202,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-3-2_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ABrick-Red-3-2_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372423418,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-3-4_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AStone-Blue-3-4_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372226810,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ANatural-3_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ANatural-3_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372554490,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-3_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ATerracotta-3_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372980474,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ATerracotta-4_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ATerracotta-4_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373209850,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20231206-AAngora-3-1-2_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20231206-AAngora-3-1-2_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372620026,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AAngora-3-2_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AAngora-3-2_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071373439226,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-3_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ABurlap-3_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372325114,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-AShell-3_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-AShell-3_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 1999
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36071372849402,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AHoneyview_111-8_resolution-standardv2-2x.jpg?v=1756197185"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AHoneyview_111-8_resolution-standardv2-2x.jpg?v=1756197185",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094109434,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-shell-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-shell-2.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589093945594,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-stone-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-stone-1.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094240506,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-angora-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-angora-1.jpg?v=1761212107",
				"width": 2001
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094306042,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-grey-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-grey-1.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094273274,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-natural-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-natural-1.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094535418,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-burlap-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-burlap-1.jpg?v=1761212107",
				"width": 2001
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094568186,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-terracotta-1.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-terracotta-1.jpg?v=1761212107",
				"width": 2000
			},
			{
				"alt": "Latvian Linen Blend Lightweight Custom Curtain - TheHues",
				"id": 36589094633722,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-brickred-2.jpg?v=1761212107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/latvian-linen-blend-lightweight-custom-curtain-brickred-2.jpg?v=1761212107",
				"width": 2001
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The soft, lightweight texture of Latvian curtains whispers elegance. A perfect linen blend that adds a touch of organic grace to your windows, letting light dance freely.</p>",
		"url": "/products/latvian-linen-blend-lightweight-custom-curtain",
		"regular_price": "$109.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780126519546,
		"title": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain",
		"handle": "quinn-100-blackout-oeko-heavyweight-velvet-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: 100% Blackout<br>Weight: Heavy Weight (440g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Quinn is a soft 100% blackout velvetfabric that offers ultimate light control and privacy.</p>",
		"published_at": "2025-05-07T16:32:29+08:00",
		"created_at": "2025-05-07T16:32:29+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Blackout",
			"Blackout pro Curtain",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains",
			"Custom Blackout Curtains > Blackout Curtains",
			"Easter Sale",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search blackout",
			"Search curtains",
			"Search Pinch pleat",
			"Soundproof & Blackout Curtains"
		],
		"price": 12900,
		"price_min": 12900,
		"price_max": 12900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319413227770,
				"title": "Champagne",
				"option1": "Champagne",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Champagne",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017972248826,
					"product_id": 8780126519546,
					"position": 1,
					"created_at": "2025-05-20T19:45:35+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Achampagne-3-2_2__resolution-standardv2-2x_628c63c6-0ed4-4a00-8c25-c431808dcfbf.jpg?v=1756981762",
					"variant_ids": [
						47319413227770
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Champagne",
				"public_title": "Champagne",
				"options": [
					"Champagne"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747221754,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Achampagne-3-2_2__resolution-standardv2-2x_628c63c6-0ed4-4a00-8c25-c431808dcfbf.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aquinn-champagne_1024x1024.jpg?v=1751278782"
			},
			{
				"id": 47319413031162,
				"title": "Ocean Blue",
				"option1": "Ocean Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Ocean Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017974051066,
					"product_id": 8780126519546,
					"position": 44,
					"created_at": "2025-05-20T19:46:17+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-7_resolution-standardv2-2x_08dc9f2a-1b47-4e9c-acb8-bdcad9a98f1f.jpg?v=1756981762",
					"variant_ids": [
						47319413031162
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Ocean Blue",
				"public_title": "Ocean Blue",
				"options": [
					"Ocean Blue"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059748204794,
					"position": 44,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-7_resolution-standardv2-2x_08dc9f2a-1b47-4e9c-acb8-bdcad9a98f1f.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aquinn-ocean-blue_1024x1024.jpg?v=1751278782"
			},
			{
				"id": 47319413063930,
				"title": "Navy Blue",
				"option1": "Navy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Navy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017973788922,
					"product_id": 8780126519546,
					"position": 29,
					"created_at": "2025-05-20T19:46:02+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-6_resolution-standardv2-2x_150c8d55-2b5c-4ad8-9004-fdd49daaf024.jpg?v=1756981762",
					"variant_ids": [
						47319413063930
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Navy Blue",
				"public_title": "Navy Blue",
				"options": [
					"Navy Blue"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059748040954,
					"position": 29,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-6_resolution-standardv2-2x_150c8d55-2b5c-4ad8-9004-fdd49daaf024.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aquinn-navy-blue_1024x1024.jpg?v=1751278782"
			},
			{
				"id": 47319413096698,
				"title": "Grass Green",
				"option1": "Grass Green",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Grass Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017972510970,
					"product_id": 8780126519546,
					"position": 33,
					"created_at": "2025-05-20T19:45:38+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agrass-green-1_1__resolution-standardv2-2x_d4882895-f064-44e2-ac6b-781d0e9033a7.jpg?v=1756981762",
					"variant_ids": [
						47319413096698
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Grass Green",
				"public_title": "Grass Green",
				"options": [
					"Grass Green"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747418362,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agrass-green-1_1__resolution-standardv2-2x_d4882895-f064-44e2-ac6b-781d0e9033a7.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/grassgreen_1024x1024.jpg?v=1754471970"
			},
			{
				"id": 47319413162234,
				"title": "Grey Blue",
				"option1": "Grey Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Grey Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017972904186,
					"product_id": 8780126519546,
					"position": 25,
					"created_at": "2025-05-20T19:45:45+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agrey-blue-3-2_2__resolution-standardv2-2x_fcfae5f8-063e-4fad-a648-016ff930db52.jpg?v=1756981762",
					"variant_ids": [
						47319413162234
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Grey Blue",
				"public_title": "Grey Blue",
				"options": [
					"Grey Blue"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747614970,
					"position": 25,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agrey-blue-3-2_2__resolution-standardv2-2x_fcfae5f8-063e-4fad-a648-016ff930db52.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413195002,
				"title": "Light Brown",
				"option1": "Light Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Light Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017973494010,
					"product_id": 8780126519546,
					"position": 40,
					"created_at": "2025-05-20T19:45:58+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Alight-brown3-2_2__resolution-standardv2-2x_1648fc3c-aabb-47ba-a2f7-8e3db2ab5603.jpg?v=1756981762",
					"variant_ids": [
						47319413195002
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Light Brown",
				"public_title": "Light Brown",
				"options": [
					"Light Brown"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747975418,
					"position": 40,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Alight-brown3-2_2__resolution-standardv2-2x_1648fc3c-aabb-47ba-a2f7-8e3db2ab5603.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413260538,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017972773114,
					"product_id": 8780126519546,
					"position": 21,
					"created_at": "2025-05-20T19:45:41+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agrey-3-2-2_2__resolution-standardv2-2x_c74bb32a-3199-4245-88bd-5b09cffb948d.jpg?v=1756981762",
					"variant_ids": [
						47319413260538
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747516666,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agrey-3-2-2_2__resolution-standardv2-2x_c74bb32a-3199-4245-88bd-5b09cffb948d.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413293306,
				"title": "Chocolate",
				"option1": "Chocolate",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Chocolate",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017972347130,
					"product_id": 8780126519546,
					"position": 48,
					"created_at": "2025-05-20T19:45:36+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Achocolate-3-2_2__resolution-standardv2-2x_ceff10f1-f73d-4069-93fc-25c6903bd841.jpg?v=1756981762",
					"variant_ids": [
						47319413293306
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Chocolate",
				"public_title": "Chocolate",
				"options": [
					"Chocolate"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747352826,
					"position": 48,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Achocolate-3-2_2__resolution-standardv2-2x_ceff10f1-f73d-4069-93fc-25c6903bd841.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413326074,
				"title": "Taro",
				"option1": "Taro",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Taro",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017974542586,
					"product_id": 8780126519546,
					"position": 52,
					"created_at": "2025-05-20T19:46:25+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ataro-1_1__resolution-standardv2-2x_03fa5888-8248-43fd-9f8f-df986172214f.jpg?v=1756981762",
					"variant_ids": [
						47319413326074
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Taro",
				"public_title": "Taro",
				"options": [
					"Taro"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059748368634,
					"position": 52,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ataro-1_1__resolution-standardv2-2x_03fa5888-8248-43fd-9f8f-df986172214f.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413358842,
				"title": "Bone",
				"option1": "Bone",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Bone",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017971921146,
					"product_id": 8780126519546,
					"position": 12,
					"created_at": "2025-05-20T19:45:32+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-4_resolution-standardv2-2x_dcfe34ad-34db-42e5-8eb2-fcd78212e303.jpg?v=1756981762",
					"variant_ids": [
						47319413358842
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Bone",
				"public_title": "Bone",
				"options": [
					"Bone"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059747090682,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-4_resolution-standardv2-2x_dcfe34ad-34db-42e5-8eb2-fcd78212e303.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413391610,
				"title": "Wine",
				"option1": "Wine",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Wine",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017967825146,
					"product_id": 8780126519546,
					"position": 17,
					"created_at": "2025-05-20T19:43:42+08:00",
					"updated_at": "2025-09-04T18:32:34+08:00",
					"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abone-1_1_-8_resolution-standardv2-2x.jpg?v=1756981954",
					"variant_ids": [
						47319413391610
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Wine",
				"public_title": "Wine",
				"options": [
					"Wine"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
					"id": 36059744436474,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abone-1_1_-8_resolution-standardv2-2x.jpg?v=1756981954"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413424378,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017974608122,
					"product_id": 8780126519546,
					"position": 7,
					"created_at": "2025-05-20T19:46:26+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ateal-1-1_1__resolution-standardv2-2x_655e9b51-76e7-4feb-984b-8b94565d07cd.jpg?v=1756981762",
					"variant_ids": [
						47319413424378
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059748466938,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ateal-1-1_1__resolution-standardv2-2x_655e9b51-76e7-4feb-984b-8b94565d07cd.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319413457146,
				"title": "Purple",
				"option1": "Purple",
				"option2": null,
				"option3": null,
				"sku": "THC-1727-SD-Purple",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44017974280442,
					"product_id": 8780126519546,
					"position": 3,
					"created_at": "2025-05-20T19:46:22+08:00",
					"updated_at": "2025-09-04T18:29:22+08:00",
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-2_resolution-standardv2-2x_176bfa78-71da-4f12-8ffc-cd9014cd7d45.jpg?v=1756981762",
					"variant_ids": [
						47319413457146
					]
				},
				"available": true,
				"name": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - Purple",
				"public_title": "Purple",
				"options": [
					"Purple"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
					"id": 36059748270330,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-2_resolution-standardv2-2x_176bfa78-71da-4f12-8ffc-cd9014cd7d45.jpg?v=1756981762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Achampagne-3-2_2__resolution-standardv2-2x_628c63c6-0ed4-4a00-8c25-c431808dcfbf.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-champagne.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-2_resolution-standardv2-2x_176bfa78-71da-4f12-8ffc-cd9014cd7d45.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-purple.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Apurple-2-1_2__resolution-highfidelityv2-2x_e37448b3-753a-460f-871e-483cf9232376.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Apurple.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Ateal-1-1_1__resolution-standardv2-2x_655e9b51-76e7-4feb-984b-8b94565d07cd.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-2_2__resolution-standardv2-2x.jpg?v=1756981954",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-teal.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Ateal-2-1_2__resolution-highfidelityv2-2x_2920d128-c9ce-4b98-8b4d-3fa6d419320a.jpg?v=1756981954",
			"//thehues.com/cdn/shop/files/Ateal.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-4_resolution-standardv2-2x_dcfe34ad-34db-42e5-8eb2-fcd78212e303.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-4-copy-2_2__resolution-standardv2-2x_925a73c1-0fb8-46d8-9527-1c67b1d52467.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-bone.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Abone-3_3__resolution-highfidelityv2-2x_bcf27a96-71ab-4001-b732-ae7364a0a83a.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-1_1_-8_resolution-standardv2-2x.jpg?v=1756981954",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-wine.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Awine-2_2__resolution-highfidelityv2-2x_0418d887-5f05-47ec-bde1-03ab56866a24.jpg?v=1756981954",
			"//thehues.com/cdn/shop/files/Awine.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Agrey-3-2-2_2__resolution-standardv2-2x_c74bb32a-3199-4245-88bd-5b09cffb948d.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-grey.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Agrey-3-1-2_3__resolution-highfidelityv2-2x_41e4ce6d-c186-49c4-8d5d-324666c93eff.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Agrey.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Agrey-blue-3-2_2__resolution-standardv2-2x_fcfae5f8-063e-4fad-a648-016ff930db52.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-greyblue.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Agrey-blue-3-1-1_4__resolution-highfidelityv2-2x_87fee0df-7c32-4b9e-bf13-4145e3a255bd.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abluegrey.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-6_resolution-standardv2-2x_150c8d55-2b5c-4ad8-9004-fdd49daaf024.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-blue.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Anavy-blue-2_2__resolution-highfidelityv2-2x_bd037448-0d2b-4e87-bc26-9197e361133e.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Anavy.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Agrass-green-1_1__resolution-standardv2-2x_d4882895-f064-44e2-ac6b-781d0e9033a7.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-grassgreen.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Agrass-green-2_2__resolution-highfidelityv2-2x_9d8f12f3-288d-4e85-b85e-7c7f50aabfe8.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Agrassgreen.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Akhaki-2_1__resolution-standardv2-2x_8b8ef917-6ec3-40c1-be0f-14beb0eb12f4.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Akhaki-1_2__resolution-highfidelityv2-2x_2c334afa-45bf-45e7-9dba-da25ffecf06a.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Akhaki.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Alight-brown3-2_2__resolution-standardv2-2x_1648fc3c-aabb-47ba-a2f7-8e3db2ab5603.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-lightbrown.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Alight-brown3-1_3__resolution-highfidelityv2-2x_7bb1fe68-2de1-42fb-b7b3-7a53dd3b4f96.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Alightbrown.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-7_resolution-standardv2-2x_08dc9f2a-1b47-4e9c-acb8-bdcad9a98f1f.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-oceanblue.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Aocean-blue-2_2__resolution-highfidelityv2-2x_6ec81d9f-cacd-4d6d-a974-e4c48bed3ad0.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Aoceanblue.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Achocolate-3-2_2__resolution-standardv2-2x_ceff10f1-f73d-4069-93fc-25c6903bd841.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-chocolate.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Achocolate-3-1_3__resolution-highfidelityv2-2x_f207ddf3-c28b-4fd3-b192-090bf7704e16.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Achocolate.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Ataro-1_1__resolution-standardv2-2x_03fa5888-8248-43fd-9f8f-df986172214f.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-taro.jpg?v=1761205751",
			"//thehues.com/cdn/shop/files/Ataro-2_2__resolution-highfidelityv2-2x_204ea656-6df2-4dff-8d69-07cc9a0e0bbf.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Ataro.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-1_resolution-standardv2-2x_aef63681-f94a-43ff-8a2a-f9bb1fd7df30.jpg?v=1756981762",
			"//thehues.com/cdn/shop/files/Achampagne-3-1_3__resolution-highfidelityv2-2x_21c713ed-5e47-4e8e-a230-4de9b5f2e005.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Achampagne.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Awine_resolution-highfidelityv2-2x_5a37a540-c8e9-40a5-80b0-176123ba5e4c.jpg?v=1756981954",
			"//thehues.com/cdn/shop/files/Ateal-4_resolution-highfidelityv2-2x_a276ced5-6c1e-437f-b81a-edd8439643e4.jpg?v=1756981954",
			"//thehues.com/cdn/shop/files/Abone-4-300x300-1_resolution-highfidelityv2-2x_4e643058-5fda-4dc3-bfd3-3e61f11e55fe.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1__resolution-standardv2-2x_f1281757-9c65-4879-93e8-5a5585975e36.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Achampagne-4-300x300-1_resolution-highfidelityv2-2x_8e16bf88-29bd-479b-ba32-ecc9349316c1.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-3_resolution-standardv2-2x_cb92e0de-5cb7-4fa5-9a74-1fa055481eda.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-5_resolution-standardv2-2x_d3917419-a821-43ac-a26f-7606882ca919.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Abone-4-copy_1_-8_resolution-standardv2-2x_14d80766-e086-462a-9eb0-65813d533891.jpg?v=1756981705",
			"//thehues.com/cdn/shop/files/Ateal-2-1_2__resolution-highfidelityv2-2x_cb6f4eaf-15fb-4d9c-8757-44e5770fd9a2.jpg?v=1756981705"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Achampagne-3-2_2__resolution-standardv2-2x_628c63c6-0ed4-4a00-8c25-c431808dcfbf_1024x1024.jpg?v=1756981762",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747221754,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achampagne-3-2_2__resolution-standardv2-2x_628c63c6-0ed4-4a00-8c25-c431808dcfbf.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achampagne-3-2_2__resolution-standardv2-2x_628c63c6-0ed4-4a00-8c25-c431808dcfbf.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733250044154,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-champagne.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-champagne.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748270330,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-2_resolution-standardv2-2x_176bfa78-71da-4f12-8ffc-cd9014cd7d45.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-2_resolution-standardv2-2x_176bfa78-71da-4f12-8ffc-cd9014cd7d45.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249847546,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-purple.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-purple.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748237562,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apurple-2-1_2__resolution-highfidelityv2-2x_e37448b3-753a-460f-871e-483cf9232376.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apurple-2-1_2__resolution-highfidelityv2-2x_e37448b3-753a-460f-871e-483cf9232376.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825305338,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apurple.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apurple.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748466938,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-1-1_1__resolution-standardv2-2x_655e9b51-76e7-4feb-984b-8b94565d07cd.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-1-1_1__resolution-standardv2-2x_655e9b51-76e7-4feb-984b-8b94565d07cd.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36059744534778,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-2_2__resolution-standardv2-2x.jpg?v=1756981954"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-2_2__resolution-standardv2-2x.jpg?v=1756981954",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733250011386,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-teal.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-teal.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36059744567546,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/Ateal-2-1_2__resolution-highfidelityv2-2x_2920d128-c9ce-4b98-8b4d-3fa6d419320a.jpg?v=1756981954"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-2-1_2__resolution-highfidelityv2-2x_2920d128-c9ce-4b98-8b4d-3fa6d419320a.jpg?v=1756981954",
				"width": 4000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825403642,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747090682,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-4_resolution-standardv2-2x_dcfe34ad-34db-42e5-8eb2-fcd78212e303.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-4_resolution-standardv2-2x_dcfe34ad-34db-42e5-8eb2-fcd78212e303.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747123450,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy-2_2__resolution-standardv2-2x_925a73c1-0fb8-46d8-9527-1c67b1d52467.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy-2_2__resolution-standardv2-2x_925a73c1-0fb8-46d8-9527-1c67b1d52467.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249814778,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-bone.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-bone.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059746992378,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-3_3__resolution-highfidelityv2-2x_bcf27a96-71ab-4001-b732-ae7364a0a83a.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-3_3__resolution-highfidelityv2-2x_bcf27a96-71ab-4001-b732-ae7364a0a83a.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156824846586,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36059744436474,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-1_1_-8_resolution-standardv2-2x.jpg?v=1756981954"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-1_1_-8_resolution-standardv2-2x.jpg?v=1756981954",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249716474,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-wine.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-wine.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36059744502010,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/Awine-2_2__resolution-highfidelityv2-2x_0418d887-5f05-47ec-bde1-03ab56866a24.jpg?v=1756981954"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awine-2_2__resolution-highfidelityv2-2x_0418d887-5f05-47ec-bde1-03ab56866a24.jpg?v=1756981954",
				"width": 4000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825436410,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awine.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awine.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747516666,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-3-2-2_2__resolution-standardv2-2x_c74bb32a-3199-4245-88bd-5b09cffb948d.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-3-2-2_2__resolution-standardv2-2x_c74bb32a-3199-4245-88bd-5b09cffb948d.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249913082,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-grey.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-grey.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747483898,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-3-1-2_3__resolution-highfidelityv2-2x_41e4ce6d-c186-49c4-8d5d-324666c93eff.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-3-1-2_3__resolution-highfidelityv2-2x_41e4ce6d-c186-49c4-8d5d-324666c93eff.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156824977658,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747614970,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-blue-3-2_2__resolution-standardv2-2x_fcfae5f8-063e-4fad-a648-016ff930db52.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-blue-3-2_2__resolution-standardv2-2x_fcfae5f8-063e-4fad-a648-016ff930db52.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249749242,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-greyblue.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-greyblue.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747582202,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-blue-3-1-1_4__resolution-highfidelityv2-2x_87fee0df-7c32-4b9e-bf13-4145e3a255bd.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-blue-3-1-1_4__resolution-highfidelityv2-2x_87fee0df-7c32-4b9e-bf13-4145e3a255bd.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156824813818,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abluegrey.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abluegrey.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748040954,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-6_resolution-standardv2-2x_150c8d55-2b5c-4ad8-9004-fdd49daaf024.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-6_resolution-standardv2-2x_150c8d55-2b5c-4ad8-9004-fdd49daaf024.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249683706,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-blue.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-blue.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748008186,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_2__resolution-highfidelityv2-2x_bd037448-0d2b-4e87-bc26-9197e361133e.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy-blue-2_2__resolution-highfidelityv2-2x_bd037448-0d2b-4e87-bc26-9197e361133e.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825174266,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Anavy.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Anavy.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747418362,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrass-green-1_1__resolution-standardv2-2x_d4882895-f064-44e2-ac6b-781d0e9033a7.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrass-green-1_1__resolution-standardv2-2x_d4882895-f064-44e2-ac6b-781d0e9033a7.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249880314,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-grassgreen.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-grassgreen.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747385594,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrass-green-2_2__resolution-highfidelityv2-2x_9d8f12f3-288d-4e85-b85e-7c7f50aabfe8.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrass-green-2_2__resolution-highfidelityv2-2x_9d8f12f3-288d-4e85-b85e-7c7f50aabfe8.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156824944890,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrassgreen.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrassgreen.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747713274,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Akhaki-2_1__resolution-standardv2-2x_8b8ef917-6ec3-40c1-be0f-14beb0eb12f4.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Akhaki-2_1__resolution-standardv2-2x_8b8ef917-6ec3-40c1-be0f-14beb0eb12f4.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747680506,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Akhaki-1_2__resolution-highfidelityv2-2x_2c334afa-45bf-45e7-9dba-da25ffecf06a.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Akhaki-1_2__resolution-highfidelityv2-2x_2c334afa-45bf-45e7-9dba-da25ffecf06a.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825010426,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Akhaki.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Akhaki.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747975418,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-brown3-2_2__resolution-standardv2-2x_1648fc3c-aabb-47ba-a2f7-8e3db2ab5603.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-brown3-2_2__resolution-standardv2-2x_1648fc3c-aabb-47ba-a2f7-8e3db2ab5603.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733250076922,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-lightbrown.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-lightbrown.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747942650,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-brown3-1_3__resolution-highfidelityv2-2x_7bb1fe68-2de1-42fb-b7b3-7a53dd3b4f96.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-brown3-1_3__resolution-highfidelityv2-2x_7bb1fe68-2de1-42fb-b7b3-7a53dd3b4f96.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825075962,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alightbrown.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alightbrown.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748204794,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-7_resolution-standardv2-2x_08dc9f2a-1b47-4e9c-acb8-bdcad9a98f1f.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-7_resolution-standardv2-2x_08dc9f2a-1b47-4e9c-acb8-bdcad9a98f1f.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249782010,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-oceanblue.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-oceanblue.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748139258,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aocean-blue-2_2__resolution-highfidelityv2-2x_6ec81d9f-cacd-4d6d-a974-e4c48bed3ad0.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aocean-blue-2_2__resolution-highfidelityv2-2x_6ec81d9f-cacd-4d6d-a974-e4c48bed3ad0.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825239802,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoceanblue.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoceanblue.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747352826,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achocolate-3-2_2__resolution-standardv2-2x_ceff10f1-f73d-4069-93fc-25c6903bd841.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achocolate-3-2_2__resolution-standardv2-2x_ceff10f1-f73d-4069-93fc-25c6903bd841.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249945850,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-chocolate.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-chocolate.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747320058,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achocolate-3-1_3__resolution-highfidelityv2-2x_f207ddf3-c28b-4fd3-b192-090bf7704e16.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achocolate-3-1_3__resolution-highfidelityv2-2x_f207ddf3-c28b-4fd3-b192-090bf7704e16.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156824912122,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achocolate.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achocolate.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748368634,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataro-1_1__resolution-standardv2-2x_03fa5888-8248-43fd-9f8f-df986172214f.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataro-1_1__resolution-standardv2-2x_03fa5888-8248-43fd-9f8f-df986172214f.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36733249978618,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-taro.jpg?v=1761205751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/quinn_-_oeko-heavyweight-velvet-custom-curtain-taro.jpg?v=1761205751",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748303098,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataro-2_2__resolution-highfidelityv2-2x_204ea656-6df2-4dff-8d69-07cc9a0e0bbf.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataro-2_2__resolution-highfidelityv2-2x_204ea656-6df2-4dff-8d69-07cc9a0e0bbf.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156825370874,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataro.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataro.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747156218,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-1_resolution-standardv2-2x_aef63681-f94a-43ff-8a2a-f9bb1fd7df30.jpg?v=1756981762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-1_resolution-standardv2-2x_aef63681-f94a-43ff-8a2a-f9bb1fd7df30.jpg?v=1756981762",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747188986,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achampagne-3-1_3__resolution-highfidelityv2-2x_21c713ed-5e47-4e8e-a230-4de9b5f2e005.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achampagne-3-1_3__resolution-highfidelityv2-2x_21c713ed-5e47-4e8e-a230-4de9b5f2e005.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36156824879354,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achampagne.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achampagne.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36059744469242,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/Awine_resolution-highfidelityv2-2x_5a37a540-c8e9-40a5-80b0-176123ba5e4c.jpg?v=1756981954"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awine_resolution-highfidelityv2-2x_5a37a540-c8e9-40a5-80b0-176123ba5e4c.jpg?v=1756981954",
				"width": 4000
			},
			{
				"alt": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36059744600314,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5000,
					"width": 4000,
					"src": "//thehues.com/cdn/shop/files/Ateal-4_resolution-highfidelityv2-2x_a276ced5-6c1e-437f-b81a-edd8439643e4.jpg?v=1756981954"
				},
				"aspect_ratio": 0.8,
				"height": 5000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-4_resolution-highfidelityv2-2x_a276ced5-6c1e-437f-b81a-edd8439643e4.jpg?v=1756981954",
				"width": 4000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747025146,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-300x300-1_resolution-highfidelityv2-2x_4e643058-5fda-4dc3-bfd3-3e61f11e55fe.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-300x300-1_resolution-highfidelityv2-2x_4e643058-5fda-4dc3-bfd3-3e61f11e55fe.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747057914,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1__resolution-standardv2-2x_f1281757-9c65-4879-93e8-5a5585975e36.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1__resolution-standardv2-2x_f1281757-9c65-4879-93e8-5a5585975e36.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747254522,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achampagne-4-300x300-1_resolution-highfidelityv2-2x_8e16bf88-29bd-479b-ba32-ecc9349316c1.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achampagne-4-300x300-1_resolution-highfidelityv2-2x_8e16bf88-29bd-479b-ba32-ecc9349316c1.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747451130,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-3_resolution-standardv2-2x_cb92e0de-5cb7-4fa5-9a74-1fa055481eda.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-3_resolution-standardv2-2x_cb92e0de-5cb7-4fa5-9a74-1fa055481eda.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059747746042,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-5_resolution-standardv2-2x_d3917419-a821-43ac-a26f-7606882ca919.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-5_resolution-standardv2-2x_d3917419-a821-43ac-a26f-7606882ca919.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748335866,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-8_resolution-standardv2-2x_14d80766-e086-462a-9eb0-65813d533891.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abone-4-copy_1_-8_resolution-standardv2-2x_14d80766-e086-462a-9eb0-65813d533891.jpg?v=1756981705",
				"width": 2000
			},
			{
				"alt": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain - TheHues",
				"id": 36059748434170,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal-2-1_2__resolution-highfidelityv2-2x_cb6f4eaf-15fb-4d9c-8757-44e5770fd9a2.jpg?v=1756981705"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal-2-1_2__resolution-highfidelityv2-2x_cb6f4eaf-15fb-4d9c-8757-44e5770fd9a2.jpg?v=1756981705",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Quinn is a soft 100% blackout velvetfabric that offers ultimate light control and privacy.</p>",
		"url": "/products/quinn-100-blackout-oeko-heavyweight-velvet-custom-curtain",
		"regular_price": "$129.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-blackout-curtains",
				"title": "Advert Blackout Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-curtains",
				"title": "Blackout Curtains"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8780119703802,
		"title": "Chloe Linen Look Burlap Textured Sheer Curtain",
		"handle": "chloe-linen-look-burlap-textured-sheer-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Semi-sheer<br>Weight: Sheer (205g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Rustic yet refined, these burlap semi-sheers let in just enough light to bathe your room in a natural glow, while their textured charm evokes an organic elegance.</p>",
		"published_at": "2025-05-07T16:29:16+08:00",
		"created_at": "2025-05-07T16:29:16+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Black Friday",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Factory products",
			"flash_categories",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"New Year's Day",
			"Search curtains",
			"Search linen",
			"Search sheer",
			"Summer Collection"
		],
		"price": 9900,
		"price_min": 9900,
		"price_max": 9900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319458906362,
				"title": "Light Beige",
				"option1": "Light Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Light Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011348984058,
					"product_id": 8780119703802,
					"position": 53,
					"created_at": "2025-05-19T19:10:09+08:00",
					"updated_at": "2025-08-26T16:30:27+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-1_1__resolution-standardv2-2x.jpg?v=1756197027",
					"variant_ids": [
						47319458906362
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Light Beige",
				"public_title": "Light Beige",
				"options": [
					"Light Beige"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36055721017594,
					"position": 53,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Alight-beige-1_1__resolution-standardv2-2x.jpg?v=1756197027"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Achloe_lightbeige_1024x1024.png?v=1751332870"
			},
			{
				"id": 47319458873594,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44120069144826,
					"product_id": 8780119703802,
					"position": 46,
					"created_at": "2025-06-04T17:47:30+08:00",
					"updated_at": "2025-08-26T16:30:27+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Acream-1-1_1__resolution-standardv2-2x_7ce548cf-f86e-497c-a4c6-7b33c4c6e82e.jpg?v=1756197027",
					"variant_ids": [
						47319458873594
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36129570816250,
					"position": 46,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Acream-1-1_1__resolution-standardv2-2x_7ce548cf-f86e-497c-a4c6-7b33c4c6e82e.jpg?v=1756197027"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Achloe_cream_1024x1024.jpg?v=1751332870"
			},
			{
				"id": 47319458742522,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011349344506,
					"product_id": 8780119703802,
					"position": 3,
					"created_at": "2025-05-19T19:10:10+08:00",
					"updated_at": "2025-08-26T16:30:23+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ataupe-1-1_1__resolution-standardv2-2x.jpg?v=1756197023",
					"variant_ids": [
						47319458742522
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36055721246970,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ataupe-1-1_1__resolution-standardv2-2x.jpg?v=1756197023"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Achloe_taupe_1024x1024.png?v=1751332870"
			},
			{
				"id": 47319458775290,
				"title": "Brick Red",
				"option1": "Brick Red",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Brick Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011342627066,
					"product_id": 8780119703802,
					"position": 12,
					"created_at": "2025-05-19T19:09:38+08:00",
					"updated_at": "2025-08-26T16:30:23+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-2-1_1__resolution-standardv2-2x.jpg?v=1756197023",
					"variant_ids": [
						47319458775290
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Brick Red",
				"public_title": "Brick Red",
				"options": [
					"Brick Red"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36055717347578,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abrick-red-2-1_1__resolution-standardv2-2x.jpg?v=1756197023"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Achloe_brickred_1024x1024.png?v=1751332870"
			},
			{
				"id": 47319458808058,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011348525306,
					"product_id": 8780119703802,
					"position": 22,
					"created_at": "2025-05-19T19:10:07+08:00",
					"updated_at": "2025-08-26T16:30:24+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agreen-1-1_1__resolution-standardv2-2x.jpg?v=1756197024",
					"variant_ids": [
						47319458808058
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36055720067322,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agreen-1-1_1__resolution-standardv2-2x.jpg?v=1756197024"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319458840826,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011344888058,
					"product_id": 8780119703802,
					"position": 33,
					"created_at": "2025-05-19T19:09:59+08:00",
					"updated_at": "2025-08-26T16:30:25+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-standardv2-2x.jpg?v=1756197025",
					"variant_ids": [
						47319458840826
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36055718756602,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-standardv2-2x.jpg?v=1756197025"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319458939130,
				"title": "Stone Blue",
				"option1": "Stone Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-42-SD-Stone Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011349180666,
					"product_id": 8780119703802,
					"position": 40,
					"created_at": "2025-05-19T19:10:08+08:00",
					"updated_at": "2025-08-26T16:30:26+08:00",
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-1-2_1__resolution-standardv2-2x.jpg?v=1756197026",
					"variant_ids": [
						47319458939130
					]
				},
				"available": true,
				"name": "Chloe Linen Look Burlap Textured Sheer Curtain - Stone Blue",
				"public_title": "Stone Blue",
				"options": [
					"Stone Blue"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
					"id": 36055720591610,
					"position": 40,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Astone-blue-1-2_1__resolution-standardv2-2x.jpg?v=1756197026"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Alight-beige-2-1_2__resolution-standardv2-2x.jpg?v=1756197022",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-lightbeige.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Ataupe-1-1_1__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Ataupe-9_4__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Ataupe-2-1_2__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Ataupe-3-1_3__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Ataupe-6_7__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-taupe.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Ataupe-8_5__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Ataupe-7_6__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Ataupe-5_8__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Abrick-red-2-1_1__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Abrick-red-9_3__resolution-standardv2-2x.jpg?v=1756197023",
			"//thehues.com/cdn/shop/files/Abrick-red-3-1_2__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Abrick-red-6_5__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Abrick-red-7_4__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Abrick-red-8_8__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Abrick-red-10_9__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Abrick-red-5-1_6__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Abrick-red-11_7__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-brickred.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Agreen-1-1_1__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Agreen-9_4__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Agreen-2-1_2__resolution-standardv2-2x.jpg?v=1756197024",
			"//thehues.com/cdn/shop/files/Agreen-3-1_3__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Agreen-6_6__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Agreen-7_5__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Agreen-8_9__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Agreen-10_10__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Agreen-11_8__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Agreen-5_7__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-green.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Abrown-7_2__resolution-standardv2-2x.jpg?v=1756197025",
			"//thehues.com/cdn/shop/files/Abrown-5-2_4__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Abrown-4-2_6__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Abrown-6_3__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Abrown-3-2_5__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-brown.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Astone-blue-1-2_1__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Astone-blue-6-1_4__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Astone-blue-4-3_2__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Astone-blue-5-2_5__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/Astone-blue-3-3_3__resolution-standardv2-2x.jpg?v=1756197026",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-stoneblue.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Acream-1-1_1__resolution-standardv2-2x_7ce548cf-f86e-497c-a4c6-7b33c4c6e82e.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Acream-7_2__resolution-standardv2-2x_e2cdd402-5e74-4c2e-9a92-1abd8dc99470.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Acream-5-1_4__resolution-standardv2-2x_35055f8c-eb9b-4dd4-bf30-b0ea4fddfff5.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Acream-4-1_6__resolution-standardv2-2x_3b2488e0-bb4b-4caf-8051-dd5f6c073667.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Acream-6-1_3__resolution-standardv2-2x_eb304c6b-27a1-457e-9402-f5d15da06d31.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Acream-3-1_5__resolution-standardv2-2x_12111f27-fb61-4c75-b2d0-594c3386a2f3.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-cream.jpg?v=1761207757",
			"//thehues.com/cdn/shop/files/Alight-beige-1_1__resolution-standardv2-2x.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Alight-beige-7_3__resolution-standardv2-2x.jpg?v=1756197027",
			"//thehues.com/cdn/shop/files/Alight-beige-4-1_6__resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Alight-beige-5-1_7__resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Alight-beige-6_5__resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Alight-beige-8_4__resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-2_resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-3_resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-7_resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-4_resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-1_resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-6_resolution-standardv2-2x.jpg?v=1756197028",
			"//thehues.com/cdn/shop/files/Achloe-5_resolution-standardv2-2x.jpg?v=1756197029"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Alight-beige-2-1_2__resolution-standardv2-2x_1024x1024.jpg?v=1756197022",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721050362,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-2-1_2__resolution-standardv2-2x.jpg?v=1756197022"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-2-1_2__resolution-standardv2-2x.jpg?v=1756197022",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596681244922,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3667,
					"width": 2934,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-lightbeige.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3667,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-lightbeige.jpg?v=1761207757",
				"width": 2934
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721246970,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-1-1_1__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-1-1_1__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721214202,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-9_4__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-9_4__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721279738,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-2-1_2__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-2-1_2__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721312506,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-3-1_3__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-3-1_3__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721115898,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-6_7__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-6_7__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596681179386,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3676,
					"width": 2941,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-taupe.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3676,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-taupe.jpg?v=1761207757",
				"width": 2941
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721181434,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-8_5__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-8_5__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721148666,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-7_6__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-7_6__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721083130,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ataupe-5_8__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ataupe-5_8__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717347578,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-2-1_1__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-2-1_1__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717216506,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-9_3__resolution-standardv2-2x.jpg?v=1756197023"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-9_3__resolution-standardv2-2x.jpg?v=1756197023",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717380346,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-3-1_2__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-3-1_2__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717118202,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-6_5__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-6_5__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717150970,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-7_4__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-7_4__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717183738,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-8_8__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-8_8__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717249274,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-10_9__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-10_9__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717413114,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-5-1_6__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-5-1_6__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717282042,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrick-red-11_7__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrick-red-11_7__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596681015546,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3680,
					"width": 2944,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-brickred.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3680,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-brickred.jpg?v=1761207757",
				"width": 2944
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720067322,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-1-1_1__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-1-1_1__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719936250,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-9_4__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-9_4__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720100090,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-2-1_2__resolution-standardv2-2x.jpg?v=1756197024"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-2-1_2__resolution-standardv2-2x.jpg?v=1756197024",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719772410,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-3-1_3__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-3-1_3__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719837946,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-6_6__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-6_6__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719870714,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-7_5__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-7_5__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719903482,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-8_9__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-8_9__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719969018,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-10_10__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-10_10__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720001786,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-11_8__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-11_8__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719805178,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreen-5_7__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-5_7__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596681048314,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3670,
					"width": 2936,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-green.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3670,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-green.jpg?v=1761207757",
				"width": 2936
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718756602,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-1-1_1__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718658298,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-7_2__resolution-standardv2-2x.jpg?v=1756197025"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-7_2__resolution-standardv2-2x.jpg?v=1756197025",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718592762,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-5-2_4__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-5-2_4__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718822138,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-4-2_6__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-4-2_6__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718625530,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-6_3__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-6_3__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718789370,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abrown-3-2_5__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abrown-3-2_5__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596680917242,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3660,
					"width": 2928,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-brown.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3660,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-brown.jpg?v=1761207757",
				"width": 2928
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720591610,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-1-2_1__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-1-2_1__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720198394,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-6-1_4__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-6-1_4__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720132858,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-4-3_2__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-4-3_2__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720165626,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-5-2_5__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-5-2_5__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720755450,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Astone-blue-3-3_3__resolution-standardv2-2x.jpg?v=1756197026"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Astone-blue-3-3_3__resolution-standardv2-2x.jpg?v=1756197026",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596680982778,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3670,
					"width": 2936,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-stoneblue.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3670,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-stoneblue.jpg?v=1761207757",
				"width": 2936
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36129570816250,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-1-1_1__resolution-standardv2-2x_7ce548cf-f86e-497c-a4c6-7b33c4c6e82e.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-1-1_1__resolution-standardv2-2x_7ce548cf-f86e-497c-a4c6-7b33c4c6e82e.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36129570980090,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-7_2__resolution-standardv2-2x_e2cdd402-5e74-4c2e-9a92-1abd8dc99470.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-7_2__resolution-standardv2-2x_e2cdd402-5e74-4c2e-9a92-1abd8dc99470.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36129570914554,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-5-1_4__resolution-standardv2-2x_35055f8c-eb9b-4dd4-bf30-b0ea4fddfff5.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-5-1_4__resolution-standardv2-2x_35055f8c-eb9b-4dd4-bf30-b0ea4fddfff5.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36129570881786,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-4-1_6__resolution-standardv2-2x_3b2488e0-bb4b-4caf-8051-dd5f6c073667.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-4-1_6__resolution-standardv2-2x_3b2488e0-bb4b-4caf-8051-dd5f6c073667.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36129570947322,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-6-1_3__resolution-standardv2-2x_eb304c6b-27a1-457e-9402-f5d15da06d31.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-6-1_3__resolution-standardv2-2x_eb304c6b-27a1-457e-9402-f5d15da06d31.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36129570849018,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-3-1_5__resolution-standardv2-2x_12111f27-fb61-4c75-b2d0-594c3386a2f3.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-3-1_5__resolution-standardv2-2x_12111f27-fb61-4c75-b2d0-594c3386a2f3.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36596680950010,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3650,
					"width": 2920,
					"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-cream.jpg?v=1761207757"
				},
				"aspect_ratio": 0.8,
				"height": 3650,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/chloe-linen-look-burlap-textured-sheer-curtain-cream.jpg?v=1761207757",
				"width": 2920
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055721017594,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-1_1__resolution-standardv2-2x.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-1_1__resolution-standardv2-2x.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720886522,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-7_3__resolution-standardv2-2x.jpg?v=1756197027"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-7_3__resolution-standardv2-2x.jpg?v=1756197027",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720788218,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-4-1_6__resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-4-1_6__resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720820986,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-5-1_7__resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-5-1_7__resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720853754,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-6_5__resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-6_5__resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720919290,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-beige-8_4__resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-beige-8_4__resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055717314810,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-2_resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-2_resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718691066,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-3_resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-3_resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055718723834,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-7_resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-7_resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055719117050,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-4_resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-4_resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720034554,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-1_resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-1_resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720296698,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-6_resolution-standardv2-2x.jpg?v=1756197028"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-6_resolution-standardv2-2x.jpg?v=1756197028",
				"width": 2000
			},
			{
				"alt": "Chloe 100% Blackout Linen Look Burlap Textured Sheer Curtain - TheHues",
				"id": 36055720952058,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achloe-5_resolution-standardv2-2x.jpg?v=1756197029"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achloe-5_resolution-standardv2-2x.jpg?v=1756197029",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Rustic yet refined, these burlap semi-sheers let in just enough light to bathe your room in a natural glow, while their textured charm evokes an organic elegance.</p>",
		"url": "/products/chloe-linen-look-burlap-textured-sheer-curtain",
		"regular_price": "$99.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8780124356858,
		"title": "Ambient Jacquard Custom Curtain",
		"handle": "ambient-jacquard-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p><strong>Material </strong>100% Polyester</p><p><strong>Features</strong> Room Darkening</p><p><strong>Weight</strong> Regular (365g/㎡)</p><p><strong>Softness</strong> Firmer</p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>The Ambient linen blend fabric, now crafted into soundproof, blackout, and thermal curtains, offers the ultimate solution for comfort and style.</p>",
		"published_at": "2025-05-07T16:31:17+08:00",
		"created_at": "2025-05-07T16:31:17+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > Solid Curtains",
			"All Curtains > Textured Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Extra 10%",
			"fall sale",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 11200,
		"price_min": 11200,
		"price_max": 11200,
		"available": true,
		"price_varies": false,
		"compare_at_price": 13900,
		"compare_at_price_min": 13900,
		"compare_at_price_max": 13900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319464837370,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR230-C-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44119954620666,
					"product_id": 8780124356858,
					"position": 1,
					"created_at": "2025-06-04T17:09:30+08:00",
					"updated_at": "2025-08-26T16:26:29+08:00",
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Awhite-1-1_1__resolution-standardv2-2x_91a3cc4f-fc3f-4d59-b360-76ef69f477bd.jpg?v=1756196789",
					"variant_ids": [
						47319464837370
					]
				},
				"available": true,
				"name": "Ambient Jacquard Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 13900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"id": 36129448689914,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Awhite-1-1_1__resolution-standardv2-2x_91a3cc4f-fc3f-4d59-b360-76ef69f477bd.jpg?v=1756196789"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aambient_white_1024x1024.png?v=1751279049"
			},
			{
				"id": 47319464870138,
				"title": "Silver",
				"option1": "Silver",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR230-C-Silver",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44119953080570,
					"product_id": 8780124356858,
					"position": 8,
					"created_at": "2025-06-04T17:09:06+08:00",
					"updated_at": "2025-08-26T16:26:30+08:00",
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Asilver-1-1_1__resolution-standardv2-2x_124582a5-1062-47f0-856f-e2517d3cf9da.jpg?v=1756196790",
					"variant_ids": [
						47319464870138
					]
				},
				"available": true,
				"name": "Ambient Jacquard Custom Curtain - Silver",
				"public_title": "Silver",
				"options": [
					"Silver"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 13900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"id": 36129447084282,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Asilver-1-1_1__resolution-standardv2-2x_124582a5-1062-47f0-856f-e2517d3cf9da.jpg?v=1756196790"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aambient_silver_1024x1024.png?v=1751279048"
			},
			{
				"id": 47319464902906,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR230-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44119931322618,
					"product_id": 8780124356858,
					"position": 15,
					"created_at": "2025-06-04T17:01:03+08:00",
					"updated_at": "2025-08-26T16:26:31+08:00",
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Acream-1-2_1__resolution-standardv2-2x_969a78cb-694d-4af6-b8d3-cbcfbc2f8532.jpg?v=1756196791",
					"variant_ids": [
						47319464902906
					]
				},
				"available": true,
				"name": "Ambient Jacquard Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 13900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"id": 36129420804346,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Acream-1-2_1__resolution-standardv2-2x_969a78cb-694d-4af6-b8d3-cbcfbc2f8532.jpg?v=1756196791"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aambient_cream_1024x1024.png?v=1751279048"
			},
			{
				"id": 47319464935674,
				"title": "Moss",
				"option1": "Moss",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR230-C-Moss",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44119945511162,
					"product_id": 8780124356858,
					"position": 22,
					"created_at": "2025-06-04T17:06:34+08:00",
					"updated_at": "2025-08-26T16:26:31+08:00",
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Amoss-1-1_1__resolution-standardv2-2x_81f4678e-4312-481c-8310-7057e11daefa.jpg?v=1756196791",
					"variant_ids": [
						47319464935674
					]
				},
				"available": true,
				"name": "Ambient Jacquard Custom Curtain - Moss",
				"public_title": "Moss",
				"options": [
					"Moss"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 13900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
					"id": 36129438630138,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Amoss-1-1_1__resolution-standardv2-2x_81f4678e-4312-481c-8310-7057e11daefa.jpg?v=1756196791"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aambient_moss_1024x1024.png?v=1751279049"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Awhite-1-1_1__resolution-standardv2-2x_91a3cc4f-fc3f-4d59-b360-76ef69f477bd.jpg?v=1756196789",
			"//thehues.com/cdn/shop/files/Awhite-6-1_5__resolution-standardv2-2x_ec3e02df-d5a8-4b9c-be40-9f19c4fa1887.jpg?v=1756196789",
			"//thehues.com/cdn/shop/files/Awhite-2-1_2__resolution-standardv2-2x_02178919-312e-4ce4-ae42-21fe3eb78372.jpg?v=1756196789",
			"//thehues.com/cdn/shop/files/Awhite-4-1_3__resolution-standardv2-2x_34f50d91-96de-4d7a-b07b-ef6960d7c5b8.jpg?v=1756196789",
			"//thehues.com/cdn/shop/files/Awhite-5-1_4__resolution-standardv2-2x_762682f3-4f22-42f3-bfde-6997c4ea32e8.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Awhite-3-1_7__resolution-standardv2-2x_9b5b64f9-1fe4-4487-871f-4cccefa9ec26.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Awhite-7_6__resolution-standardv2-2x_61e172b8-03f8-4b25-8256-e7934fc79a18.jpg?v=1761210252",
			"//thehues.com/cdn/shop/files/Asilver-1-1_1__resolution-standardv2-2x_124582a5-1062-47f0-856f-e2517d3cf9da.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Asilver-4_6__resolution-standardv2-2x_ac6bfc11-df4f-42f0-84ca-c93a14a7fd20.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Asilver-2_2__resolution-standardv2-2x_21c305b7-0653-4662-b1bf-8233affa74a0.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Asilver-7_3__resolution-standardv2-2x_e3a39437-011d-41e7-aac9-11ea922ffbcd.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Asilver-6_4__resolution-standardv2-2x_873e3d3b-a84e-42e0-a3ff-311498d72b35.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Asilver-3_7__resolution-standardv2-2x_fedb3620-df33-430e-a306-c296c3507e5e.jpg?v=1756196790",
			"//thehues.com/cdn/shop/files/Asilver-5_5__resolution-standardv2-2x_8c000304-5214-4284-bc8c-41e7ed1af2e0.jpg?v=1761210252",
			"//thehues.com/cdn/shop/files/Acream-1-2_1__resolution-standardv2-2x_969a78cb-694d-4af6-b8d3-cbcfbc2f8532.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Acream-7_5__resolution-standardv2-2x_d9a6ac6a-23a9-4489-936c-2425ed294456.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Acream-2_2__resolution-standardv2-2x_cc0d07d2-5d78-43e4-93dc-0302bc7ab5fd.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Acream-4_3__resolution-standardv2-2x_94690603-939a-4aa0-bc6e-2b8dd59ded0e.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Acream-5_4__resolution-standardv2-2x_a48a0369-90e7-45dd-b885-fe7507f9efb6.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Acream-3-1_7__resolution-standardv2-2x_9d953bfa-1a88-41ae-92e2-ed14798f85b8.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Acream-6_6__resolution-standardv2-2x_de98f30e-4970-405d-8007-c4c67a3ab1a9.jpg?v=1761210252",
			"//thehues.com/cdn/shop/files/Amoss-1-1_1__resolution-standardv2-2x_81f4678e-4312-481c-8310-7057e11daefa.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Amoss-4_6__resolution-standardv2-2x_1143f691-0ce5-4e67-bd3d-18c94335e393.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Amoss-2_2__resolution-standardv2-2x_e45d1f26-81a3-486c-955b-ee79595ed6e4.jpg?v=1756196791",
			"//thehues.com/cdn/shop/files/Amoss-7_3__resolution-standardv2-2x_6e327f27-dfe9-4489-bed4-048b725cc661.jpg?v=1756196792",
			"//thehues.com/cdn/shop/files/Amoss-6_4__resolution-standardv2-2x_5ddbf497-ebb3-4b10-ae7a-81f213a420ec.jpg?v=1756196792",
			"//thehues.com/cdn/shop/files/Amoss-3_7__resolution-standardv2-2x_dee1730f-cd16-43cc-9f67-4c10bbb949b7.jpg?v=1756196792",
			"//thehues.com/cdn/shop/files/Amoss-5_5__resolution-standardv2-2x_430e89df-3d76-49bf-8792-b5b9fbd119d3.jpg?v=1761210252"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Awhite-1-1_1__resolution-standardv2-2x_91a3cc4f-fc3f-4d59-b360-76ef69f477bd_1024x1024.jpg?v=1756196789",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448689914,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-1-1_1__resolution-standardv2-2x_91a3cc4f-fc3f-4d59-b360-76ef69f477bd.jpg?v=1756196789"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-1-1_1__resolution-standardv2-2x_91a3cc4f-fc3f-4d59-b360-76ef69f477bd.jpg?v=1756196789",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448624378,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-6-1_5__resolution-standardv2-2x_ec3e02df-d5a8-4b9c-be40-9f19c4fa1887.jpg?v=1756196789"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-6-1_5__resolution-standardv2-2x_ec3e02df-d5a8-4b9c-be40-9f19c4fa1887.jpg?v=1756196789",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448722682,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-2-1_2__resolution-standardv2-2x_02178919-312e-4ce4-ae42-21fe3eb78372.jpg?v=1756196789"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-2-1_2__resolution-standardv2-2x_02178919-312e-4ce4-ae42-21fe3eb78372.jpg?v=1756196789",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448820986,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-4-1_3__resolution-standardv2-2x_34f50d91-96de-4d7a-b07b-ef6960d7c5b8.jpg?v=1756196789"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-4-1_3__resolution-standardv2-2x_34f50d91-96de-4d7a-b07b-ef6960d7c5b8.jpg?v=1756196789",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448853754,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-5-1_4__resolution-standardv2-2x_762682f3-4f22-42f3-bfde-6997c4ea32e8.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-5-1_4__resolution-standardv2-2x_762682f3-4f22-42f3-bfde-6997c4ea32e8.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448788218,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-3-1_7__resolution-standardv2-2x_9b5b64f9-1fe4-4487-871f-4cccefa9ec26.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-3-1_7__resolution-standardv2-2x_9b5b64f9-1fe4-4487-871f-4cccefa9ec26.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129448657146,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-7_6__resolution-standardv2-2x_61e172b8-03f8-4b25-8256-e7934fc79a18.jpg?v=1761210252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-7_6__resolution-standardv2-2x_61e172b8-03f8-4b25-8256-e7934fc79a18.jpg?v=1761210252",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129447084282,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-1-1_1__resolution-standardv2-2x_124582a5-1062-47f0-856f-e2517d3cf9da.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-1-1_1__resolution-standardv2-2x_124582a5-1062-47f0-856f-e2517d3cf9da.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129446953210,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-4_6__resolution-standardv2-2x_ac6bfc11-df4f-42f0-84ca-c93a14a7fd20.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-4_6__resolution-standardv2-2x_ac6bfc11-df4f-42f0-84ca-c93a14a7fd20.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129447149818,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-2_2__resolution-standardv2-2x_21c305b7-0653-4662-b1bf-8233affa74a0.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-2_2__resolution-standardv2-2x_21c305b7-0653-4662-b1bf-8233affa74a0.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129447051514,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-7_3__resolution-standardv2-2x_e3a39437-011d-41e7-aac9-11ea922ffbcd.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-7_3__resolution-standardv2-2x_e3a39437-011d-41e7-aac9-11ea922ffbcd.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129447018746,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-6_4__resolution-standardv2-2x_873e3d3b-a84e-42e0-a3ff-311498d72b35.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-6_4__resolution-standardv2-2x_873e3d3b-a84e-42e0-a3ff-311498d72b35.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129447182586,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-3_7__resolution-standardv2-2x_fedb3620-df33-430e-a306-c296c3507e5e.jpg?v=1756196790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-3_7__resolution-standardv2-2x_fedb3620-df33-430e-a306-c296c3507e5e.jpg?v=1756196790",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129446985978,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver-5_5__resolution-standardv2-2x_8c000304-5214-4284-bc8c-41e7ed1af2e0.jpg?v=1761210252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver-5_5__resolution-standardv2-2x_8c000304-5214-4284-bc8c-41e7ed1af2e0.jpg?v=1761210252",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420804346,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-1-2_1__resolution-standardv2-2x_969a78cb-694d-4af6-b8d3-cbcfbc2f8532.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-1-2_1__resolution-standardv2-2x_969a78cb-694d-4af6-b8d3-cbcfbc2f8532.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420771578,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-7_5__resolution-standardv2-2x_d9a6ac6a-23a9-4489-936c-2425ed294456.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-7_5__resolution-standardv2-2x_d9a6ac6a-23a9-4489-936c-2425ed294456.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420837114,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-2_2__resolution-standardv2-2x_cc0d07d2-5d78-43e4-93dc-0302bc7ab5fd.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-2_2__resolution-standardv2-2x_cc0d07d2-5d78-43e4-93dc-0302bc7ab5fd.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420673274,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-4_3__resolution-standardv2-2x_94690603-939a-4aa0-bc6e-2b8dd59ded0e.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-4_3__resolution-standardv2-2x_94690603-939a-4aa0-bc6e-2b8dd59ded0e.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420706042,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-5_4__resolution-standardv2-2x_a48a0369-90e7-45dd-b885-fe7507f9efb6.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-5_4__resolution-standardv2-2x_a48a0369-90e7-45dd-b885-fe7507f9efb6.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420869882,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-3-1_7__resolution-standardv2-2x_9d953bfa-1a88-41ae-92e2-ed14798f85b8.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-3-1_7__resolution-standardv2-2x_9d953bfa-1a88-41ae-92e2-ed14798f85b8.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129420738810,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-6_6__resolution-standardv2-2x_de98f30e-4970-405d-8007-c4c67a3ab1a9.jpg?v=1761210252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-6_6__resolution-standardv2-2x_de98f30e-4970-405d-8007-c4c67a3ab1a9.jpg?v=1761210252",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438630138,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-1-1_1__resolution-standardv2-2x_81f4678e-4312-481c-8310-7057e11daefa.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-1-1_1__resolution-standardv2-2x_81f4678e-4312-481c-8310-7057e11daefa.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438499066,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-4_6__resolution-standardv2-2x_1143f691-0ce5-4e67-bd3d-18c94335e393.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-4_6__resolution-standardv2-2x_1143f691-0ce5-4e67-bd3d-18c94335e393.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438662906,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-2_2__resolution-standardv2-2x_e45d1f26-81a3-486c-955b-ee79595ed6e4.jpg?v=1756196791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-2_2__resolution-standardv2-2x_e45d1f26-81a3-486c-955b-ee79595ed6e4.jpg?v=1756196791",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438597370,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-7_3__resolution-standardv2-2x_6e327f27-dfe9-4489-bed4-048b725cc661.jpg?v=1756196792"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-7_3__resolution-standardv2-2x_6e327f27-dfe9-4489-bed4-048b725cc661.jpg?v=1756196792",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438564602,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-6_4__resolution-standardv2-2x_5ddbf497-ebb3-4b10-ae7a-81f213a420ec.jpg?v=1756196792"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-6_4__resolution-standardv2-2x_5ddbf497-ebb3-4b10-ae7a-81f213a420ec.jpg?v=1756196792",
				"width": 2000
			},
			{
				"alt": "Ambient 100% Blackout Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438695674,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-3_7__resolution-standardv2-2x_dee1730f-cd16-43cc-9f67-4c10bbb949b7.jpg?v=1756196792"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-3_7__resolution-standardv2-2x_dee1730f-cd16-43cc-9f67-4c10bbb949b7.jpg?v=1756196792",
				"width": 2000
			},
			{
				"alt": "Ambient Linen Blend Jacquard Custom Curtain - TheHues",
				"id": 36129438531834,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-5_5__resolution-standardv2-2x_430e89df-3d76-49bf-8792-b5b9fbd119d3.jpg?v=1761210252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-5_5__resolution-standardv2-2x_430e89df-3d76-49bf-8792-b5b9fbd119d3.jpg?v=1761210252",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36104624144634,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.562,
					"height": 854,
					"width": 480,
					"src": "//thehues.com/cdn/shop/files/preview_images/2772464218dc4ebbbcf8bf8fce818532.thumbnail.0000000000.jpg?v=1748482279"
				},
				"aspect_ratio": 0.558,
				"duration": 34000,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2772464218dc4ebbbcf8bf8fce818532/2772464218dc4ebbbcf8bf8fce818532.SD-480p-1.5Mbps-48422077.mp4?v=0",
						"width": 268
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2772464218dc4ebbbcf8bf8fce818532/2772464218dc4ebbbcf8bf8fce818532.HD-720p-4.5Mbps-48422077.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 720,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2772464218dc4ebbbcf8bf8fce818532/2772464218dc4ebbbcf8bf8fce818532.m3u8?v=0",
						"width": 404
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Ambient linen blend fabric, now crafted into soundproof, blackout, and thermal curtains, offers the ultimate solution for comfort and style.</p>",
		"url": "/products/ambient-jacquard-custom-curtain",
		"regular_price": "$112.00",
		"sale_price": "$139.00",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780116721914,
		"title": "Traunsee Cotton Blend Textured Custom Curtain",
		"handle": "traunsee-cotton-blend-textured-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 50% Cotton &amp; 50% Polyester<br>Features: Light Filtering<br>Weight: Regular (310g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p></div>`,
		"description": "<p>Traunsee curtains blend thick sheer linen with textured hues, creating a quiet elegance. The fabric?¡¥s depth and warmth transform light into a serene, inviting glow.</p>",
		"published_at": "2025-05-07T16:27:46+08:00",
		"created_at": "2025-05-07T16:27:46+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"flash_categories",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"Outsourced products",
			"Search cotton",
			"Search curtains",
			"Summer Collection"
		],
		"price": 11500,
		"price_min": 11500,
		"price_max": 11500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319402807546,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181260075258,
					"product_id": 8780116721914,
					"position": 1,
					"created_at": "2025-06-11T09:38:31+08:00",
					"updated_at": "2025-08-26T16:32:32+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/Awhite-1-1_resolution-standardv2-2x_9f54da58-08f4-477b-a71f-1fc2870d40df.jpg?v=1756197152",
					"variant_ids": [
						47319402807546
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166668943610,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/Awhite-1-1_resolution-standardv2-2x_9f54da58-08f4-477b-a71f-1fc2870d40df.jpg?v=1756197152"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATraunsee-ivory_1024x1024.jpg?v=1751348819"
			},
			{
				"id": 47319402840314,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181262663930,
					"product_id": 8780116721914,
					"position": 3,
					"created_at": "2025-06-11T09:38:50+08:00",
					"updated_at": "2025-08-26T16:32:32+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-2_resolution-standardv2-2x.jpg?v=1756197152",
					"variant_ids": [
						47319402840314
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166670418170,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-2_resolution-standardv2-2x.jpg?v=1756197152"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATraunsee-white_1024x1024.jpg?v=1751348819"
			},
			{
				"id": 47319402873082,
				"title": "Silver Grey",
				"option1": "Silver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Silver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181260632314,
					"product_id": 8780116721914,
					"position": 10,
					"created_at": "2025-06-11T09:38:39+08:00",
					"updated_at": "2025-08-26T16:32:33+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/Asilvergrey-1_resolution-standardv2-2x.jpg?v=1756197153",
					"variant_ids": [
						47319402873082
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Silver Grey",
				"public_title": "Silver Grey",
				"options": [
					"Silver Grey"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166669107450,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/Asilvergrey-1_resolution-standardv2-2x.jpg?v=1756197153"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATraunsee-grey_1024x1024.jpg?v=1751348819"
			},
			{
				"id": 47319402971386,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181259976954,
					"product_id": 8780116721914,
					"position": 16,
					"created_at": "2025-06-11T09:38:30+08:00",
					"updated_at": "2025-08-26T16:32:33+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_316c3df3-5182-46e9-8427-f534d3af07c3.jpg?v=1756197153",
					"variant_ids": [
						47319402971386
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166668452090,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_316c3df3-5182-46e9-8427-f534d3af07c3.jpg?v=1756197153"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATraunsee-silver-grey_1024x1024.jpg?v=1751348819"
			},
			{
				"id": 47319402905850,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181260402938,
					"product_id": 8780116721914,
					"position": 12,
					"created_at": "2025-06-11T09:38:36+08:00",
					"updated_at": "2025-08-26T16:32:33+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/Asand-1_resolution-standardv2-2x_60424c24-e494-441e-a898-e290ea9537f4.jpg?v=1756197153",
					"variant_ids": [
						47319402905850
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166668976378,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/Asand-1_resolution-standardv2-2x_60424c24-e494-441e-a898-e290ea9537f4.jpg?v=1756197153"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319403036922,
				"title": "Cappuccino",
				"option1": "Cappuccino",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Cappuccino",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181258567930,
					"product_id": 8780116721914,
					"position": 20,
					"created_at": "2025-06-11T09:38:15+08:00",
					"updated_at": "2025-08-26T16:32:34+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-1_resolution-standardv2-2x.jpg?v=1756197154",
					"variant_ids": [
						47319403036922
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Cappuccino",
				"public_title": "Cappuccino",
				"options": [
					"Cappuccino"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166667632890,
					"position": 20,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/ACappuccino-1_resolution-standardv2-2x.jpg?v=1756197154"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319403069690,
				"title": "Denim Blue",
				"option1": "Denim Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Denim Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181258961146,
					"product_id": 8780116721914,
					"position": 18,
					"created_at": "2025-06-11T09:38:20+08:00",
					"updated_at": "2025-08-26T16:32:34+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/ADenim-Blue-1_resolution-standardv2-2x.jpg?v=1756197154",
					"variant_ids": [
						47319403069690
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Denim Blue",
				"public_title": "Denim Blue",
				"options": [
					"Denim Blue"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166668124410,
					"position": 18,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/ADenim-Blue-1_resolution-standardv2-2x.jpg?v=1756197154"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319402938618,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-80-SD-Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44181259256058,
					"product_id": 8780116721914,
					"position": 14,
					"created_at": "2025-06-11T09:38:24+08:00",
					"updated_at": "2025-08-26T16:32:33+08:00",
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"width": 1280,
					"height": 1600,
					"src": "//thehues.com/cdn/shop/files/Agreen-1_resolution-standardv2-2x_a077574e-7385-4273-9fd4-020d26c7016a.jpg?v=1756197153",
					"variant_ids": [
						47319402938618
					]
				},
				"available": true,
				"name": "Traunsee Cotton Blend Textured Custom Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 11500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
					"id": 36166668288250,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1600,
						"width": 1280,
						"src": "//thehues.com/cdn/shop/files/Agreen-1_resolution-standardv2-2x_a077574e-7385-4273-9fd4-020d26c7016a.jpg?v=1756197153"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Awhite-1-1_resolution-standardv2-2x_9f54da58-08f4-477b-a71f-1fc2870d40df.jpg?v=1756197152",
			"//thehues.com/cdn/shop/files/Aivory-2_resolution-standardv2-2x.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/AHoneyview_1115-2_resolution-standardv2-2x.jpg?v=1756197152",
			"//thehues.com/cdn/shop/files/AHoneyview_1115-7_resolution-standardv2-2x.jpg?v=1756197152",
			"//thehues.com/cdn/shop/files/ATraunsee-1_resolution-standardv2-2x.jpg?v=1756197152",
			"//thehues.com/cdn/shop/files/AHoneyview_1115-8_resolution-standardv2-2x.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/AHoneyview_1115-5_resolution-standardv2-2x.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/AHoneyview_1115-3_resolution-standardv2-2x.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/AHoneyview_1115-4_resolution-standardv2-2x.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/Asilvergrey-1_resolution-standardv2-2x.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/Asilvergrey-2_resolution-standardv2-2x.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/Asand-1_resolution-standardv2-2x_60424c24-e494-441e-a898-e290ea9537f4.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/Asand-2_resolution-standardv2-2x_d7007ea6-4af8-4b85-a806-22031d581401.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/Agreen-1_resolution-standardv2-2x_a077574e-7385-4273-9fd4-020d26c7016a.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/Agreen-2_resolution-standardv2-2x_9973f3ff-4e93-4140-b4ae-90ecb992f98b.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_316c3df3-5182-46e9-8427-f534d3af07c3.jpg?v=1756197153",
			"//thehues.com/cdn/shop/files/AGrey-2-1_resolution-standardv2-2x.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/ADenim-Blue-1_resolution-standardv2-2x.jpg?v=1756197154",
			"//thehues.com/cdn/shop/files/ADenim-Blue-2_resolution-standardv2-2x.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/ACappuccino-1_resolution-standardv2-2x.jpg?v=1756197154",
			"//thehues.com/cdn/shop/files/ACappuccino-2_resolution-standardv2-2x.jpg?v=1761204936",
			"//thehues.com/cdn/shop/files/Adark-grey-1_resolution-standardv2-2x_fb586493-ae01-4d3e-b7c4-b711c05fb648.jpg?v=1756197154",
			"//thehues.com/cdn/shop/files/Adark-grey-2_resolution-standardv2-2x_d9991a07-5174-4243-80a2-fd02094e05b3.jpg?v=1761204936"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Awhite-1-1_resolution-standardv2-2x_9f54da58-08f4-477b-a71f-1fc2870d40df_1024x1024.jpg?v=1756197152",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668943610,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Awhite-1-1_resolution-standardv2-2x_9f54da58-08f4-477b-a71f-1fc2870d40df.jpg?v=1756197152"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-1-1_resolution-standardv2-2x_9f54da58-08f4-477b-a71f-1fc2870d40df.jpg?v=1756197152",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668910842,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Aivory-2_resolution-standardv2-2x.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aivory-2_resolution-standardv2-2x.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670418170,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-2_resolution-standardv2-2x.jpg?v=1756197152"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-2_resolution-standardv2-2x.jpg?v=1756197152",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670549242,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-7_resolution-standardv2-2x.jpg?v=1756197152"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-7_resolution-standardv2-2x.jpg?v=1756197152",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670614778,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/ATraunsee-1_resolution-standardv2-2x.jpg?v=1756197152"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATraunsee-1_resolution-standardv2-2x.jpg?v=1756197152",
				"width": 3072
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670582010,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-8_resolution-standardv2-2x.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-8_resolution-standardv2-2x.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670516474,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-5_resolution-standardv2-2x.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-5_resolution-standardv2-2x.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670450938,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-3_resolution-standardv2-2x.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-3_resolution-standardv2-2x.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166670483706,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-4_resolution-standardv2-2x.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoneyview_1115-4_resolution-standardv2-2x.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166669107450,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Asilvergrey-1_resolution-standardv2-2x.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilvergrey-1_resolution-standardv2-2x.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166669140218,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Asilvergrey-2_resolution-standardv2-2x.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilvergrey-2_resolution-standardv2-2x.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668976378,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Asand-1_resolution-standardv2-2x_60424c24-e494-441e-a898-e290ea9537f4.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asand-1_resolution-standardv2-2x_60424c24-e494-441e-a898-e290ea9537f4.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166669009146,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Asand-2_resolution-standardv2-2x_d7007ea6-4af8-4b85-a806-22031d581401.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asand-2_resolution-standardv2-2x_d7007ea6-4af8-4b85-a806-22031d581401.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668288250,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Agreen-1_resolution-standardv2-2x_a077574e-7385-4273-9fd4-020d26c7016a.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-1_resolution-standardv2-2x_a077574e-7385-4273-9fd4-020d26c7016a.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668321018,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Agreen-2_resolution-standardv2-2x_9973f3ff-4e93-4140-b4ae-90ecb992f98b.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreen-2_resolution-standardv2-2x_9973f3ff-4e93-4140-b4ae-90ecb992f98b.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668452090,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_316c3df3-5182-46e9-8427-f534d3af07c3.jpg?v=1756197153"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_316c3df3-5182-46e9-8427-f534d3af07c3.jpg?v=1756197153",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668484858,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/AGrey-2-1_resolution-standardv2-2x.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-2-1_resolution-standardv2-2x.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668124410,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/ADenim-Blue-1_resolution-standardv2-2x.jpg?v=1756197154"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADenim-Blue-1_resolution-standardv2-2x.jpg?v=1756197154",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668157178,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/ADenim-Blue-2_resolution-standardv2-2x.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADenim-Blue-2_resolution-standardv2-2x.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166667632890,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-1_resolution-standardv2-2x.jpg?v=1756197154"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACappuccino-1_resolution-standardv2-2x.jpg?v=1756197154",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166667665658,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/ACappuccino-2_resolution-standardv2-2x.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACappuccino-2_resolution-standardv2-2x.jpg?v=1761204936",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668026106,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Adark-grey-1_resolution-standardv2-2x_fb586493-ae01-4d3e-b7c4-b711c05fb648.jpg?v=1756197154"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-grey-1_resolution-standardv2-2x_fb586493-ae01-4d3e-b7c4-b711c05fb648.jpg?v=1756197154",
				"width": 1280
			},
			{
				"alt": "Traunsee Cotton Blend Textured Custom Curtain - TheHues",
				"id": 36166668058874,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1600,
					"width": 1280,
					"src": "//thehues.com/cdn/shop/files/Adark-grey-2_resolution-standardv2-2x_d9991a07-5174-4243-80a2-fd02094e05b3.jpg?v=1761204936"
				},
				"aspect_ratio": 0.8,
				"height": 1600,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-grey-2_resolution-standardv2-2x_d9991a07-5174-4243-80a2-fd02094e05b3.jpg?v=1761204936",
				"width": 1280
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Traunsee curtains blend thick sheer linen with textured hues, creating a quiet elegance. The fabric?¡¥s depth and warmth transform light into a serene, inviting glow.</p>",
		"url": "/products/traunsee-cotton-blend-textured-custom-curtain",
		"regular_price": "$115.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/cotton-curtains",
				"title": "Cotton Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8860670820602,
		"title": "Milo Linen Blend Striped Custom Curtain",
		"handle": "milo-linen-blend-striped-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 15% Linen 85% Polyester<br>Features: Light Filtering<br>Weight: Regular (482g/㎡)<br>Softness: Soft</p><h3>Care</h3><p><br>Washable</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p></div>`,
		"description": "<p>Grainy linen-look stripe in striped patterns ¡ª unfussy grace, slow-living texture</p>",
		"published_at": "2025-07-17T17:26:47+08:00",
		"created_at": "2025-07-15T15:39:01+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > striped custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 9900,
		"price_min": 9900,
		"price_max": 9900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47512588779770,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-WuJi-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44529265934586,
					"product_id": 8860670820602,
					"position": 1,
					"created_at": "2025-07-16T16:44:39+08:00",
					"updated_at": "2025-08-26T16:18:55+08:00",
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_green_1_c253ad50-daa6-4a3b-b4aa-a0ee6a3d7928.jpg?v=1756196335",
					"variant_ids": [
						47512588779770
					]
				},
				"available": true,
				"name": "Milo Linen Blend Striped Custom Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"id": 36387929260282,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_green_1_c253ad50-daa6-4a3b-b4aa-a0ee6a3d7928.jpg?v=1756196335"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/greenn_1024x1024.jpg?v=1752718672"
			},
			{
				"id": 47512588583162,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-WuJi-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44529266622714,
					"product_id": 8860670820602,
					"position": 3,
					"created_at": "2025-07-16T16:44:45+08:00",
					"updated_at": "2025-08-26T16:18:55+08:00",
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_1_eccc81ea-832a-4741-81bd-a3a936bbe425.jpg?v=1756196335",
					"variant_ids": [
						47512588583162
					]
				},
				"available": true,
				"name": "Milo Linen Blend Striped Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"id": 36387929915642,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_sand_1_eccc81ea-832a-4741-81bd-a3a936bbe425.jpg?v=1756196335"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/sandd_1024x1024.jpg?v=1752718672"
			},
			{
				"id": 47512592580858,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-WuJi-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44652257575162,
					"product_id": 8860670820602,
					"position": 27,
					"created_at": "2025-08-01T17:26:17+08:00",
					"updated_at": "2025-08-26T16:18:57+08:00",
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_1_97c1e333-f00e-4e64-82bf-086f80f0b679.jpg?v=1756196337",
					"variant_ids": [
						47512592580858
					]
				},
				"available": true,
				"name": "Milo Linen Blend Striped Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"id": 36464694526202,
					"position": 27,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_gray_1_97c1e333-f00e-4e64-82bf-086f80f0b679.jpg?v=1756196337"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/gray_0cc75b51-7a5d-4599-87ea-30046f66f8b3_1024x1024.jpg?v=1754040451"
			},
			{
				"id": 47512592613626,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-WuJi-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44529262756090,
					"product_id": 8860670820602,
					"position": 9,
					"created_at": "2025-07-16T16:43:49+08:00",
					"updated_at": "2025-08-26T16:18:56+08:00",
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_1_512a7e1b-29b2-4a6f-b7ff-671ee1e4854b.jpg?v=1756196336",
					"variant_ids": [
						47512592613626
					]
				},
				"available": true,
				"name": "Milo Linen Blend Striped Custom Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"id": 36387925819642,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_brown_1_512a7e1b-29b2-4a6f-b7ff-671ee1e4854b.jpg?v=1756196336"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/brown_26bdfcf8-f31c-491e-8ea7-d3abdbd286b4_1024x1024.jpg?v=1752718672"
			},
			{
				"id": 47512588878074,
				"title": "BlueBerry",
				"option1": "BlueBerry",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-WuJi-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44529208328442,
					"product_id": 8860670820602,
					"position": 21,
					"created_at": "2025-07-16T16:35:00+08:00",
					"updated_at": "2025-08-26T16:18:57+08:00",
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_BLACK_1_de439f7f-ac41-4afe-9435-5cfdeddf6aaa.jpg?v=1756196337",
					"variant_ids": [
						47512588878074
					]
				},
				"available": true,
				"name": "Milo Linen Blend Striped Custom Curtain - BlueBerry",
				"public_title": "BlueBerry",
				"options": [
					"BlueBerry"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
					"id": 36387884138746,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_BLACK_1_de439f7f-ac41-4afe-9435-5cfdeddf6aaa.jpg?v=1756196337"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/black_fe220778-ec16-4490-b9c9-2c944560f91f_1024x1024.jpg?v=1752718672"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/wuji_green_1_c253ad50-daa6-4a3b-b4aa-a0ee6a3d7928.jpg?v=1756196335",
			"//thehues.com/cdn/shop/files/wuji_green_3_5856084d-3fe6-456c-bd08-49b1f0c706dd.jpg?v=1761202687",
			"//thehues.com/cdn/shop/files/wuji_sand_1_eccc81ea-832a-4741-81bd-a3a936bbe425.jpg?v=1756196335",
			"//thehues.com/cdn/shop/files/wuji_sand_2_b5c3f3b3-e1c6-447d-b003-6c354b5273a9.jpg?v=1756196335",
			"//thehues.com/cdn/shop/files/wuji_sand_6_d001db9e-0156-45f8-9eea-93e1da66b6db.jpg?v=1756196335",
			"//thehues.com/cdn/shop/files/wuji_sand_4_bec6678f-a8ee-491e-af49-f5d722b69f07.jpg?v=1756196335",
			"//thehues.com/cdn/shop/files/wuji_sand_9.jpg?v=1756196335",
			"//thehues.com/cdn/shop/files/wuji_sand_3_6bfab157-5e21-406b-8b50-cef354a67f26.jpg?v=1761202687",
			"//thehues.com/cdn/shop/files/wuji_brown_1_512a7e1b-29b2-4a6f-b7ff-671ee1e4854b.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_brown_2_66ba5d08-4f09-4ed2-ba42-b495700690b9.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_brown_6_2b93ea58-544d-4394-8c71-96019e282e48.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_brown_4_0b279f77-e6f2-4a60-81b0-45722accffdc.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_brown_9.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_brown_3_fa762512-f480-42d7-b4b1-ff8df7affc23.jpg?v=1761202687",
			"//thehues.com/cdn/shop/files/wuji_green_12.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_green_13.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_green_2_80a993a8-5ed0-4a1d-8782-ef7c395db147.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_green_9.jpg?v=1756196336",
			"//thehues.com/cdn/shop/files/wuji_green_4_a1cf52b1-d834-4ece-a748-86295f7fa8a5.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_green_8.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_BLACK_1_de439f7f-ac41-4afe-9435-5cfdeddf6aaa.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_black_2_2d1856dc-a5f2-408d-95ab-62d1f061ebd5.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_black_6_567f64f1-4685-4833-9638-d2cfc3ff81c7.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_black_4_3a7a2822-db59-41f0-8687-8fc2d60a0878.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_black_5_681f97c5-b5a7-48be-975f-f12e5d429159.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_black_3_fc56a158-78f8-4d06-b41a-90fa0c7ce488.jpg?v=1761202687",
			"//thehues.com/cdn/shop/files/wuji_gray_1_97c1e333-f00e-4e64-82bf-086f80f0b679.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_gray_2_875d3062-9503-48f6-95a7-f17ab1933e31.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_gray_6_a1938a5a-b897-424c-9fc7-2c489e8f8b33.jpg?v=1756196337",
			"//thehues.com/cdn/shop/files/wuji_gray_4_6877d841-c51f-458f-9f66-1afcabe99cfa.jpg?v=1756196338",
			"//thehues.com/cdn/shop/files/wuji_gray_8_a49cefa9-3d73-4533-ba1a-254f80933d9c.jpg?v=1756196338",
			"//thehues.com/cdn/shop/files/wuji_gray_3_7233b23d-6c5a-4cd3-b22f-c1016a3cf2cd.jpg?v=1761202687",
			"//thehues.com/cdn/shop/files/wuji_gray_1_1118bcac-3ae5-454b-ba51-f5f71a526467.jpg?v=1756196338",
			"//thehues.com/cdn/shop/files/wuji_gray_9.jpg?v=1756196338",
			"//thehues.com/cdn/shop/files/wuji_gray_7.jpg?v=1756196338",
			"//thehues.com/cdn/shop/files/wuji_gray_4_f35a99f7-e6b3-4251-b009-2076abc2a95b.jpg?v=1756196339",
			"//thehues.com/cdn/shop/files/wuji_gray_8.jpg?v=1756196339",
			"//thehues.com/cdn/shop/files/wuji_gray_3_b350c75a-a49a-43fc-8c19-fef5c9e23770.jpg?v=1761201612",
			"//thehues.com/cdn/shop/files/wuji_black_10.jpg?v=1756196339",
			"//thehues.com/cdn/shop/files/wuji_brown_8.jpg?v=1756196339",
			"//thehues.com/cdn/shop/files/wuji_gray_11.jpg?v=1756196340",
			"//thehues.com/cdn/shop/files/wuji_green_5_173090a4-46d0-4263-886f-a13d195006d3.jpg?v=1756196340",
			"//thehues.com/cdn/shop/files/wuji_gray_11_6781c4a5-04d3-4ed9-b335-c3cd4fa3a5d0.jpg?v=1756196340",
			"//thehues.com/cdn/shop/files/wuji_gray_10.jpg?v=1756196340",
			"//thehues.com/cdn/shop/files/wuji_gray_5_c3446221-4826-43be-b3fc-fa6b8d57409c.jpg?v=1756196340",
			"//thehues.com/cdn/shop/files/wuji_gray_7_1a83b297-996a-4b63-9a45-7a4b949fa941.jpg?v=1756196340",
			"//thehues.com/cdn/shop/files/wuji_gray_9_bf54b1b3-4ca8-4c28-a9ad-4193813fe436.jpg?v=1756196341"
		],
		"featured_image": "//thehues.com/cdn/shop/files/wuji_green_1_c253ad50-daa6-4a3b-b4aa-a0ee6a3d7928_1024x1024.jpg?v=1756196335",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929260282,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_1_c253ad50-daa6-4a3b-b4aa-a0ee6a3d7928.jpg?v=1756196335"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_1_c253ad50-daa6-4a3b-b4aa-a0ee6a3d7928.jpg?v=1756196335",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929882874,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_3_5856084d-3fe6-456c-bd08-49b1f0c706dd.jpg?v=1761202687"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_3_5856084d-3fe6-456c-bd08-49b1f0c706dd.jpg?v=1761202687",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929915642,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_1_eccc81ea-832a-4741-81bd-a3a936bbe425.jpg?v=1756196335"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_sand_1_eccc81ea-832a-4741-81bd-a3a936bbe425.jpg?v=1756196335",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929948410,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_2_b5c3f3b3-e1c6-447d-b003-6c354b5273a9.jpg?v=1756196335"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_sand_2_b5c3f3b3-e1c6-447d-b003-6c354b5273a9.jpg?v=1756196335",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929784570,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_6_d001db9e-0156-45f8-9eea-93e1da66b6db.jpg?v=1756196335"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_sand_6_d001db9e-0156-45f8-9eea-93e1da66b6db.jpg?v=1756196335",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387930013946,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_4_bec6678f-a8ee-491e-af49-f5d722b69f07.jpg?v=1756196335"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_sand_4_bec6678f-a8ee-491e-af49-f5d722b69f07.jpg?v=1756196335",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929850106,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_9.jpg?v=1756196335"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_sand_9.jpg?v=1756196335",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387930046714,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_sand_3_6bfab157-5e21-406b-8b50-cef354a67f26.jpg?v=1761202687"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_sand_3_6bfab157-5e21-406b-8b50-cef354a67f26.jpg?v=1761202687",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387925819642,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_1_512a7e1b-29b2-4a6f-b7ff-671ee1e4854b.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_1_512a7e1b-29b2-4a6f-b7ff-671ee1e4854b.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926180090,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_2_66ba5d08-4f09-4ed2-ba42-b495700690b9.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_2_66ba5d08-4f09-4ed2-ba42-b495700690b9.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387925754106,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_6_2b93ea58-544d-4394-8c71-96019e282e48.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_6_2b93ea58-544d-4394-8c71-96019e282e48.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926245626,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_4_0b279f77-e6f2-4a60-81b0-45722accffdc.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_4_0b279f77-e6f2-4a60-81b0-45722accffdc.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926114554,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_9.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_9.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387927195898,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_3_fa762512-f480-42d7-b4b1-ff8df7affc23.jpg?v=1761202687"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_3_fa762512-f480-42d7-b4b1-ff8df7affc23.jpg?v=1761202687",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929293050,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/wuji_green_12.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_12.jpg?v=1756196336",
				"width": 2001
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929325818,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/wuji_green_13.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_13.jpg?v=1756196336",
				"width": 2001
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929391354,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_2_80a993a8-5ed0-4a1d-8782-ef7c395db147.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_2_80a993a8-5ed0-4a1d-8782-ef7c395db147.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929424122,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_9.jpg?v=1756196336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_9.jpg?v=1756196336",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929719034,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_4_a1cf52b1-d834-4ece-a748-86295f7fa8a5.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_4_a1cf52b1-d834-4ece-a748-86295f7fa8a5.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929358586,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_8.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_8.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884138746,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BLACK_1_de439f7f-ac41-4afe-9435-5cfdeddf6aaa.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BLACK_1_de439f7f-ac41-4afe-9435-5cfdeddf6aaa.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884171514,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_black_2_2d1856dc-a5f2-408d-95ab-62d1f061ebd5.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_black_2_2d1856dc-a5f2-408d-95ab-62d1f061ebd5.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884302586,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_black_6_567f64f1-4685-4833-9638-d2cfc3ff81c7.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_black_6_567f64f1-4685-4833-9638-d2cfc3ff81c7.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884237050,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_black_4_3a7a2822-db59-41f0-8687-8fc2d60a0878.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_black_4_3a7a2822-db59-41f0-8687-8fc2d60a0878.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884269818,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_black_5_681f97c5-b5a7-48be-975f-f12e5d429159.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_black_5_681f97c5-b5a7-48be-975f-f12e5d429159.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884204282,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_black_3_fc56a158-78f8-4d06-b41a-90fa0c7ce488.jpg?v=1761202687"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_black_3_fc56a158-78f8-4d06-b41a-90fa0c7ce488.jpg?v=1761202687",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694526202,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_1_97c1e333-f00e-4e64-82bf-086f80f0b679.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_1_97c1e333-f00e-4e64-82bf-086f80f0b679.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694558970,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_2_875d3062-9503-48f6-95a7-f17ab1933e31.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_2_875d3062-9503-48f6-95a7-f17ab1933e31.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694329594,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_6_a1938a5a-b897-424c-9fc7-2c489e8f8b33.jpg?v=1756196337"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_6_a1938a5a-b897-424c-9fc7-2c489e8f8b33.jpg?v=1756196337",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694690042,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_4_6877d841-c51f-458f-9f66-1afcabe99cfa.jpg?v=1756196338"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_4_6877d841-c51f-458f-9f66-1afcabe99cfa.jpg?v=1756196338",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694722810,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_8_a49cefa9-3d73-4533-ba1a-254f80933d9c.jpg?v=1756196338"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_8_a49cefa9-3d73-4533-ba1a-254f80933d9c.jpg?v=1756196338",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464695378170,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_3_7233b23d-6c5a-4cd3-b22f-c1016a3cf2cd.jpg?v=1761202687"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_3_7233b23d-6c5a-4cd3-b22f-c1016a3cf2cd.jpg?v=1761202687",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926606074,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_1_1118bcac-3ae5-454b-ba51-f5f71a526467.jpg?v=1756196338"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_1_1118bcac-3ae5-454b-ba51-f5f71a526467.jpg?v=1756196338",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926671610,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_9.jpg?v=1756196338"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_9.jpg?v=1756196338",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387927163130,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_7.jpg?v=1756196338"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_7.jpg?v=1756196338",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387927097594,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_4_f35a99f7-e6b3-4251-b009-2076abc2a95b.jpg?v=1756196339"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_4_f35a99f7-e6b3-4251-b009-2076abc2a95b.jpg?v=1756196339",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387927130362,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_8.jpg?v=1756196339"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_8.jpg?v=1756196339",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387927228666,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_3_b350c75a-a49a-43fc-8c19-fef5c9e23770.jpg?v=1761201612"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_3_b350c75a-a49a-43fc-8c19-fef5c9e23770.jpg?v=1761201612",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387884335354,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_black_10.jpg?v=1756196339"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_black_10.jpg?v=1756196339",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926212858,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_brown_8.jpg?v=1756196339"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_brown_8.jpg?v=1756196339",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387926638842,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_11.jpg?v=1756196340"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_11.jpg?v=1756196340",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36387929751802,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_green_5_173090a4-46d0-4263-886f-a13d195006d3.jpg?v=1756196340"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_green_5_173090a4-46d0-4263-886f-a13d195006d3.jpg?v=1756196340",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694624506,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_11_6781c4a5-04d3-4ed9-b335-c3cd4fa3a5d0.jpg?v=1756196340"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_11_6781c4a5-04d3-4ed9-b335-c3cd4fa3a5d0.jpg?v=1756196340",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694657274,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_10.jpg?v=1756196340"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_10.jpg?v=1756196340",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694755578,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_5_c3446221-4826-43be-b3fc-fa6b8d57409c.jpg?v=1756196340"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_5_c3446221-4826-43be-b3fc-fa6b8d57409c.jpg?v=1756196340",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694788346,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_7_1a83b297-996a-4b63-9a45-7a4b949fa941.jpg?v=1756196340"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_7_1a83b297-996a-4b63-9a45-7a4b949fa941.jpg?v=1756196340",
				"width": 2000
			},
			{
				"alt": "Milo Linen Blend Striped Custom Curtain - TheHues",
				"id": 36464694591738,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_gray_9_bf54b1b3-4ca8-4c28-a9ad-4193813fe436.jpg?v=1756196341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_gray_9_bf54b1b3-4ca8-4c28-a9ad-4193813fe436.jpg?v=1756196341",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36393033597178,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 1920,
					"width": 1440,
					"src": "//thehues.com/cdn/shop/files/preview_images/42d32d72094645768e4be1af2884a693.thumbnail.0000000000.jpg?v=1752746313"
				},
				"aspect_ratio": 0.75,
				"duration": 9290,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/42d32d72094645768e4be1af2884a693/42d32d72094645768e4be1af2884a693.SD-480p-1.2Mbps-51412595.mp4?v=0",
						"width": 360
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/42d32d72094645768e4be1af2884a693/42d32d72094645768e4be1af2884a693.HD-1080p-4.8Mbps-51412595.mp4?v=0",
						"width": 810
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/42d32d72094645768e4be1af2884a693/42d32d72094645768e4be1af2884a693.HD-720p-3.0Mbps-51412595.mp4?v=0",
						"width": 540
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/42d32d72094645768e4be1af2884a693/42d32d72094645768e4be1af2884a693.m3u8?v=0",
						"width": 810
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Grainy linen-look stripe in striped patterns ¡ª unfussy grace, slow-living texture</p>",
		"url": "/products/milo-linen-blend-striped-custom-curtain",
		"regular_price": "$99.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/striped-curtain",
				"title": "Striped Curtain"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8830937694458,
		"title": "Fiona Linen Blend Custom Curtain",
		"handle": "fiona-linen-blend-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 12% Linen 28% Polyester 60% Viscose<br>Features: Light Filtering<br>Weight: Regular (300g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Tumble Dry</p><p>Do Not Bleach</p><p>Iron At Medium Temperature</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Woven with quiet intricacy, Fiona‘s linen blend brings together layered tones and soft lines¡ªcreating a rich, dimensional surface that¡¯s full of life.</p>",
		"published_at": "2025-06-20T20:05:13+08:00",
		"created_at": "2025-06-11T16:55:58+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"flash_categories",
			"indoor curtain",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat"
		],
		"price": 11200,
		"price_min": 11200,
		"price_max": 11200,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47405353664762,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896879354,
					"product_id": 8830937694458,
					"position": 6,
					"created_at": "2025-06-20T18:56:58+08:00",
					"updated_at": "2025-08-26T16:19:52+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_1.png?v=1756196392",
					"variant_ids": [
						47405353664762
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264188154,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_1.png?v=1756196392"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afiona_cream_1024x1024.jpg?v=1751336378"
			},
			{
				"id": 47405356450042,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896715514,
					"product_id": 8830937694458,
					"position": 11,
					"created_at": "2025-06-20T18:56:57+08:00",
					"updated_at": "2025-08-26T16:19:52+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_2.png?v=1756196392",
					"variant_ids": [
						47405356450042
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264024314,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_2.png?v=1756196392"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afiona_cream_1024x1024.jpg?v=1751336378"
			},
			{
				"id": 47405356548346,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287897698554,
					"product_id": 8830937694458,
					"position": 1,
					"created_at": "2025-06-20T18:57:02+08:00",
					"updated_at": "2025-08-26T16:19:51+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_5.png?v=1756196391",
					"variant_ids": [
						47405356548346
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264384762,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_5.png?v=1756196391"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afiona_sand_1024x1024.jpg?v=1751336378"
			},
			{
				"id": 47405356581114,
				"title": "Pink",
				"option1": "Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-6-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287897010426,
					"product_id": 8830937694458,
					"position": 26,
					"created_at": "2025-06-20T18:57:00+08:00",
					"updated_at": "2025-08-26T16:19:53+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_6.png?v=1756196393",
					"variant_ids": [
						47405356581114
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Pink",
				"public_title": "Pink",
				"options": [
					"Pink"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264286458,
					"position": 26,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_6.png?v=1756196393"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afiona_pink_1024x1024.jpg?v=1751336378"
			},
			{
				"id": 47405356515578,
				"title": "Almond",
				"option1": "Almond",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896912122,
					"product_id": 8830937694458,
					"position": 21,
					"created_at": "2025-06-20T18:56:59+08:00",
					"updated_at": "2025-08-26T16:19:53+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_4.png?v=1756196393",
					"variant_ids": [
						47405356515578
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Almond",
				"public_title": "Almond",
				"options": [
					"Almond"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264220922,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_4.png?v=1756196393"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356712186,
				"title": "Fog",
				"option1": "Fog",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-10-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896781050,
					"product_id": 8830937694458,
					"position": 46,
					"created_at": "2025-06-20T18:56:57+08:00",
					"updated_at": "2025-08-26T16:19:56+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_10.png?v=1756196396",
					"variant_ids": [
						47405356712186
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Fog",
				"public_title": "Fog",
				"options": [
					"Fog"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264122618,
					"position": 46,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_10.png?v=1756196396"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356482810,
				"title": "Oatmeal",
				"option1": "Oatmeal",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896944890,
					"product_id": 8830937694458,
					"position": 16,
					"created_at": "2025-06-20T18:56:59+08:00",
					"updated_at": "2025-08-26T16:19:52+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_3.png?v=1756196392",
					"variant_ids": [
						47405356482810
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Oatmeal",
				"public_title": "Oatmeal",
				"options": [
					"Oatmeal"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264253690,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_3.png?v=1756196392"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356679418,
				"title": "Sea Salt",
				"option1": "Sea Salt",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-9-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896748282,
					"product_id": 8830937694458,
					"position": 41,
					"created_at": "2025-06-20T18:56:57+08:00",
					"updated_at": "2025-08-26T16:19:55+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_9.png?v=1756196395",
					"variant_ids": [
						47405356679418
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Sea Salt",
				"public_title": "Sea Salt",
				"options": [
					"Sea Salt"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264057082,
					"position": 41,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_9.png?v=1756196395"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356744954,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-11-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896813818,
					"product_id": 8830937694458,
					"position": 51,
					"created_at": "2025-06-20T18:56:57+08:00",
					"updated_at": "2025-08-26T16:19:56+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_11.png?v=1756196396",
					"variant_ids": [
						47405356744954
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264089850,
					"position": 51,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_11.png?v=1756196396"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356646650,
				"title": "Sea Foam",
				"option1": "Sea Foam",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-8-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896649978,
					"product_id": 8830937694458,
					"position": 36,
					"created_at": "2025-06-20T18:56:55+08:00",
					"updated_at": "2025-08-26T16:19:55+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_8.png?v=1756196395",
					"variant_ids": [
						47405356646650
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Sea Foam",
				"public_title": "Sea Foam",
				"options": [
					"Sea Foam"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232263958778,
					"position": 36,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_8.png?v=1756196395"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356613882,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-7-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287896846586,
					"product_id": 8830937694458,
					"position": 31,
					"created_at": "2025-06-20T18:56:58+08:00",
					"updated_at": "2025-08-26T16:19:54+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/1_89901_7.png?v=1756196394",
					"variant_ids": [
						47405356613882
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36232264155386,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/1_89901_7.png?v=1756196394"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405356777722,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-89901-12-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44261912543482,
					"product_id": 8830937694458,
					"position": 56,
					"created_at": "2025-06-18T18:38:21+08:00",
					"updated_at": "2025-08-26T16:19:57+08:00",
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/A12.jpg?v=1756196397",
					"variant_ids": [
						47405356777722
					]
				},
				"available": true,
				"name": "Fiona Linen Blend Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Fiona Linen Blend Custom Curtain - TheHues",
					"id": 36215866654970,
					"position": 56,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A12.jpg?v=1756196397"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/1_89901_5.png?v=1756196391",
			"//thehues.com/cdn/shop/files/5_89901_5.png?v=1761272232",
			"//thehues.com/cdn/shop/files/2_89901_5.png?v=1756196391",
			"//thehues.com/cdn/shop/files/3_89901_5.png?v=1756196391",
			"//thehues.com/cdn/shop/files/4_89901_5.png?v=1756196391",
			"//thehues.com/cdn/shop/files/1_89901_1.png?v=1756196392",
			"//thehues.com/cdn/shop/files/2_89901_1.png?v=1756196392",
			"//thehues.com/cdn/shop/files/3_89901_1.png?v=1756196392",
			"//thehues.com/cdn/shop/files/5_89901_1.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_1.png?v=1756196392",
			"//thehues.com/cdn/shop/files/1_89901_2.png?v=1756196392",
			"//thehues.com/cdn/shop/files/2_89901_2.png?v=1756196392",
			"//thehues.com/cdn/shop/files/3_89901_2.png?v=1756196392",
			"//thehues.com/cdn/shop/files/5_89901_2.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_2.png?v=1756196392",
			"//thehues.com/cdn/shop/files/1_89901_3.png?v=1756196392",
			"//thehues.com/cdn/shop/files/2_89901_3.png?v=1756196393",
			"//thehues.com/cdn/shop/files/3_89901_3.png?v=1756196393",
			"//thehues.com/cdn/shop/files/5_89901_3.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_3.png?v=1756196393",
			"//thehues.com/cdn/shop/files/1_89901_4.png?v=1756196393",
			"//thehues.com/cdn/shop/files/2_89901_4.png?v=1756196393",
			"//thehues.com/cdn/shop/files/3_89901_4.png?v=1756196393",
			"//thehues.com/cdn/shop/files/5_89901_4.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_4.png?v=1756196393",
			"//thehues.com/cdn/shop/files/1_89901_6.png?v=1756196393",
			"//thehues.com/cdn/shop/files/2_89901_6.png?v=1756196394",
			"//thehues.com/cdn/shop/files/3_89901_6.png?v=1756196394",
			"//thehues.com/cdn/shop/files/5_89901_6.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_6.png?v=1756196394",
			"//thehues.com/cdn/shop/files/1_89901_7.png?v=1756196394",
			"//thehues.com/cdn/shop/files/2_89901_7.png?v=1756196394",
			"//thehues.com/cdn/shop/files/3_89901_7.png?v=1756196394",
			"//thehues.com/cdn/shop/files/5_89901_7.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_7.png?v=1756196394",
			"//thehues.com/cdn/shop/files/1_89901_8.png?v=1756196395",
			"//thehues.com/cdn/shop/files/2_89901_8.png?v=1756196395",
			"//thehues.com/cdn/shop/files/3_89901_8.png?v=1756196395",
			"//thehues.com/cdn/shop/files/5_89901_8.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_8.png?v=1756196395",
			"//thehues.com/cdn/shop/files/1_89901_9.png?v=1756196395",
			"//thehues.com/cdn/shop/files/2_89901_9.png?v=1756196395",
			"//thehues.com/cdn/shop/files/3_89901_9.png?v=1756196395",
			"//thehues.com/cdn/shop/files/5_89901_9.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_9.png?v=1756196395",
			"//thehues.com/cdn/shop/files/1_89901_10.png?v=1756196396",
			"//thehues.com/cdn/shop/files/2_89901_10.png?v=1756196396",
			"//thehues.com/cdn/shop/files/3_89901_10.png?v=1756196396",
			"//thehues.com/cdn/shop/files/5_89901_10.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_10.png?v=1756196396",
			"//thehues.com/cdn/shop/files/1_89901_11.png?v=1756196396",
			"//thehues.com/cdn/shop/files/2_89901_11.png?v=1756196396",
			"//thehues.com/cdn/shop/files/3_89901_11.png?v=1756196396",
			"//thehues.com/cdn/shop/files/5_89901_11.png?v=1761272232",
			"//thehues.com/cdn/shop/files/4_89901_11.png?v=1756196396",
			"//thehues.com/cdn/shop/files/A12.jpg?v=1756196397",
			"//thehues.com/cdn/shop/files/A89901_2_12-standardv2-2000w.jpg?v=1756196397",
			"//thehues.com/cdn/shop/files/A89901_3_12-standardv2-2000w.jpg?v=1756196397",
			"//thehues.com/cdn/shop/files/A89901_5_12-standardv2-2000w.jpg?v=1756196397",
			"//thehues.com/cdn/shop/files/4_89901_12.png?v=1756196397",
			"//thehues.com/cdn/shop/files/5_89901_12.png?v=1761272232",
			"//thehues.com/cdn/shop/files/3_89901_12.png?v=1756196397",
			"//thehues.com/cdn/shop/files/2_89901_12.png?v=1756196397",
			"//thehues.com/cdn/shop/files/89901_FAMILY.png?v=1756196397"
		],
		"featured_image": "//thehues.com/cdn/shop/files/1_89901_5_1024x1024.png?v=1756196391",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264384762,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_5.png?v=1756196391"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_5.png?v=1756196391",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264319226,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_5.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_5.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268415226,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_5.png?v=1756196391"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_5.png?v=1756196391",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268382458,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_5.png?v=1756196391"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_5.png?v=1756196391",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267694330,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_5.png?v=1756196391"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_5.png?v=1756196391",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264188154,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_1.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_1.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267989242,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_1.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_1.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267890938,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_1.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_1.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263860474,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_1.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_1.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267432186,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_1.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_1.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264024314,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_2.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_2.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267956474,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_2.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_2.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267792634,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_2.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_2.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263729402,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_2.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_2.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267137274,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_2.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_2.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264253690,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_3.png?v=1756196392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_3.png?v=1756196392",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268251386,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_3.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_3.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268120314,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_3.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_3.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263991546,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_3.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_3.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267301114,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_3.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_3.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264220922,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_4.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_4.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267825402,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_4.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_4.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267759866,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_4.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_4.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263794938,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_4.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_4.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267170042,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_4.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_4.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264286458,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_6.png?v=1756196393"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_6.png?v=1756196393",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268447994,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_6.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_6.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268349690,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_6.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_6.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264351994,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_6.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_6.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267464954,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_6.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_6.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264155386,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_7.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_7.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268185850,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_7.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_7.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268022010,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_7.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_7.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263893242,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_7.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_7.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267366650,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_7.png?v=1756196394"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_7.png?v=1756196394",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263958778,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_8.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_8.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267858170,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_8.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_8.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267727098,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_8.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_8.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263762170,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_8.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_8.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267104506,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_8.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_8.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264057082,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_9.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_9.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268153082,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_9.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_9.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267923706,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_9.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_9.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263926010,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_9.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_9.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267202810,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_9.png?v=1756196395"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_9.png?v=1756196395",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264122618,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_10.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_10.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268284154,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_10.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_10.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268087546,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_10.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_10.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263827706,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_10.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_10.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267268346,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_10.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_10.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264089850,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_89901_11.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_89901_11.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268316922,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_11.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_11.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232268054778,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_11.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_11.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232263139578,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_11.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_11.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267235578,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_11.png?v=1756196396"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_11.png?v=1756196396",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36215866654970,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A12.jpg?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A12.jpg?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36168028913914,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A89901_2_12-standardv2-2000w.jpg?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A89901_2_12-standardv2-2000w.jpg?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36168028946682,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A89901_3_12-standardv2-2000w.jpg?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A89901_3_12-standardv2-2000w.jpg?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36168029012218,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A89901_5_12-standardv2-2000w.jpg?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A89901_5_12-standardv2-2000w.jpg?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232264417530,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/4_89901_12.png?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4_89901_12.png?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232262549754,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_89901_12.png?v=1761272232"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_89901_12.png?v=1761272232",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267071738,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_89901_12.png?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_89901_12.png?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232267333882,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_89901_12.png?v=1756196397"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_89901_12.png?v=1756196397",
				"width": 2000
			},
			{
				"alt": "Fiona Linen Blend Custom Curtain - TheHues",
				"id": 36232399585530,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.788,
					"height": 2537,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/89901_FAMILY.png?v=1756196397"
				},
				"aspect_ratio": 0.788,
				"height": 2537,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/89901_FAMILY.png?v=1756196397",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36215577444602,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1920,
					"width": 1536,
					"src": "//thehues.com/cdn/shop/files/preview_images/10cb61e9079341078866d28837a2f184.thumbnail.0000000000.jpg?v=1750240925"
				},
				"aspect_ratio": 0.8,
				"duration": 8570,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/10cb61e9079341078866d28837a2f184/10cb61e9079341078866d28837a2f184.SD-480p-1.5Mbps-49607127.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/10cb61e9079341078866d28837a2f184/10cb61e9079341078866d28837a2f184.HD-1080p-7.2Mbps-49607127.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/10cb61e9079341078866d28837a2f184/10cb61e9079341078866d28837a2f184.HD-720p-4.5Mbps-49607127.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/10cb61e9079341078866d28837a2f184/10cb61e9079341078866d28837a2f184.m3u8?v=0",
						"width": 864
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Woven with quiet intricacy, Fiona‘s linen blend brings together layered tones and soft lines¡ªcreating a rich, dimensional surface that¡¯s full of life.</p>",
		"url": "/products/fiona-linen-blend-custom-curtain",
		"regular_price": "$112.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8879705227514,
		"title": "Cassie Linen Blend Custom Curtains",
		"handle": "cassie-line-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p><strong>Material </strong>8% Linen &amp; 92% Polyester</p><p><strong>Features</strong> Light Filtering</p><p><strong>Weight</strong> Regular (450g/㎡)</p><p><strong>Softness</strong> Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Dive into our vibrant color range (from earthy neutrals to bold accents) and let these easy-to-style drapes add depth to any room – because ordinary is overrated.</p>",
		"published_at": "2025-08-27T16:19:20+08:00",
		"created_at": "2025-08-06T16:44:35+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"flash_categories",
			"indoor curtain",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 9900,
		"price_min": 9900,
		"price_max": 9900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47588143497466,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-0-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015171834,
					"product_id": 8879705227514,
					"position": 1,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-white.jpg?v=1758274105",
					"variant_ids": [
						47588143497466
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633499898,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-white.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-white_1024x1024.jpg?v=1754902178"
			},
			{
				"id": 47588143563002,
				"title": "Oatmeal",
				"option1": "Oatmeal",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015007994,
					"product_id": 8879705227514,
					"position": 11,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-oatmeal.jpg?v=1758274105",
					"variant_ids": [
						47588143563002
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Oatmeal",
				"public_title": "Oatmeal",
				"options": [
					"Oatmeal"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633303290,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-oatmeal.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-oatmeal_1024x1024.jpg?v=1754903031"
			},
			{
				"id": 47588143530234,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015204602,
					"product_id": 8879705227514,
					"position": 6,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-natural.jpg?v=1758274105",
					"variant_ids": [
						47588143530234
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633532666,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-natural.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-natual_1024x1024.jpg?v=1754902997"
			},
			{
				"id": 47588143595770,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015139066,
					"product_id": 8879705227514,
					"position": 16,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-sand.jpg?v=1758274105",
					"variant_ids": [
						47588143595770
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633467130,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-sand.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-sand_1024x1024.jpg?v=1754903447"
			},
			{
				"id": 47588143628538,
				"title": "Tan",
				"option1": "Tan",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-6-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015499514,
					"product_id": 8879705227514,
					"position": 21,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-tan.jpg?v=1758274105",
					"variant_ids": [
						47588143628538
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Tan",
				"public_title": "Tan",
				"options": [
					"Tan"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633827578,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-tan.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-tan_1024x1024.jpg?v=1754903527"
			},
			{
				"id": 47588143661306,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-10-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015302906,
					"product_id": 8879705227514,
					"position": 26,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taupe.jpg?v=1758274105",
					"variant_ids": [
						47588143661306
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633630970,
					"position": 26,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taupe.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-taupe_1024x1024.jpg?v=1754903549"
			},
			{
				"id": 47588143694074,
				"title": "Beige Taupe",
				"option1": "Beige Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-11-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015073530,
					"product_id": 8879705227514,
					"position": 31,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-beigetaupe.jpg?v=1758274105",
					"variant_ids": [
						47588143694074
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Beige Taupe",
				"public_title": "Beige Taupe",
				"options": [
					"Beige Taupe"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633401594,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-beigetaupe.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-beigetaupe_1024x1024.jpg?v=1754903574"
			},
			{
				"id": 47588143726842,
				"title": "Stone",
				"option1": "Stone",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-14-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015237370,
					"product_id": 8879705227514,
					"position": 36,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-stone.jpg?v=1758274105",
					"variant_ids": [
						47588143726842
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Stone",
				"public_title": "Stone",
				"options": [
					"Stone"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633565434,
					"position": 36,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-stone.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-stone_1024x1024.jpg?v=1754903720"
			},
			{
				"id": 47588143759610,
				"title": "Cement",
				"option1": "Cement",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-16-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015335674,
					"product_id": 8879705227514,
					"position": 41,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-cement.jpg?v=1758274105",
					"variant_ids": [
						47588143759610
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Cement",
				"public_title": "Cement",
				"options": [
					"Cement"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633696506,
					"position": 41,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-cement.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-cement_1024x1024.jpg?v=1754904393"
			},
			{
				"id": 47588143792378,
				"title": "Light Grey",
				"option1": "Light Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-17-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015401210,
					"product_id": 8879705227514,
					"position": 46,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-lightgrey.jpg?v=1758274105",
					"variant_ids": [
						47588143792378
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Light Grey",
				"public_title": "Light Grey",
				"options": [
					"Light Grey"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633729274,
					"position": 46,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-lightgrey.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-lightgrey_1024x1024.jpg?v=1754904425"
			},
			{
				"id": 47588143825146,
				"title": "Silver Gray",
				"option1": "Silver Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-18-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015532282,
					"product_id": 8879705227514,
					"position": 101,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:27+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-silvewrbeige.jpg?v=1758274107",
					"variant_ids": [
						47588143825146
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Silver Gray",
				"public_title": "Silver Gray",
				"options": [
					"Silver Gray"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633860346,
					"position": 101,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-silvewrbeige.jpg?v=1758274107"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-silverbeige_1024x1024.jpg?v=1754904450"
			},
			{
				"id": 47588143857914,
				"title": "Pink",
				"option1": "Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-19-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015270138,
					"product_id": 8879705227514,
					"position": 51,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-pink.jpg?v=1758274105",
					"variant_ids": [
						47588143857914
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Pink",
				"public_title": "Pink",
				"options": [
					"Pink"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633598202,
					"position": 51,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-pink.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-pink_1024x1024.jpg?v=1754904481"
			},
			{
				"id": 47588143890682,
				"title": "Taro",
				"option1": "Taro",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-20-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015466746,
					"product_id": 8879705227514,
					"position": 56,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taro.jpg?v=1758274105",
					"variant_ids": [
						47588143890682
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Taro",
				"public_title": "Taro",
				"options": [
					"Taro"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633794810,
					"position": 56,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taro.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-taro_1024x1024.jpg?v=1754904503"
			},
			{
				"id": 47588143923450,
				"title": "Yellow",
				"option1": "Yellow",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH8916-28-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015630586,
					"product_id": 8879705227514,
					"position": 61,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-yellow.jpg?v=1758274105",
					"variant_ids": [
						47588143923450
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Yellow",
				"public_title": "Yellow",
				"options": [
					"Yellow"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633958650,
					"position": 61,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-yellow.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-yellow_1024x1024.jpg?v=1754904525"
			},
			{
				"id": 47588143956218,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH8916-29-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015565050,
					"product_id": 8879705227514,
					"position": 66,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-green.jpg?v=1758274105",
					"variant_ids": [
						47588143956218
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633893114,
					"position": 66,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-green.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-green_1024x1024.jpg?v=1754904546"
			},
			{
				"id": 47588143988986,
				"title": "Sea Green",
				"option1": "Sea Green",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-31-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015597818,
					"product_id": 8879705227514,
					"position": 71,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-seagreen.jpg?v=1758274105",
					"variant_ids": [
						47588143988986
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Sea Green",
				"public_title": "Sea Green",
				"options": [
					"Sea Green"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633925882,
					"position": 71,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-seagreen.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-seagreen_1024x1024.jpg?v=1754904572"
			},
			{
				"id": 47588144021754,
				"title": "Mint",
				"option1": "Mint",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-33-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015368442,
					"product_id": 8879705227514,
					"position": 76,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-mint.jpg?v=1758274105",
					"variant_ids": [
						47588144021754
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Mint",
				"public_title": "Mint",
				"options": [
					"Mint"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633663738,
					"position": 76,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-mint.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-mint_1024x1024.jpg?v=1754904594"
			},
			{
				"id": 47588144054522,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-34-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015106298,
					"product_id": 8879705227514,
					"position": 81,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-teal.jpg?v=1758274105",
					"variant_ids": [
						47588144054522
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633434362,
					"position": 81,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-teal.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-teal_1024x1024.jpg?v=1754904832"
			},
			{
				"id": 47588144087290,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-35-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015433978,
					"product_id": 8879705227514,
					"position": 86,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-blue.jpg?v=1758274105",
					"variant_ids": [
						47588144087290
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633762042,
					"position": 86,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-blue.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-blue_1024x1024.jpg?v=1754904909"
			},
			{
				"id": 47588144120058,
				"title": "Navy",
				"option1": "Navy",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-36-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120015040762,
					"product_id": 8879705227514,
					"position": 91,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-navy.jpg?v=1758274105",
					"variant_ids": [
						47588144120058
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Navy",
				"public_title": "Navy",
				"options": [
					"Navy"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633368826,
					"position": 91,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-navy.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-navy_1024x1024.jpg?v=1754904935"
			},
			{
				"id": 47588144152826,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-MBH9850-37-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45120014975226,
					"product_id": 8879705227514,
					"position": 96,
					"created_at": "2025-09-19T17:10:15+08:00",
					"updated_at": "2025-09-19T17:28:25+08:00",
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-black.jpg?v=1758274105",
					"variant_ids": [
						47588144152826
					]
				},
				"available": true,
				"name": "Cassie Linen Blend Custom Curtains - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 9900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cassie Linen Blend Custom Curtains - TheHues",
					"id": 36840633336058,
					"position": 96,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-black.jpg?v=1758274105"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-color-black_1024x1024.jpg?v=1754905099"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-white.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-2.jpg?v=1758274220",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-6.jpg?v=1758274220",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-5.jpg?v=1758274220",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-natural.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-oatmeal.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal.png?v=1761200281",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-sand.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beige.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-tan.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taupe.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-beigetaupe.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-stone.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-cement.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-lightgrey.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-pink.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taro.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-yellow.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-yellow.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-green.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-4.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-1.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-seagreen.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-mint.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-teal.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-blue.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-navy.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-navy-15.jpg?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-black.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-2.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-6.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-5.jpg?v=1758274105",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black.png?v=1761200162",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-silvewrbeige.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-2.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-6.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-5.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige.png?v=1761200281",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-white.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-natural.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-oatmeal.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-sand.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-tan.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-taupe.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-beigetaupe.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-stone.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-cement.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-lightgrey.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-pink.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-tario.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-yellow.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-green.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-seagreen.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-mint.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-teal.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-blue.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-navy.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-black.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-silverbeige.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/Cassie-custom-curtain-sand-13.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-5.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/Cassie-custom-curtain-teal-13.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-3.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/Cassie-custom-curtain-sand-11.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/Cassie-custom-curtain-teal-11.jpg?v=1758274107",
			"//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy.png?v=1761200162"
		],
		"featured_image": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-white_1024x1024.jpg?v=1758274105",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633499898,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-white.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-white.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666305806586,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008543482,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-2.jpg?v=1758274220"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-2.jpg?v=1758274220",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008674554,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-6.jpg?v=1758274220"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-6.jpg?v=1758274220",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008641786,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-5.jpg?v=1758274220"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-5.jpg?v=1758274220",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633532666,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-natural.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-natural.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005922042,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006053114,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006020346,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307412218,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633303290,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-oatmeal.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-oatmeal.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006315258,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006446330,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006413562,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307248378,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal.png?v=1761200281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal.png?v=1761200281",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633467130,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-sand.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-sand.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006708474,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006839546,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006806778,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666308296954,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beige.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beige.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633827578,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-tan.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-tan.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007494906,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007625978,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007593210,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666308165882,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633630970,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taupe.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taupe.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007888122,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008117498,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008051962,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307543290,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633401594,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-beigetaupe.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-beigetaupe.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004513018,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004644090,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004611322,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307444986,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633565434,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-stone.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-stone.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007298298,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007429370,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007396602,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666306724090,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633696506,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-cement.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-cement.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005102842,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005233914,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005201146,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666303381754,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633729274,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-lightgrey.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-lightgrey.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005496058,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005659898,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005594362,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666304135418,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633598202,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-pink.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-pink.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006511866,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006642938,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006610170,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307510522,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633794810,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taro.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-taro.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007691514,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007822586,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007789818,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307477754,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633958650,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-yellow.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-yellow.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008740090,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008871162,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008838394,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666242564346,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-yellow.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-yellow.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633893114,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-green.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-green.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005364986,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-4.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-4.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005299450,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005266682,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-1.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-1.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307576058,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633925882,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-seagreen.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-seagreen.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006905082,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007036154,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007003386,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666307182842,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633663738,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-mint.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-mint.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005725434,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005856506,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005823738,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666306756858,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633434362,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-teal.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-teal.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008248570,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008477946,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008412410,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666308460794,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633762042,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-blue.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-blue.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004906234,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005037306,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005004538,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666306822394,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633368826,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-navy.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-navy.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006118650,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006249722,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006216954,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666654785786,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-navy-15.jpg?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-navy-15.jpg?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633336058,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-black.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-black.jpg?v=1758274105",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004709626,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-2.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-2.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004840698,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-6.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-6.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004807930,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-5.jpg?v=1758274105"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-5.jpg?v=1758274105",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666299416826,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black.png?v=1761200162",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36840633860346,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-silvewrbeige.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-1-silvewrbeige.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007101690,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-2.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-2.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007232762,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-6.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-6.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007199994,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-5.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-5.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666304790778,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige.png?v=1761200281"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige.png?v=1761200281",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815171322,
				"position": 106,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-white.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-white.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814745338,
				"position": 107,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-natural.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-natural.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814810874,
				"position": 108,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-oatmeal.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-oatmeal.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815073018,
				"position": 109,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-sand.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-sand.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814843642,
				"position": 110,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-tan.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-tan.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814778106,
				"position": 111,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-taupe.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-taupe.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814712570,
				"position": 112,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-beigetaupe.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-beigetaupe.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815007482,
				"position": 113,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-stone.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-stone.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814941946,
				"position": 114,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-cement.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-cement.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815040250,
				"position": 115,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-lightgrey.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-lightgrey.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814909178,
				"position": 116,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-pink.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-pink.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815236858,
				"position": 117,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-tario.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-tario.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815138554,
				"position": 118,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-yellow.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-yellow.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814974714,
				"position": 119,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-green.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-green.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815335162,
				"position": 120,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-seagreen.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-seagreen.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815302394,
				"position": 121,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-mint.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-mint.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815105786,
				"position": 122,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-teal.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-teal.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815269626,
				"position": 123,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-blue.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-blue.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814679802,
				"position": 124,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-navy.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-navy.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665814876410,
				"position": 125,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-black.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-black.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665815204090,
				"position": 126,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-silverbeige.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-curtains-silverbeige.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008772858,
				"position": 127,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-yellow-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006151418,
				"position": 128,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008576250,
				"position": 129,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-white-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005954810,
				"position": 130,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-natural-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006348026,
				"position": 131,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-oatmeal-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665032311034,
				"position": 132,
				"preview_image": {
					"aspect_ratio": 0.754,
					"height": 4338,
					"width": 3269,
					"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-sand-13.jpg?v=1758274107"
				},
				"aspect_ratio": 0.754,
				"height": 4338,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-sand-13.jpg?v=1758274107",
				"width": 3269
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006741242,
				"position": 133,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-sand-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007527674,
				"position": 134,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-tan-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007953658,
				"position": 135,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taupe-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004545786,
				"position": 136,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-beigetaupe-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007331066,
				"position": 137,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-stone-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005135610,
				"position": 138,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-cement-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005528826,
				"position": 139,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-lightgrey-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006544634,
				"position": 140,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-pink-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007724282,
				"position": 141,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-taro-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005397754,
				"position": 142,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-5.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-green-5.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522006937850,
				"position": 143,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-seagreen-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522005758202,
				"position": 144,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-mint-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522008314106,
				"position": 145,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-teal-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665032343802,
				"position": 146,
				"preview_image": {
					"aspect_ratio": 0.828,
					"height": 4683,
					"width": 3876,
					"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-teal-13.jpg?v=1758274107"
				},
				"aspect_ratio": 0.828,
				"height": 4683,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-teal-13.jpg?v=1758274107",
				"width": 3876
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004939002,
				"position": 147,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-blue-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522004742394,
				"position": 148,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-black-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36522007134458,
				"position": 149,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-3.jpg?v=1758274107"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-silverbeige-3.jpg?v=1758274107",
				"width": 2000
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665012551930,
				"position": 150,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-sand-11.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-sand-11.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36665012420858,
				"position": 151,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 1344,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-teal-11.jpg?v=1758274107"
				},
				"aspect_ratio": 0.667,
				"height": 1344,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cassie-custom-curtain-teal-11.jpg?v=1758274107",
				"width": 896
			},
			{
				"alt": "Cassie Linen Blend Custom Curtains - TheHues",
				"id": 36666306789626,
				"position": 152,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy.png?v=1761200162"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cassie-linen-blend-custom-curtains-navy.png?v=1761200162",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Dive into our vibrant color range (from earthy neutrals to bold accents) and let these easy-to-style drapes add depth to any room – because ordinary is overrated.</p>",
		"url": "/products/cassie-line-custom-curtain",
		"regular_price": "$99.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780126552314,
		"title": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain",
		"handle": "kensington-100-blackout-oeko-linen-look-smooth-lightweight-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 100% Polyester<br>Features: OEKO-TEX Certified Safe Fabric<br>Weight: Regular (275g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning</p></div>`,
		"description": "<p>Kensington combines the timeless elegance of a linen look with the practicality of 100% blackout curtains.</p>",
		"published_at": "2025-05-07T16:32:30+08:00",
		"created_at": "2025-05-07T16:32:30+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout",
			"Blackout pro Curtain",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains",
			"Custom Blackout Curtains > Blackout Curtains",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search blackout",
			"Search curtains",
			"Search Pinch pleat",
			"Soundproof & Blackout Curtains"
		],
		"price": 13500,
		"price_min": 13500,
		"price_max": 13500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319437213946,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1320-SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44259151249658,
					"product_id": 8780126552314,
					"position": 13,
					"created_at": "2025-06-18T09:33:51+08:00",
					"updated_at": "2025-10-09T14:01:52+08:00",
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Bedroom.jpg?v=1759989712",
					"variant_ids": [
						47319437213946
					]
				},
				"available": true,
				"name": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 13500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"id": 36214325674234,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Bedroom.jpg?v=1759989712"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Akensington_grey_1024x1024.png?v=1751278745"
			},
			{
				"id": 47319437115642,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-1320-SD-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44259151184122,
					"product_id": 8780126552314,
					"position": 1,
					"created_at": "2025-06-18T09:33:51+08:00",
					"updated_at": "2025-10-09T14:01:52+08:00",
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Bedroom.jpg?v=1759989712",
					"variant_ids": [
						47319437115642
					]
				},
				"available": true,
				"name": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 13500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"id": 36214325608698,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Bedroom.jpg?v=1759989712"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Akensington_brown_1024x1024.png?v=1751278745"
			},
			{
				"id": 47319437148410,
				"title": "Terracotta",
				"option1": "Terracotta",
				"option2": null,
				"option3": null,
				"sku": "THC-1320-SD-Terracotta",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44259151053050,
					"product_id": 8780126552314,
					"position": 5,
					"created_at": "2025-06-18T09:33:52+08:00",
					"updated_at": "2025-10-09T14:01:52+08:00",
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Bedroom.jpg?v=1759989712",
					"variant_ids": [
						47319437148410
					]
				},
				"available": true,
				"name": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - Terracotta",
				"public_title": "Terracotta",
				"options": [
					"Terracotta"
				],
				"price": 13500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"id": 36214325739770,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Bedroom.jpg?v=1759989712"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Akensington_terracotta_1024x1024.png?v=1751278745"
			},
			{
				"id": 47319437181178,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-1320-SD-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44259151151354,
					"product_id": 8780126552314,
					"position": 9,
					"created_at": "2025-06-18T09:33:51+08:00",
					"updated_at": "2025-10-09T14:01:52+08:00",
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Bedroom.jpg?v=1759989712",
					"variant_ids": [
						47319437181178
					]
				},
				"available": true,
				"name": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 13500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"id": 36214325707002,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Bedroom.jpg?v=1759989712"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Akensington_sand_1024x1024.png?v=1751278745"
			},
			{
				"id": 47319437246714,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-1320-SD-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44259151085818,
					"product_id": 8780126552314,
					"position": 17,
					"created_at": "2025-06-18T09:33:51+08:00",
					"updated_at": "2025-10-09T14:01:52+08:00",
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Bedroom.jpg?v=1759989712",
					"variant_ids": [
						47319437246714
					]
				},
				"available": true,
				"name": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 13500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
					"id": 36214325641466,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Bedroom.jpg?v=1759989712"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Bedroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Close-up.jpg?v=1761275846",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Livingroom.jpg?v=1761275846",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Fabric_Details.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Bedroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Livingroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Close-up.jpg?v=1761205021",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Fabric_Details.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Bedroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Livingroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Close-up.jpg?v=1761205021",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Fabric_Details.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Bedroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Livingroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Close-up.jpg?v=1761205021",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Fabric_Details.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Bedroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Livingroom.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Close-up.jpg?v=1761205021",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Fabric_Details.jpg?v=1759989712",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Modern_Living_Room.jpg?v=1756196691",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Modern_Bedroom.jpg?v=1756196691",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Modern_Bedroom.jpg?v=1756196691",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Modern_Living_Room.jpg?v=1756196692",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Modern_Living_Room.jpg?v=1756196692",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Modern_Bedroom.jpg?v=1756196692",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Modern_Bedroom.jpg?v=1756196692",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Modern_Living_Room.jpg?v=1756196692",
			"//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Modern_Bedroom.jpg?v=1756196692"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Bedroom_1024x1024.jpg?v=1759989712",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325608698,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Bedroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Bedroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36076589875450,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Close-up.jpg?v=1761275846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Close-up.jpg?v=1761275846",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325772538,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Livingroom.jpg?v=1761275846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Livingroom.jpg?v=1761275846",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616512250,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Fabric_Details.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Fabric_Details.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325739770,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Bedroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Bedroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325903610,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Livingroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Livingroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617298682,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Close-up.jpg?v=1761205021"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Close-up.jpg?v=1761205021",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617265914,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Fabric_Details.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Fabric_Details.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325707002,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Bedroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Bedroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325870842,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Livingroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Livingroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617069306,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Close-up.jpg?v=1761205021"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Close-up.jpg?v=1761205021",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617003770,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Fabric_Details.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Fabric_Details.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325674234,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Bedroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Bedroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325838074,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Livingroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Livingroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616839930,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Close-up.jpg?v=1761205021"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Close-up.jpg?v=1761205021",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616872698,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Fabric_Details.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Fabric_Details.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325641466,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Bedroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Bedroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36214325805306,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Livingroom.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Livingroom.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616676090,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Close-up.jpg?v=1761205021"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Close-up.jpg?v=1761205021",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616577786,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Fabric_Details.jpg?v=1759989712"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Fabric_Details.jpg?v=1759989712",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616774394,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Modern_Living_Room.jpg?v=1756196691"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Modern_Living_Room.jpg?v=1756196691",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616479482,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Modern_Bedroom.jpg?v=1756196691"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Brown_Modern_Bedroom.jpg?v=1756196691",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617233146,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Modern_Bedroom.jpg?v=1756196691"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Modern_Bedroom.jpg?v=1756196691",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617200378,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Modern_Living_Room.jpg?v=1756196692"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Terracotta_Modern_Living_Room.jpg?v=1756196692",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617102074,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Modern_Living_Room.jpg?v=1756196692"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Modern_Living_Room.jpg?v=1756196692",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071617036538,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Modern_Bedroom.jpg?v=1756196692"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Sand_Modern_Bedroom.jpg?v=1756196692",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616807162,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Modern_Bedroom.jpg?v=1756196692"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Grey_Modern_Bedroom.jpg?v=1756196692",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616610554,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Modern_Living_Room.jpg?v=1756196692"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Modern_Living_Room.jpg?v=1756196692",
				"width": 2000
			},
			{
				"alt": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain - TheHues",
				"id": 36071616643322,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Modern_Bedroom.jpg?v=1756196692"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Kensington_Linen_Look_Custom_Curtain_Cream_Modern_Bedroom.jpg?v=1756196692",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Kensington combines the timeless elegance of a linen look with the practicality of 100% blackout curtains.</p>",
		"url": "/products/kensington-100-blackout-oeko-linen-look-smooth-lightweight-custom-curtain",
		"regular_price": "$135.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-blackout-curtains",
				"title": "Advert Blackout Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-curtains",
				"title": "Blackout Curtains"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8780122783994,
		"title": "Silhouette Linen Blend Woven Sheer Custom Curtain",
		"handle": "silhouette-linen-blend-woven-sheer-custom-curtain",
		"product_details": `<div class="metafield-rich_text_field"><h3>Specifications</h3><p>Material: 52% Polyester &amp; 48% Linen<br>Features: Unique Linen Sheer Fabric<br>Weight: Sheer (150g/㎡)Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Safe to Iron</p><p>Dry Clean Allowed</p></div>`,
		"description": "<p>With its delicate sheerness, the Silhouette Curtain offers both privacy and a peaceful atmosphere, transforming your room into a sanctuary of quiet elegance.</p>",
		"published_at": "2025-05-07T16:30:28+08:00",
		"created_at": "2025-05-07T16:30:28+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > New Sheer Curtains",
			"All Curtains > pinch pleat custom curtains",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"Easter Sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search sheer",
			"Summer"
		],
		"price": 11700,
		"price_min": 11700,
		"price_max": 11700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319406346490,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-FT010-C-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44016289120506,
					"product_id": 8780122783994,
					"position": 1,
					"created_at": "2025-05-20T14:03:31+08:00",
					"updated_at": "2025-08-26T16:27:53+08:00",
					"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-1_1__resolution-standardv2-2x.jpg?v=1756196873",
					"variant_ids": [
						47319406346490
					]
				},
				"available": true,
				"name": "Silhouette Linen Blend Woven Sheer Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
					"id": 36058805371130,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Aivory-1_1__resolution-standardv2-2x.jpg?v=1756196873"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250515-Aivory-7_3__resolution-standardv2-2x_1024x1024.jpg?v=1761213678"
			},
			{
				"id": 47319406412026,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-FT010-C-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44016289906938,
					"product_id": 8780122783994,
					"position": 12,
					"created_at": "2025-05-20T14:03:36+08:00",
					"updated_at": "2025-08-26T16:27:54+08:00",
					"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg?v=1756196874",
					"variant_ids": [
						47319406412026
					]
				},
				"available": true,
				"name": "Silhouette Linen Blend Woven Sheer Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
					"id": 36058805862650,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg?v=1756196874"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250515-Asand-6_4__resolution-standardv2-2x_1024x1024.jpg?v=1756196875"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250515-Aivory-1_1__resolution-standardv2-2x.jpg?v=1756196873",
			"//thehues.com/cdn/shop/files/20250515-Aivory-1_7__resolution-standardv2-2x.jpg?v=1756196873",
			"//thehues.com/cdn/shop/files/20250515-Aivory-2_2__resolution-standardv2-2x.jpg?v=1756196873",
			"//thehues.com/cdn/shop/files/20250515-Aivory-7_3__resolution-standardv2-2x.jpg?v=1761213678",
			"//thehues.com/cdn/shop/files/20250515-Aivory-2_6__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Awhite-1_1__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Awhite-1_7__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Awhite-5_5__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Awhite-2_6__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Awhite-6_4__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Awhite-7_3__resolution-standardv2-2x.jpg?v=1761213678",
			"//thehues.com/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Asand-1_1__resolution-standardv2-2x.jpg?v=1756196874",
			"//thehues.com/cdn/shop/files/20250515-Asand-7_3__resolution-standardv2-2x.jpg?v=1761213678",
			"//thehues.com/cdn/shop/files/20250515-Asand-2_6__resolution-standardv2-2x.jpg?v=1756196875",
			"//thehues.com/cdn/shop/files/20250515-Asand-5_5__resolution-standardv2-2x.jpg?v=1756196875",
			"//thehues.com/cdn/shop/files/20250515-Asand-6_4__resolution-standardv2-2x.jpg?v=1756196875",
			"//thehues.com/cdn/shop/files/20250515-Asand-1_7__resolution-standardv2-2x.jpg?v=1756196875"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250515-Aivory-1_1__resolution-standardv2-2x_1024x1024.jpg?v=1756196873",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805371130,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-1_1__resolution-standardv2-2x.jpg?v=1756196873"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aivory-1_1__resolution-standardv2-2x.jpg?v=1756196873",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805403898,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-1_7__resolution-standardv2-2x.jpg?v=1756196873"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aivory-1_7__resolution-standardv2-2x.jpg?v=1756196873",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805272826,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_2__resolution-standardv2-2x.jpg?v=1756196873"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_2__resolution-standardv2-2x.jpg?v=1756196873",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805338362,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-7_3__resolution-standardv2-2x.jpg?v=1761213678"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aivory-7_3__resolution-standardv2-2x.jpg?v=1761213678",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805305594,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_6__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_6__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805469434,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-1_1__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-1_1__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805502202,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-1_7__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-1_7__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805567738,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-5_5__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-5_5__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805534970,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-2_6__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-2_6__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805600506,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-6_4__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-6_4__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805633274,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7_3__resolution-standardv2-2x.jpg?v=1761213678"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7_3__resolution-standardv2-2x.jpg?v=1761213678",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805862650,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805666042,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asand-1_1__resolution-standardv2-2x.jpg?v=1756196874"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asand-1_1__resolution-standardv2-2x.jpg?v=1756196874",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805829882,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asand-7_3__resolution-standardv2-2x.jpg?v=1761213678"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asand-7_3__resolution-standardv2-2x.jpg?v=1761213678",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805731578,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asand-2_6__resolution-standardv2-2x.jpg?v=1756196875"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asand-2_6__resolution-standardv2-2x.jpg?v=1756196875",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805764346,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asand-5_5__resolution-standardv2-2x.jpg?v=1756196875"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asand-5_5__resolution-standardv2-2x.jpg?v=1756196875",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805797114,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asand-6_4__resolution-standardv2-2x.jpg?v=1756196875"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asand-6_4__resolution-standardv2-2x.jpg?v=1756196875",
				"width": 2000
			},
			{
				"alt": "Silhouette Linen Blend Woven Sheer Custom Curtain - TheHues",
				"id": 36058805698810,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Asand-1_7__resolution-standardv2-2x.jpg?v=1756196875"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Asand-1_7__resolution-standardv2-2x.jpg?v=1756196875",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36099004793082,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/2a89bf2d244d4b1a9c5d403279a4326e.thumbnail.0000000000.jpg?v=1748413025"
				},
				"aspect_ratio": 0.563,
				"duration": 15000,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2a89bf2d244d4b1a9c5d403279a4326e/2a89bf2d244d4b1a9c5d403279a4326e.SD-480p-0.9Mbps-48362495.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2a89bf2d244d4b1a9c5d403279a4326e/2a89bf2d244d4b1a9c5d403279a4326e.HD-1080p-2.5Mbps-48362495.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2a89bf2d244d4b1a9c5d403279a4326e/2a89bf2d244d4b1a9c5d403279a4326e.HD-720p-1.6Mbps-48362495.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2a89bf2d244d4b1a9c5d403279a4326e/2a89bf2d244d4b1a9c5d403279a4326e.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With its delicate sheerness, the Silhouette Curtain offers both privacy and a peaceful atmosphere, transforming your room into a sanctuary of quiet elegance.</p>",
		"url": "/products/silhouette-linen-blend-woven-sheer-custom-curtain",
		"regular_price": "$117.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780129730810,
		"title": "Breeze Linen Blend Custom Curtain",
		"handle": "breeze-linen-blend-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Materia: 20% Linen &amp; 80% Polyester<br>Features: Light Filtering<br>Weight: Regular (280g/㎡)<br>Softness: Soft</p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p>`,
		"description": "<p>A whisper of linen, a breath of air¡ªBreeze¡¯s gentle transparency and timeless feel make it a subtle anchor for any space.</p>",
		"published_at": "2025-05-07T16:34:03+08:00",
		"created_at": "2025-05-07T16:34:03+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"sale top 10",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer Collection",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 11200,
		"price_min": 11200,
		"price_max": 11200,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319462183162,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH10381-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246068691194,
					"product_id": 8780129730810,
					"position": 36,
					"created_at": "2025-06-17T15:35:13+08:00",
					"updated_at": "2025-08-26T16:23:41+08:00",
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2breeze_beige.jpg?v=1756196621",
					"variant_ids": [
						47319462183162
					]
				},
				"available": true,
				"name": "Breeze Linen Blend Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"id": 36206940848378,
					"position": 36,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2breeze_beige.jpg?v=1756196621"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abreeze_beige_1024x1024.jpg?v=1751278021"
			},
			{
				"id": 47319462117626,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-LHA1801-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246068625658,
					"product_id": 8780129730810,
					"position": 29,
					"created_at": "2025-06-17T15:35:14+08:00",
					"updated_at": "2025-08-26T16:23:41+08:00",
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2breeze_sand.jpg?v=1756196621",
					"variant_ids": [
						47319462117626
					]
				},
				"available": true,
				"name": "Breeze Linen Blend Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"id": 36206940979450,
					"position": 29,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2breeze_sand.jpg?v=1756196621"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abreeze_sand_1024x1024.jpg?v=1751278021"
			},
			{
				"id": 47319462150394,
				"title": "Sage",
				"option1": "Sage",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH10381-10-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246068789498,
					"product_id": 8780129730810,
					"position": 22,
					"created_at": "2025-06-17T15:35:14+08:00",
					"updated_at": "2025-08-26T16:23:40+08:00",
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2breeze_sage.jpg?v=1756196620",
					"variant_ids": [
						47319462150394
					]
				},
				"available": true,
				"name": "Breeze Linen Blend Custom Curtain - Sage",
				"public_title": "Sage",
				"options": [
					"Sage"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"id": 36206940946682,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2breeze_sage.jpg?v=1756196620"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abreeze_sage_1024x1024.jpg?v=1751278021"
			},
			{
				"id": 47319462215930,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH10381-19-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246068822266,
					"product_id": 8780129730810,
					"position": 9,
					"created_at": "2025-06-17T15:35:14+08:00",
					"updated_at": "2025-08-26T16:23:39+08:00",
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2breeze_green.jpg?v=1756196619",
					"variant_ids": [
						47319462215930
					]
				},
				"available": true,
				"name": "Breeze Linen Blend Custom Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"id": 36206940881146,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2breeze_green.jpg?v=1756196619"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abreeze_green_1024x1024.jpg?v=1751278021"
			},
			{
				"id": 47319462248698,
				"title": "Navy",
				"option1": "Navy",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH10381-28-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246068658426,
					"product_id": 8780129730810,
					"position": 15,
					"created_at": "2025-06-17T15:35:14+08:00",
					"updated_at": "2025-08-26T16:23:39+08:00",
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2breeze_NAVY.jpg?v=1756196619",
					"variant_ids": [
						47319462248698
					]
				},
				"available": true,
				"name": "Breeze Linen Blend Custom Curtain - Navy",
				"public_title": "Navy",
				"options": [
					"Navy"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Breeze Linen Blend Custom Curtain - TheHues",
					"id": 36206940913914,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2breeze_NAVY.jpg?v=1756196619"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02312copy2_resolution-standardv2-2x.jpg?v=1756196618",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18043copy_resolution-standardv2-2x.jpg?v=1756196618",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02291copy2_resolution-standardv2-2x.jpg?v=1756196618",
			"//thehues.com/cdn/shop/files/beige2.jpg?v=1756196618",
			"//thehues.com/cdn/shop/files/beige.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02284copy2_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18042copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18041copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/2breeze_green.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/breeze_green.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18051copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18052copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18053copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18051copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/2breeze_NAVY.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/breeze_navy.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18061copy_resolution-standardv2-2x.jpg?v=1756196619",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18062copy_resolution-standardv2-2x.jpg?v=1761204151",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18062copy_resolution-standardv2-2x.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18063copy_resolution-standardv2-2x.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18061copy_resolution-standardv2-2x.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/2breeze_sage.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/breeze_sage.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18031copy_resolution-standardv2-2x.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18032copy_resolution-standardv2-2x.jpg?v=1761204151",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18032copy_resolution-standardv2-2x.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18033copy_resolution-standardv2-2x.jpg?v=1756196620",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18031copy_resolution-standardv2-2x.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/2breeze_sand.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/breeze_sand.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18011copy_resolution-standardv2-2x.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18012copy_resolution-standardv2-2x.jpg?v=1761204151",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18012copy_resolution-standardv2-2x.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18013copy_resolution-standardv2-2x.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18011copy_resolution-standardv2-2x.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/2breeze_beige.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/breeze_beige.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18041copy_resolution-standardv2-2x.jpg?v=1756196621",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18042copy_resolution-standardv2-2x.jpg?v=1761204151",
			"//thehues.com/cdn/shop/files/image1.jpg?v=1756196622",
			"//thehues.com/cdn/shop/files/20250522-20250520-A1801__resolution-standardv2-2x.jpg?v=1756196622",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02294copy2_resolution-standardv2-2x.jpg?v=1756196622",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02306copy2_resolution-standardv2-2x.jpg?v=1756196622",
			"//thehues.com/cdn/shop/files/20250522-20250520-A1806copy_resolution-standardv2-2x.jpg?v=1756196622",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18052copy_resolution-standardv2-2x.jpg?v=1761204151",
			"//thehues.com/cdn/shop/files/20250522-20250520-A1805copy_resolution-standardv2-2x.jpg?v=1756196622",
			"//thehues.com/cdn/shop/files/20250522-20250520-A1803__resolution-standardv2-2x.jpg?v=1756196622"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02312copy2_resolution-standardv2-2x_1024x1024.jpg?v=1756196618",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799030010,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02312copy2_resolution-standardv2-2x.jpg?v=1756196618"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02312copy2_resolution-standardv2-2x.jpg?v=1756196618",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071789068538,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18043copy_resolution-standardv2-2x.jpg?v=1756196618"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18043copy_resolution-standardv2-2x.jpg?v=1756196618",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799095546,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02291copy2_resolution-standardv2-2x.jpg?v=1756196618"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02291copy2_resolution-standardv2-2x.jpg?v=1756196618",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36296662843642,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/beige2.jpg?v=1756196618"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/beige2.jpg?v=1756196618",
				"width": 1638
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36296662778106,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/beige.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/beige.jpg?v=1756196619",
				"width": 1638
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799062778,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02284copy2_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02284copy2_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071789035770,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18042copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18042copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071789003002,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18041copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18041copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206940881146,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2breeze_green.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2breeze_green.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206941044986,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/breeze_green.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/breeze_green.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799521530,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18051copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18051copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799455994,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18052copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18052copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799488762,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18053copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18053copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799423226,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18051copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18051copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206940913914,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2breeze_NAVY.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2breeze_NAVY.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206941077754,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/breeze_navy.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/breeze_navy.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799324922,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18061copy_resolution-standardv2-2x.jpg?v=1756196619"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18061copy_resolution-standardv2-2x.jpg?v=1756196619",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799357690,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18062copy_resolution-standardv2-2x.jpg?v=1761204151"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18062copy_resolution-standardv2-2x.jpg?v=1761204151",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799259386,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18062copy_resolution-standardv2-2x.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18062copy_resolution-standardv2-2x.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799292154,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18063copy_resolution-standardv2-2x.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18063copy_resolution-standardv2-2x.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799226618,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18061copy_resolution-standardv2-2x.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18061copy_resolution-standardv2-2x.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206940946682,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2breeze_sage.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2breeze_sage.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206941110522,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/breeze_sage.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/breeze_sage.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799718138,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18031copy_resolution-standardv2-2x.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18031copy_resolution-standardv2-2x.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799750906,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18032copy_resolution-standardv2-2x.jpg?v=1761204151"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18032copy_resolution-standardv2-2x.jpg?v=1761204151",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799652602,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18032copy_resolution-standardv2-2x.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18032copy_resolution-standardv2-2x.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799685370,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18033copy_resolution-standardv2-2x.jpg?v=1756196620"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18033copy_resolution-standardv2-2x.jpg?v=1756196620",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799619834,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18031copy_resolution-standardv2-2x.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-LHA18031copy_resolution-standardv2-2x.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206940979450,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2breeze_sand.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2breeze_sand.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206941143290,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/breeze_sand.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/breeze_sand.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798833402,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18011copy_resolution-standardv2-2x.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18011copy_resolution-standardv2-2x.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798866170,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18012copy_resolution-standardv2-2x.jpg?v=1761204151"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18012copy_resolution-standardv2-2x.jpg?v=1761204151",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798767866,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18012copy_resolution-standardv2-2x.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18012copy_resolution-standardv2-2x.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798800634,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18013copy_resolution-standardv2-2x.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18013copy_resolution-standardv2-2x.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798931706,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18011copy_resolution-standardv2-2x.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA_LHA18011copy_resolution-standardv2-2x.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206940848378,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2breeze_beige.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2breeze_beige.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36206941012218,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/breeze_beige.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/breeze_beige.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071789101306,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18041copy_resolution-standardv2-2x.jpg?v=1756196621"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18041copy_resolution-standardv2-2x.jpg?v=1756196621",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071789134074,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18042copy_resolution-standardv2-2x.jpg?v=1761204151"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18042copy_resolution-standardv2-2x.jpg?v=1761204151",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798505722,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/image1.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image1.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071798898938,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1801__resolution-standardv2-2x.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1801__resolution-standardv2-2x.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799128314,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02294copy2_resolution-standardv2-2x.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02294copy2_resolution-standardv2-2x.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799161082,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02306copy2_resolution-standardv2-2x.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02306copy2_resolution-standardv2-2x.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799390458,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1806copy_resolution-standardv2-2x.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1806copy_resolution-standardv2-2x.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799554298,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18052copy_resolution-standardv2-2x.jpg?v=1761204151"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18052copy_resolution-standardv2-2x.jpg?v=1761204151",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799587066,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1805copy_resolution-standardv2-2x.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1805copy_resolution-standardv2-2x.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": "Breeze Linen Blend Custom Curtain - TheHues",
				"id": 36071799783674,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1803__resolution-standardv2-2x.jpg?v=1756196622"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A1803__resolution-standardv2-2x.jpg?v=1756196622",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36133926600954,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1080,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/fb9d5d85f27f40699029305075abaa48.thumbnail.0000000000.jpg?v=1749095454"
				},
				"aspect_ratio": 1,
				"duration": 7760,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/fb9d5d85f27f40699029305075abaa48/fb9d5d85f27f40699029305075abaa48.SD-480p-1.5Mbps-48848833.mp4?v=0",
						"width": 480
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/fb9d5d85f27f40699029305075abaa48/fb9d5d85f27f40699029305075abaa48.HD-1080p-7.2Mbps-48848833.mp4?v=0",
						"width": 1080
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/fb9d5d85f27f40699029305075abaa48/fb9d5d85f27f40699029305075abaa48.HD-720p-4.5Mbps-48848833.mp4?v=0",
						"width": 720
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/fb9d5d85f27f40699029305075abaa48/fb9d5d85f27f40699029305075abaa48.m3u8?v=0",
						"width": 1080
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>A whisper of linen, a breath of air¡ªBreeze¡¯s gentle transparency and timeless feel make it a subtle anchor for any space.</p>",
		"url": "/products/breeze-linen-blend-custom-curtain",
		"regular_price": "$112.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780122849530,
		"title": "Haze Linen Blend Golden Threads Textured Custom Curtain",
		"handle": "haze-linen-blend-golden-threads-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 90% Polyester &amp; 5% Linen 5% Acrylic<br>Features: Unique Textured Fabric<br>Weight: Heavy Weight (385g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Dry wash only</p><p>Do Not Dry</p><p>Do not bleach</p><p>Safe to Iron</p><p>Dry Clean Allowed</p>`,
		"description": "<p>The Haze linen blend envelops your room in a delicate, airy embrace, its textured surface creating a soft, ethereal atmosphere. Perfect for those seeking tranquility, this fabric adds a whisper of nature's charm to any setting.</p>",
		"published_at": "2025-05-07T16:30:29+08:00",
		"created_at": "2025-05-07T16:30:29+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > Solid Curtains",
			"All Curtains > Textured Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Extra 10%",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat"
		],
		"price": 10800,
		"price_min": 10800,
		"price_max": 10800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319445438714,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-AN050-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037104369914,
					"product_id": 8780122849530,
					"position": 1,
					"created_at": "2025-05-22T17:30:31+08:00",
					"updated_at": "2025-08-26T16:27:48+08:00",
					"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240522-ACream-1-2-1_resolution-standardv2-2x.jpg?v=1756196868",
					"variant_ids": [
						47319445438714
					]
				},
				"available": true,
				"name": "Haze Linen Blend Golden Threads Textured Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
					"id": 36071360692474,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240522-ACream-1-2-1_resolution-standardv2-2x.jpg?v=1756196868"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-AHaze-display_resolution-standardv2-2x_1024x1024.jpg?v=1761275423"
			},
			{
				"id": 47319445471482,
				"title": "Oatmeal",
				"option1": "Oatmeal",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-AN050-C-Oatmeal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037105484026,
					"product_id": 8780122849530,
					"position": 9,
					"created_at": "2025-05-22T17:30:42+08:00",
					"updated_at": "2025-08-26T16:27:49+08:00",
					"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-1-2_resolution-standardv2-2x.jpg?v=1756196869",
					"variant_ids": [
						47319445471482
					]
				},
				"available": true,
				"name": "Haze Linen Blend Golden Threads Textured Custom Curtain - Oatmeal",
				"public_title": "Oatmeal",
				"options": [
					"Oatmeal"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
					"id": 36071361151226,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-1-2_resolution-standardv2-2x.jpg?v=1756196869"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-Aoatmeal_resolution-standardv2-2x_1024x1024.jpg?v=1761275423"
			},
			{
				"id": 47319445504250,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-AN050-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037102993658,
					"product_id": 8780122849530,
					"position": 17,
					"created_at": "2025-05-22T17:30:10+08:00",
					"updated_at": "2025-10-24T11:10:23+08:00",
					"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250208-Ablack-1_resolution-standardv2-2x.jpg?v=1761275423",
					"variant_ids": [
						47319445504250
					]
				},
				"available": true,
				"name": "Haze Linen Blend Golden Threads Textured Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
					"id": 36071360004346,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250208-Ablack-1_resolution-standardv2-2x.jpg?v=1761275423"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-Ablack-1_resolution-standardv2-2x_1024x1024.jpg?v=1761275423"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240522-ACream-1-2-1_resolution-standardv2-2x.jpg?v=1756196868",
			"//thehues.com/cdn/shop/files/20240522-ACream-5-2_resolution-standardv2-2x.jpg?v=1756196868",
			"//thehues.com/cdn/shop/files/20240522-ACream-3-2-1_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20250208-ACream-2-2_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20250208-ACream-3-1-1_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20250208-ACream-1-2-1_resolution-standardv2-2x-2.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20240522-ACream-4-2-1_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20250208-AHaze-display_resolution-standardv2-2x.jpg?v=1761275423",
			"//thehues.com/cdn/shop/files/20240522-Aoatmeal-1-2_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20240522-Aoatmeal-3-2_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20250208-Aoatmeal-3-1-2_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20240522-Aoatmeal-5-2_resolution-standardv2-2x.jpg?v=1756196869",
			"//thehues.com/cdn/shop/files/20250208-Aoatmeal-2-2_resolution-standardv2-2x.jpg?v=1756196870",
			"//thehues.com/cdn/shop/files/20240522-Aoatmeal-4-2_resolution-standardv2-2x.jpg?v=1756196870",
			"//thehues.com/cdn/shop/files/20250208-Aoatmeal-1-2_resolution-standardv2-2x-2.jpg?v=1756196870",
			"//thehues.com/cdn/shop/files/20250208-Aoatmeal_resolution-standardv2-2x.jpg?v=1761275423",
			"//thehues.com/cdn/shop/files/20250208-Ablack-1_resolution-standardv2-2x.jpg?v=1761275423"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240522-ACream-1-2-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196868",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360692474,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-ACream-1-2-1_resolution-standardv2-2x.jpg?v=1756196868"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-ACream-1-2-1_resolution-standardv2-2x.jpg?v=1756196868",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360790778,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-ACream-5-2_resolution-standardv2-2x.jpg?v=1756196868"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-ACream-5-2_resolution-standardv2-2x.jpg?v=1756196868",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360725242,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-ACream-3-2-1_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-ACream-3-2-1_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360594170,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACream-2-2_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACream-2-2_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360626938,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACream-3-1-1_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACream-3-1-1_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360561402,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACream-1-2-1_resolution-standardv2-2x-2.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACream-1-2-1_resolution-standardv2-2x-2.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360758010,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-ACream-4-2-1_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-ACream-4-2-1_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360659706,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-AHaze-display_resolution-standardv2-2x.jpg?v=1761275423"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-AHaze-display_resolution-standardv2-2x.jpg?v=1761275423",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361151226,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-1-2_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-1-2_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361183994,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-3-2_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-3-2_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361413370,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal-3-1-2_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal-3-1-2_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361249530,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-5-2_resolution-standardv2-2x.jpg?v=1756196869"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-5-2_resolution-standardv2-2x.jpg?v=1756196869",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361380602,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal-2-2_resolution-standardv2-2x.jpg?v=1756196870"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal-2-2_resolution-standardv2-2x.jpg?v=1756196870",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361216762,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-4-2_resolution-standardv2-2x.jpg?v=1756196870"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-Aoatmeal-4-2_resolution-standardv2-2x.jpg?v=1756196870",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361347834,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal-1-2_resolution-standardv2-2x-2.jpg?v=1756196870"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal-1-2_resolution-standardv2-2x-2.jpg?v=1756196870",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071361282298,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal_resolution-standardv2-2x.jpg?v=1761275423"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-Aoatmeal_resolution-standardv2-2x.jpg?v=1761275423",
				"width": 1999
			},
			{
				"alt": "Haze Linen Blend Golden Threads Textured Custom Curtain - TheHues",
				"id": 36071360004346,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-Ablack-1_resolution-standardv2-2x.jpg?v=1761275423"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-Ablack-1_resolution-standardv2-2x.jpg?v=1761275423",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Haze linen blend envelops your room in a delicate, airy embrace, its textured surface creating a soft, ethereal atmosphere. Perfect for those seeking tranquility, this fabric adds a whisper of nature's charm to any setting.</p>",
		"url": "/products/haze-linen-blend-golden-threads-textured-custom-curtain",
		"regular_price": "$108.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			}
		]
	},
	{
		"id": 8780124389626,
		"title": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain",
		"handle": "ivy-linen-look-heavyweight-herringbone-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 82% Polyester &amp; 18%Viscose<br>Features: Unique Textured Fabric<br>Weight: Heavy Weight (430g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Safe to Iron</p><p>Dry Clean Allowed</p>`,
		"description": "<p>The Ivy woven textured curtains, now reimagined as soundproof, blackout, and thermal curtains, combine elegance with superior functionality.</p>",
		"published_at": "2025-05-07T16:31:18+08:00",
		"created_at": "2025-05-07T16:31:18+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > heavyweight custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > Solid Curtains",
			"All Curtains > Textured Curtains",
			"All Curtains > vintage custom curtains",
			"Bestseller",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Light Filtering Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Easter Sale",
			"Extra 10%",
			"fall sale",
			"Independence Day",
			"indoor curtain",
			"july sale",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Pinch pleat",
			"upcoming fall"
		],
		"price": 10000,
		"price_min": 10000,
		"price_max": 10000,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319439245562,
				"title": "Moss",
				"option1": "Moss",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Moss",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037551948026,
					"product_id": 8780124389626,
					"position": 1,
					"created_at": "2025-05-22T18:16:45+08:00",
					"updated_at": "2025-08-26T16:26:23+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg?v=1756196783",
					"variant_ids": [
						47319439245562
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Moss",
				"public_title": "Moss",
				"options": [
					"Moss"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071600161018,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg?v=1756196783"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aivy_moss_1024x1024.png?v=1751334085"
			},
			{
				"id": 47319439278330,
				"title": "Maldives",
				"option1": "Maldives",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Maldives",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037551456506,
					"product_id": 8780124389626,
					"position": 6,
					"created_at": "2025-05-22T18:16:41+08:00",
					"updated_at": "2025-08-26T16:26:23+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-1_resolution-standardv2-2x.jpg?v=1756196783",
					"variant_ids": [
						47319439278330
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Maldives",
				"public_title": "Maldives",
				"options": [
					"Maldives"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071599866106,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-1_resolution-standardv2-2x.jpg?v=1756196783"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aivy_maldives_1024x1024.jpg?v=1751334084"
			},
			{
				"id": 47319439311098,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037550866682,
					"product_id": 8780124389626,
					"position": 11,
					"created_at": "2025-05-22T18:16:35+08:00",
					"updated_at": "2025-08-26T16:26:24+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250115-AIvory-2-1_resolution-standardv2-2x.jpg?v=1756196784",
					"variant_ids": [
						47319439311098
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071599538426,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250115-AIvory-2-1_resolution-standardv2-2x.jpg?v=1756196784"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aivy_ivory_1024x1024.png?v=1751334085"
			},
			{
				"id": 47319439343866,
				"title": "Oatmeal",
				"option1": "Oatmeal",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Oatmeal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037552341242,
					"product_id": 8780124389626,
					"position": 16,
					"created_at": "2025-05-22T18:16:52+08:00",
					"updated_at": "2025-08-26T16:26:25+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250115-Aoatmeal-2_resolution-standardv2-2x.jpg?v=1756196785",
					"variant_ids": [
						47319439343866
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Oatmeal",
				"public_title": "Oatmeal",
				"options": [
					"Oatmeal"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071600488698,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250115-Aoatmeal-2_resolution-standardv2-2x.jpg?v=1756196785"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aivy_oatmeal_1024x1024.png?v=1751334084"
			},
			{
				"id": 47319439376634,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037550178554,
					"product_id": 8780124389626,
					"position": 21,
					"created_at": "2025-05-22T18:16:25+08:00",
					"updated_at": "2025-08-26T16:26:25+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250115-ABrown-1_resolution-standardv2-2x.jpg?v=1756196785",
					"variant_ids": [
						47319439376634
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071599145210,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250115-ABrown-1_resolution-standardv2-2x.jpg?v=1756196785"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DM_20250829164830_001_1024x1024.png?v=1756458876"
			},
			{
				"id": 47319439409402,
				"title": "Stone",
				"option1": "Stone",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Stone",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037559353594,
					"product_id": 8780124389626,
					"position": 26,
					"created_at": "2025-05-22T18:17:14+08:00",
					"updated_at": "2025-08-26T16:26:25+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2070,
					"src": "//thehues.com/cdn/shop/files/20250115-AStone-2_resolution-standardv2-2x.jpg?v=1756196785",
					"variant_ids": [
						47319439409402
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Stone",
				"public_title": "Stone",
				"options": [
					"Stone"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071603831034,
					"position": 26,
					"preview_image": {
						"aspect_ratio": 0.966,
						"height": 2070,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250115-AStone-2_resolution-standardv2-2x.jpg?v=1756196785"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319439442170,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR460-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037549949178,
					"product_id": 8780124389626,
					"position": 31,
					"created_at": "2025-05-22T18:16:20+08:00",
					"updated_at": "2025-08-26T16:26:26+08:00",
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250115-ABlack-2-1_resolution-standardv2-2x.jpg?v=1756196786",
					"variant_ids": [
						47319439442170
					]
				},
				"available": true,
				"name": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 10000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
					"id": 36071598850298,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250115-ABlack-2-1_resolution-standardv2-2x.jpg?v=1756196786"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg?v=1756196783",
			"//thehues.com/cdn/shop/files/20250115-AMoss-5-1_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-AMoss-3-8_resolution-standardv2-2x.jpg?v=1756196783",
			"//thehues.com/cdn/shop/files/20250115-AMoss-4-1_resolution-standardv2-2x.jpg?v=1756196783",
			"//thehues.com/cdn/shop/files/20250115-AMoss-1-2_resolution-standardv2-2x.jpg?v=1756196783",
			"//thehues.com/cdn/shop/files/20250115-AMaldives-1_resolution-standardv2-2x.jpg?v=1756196783",
			"//thehues.com/cdn/shop/files/20250115-AMaldives-2_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-AMaldives-5_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-AMaldives-4_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-AMaldives-3_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-AIvory-2-1_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-AIvory-1-1_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-AIvory-3-9_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-AIvory-5_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-AIvory-4_resolution-standardv2-2x.jpg?v=1756196784",
			"//thehues.com/cdn/shop/files/20250115-Aoatmeal-2_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-AOatmeal-2-1-1_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-AOatmeal-3_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-AOatmeal-6_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-AOatmeal-4_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-ABrown-1_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-ABrown-2_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-ABrown-3_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-ABrown-5_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-ABrown-4_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-AStone-2_resolution-standardv2-2x.jpg?v=1756196785",
			"//thehues.com/cdn/shop/files/20250115-AStone-3_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-AStone-4_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-AStone-5_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-AStone-1_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-ABlack-2-1_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-ABlack-3-7_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-ABlack-4-8_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-ABlack-1-1_resolution-standardv2-2x.jpg?v=1756196786",
			"//thehues.com/cdn/shop/files/20250115-ABlack-5-1_resolution-standardv2-2x.jpg?v=1761210154",
			"//thehues.com/cdn/shop/files/20250115-Aoatmeal-1_resolution-standardv2-2x.jpg?v=1756196786"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196783",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600161018,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg?v=1756196783"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg?v=1756196783",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600259322,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMoss-5-1_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMoss-5-1_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600193786,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMoss-3-8_resolution-standardv2-2x.jpg?v=1756196783"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMoss-3-8_resolution-standardv2-2x.jpg?v=1756196783",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600226554,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMoss-4-1_resolution-standardv2-2x.jpg?v=1756196783"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMoss-4-1_resolution-standardv2-2x.jpg?v=1756196783",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600292090,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMoss-1-2_resolution-standardv2-2x.jpg?v=1756196783"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMoss-1-2_resolution-standardv2-2x.jpg?v=1756196783",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599866106,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-1_resolution-standardv2-2x.jpg?v=1756196783"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-1_resolution-standardv2-2x.jpg?v=1756196783",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599898874,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-2_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-2_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599833338,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-5_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-5_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599800570,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-4_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-4_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599767802,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-3_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AMaldives-3_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599538426,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AIvory-2-1_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AIvory-2-1_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599669498,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AIvory-1-1_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AIvory-1-1_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599571194,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AIvory-3-9_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AIvory-3-9_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599636730,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AIvory-5_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AIvory-5_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599603962,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AIvory-4_resolution-standardv2-2x.jpg?v=1756196784"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AIvory-4_resolution-standardv2-2x.jpg?v=1756196784",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600488698,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-Aoatmeal-2_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-Aoatmeal-2_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600357626,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-2-1-1_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-2-1-1_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600390394,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-3_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-3_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071601242362,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-6_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-6_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600423162,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-4_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AOatmeal-4_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599145210,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABrown-1_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABrown-1_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599177978,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABrown-2_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABrown-2_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599046906,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABrown-3_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABrown-3_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599112442,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABrown-5_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABrown-5_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071599079674,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABrown-4_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABrown-4_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071603831034,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 2070,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250115-AStone-2_resolution-standardv2-2x.jpg?v=1756196785"
				},
				"aspect_ratio": 0.966,
				"height": 2070,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AStone-2_resolution-standardv2-2x.jpg?v=1756196785",
				"width": 2000
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071603863802,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 2070,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250115-AStone-3_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.966,
				"height": 2070,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AStone-3_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 2000
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071603896570,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 2070,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250115-AStone-4_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.966,
				"height": 2070,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AStone-4_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 2000
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071603929338,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 2070,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250115-AStone-5_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.966,
				"height": 2070,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AStone-5_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 2000
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071603962106,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 2070,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250115-AStone-1_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.966,
				"height": 2070,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-AStone-1_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 2000
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071598850298,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABlack-2-1_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABlack-2-1_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071598883066,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABlack-3-7_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABlack-3-7_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071598915834,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABlack-4-8_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABlack-4-8_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071598817530,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABlack-1-1_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABlack-1-1_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071598948602,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-ABlack-5-1_resolution-standardv2-2x.jpg?v=1761210154"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-ABlack-5-1_resolution-standardv2-2x.jpg?v=1761210154",
				"width": 1999
			},
			{
				"alt": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain - TheHues",
				"id": 36071600455930,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250115-Aoatmeal-1_resolution-standardv2-2x.jpg?v=1756196786"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250115-Aoatmeal-1_resolution-standardv2-2x.jpg?v=1756196786",
				"width": 1999
			},
			{
				"alt": null,
				"id": 36104656421114,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/3f296861f180461ba9aedb980af71712.thumbnail.0000000000.jpg?v=1748483455"
				},
				"aspect_ratio": 0.563,
				"duration": 27930,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/3f296861f180461ba9aedb980af71712/3f296861f180461ba9aedb980af71712.SD-480p-0.9Mbps-48422922.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/3f296861f180461ba9aedb980af71712/3f296861f180461ba9aedb980af71712.HD-1080p-2.5Mbps-48422922.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/3f296861f180461ba9aedb980af71712/3f296861f180461ba9aedb980af71712.HD-720p-1.6Mbps-48422922.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/3f296861f180461ba9aedb980af71712/3f296861f180461ba9aedb980af71712.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Ivy woven textured curtains, now reimagined as soundproof, blackout, and thermal curtains, combine elegance with superior functionality.</p>",
		"url": "/products/ivy-linen-look-heavyweight-herringbone-textured-custom-curtain",
		"regular_price": "$100.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			}
		]
	},
	{
		"id": 8780123144442,
		"title": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy",
		"handle": "rome-foil-printed-velvet-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>With foil-printed patterns that glimmer like sunlight on water, these curtains transform any space into a refined sanctuary of light and texture.</p>",
		"published_at": "2025-05-07T16:30:42+08:00",
		"created_at": "2025-05-07T16:30:42+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > black custom curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"Extra 10%",
			"fall sale",
			"flash_categories",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"Summer"
		],
		"price": 12800,
		"price_min": 12800,
		"price_max": 12800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319410475258,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44018072387834,
					"product_id": 8780123144442,
					"position": 1,
					"created_at": "2025-05-20T20:07:59+08:00",
					"updated_at": "2025-08-26T16:27:24+08:00",
					"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ablack-3-4_1__resolution-standardv2-2x_7853f115-4295-48e8-a2c5-a3a3d4f30452.jpg?v=1756196844",
					"variant_ids": [
						47319410475258
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
					"id": 36059813249274,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ablack-3-4_1__resolution-standardv2-2x_7853f115-4295-48e8-a2c5-a3a3d4f30452.jpg?v=1756196844"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ablack-31_resolution-highfidelityv2-2x_e6ef8f99-9493-4231-8006-3b4d3a7c12d7_1024x1024.jpg?v=1756196846"
			},
			{
				"id": 47319410049274,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435688186,
					"product_id": 8780123144442,
					"position": 17,
					"created_at": "2025-05-19T19:31:14+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Arome-display-3_10_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410049274
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781867770,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Arome-display-3_10_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Arome-display-3_10_2_resolution-highfidelityv2-2x_1024x1024.jpg?v=1761273723"
			},
			{
				"id": 47319410082042,
				"title": "Champagne",
				"option1": "Champagne",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Champagne",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435786490,
					"product_id": 8780123144442,
					"position": 16,
					"created_at": "2025-05-19T19:31:14+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Achampagne_9_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410082042
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Champagne",
				"public_title": "Champagne",
				"options": [
					"Champagne"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781966074,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Achampagne_9_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Achampagne_9_2_resolution-highfidelityv2-2x_1024x1024.jpg?v=1761273723"
			},
			{
				"id": 47319410114810,
				"title": "Silver",
				"option1": "Silver",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Silver",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435819258,
					"product_id": 8780123144442,
					"position": 15,
					"created_at": "2025-05-19T19:31:14+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Asilver_8_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410114810
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Silver",
				"public_title": "Silver",
				"options": [
					"Silver"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781900538,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Asilver_8_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asilver_8_2_resolution-highfidelityv2-2x_1024x1024.jpg?v=1761273723"
			},
			{
				"id": 47319410147578,
				"title": "Light Blue",
				"option1": "Light Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Light Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011436015866,
					"product_id": 8780123144442,
					"position": 14,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Alightblue_7_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410147578
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Light Blue",
				"public_title": "Light Blue",
				"options": [
					"Light Blue"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781638394,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Alightblue_7_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410180346,
				"title": "Misty",
				"option1": "Misty",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Misty",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435917562,
					"product_id": 8780123144442,
					"position": 13,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Amisty_6_3_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410180346
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Misty",
				"public_title": "Misty",
				"options": [
					"Misty"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781703930,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Amisty_6_3_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410213114,
				"title": "Gold",
				"option1": "Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435655418,
					"product_id": 8780123144442,
					"position": 12,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agold_5_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410213114
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Gold",
				"public_title": "Gold",
				"options": [
					"Gold"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781572858,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agold_5_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410245882,
				"title": "Coral",
				"option1": "Coral",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Coral",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435983098,
					"product_id": 8780123144442,
					"position": 11,
					"created_at": "2025-05-19T19:31:14+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Acoral_3_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410245882
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Coral",
				"public_title": "Coral",
				"options": [
					"Coral"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055782031610,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Acoral_3_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410278650,
				"title": "Mustard Green",
				"option1": "Mustard Green",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Mustard Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435622650,
					"product_id": 8780123144442,
					"position": 10,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Amustardgreen_2_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410278650
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Mustard Green",
				"public_title": "Mustard Green",
				"options": [
					"Mustard Green"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781769466,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Amustardgreen_2_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410311418,
				"title": "Orange",
				"option1": "Orange",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Orange",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435950330,
					"product_id": 8780123144442,
					"position": 9,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Aorange_1_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410311418
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Orange",
				"public_title": "Orange",
				"options": [
					"Orange"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781802234,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Aorange_1_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410344186,
				"title": "Metallic",
				"option1": "Metallic",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Metallic",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011436048634,
					"product_id": 8780123144442,
					"position": 8,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ametallic_4_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410344186
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Metallic",
				"public_title": "Metallic",
				"options": [
					"Metallic"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781671162,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ametallic_4_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410376954,
				"title": "Golden Brown",
				"option1": "Golden Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Golden Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435753722,
					"product_id": 8780123144442,
					"position": 7,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Agoldenbrown2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410376954
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Golden Brown",
				"public_title": "Golden Brown",
				"options": [
					"Golden Brown"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781605626,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Agoldenbrown2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410409722,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435720954,
					"product_id": 8780123144442,
					"position": 6,
					"created_at": "2025-05-19T19:31:14+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ateal2_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410409722
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781933306,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ateal2_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319410442490,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2304-C-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44011435884794,
					"product_id": 8780123144442,
					"position": 4,
					"created_at": "2025-05-19T19:31:13+08:00",
					"updated_at": "2025-10-24T10:42:03+08:00",
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Ared-12_resolution-highfidelityv2-2x.jpg?v=1761273723",
					"variant_ids": [
						47319410442490
					]
				},
				"available": true,
				"name": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 12800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
					"id": 36055781835002,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Ared-12_resolution-highfidelityv2-2x.jpg?v=1761273723"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Ablack-3-4_1__resolution-standardv2-2x_7853f115-4295-48e8-a2c5-a3a3d4f30452.jpg?v=1756196844",
			"//thehues.com/cdn/shop/files/Ablack-4333_9__resolution-standardv2-2x_339b8958-0bdc-4c8a-b676-d9bc4841c6ac.jpg?v=1756196844",
			"//thehues.com/cdn/shop/files/Ablack-6-6_6__resolution-highfidelityv2-2x_ada32f0d-7a2d-44b8-a8cd-927161fd8033.jpg?v=1756196844",
			"//thehues.com/cdn/shop/files/Ared-12_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Ablack-1-3_10__resolution-highfidelityv2-2x_03c6af09-8595-4831-aebb-4fac183182c5.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Ateal2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Agoldenbrown2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Ametallic_4_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Aorange_1_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Amustardgreen_2_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Acoral_3_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Agold_5_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Amisty_6_3_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Alightblue_7_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Asilver_8_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Achampagne_9_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Arome-display-3_10_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
			"//thehues.com/cdn/shop/files/Ablack-4333_9_-1_resolution-standardv2-2x_c76683b3-8df8-4e29-b868-e0d8af330671.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Ablack-2-2_8__resolution-standardv2-2x_2a7235f2-f9a1-42d6-9f82-9d4140470c5e.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Ablack-2-3_2__resolution-standardv2-2x_4b330b82-72af-442e-9045-9a8fdad61dd1.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Ablack-31_resolution-highfidelityv2-2x_e6ef8f99-9493-4231-8006-3b4d3a7c12d7.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Ablack-3-2_4__resolution-standardv2-2x_5b1fa695-6f62-44bd-bcf3-816e6cef7e22.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Ablack-3-3_5__resolution-standardv2-2x_f993a3f5-f758-4262-83f2-df2d84e5bae4.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Ablack-5-6_7__resolution-highfidelityv2-2x_1d7e22fb-b9b7-4750-8637-44e88ae7b5a6.jpg?v=1756196846",
			"//thehues.com/cdn/shop/files/Amisty_6_4_resolution-highfidelityv2-2x.jpg?v=1761273723"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Ablack-3-4_1__resolution-standardv2-2x_7853f115-4295-48e8-a2c5-a3a3d4f30452_1024x1024.jpg?v=1756196844",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813249274,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-3-4_1__resolution-standardv2-2x_7853f115-4295-48e8-a2c5-a3a3d4f30452.jpg?v=1756196844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-3-4_1__resolution-standardv2-2x_7853f115-4295-48e8-a2c5-a3a3d4f30452.jpg?v=1756196844",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813347578,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-4333_9__resolution-standardv2-2x_339b8958-0bdc-4c8a-b676-d9bc4841c6ac.jpg?v=1756196844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-4333_9__resolution-standardv2-2x_339b8958-0bdc-4c8a-b676-d9bc4841c6ac.jpg?v=1756196844",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813314810,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-6-6_6__resolution-highfidelityv2-2x_ada32f0d-7a2d-44b8-a8cd-927161fd8033.jpg?v=1756196844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-6-6_6__resolution-highfidelityv2-2x_ada32f0d-7a2d-44b8-a8cd-927161fd8033.jpg?v=1756196844",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781835002,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-12_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-12_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813052666,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-1-3_10__resolution-highfidelityv2-2x_03c6af09-8595-4831-aebb-4fac183182c5.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-1-3_10__resolution-highfidelityv2-2x_03c6af09-8595-4831-aebb-4fac183182c5.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781933306,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ateal2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ateal2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781605626,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agoldenbrown2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agoldenbrown2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781671162,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ametallic_4_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ametallic_4_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781802234,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aorange_1_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aorange_1_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781769466,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amustardgreen_2_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amustardgreen_2_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055782031610,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acoral_3_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acoral_3_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781572858,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agold_5_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agold_5_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781703930,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amisty_6_3_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amisty_6_3_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781638394,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alightblue_7_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alightblue_7_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781900538,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Asilver_8_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Asilver_8_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781966074,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Achampagne_9_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Achampagne_9_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781867770,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Arome-display-3_10_2_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Arome-display-3_10_2_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813380346,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-4333_9_-1_resolution-standardv2-2x_c76683b3-8df8-4e29-b868-e0d8af330671.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-4333_9_-1_resolution-standardv2-2x_c76683b3-8df8-4e29-b868-e0d8af330671.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813085434,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-2_8__resolution-standardv2-2x_2a7235f2-f9a1-42d6-9f82-9d4140470c5e.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-2_8__resolution-standardv2-2x_2a7235f2-f9a1-42d6-9f82-9d4140470c5e.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813118202,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-3_2__resolution-standardv2-2x_4b330b82-72af-442e-9045-9a8fdad61dd1.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-3_2__resolution-standardv2-2x_4b330b82-72af-442e-9045-9a8fdad61dd1.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813150970,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-31_resolution-highfidelityv2-2x_e6ef8f99-9493-4231-8006-3b4d3a7c12d7.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-31_resolution-highfidelityv2-2x_e6ef8f99-9493-4231-8006-3b4d3a7c12d7.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813183738,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-3-2_4__resolution-standardv2-2x_5b1fa695-6f62-44bd-bcf3-816e6cef7e22.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-3-2_4__resolution-standardv2-2x_5b1fa695-6f62-44bd-bcf3-816e6cef7e22.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813216506,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-3-3_5__resolution-standardv2-2x_f993a3f5-f758-4262-83f2-df2d84e5bae4.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-3-3_5__resolution-standardv2-2x_f993a3f5-f758-4262-83f2-df2d84e5bae4.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy - TheHues",
				"id": 36059813282042,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-5-6_7__resolution-highfidelityv2-2x_1d7e22fb-b9b7-4750-8637-44e88ae7b5a6.jpg?v=1756196846"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-5-6_7__resolution-highfidelityv2-2x_1d7e22fb-b9b7-4750-8637-44e88ae7b5a6.jpg?v=1756196846",
				"width": 2000
			},
			{
				"alt": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain - TheHues",
				"id": 36055781736698,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amisty_6_4_resolution-highfidelityv2-2x.jpg?v=1761273723"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amisty_6_4_resolution-highfidelityv2-2x.jpg?v=1761273723",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36106677944570,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1920,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/8a29c9709d934bc0bd871758a4c2135b.thumbnail.0000000000.jpg?v=1748511660"
				},
				"aspect_ratio": 0.563,
				"duration": 49000,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8a29c9709d934bc0bd871758a4c2135b/8a29c9709d934bc0bd871758a4c2135b.SD-480p-0.9Mbps-48443537.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8a29c9709d934bc0bd871758a4c2135b/8a29c9709d934bc0bd871758a4c2135b.HD-1080p-2.5Mbps-48443537.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8a29c9709d934bc0bd871758a4c2135b/8a29c9709d934bc0bd871758a4c2135b.HD-720p-1.6Mbps-48443537.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8a29c9709d934bc0bd871758a4c2135b/8a29c9709d934bc0bd871758a4c2135b.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With foil-printed patterns that glimmer like sunlight on water, these curtains transform any space into a refined sanctuary of light and texture.</p>",
		"url": "/products/rome-foil-printed-velvet-custom-curtain-designed-in-italy",
		"regular_price": "$128.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780123111674,
		"title": "Moonlit Velvet Custom Curtain",
		"handle": "moonlit-velvet-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester</p><p>Features: Lush Velvet Fabric</p><p>Weight: Regular (365g/㎡)</p><p>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>The Moonlit Shimmering Velvet curtains capture the soft glow of moonlight, draping your space in an aura of sophistication and timeless beauty.</p>",
		"published_at": "2025-05-23T18:10:06+08:00",
		"created_at": "2025-05-07T16:30:40+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > Solid Curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"upcoming fall"
		],
		"price": 10800,
		"price_min": 10800,
		"price_max": 10800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319421845754,
				"title": "Champagne",
				"option1": "Champagne",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Champagne",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048845111546,
					"product_id": 8780123111674,
					"position": 45,
					"created_at": "2025-05-23T17:57:26+08:00",
					"updated_at": "2025-08-26T16:27:33+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Champagne-1_7bec0c71-4a29-49d4-aad2-34124a9e7b2f.jpg?v=1756196853",
					"variant_ids": [
						47319421845754
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Champagne",
				"public_title": "Champagne",
				"options": [
					"Champagne"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327365882,
					"position": 45,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Champagne-1_7bec0c71-4a29-49d4-aad2-34124a9e7b2f.jpg?v=1756196853"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/champane-300x300_1024x1024.png?v=1751357972"
			},
			{
				"id": 47319421812986,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048846323962,
					"product_id": 8780123111674,
					"position": 1,
					"created_at": "2025-05-23T17:57:27+08:00",
					"updated_at": "2025-08-26T16:27:28+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Cream-1_b045f235-879b-43e9-94cf-697de52774a8.jpg?v=1756196848",
					"variant_ids": [
						47319421812986
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327496954,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Cream-1_b045f235-879b-43e9-94cf-697de52774a8.jpg?v=1756196848"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cream-300x300_1024x1024.png?v=1751357973"
			},
			{
				"id": 47319421944058,
				"title": "Azure",
				"option1": "Azure",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Azure",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048845603066,
					"product_id": 8780123111674,
					"position": 53,
					"created_at": "2025-05-23T17:57:26+08:00",
					"updated_at": "2025-08-26T16:27:33+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Azure-1_977305ca-36ba-4db9-bf4e-80dd1292c218.jpg?v=1756196853",
					"variant_ids": [
						47319421944058
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Azure",
				"public_title": "Azure",
				"options": [
					"Azure"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327103738,
					"position": 53,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Azure-1_977305ca-36ba-4db9-bf4e-80dd1292c218.jpg?v=1756196853"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/azure300x300_1024x1024.png?v=1751357972"
			},
			{
				"id": 47319421878522,
				"title": "Silver Grey",
				"option1": "Silver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Silver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048845766906,
					"product_id": 8780123111674,
					"position": 9,
					"created_at": "2025-05-23T17:57:27+08:00",
					"updated_at": "2025-08-26T16:27:29+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-1_986b68d7-4bd0-49b8-9bce-3af96d01c7d9.jpg?v=1756196849",
					"variant_ids": [
						47319421878522
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Silver Grey",
				"public_title": "Silver Grey",
				"options": [
					"Silver Grey"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078328021242,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-1_986b68d7-4bd0-49b8-9bce-3af96d01c7d9.jpg?v=1756196849"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/silver-grey300x300_1024x1024.png?v=1751357973"
			},
			{
				"id": 47319421911290,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048846192890,
					"product_id": 8780123111674,
					"position": 49,
					"created_at": "2025-05-23T17:57:27+08:00",
					"updated_at": "2025-08-26T16:27:33+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Grey-1_c559e2e6-784b-471b-ba28-b9edbc9d8bef.jpg?v=1756196853",
					"variant_ids": [
						47319421911290
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327660794,
					"position": 49,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Grey-1_c559e2e6-784b-471b-ba28-b9edbc9d8bef.jpg?v=1756196853"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319421976826,
				"title": "Mustard",
				"option1": "Mustard",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Mustard",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44621391134970,
					"product_id": 8780123111674,
					"position": 61,
					"created_at": "2025-07-28T16:01:21+08:00",
					"updated_at": "2025-09-19T17:36:26+08:00",
					"alt": "Moonlit 4 Layers Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/image_1.jpg?v=1758274586",
					"variant_ids": [
						47319421976826
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Mustard",
				"public_title": "Mustard",
				"options": [
					"Mustard"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit 4 Layers Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
					"id": 36445745905914,
					"position": 61,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/image_1.jpg?v=1758274586"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422009594,
				"title": "Salmon",
				"option1": "Salmon",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Salmon",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048844390650,
					"product_id": 8780123111674,
					"position": 17,
					"created_at": "2025-05-23T17:57:27+08:00",
					"updated_at": "2025-08-26T16:27:30+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Salmon-1_163c53b2-8388-4a48-976d-3ce2ded8b037.jpg?v=1756196850",
					"variant_ids": [
						47319422009594
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Salmon",
				"public_title": "Salmon",
				"options": [
					"Salmon"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327922938,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Salmon-1_163c53b2-8388-4a48-976d-3ce2ded8b037.jpg?v=1756196850"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422042362,
				"title": "Carrot",
				"option1": "Carrot",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Carrot",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048844718330,
					"product_id": 8780123111674,
					"position": 21,
					"created_at": "2025-05-23T17:57:26+08:00",
					"updated_at": "2025-08-26T16:27:30+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Carrot-1_87a41163-cf0b-47d0-9d40-110336224e6d.jpg?v=1756196850",
					"variant_ids": [
						47319422042362
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Carrot",
				"public_title": "Carrot",
				"options": [
					"Carrot"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078326743290,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250213-Carrot-1_87a41163-cf0b-47d0-9d40-110336224e6d.jpg?v=1756196850"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422075130,
				"title": "Camel",
				"option1": "Camel",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Camel",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048843997434,
					"product_id": 8780123111674,
					"position": 29,
					"created_at": "2025-05-23T17:57:25+08:00",
					"updated_at": "2025-08-26T16:27:31+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250110-Camel-1_9fcbe77b-d944-4d96-a14e-a9d64c2a63a4.jpg?v=1756196851",
					"variant_ids": [
						47319422075130
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Camel",
				"public_title": "Camel",
				"options": [
					"Camel"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078326612218,
					"position": 29,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250110-Camel-1_9fcbe77b-d944-4d96-a14e-a9d64c2a63a4.jpg?v=1756196851"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422107898,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048843964666,
					"product_id": 8780123111674,
					"position": 33,
					"created_at": "2025-05-23T17:57:25+08:00",
					"updated_at": "2025-08-26T16:27:31+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown_4c964c13-c979-4803-a67e-2a84a9ea30f5.jpg?v=1756196851",
					"variant_ids": [
						47319422107898
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078326317306,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250110-Brown_4c964c13-c979-4803-a67e-2a84a9ea30f5.jpg?v=1756196851"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422140666,
				"title": "Metallic",
				"option1": "Metallic",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Metallic",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048844325114,
					"product_id": 8780123111674,
					"position": 25,
					"created_at": "2025-05-23T17:57:26+08:00",
					"updated_at": "2025-08-26T16:27:31+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Metallic-1_98d35e04-f0b2-4f8c-a415-e4dcd8df7a47.jpg?v=1756196851",
					"variant_ids": [
						47319422140666
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Metallic",
				"public_title": "Metallic",
				"options": [
					"Metallic"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078326972666,
					"position": 25,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250213-Metallic-1_98d35e04-f0b2-4f8c-a415-e4dcd8df7a47.jpg?v=1756196851"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422173434,
				"title": "Ebony",
				"option1": "Ebony",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Ebony",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048845963514,
					"product_id": 8780123111674,
					"position": 57,
					"created_at": "2025-05-23T17:57:26+08:00",
					"updated_at": "2025-08-26T16:27:34+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Ebony-1_4165fd08-6cf0-40eb-b63d-5be0dc18fc8a.jpg?v=1756196854",
					"variant_ids": [
						47319422173434
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Ebony",
				"public_title": "Ebony",
				"options": [
					"Ebony"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078326874362,
					"position": 57,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250213-Ebony-1_4165fd08-6cf0-40eb-b63d-5be0dc18fc8a.jpg?v=1756196854"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422206202,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048844914938,
					"product_id": 8780123111674,
					"position": 13,
					"created_at": "2025-05-23T17:57:27+08:00",
					"updated_at": "2025-08-26T16:27:29+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Red-1_a174f249-e578-4f59-9cb8-b533a1d62b72.jpg?v=1756196849",
					"variant_ids": [
						47319422206202
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327791866,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Red-1_a174f249-e578-4f59-9cb8-b533a1d62b72.jpg?v=1756196849"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422238970,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048845078778,
					"product_id": 8780123111674,
					"position": 5,
					"created_at": "2025-05-23T17:57:28+08:00",
					"updated_at": "2025-08-26T16:27:29+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Teal-1_d0547d79-f944-4be1-8aca-6b6c2d2e9498.jpg?v=1756196849",
					"variant_ids": [
						47319422238970
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078328152314,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Teal-1_d0547d79-f944-4be1-8aca-6b6c2d2e9498.jpg?v=1756196849"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319422271738,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137PLUSH-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44048845439226,
					"product_id": 8780123111674,
					"position": 41,
					"created_at": "2025-05-23T17:57:26+08:00",
					"updated_at": "2025-08-26T16:27:32+08:00",
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250523-Black-1_d0ef4388-0b2a-4dd1-a423-14465f1e616f.jpg?v=1756196852",
					"variant_ids": [
						47319422271738
					]
				},
				"available": true,
				"name": "Moonlit Velvet Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 10800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Moonlit Velvet Custom Curtain - TheHues",
					"id": 36078327234810,
					"position": 41,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250523-Black-1_d0ef4388-0b2a-4dd1-a423-14465f1e616f.jpg?v=1756196852"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250523-Cream-1_b045f235-879b-43e9-94cf-697de52774a8.jpg?v=1756196848",
			"//thehues.com/cdn/shop/files/20250523-Cream-4_82f68640-1b47-4fd6-baf4-e8b2a91413c7.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Cream-2_62ae2970-453c-481e-ace7-162ab6b85dc2.jpg?v=1756196848",
			"//thehues.com/cdn/shop/files/20250523-Cream-3_98d367bc-4feb-4672-8d11-c1d545372a02.jpg?v=1756196848",
			"//thehues.com/cdn/shop/files/20250523-Teal-1_d0547d79-f944-4be1-8aca-6b6c2d2e9498.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Teal-4_a16bbc54-b4af-4973-b214-acaf9eb2ad1a.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Teal-2_ec072cfa-4b57-4791-b55a-d8baaf090b3f.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Teal-3_27fcd15e-5f13-4727-b835-4c8f1938167f.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Silver-Grey-1_986b68d7-4bd0-49b8-9bce-3af96d01c7d9.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Silver-Grey-4_29baf6f8-9210-4b8e-96e3-8b079c848458.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Silver-Grey-2_12c9e982-46ee-44ab-ba1c-9427bf3e40ac.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Silver-Grey-3_13bf2cd1-7867-42ea-94e7-e29c3d237e9e.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Red-1_a174f249-e578-4f59-9cb8-b533a1d62b72.jpg?v=1756196849",
			"//thehues.com/cdn/shop/files/20250523-Red-4_a3af4348-6e5f-479f-b77e-5ad176babfa1.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Red-2_4f95c35e-50e8-4266-bc5d-aecf3e58747a.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250523-Red-3_5012ee67-68f6-49f5-ac21-75f42190251c.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250523-Salmon-1_163c53b2-8388-4a48-976d-3ce2ded8b037.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20240806-Salmon-4_2a7dae2c-06e6-4f42-9d5a-82a133115c9c.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Salmon-2_032a3425-c1dc-4921-bafb-91577b7c0f62.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250523-Salmon-3_056da3a6-3dea-44ca-8b0c-f526ca2da593.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250213-Carrot-1_87a41163-cf0b-47d0-9d40-110336224e6d.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250213-Carrot-4_85f954fb-a0c3-493f-a367-752ae13806ec.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250213-Carrot-2_cde49f33-6153-41ac-8d3c-239789bef7cf.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250213-Carrot-3_53c887a5-20e1-496b-8acd-1a565c9f1230.jpg?v=1756196850",
			"//thehues.com/cdn/shop/files/20250213-Metallic-1_98d35e04-f0b2-4f8c-a415-e4dcd8df7a47.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250213-Metallic-4_8eaf35d7-d28e-4d20-86fa-afae4b060756.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250213-Metallic-2_aa9d06b7-2857-4458-bc50-efc606da019a.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250213-Metallic-3_bc7724b2-3779-4f33-8600-bc8178644da5.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250110-Camel-1_9fcbe77b-d944-4d96-a14e-a9d64c2a63a4.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250110-Camel-3_0ac695c8-ea99-4b55-8efa-7a401e90d9d1.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250110-Camel-2_3a4e75e9-3698-4b14-b1c6-2be6a2cba81a.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250110-Camel-4_8a9a8b10-83fa-4507-9ece-9de51c95dac6.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250110-Brown_4c964c13-c979-4803-a67e-2a84a9ea30f5.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250110-Brown-5_1a1cc0e3-0189-4b7d-bf27-268e0fdbef8d.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250110-Brown-2_8f539888-c9ab-4c46-a9ab-e348f45d2273.jpg?v=1756196851",
			"//thehues.com/cdn/shop/files/20250110-Brown-7_e868dda3-87cf-42d4-8865-8dd4700aad06.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250110-Brown-1_85f35a17-8ee1-4f34-9eb0-43db440d17fc.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250110-Brown-3_9e09dbe5-232e-479e-b1fe-8b955f23d2b1.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250110-Brown-4_ed5f707d-5f41-4e83-a252-f36c2fefd5c0.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250110-Brown-6_7a0121c3-8342-45e5-aef1-50998a18b825.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250523-Black-1_d0ef4388-0b2a-4dd1-a423-14465f1e616f.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250523-Black-4_37f15fa5-4702-47d0-b77f-862cd214d63e.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Black-2_2a068bb8-b9bc-4cb3-9062-a9cbc6cda355.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250523-Black-3_a82ead46-ccdf-42b1-b7dd-92c047e042b8.jpg?v=1756196852",
			"//thehues.com/cdn/shop/files/20250523-Champagne-1_7bec0c71-4a29-49d4-aad2-34124a9e7b2f.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Champagne-4_9f0ef89a-c9c7-4090-a1d2-c8fc89b29ce9.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Champagne-2_ef90970f-1da0-49fc-8f1d-9898631c21e6.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Champagne-3_bbbc53c0-b39c-4946-95ea-ec11918aef7c.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Grey-1_c559e2e6-784b-471b-ba28-b9edbc9d8bef.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Grey-4_ad274284-3244-41cb-b3b4-ab010387c11f.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Grey-2_40b4f5aa-0436-4ff5-a2e0-4be509e3f26c.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Grey-3_0b55f06c-a86c-485a-a113-ac19a74da71d.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Azure-1_977305ca-36ba-4db9-bf4e-80dd1292c218.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Azure-4_4ac684a4-0e09-4bd1-8b49-7df3c4fcaf1f.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/20250523-Azure-2_223b383a-244a-4a67-bbbd-b78fd7003dc2.jpg?v=1756196853",
			"//thehues.com/cdn/shop/files/20250523-Azure-3_481746a2-6817-4669-8884-056f995c38a7.jpg?v=1756196854",
			"//thehues.com/cdn/shop/files/20250213-Ebony-1_4165fd08-6cf0-40eb-b63d-5be0dc18fc8a.jpg?v=1756196854",
			"//thehues.com/cdn/shop/files/20250213-Ebony-2_480f6ac8-c904-4bfb-aa8a-26fd94088abd.jpg?v=1756196854",
			"//thehues.com/cdn/shop/files/20250213-Ebony-3_0601c985-0293-497b-a89b-61eeaa64ab77.jpg?v=1756196854",
			"//thehues.com/cdn/shop/files/20250523-Ebony-4_a1b9ff36-d0c1-4785-9630-525c93b1d7d0.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/image_1.jpg?v=1758274586",
			"//thehues.com/cdn/shop/files/image_2.jpg?v=1761214052",
			"//thehues.com/cdn/shop/files/image_3.jpg?v=1758274586",
			"//thehues.com/cdn/shop/files/image_4.jpg?v=1758274586"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250523-Cream-1_b045f235-879b-43e9-94cf-697de52774a8_1024x1024.jpg?v=1756196848",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327496954,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Cream-1_b045f235-879b-43e9-94cf-697de52774a8.jpg?v=1756196848"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Cream-1_b045f235-879b-43e9-94cf-697de52774a8.jpg?v=1756196848",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327595258,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Cream-4_82f68640-1b47-4fd6-baf4-e8b2a91413c7.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Cream-4_82f68640-1b47-4fd6-baf4-e8b2a91413c7.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327529722,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Cream-2_62ae2970-453c-481e-ace7-162ab6b85dc2.jpg?v=1756196848"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Cream-2_62ae2970-453c-481e-ace7-162ab6b85dc2.jpg?v=1756196848",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327562490,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Cream-3_98d367bc-4feb-4672-8d11-c1d545372a02.jpg?v=1756196848"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Cream-3_98d367bc-4feb-4672-8d11-c1d545372a02.jpg?v=1756196848",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328152314,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Teal-1_d0547d79-f944-4be1-8aca-6b6c2d2e9498.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Teal-1_d0547d79-f944-4be1-8aca-6b6c2d2e9498.jpg?v=1756196849",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328250618,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Teal-4_a16bbc54-b4af-4973-b214-acaf9eb2ad1a.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Teal-4_a16bbc54-b4af-4973-b214-acaf9eb2ad1a.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328185082,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Teal-2_ec072cfa-4b57-4791-b55a-d8baaf090b3f.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Teal-2_ec072cfa-4b57-4791-b55a-d8baaf090b3f.jpg?v=1756196849",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328217850,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Teal-3_27fcd15e-5f13-4727-b835-4c8f1938167f.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Teal-3_27fcd15e-5f13-4727-b835-4c8f1938167f.jpg?v=1756196849",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328021242,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-1_986b68d7-4bd0-49b8-9bce-3af96d01c7d9.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-1_986b68d7-4bd0-49b8-9bce-3af96d01c7d9.jpg?v=1756196849",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328119546,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-4_29baf6f8-9210-4b8e-96e3-8b079c848458.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-4_29baf6f8-9210-4b8e-96e3-8b079c848458.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328054010,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-2_12c9e982-46ee-44ab-ba1c-9427bf3e40ac.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-2_12c9e982-46ee-44ab-ba1c-9427bf3e40ac.jpg?v=1756196849",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078328086778,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-3_13bf2cd1-7867-42ea-94e7-e29c3d237e9e.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Silver-Grey-3_13bf2cd1-7867-42ea-94e7-e29c3d237e9e.jpg?v=1756196849",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327791866,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Red-1_a174f249-e578-4f59-9cb8-b533a1d62b72.jpg?v=1756196849"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Red-1_a174f249-e578-4f59-9cb8-b533a1d62b72.jpg?v=1756196849",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327890170,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Red-4_a3af4348-6e5f-479f-b77e-5ad176babfa1.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Red-4_a3af4348-6e5f-479f-b77e-5ad176babfa1.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327824634,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Red-2_4f95c35e-50e8-4266-bc5d-aecf3e58747a.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Red-2_4f95c35e-50e8-4266-bc5d-aecf3e58747a.jpg?v=1756196850",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327857402,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Red-3_5012ee67-68f6-49f5-ac21-75f42190251c.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Red-3_5012ee67-68f6-49f5-ac21-75f42190251c.jpg?v=1756196850",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327922938,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Salmon-1_163c53b2-8388-4a48-976d-3ce2ded8b037.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Salmon-1_163c53b2-8388-4a48-976d-3ce2ded8b037.jpg?v=1756196850",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326284538,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240806-Salmon-4_2a7dae2c-06e6-4f42-9d5a-82a133115c9c.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240806-Salmon-4_2a7dae2c-06e6-4f42-9d5a-82a133115c9c.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327955706,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Salmon-2_032a3425-c1dc-4921-bafb-91577b7c0f62.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Salmon-2_032a3425-c1dc-4921-bafb-91577b7c0f62.jpg?v=1756196850",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327988474,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Salmon-3_056da3a6-3dea-44ca-8b0c-f526ca2da593.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Salmon-3_056da3a6-3dea-44ca-8b0c-f526ca2da593.jpg?v=1756196850",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326743290,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Carrot-1_87a41163-cf0b-47d0-9d40-110336224e6d.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Carrot-1_87a41163-cf0b-47d0-9d40-110336224e6d.jpg?v=1756196850",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326841594,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Carrot-4_85f954fb-a0c3-493f-a367-752ae13806ec.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Carrot-4_85f954fb-a0c3-493f-a367-752ae13806ec.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326776058,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Carrot-2_cde49f33-6153-41ac-8d3c-239789bef7cf.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Carrot-2_cde49f33-6153-41ac-8d3c-239789bef7cf.jpg?v=1756196850",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326808826,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Carrot-3_53c887a5-20e1-496b-8acd-1a565c9f1230.jpg?v=1756196850"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Carrot-3_53c887a5-20e1-496b-8acd-1a565c9f1230.jpg?v=1756196850",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326972666,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Metallic-1_98d35e04-f0b2-4f8c-a415-e4dcd8df7a47.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Metallic-1_98d35e04-f0b2-4f8c-a415-e4dcd8df7a47.jpg?v=1756196851",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327070970,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Metallic-4_8eaf35d7-d28e-4d20-86fa-afae4b060756.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Metallic-4_8eaf35d7-d28e-4d20-86fa-afae4b060756.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327005434,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Metallic-2_aa9d06b7-2857-4458-bc50-efc606da019a.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Metallic-2_aa9d06b7-2857-4458-bc50-efc606da019a.jpg?v=1756196851",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327038202,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Metallic-3_bc7724b2-3779-4f33-8600-bc8178644da5.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Metallic-3_bc7724b2-3779-4f33-8600-bc8178644da5.jpg?v=1756196851",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326612218,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250110-Camel-1_9fcbe77b-d944-4d96-a14e-a9d64c2a63a4.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Camel-1_9fcbe77b-d944-4d96-a14e-a9d64c2a63a4.jpg?v=1756196851",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326677754,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Camel-3_0ac695c8-ea99-4b55-8efa-7a401e90d9d1.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Camel-3_0ac695c8-ea99-4b55-8efa-7a401e90d9d1.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326644986,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Camel-2_3a4e75e9-3698-4b14-b1c6-2be6a2cba81a.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Camel-2_3a4e75e9-3698-4b14-b1c6-2be6a2cba81a.jpg?v=1756196851",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326710522,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Camel-4_8a9a8b10-83fa-4507-9ece-9de51c95dac6.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Camel-4_8a9a8b10-83fa-4507-9ece-9de51c95dac6.jpg?v=1756196851",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326317306,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown_4c964c13-c979-4803-a67e-2a84a9ea30f5.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown_4c964c13-c979-4803-a67e-2a84a9ea30f5.jpg?v=1756196851",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326481146,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-5_1a1cc0e3-0189-4b7d-bf27-268e0fdbef8d.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-5_1a1cc0e3-0189-4b7d-bf27-268e0fdbef8d.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326382842,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-2_8f539888-c9ab-4c46-a9ab-e348f45d2273.jpg?v=1756196851"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-2_8f539888-c9ab-4c46-a9ab-e348f45d2273.jpg?v=1756196851",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326579450,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-7_e868dda3-87cf-42d4-8865-8dd4700aad06.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-7_e868dda3-87cf-42d4-8865-8dd4700aad06.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326350074,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-1_85f35a17-8ee1-4f34-9eb0-43db440d17fc.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-1_85f35a17-8ee1-4f34-9eb0-43db440d17fc.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326415610,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-3_9e09dbe5-232e-479e-b1fe-8b955f23d2b1.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-3_9e09dbe5-232e-479e-b1fe-8b955f23d2b1.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326448378,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-4_ed5f707d-5f41-4e83-a252-f36c2fefd5c0.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-4_ed5f707d-5f41-4e83-a252-f36c2fefd5c0.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326546682,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250110-Brown-6_7a0121c3-8342-45e5-aef1-50998a18b825.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250110-Brown-6_7a0121c3-8342-45e5-aef1-50998a18b825.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327234810,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Black-1_d0ef4388-0b2a-4dd1-a423-14465f1e616f.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Black-1_d0ef4388-0b2a-4dd1-a423-14465f1e616f.jpg?v=1756196852",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327333114,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Black-4_37f15fa5-4702-47d0-b77f-862cd214d63e.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Black-4_37f15fa5-4702-47d0-b77f-862cd214d63e.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327267578,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Black-2_2a068bb8-b9bc-4cb3-9062-a9cbc6cda355.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Black-2_2a068bb8-b9bc-4cb3-9062-a9cbc6cda355.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327300346,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Black-3_a82ead46-ccdf-42b1-b7dd-92c047e042b8.jpg?v=1756196852"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Black-3_a82ead46-ccdf-42b1-b7dd-92c047e042b8.jpg?v=1756196852",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327365882,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Champagne-1_7bec0c71-4a29-49d4-aad2-34124a9e7b2f.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Champagne-1_7bec0c71-4a29-49d4-aad2-34124a9e7b2f.jpg?v=1756196853",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327464186,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Champagne-4_9f0ef89a-c9c7-4090-a1d2-c8fc89b29ce9.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Champagne-4_9f0ef89a-c9c7-4090-a1d2-c8fc89b29ce9.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327398650,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Champagne-2_ef90970f-1da0-49fc-8f1d-9898631c21e6.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Champagne-2_ef90970f-1da0-49fc-8f1d-9898631c21e6.jpg?v=1756196853",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327431418,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Champagne-3_bbbc53c0-b39c-4946-95ea-ec11918aef7c.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Champagne-3_bbbc53c0-b39c-4946-95ea-ec11918aef7c.jpg?v=1756196853",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327660794,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Grey-1_c559e2e6-784b-471b-ba28-b9edbc9d8bef.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Grey-1_c559e2e6-784b-471b-ba28-b9edbc9d8bef.jpg?v=1756196853",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327759098,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Grey-4_ad274284-3244-41cb-b3b4-ab010387c11f.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Grey-4_ad274284-3244-41cb-b3b4-ab010387c11f.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327693562,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Grey-2_40b4f5aa-0436-4ff5-a2e0-4be509e3f26c.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Grey-2_40b4f5aa-0436-4ff5-a2e0-4be509e3f26c.jpg?v=1756196853",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327726330,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Grey-3_0b55f06c-a86c-485a-a113-ac19a74da71d.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Grey-3_0b55f06c-a86c-485a-a113-ac19a74da71d.jpg?v=1756196853",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327103738,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250523-Azure-1_977305ca-36ba-4db9-bf4e-80dd1292c218.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Azure-1_977305ca-36ba-4db9-bf4e-80dd1292c218.jpg?v=1756196853",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327202042,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Azure-4_4ac684a4-0e09-4bd1-8b49-7df3c4fcaf1f.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Azure-4_4ac684a4-0e09-4bd1-8b49-7df3c4fcaf1f.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327136506,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Azure-2_223b383a-244a-4a67-bbbd-b78fd7003dc2.jpg?v=1756196853"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Azure-2_223b383a-244a-4a67-bbbd-b78fd7003dc2.jpg?v=1756196853",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327169274,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Azure-3_481746a2-6817-4669-8884-056f995c38a7.jpg?v=1756196854"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Azure-3_481746a2-6817-4669-8884-056f995c38a7.jpg?v=1756196854",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326874362,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Ebony-1_4165fd08-6cf0-40eb-b63d-5be0dc18fc8a.jpg?v=1756196854"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Ebony-1_4165fd08-6cf0-40eb-b63d-5be0dc18fc8a.jpg?v=1756196854",
				"width": 2000
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326907130,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Ebony-2_480f6ac8-c904-4bfb-aa8a-26fd94088abd.jpg?v=1756196854"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Ebony-2_480f6ac8-c904-4bfb-aa8a-26fd94088abd.jpg?v=1756196854",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078326939898,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Ebony-3_0601c985-0293-497b-a89b-61eeaa64ab77.jpg?v=1756196854"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Ebony-3_0601c985-0293-497b-a89b-61eeaa64ab77.jpg?v=1756196854",
				"width": 1999
			},
			{
				"alt": "Moonlit Velvet Custom Curtain - TheHues",
				"id": 36078327628026,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250523-Ebony-4_a1b9ff36-d0c1-4785-9630-525c93b1d7d0.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250523-Ebony-4_a1b9ff36-d0c1-4785-9630-525c93b1d7d0.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit 4 Layers Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36445745905914,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/image_1.jpg?v=1758274586"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image_1.jpg?v=1758274586",
				"width": 2000
			},
			{
				"alt": "Moonlit 4 Layers Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36445745971450,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/image_2.jpg?v=1761214052"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image_2.jpg?v=1761214052",
				"width": 1999
			},
			{
				"alt": "Moonlit 4 Layers Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36445745873146,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/image_3.jpg?v=1758274586"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image_3.jpg?v=1758274586",
				"width": 1999
			},
			{
				"alt": "Moonlit 4 Layers Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain - TheHues",
				"id": 36445745938682,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/image_4.jpg?v=1758274586"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image_4.jpg?v=1758274586",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Moonlit Shimmering Velvet curtains capture the soft glow of moonlight, draping your space in an aura of sophistication and timeless beauty.</p>",
		"url": "/products/moonlit-velvet-textured-custom-curtain",
		"regular_price": "$108.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780126585082,
		"title": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain",
		"handle": "florence-100-blackout-oeko-heavyweight-woven-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: OEKO-TEX Certified Safe Fabric<br>Weight: Heavy Weight (430g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Do not dry clean</p>`,
		"description": "<p>Florence curtains bring a refined charm with their textured linen-look fabric that is 100% blackout.</p>",
		"published_at": "2025-05-13T14:26:44+08:00",
		"created_at": "2025-05-07T16:32:31+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Blackout",
			"can't memory",
			"Curtains",
			"indoor curtain",
			"july sale"
		],
		"price": 12900,
		"price_min": 12900,
		"price_max": 12900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319449403642,
				"title": "Ash Pink",
				"option1": "Ash Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-1726-SD-Ash Pink",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44036692803834,
					"product_id": 8780126585082,
					"position": 1,
					"created_at": "2025-05-22T15:50:30+08:00",
					"updated_at": "2025-09-01T15:15:08+08:00",
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-1_1__resolution-standardv2-2x_de4a8175-84e1-4221-9fc7-4b7e54327362.jpg?v=1756710908",
					"variant_ids": [
						47319449403642
					]
				},
				"available": true,
				"name": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - Ash Pink",
				"public_title": "Ash Pink",
				"options": [
					"Ash Pink"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"id": 36071085244666,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-1_1__resolution-standardv2-2x_de4a8175-84e1-4221-9fc7-4b7e54327362.jpg?v=1756710908"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aash-pink-4-300x300-1_resolution-standardv2-2x_f56206c6-7c68-4fb0-baa4-3b4400744eb4_1024x1024.jpg?v=1756710908"
			},
			{
				"id": 47319449436410,
				"title": "Light Silver",
				"option1": "Light Silver",
				"option2": null,
				"option3": null,
				"sku": "THC-1726-SD-Light Silver",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44036693557498,
					"product_id": 8780126585082,
					"position": 6,
					"created_at": "2025-05-22T15:50:39+08:00",
					"updated_at": "2025-09-01T15:15:08+08:00",
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Alight-silver-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
					"variant_ids": [
						47319449436410
					]
				},
				"available": true,
				"name": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - Light Silver",
				"public_title": "Light Silver",
				"options": [
					"Light Silver"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"id": 36071086129402,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Alight-silver-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Alight-silver-4-300x300-1_resolution-standardv2-2x_1024x1024.jpg?v=1756710908"
			},
			{
				"id": 47319449469178,
				"title": "Oat",
				"option1": "Oat",
				"option2": null,
				"option3": null,
				"sku": "THC-1726-SD-Oat",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44036693950714,
					"product_id": 8780126585082,
					"position": 11,
					"created_at": "2025-05-22T15:50:45+08:00",
					"updated_at": "2025-09-01T15:15:08+08:00",
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Aoat-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
					"variant_ids": [
						47319449469178
					]
				},
				"available": true,
				"name": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - Oat",
				"public_title": "Oat",
				"options": [
					"Oat"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"id": 36071086260474,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Aoat-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aoat-4-300x300-1_resolution-standardv2-2x_1024x1024.jpg?v=1756710908"
			},
			{
				"id": 47319449501946,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-1726-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44036693426426,
					"product_id": 8780126585082,
					"position": 16,
					"created_at": "2025-05-22T15:50:38+08:00",
					"updated_at": "2025-09-01T15:15:08+08:00",
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
					"variant_ids": [
						47319449501946
					]
				},
				"available": true,
				"name": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"id": 36071085998330,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abeige-4-300x300-1_resolution-standardv2-2x_1024x1024.jpg?v=1756710908"
			},
			{
				"id": 47319449534714,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-1726-SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44036694114554,
					"product_id": 8780126585082,
					"position": 21,
					"created_at": "2025-05-22T15:50:47+08:00",
					"updated_at": "2025-09-01T15:15:08+08:00",
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Awhite-4-1-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
					"variant_ids": [
						47319449534714
					]
				},
				"available": true,
				"name": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
					"id": 36071086391546,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Awhite-4-1-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Awhite-4-1-300x300-1_resolution-standardv2-2x_03ed9018-ecec-4750-9b06-7db10345829c_1024x1024.jpg?v=1756710908"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Aash-pink-4-copy-1_1__resolution-standardv2-2x_de4a8175-84e1-4221-9fc7-4b7e54327362.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-ashpink.jpg?v=1761205096",
			"//thehues.com/cdn/shop/files/Aash-pink-4-copy-2_2__resolution-standardv2-2x_3c4a81fb-c791-42d9-9cca-7d7816e7170e.jpg?v=1756710917",
			"//thehues.com/cdn/shop/files/Aash-pink-4-300x300-1_resolution-standardv2-2x_f56206c6-7c68-4fb0-baa4-3b4400744eb4.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Aash-pink-3-1_4__resolution-standardv2-2x_8725cc0d-4dc9-46b2-8cfe-e292d731c977.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Alight-silver-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Alight-silver-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-lightsilver.jpg?v=1761205096",
			"//thehues.com/cdn/shop/files/Alight-silver-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Alight-silver-3_3__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Aoat-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Aoat-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-oat.jpg?v=1761205096",
			"//thehues.com/cdn/shop/files/Aoat-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Aoat-3_3__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Abeige-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Abeige-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-beige.jpg?v=1761205096",
			"//thehues.com/cdn/shop/files/Abeige-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Abeige-3-4_3__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Awhite-4-1-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Awhite-4-1-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-white.jpg?v=1761205096",
			"//thehues.com/cdn/shop/files/Awhite-4-1-300x300-1_resolution-standardv2-2x_03ed9018-ecec-4750-9b06-7db10345829c.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Awhite-3-1_3__resolution-standardv2-2x_a9cdeec9-1647-4f1f-8a69-4ab1d44b0769.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Aashpink.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Abeige.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Alightsilver.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/Aoat.jpg?v=1756710908",
			"//thehues.com/cdn/shop/files/White.jpg?v=1756710908"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-1_1__resolution-standardv2-2x_de4a8175-84e1-4221-9fc7-4b7e54327362_1024x1024.jpg?v=1756710908",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071085244666,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-1_1__resolution-standardv2-2x_de4a8175-84e1-4221-9fc7-4b7e54327362.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-1_1__resolution-standardv2-2x_de4a8175-84e1-4221-9fc7-4b7e54327362.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain - TheHues",
				"id": 36700574286074,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-ashpink.jpg?v=1761205096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-ashpink.jpg?v=1761205096",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071085506810,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-2_2__resolution-standardv2-2x_3c4a81fb-c791-42d9-9cca-7d7816e7170e.jpg?v=1756710917"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash-pink-4-copy-2_2__resolution-standardv2-2x_3c4a81fb-c791-42d9-9cca-7d7816e7170e.jpg?v=1756710917",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071083868410,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash-pink-4-300x300-1_resolution-standardv2-2x_f56206c6-7c68-4fb0-baa4-3b4400744eb4.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash-pink-4-300x300-1_resolution-standardv2-2x_f56206c6-7c68-4fb0-baa4-3b4400744eb4.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071083835642,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aash-pink-3-1_4__resolution-standardv2-2x_8725cc0d-4dc9-46b2-8cfe-e292d731c977.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aash-pink-3-1_4__resolution-standardv2-2x_8725cc0d-4dc9-46b2-8cfe-e292d731c977.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086129402,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-silver-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-silver-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086162170,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-silver-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-silver-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain - TheHues",
				"id": 36700574318842,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-lightsilver.jpg?v=1761205096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-lightsilver.jpg?v=1761205096",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086096634,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-silver-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-silver-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086194938,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alight-silver-3_3__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alight-silver-3_3__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086260474,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086293242,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain - TheHues",
				"id": 36700574384378,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-oat.jpg?v=1761205096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-oat.jpg?v=1761205096",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086227706,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086326010,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat-3_3__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat-3_3__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071085998330,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-4-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086031098,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-4-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain - TheHues",
				"id": 36700574351610,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-beige.jpg?v=1761205096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-beige.jpg?v=1761205096",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071085965562,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-4-300x300-1_resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086063866,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3-4_3__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3-4_3__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086391546,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-4-1-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-4-1-copy-1_1__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086424314,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-4-1-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-4-1-copy-2_2__resolution-standardv2-2x.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain - TheHues",
				"id": 36700574253306,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-white.jpg?v=1761205096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/florence-blackout--heavyweight-woven-textured-custom-curtain-white.jpg?v=1761205096",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086358778,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-4-1-300x300-1_resolution-standardv2-2x_03ed9018-ecec-4750-9b06-7db10345829c.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-4-1-300x300-1_resolution-standardv2-2x_03ed9018-ecec-4750-9b06-7db10345829c.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36071086457082,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-3-1_3__resolution-standardv2-2x_a9cdeec9-1647-4f1f-8a69-4ab1d44b0769.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-3-1_3__resolution-standardv2-2x_a9cdeec9-1647-4f1f-8a69-4ab1d44b0769.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36156815540474,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aashpink.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aashpink.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36156815606010,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36156815638778,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Alightsilver.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Alightsilver.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36156815671546,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aoat.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aoat.jpg?v=1756710908",
				"width": 2000
			},
			{
				"alt": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain - TheHues",
				"id": 36156815704314,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/White.jpg?v=1756710908"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/White.jpg?v=1756710908",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Florence curtains bring a refined charm with their textured linen-look fabric that is 100% blackout.</p>",
		"url": "/products/florence-100-blackout-oeko-heavyweight-woven-textured-custom-curtain",
		"regular_price": "$129.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780124750074,
		"title": "Manhattan Linen Blend Grid Sheer Custom Curtain",
		"handle": "manhattan-linen-blend-grid-sheer-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 95%Polyester &amp; 5% Linen<br>Features: Unique Meteor Fabric<br>Weight: Sheer (160g/㎡)Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>These fishnet grid sheer curtains are crafted with a delicate yarn, creating a beautiful texture that softens the light as it filters through.</p>",
		"published_at": "2025-05-07T16:31:28+08:00",
		"created_at": "2025-05-07T16:31:28+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > New Sheer Curtains",
			"All Curtains > pinch pleat custom curtains",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Easter Sale",
			"Extra 10%",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Search sheer"
		],
		"price": 10700,
		"price_min": 10700,
		"price_max": 10700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319428432122,
				"title": "White Gold",
				"option1": "White Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-LA040-C-White Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037606342906,
					"product_id": 8780124750074,
					"position": 1,
					"created_at": "2025-05-22T18:21:17+08:00",
					"updated_at": "2025-08-26T16:26:09+08:00",
					"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-1_resolution-standardv2-2x.jpg?v=1756196769",
					"variant_ids": [
						47319428432122
					]
				},
				"available": true,
				"name": "Manhattan Linen Blend Grid Sheer Custom Curtain - White Gold",
				"public_title": "White Gold",
				"options": [
					"White Gold"
				],
				"price": 10700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
					"id": 36071628472570,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-1_resolution-standardv2-2x.jpg?v=1756196769"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Amanhattan_whitegold_1024x1024.png?v=1751334996"
			},
			{
				"id": 47319428464890,
				"title": "Black Gold",
				"option1": "Black Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-LA040-C-Black Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037605589242,
					"product_id": 8780124750074,
					"position": 9,
					"created_at": "2025-05-22T18:21:08+08:00",
					"updated_at": "2025-08-26T16:26:10+08:00",
					"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-1_resolution-standardv2-2x.jpg?v=1756196770",
					"variant_ids": [
						47319428464890
					]
				},
				"available": true,
				"name": "Manhattan Linen Blend Grid Sheer Custom Curtain - Black Gold",
				"public_title": "Black Gold",
				"options": [
					"Black Gold"
				],
				"price": 10700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
					"id": 36071628308730,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-1_resolution-standardv2-2x.jpg?v=1756196770"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Amanhattan_blackgold_1024x1024.png?v=1751334524"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold-1_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold-3_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold-7_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold-6_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold-2_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20241127-AWhite-Gold-5_resolution-standardv2-2x.jpg?v=1756196769",
			"//thehues.com/cdn/shop/files/20250516-AWhite-Gold-4_resolution-standardv2-2x.jpg?v=1761209681",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-1_resolution-standardv2-2x.jpg?v=1756196770",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-7_resolution-standardv2-2x.jpg?v=1756196770",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-2_resolution-standardv2-2x.jpg?v=1756196770",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-3_resolution-standardv2-2x.jpg?v=1756196770",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-6_resolution-standardv2-2x.jpg?v=1756196770",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-8_resolution-standardv2-2x.jpg?v=1761209681",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-4_resolution-standardv2-2x.jpg?v=1756196770",
			"//thehues.com/cdn/shop/files/20250516-ABlack-Gold-5_resolution-standardv2-2x.jpg?v=1756196770"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196769",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628472570,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-1_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-1_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628538106,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-3_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-3_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628439802,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628636410,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-7_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-7_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628603642,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-6_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-6_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628505338,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-2_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-2_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628570874,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-5_resolution-standardv2-2x.jpg?v=1756196769"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20241127-AWhite-Gold-5_resolution-standardv2-2x.jpg?v=1756196769",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628669178,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AWhite-Gold-4_resolution-standardv2-2x.jpg?v=1761209681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AWhite-Gold-4_resolution-standardv2-2x.jpg?v=1761209681",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628308730,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-1_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-1_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628243194,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-7_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-7_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628341498,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-2_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-2_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628112122,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-3_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-3_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628210426,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-6_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-6_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628275962,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-8_resolution-standardv2-2x.jpg?v=1761209681"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-8_resolution-standardv2-2x.jpg?v=1761209681",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628144890,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-4_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-4_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			},
			{
				"alt": "Manhattan Linen Blend Grid Sheer Custom Curtain - TheHues",
				"id": 36071628177658,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-5_resolution-standardv2-2x.jpg?v=1756196770"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-Gold-5_resolution-standardv2-2x.jpg?v=1756196770",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>These fishnet grid sheer curtains are crafted with a delicate yarn, creating a beautiful texture that softens the light as it filters through.</p>",
		"url": "/products/manhattan-linen-blend-grid-sheer-custom-curtain",
		"regular_price": "$107.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780122390778,
		"title": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain",
		"handle": "peacock-linen-blend-heavyweight-floral-patterned-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 93% Polyester &amp; 7% Linen<br>Features: Unique Printed Fabric<br>Weight: Heavy Weight (450g/㎡)<br>Softness: Firmer</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do not bleach</p><p>Iron on Low Temp</p><p>Any solvent except tetrachlorethylene</p>`,
		"description": "<p>Bold yet serene, The Peacock Printed Curtain blends nature's timeless motifs with the sophistication of a linen blend, offering a harmonious touch of elegance that transforms your space.</p>",
		"published_at": "2025-05-07T16:30:18+08:00",
		"created_at": "2025-05-07T16:30:18+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > floral custom curtains",
			"All Curtains > heavyweight custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > vintage custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Easter Sale",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat"
		],
		"price": 11600,
		"price_min": 11600,
		"price_max": 11600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319414997242,
				"title": "Summer",
				"option1": "Summer",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF020-C-Summer",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037156372730,
					"product_id": 8780122390778,
					"position": 5,
					"created_at": "2025-05-22T17:37:49+08:00",
					"updated_at": "2025-09-04T16:59:07+08:00",
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-Asummer-2_resolution-standardv2-2x.jpg?v=1756976347",
					"variant_ids": [
						47319414997242
					]
				},
				"available": true,
				"name": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - Summer",
				"public_title": "Summer",
				"options": [
					"Summer"
				],
				"price": 11600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
					"id": 36071387627770,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-Asummer-2_resolution-standardv2-2x.jpg?v=1756976347"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apeacock_summer_1024x1024.png?v=1756976283"
			},
			{
				"id": 47319415030010,
				"title": "Fall",
				"option1": "Fall",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF020-C-Fall",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037154767098,
					"product_id": 8780122390778,
					"position": 11,
					"created_at": "2025-05-22T17:37:11+08:00",
					"updated_at": "2025-09-04T16:58:23+08:00",
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x-2.jpg?v=1756976303",
					"variant_ids": [
						47319415030010
					]
				},
				"available": true,
				"name": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - Fall",
				"public_title": "Fall",
				"options": [
					"Fall"
				],
				"price": 11600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
					"id": 36071386874106,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x-2.jpg?v=1756976303"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apeacock_fall_1024x1024.jpg?v=1756976283"
			},
			{
				"id": 47319414931706,
				"title": "Spring",
				"option1": "Spring",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF020-C-Spring",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037155782906,
					"product_id": 8780122390778,
					"position": 3,
					"created_at": "2025-05-22T17:37:41+08:00",
					"updated_at": "2025-09-04T17:57:09+08:00",
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-41_resolution-standardv2-2x.jpg?v=1756979829",
					"variant_ids": [
						47319414931706
					]
				},
				"available": true,
				"name": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - Spring",
				"public_title": "Spring",
				"options": [
					"Spring"
				],
				"price": 11600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
					"id": 36071387234554,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-AFrame-41_resolution-standardv2-2x.jpg?v=1756979829"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apeacock_spring_1024x1024.png?v=1756976283"
			},
			{
				"id": 47319414964474,
				"title": "Winter",
				"option1": "Winter",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF020-C-Winter",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037156503802,
					"product_id": 8780122390778,
					"position": 20,
					"created_at": "2025-05-22T17:37:50+08:00",
					"updated_at": "2025-09-04T17:57:09+08:00",
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-42_resolution-standardv2-2x.jpg?v=1756979829",
					"variant_ids": [
						47319414964474
					]
				},
				"available": true,
				"name": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - Winter",
				"public_title": "Winter",
				"options": [
					"Winter"
				],
				"price": 11600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
					"id": 36071387726074,
					"position": 20,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-AFrame-42_resolution-standardv2-2x.jpg?v=1756979829"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apeacock_winter_1024x1024.png?v=1756976283"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Front.jpg?v=1756976347",
			"//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-summer.jpg?v=1761213522",
			"//thehues.com/cdn/shop/files/20250516-AFrame-41_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-spring.jpg?v=1761213522",
			"//thehues.com/cdn/shop/files/20250116-Asummer-2_resolution-standardv2-2x.jpg?v=1756976347",
			"//thehues.com/cdn/shop/files/20250116-Asummer-3_resolution-standardv2-2x.jpg?v=1756976347",
			"//thehues.com/cdn/shop/files/20250116-Asummer-5_resolution-standardv2-2x.jpg?v=1756976347",
			"//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Puddle.jpg?v=1756976347",
			"//thehues.com/cdn/shop/files/20250116-Asummer-6_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/20250116-Asummer-1_resolution-standardv2-2x-2.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x-2.jpg?v=1756976303",
			"//thehues.com/cdn/shop/files/20250116-Afall-3-5_resolution-standardv2-2x.jpg?v=1756976303",
			"//thehues.com/cdn/shop/files/20250116-Afall-3-2_resolution-standardv2-2x-2.jpg?v=1756976303",
			"//thehues.com/cdn/shop/files/20250516-AFall-2_resolution-standardv2-2x.jpg?v=1756976303",
			"//thehues.com/cdn/shop/files/20250116-Afall-3-3_resolution-standardv2-2x-2.jpg?v=1756976303",
			"//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-fall.jpg?v=1761213522",
			"//thehues.com/cdn/shop/files/20240523-Afall-3-2_resolution-standardv2-2x.jpg?v=1756976303",
			"//thehues.com/cdn/shop/files/20240523-Afall-3-3_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/20250516-AFrame-42_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-winter.jpg?v=1761213522",
			"//thehues.com/cdn/shop/files/20250116-Afall-3-4_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/20250516-AFall-1_resolution-standardv2-2x.jpg?v=1756976283",
			"//thehues.com/cdn/shop/files/20240523-AFall-2_resolution-standardv2-2x.jpg?v=1756976283",
			"//thehues.com/cdn/shop/files/20240523-AFall-3_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/20250516-AFall-2_resolution-standardv2-2x-2.jpg?v=1756976283",
			"//thehues.com/cdn/shop/files/20250516-AFall-3_resolution-standardv2-2x-2.jpg?v=1756976283",
			"//thehues.com/cdn/shop/files/20250516-AFall-4_resolution-standardv2-2x.jpg?v=1756979829",
			"//thehues.com/cdn/shop/files/Apeacock_summer.png?v=1756976283",
			"//thehues.com/cdn/shop/files/Apeacock_spring.png?v=1756976283",
			"//thehues.com/cdn/shop/files/Apeacock_winter.png?v=1756976283",
			"//thehues.com/cdn/shop/files/Apeacock_fall.jpg?v=1756976283"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Front_1024x1024.jpg?v=1756976347",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387562234,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Front.jpg?v=1756976347"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Front.jpg?v=1756976347",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36732822126842,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-summer.jpg?v=1761213522"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-summer.jpg?v=1761213522",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071387234554,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-41_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-41_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36732822094074,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-spring.jpg?v=1761213522"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-spring.jpg?v=1761213522",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387627770,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asummer-2_resolution-standardv2-2x.jpg?v=1756976347"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asummer-2_resolution-standardv2-2x.jpg?v=1756976347",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387660538,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asummer-3_resolution-standardv2-2x.jpg?v=1756976347"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asummer-3_resolution-standardv2-2x.jpg?v=1756976347",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387693306,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asummer-5_resolution-standardv2-2x.jpg?v=1756976347"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asummer-5_resolution-standardv2-2x.jpg?v=1756976347",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387529466,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Puddle.jpg?v=1756976347"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Peacock_Linen_Blend_Summer_Puddle.jpg?v=1756976347",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071387496698,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asummer-6_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asummer-6_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071387595002,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Asummer-1_resolution-standardv2-2x-2.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asummer-1_resolution-standardv2-2x-2.jpg?v=1756979829",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071386874106,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x-2.jpg?v=1756976303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x-2.jpg?v=1756976303",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071386710266,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-5_resolution-standardv2-2x.jpg?v=1756976303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-5_resolution-standardv2-2x.jpg?v=1756976303",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071386906874,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-2_resolution-standardv2-2x-2.jpg?v=1756976303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-2_resolution-standardv2-2x-2.jpg?v=1756976303",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071386743034,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFall-2_resolution-standardv2-2x.jpg?v=1756976303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFall-2_resolution-standardv2-2x.jpg?v=1756976303",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071386939642,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-3_resolution-standardv2-2x-2.jpg?v=1756976303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-3_resolution-standardv2-2x-2.jpg?v=1756976303",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36732821537018,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-fall.jpg?v=1761213522"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-fall.jpg?v=1761213522",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071386775802,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240523-Afall-3-2_resolution-standardv2-2x.jpg?v=1756976303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-Afall-3-2_resolution-standardv2-2x.jpg?v=1756976303",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071386808570,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240523-Afall-3-3_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-Afall-3-3_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071386841338,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071387726074,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-42_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-42_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36732822159610,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-winter.jpg?v=1761213522"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain-winter.jpg?v=1761213522",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071386972410,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-4_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Afall-3-4_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387332858,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFall-1_resolution-standardv2-2x.jpg?v=1756976283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFall-1_resolution-standardv2-2x.jpg?v=1756976283",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387267322,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240523-AFall-2_resolution-standardv2-2x.jpg?v=1756976283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-AFall-2_resolution-standardv2-2x.jpg?v=1756976283",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071387300090,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240523-AFall-3_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-AFall-3_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 2000
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387365626,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFall-2_resolution-standardv2-2x-2.jpg?v=1756976283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFall-2_resolution-standardv2-2x-2.jpg?v=1756976283",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36071387398394,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFall-3_resolution-standardv2-2x-2.jpg?v=1756976283"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFall-3_resolution-standardv2-2x-2.jpg?v=1756976283",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Cafe Curtain - TheHues",
				"id": 36071387431162,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFall-4_resolution-standardv2-2x.jpg?v=1756979829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFall-4_resolution-standardv2-2x.jpg?v=1756979829",
				"width": 1999
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36300930547962,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 207,
					"width": 200,
					"src": "//thehues.com/cdn/shop/files/Apeacock_summer.png?v=1756976283"
				},
				"aspect_ratio": 0.966,
				"height": 207,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apeacock_summer.png?v=1756976283",
				"width": 200
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36300930482426,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 207,
					"width": 200,
					"src": "//thehues.com/cdn/shop/files/Apeacock_spring.png?v=1756976283"
				},
				"aspect_ratio": 0.966,
				"height": 207,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apeacock_spring.png?v=1756976283",
				"width": 200
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36300930416890,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.966,
					"height": 207,
					"width": 200,
					"src": "//thehues.com/cdn/shop/files/Apeacock_winter.png?v=1756976283"
				},
				"aspect_ratio": 0.966,
				"height": 207,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apeacock_winter.png?v=1756976283",
				"width": 200
			},
			{
				"alt": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain - TheHues",
				"id": 36300930384122,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 200,
					"width": 200,
					"src": "//thehues.com/cdn/shop/files/Apeacock_fall.jpg?v=1756976283"
				},
				"aspect_ratio": 1,
				"height": 200,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apeacock_fall.jpg?v=1756976283",
				"width": 200
			},
			{
				"alt": null,
				"id": 36106548412666,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/33146098e5794a1f826f5d43b4a97624.thumbnail.0000000000.jpg?v=1748510527"
				},
				"aspect_ratio": 0.563,
				"duration": 15420,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/33146098e5794a1f826f5d43b4a97624/33146098e5794a1f826f5d43b4a97624.SD-480p-0.9Mbps-48442559.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/33146098e5794a1f826f5d43b4a97624/33146098e5794a1f826f5d43b4a97624.HD-1080p-2.5Mbps-48442559.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/33146098e5794a1f826f5d43b4a97624/33146098e5794a1f826f5d43b4a97624.HD-720p-1.6Mbps-48442559.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/33146098e5794a1f826f5d43b4a97624/33146098e5794a1f826f5d43b4a97624.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bold yet serene, The Peacock Printed Curtain blends nature's timeless motifs with the sophistication of a linen blend, offering a harmonious touch of elegance that transforms your space.</p>",
		"url": "/products/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain",
		"regular_price": "$116.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780122587386,
		"title": "Aztec Linen Blend Woven Patterned Custom Curtain",
		"handle": "aztec-linen-blend-woven-patterned-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 95% Polyester 5% Linen<br>Features: Unique Textured Fabric</p><p>Weight: Regular (370g/㎡)<br>Softness:Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Rooted in ancient artistry, Aztek weaves tribal sophistication into a linen blend. Its soft texture and timeless patterns bring a sense of history and elegance to your space.</p>",
		"published_at": "2025-05-07T16:30:23+08:00",
		"created_at": "2025-05-07T16:30:23+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > black custom curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > geometric custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Extra 10%",
			"fall sale",
			"flash_categories",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"july sale",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat"
		],
		"price": 10200,
		"price_min": 10200,
		"price_max": 10200,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319463395578,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-1342405-6-661-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037283709178,
					"product_id": 8780122587386,
					"position": 1,
					"created_at": "2025-05-22T17:49:29+08:00",
					"updated_at": "2025-08-26T16:28:04+08:00",
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-4_resolution-standardv2-2x.jpg?v=1756196884",
					"variant_ids": [
						47319463395578
					]
				},
				"available": true,
				"name": "Aztec Linen Blend Woven Patterned Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"id": 36071455817978,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-4_resolution-standardv2-2x.jpg?v=1756196884"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-display-2_resolution-standardv2-2x_1024x1024.jpg?v=1756196884"
			},
			{
				"id": 47319463461114,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-1342405-6-661-C-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037283578106,
					"product_id": 8780122587386,
					"position": 3,
					"created_at": "2025-05-22T17:49:29+08:00",
					"updated_at": "2025-10-24T10:50:58+08:00",
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Awhite_resolution-standardv2-2x.jpg?v=1761274258",
					"variant_ids": [
						47319463461114
					]
				},
				"available": true,
				"name": "Aztec Linen Blend Woven Patterned Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"id": 36071455752442,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Awhite_resolution-standardv2-2x.jpg?v=1761274258"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Awhite_resolution-standardv2-2x_1024x1024.jpg?v=1761274258"
			},
			{
				"id": 47319463428346,
				"title": "Lavender Grey",
				"option1": "Lavender Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1342405-6-661-C-Lavender Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037283545338,
					"product_id": 8780122587386,
					"position": 4,
					"created_at": "2025-05-22T17:49:29+08:00",
					"updated_at": "2025-10-24T10:50:58+08:00",
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-ALavenderGrey_resolution-standardv2-2x.jpg?v=1761274258",
					"variant_ids": [
						47319463428346
					]
				},
				"available": true,
				"name": "Aztec Linen Blend Woven Patterned Custom Curtain - Lavender Grey",
				"public_title": "Lavender Grey",
				"options": [
					"Lavender Grey"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"id": 36071455686906,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-ALavenderGrey_resolution-standardv2-2x.jpg?v=1761274258"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ALavenderGrey_resolution-standardv2-2x_1024x1024.jpg?v=1761274258"
			},
			{
				"id": 47319463362810,
				"title": "Light Taro",
				"option1": "Light Taro",
				"option2": null,
				"option3": null,
				"sku": "THC-1342405-6-661-C-Light Taro",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037283643642,
					"product_id": 8780122587386,
					"position": 5,
					"created_at": "2025-05-22T17:49:29+08:00",
					"updated_at": "2025-10-24T10:50:58+08:00",
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Alighttara_resolution-standardv2-2x.jpg?v=1761274258",
					"variant_ids": [
						47319463362810
					]
				},
				"available": true,
				"name": "Aztec Linen Blend Woven Patterned Custom Curtain - Light Taro",
				"public_title": "Light Taro",
				"options": [
					"Light Taro"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
					"id": 36071455719674,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Alighttara_resolution-standardv2-2x.jpg?v=1761274258"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Alighttara_resolution-standardv2-2x_1024x1024.jpg?v=1761274258"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240522-A2405-6-661-4_resolution-standardv2-2x.jpg?v=1756196884",
			"//thehues.com/cdn/shop/files/20250516-A2405-6-661-2_resolution-standardv2-2x-2.jpg?v=1756196884",
			"//thehues.com/cdn/shop/files/20250516-Awhite_resolution-standardv2-2x.jpg?v=1761274258",
			"//thehues.com/cdn/shop/files/20250516-ALavenderGrey_resolution-standardv2-2x.jpg?v=1761274258",
			"//thehues.com/cdn/shop/files/20250516-Alighttara_resolution-standardv2-2x.jpg?v=1761274258",
			"//thehues.com/cdn/shop/files/20250516-A2405-6-661-display-2_resolution-standardv2-2x.jpg?v=1756196884",
			"//thehues.com/cdn/shop/files/20240522-A2405-6-661-1_resolution-standardv2-2x.jpg?v=1756196884",
			"//thehues.com/cdn/shop/files/20250516-A2405-6-661-4_resolution-standardv2-2x-2.jpg?v=1756196885",
			"//thehues.com/cdn/shop/files/20250516-A2405-6-661-2_resolution-standardv2-2x.jpg?v=1756196885",
			"//thehues.com/cdn/shop/files/20250516-2405-6-661-display-2.jpg?v=1761274258",
			"//thehues.com/cdn/shop/files/20250516-A2405-6-661-3_resolution-standardv2-2x.jpg?v=1756196885",
			"//thehues.com/cdn/shop/files/20250516-A2405-6-661-1_resolution-standardv2-2x-2.jpg?v=1756196885"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-4_resolution-standardv2-2x_1024x1024.jpg?v=1756196884",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455817978,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-4_resolution-standardv2-2x.jpg?v=1756196884"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-4_resolution-standardv2-2x.jpg?v=1756196884",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455949050,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-2_resolution-standardv2-2x-2.jpg?v=1756196884"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-2_resolution-standardv2-2x-2.jpg?v=1756196884",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455752442,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Awhite_resolution-standardv2-2x.jpg?v=1761274258"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Awhite_resolution-standardv2-2x.jpg?v=1761274258",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455686906,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ALavenderGrey_resolution-standardv2-2x.jpg?v=1761274258"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ALavenderGrey_resolution-standardv2-2x.jpg?v=1761274258",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455719674,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Alighttara_resolution-standardv2-2x.jpg?v=1761274258"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Alighttara_resolution-standardv2-2x.jpg?v=1761274258",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455654138,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-display-2_resolution-standardv2-2x.jpg?v=1756196884"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-display-2_resolution-standardv2-2x.jpg?v=1756196884",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455785210,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-1_resolution-standardv2-2x.jpg?v=1756196884"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-A2405-6-661-1_resolution-standardv2-2x.jpg?v=1756196884",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455621370,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-4_resolution-standardv2-2x-2.jpg?v=1756196885"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-4_resolution-standardv2-2x-2.jpg?v=1756196885",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455916282,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-2_resolution-standardv2-2x.jpg?v=1756196885"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-2_resolution-standardv2-2x.jpg?v=1756196885",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455850746,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-2405-6-661-display-2.jpg?v=1761274258"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-2405-6-661-display-2.jpg?v=1761274258",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455981818,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-3_resolution-standardv2-2x.jpg?v=1756196885"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-3_resolution-standardv2-2x.jpg?v=1756196885",
				"width": 1999
			},
			{
				"alt": "Aztec Linen Blend Woven Patterned Custom Curtain - TheHues",
				"id": 36071455883514,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-1_resolution-standardv2-2x-2.jpg?v=1756196885"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2405-6-661-1_resolution-standardv2-2x-2.jpg?v=1756196885",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Rooted in ancient artistry, Aztek weaves tribal sophistication into a linen blend. Its soft texture and timeless patterns bring a sense of history and elegance to your space.</p>",
		"url": "/products/aztec-linen-blend-woven-patterned-custom-curtain",
		"regular_price": "$102.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780119441658,
		"title": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain",
		"handle": "herringbone-4-layers-herringbone-chenille-soundproof-thermal-100-blackout-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Soundproof &amp; Thermal Insulation<br>Weight: Heavy Weight (898g/㎡)</p><p>Softness: Soft</p><p></p><h3>Care</h3><p>Dry wash only, do not clean not too frequently</p><p>Dryer safe on medium heat</p><p>Iron safe on backside only</p><p>Do not bleach</p><p>If curtains require cleaning — taking off lining is recommended</p>`,
		"description": "<p>Chenille curtains with a herringbone touch¡ªfour layers of soundproof, 100% blackout and thermal-insulated luxury for a home steeped in quiet sophistication.</p>",
		"published_at": "2025-05-07T16:29:11+08:00",
		"created_at": "2025-05-07T16:29:11+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"4 layer",
			"All Bestsellers",
			"All Curtains",
			"Black Friday",
			"Blackout",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Blackout Curtains",
			"Custom Blackout Curtains > Blackout Curtains",
			"Custom Blackout Curtains > Dustproof Curtains",
			"Custom Blackout Curtains > Soundproof Curtains",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Content",
			"New Year's Day",
			"Search blackout",
			"Search curtains",
			"Search dust",
			"Search soundproof",
			"Soundproof",
			"Soundproof & Blackout Curtains",
			"Spring Time Sale",
			"Thermal Curtains"
		],
		"price": 13900,
		"price_min": 13900,
		"price_max": 13900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47328941998330,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-86-4L-1",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996585689338,
					"product_id": 8780119441658,
					"position": 1,
					"created_at": "2025-05-17T17:19:16+08:00",
					"updated_at": "2025-09-01T16:39:05+08:00",
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-2_resolution-standard_v2-2x.jpg?v=1756715945",
					"variant_ids": [
						47328941998330
					]
				},
				"available": true,
				"name": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"id": 36046470086906,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-2_resolution-standard_v2-2x.jpg?v=1756715945"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Acream_resolution-high_fidelity_v2-2x_1024x1024.jpg?v=1756715945"
			},
			{
				"id": 47328942031098,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-86-4L-2",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996580577530,
					"product_id": 8780119441658,
					"position": 5,
					"created_at": "2025-05-17T17:18:41+08:00",
					"updated_at": "2025-09-01T16:39:05+08:00",
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1__resolution-standardv2-2x.jpg?v=1756715945",
					"variant_ids": [
						47328942031098
					]
				},
				"available": true,
				"name": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"id": 36046466711802,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-3_1__resolution-standardv2-2x.jpg?v=1756715945"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abeige-2-2_4__resolution-highfidelityv2-2x_1024x1024.jpg?v=1756715945"
			},
			{
				"id": 47328942063866,
				"title": "Pearl",
				"option1": "Pearl",
				"option2": null,
				"option3": null,
				"sku": "THC-86-4L-3",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996589392122,
					"product_id": 8780119441658,
					"position": 9,
					"created_at": "2025-05-17T17:19:40+08:00",
					"updated_at": "2025-09-01T16:39:05+08:00",
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-5_resolution-standard_v2-2x.jpg?v=1756715945",
					"variant_ids": [
						47328942063866
					]
				},
				"available": true,
				"name": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - Pearl",
				"public_title": "Pearl",
				"options": [
					"Pearl"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"id": 36046472610042,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-5_resolution-standard_v2-2x.jpg?v=1756715945"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apearl-2_resolution-high_fidelity_v2-2x_1024x1024.jpg?v=1756715945"
			},
			{
				"id": 47328942096634,
				"title": "Dust Blue",
				"option1": "Dust Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-86-4L-4",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996586180858,
					"product_id": 8780119441658,
					"position": 13,
					"created_at": "2025-05-17T17:19:21+08:00",
					"updated_at": "2025-09-01T16:39:05+08:00",
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-3_resolution-standard_v2-2x.jpg?v=1756715945",
					"variant_ids": [
						47328942096634
					]
				},
				"available": true,
				"name": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - Dust Blue",
				"public_title": "Dust Blue",
				"options": [
					"Dust Blue"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"id": 36046470414586,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-3_resolution-standard_v2-2x.jpg?v=1756715945"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Adustblue-2_resolution-high_fidelity_v2-2x_1024x1024.jpg?v=1756715945"
			},
			{
				"id": 47328942129402,
				"title": "Charcoal Gray",
				"option1": "Charcoal Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-86-4L-5",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996584182010,
					"product_id": 8780119441658,
					"position": 17,
					"created_at": "2025-05-17T17:19:12+08:00",
					"updated_at": "2025-09-01T16:39:05+08:00",
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-1_resolution-standard_v2-2x.jpg?v=1756715945",
					"variant_ids": [
						47328942129402
					]
				},
				"available": true,
				"name": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - Charcoal Gray",
				"public_title": "Charcoal Gray",
				"options": [
					"Charcoal Gray"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"id": 36046468940026,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-1_resolution-standard_v2-2x.jpg?v=1756715945"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47328942162170,
				"title": "Moss Green",
				"option1": "Moss Green",
				"option2": null,
				"option3": null,
				"sku": "THC-86-4L-6",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996587294970,
					"product_id": 8780119441658,
					"position": 21,
					"created_at": "2025-05-17T17:19:30+08:00",
					"updated_at": "2025-09-01T16:39:05+08:00",
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-4_resolution-standard_v2-2x.jpg?v=1756715945",
					"variant_ids": [
						47328942162170
					]
				},
				"available": true,
				"name": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - Moss Green",
				"public_title": "Moss Green",
				"options": [
					"Moss Green"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
					"id": 36046471299322,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-4_resolution-standard_v2-2x.jpg?v=1756715945"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Abeige-3_1_-2_resolution-standard_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-cream.jpg?v=1756715958",
			"//thehues.com/cdn/shop/files/Acream-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715958",
			"//thehues.com/cdn/shop/files/Acream-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-3_1__resolution-standardv2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-4_2__resolution-highfidelityv2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-beige.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-1_3__resolution-highfidelityv2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-3_1_-5_resolution-standard_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Apearl-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-peral.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Apearl-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-3_1_-3_resolution-standard_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Adustblue-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-blue.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Adustblue-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-3_1_-1_resolution-standard_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Acharcoal-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-grey.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Acharcoal-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-3_1_-4_resolution-standard_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Amoss-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-green.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Amoss-1-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Abeige-2-2_4__resolution-highfidelityv2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Apearl-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Amoss-2-1_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Acharcoal-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Acream-2_4__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Acream_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/Adustblue-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/4layers_9f9ca965-7cf2-4ce6-b754-6699ddcb126f.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/4-layers-3-1_7_copy_b0bc6fc2-a3e6-480d-a013-f1eb17cfb902.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/blackout_50747bbe-4333-422f-bcdc-2ee816dccee5.jpg?v=1756715945",
			"//thehues.com/cdn/shop/files/noise_df43bdb8-35bb-4485-87b8-3054d343dc80.jpg?v=1756715945"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Abeige-3_1_-2_resolution-standard_v2-2x_1024x1024.jpg?v=1756715945",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470086906,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-2_resolution-standard_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-2_resolution-standard_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36701104963834,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2653,
					"width": 2122,
					"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-cream.jpg?v=1756715958"
				},
				"aspect_ratio": 0.8,
				"height": 2653,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-cream.jpg?v=1756715958",
				"width": 2122
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470152442,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715958"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715958",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470054138,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046466711802,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1__resolution-standardv2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3_1__resolution-standardv2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046466744570,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-4_2__resolution-highfidelityv2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-4_2__resolution-highfidelityv2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36701104931066,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2653,
					"width": 2122,
					"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-beige.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2653,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-beige.jpg?v=1756715945",
				"width": 2122
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046466646266,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-1_3__resolution-highfidelityv2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-1_3__resolution-highfidelityv2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046472610042,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-5_resolution-standard_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-5_resolution-standard_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046472544506,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apearl-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apearl-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36701105029370,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2653,
					"width": 2122,
					"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-peral.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2653,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-peral.jpg?v=1756715945",
				"width": 2122
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046472413434,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apearl-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apearl-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470414586,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-3_resolution-standard_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-3_resolution-standard_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470512890,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adustblue-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adustblue-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36701105062138,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2653,
					"width": 2122,
					"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-blue.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2653,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-blue.jpg?v=1756715945",
				"width": 2122
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470447354,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adustblue-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adustblue-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046468940026,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-1_resolution-standard_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-1_resolution-standard_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046469234938,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acharcoal-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acharcoal-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36701103849722,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2653,
					"width": 2122,
					"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-grey.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2653,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-grey.jpg?v=1756715945",
				"width": 2122
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046468972794,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acharcoal-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acharcoal-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046471299322,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-4_resolution-standard_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-3_1_-4_resolution-standard_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046471364858,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-4_2__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36701104996602,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2653,
					"width": 2122,
					"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-green.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2653,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/herringbone-chenille-soundproof-thermal-blackout-custom-curtain-green.jpg?v=1756715945",
				"width": 2122
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046471332090,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-1-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-1-1_3__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046466679034,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Abeige-2-2_4__resolution-highfidelityv2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Abeige-2-2_4__resolution-highfidelityv2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046472577274,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Apearl-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Apearl-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046471397626,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Amoss-2-1_resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Amoss-2-1_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046469202170,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acharcoal-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acharcoal-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470185210,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream-2_4__resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream-2_4__resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046469988602,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acream_resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acream_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36046470480122,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adustblue-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adustblue-2_resolution-high_fidelity_v2-2x.jpg?v=1756715945",
				"width": 2000
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36059633320186,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1000,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/4layers_9f9ca965-7cf2-4ce6-b754-6699ddcb126f.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 1000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4layers_9f9ca965-7cf2-4ce6-b754-6699ddcb126f.jpg?v=1756715945",
				"width": 800
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36059633352954,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1000,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/4-layers-3-1_7_copy_b0bc6fc2-a3e6-480d-a013-f1eb17cfb902.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 1000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/4-layers-3-1_7_copy_b0bc6fc2-a3e6-480d-a013-f1eb17cfb902.jpg?v=1756715945",
				"width": 800
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36059633385722,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1000,
					"width": 800,
					"src": "//thehues.com/cdn/shop/files/blackout_50747bbe-4333-422f-bcdc-2ee816dccee5.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 1000,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blackout_50747bbe-4333-422f-bcdc-2ee816dccee5.jpg?v=1756715945",
				"width": 800
			},
			{
				"alt": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain - TheHues",
				"id": 36059633418490,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1250,
					"width": 1000,
					"src": "//thehues.com/cdn/shop/files/noise_df43bdb8-35bb-4485-87b8-3054d343dc80.jpg?v=1756715945"
				},
				"aspect_ratio": 0.8,
				"height": 1250,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/noise_df43bdb8-35bb-4485-87b8-3054d343dc80.jpg?v=1756715945",
				"width": 1000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Chenille curtains with a herringbone touch¡ªfour layers of soundproof, 100% blackout and thermal-insulated luxury for a home steeped in quiet sophistication.</p>",
		"url": "/products/herringbone-4-layers-herringbone-chenille-soundproof-thermal-100-blackout-custom-curtain",
		"regular_price": "$139.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-blackout-curtains",
				"title": "Advert Blackout Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/advert-soundproof-curtains",
				"title": "Advert Soundproof Curtains"
			},
			{
				"url": "/collections/advert-thermal-curtains",
				"title": "Advert Thermal Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-curtains",
				"title": "Blackout Curtains"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/soundproof-curtains",
				"title": "Soundproof Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/thermal-curtains",
				"title": "Thermal Curtains"
			}
		]
	},
	{
		"id": 8780129763578,
		"title": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain",
		"handle": "jupiter-linen-look-soft-heavyweight-sheer-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Materia: 30% Rayon &amp; 70% Polyester<br>Features: Sheer<br>Weight: Heavy Weight (440g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p>`,
		"description": "<p>With its graceful weight and breathable weave, Jupiter is a sheer curtain that hangs with sculptural ease, soft as a sigh and grounded in elegance.</p>",
		"published_at": "2025-05-07T16:34:03+08:00",
		"created_at": "2025-05-07T16:34:03+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Factory products",
			"flash_categories",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"Search curtains",
			"Search sheer",
			"Summer Collection"
		],
		"price": 12000,
		"price_min": 12000,
		"price_max": 12000,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319437508858,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-FT430-SD-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44286341382394,
					"product_id": 8780129763578,
					"position": 1,
					"created_at": "2025-06-20T14:55:59+08:00",
					"updated_at": "2025-08-26T16:23:32+08:00",
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"width": 1639,
					"height": 2048,
					"src": "//thehues.com/cdn/shop/files/IMG_6156_3_b25545f5-e792-4ce0-9be9-53793f53adf1.jpg?v=1756196612",
					"variant_ids": [
						47319437508858
					]
				},
				"available": true,
				"name": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"id": 36231211745530,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2048,
						"width": 1639,
						"src": "//thehues.com/cdn/shop/files/IMG_6156_3_b25545f5-e792-4ce0-9be9-53793f53adf1.jpg?v=1756196612"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ajupiter_cream_1024x1024.png?v=1751278389"
			},
			{
				"id": 47319437541626,
				"title": "Sage",
				"option1": "Sage",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-FT430-SD-Sage",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037979930874,
					"product_id": 8780129763578,
					"position": 19,
					"created_at": "2025-05-22T18:51:31+08:00",
					"updated_at": "2025-08-26T16:23:33+08:00",
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy3_resolution-standardv2-2x.jpg?v=1756196613",
					"variant_ids": [
						47319437541626
					]
				},
				"available": true,
				"name": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - Sage",
				"public_title": "Sage",
				"options": [
					"Sage"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"id": 36071822557434,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy3_resolution-standardv2-2x.jpg?v=1756196613"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ajupiter_sage_1024x1024.png?v=1751278389"
			},
			{
				"id": 47319437574394,
				"title": "Dark Green",
				"option1": "Dark Green",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-FT430-SD-Dark Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037977702650,
					"product_id": 8780129763578,
					"position": 27,
					"created_at": "2025-05-22T18:51:27+08:00",
					"updated_at": "2025-08-26T16:23:34+08:00",
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1darkgreen.jpg?v=1756196614",
					"variant_ids": [
						47319437574394
					]
				},
				"available": true,
				"name": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - Dark Green",
				"public_title": "Dark Green",
				"options": [
					"Dark Green"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"id": 36071821639930,
					"position": 27,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Jupiter_1darkgreen.jpg?v=1756196614"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ajupiter_darkgreen_1024x1024.png?v=1751278389"
			},
			{
				"id": 47319437607162,
				"title": "Ash Beige",
				"option1": "Ash Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-FT430-SD-Ash Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037972492538,
					"product_id": 8780129763578,
					"position": 7,
					"created_at": "2025-05-22T18:50:44+08:00",
					"updated_at": "2025-08-26T16:23:32+08:00",
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1ashbeige.jpg?v=1756196612",
					"variant_ids": [
						47319437607162
					]
				},
				"available": true,
				"name": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - Ash Beige",
				"public_title": "Ash Beige",
				"options": [
					"Ash Beige"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"id": 36071818592506,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Jupiter_1ashbeige.jpg?v=1756196612"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ajupiter_ashbeige_1024x1024.png?v=1751278389"
			},
			{
				"id": 47319437639930,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-FT430-SD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037979046138,
					"product_id": 8780129763578,
					"position": 13,
					"created_at": "2025-05-22T18:51:30+08:00",
					"updated_at": "2025-08-26T16:23:33+08:00",
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2red.jpg?v=1756196613",
					"variant_ids": [
						47319437639930
					]
				},
				"available": true,
				"name": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"id": 36071822426362,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Jupiter_2red.jpg?v=1756196613"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319437672698,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-138-FA-FT430-SD-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44038005620986,
					"product_id": 8780129763578,
					"position": 33,
					"created_at": "2025-05-22T18:54:07+08:00",
					"updated_at": "2025-08-26T16:23:34+08:00",
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1sand.jpg?v=1756196614",
					"variant_ids": [
						47319437672698
					]
				},
				"available": true,
				"name": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
					"id": 36071837434106,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Jupiter_1sand.jpg?v=1756196614"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/IMG_6156_3_b25545f5-e792-4ce0-9be9-53793f53adf1.jpg?v=1756196612",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D1copy_resolution-standardv2-2x.jpg?v=1756196612",
			"//thehues.com/cdn/shop/files/IMG_6152_1.jpg?v=1756196612",
			"//thehues.com/cdn/shop/files/1_1367519a-8eeb-478f-8974-e32b707514e4.png?v=1756196612",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D2copy_resolution-standardv2-2x.jpg?v=1756196612",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D3copy_resolution-standardv2-2x.jpg?v=1756196612",
			"//thehues.com/cdn/shop/files/Jupiter_1ashbeige.jpg?v=1756196612",
			"//thehues.com/cdn/shop/files/Jupiter_2ashbeige.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D4copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D2copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D1copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D3copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/Jupiter_2red.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/Jupiter_1red.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D4copy_resolution-standardv2-2x.jpg?v=1761204433",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D3copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D2copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D1copy_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy3_resolution-standardv2-2x.jpg?v=1756196613",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01919copy2_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02045copy2_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02140copy2_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02049copy2_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02023copy2_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304Dcopy_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D4copy_resolution-standardv2-2x.jpg?v=1761204433",
			"//thehues.com/cdn/shop/files/Jupiter_1darkgreen.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/Jupiter_2darkgreen.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D4copy_resolution-standardv2-2x.jpg?v=1761204433",
			"//thehues.com/cdn/shop/files/Jupiter-dark_green_2.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/Jupiter-dark_green_1.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D1copy_resolution-standardv2-2x.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/Jupiter_1sand.jpg?v=1756196614",
			"//thehues.com/cdn/shop/files/Jupiter_2sand.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/IMG_1579.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D4copy_resolution-standardv2-2x_3b0b5670-3454-4ccf-bfe0-cc9bf19a7bf7.jpg?v=1761204433",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D1copy_resolution-standardv2-2x_7ccc413e-6e99-4280-a887-5c4098631fae.jpg?v=1761204433",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D2copy_resolution-standardv2-2x_6585a56d-c9af-4fc5-a6f9-3b36647e937c.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D3copy_resolution-standardv2-2x_b45ca92b-6bfc-44e6-a8bd-fba6fc4a19b1.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D3copy_resolution-standardv2-2x.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D2copy_resolution-standardv2-2x.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/IMG_6156_3.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/IMG_6156_2.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/Jupiter_2cream.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/Jupiter_1cream.jpg?v=1756196615",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D4copy_resolution-standardv2-2x.jpg?v=1761204433",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D2copy_resolution-standardv2-2x.jpg?v=1756196616",
			"//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D3copy_resolution-standardv2-2x.jpg?v=1756196616",
			"//thehues.com/cdn/shop/files/Jupiter_1sage.jpg?v=1756196616",
			"//thehues.com/cdn/shop/files/Jupiter_2sage.jpg?v=1756196616",
			"//thehues.com/cdn/shop/files/JUPITER-FAMILY-11.jpg?v=1756196616",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy23_resolution-standardv2-2x.jpg?v=1756196616"
		],
		"featured_image": "//thehues.com/cdn/shop/files/IMG_6156_3_b25545f5-e792-4ce0-9be9-53793f53adf1_1024x1024.jpg?v=1756196612",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36231211745530,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1639,
					"src": "//thehues.com/cdn/shop/files/IMG_6156_3_b25545f5-e792-4ce0-9be9-53793f53adf1.jpg?v=1756196612"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_6156_3_b25545f5-e792-4ce0-9be9-53793f53adf1.jpg?v=1756196612",
				"width": 1639
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071820099834,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D1copy_resolution-standardv2-2x.jpg?v=1756196612"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D1copy_resolution-standardv2-2x.jpg?v=1756196612",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36224385712378,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/IMG_6152_1.jpg?v=1756196612"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_6152_1.jpg?v=1756196612",
				"width": 1638
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36318664818938,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.753,
					"height": 1232,
					"width": 928,
					"src": "//thehues.com/cdn/shop/files/1_1367519a-8eeb-478f-8974-e32b707514e4.png?v=1756196612"
				},
				"aspect_ratio": 0.753,
				"height": 1232,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_1367519a-8eeb-478f-8974-e32b707514e4.png?v=1756196612",
				"width": 928
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071820132602,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D2copy_resolution-standardv2-2x.jpg?v=1756196612"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D2copy_resolution-standardv2-2x.jpg?v=1756196612",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071819968762,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D3copy_resolution-standardv2-2x.jpg?v=1756196612"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D3copy_resolution-standardv2-2x.jpg?v=1756196612",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071818592506,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1ashbeige.jpg?v=1756196612"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_1ashbeige.jpg?v=1756196612",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071818625274,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2ashbeige.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_2ashbeige.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071818559738,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D4copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D4copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071818494202,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D2copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D2copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071818461434,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D1copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D1copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071818526970,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D3copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D3copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822426362,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2red.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_2red.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822360826,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1red.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_1red.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822295290,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D4copy_resolution-standardv2-2x.jpg?v=1761204433"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D4copy_resolution-standardv2-2x.jpg?v=1761204433",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822229754,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D3copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D3copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822131450,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D2copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D2copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822065914,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D1copy_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4308D1copy_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822557434,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy3_resolution-standardv2-2x.jpg?v=1756196613"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy3_resolution-standardv2-2x.jpg?v=1756196613",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837925626,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01919copy2_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01919copy2_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837958394,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02045copy2_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02045copy2_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837991162,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02140copy2_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02140copy2_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822524666,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02049copy2_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02049copy2_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822459130,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02023copy2_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02023copy2_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822688506,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304Dcopy_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304Dcopy_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822655738,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D4copy_resolution-standardv2-2x.jpg?v=1761204433"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D4copy_resolution-standardv2-2x.jpg?v=1761204433",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071821639930,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1darkgreen.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_1darkgreen.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071821672698,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2darkgreen.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_2darkgreen.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071821607162,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D4copy_resolution-standardv2-2x.jpg?v=1761204433"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D4copy_resolution-standardv2-2x.jpg?v=1761204433",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36451200893178,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter-dark_green_2.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter-dark_green_2.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36451200925946,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter-dark_green_1.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter-dark_green_1.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071821508858,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D1copy_resolution-standardv2-2x.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D1copy_resolution-standardv2-2x.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837434106,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1sand.jpg?v=1756196614"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_1sand.jpg?v=1756196614",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837401338,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2sand.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_2sand.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36455459946746,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/IMG_1579.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_1579.jpg?v=1756196615",
				"width": 1638
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837729018,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D4copy_resolution-standardv2-2x_3b0b5670-3454-4ccf-bfe0-cc9bf19a7bf7.jpg?v=1761204433"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D4copy_resolution-standardv2-2x_3b0b5670-3454-4ccf-bfe0-cc9bf19a7bf7.jpg?v=1761204433",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837761786,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D1copy_resolution-standardv2-2x_7ccc413e-6e99-4280-a887-5c4098631fae.jpg?v=1761204433"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D1copy_resolution-standardv2-2x_7ccc413e-6e99-4280-a887-5c4098631fae.jpg?v=1761204433",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837794554,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D2copy_resolution-standardv2-2x_6585a56d-c9af-4fc5-a6f9-3b36647e937c.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D2copy_resolution-standardv2-2x_6585a56d-c9af-4fc5-a6f9-3b36647e937c.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837827322,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D3copy_resolution-standardv2-2x_b45ca92b-6bfc-44e6-a8bd-fba6fc4a19b1.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4310D3copy_resolution-standardv2-2x_b45ca92b-6bfc-44e6-a8bd-fba6fc4a19b1.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071821574394,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D3copy_resolution-standardv2-2x.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D3copy_resolution-standardv2-2x.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071821541626,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D2copy_resolution-standardv2-2x.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4305D2copy_resolution-standardv2-2x.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36224611549434,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1639,
					"src": "//thehues.com/cdn/shop/files/IMG_6156_3.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_6156_3.jpg?v=1756196615",
				"width": 1639
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36224385745146,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1639,
					"src": "//thehues.com/cdn/shop/files/IMG_6156_2.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_6156_2.jpg?v=1756196615",
				"width": 1639
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071820067066,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2cream.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_2cream.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071820034298,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1cream.jpg?v=1756196615"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_1cream.jpg?v=1756196615",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071820001530,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D4copy_resolution-standardv2-2x.jpg?v=1761204433"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4301D4copy_resolution-standardv2-2x.jpg?v=1761204433",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822590202,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D2copy_resolution-standardv2-2x.jpg?v=1756196616"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D2copy_resolution-standardv2-2x.jpg?v=1756196616",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822622970,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D3copy_resolution-standardv2-2x.jpg?v=1756196616"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-AFA-FT4304D3copy_resolution-standardv2-2x.jpg?v=1756196616",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822721274,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_1sage.jpg?v=1756196616"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_1sage.jpg?v=1756196616",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071822754042,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Jupiter_2sage.jpg?v=1756196616"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Jupiter_2sage.jpg?v=1756196616",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837860090,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/JUPITER-FAMILY-11.jpg?v=1756196616"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/JUPITER-FAMILY-11.jpg?v=1756196616",
				"width": 2000
			},
			{
				"alt": "Jupiter Linen Look Soft Heavyweight Sheer Custom Curtain - TheHues",
				"id": 36071837892858,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy23_resolution-standardv2-2x.jpg?v=1756196616"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02240copy23_resolution-standardv2-2x.jpg?v=1756196616",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36133404967162,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1080,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/43c8ffde7f1942158d61fe38e761ab2f.thumbnail.0000000000.jpg?v=1749088575"
				},
				"aspect_ratio": 1,
				"duration": 7730,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/43c8ffde7f1942158d61fe38e761ab2f/43c8ffde7f1942158d61fe38e761ab2f.SD-480p-1.5Mbps-48845354.mp4?v=0",
						"width": 480
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/43c8ffde7f1942158d61fe38e761ab2f/43c8ffde7f1942158d61fe38e761ab2f.HD-1080p-7.2Mbps-48845354.mp4?v=0",
						"width": 1080
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/43c8ffde7f1942158d61fe38e761ab2f/43c8ffde7f1942158d61fe38e761ab2f.HD-720p-4.5Mbps-48845354.mp4?v=0",
						"width": 720
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/43c8ffde7f1942158d61fe38e761ab2f/43c8ffde7f1942158d61fe38e761ab2f.m3u8?v=0",
						"width": 1080
					}
				]
			},
			{
				"alt": null,
				"id": 36347606499578,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/346caaa531f14dbb883c623006905fa0.thumbnail.0000000000.jpg?v=1752144401"
				},
				"aspect_ratio": 0.563,
				"duration": 13810,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/346caaa531f14dbb883c623006905fa0/346caaa531f14dbb883c623006905fa0.SD-480p-0.9Mbps-50976456.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/346caaa531f14dbb883c623006905fa0/346caaa531f14dbb883c623006905fa0.HD-1080p-2.5Mbps-50976456.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/346caaa531f14dbb883c623006905fa0/346caaa531f14dbb883c623006905fa0.HD-720p-1.6Mbps-50976456.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/346caaa531f14dbb883c623006905fa0/346caaa531f14dbb883c623006905fa0.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With its graceful weight and breathable weave, Jupiter is a sheer curtain that hangs with sculptural ease, soft as a sigh and grounded in elegance.</p>",
		"url": "/products/jupiter-linen-look-soft-heavyweight-sheer-custom-curtain",
		"regular_price": "$120.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8780124553466,
		"title": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "impression-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Materia: 30% Rayon &amp; 70% Polyester<br>Features: Sheer<br>Weight: Heavy Weight (440g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p>`,
		"description": "<p>The Impression Velvet curtain with foil printed subtle patterns exudes sophistication and luxury. The soft velvet fabric provides a rich texture, while the delicate foil print adds a modern, artistic touch.</p>",
		"published_at": "2025-05-07T16:31:23+08:00",
		"created_at": "2025-05-07T16:31:23+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > black custom curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Solid Velvet Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"fall sale",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"upcoming fall"
		],
		"price": 12700,
		"price_min": 12700,
		"price_max": 12700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319439999226,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996661809402,
					"product_id": 8780124553466,
					"position": 1,
					"created_at": "2025-05-17T17:28:41+08:00",
					"updated_at": "2025-09-04T18:21:45+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/A_1_resolution-standardv2-2x.jpg?v=1756981305",
					"variant_ids": [
						47319439999226
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36046517797114,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A_1_resolution-standardv2-2x.jpg?v=1756981305"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319439769850,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44999718273274,
					"product_id": 8780124553466,
					"position": 13,
					"created_at": "2025-09-03T09:50:21+08:00",
					"updated_at": "2025-09-04T18:21:45+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1756981305",
					"variant_ids": [
						47319439769850
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36721313710330,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1756981305"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cream_1024x1024.jpg?v=1756981305"
			},
			{
				"id": 47319439802618,
				"title": "Lit",
				"option1": "Lit",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Lit",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011668271354,
					"product_id": 8780124553466,
					"position": 11,
					"created_at": "2025-09-04T18:19:11+08:00",
					"updated_at": "2025-10-23T16:51:52+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit_2e325e8e-00cf-4b54-a786-1ba28260e1b6.jpg?v=1761209512",
					"variant_ids": [
						47319439802618
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Lit",
				"public_title": "Lit",
				"options": [
					"Lit"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36733205741818,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit_2e325e8e-00cf-4b54-a786-1ba28260e1b6.jpg?v=1761209512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/lit_1024x1024.jpg?v=1756981305"
			},
			{
				"id": 47319439835386,
				"title": "Grey Blue",
				"option1": "Grey Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Grey Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011667943674,
					"product_id": 8780124553466,
					"position": 21,
					"created_at": "2025-09-04T18:19:10+08:00",
					"updated_at": "2025-10-23T16:51:52+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue_ec318d3d-7262-4d56-96be-09d20f4547e5.jpg?v=1761209512",
					"variant_ids": [
						47319439835386
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Grey Blue",
				"public_title": "Grey Blue",
				"options": [
					"Grey Blue"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36733205414138,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue_ec318d3d-7262-4d56-96be-09d20f4547e5.jpg?v=1761209512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/silver_1024x1024.jpg?v=1756981305"
			},
			{
				"id": 47319439868154,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011667386618,
					"product_id": 8780124553466,
					"position": 9,
					"created_at": "2025-09-04T18:19:03+08:00",
					"updated_at": "2025-10-23T16:51:52+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-blue.jpg?v=1761209512",
					"variant_ids": [
						47319439868154
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36733204857082,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-blue.jpg?v=1761209512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/blue_1024x1024.jpg?v=1756981305"
			},
			{
				"id": 47319439900922,
				"title": "Pink",
				"option1": "Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Pink",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011668730106,
					"product_id": 8780124553466,
					"position": 7,
					"created_at": "2025-09-04T18:19:14+08:00",
					"updated_at": "2025-10-23T16:51:52+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-pink.jpg?v=1761209512",
					"variant_ids": [
						47319439900922
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Pink",
				"public_title": "Pink",
				"options": [
					"Pink"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36733205774586,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-pink.jpg?v=1761209512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319439933690,
				"title": "Gold",
				"option1": "Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011667910906,
					"product_id": 8780124553466,
					"position": 5,
					"created_at": "2025-09-04T18:19:08+08:00",
					"updated_at": "2025-10-23T16:51:52+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold_b5fded5c-d528-44da-95e1-3fc76dc9dea9.jpg?v=1761209512",
					"variant_ids": [
						47319439933690
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Gold",
				"public_title": "Gold",
				"options": [
					"Gold"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36733205283066,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold_b5fded5c-d528-44da-95e1-3fc76dc9dea9.jpg?v=1761209512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319439966458,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-577-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011668795642,
					"product_id": 8780124553466,
					"position": 3,
					"created_at": "2025-09-04T18:19:15+08:00",
					"updated_at": "2025-10-23T16:51:52+08:00",
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761209512",
					"variant_ids": [
						47319439966458
					]
				},
				"available": true,
				"name": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36733206266106,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761209512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/A_1_resolution-standardv2-2x.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/Aimpression-black-4_resolution-standardv2-2x.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/teal.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold_b5fded5c-d528-44da-95e1-3fc76dc9dea9.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/gold.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-pink.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/pink.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-blue.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/blue.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit_2e325e8e-00cf-4b54-a786-1ba28260e1b6.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/lit.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-3.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-4.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-6.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-7.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream_96dca2da-3c0f-47a7-a257-93d616167307.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/cream.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue_ec318d3d-7262-4d56-96be-09d20f4547e5.jpg?v=1761209512",
			"//thehues.com/cdn/shop/files/silver.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/Aimpression-black-9_2_1_resolution-standardv2-2x.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/Aimpression-black-6_3__resolution-standardv2-2x.jpg?v=1756981305",
			"//thehues.com/cdn/shop/files/Aimpression-black-2_4__resolution-standardv2-2x.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/Aimpression-black-3_6__resolution-standardv2-2x.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/Aimpression-black-7_5__resolution-standardv2-2x.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/Aimpression-black-8_7__resolution-standardv2-2x.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/black.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lightblue.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-coral.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1756981287",
			"//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-mustardgreen.jpg?v=1756981287"
		],
		"featured_image": "//thehues.com/cdn/shop/files/A_1_resolution-standardv2-2x_1024x1024.jpg?v=1756981305",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517797114,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A_1_resolution-standardv2-2x.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A_1_resolution-standardv2-2x.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517895418,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-4_resolution-standardv2-2x.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-4_resolution-standardv2-2x.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733206266106,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533558522,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/teal.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/teal.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733205283066,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold_b5fded5c-d528-44da-95e1-3fc76dc9dea9.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold_b5fded5c-d528-44da-95e1-3fc76dc9dea9.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533460218,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/gold.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/gold.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733205774586,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-pink.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-pink.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533525754,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pink.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pink.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733204857082,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-blue.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-blue.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533361914,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/blue.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blue.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733205741818,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit_2e325e8e-00cf-4b54-a786-1ba28260e1b6.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit_2e325e8e-00cf-4b54-a786-1ba28260e1b6.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533492986,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/lit.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/lit.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721313710330,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721313644794,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-3.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-3.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721313579258,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-4.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-4.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721313677562,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721313612026,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-6.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-6.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721313743098,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-7.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream-7.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733205119226,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream_96dca2da-3c0f-47a7-a257-93d616167307.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream_96dca2da-3c0f-47a7-a257-93d616167307.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533329146,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/cream.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cream.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36733205414138,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue_ec318d3d-7262-4d56-96be-09d20f4547e5.jpg?v=1761209512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue_ec318d3d-7262-4d56-96be-09d20f4547e5.jpg?v=1761209512",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533394682,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/silver.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/silver.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046518026490,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-9_2_1_resolution-standardv2-2x.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-9_2_1_resolution-standardv2-2x.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517928186,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-6_3__resolution-standardv2-2x.jpg?v=1756981305"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-6_3__resolution-standardv2-2x.jpg?v=1756981305",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517829882,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-2_4__resolution-standardv2-2x.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-2_4__resolution-standardv2-2x.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517862650,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-3_6__resolution-standardv2-2x.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-3_6__resolution-standardv2-2x.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517960954,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-7_5__resolution-standardv2-2x.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-7_5__resolution-standardv2-2x.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046517993722,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Aimpression-black-8_7__resolution-standardv2-2x.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Aimpression-black-8_7__resolution-standardv2-2x.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36046533427450,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/black.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721307648250,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721307451642,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-greyblue.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721307517178,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lightblue.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lightblue.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721307844858,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-lit.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721307910394,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721308041466,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-coral.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-coral.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721307975930,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1756981287",
				"width": 2000
			},
			{
				"alt": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721308008698,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-mustardgreen.jpg?v=1756981287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/impression-foil-printed-velvet-patterned-custom-curtain-mustardgreen.jpg?v=1756981287",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Impression Velvet curtain with foil printed subtle patterns exudes sophistication and luxury. The soft velvet fabric provides a rich texture, while the delicate foil print adds a modern, artistic touch.</p>",
		"url": "/products/impression-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$127.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780122620154,
		"title": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain",
		"handle": "deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 81% Polyester &amp; 8% Wool &amp; 6% Acrylic &amp; 5% Linen<br>Features: Unique Wool &amp; Linen Blend Fabric<br>Weight: Heavy Weight (430g/㎡)</p><p>Softness: Firmer</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Crafted from a luxurious wool and linen blend, this curtain combines the natural warmth of wool with the airy elegance of linen. The intricate geometric pattern adds depth, creating a refined focal point for any space.</p>",
		"published_at": "2025-05-07T16:30:24+08:00",
		"created_at": "2025-05-07T16:30:24+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > geometric custom curtains",
			"All Curtains > grey custom curtains",
			"All Curtains > heavyweight custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Wool Curtains",
			"Custom Blackout Curtains > Patterned Curtains",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat"
		],
		"price": 11300,
		"price_min": 11300,
		"price_max": 11300,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319452745978,
				"title": "Urban",
				"option1": "Urban",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF0302-C-Urban",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037172363514,
					"product_id": 8780122620154,
					"position": 1,
					"created_at": "2025-05-22T17:39:39+08:00",
					"updated_at": "2025-09-04T16:16:02+08:00",
					"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240524-AUrban-2_resolution-standardv2-2x.jpg?v=1756973762",
					"variant_ids": [
						47319452745978
					]
				},
				"available": true,
				"name": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - Urban",
				"public_title": "Urban",
				"options": [
					"Urban"
				],
				"price": 11300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
					"id": 36071396016378,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240524-AUrban-2_resolution-standardv2-2x.jpg?v=1756973762"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AUrban-1_resolution-standardv2-2x_1024x1024.jpg?v=1756973762"
			},
			{
				"id": 47319452713210,
				"title": "Khaki",
				"option1": "Khaki",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF0301-C-Khaki",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011185008890,
					"product_id": 8780122620154,
					"position": 3,
					"created_at": "2025-09-04T16:10:55+08:00",
					"updated_at": "2025-10-23T17:59:49+08:00",
					"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-khaki.jpg?v=1761213589",
					"variant_ids": [
						47319452713210
					]
				},
				"available": true,
				"name": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - Khaki",
				"public_title": "Khaki",
				"options": [
					"Khaki"
				],
				"price": 11300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
					"id": 36732727361786,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-khaki.jpg?v=1761213589"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFB-KF0301-Khaki-1_resolution-standardv2-2x_1024x1024.jpg?v=1756973762"
			},
			{
				"id": 47319452778746,
				"title": "Pool",
				"option1": "Pool",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-KF0303-C-Pool",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011185041658,
					"product_id": 8780122620154,
					"position": 6,
					"created_at": "2025-09-04T16:11:00+08:00",
					"updated_at": "2025-10-23T17:59:49+08:00",
					"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-teal.jpg?v=1761213589",
					"variant_ids": [
						47319452778746
					]
				},
				"available": true,
				"name": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - Pool",
				"public_title": "Pool",
				"options": [
					"Pool"
				],
				"price": 11300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
					"id": 36732727394554,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-teal.jpg?v=1761213589"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFB-KF0303-Pool_resolution-standardv2-2x_1024x1024.jpg?v=1756973762"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240524-AUrban-2_resolution-standardv2-2x.jpg?v=1756973762",
			"//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-black.jpg?v=1761213589",
			"//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-khaki.jpg?v=1761213589",
			"//thehues.com/cdn/shop/files/20250516-AFB-KF0301-Khaki-1_resolution-standardv2-2x.jpg?v=1756973762",
			"//thehues.com/cdn/shop/files/20250516-AUrban-1_resolution-standardv2-2x.jpg?v=1756973762",
			"//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-teal.jpg?v=1761213589",
			"//thehues.com/cdn/shop/files/20250516-AFB-KF0303-Pool_resolution-standardv2-2x.jpg?v=1756973762",
			"//thehues.com/cdn/shop/files/20250516-AUrban-6_resolution-standardv2-2x.jpg?v=1756973582",
			"//thehues.com/cdn/shop/files/20240524-AUrban-3_resolution-standardv2-2x.jpg?v=1756973582",
			"//thehues.com/cdn/shop/files/20250516-AUrban-4_resolution-standardv2-2x.jpg?v=1756973582",
			"//thehues.com/cdn/shop/files/20250516-AUrban-5_resolution-standardv2-2x.jpg?v=1756973582"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240524-AUrban-2_resolution-standardv2-2x_1024x1024.jpg?v=1756973762",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071396016378,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-AUrban-2_resolution-standardv2-2x.jpg?v=1756973762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-AUrban-2_resolution-standardv2-2x.jpg?v=1756973762",
				"width": 1999
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36732725526778,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-black.jpg?v=1761213589"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-black.jpg?v=1761213589",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36732727361786,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-khaki.jpg?v=1761213589"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-khaki.jpg?v=1761213589",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071396081914,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AFB-KF0301-Khaki-1_resolution-standardv2-2x.jpg?v=1756973762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFB-KF0301-Khaki-1_resolution-standardv2-2x.jpg?v=1756973762",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071395885306,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AUrban-1_resolution-standardv2-2x.jpg?v=1756973762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AUrban-1_resolution-standardv2-2x.jpg?v=1756973762",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36732727394554,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-teal.jpg?v=1761213589"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain-teal.jpg?v=1761213589",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071395852538,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AFB-KF0303-Pool_resolution-standardv2-2x.jpg?v=1756973762"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFB-KF0303-Pool_resolution-standardv2-2x.jpg?v=1756973762",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071395983610,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AUrban-6_resolution-standardv2-2x.jpg?v=1756973582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AUrban-6_resolution-standardv2-2x.jpg?v=1756973582",
				"width": 1999
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071396049146,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240524-AUrban-3_resolution-standardv2-2x.jpg?v=1756973582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-AUrban-3_resolution-standardv2-2x.jpg?v=1756973582",
				"width": 2000
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071395918074,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AUrban-4_resolution-standardv2-2x.jpg?v=1756973582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AUrban-4_resolution-standardv2-2x.jpg?v=1756973582",
				"width": 1999
			},
			{
				"alt": "Deconstructed Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain - TheHues",
				"id": 36071395950842,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AUrban-5_resolution-standardv2-2x.jpg?v=1756973582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AUrban-5_resolution-standardv2-2x.jpg?v=1756973582",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Crafted from a luxurious wool and linen blend, this curtain combines the natural warmth of wool with the airy elegance of linen. The intricate geometric pattern adds depth, creating a refined focal point for any space.</p>",
		"url": "/products/deconstructed-linen-wool-blend-heavyweight-geometric-fringed-patterned-custom-curtain",
		"regular_price": "$113.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/woolen-curtains",
				"title": "Woolen Curtains"
			}
		]
	},
	{
		"id": 8780122325242,
		"title": "Mist Patterned Heavyweight Custom Curtain",
		"handle": "mist-patterned-heavyweight-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 50% Polyester &amp; 40% Acrylic &amp; 10% Cotton<br>Features: Blackout &amp; Thermal Insulation<br>Weight: Regular (430g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Mist drapes your space in ethereal elegance, its soft cotton blend and delicate patterns evoking the serenity of a hazy dawn.</p>",
		"published_at": "2025-05-07T16:30:16+08:00",
		"created_at": "2025-05-07T16:30:16+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > heavyweight custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Extra 10%",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Search cotton",
			"Search curtains",
			"Search Pinch pleat"
		],
		"price": 10200,
		"price_min": 10200,
		"price_max": 10200,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319425450234,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-1342403-7-657-C-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037622989050,
					"product_id": 8780122325242,
					"position": 30,
					"created_at": "2025-05-22T18:22:34+08:00",
					"updated_at": "2025-08-26T16:28:20+08:00",
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-2_resolution-standardv2-2x.jpg?v=1756196900",
					"variant_ids": [
						47319425450234
					]
				},
				"available": true,
				"name": "Mist Patterned Heavyweight Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"id": 36071637221626,
					"position": 30,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-2_resolution-standardv2-2x.jpg?v=1756196900"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250116-Asand-4-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196901"
			},
			{
				"id": 47319425351930,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-1342403-7-657-C-Ash",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037620793594,
					"product_id": 8780122325242,
					"position": 3,
					"created_at": "2025-05-22T18:22:04+08:00",
					"updated_at": "2025-08-26T16:28:16+08:00",
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-2_resolution-standardv2-2x.jpg?v=1756196896",
					"variant_ids": [
						47319425351930
					]
				},
				"available": true,
				"name": "Mist Patterned Heavyweight Custom Curtain - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"id": 36071635878138,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-2_resolution-standardv2-2x.jpg?v=1756196896"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250116-Aash-4-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196897"
			},
			{
				"id": 47319425384698,
				"title": "Light Grey",
				"option1": "Light Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1342403-7-657-C-Light Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037622563066,
					"product_id": 8780122325242,
					"position": 12,
					"created_at": "2025-05-22T18:22:26+08:00",
					"updated_at": "2025-08-26T16:28:18+08:00",
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-2_resolution-standardv2-2x.jpg?v=1756196898",
					"variant_ids": [
						47319425384698
					]
				},
				"available": true,
				"name": "Mist Patterned Heavyweight Custom Curtain - Light Grey",
				"public_title": "Light Grey",
				"options": [
					"Light Grey"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"id": 36071636861178,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-2_resolution-standardv2-2x.jpg?v=1756196898"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250206-Alight-grey-4-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196899"
			},
			{
				"id": 47319425417466,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-1342403-7-657-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037621547258,
					"product_id": 8780122325242,
					"position": 21,
					"created_at": "2025-05-22T18:22:19+08:00",
					"updated_at": "2025-08-26T16:28:19+08:00",
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x-2.jpg?v=1756196899",
					"variant_ids": [
						47319425417466
					]
				},
				"available": true,
				"name": "Mist Patterned Heavyweight Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 10200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
					"id": 36071636533498,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x-2.jpg?v=1756196899"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250206-Ablack-4-1_resolution-standardv2-2x-2_1024x1024.jpg?v=1756196900"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250116-Asand-4-3_resolution-standardv2-2x.jpg?v=1756196895",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-8_resolution-standardv2-2x.jpg?v=1756196896",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-2_resolution-standardv2-2x.jpg?v=1756196896",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-3_resolution-standardv2-2x.jpg?v=1756196896",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-9_resolution-standardv2-2x.jpg?v=1756196896",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-4_resolution-standardv2-2x.jpg?v=1756196896",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-7_resolution-standardv2-2x.jpg?v=1761210674",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-5_resolution-standardv2-2x.jpg?v=1756196897",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-6_resolution-standardv2-2x.jpg?v=1756196897",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-8_resolution-standardv2-2x.jpg?v=1756196897",
			"//thehues.com/cdn/shop/files/20250116-Aash-4-1_resolution-standardv2-2x.jpg?v=1756196897",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-2_resolution-standardv2-2x.jpg?v=1756196898",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-3_resolution-standardv2-2x.jpg?v=1756196898",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-9_resolution-standardv2-2x.jpg?v=1756196898",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-4_resolution-standardv2-2x.jpg?v=1756196898",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-7_resolution-standardv2-2x.jpg?v=1761210674",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-5_resolution-standardv2-2x.jpg?v=1756196898",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-6_resolution-standardv2-2x.jpg?v=1756196898",
			"//thehues.com/cdn/shop/files/20250116-Alight-grey-4-8_resolution-standardv2-2x.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250206-Alight-grey-4-1_resolution-standardv2-2x.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x-2.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-3_resolution-standardv2-2x.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-4_resolution-standardv2-2x.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-7_resolution-standardv2-2x.jpg?v=1761210674",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-5_resolution-standardv2-2x.jpg?v=1756196899",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-6_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Ablack-4-1_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250206-Ablack-4-1_resolution-standardv2-2x-2.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-2_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-9_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-4_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-7_resolution-standardv2-2x.jpg?v=1761210674",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-5_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-6_resolution-standardv2-2x.jpg?v=1756196900",
			"//thehues.com/cdn/shop/files/20250116-Asand-4-1_resolution-standardv2-2x.jpg?v=1756196901"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250116-Asand-4-3_resolution-standardv2-2x_1024x1024.jpg?v=1756196895",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637254394,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-3_resolution-standardv2-2x.jpg?v=1756196895"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-3_resolution-standardv2-2x.jpg?v=1756196895",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637418234,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-8_resolution-standardv2-2x.jpg?v=1756196896"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-8_resolution-standardv2-2x.jpg?v=1756196896",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071635878138,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-2_resolution-standardv2-2x.jpg?v=1756196896"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-2_resolution-standardv2-2x.jpg?v=1756196896",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071635910906,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-3_resolution-standardv2-2x.jpg?v=1756196896"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-3_resolution-standardv2-2x.jpg?v=1756196896",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071635812602,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-9_resolution-standardv2-2x.jpg?v=1756196896"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-9_resolution-standardv2-2x.jpg?v=1756196896",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071635943674,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-4_resolution-standardv2-2x.jpg?v=1756196896"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-4_resolution-standardv2-2x.jpg?v=1756196896",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636041978,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-7_resolution-standardv2-2x.jpg?v=1761210674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-7_resolution-standardv2-2x.jpg?v=1761210674",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071635976442,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-5_resolution-standardv2-2x.jpg?v=1756196897"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-5_resolution-standardv2-2x.jpg?v=1756196897",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636009210,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-6_resolution-standardv2-2x.jpg?v=1756196897"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-6_resolution-standardv2-2x.jpg?v=1756196897",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636074746,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-8_resolution-standardv2-2x.jpg?v=1756196897"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-8_resolution-standardv2-2x.jpg?v=1756196897",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071635845370,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-1_resolution-standardv2-2x.jpg?v=1756196897"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Aash-4-1_resolution-standardv2-2x.jpg?v=1756196897",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636861178,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-2_resolution-standardv2-2x.jpg?v=1756196898"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-2_resolution-standardv2-2x.jpg?v=1756196898",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636893946,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-3_resolution-standardv2-2x.jpg?v=1756196898"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-3_resolution-standardv2-2x.jpg?v=1756196898",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637123322,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-9_resolution-standardv2-2x.jpg?v=1756196898"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-9_resolution-standardv2-2x.jpg?v=1756196898",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636926714,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-4_resolution-standardv2-2x.jpg?v=1756196898"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-4_resolution-standardv2-2x.jpg?v=1756196898",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637025018,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-7_resolution-standardv2-2x.jpg?v=1761210674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-7_resolution-standardv2-2x.jpg?v=1761210674",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636959482,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-5_resolution-standardv2-2x.jpg?v=1756196898"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-5_resolution-standardv2-2x.jpg?v=1756196898",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636992250,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-6_resolution-standardv2-2x.jpg?v=1756196898"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-6_resolution-standardv2-2x.jpg?v=1756196898",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637090554,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-8_resolution-standardv2-2x.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Alight-grey-4-8_resolution-standardv2-2x.jpg?v=1756196899",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636828410,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250206-Alight-grey-4-1_resolution-standardv2-2x.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250206-Alight-grey-4-1_resolution-standardv2-2x.jpg?v=1756196899",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636533498,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x-2.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x-2.jpg?v=1756196899",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636566266,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-3_resolution-standardv2-2x.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-3_resolution-standardv2-2x.jpg?v=1756196899",
				"width": 2000
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636500730,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-2_resolution-standardv2-2x.jpg?v=1756196899",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636599034,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-4_resolution-standardv2-2x.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-4_resolution-standardv2-2x.jpg?v=1756196899",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636697338,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-7_resolution-standardv2-2x.jpg?v=1761210674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-7_resolution-standardv2-2x.jpg?v=1761210674",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636631802,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-5_resolution-standardv2-2x.jpg?v=1756196899"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-5_resolution-standardv2-2x.jpg?v=1756196899",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636664570,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-6_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-6_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636467962,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-1_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Ablack-4-1_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071636435194,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250206-Ablack-4-1_resolution-standardv2-2x-2.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250206-Ablack-4-1_resolution-standardv2-2x-2.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637221626,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-2_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-2_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637156090,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-9_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-9_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637287162,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-4_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-4_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637385466,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-7_resolution-standardv2-2x.jpg?v=1761210674"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-7_resolution-standardv2-2x.jpg?v=1761210674",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637319930,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-5_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-5_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637352698,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-6_resolution-standardv2-2x.jpg?v=1756196900"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-6_resolution-standardv2-2x.jpg?v=1756196900",
				"width": 1999
			},
			{
				"alt": "Mist Patterned Heavyweight Custom Curtain - TheHues",
				"id": 36071637188858,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-1_resolution-standardv2-2x.jpg?v=1756196901"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-Asand-4-1_resolution-standardv2-2x.jpg?v=1756196901",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Mist drapes your space in ethereal elegance, its soft cotton blend and delicate patterns evoking the serenity of a hazy dawn.</p>",
		"url": "/products/mist-patterned-heavyweight-custom-curtain",
		"regular_price": "$102.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/cotton-curtains",
				"title": "Cotton Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8780124520698,
		"title": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "pebbles-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Pebbles Foil Printed Velvet curtains bring a playful yet sophisticated touch to any space. The fun, irregular pebble-inspired print adds a sense of whimsy and movement, while the foil accents offer a modern, luxurious shimmer.</p>",
		"published_at": "2025-05-07T16:31:22+08:00",
		"created_at": "2025-05-07T16:31:22+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Solid Velvet Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"fall sale",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Pinch pleat",
			"Search velvet"
		],
		"price": 13800,
		"price_min": 13800,
		"price_max": 13800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319414472954,
				"title": "Black Gold",
				"option1": "Black Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Black Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44987214299386,
					"product_id": 8780124520698,
					"position": 9,
					"created_at": "2025-09-02T18:17:48+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-7.jpg?v=1756808735",
					"variant_ids": [
						47319414472954
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black Gold",
				"public_title": "Black Gold",
				"options": [
					"Black Gold"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36711302332666,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-7.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319414276346,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037654905082,
					"product_id": 8780124520698,
					"position": 3,
					"created_at": "2025-05-22T18:24:15+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-ABF-A10-1_resolution-standardv2-2x.jpg?v=1756808735",
					"variant_ids": [
						47319414276346
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071653409018,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-ABF-A10-1_resolution-standardv2-2x.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ABF-A10-1_resolution-standardv2-2x_1024x1024.jpg?v=1756808735"
			},
			{
				"id": 47319414309114,
				"title": "Shimmer",
				"option1": "Shimmer",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Shimmer",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037654839546,
					"product_id": 8780124520698,
					"position": 4,
					"created_at": "2025-05-22T18:24:14+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Ashimmer_resolution-standardv2-2x.jpg?v=1756808735",
					"variant_ids": [
						47319414309114
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Shimmer",
				"public_title": "Shimmer",
				"options": [
					"Shimmer"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071653310714,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Ashimmer_resolution-standardv2-2x.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Ashimmer_resolution-standardv2-2x_1024x1024.jpg?v=1756808735"
			},
			{
				"id": 47319414341882,
				"title": "Silver Grey",
				"option1": "Silver Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Silver Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037654872314,
					"product_id": 8780124520698,
					"position": 5,
					"created_at": "2025-05-22T18:24:14+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-AsilverGrey_resolution-standardv2-2x_38ffb44a-6425-4632-98f4-cfeb3d2b295a.jpg?v=1756808735",
					"variant_ids": [
						47319414341882
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Silver Grey",
				"public_title": "Silver Grey",
				"options": [
					"Silver Grey"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071653343482,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-AsilverGrey_resolution-standardv2-2x_38ffb44a-6425-4632-98f4-cfeb3d2b295a.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x_5e16d661-756c-492a-bd72-d83c54f5fd57_1024x1024.jpg?v=1756808735"
			},
			{
				"id": 47319414374650,
				"title": "Hazy Blue",
				"option1": "Hazy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Hazy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037654970618,
					"product_id": 8780124520698,
					"position": 6,
					"created_at": "2025-05-22T18:24:15+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Ahazyblus_resolution-standardv2-2x.jpg?v=1756808735",
					"variant_ids": [
						47319414374650
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Hazy Blue",
				"public_title": "Hazy Blue",
				"options": [
					"Hazy Blue"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071653540090,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Ahazyblus_resolution-standardv2-2x.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Ahazyblus_resolution-standardv2-2x_1024x1024.jpg?v=1756808735"
			},
			{
				"id": 47319414407418,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037655101690,
					"product_id": 8780124520698,
					"position": 7,
					"created_at": "2025-05-22T18:24:14+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x_5e16d661-756c-492a-bd72-d83c54f5fd57.jpg?v=1756808735",
					"variant_ids": [
						47319414407418
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071653376250,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x_5e16d661-756c-492a-bd72-d83c54f5fd57.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319414440186,
				"title": "Gold",
				"option1": "Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-A10-C-Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037655036154,
					"product_id": 8780124520698,
					"position": 8,
					"created_at": "2025-05-22T18:24:15+08:00",
					"updated_at": "2025-09-02T18:25:35+08:00",
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x_814fbda7-e5e6-41ed-8164-eb066cc88fa2.jpg?v=1756808735",
					"variant_ids": [
						47319414440186
					]
				},
				"available": true,
				"name": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Gold",
				"public_title": "Gold",
				"options": [
					"Gold"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071653507322,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x_814fbda7-e5e6-41ed-8164-eb066cc88fa2.jpg?v=1756808735"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-6.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-4.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-ABF-A10-1_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-Ashimmer_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-AsilverGrey_resolution-standardv2-2x_38ffb44a-6425-4632-98f4-cfeb3d2b295a.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-Ahazyblus_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x_5e16d661-756c-492a-bd72-d83c54f5fd57.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x_814fbda7-e5e6-41ed-8164-eb066cc88fa2.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-7.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-5.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-1.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-3.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-2.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-Ablackgold_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-blackgold.jpg?v=1761277225",
			"//thehues.com/cdn/shop/files/20250516-APebbles-Gold-1_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-APebbles-Gold-4_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-APebbles-Gold-2_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/20250516-APebbles-Gold-3_resolution-standardv2-2x.jpg?v=1756808735",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1761277225",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-hazyblue.jpg?v=1761277225",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-ivory.jpg?v=1761277225",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-shimmer.jpg?v=1761277225",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-silvergrey.jpg?v=1761277225",
			"//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761277225"
		],
		"featured_image": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-6_1024x1024.jpg?v=1756808735",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711302463738,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-6.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-6.jpg?v=1756808735",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287030010,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5751,
					"width": 3834,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-4.jpg?v=1756808735"
				},
				"aspect_ratio": 0.667,
				"height": 5751,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-4.jpg?v=1756808735",
				"width": 3834
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653409018,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABF-A10-1_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABF-A10-1_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653310714,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Ashimmer_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Ashimmer_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653343482,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AsilverGrey_resolution-standardv2-2x_38ffb44a-6425-4632-98f4-cfeb3d2b295a.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AsilverGrey_resolution-standardv2-2x_38ffb44a-6425-4632-98f4-cfeb3d2b295a.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653540090,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Ahazyblus_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Ahazyblus_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653376250,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x_5e16d661-756c-492a-bd72-d83c54f5fd57.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x_5e16d661-756c-492a-bd72-d83c54f5fd57.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653507322,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x_814fbda7-e5e6-41ed-8164-eb066cc88fa2.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x_814fbda7-e5e6-41ed-8164-eb066cc88fa2.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711302332666,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-7.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-7.jpg?v=1756808735",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711302430970,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-5.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-5.jpg?v=1756808735",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711302365434,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-1.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-1.jpg?v=1756808735",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287324922,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5751,
					"width": 3834,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-3.jpg?v=1756808735"
				},
				"aspect_ratio": 0.667,
				"height": 5751,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-3.jpg?v=1756808735",
				"width": 3834
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287259386,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5751,
					"width": 3834,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-2.jpg?v=1756808735"
				},
				"aspect_ratio": 0.667,
				"height": 5751,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-black-gold-2.jpg?v=1756808735",
				"width": 3834
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653441786,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Ablackgold_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Ablackgold_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287357690,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-blackgold.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-blackgold.jpg?v=1761277225",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653572858,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-1_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-1_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653277946,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-4_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-4_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653605626,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-2_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-2_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071653638394,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-3_resolution-standardv2-2x.jpg?v=1756808735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-APebbles-Gold-3_resolution-standardv2-2x.jpg?v=1756808735",
				"width": 1999
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287193850,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1761277225",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287292154,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-hazyblue.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-hazyblue.jpg?v=1761277225",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287128314,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-ivory.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-ivory.jpg?v=1761277225",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287062778,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-shimmer.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-shimmer.jpg?v=1761277225",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287226618,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-silvergrey.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-silvergrey.jpg?v=1761277225",
				"width": 2000
			},
			{
				"alt": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711287390458,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761277225"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/pebbles-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761277225",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Pebbles Foil Printed Velvet curtains bring a playful yet sophisticated touch to any space. The fun, irregular pebble-inspired print adds a sense of whimsy and movement, while the foil accents offer a modern, luxurious shimmer.</p>",
		"url": "/products/pebbles-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$138.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780123046138,
		"title": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "casablanca-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Casablanca's reflective design creates a radiant shine, adding elegance and a touch of glamour to your space.</p>",
		"published_at": "2025-05-07T16:30:38+08:00",
		"created_at": "2025-05-07T16:30:38+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"fall sale",
			"flash_categories",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"upcoming fall"
		],
		"price": 12700,
		"price_min": 12700,
		"price_max": 12700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319461298426,
				"title": "Sahara",
				"option1": "Sahara",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Sahara",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037208015098,
					"product_id": 8780123046138,
					"position": 1,
					"created_at": "2025-05-22T17:42:59+08:00",
					"updated_at": "2025-09-05T15:35:26+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240525-ASahara-2_resolution-standardv2-2x.jpg?v=1757057726",
					"variant_ids": [
						47319461298426
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Sahara",
				"public_title": "Sahara",
				"options": [
					"Sahara"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071414759674,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240525-ASahara-2_resolution-standardv2-2x.jpg?v=1757057726"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Acasablanca_sahara_1024x1024.png?v=1751350598"
			},
			{
				"id": 47319461134586,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44999804158202,
					"product_id": 8780123046138,
					"position": 3,
					"created_at": "2025-09-03T10:14:22+08:00",
					"updated_at": "2025-09-05T15:35:26+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1757057726",
					"variant_ids": [
						47319461134586
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36721394385146,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1757057726"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Acasablanca_cream_1024x1024.png?v=1751350598"
			},
			{
				"id": 47319461167354,
				"title": "Champagne",
				"option1": "Champagne",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Champagne",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352603980026,
					"product_id": 8780123046138,
					"position": 10,
					"created_at": "2025-06-26T10:06:07+08:00",
					"updated_at": "2025-09-05T15:35:26+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Champagne.jpg?v=1757057726",
					"variant_ids": [
						47319461167354
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Champagne",
				"public_title": "Champagne",
				"options": [
					"Champagne"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36271482405114,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Champagne.jpg?v=1757057726"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Acasablanca_champagne_1024x1024.png?v=1751350598"
			},
			{
				"id": 47319461200122,
				"title": "Misty",
				"option1": "Misty",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Misty",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352604012794,
					"product_id": 8780123046138,
					"position": 11,
					"created_at": "2025-06-26T10:06:08+08:00",
					"updated_at": "2025-09-05T15:35:26+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Misty.jpg?v=1757057726",
					"variant_ids": [
						47319461200122
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Misty",
				"public_title": "Misty",
				"options": [
					"Misty"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36271482536186,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Misty.jpg?v=1757057726"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Acasablanca_misty_1024x1024.png?v=1751350598"
			},
			{
				"id": 47319461232890,
				"title": "Hazy Blue",
				"option1": "Hazy Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Hazy Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352603914490,
					"product_id": 8780123046138,
					"position": 12,
					"created_at": "2025-06-26T10:06:08+08:00",
					"updated_at": "2025-09-05T15:35:26+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/HazyBlue.jpg?v=1757057726",
					"variant_ids": [
						47319461232890
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Hazy Blue",
				"public_title": "Hazy Blue",
				"options": [
					"Hazy Blue"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36271482503418,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/HazyBlue.jpg?v=1757057726"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319461265658,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352604045562,
					"product_id": 8780123046138,
					"position": 16,
					"created_at": "2025-06-26T10:06:07+08:00",
					"updated_at": "2025-09-05T15:36:14+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/grey.jpg?v=1757057774",
					"variant_ids": [
						47319461265658
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36271482470650,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/grey.jpg?v=1757057774"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319461331194,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BFSTRAPPO-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352603881722,
					"product_id": 8780123046138,
					"position": 4,
					"created_at": "2025-06-26T10:06:07+08:00",
					"updated_at": "2025-09-05T15:35:26+08:00",
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/black_15088062-61d4-43b2-9161-5effbab5206b.jpg?v=1757057726",
					"variant_ids": [
						47319461331194
					]
				},
				"available": true,
				"name": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36271482372346,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/black_15088062-61d4-43b2-9161-5effbab5206b.jpg?v=1757057726"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240525-ASahara-2_resolution-standardv2-2x.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/20250516-ASahara-1_resolution-standardv2-2x.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/black_15088062-61d4-43b2-9161-5effbab5206b.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-2.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-3.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-4.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-6.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/Champagne.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/Misty.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/HazyBlue.jpg?v=1757057726",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-taupe.jpg?v=1761275902",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1761275902",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-hazyblue.jpg?v=1761275902",
			"//thehues.com/cdn/shop/files/grey.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20250516-ASahara-6_resolution-standardv2-2x.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20240524-ASahara-3_resolution-standardv2-2x.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20250516-ASahara-2_resolution-standardv2-2x-2.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20250516-ASahara-7_resolution-standardv2-2x.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20240524-ASahara-5_resolution-standardv2-2x.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-champangne.jpg?v=1761275902",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1761275902",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1761275902",
			"//thehues.com/cdn/shop/files/Cream_ff9e447a-8057-4731-9a92-a1846295407c.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20250516-ASahara-1_resolution-standardv2-2x-2.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/20250516-ACasablanca-display-2_resolution-standardv2-2x.jpg?v=1757057774",
			"//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-sahara.jpg?v=1761275902"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240525-ASahara-2_resolution-standardv2-2x_1024x1024.jpg?v=1757057726",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414759674,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240525-ASahara-2_resolution-standardv2-2x.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240525-ASahara-2_resolution-standardv2-2x.jpg?v=1757057726",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414497530,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ASahara-1_resolution-standardv2-2x.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ASahara-1_resolution-standardv2-2x.jpg?v=1757057726",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721394385146,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36271482372346,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/black_15088062-61d4-43b2-9161-5effbab5206b.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/black_15088062-61d4-43b2-9161-5effbab5206b.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721394417914,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-2.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-2.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721394286842,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-3.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-3.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721394450682,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-4.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-4.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721394319610,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-6.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-6.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721394352378,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream-5.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36271482405114,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Champagne.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Champagne.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36271482536186,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Misty.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Misty.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36271482503418,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/HazyBlue.jpg?v=1757057726"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/HazyBlue.jpg?v=1757057726",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391239418,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-taupe.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-taupe.jpg?v=1761275902",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391501562,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1761275902",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391468794,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-hazyblue.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-hazyblue.jpg?v=1761275902",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36271482470650,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/grey.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey.jpg?v=1757057774",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414595834,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ASahara-6_resolution-standardv2-2x.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ASahara-6_resolution-standardv2-2x.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414661370,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-ASahara-3_resolution-standardv2-2x.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-ASahara-3_resolution-standardv2-2x.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414563066,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ASahara-2_resolution-standardv2-2x-2.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ASahara-2_resolution-standardv2-2x-2.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414628602,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ASahara-7_resolution-standardv2-2x.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ASahara-7_resolution-standardv2-2x.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414694138,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-ASahara-5_resolution-standardv2-2x.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-ASahara-5_resolution-standardv2-2x.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391108346,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-champangne.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-champangne.jpg?v=1761275902",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391173882,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1761275902",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391141114,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1761275902",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36271482437882,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Cream_ff9e447a-8057-4731-9a92-a1846295407c.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Cream_ff9e447a-8057-4731-9a92-a1846295407c.jpg?v=1757057774",
				"width": 2000
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414530298,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ASahara-1_resolution-standardv2-2x-2.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ASahara-1_resolution-standardv2-2x-2.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071414464762,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ACasablanca-display-2_resolution-standardv2-2x.jpg?v=1757057774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ACasablanca-display-2_resolution-standardv2-2x.jpg?v=1757057774",
				"width": 1999
			},
			{
				"alt": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721391436026,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-sahara.jpg?v=1761275902"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/casablanca-foil-printed-velvet-patterned-custom-curtain-sahara.jpg?v=1761275902",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Casablanca's reflective design creates a radiant shine, adding elegance and a touch of glamour to your space.</p>",
		"url": "/products/casablanca-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$127.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780123078906,
		"title": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "palma-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>The fabric capture the essence of shimmering sunlight reflecting off calm water. Their foil print creates a delicate, glistening effect, reminiscent of sunshine dancing on the surface of a serene lake.</p>",
		"published_at": "2025-05-07T16:30:39+08:00",
		"created_at": "2025-05-07T16:30:39+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Solid Velvet Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"Extra 10%",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"Summer"
		],
		"price": 12000,
		"price_min": 12000,
		"price_max": 12000,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319415652602,
				"title": "Rose Gold",
				"option1": "Rose Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Rose Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037626331386,
					"product_id": 8780123078906,
					"position": 3,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-6_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415652602
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Rose Gold",
				"public_title": "Rose Gold",
				"options": [
					"Rose Gold"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638696186,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-6_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apalma-rose-gold_1024x1024.jpg?v=1751333736"
			},
			{
				"id": 47319415554298,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037625676026,
					"product_id": 8780123078906,
					"position": 7,
					"created_at": "2025-05-22T18:23:17+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Acream_resolution-standardv2-2x_b5a262ff-2b4d-4a99-bc31-5918d01c3036.jpg?v=1761274109",
					"variant_ids": [
						47319415554298
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071639023866,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Acream_resolution-standardv2-2x_b5a262ff-2b4d-4a99-bc31-5918d01c3036.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apalma-cream_1024x1024.jpg?v=1751333736"
			},
			{
				"id": 47319415587066,
				"title": "Champagne",
				"option1": "Champagne",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Champagne",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037626822906,
					"product_id": 8780123078906,
					"position": 8,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Achamoagna_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415587066
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Champagne",
				"public_title": "Champagne",
				"options": [
					"Champagne"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638925562,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Achamoagna_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apalma-champagne_1024x1024.jpg?v=1751333736"
			},
			{
				"id": 47319415619834,
				"title": "Silver",
				"option1": "Silver",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Silver",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037625643258,
					"product_id": 8780123078906,
					"position": 9,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x_6af97ff0-08eb-481c-b19b-003609d84b0d.jpg?v=1761274109",
					"variant_ids": [
						47319415619834
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Silver",
				"public_title": "Silver",
				"options": [
					"Silver"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638139130,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x_6af97ff0-08eb-481c-b19b-003609d84b0d.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Apalma-silver_1024x1024.jpg?v=1751333736"
			},
			{
				"id": 47319415685370,
				"title": "Azure",
				"option1": "Azure",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Azure",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037627019514,
					"product_id": 8780123078906,
					"position": 13,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Aazure_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415685370
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Azure",
				"public_title": "Azure",
				"options": [
					"Azure"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638860026,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Aazure_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319415718138,
				"title": "Misty",
				"option1": "Misty",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Misty",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037625479418,
					"product_id": 8780123078906,
					"position": 10,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Amisty_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415718138
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Misty",
				"public_title": "Misty",
				"options": [
					"Misty"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638466810,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250213-Amisty_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319415750906,
				"title": "Gold",
				"option1": "Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037625741562,
					"product_id": 8780123078906,
					"position": 11,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Agold_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415750906
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Gold",
				"public_title": "Gold",
				"options": [
					"Gold"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638368506,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250213-Agold_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319415783674,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Ash",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037625446650,
					"product_id": 8780123078906,
					"position": 12,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Aash_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415783674
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638270202,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250213-Aash_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319415816442,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037626691834,
					"product_id": 8780123078906,
					"position": 14,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Ateal_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415816442
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638761722,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250213-Ateal_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319415849210,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF2305-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037626921210,
					"product_id": 8780123078906,
					"position": 15,
					"created_at": "2025-05-22T18:23:16+08:00",
					"updated_at": "2025-10-24T10:48:29+08:00",
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250213-Ablack_resolution-standardv2-2x.jpg?v=1761274109",
					"variant_ids": [
						47319415849210
					]
				},
				"available": true,
				"name": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12000,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071638302970,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250213-Ablack_resolution-standardv2-2x.jpg?v=1761274109"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240523-Arosegold-1_resolution-standardv2-2x.jpg?v=1756196856",
			"//thehues.com/cdn/shop/files/20240523-Arosegold-5_resolution-standardv2-2x.jpg?v=1756196857",
			"//thehues.com/cdn/shop/files/20250213-Arosegold-6_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20240523-Arosegold-3_resolution-standardv2-2x.jpg?v=1757057934",
			"//thehues.com/cdn/shop/files/20250213-Arosegold-2_resolution-standardv2-2x.jpg?v=1757057934",
			"//thehues.com/cdn/shop/files/20250213-Arosegold-4_resolution-standardv2-2x.jpg?v=1757057934",
			"//thehues.com/cdn/shop/files/20250516-Acream_resolution-standardv2-2x_b5a262ff-2b4d-4a99-bc31-5918d01c3036.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250516-Achamoagna_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x_6af97ff0-08eb-481c-b19b-003609d84b0d.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250213-Amisty_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250213-Agold_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250213-Aash_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250516-Aazure_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250213-Ateal_resolution-standardv2-2x.jpg?v=1761274109",
			"//thehues.com/cdn/shop/files/20250213-Ablack_resolution-standardv2-2x.jpg?v=1761274109"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240523-Arosegold-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196856",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638171898,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240523-Arosegold-1_resolution-standardv2-2x.jpg?v=1756196856"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-Arosegold-1_resolution-standardv2-2x.jpg?v=1756196856",
				"width": 2000
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638237434,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240523-Arosegold-5_resolution-standardv2-2x.jpg?v=1756196857"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-Arosegold-5_resolution-standardv2-2x.jpg?v=1756196857",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638696186,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-6_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-6_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638204666,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240523-Arosegold-3_resolution-standardv2-2x.jpg?v=1757057934"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-Arosegold-3_resolution-standardv2-2x.jpg?v=1757057934",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638532346,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-2_resolution-standardv2-2x.jpg?v=1757057934"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-2_resolution-standardv2-2x.jpg?v=1757057934",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638630650,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-4_resolution-standardv2-2x.jpg?v=1757057934"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Arosegold-4_resolution-standardv2-2x.jpg?v=1757057934",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071639023866,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Acream_resolution-standardv2-2x_b5a262ff-2b4d-4a99-bc31-5918d01c3036.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Acream_resolution-standardv2-2x_b5a262ff-2b4d-4a99-bc31-5918d01c3036.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638925562,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Achamoagna_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Achamoagna_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638139130,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x_6af97ff0-08eb-481c-b19b-003609d84b0d.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x_6af97ff0-08eb-481c-b19b-003609d84b0d.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638466810,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Amisty_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Amisty_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638368506,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Agold_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Agold_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638270202,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Aash_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Aash_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638860026,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Aazure_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Aazure_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638761722,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Ateal_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Ateal_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			},
			{
				"alt": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071638302970,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Ablack_resolution-standardv2-2x.jpg?v=1761274109"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Ablack_resolution-standardv2-2x.jpg?v=1761274109",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The fabric capture the essence of shimmering sunlight reflecting off calm water. Their foil print creates a delicate, glistening effect, reminiscent of sunshine dancing on the surface of a serene lake.</p>",
		"url": "/products/palma-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$120.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8860707946746,
		"title": "Iris Textured Custom Curtain",
		"handle": "iris-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Light Filtering<br>Weight: Regular (446g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash Safe</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Safe</p><p>PCE Only Delicate Cleaning<br></p>`,
		"description": "<p>Tactile grid texture in stone-washed neutrals—crafted depth, quiet artistry. Where subtlety speaks loudest.</p>",
		"published_at": "2025-07-17T17:26:51+08:00",
		"created_at": "2025-07-15T16:18:13+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Factory products",
			"flash_categories",
			"indoor curtain",
			"july sale",
			"New Arrival",
			"New Arrivals",
			"New Content",
			"Search curtains",
			"Search linen",
			"Summer Collection"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47512708677882,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-12-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535010066682,
					"product_id": 8860707946746,
					"position": 1,
					"created_at": "2025-07-17T11:47:36+08:00",
					"updated_at": "2025-08-26T16:18:35+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/12_green.jpg?v=1756196315",
					"variant_ids": [
						47512708677882
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391871512826,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/12_green.jpg?v=1756196315"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/green_1a83b9d2-9313-4d54-abd9-830104ddc867_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512702976250,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44536612782330,
					"product_id": 8860707946746,
					"position": 3,
					"created_at": "2025-07-17T18:31:39+08:00",
					"updated_at": "2025-08-26T16:18:35+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/white_52ccd6ed-c4e1-4a1e-833a-b86f6b3fad13.jpg?v=1756196315",
					"variant_ids": [
						47512702976250
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36393105129722,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/white_52ccd6ed-c4e1-4a1e-833a-b86f6b3fad13.jpg?v=1756196315"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/white_36a2e8db-7c7e-4460-81e1-3dd5e7de4130_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512705892602,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44536612946170,
					"product_id": 8860707946746,
					"position": 9,
					"created_at": "2025-07-17T18:31:39+08:00",
					"updated_at": "2025-08-26T16:18:36+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/ivory_7c142734-e4d3-4678-9279-e5082f52ed4c.jpg?v=1756196316",
					"variant_ids": [
						47512705892602
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36393105228026,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/ivory_7c142734-e4d3-4678-9279-e5082f52ed4c.jpg?v=1756196316"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ivory_bfeb1d01-fe49-4fb1-889a-fd033c37f567_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512705925370,
				"title": "Oatmeal",
				"option1": "Oatmeal",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44536612815098,
					"product_id": 8860707946746,
					"position": 15,
					"created_at": "2025-07-17T18:31:39+08:00",
					"updated_at": "2025-08-26T16:18:37+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/oatmeal.jpg?v=1756196317",
					"variant_ids": [
						47512705925370
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Oatmeal",
				"public_title": "Oatmeal",
				"options": [
					"Oatmeal"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36393105162490,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/oatmeal.jpg?v=1756196317"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/oat_9bdb2d93-c1b5-44bd-a84d-339ed7adde98_1024x1024.jpg?v=1752717974"
			},
			{
				"id": 47512705958138,
				"title": "Champagne",
				"option1": "Champagne",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44536612913402,
					"product_id": 8860707946746,
					"position": 21,
					"created_at": "2025-07-17T18:31:39+08:00",
					"updated_at": "2025-08-26T16:18:37+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/champagne_ab0d04c5-e2de-4c9d-af3e-f9a7e50fde09.jpg?v=1756196317",
					"variant_ids": [
						47512705958138
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Champagne",
				"public_title": "Champagne",
				"options": [
					"Champagne"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36393105293562,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/champagne_ab0d04c5-e2de-4c9d-af3e-f9a7e50fde09.jpg?v=1756196317"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/champagne_c8fb34b2-d8ab-412c-b1ef-a16c0531b9b9_1024x1024.jpg?v=1752717974"
			},
			{
				"id": 47512705990906,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44536612847866,
					"product_id": 8860707946746,
					"position": 27,
					"created_at": "2025-07-17T18:31:39+08:00",
					"updated_at": "2025-08-26T16:18:38+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/sand_ebb26228-dadc-48f9-956e-206181ecb312.jpg?v=1756196318",
					"variant_ids": [
						47512705990906
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36393105260794,
					"position": 27,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/sand_ebb26228-dadc-48f9-956e-206181ecb312.jpg?v=1756196318"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/sand_600dd670-f8e6-42e0-b98c-5c82e10cae6e_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512706023674,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-6-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44536612880634,
					"product_id": 8860707946746,
					"position": 33,
					"created_at": "2025-07-17T18:31:39+08:00",
					"updated_at": "2025-08-26T16:18:39+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/taupe_939cdcc4-bb33-4815-8faa-a0606433413e.jpg?v=1756196319",
					"variant_ids": [
						47512706023674
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36393105195258,
					"position": 33,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/taupe_939cdcc4-bb33-4815-8faa-a0606433413e.jpg?v=1756196319"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/taupe_7b930f3d-bc9c-4a59-bd5e-2fd1d1f70df3_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512708514042,
				"title": "Silver Gray",
				"option1": "Silver Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-7-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535011049722,
					"product_id": 8860707946746,
					"position": 39,
					"created_at": "2025-07-17T11:47:58+08:00",
					"updated_at": "2025-08-26T16:18:39+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/7_7_silvergray_a425789c-5443-458b-9b89-cb05ba5da309.jpg?v=1756196319",
					"variant_ids": [
						47512708514042
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Silver Gray",
				"public_title": "Silver Gray",
				"options": [
					"Silver Gray"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391872495866,
					"position": 39,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/7_7_silvergray_a425789c-5443-458b-9b89-cb05ba5da309.jpg?v=1756196319"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/silver_81a06ef6-91d8-4827-85da-02aaaba0e92f_1024x1024.jpg?v=1752717974"
			},
			{
				"id": 47512708546810,
				"title": "Khaki",
				"option1": "Khaki",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-8-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535010197754,
					"product_id": 8860707946746,
					"position": 45,
					"created_at": "2025-07-17T11:47:38+08:00",
					"updated_at": "2025-08-26T16:18:40+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/8_khaki.jpg?v=1756196320",
					"variant_ids": [
						47512708546810
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Khaki",
				"public_title": "Khaki",
				"options": [
					"Khaki"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391871643898,
					"position": 45,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/8_khaki.jpg?v=1756196320"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/khaki_8a3f1d1d-9307-41ae-aece-0b0a00cd5566_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512708579578,
				"title": "Gray",
				"option1": "Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-9-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535010132218,
					"product_id": 8860707946746,
					"position": 51,
					"created_at": "2025-07-17T11:47:38+08:00",
					"updated_at": "2025-08-26T16:18:41+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/9_darkgray.jpg?v=1756196321",
					"variant_ids": [
						47512708579578
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Gray",
				"public_title": "Gray",
				"options": [
					"Gray"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391871578362,
					"position": 51,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/9_darkgray.jpg?v=1756196321"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/gray_c5901f8c-5354-4c3f-9e47-a168178e92fa_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512708612346,
				"title": "Dark Gray",
				"option1": "Dark Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-10-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535010164986,
					"product_id": 8860707946746,
					"position": 57,
					"created_at": "2025-07-17T11:47:38+08:00",
					"updated_at": "2025-08-26T16:18:41+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/10_darkgray.jpg?v=1756196321",
					"variant_ids": [
						47512708612346
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Dark Gray",
				"public_title": "Dark Gray",
				"options": [
					"Dark Gray"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391871611130,
					"position": 57,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/10_darkgray.jpg?v=1756196321"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/darkgreay_1024x1024.jpg?v=1752717973"
			},
			{
				"id": 47512708645114,
				"title": "Chestnut",
				"option1": "Chestnut",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-11-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535010099450,
					"product_id": 8860707946746,
					"position": 63,
					"created_at": "2025-07-17T11:47:38+08:00",
					"updated_at": "2025-08-26T16:18:42+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/11_chestnut.jpg?v=1756196322",
					"variant_ids": [
						47512708645114
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Chestnut",
				"public_title": "Chestnut",
				"options": [
					"Chestnut"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391871545594,
					"position": 63,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/11_chestnut.jpg?v=1756196322"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/chestnut_1024x1024.jpg?v=1752717974"
			},
			{
				"id": 47512708710650,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-HA06-13-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44535010033914,
					"product_id": 8860707946746,
					"position": 73,
					"created_at": "2025-07-17T11:47:36+08:00",
					"updated_at": "2025-08-26T16:18:43+08:00",
					"alt": "Iris Textured Custom Curtain - TheHues",
					"width": 4216,
					"height": 5270,
					"src": "//thehues.com/cdn/shop/files/13_black.jpg?v=1756196323",
					"variant_ids": [
						47512708710650
					]
				},
				"available": true,
				"name": "Iris Textured Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Iris Textured Custom Curtain - TheHues",
					"id": 36391871480058,
					"position": 73,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5270,
						"width": 4216,
						"src": "//thehues.com/cdn/shop/files/13_black.jpg?v=1756196323"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/black_952d92e8-2659-4a19-9802-00b238ab86d9_1024x1024.jpg?v=1752717974"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/12_green.jpg?v=1756196315",
			"//thehues.com/cdn/shop/files/6_12_green.jpg?v=1756196315",
			"//thehues.com/cdn/shop/files/white_52ccd6ed-c4e1-4a1e-833a-b86f6b3fad13.jpg?v=1756196315",
			"//thehues.com/cdn/shop/files/9_1_white.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/8_1_white.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/2_1.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/10_1_white.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/1_1.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/ivory_7c142734-e4d3-4678-9279-e5082f52ed4c.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/8_2_ivory.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/2_2.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/10_2_ivory.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/1_2.jpg?v=1756196316",
			"//thehues.com/cdn/shop/files/9_2_ivory.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/oatmeal.jpg?v=1756196317",
			"//thehues.com/cdn/shop/files/8_3_oatmeal.jpg?v=1756196317",
			"//thehues.com/cdn/shop/files/2_3.jpg?v=1756196317",
			"//thehues.com/cdn/shop/files/10_3_oatmeal.jpg?v=1756196317",
			"//thehues.com/cdn/shop/files/1_3.jpg?v=1756196317",
			"//thehues.com/cdn/shop/files/9_3_oatmeal.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/champagne_ab0d04c5-e2de-4c9d-af3e-f9a7e50fde09.jpg?v=1756196317",
			"//thehues.com/cdn/shop/files/8_4_champagne.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/2_4.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/10_4_champagne.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/1_4.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/9_4_champagne.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/sand_ebb26228-dadc-48f9-956e-206181ecb312.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/8_5_sand.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/2_5.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/10_5_sand.jpg?v=1756196318",
			"//thehues.com/cdn/shop/files/1_5.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/9_5_sand.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/taupe_939cdcc4-bb33-4815-8faa-a0606433413e.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/8_6_taupe.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/2_6.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/10_6_taupe.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/1_6.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/9_6_taupe.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/7_7_silvergray_a425789c-5443-458b-9b89-cb05ba5da309.jpg?v=1756196319",
			"//thehues.com/cdn/shop/files/8_7_silvergray.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/2_7.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/10_7_silvergray.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/1_7.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/9_7_silvergray.jpg?v=1761203303",
			"//thehues.com/cdn/shop/files/8_khaki.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/5_8_khkai.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/2_8_khaki.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/6_8_khaki.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/1_8_khaki.jpg?v=1756196320",
			"//thehues.com/cdn/shop/files/3_8_khaki.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/9_darkgray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/5_9_gray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/2_9_gray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/6_9_gray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/1_9_gray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/3_9_gray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/10_darkgray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/5_10_darkgray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/2_10_darkgray.jpg?v=1756196321",
			"//thehues.com/cdn/shop/files/6_10_darkgray.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/1_10_darkgray.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/3_10_darkgray.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/11_chestnut.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/5_11_chestnut.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/2_11_chestnut.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/6_11_chestnut.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/1_11_chestnut.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/3_11_chestnut.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/5_12_green.jpg?v=1756196322",
			"//thehues.com/cdn/shop/files/2_12_green.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/1_12_green.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/3_12_green.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/13_black.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/5_13_black.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/2_13_black.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/6_13_black.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/1_13_black.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/3_13_black.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/7_1_wite_451f6f06-762b-404b-9c95-1170d4c9807b.jpg?v=1756196323",
			"//thehues.com/cdn/shop/files/7_2_ivory_c8484bef-0c36-4033-9892-821455366838.jpg?v=1756196324",
			"//thehues.com/cdn/shop/files/7_3_oatmeal_5dd62ee1-23f6-4afe-b15a-3f8df88469f6.jpg?v=1756196324",
			"//thehues.com/cdn/shop/files/7_4_champagne_7314fb3d-720c-482e-998d-e4a809e56dee.jpg?v=1756196324",
			"//thehues.com/cdn/shop/files/7_5_sand_69d8a1bf-295c-4aa8-997c-10b0901c4076.jpg?v=1756196324",
			"//thehues.com/cdn/shop/files/7_6_taupe_d42d1ca0-04d7-46a5-91a4-110e017c9c84.jpg?v=1756196324"
		],
		"featured_image": "//thehues.com/cdn/shop/files/12_green_1024x1024.jpg?v=1756196315",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391871512826,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/12_green.jpg?v=1756196315"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/12_green.jpg?v=1756196315",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387783573754,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6_12_green.jpg?v=1756196315"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6_12_green.jpg?v=1756196315",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36393105129722,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/white_52ccd6ed-c4e1-4a1e-833a-b86f6b3fad13.jpg?v=1756196315"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/white_52ccd6ed-c4e1-4a1e-833a-b86f6b3fad13.jpg?v=1756196315",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387795370234,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_1_white.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_1_white.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387795239162,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_1_white.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_1_white.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387795206394,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_1.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_1.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387795140858,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_1_white.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_1_white.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387795075322,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_1.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_1.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36393105228026,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/ivory_7c142734-e4d3-4678-9279-e5082f52ed4c.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ivory_7c142734-e4d3-4678-9279-e5082f52ed4c.jpg?v=1756196316",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787145466,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_2_ivory.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_2_ivory.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787178234,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_2.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_2.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787014394,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_2_ivory.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_2_ivory.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387786850554,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_2.jpg?v=1756196316"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_2.jpg?v=1756196316",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787112698,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_2_ivory.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_2_ivory.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36393105162490,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/oatmeal.jpg?v=1756196317"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/oatmeal.jpg?v=1756196317",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387791962362,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_3_oatmeal.jpg?v=1756196317"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_3_oatmeal.jpg?v=1756196317",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387791995130,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_3.jpg?v=1756196317"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_3.jpg?v=1756196317",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387791503610,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_3_oatmeal.jpg?v=1756196317"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_3_oatmeal.jpg?v=1756196317",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387791634682,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_3.jpg?v=1756196317"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_3.jpg?v=1756196317",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387791700218,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_3_oatmeal.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_3_oatmeal.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36393105293562,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/champagne_ab0d04c5-e2de-4c9d-af3e-f9a7e50fde09.jpg?v=1756196317"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/champagne_ab0d04c5-e2de-4c9d-af3e-f9a7e50fde09.jpg?v=1756196317",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387785408762,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_4_champagne.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_4_champagne.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387785605370,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_4.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_4.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782197498,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_4_champagne.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_4_champagne.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782000890,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_4.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_4.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782820090,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_4_champagne.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_4_champagne.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36393105260794,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/sand_ebb26228-dadc-48f9-956e-206181ecb312.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sand_ebb26228-dadc-48f9-956e-206181ecb312.jpg?v=1756196318",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387792945402,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_5_sand.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_5_sand.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387792978170,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_5.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_5.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387792879866,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_5_sand.jpg?v=1756196318"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_5_sand.jpg?v=1756196318",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387792716026,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_5.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_5.jpg?v=1756196319",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387792912634,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_5_sand.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_5_sand.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36393105195258,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/taupe_939cdcc4-bb33-4815-8faa-a0606433413e.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/taupe_939cdcc4-bb33-4815-8faa-a0606433413e.jpg?v=1756196319",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794551034,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_6_taupe.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_6_taupe.jpg?v=1756196319",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794583802,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_6.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_6.jpg?v=1756196319",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794485498,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_6_taupe.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_6_taupe.jpg?v=1756196319",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794452730,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_6.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_6.jpg?v=1756196319",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794518266,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_6_taupe.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_6_taupe.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872495866,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_7_silvergray_a425789c-5443-458b-9b89-cb05ba5da309.jpg?v=1756196319"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_7_silvergray_a425789c-5443-458b-9b89-cb05ba5da309.jpg?v=1756196319",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794026746,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/8_7_silvergray.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_7_silvergray.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794092282,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_7.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_7.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387793993978,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/10_7_silvergray.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_7_silvergray.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387793830138,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_7.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_7.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387794059514,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/9_7_silvergray.jpg?v=1761203303"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_7_silvergray.jpg?v=1761203303",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391871643898,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/8_khaki.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/8_khaki.jpg?v=1756196320",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387790061818,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_8_khkai.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_8_khkai.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387789996282,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_8_khaki.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_8_khaki.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387789766906,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6_8_khaki.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6_8_khaki.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387789635834,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_8_khaki.jpg?v=1756196320"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_8_khaki.jpg?v=1756196320",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387789963514,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_8_khaki.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_8_khaki.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391871578362,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/9_darkgray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9_darkgray.jpg?v=1756196321",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782590714,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_9_gray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_9_gray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782623482,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_9_gray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_9_gray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782459642,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6_9_gray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6_9_gray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782525178,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_9_gray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_9_gray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387782557946,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_9_gray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_9_gray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391871611130,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/10_darkgray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/10_darkgray.jpg?v=1756196321",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387786981626,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_10_darkgray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_10_darkgray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787604218,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_10_darkgray.jpg?v=1756196321"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_10_darkgray.jpg?v=1756196321",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387785834746,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6_10_darkgray.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6_10_darkgray.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387786293498,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_10_darkgray.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_10_darkgray.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787342074,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_10_darkgray.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_10_darkgray.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391871545594,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/11_chestnut.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/11_chestnut.jpg?v=1756196322",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387786686714,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_11_chestnut.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_11_chestnut.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787571450,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_11_chestnut.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_11_chestnut.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387785212154,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6_11_chestnut.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6_11_chestnut.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387785244922,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_11_chestnut.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_11_chestnut.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387787079930,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_11_chestnut.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_11_chestnut.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387784163578,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_12_green.jpg?v=1756196322"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_12_green.jpg?v=1756196322",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387784196346,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_12_green.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_12_green.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387783442682,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_12_green.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_12_green.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387783639290,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_12_green.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_12_green.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391871480058,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/13_black.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/13_black.jpg?v=1756196323",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387766763770,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/5_13_black.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/5_13_black.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387766665466,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2_13_black.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2_13_black.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387766796538,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6_13_black.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6_13_black.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387766632698,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/1_13_black.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1_13_black.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36387766698234,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/3_13_black.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/3_13_black.jpg?v=1756196323",
				"width": 2000
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872528634,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_1_wite_451f6f06-762b-404b-9c95-1170d4c9807b.jpg?v=1756196323"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_1_wite_451f6f06-762b-404b-9c95-1170d4c9807b.jpg?v=1756196323",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872626938,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_2_ivory_c8484bef-0c36-4033-9892-821455366838.jpg?v=1756196324"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_2_ivory_c8484bef-0c36-4033-9892-821455366838.jpg?v=1756196324",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872659706,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_3_oatmeal_5dd62ee1-23f6-4afe-b15a-3f8df88469f6.jpg?v=1756196324"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_3_oatmeal_5dd62ee1-23f6-4afe-b15a-3f8df88469f6.jpg?v=1756196324",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872692474,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_4_champagne_7314fb3d-720c-482e-998d-e4a809e56dee.jpg?v=1756196324"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_4_champagne_7314fb3d-720c-482e-998d-e4a809e56dee.jpg?v=1756196324",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872594170,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_5_sand_69d8a1bf-295c-4aa8-997c-10b0901c4076.jpg?v=1756196324"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_5_sand_69d8a1bf-295c-4aa8-997c-10b0901c4076.jpg?v=1756196324",
				"width": 4216
			},
			{
				"alt": "Iris Textured Custom Curtain - TheHues",
				"id": 36391872561402,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5270,
					"width": 4216,
					"src": "//thehues.com/cdn/shop/files/7_6_taupe_d42d1ca0-04d7-46a5-91a4-110e017c9c84.jpg?v=1756196324"
				},
				"aspect_ratio": 0.8,
				"height": 5270,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/7_6_taupe_d42d1ca0-04d7-46a5-91a4-110e017c9c84.jpg?v=1756196324",
				"width": 4216
			},
			{
				"alt": null,
				"id": 36393033564410,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 1920,
					"width": 1440,
					"src": "//thehues.com/cdn/shop/files/preview_images/0c01f6d2c44747dd8bf96d025eabe598.thumbnail.0000000000.jpg?v=1752746311"
				},
				"aspect_ratio": 0.75,
				"duration": 8270,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0c01f6d2c44747dd8bf96d025eabe598/0c01f6d2c44747dd8bf96d025eabe598.SD-480p-1.2Mbps-51412594.mp4?v=0",
						"width": 360
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0c01f6d2c44747dd8bf96d025eabe598/0c01f6d2c44747dd8bf96d025eabe598.HD-1080p-4.8Mbps-51412594.mp4?v=0",
						"width": 810
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0c01f6d2c44747dd8bf96d025eabe598/0c01f6d2c44747dd8bf96d025eabe598.HD-720p-3.0Mbps-51412594.mp4?v=0",
						"width": 540
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0c01f6d2c44747dd8bf96d025eabe598/0c01f6d2c44747dd8bf96d025eabe598.m3u8?v=0",
						"width": 810
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Tactile grid texture in stone-washed neutrals—crafted depth, quiet artistry. Where subtlety speaks loudest.</p>",
		"url": "/products/iris-textured-custom-curtain",
		"regular_price": "$109.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrival-curtains",
				"title": "New Arrival Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			}
		]
	},
	{
		"id": 8875378999546,
		"title": "Helena 100% Linen Custom Curtains",
		"handle": "helena-100-linen-custom-curtains",
		"product_details": `<h3>Specifications</h3><p><strong>Material </strong>100% Linen</p><p><strong>Features</strong> Light Filtering</p><p><strong>Weight</strong> Regular (210g/㎡)</p><p><strong>Softness</strong> Soft</p><p></p><h3>Care</h3><p>Not suitable for washing</p><p>Avoid ironing</p><p>Not suitable for dryer</p><p>Avoid bleaching</p>`,
		"description": "<p>Lightweight &amp; airy pure linen, draping gracefully to breathe effortless elegance into your space. <br>Ethereal softness meets easy versatility – in a spectrum of colors made for effortless pairing.</p>",
		"published_at": "2025-09-25T09:12:48+08:00",
		"created_at": "2025-08-01T16:41:34+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"flash_categories",
			"indoor curtain",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47572575289594,
				"title": "Grey Beige",
				"option1": "Grey Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-9-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761229689082,
					"product_id": 8875378999546,
					"position": 46,
					"created_at": "2025-08-11T14:16:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-1.jpg?v=1758701211",
					"variant_ids": [
						47572575289594
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Grey Beige",
				"public_title": "Grey Beige",
				"options": [
					"Grey Beige"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521985212666,
					"position": 47,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-1.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-graybeige_1024x1024.jpg?v=1754897011"
			},
			{
				"id": 47572574994682,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-12-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313722618,
					"product_id": 8875378999546,
					"position": 1,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:05:02+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-grey.jpg?v=1758701102",
					"variant_ids": [
						47572574994682
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585332474,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-grey.jpg?v=1758701102"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-grey_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575158522,
				"title": "Dark Green",
				"option1": "Dark Green",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-40-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761229066490,
					"product_id": 8875378999546,
					"position": 26,
					"created_at": "2025-08-11T14:16:46+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-2.jpg?v=1758701211",
					"variant_ids": [
						47572575158522
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Dark Green",
				"public_title": "Dark Green",
				"options": [
					"Dark Green"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521984590074,
					"position": 27,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-2.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-darkgreen_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47603297091834,
				"title": "Elephant",
				"option1": "Elephant",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-22-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313460474,
					"product_id": 8875378999546,
					"position": 121,
					"created_at": "2025-09-24T15:53:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-elephant.jpg?v=1758701211",
					"variant_ids": [
						47603297091834
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Elephant",
				"public_title": "Elephant",
				"options": [
					"Elephant"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585037562,
					"position": 122,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-elephant.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/BLACK_746fa9fb-eed5-4f8d-a397-b9ecdc886483_1024x1024.jpg?v=1760063745"
			},
			{
				"id": 47572575518970,
				"title": "Camel",
				"option1": "Camel",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-7-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313886458,
					"product_id": 8875378999546,
					"position": 96,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-camel.jpg?v=1758701211",
					"variant_ids": [
						47572575518970
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Camel",
				"public_title": "Camel",
				"options": [
					"Camel"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585496314,
					"position": 97,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-camel.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-camel_1024x1024.jpg?v=1754897011"
			},
			{
				"id": 47572575027450,
				"title": "Dark Grey",
				"option1": "Dark Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313493242,
					"product_id": 8875378999546,
					"position": 6,
					"created_at": "2025-09-24T15:53:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-darkgrey.jpg?v=1758701211",
					"variant_ids": [
						47572575027450
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Dark Grey",
				"public_title": "Dark Grey",
				"options": [
					"Dark Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585070330,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-darkgrey.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-darkgrey_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47603297157370,
				"title": "Brick",
				"option1": "Brick",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-26-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313755386,
					"product_id": 8875378999546,
					"position": 81,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brick.jpg?v=1758701211",
					"variant_ids": [
						47603297157370
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Brick",
				"public_title": "Brick",
				"options": [
					"Brick"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585365242,
					"position": 82,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brick.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/orange_1024x1024.jpg?v=1760063837"
			},
			{
				"id": 47572575256826,
				"title": "Beige White",
				"option1": "Beige White",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761228050682,
					"product_id": 8875378999546,
					"position": 41,
					"created_at": "2025-08-11T14:16:46+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-1.jpg?v=1758701211",
					"variant_ids": [
						47572575256826
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Beige White",
				"public_title": "Beige White",
				"options": [
					"Beige White"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521983574266,
					"position": 42,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-1.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-beigewhite_1024x1024.jpg?v=1754897009"
			},
			{
				"id": 47572575060218,
				"title": "Moss",
				"option1": "Moss",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-14-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313526010,
					"product_id": 8875378999546,
					"position": 11,
					"created_at": "2025-09-24T15:53:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-moss.jpg?v=1758701211",
					"variant_ids": [
						47572575060218
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Moss",
				"public_title": "Moss",
				"options": [
					"Moss"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585103098,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-moss.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-moss_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575092986,
				"title": "Army Green",
				"option1": "Army Green",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-23-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313427706,
					"product_id": 8875378999546,
					"position": 16,
					"created_at": "2025-09-24T15:53:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-armygreen.jpg?v=1758701211",
					"variant_ids": [
						47572575092986
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Army Green",
				"public_title": "Army Green",
				"options": [
					"Army Green"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585004794,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-armygreen.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-argygreen_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575125754,
				"title": "Pine",
				"option1": "Pine",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-29-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313591546,
					"product_id": 8875378999546,
					"position": 21,
					"created_at": "2025-09-24T15:53:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pine.jpg?v=1758701211",
					"variant_ids": [
						47572575125754
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Pine",
				"public_title": "Pine",
				"options": [
					"Pine"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585168634,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pine.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-pine_1024x1024.jpg?v=1754897011"
			},
			{
				"id": 47572575224058,
				"title": "Ivory White",
				"option1": "Ivory White",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761230016762,
					"product_id": 8875378999546,
					"position": 36,
					"created_at": "2025-08-11T14:16:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-1.jpg?v=1758701211",
					"variant_ids": [
						47572575224058
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Ivory White",
				"public_title": "Ivory White",
				"options": [
					"Ivory White"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521985540346,
					"position": 37,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-1.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-ivorywhite_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575322362,
				"title": "Stone",
				"option1": "Stone",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761231163642,
					"product_id": 8875378999546,
					"position": 51,
					"created_at": "2025-08-11T14:16:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-1.jpg?v=1758701211",
					"variant_ids": [
						47572575322362
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Stone",
				"public_title": "Stone",
				"options": [
					"Stone"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521986687226,
					"position": 52,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-1.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-stone_1024x1024.jpg?v=1754897011"
			},
			{
				"id": 47572575355130,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-18-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761230999802,
					"product_id": 8875378999546,
					"position": 56,
					"created_at": "2025-08-11T14:16:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-1.jpg?v=1758701211",
					"variant_ids": [
						47572575355130
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521986523386,
					"position": 57,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-1.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-sand_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575387898,
				"title": "Light Brown",
				"option1": "Light Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-27-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313788154,
					"product_id": 8875378999546,
					"position": 61,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-lightbrown.jpg?v=1758701211",
					"variant_ids": [
						47572575387898
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Light Brown",
				"public_title": "Light Brown",
				"options": [
					"Light Brown"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585398010,
					"position": 62,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-lightbrown.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-lightbrown_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575584506,
				"title": "Bronze",
				"option1": "Bronze",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-16-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313951994,
					"product_id": 8875378999546,
					"position": 111,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bronze.jpg?v=1758701211",
					"variant_ids": [
						47572575584506
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Bronze",
				"public_title": "Bronze",
				"options": [
					"Bronze"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585561850,
					"position": 112,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bronze.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-bronze_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575191290,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-17-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44761231655162,
					"product_id": 8875378999546,
					"position": 31,
					"created_at": "2025-08-11T14:16:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-1.jpg?v=1758701211",
					"variant_ids": [
						47572575191290
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36521987178746,
					"position": 32,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-1.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-white_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575420666,
				"title": "Tavern Taupe",
				"option1": "Tavern Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313689850,
					"product_id": 8875378999546,
					"position": 106,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taverntaupe.jpg?v=1758701211",
					"variant_ids": [
						47572575420666
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Tavern Taupe",
				"public_title": "Tavern Taupe",
				"options": [
					"Tavern Taupe"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585299706,
					"position": 107,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taverntaupe.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-taverntaupe_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575453434,
				"title": "Taupe Grey",
				"option1": "Taupe Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-15-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313657082,
					"product_id": 8875378999546,
					"position": 101,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taupegrey.jpg?v=1758701211",
					"variant_ids": [
						47572575453434
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Taupe Grey",
				"public_title": "Taupe Grey",
				"options": [
					"Taupe Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585266938,
					"position": 102,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taupegrey.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-taupegrey_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575486202,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-38-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313558778,
					"product_id": 8875378999546,
					"position": 66,
					"created_at": "2025-09-24T15:53:47+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brown.jpg?v=1758701211",
					"variant_ids": [
						47572575486202
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585135866,
					"position": 67,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brown.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-brown_1024x1024.jpg?v=1754897010"
			},
			{
				"id": 47572575551738,
				"title": "Mustard",
				"option1": "Mustard",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-28-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313919226,
					"product_id": 8875378999546,
					"position": 86,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-mustard.jpg?v=1758701211",
					"variant_ids": [
						47572575551738
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Mustard",
				"public_title": "Mustard",
				"options": [
					"Mustard"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585529082,
					"position": 87,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-mustard.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-musturd_1024x1024.jpg?v=1754897011"
			},
			{
				"id": 47572575650042,
				"title": "Pink",
				"option1": "Pink",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-6-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313984762,
					"product_id": 8875378999546,
					"position": 91,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pink.jpg?v=1758701211",
					"variant_ids": [
						47572575650042
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Pink",
				"public_title": "Pink",
				"options": [
					"Pink"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585594618,
					"position": 92,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pink.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/helena-linen-custom-curtain-color-pink_1024x1024.jpg?v=1754897011"
			},
			{
				"id": 47572575682810,
				"title": "Wine",
				"option1": "Wine",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-13-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313820922,
					"product_id": 8875378999546,
					"position": 71,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-wine.jpg?v=1758701211",
					"variant_ids": [
						47572575682810
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Wine",
				"public_title": "Wine",
				"options": [
					"Wine"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585430778,
					"position": 72,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-wine.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47572575748346,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-19-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177313853690,
					"product_id": 8875378999546,
					"position": 76,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-blue.jpg?v=1758701211",
					"variant_ids": [
						47572575748346
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585463546,
					"position": 77,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-blue.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47603297124602,
				"title": "Grey Blue Sea",
				"option1": "Grey Blue Sea",
				"option2": null,
				"option3": null,
				"sku": "THC-MBH-JD1099-35-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45177314050298,
					"product_id": 8875378999546,
					"position": 116,
					"created_at": "2025-09-24T15:53:48+08:00",
					"updated_at": "2025-09-24T16:06:51+08:00",
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bluesea.jpg?v=1758701211",
					"variant_ids": [
						47603297124602
					]
				},
				"available": true,
				"name": "Helena 100% Linen Custom Curtains - Grey Blue Sea",
				"public_title": "Grey Blue Sea",
				"options": [
					"Grey Blue Sea"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Helena 100% Linen Custom Curtains - TheHues",
					"id": 36897585627386,
					"position": 117,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bluesea.jpg?v=1758701211"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/SILVERGREY_fc4b0a40-39e7-4e69-be98-62588ff4a113_1024x1024.jpg?v=1760063796"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-grey.jpg?v=1758701102",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-darkgrey.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-moss.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-armygreen.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pine.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-4.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-4.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-4.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-4.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-4.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-4.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-lightbrown.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brown.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-wine.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-5.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-1.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-blue.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brick.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-mustard.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pink.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-camel.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taupegrey.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taverntaupe.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bronze.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bluesea.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-elephant.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-1.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-3.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-4.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-5.jpg?v=1761199590",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-2.jpg?v=1758701211",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-3.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-2.jpg?v=1758701103",
			"//thehues.com/cdn/shop/files/Helena-custom-curtain.jpg?v=1758701103"
		],
		"featured_image": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-grey_1024x1024.jpg?v=1758701102",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585332474,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-grey.jpg?v=1758701102"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-grey.jpg?v=1758701102",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985179898,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985048826,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985114362,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985147130,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585070330,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-darkgrey.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-darkgrey.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984721146,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36881928782074,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1350,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/bba4633fb4114208a95984d444e3babd.thumbnail.0000000000.jpg?v=1758680877"
				},
				"aspect_ratio": 0.8,
				"duration": 5800,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/bba4633fb4114208a95984d444e3babd/bba4633fb4114208a95984d444e3babd.SD-480p-1.5Mbps-58125712.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/bba4633fb4114208a95984d444e3babd/bba4633fb4114208a95984d444e3babd.HD-1080p-7.2Mbps-58125712.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/bba4633fb4114208a95984d444e3babd/bba4633fb4114208a95984d444e3babd.HD-720p-4.5Mbps-58125712.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/bba4633fb4114208a95984d444e3babd/bba4633fb4114208a95984d444e3babd.m3u8?v=0",
						"width": 864
					}
				]
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984786682,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984819450,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984852218,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585103098,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-moss.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-moss.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985868026,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985933562,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985966330,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985999098,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585004794,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-armygreen.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-armygreen.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983410426,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983475962,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983508730,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983541498,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585168634,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pine.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pine.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986195706,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986261242,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986294010,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986326778,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984590074,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984557306,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984622842,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984655610,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984688378,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgreen-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987178746,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987244282,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-3.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987211514,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987309818,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987277050,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-4.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-white-4.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985540346,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985605882,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-3.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985573114,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985671418,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985638650,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-4.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-ivorywhite-4.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983574266,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983639802,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-3.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983607034,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983705338,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983672570,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-4.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-beigewhite-4.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985212666,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985278202,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-3.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985245434,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985343738,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985310970,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-4.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybeige-4.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986687226,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986752762,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-3.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986719994,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986818298,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986785530,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-4.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-stone-4.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986523386,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986588922,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-3.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986556154,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986654458,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986621690,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-4.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-sand-4.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585398010,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-lightbrown.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-lightbrown.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985704186,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985769722,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985802490,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985835258,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585135866,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brown.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brown.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984229626,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984295162,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984327930,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984360698,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585430778,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-wine.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-wine.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987375354,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987440890,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-4.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987473658,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-5.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-5.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987342586,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-1.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-1.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585463546,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-blue.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-blue.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983738106,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983803642,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983836410,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983869178,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585365242,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brick.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-brick.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983901946,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983967482,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984000250,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984033018,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585529082,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-mustard.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-mustard.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986031866,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986097402,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986130170,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986162938,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585594618,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pink.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-pink.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986359546,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986425082,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986457850,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986490618,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585496314,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-camel.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-camel.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984393466,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984459002,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984491770,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984524538,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585266938,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taupegrey.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taupegrey.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986851066,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986916602,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986949370,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986982138,
				"position": 106,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585299706,
				"position": 107,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taverntaupe.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-taverntaupe.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987014906,
				"position": 108,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987080442,
				"position": 109,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987113210,
				"position": 110,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987145978,
				"position": 111,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585561850,
				"position": 112,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bronze.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bronze.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984065786,
				"position": 113,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984131322,
				"position": 114,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984164090,
				"position": 115,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984196858,
				"position": 116,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585627386,
				"position": 117,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bluesea.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-bluesea.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985376506,
				"position": 118,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985442042,
				"position": 119,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985474810,
				"position": 120,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985507578,
				"position": 121,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36897585037562,
				"position": 122,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-elephant.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-100-linen-custom-curtains-elephant.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984884986,
				"position": 123,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-1.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-1.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984950522,
				"position": 124,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-3.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-3.jpg?v=1758701211",
				"width": 1999
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984983290,
				"position": 125,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-4.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-4.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985016058,
				"position": 126,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-5.jpg?v=1761199590"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-5.jpg?v=1761199590",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985081594,
				"position": 127,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-grey-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984753914,
				"position": 128,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-darkgrey-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985900794,
				"position": 129,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-2.jpg?v=1758701211"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-moss-2.jpg?v=1758701211",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983443194,
				"position": 130,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-armygreen-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986228474,
				"position": 131,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pine-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985736954,
				"position": 132,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-lightbrown-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984262394,
				"position": 133,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brown-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987408122,
				"position": 134,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-3.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-wine-3.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983770874,
				"position": 135,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-blue-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521983934714,
				"position": 136,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-brick-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986064634,
				"position": 137,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-mustard-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986392314,
				"position": 138,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-pink-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984426234,
				"position": 139,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-camel-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521986883834,
				"position": 140,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taupegrey-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521987047674,
				"position": 141,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-taverntaupe-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984098554,
				"position": 142,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-bronze-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521985409274,
				"position": 143,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-greybluesea-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36521984917754,
				"position": 144,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-2.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/helena-linen-custom-curtains-elephant-2.jpg?v=1758701103",
				"width": 2000
			},
			{
				"alt": "Helena 100% Linen Custom Curtains - TheHues",
				"id": 36889310626042,
				"position": 145,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 834,
					"width": 667,
					"src": "//thehues.com/cdn/shop/files/Helena-custom-curtain.jpg?v=1758701103"
				},
				"aspect_ratio": 0.8,
				"height": 834,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Helena-custom-curtain.jpg?v=1758701103",
				"width": 667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Lightweight &amp; airy pure linen, draping gracefully to breathe effortless elegance into your space. <br>Ethereal softness meets easy versatility – in a spectrum of colors made for effortless pairing.</p>",
		"url": "/products/helena-100-linen-custom-curtains",
		"regular_price": "$109.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780124455162,
		"title": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain",
		"handle": "chelsea-cotton-blend-geometric-golden-grid-patterned-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 95% Polyester &amp; 5% cotton<br>Features: Unique Meteor Fabric<br>Weight: Regular (360g/㎡)<br>Softness: Hard</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Safe to Iron</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Made from a soft yet durable cotton blend, these curtains provide soundproofing, blackout and insulation ensuring a peaceful and quiet environment.</p>",
		"published_at": "2025-05-07T16:31:20+08:00",
		"created_at": "2025-05-07T16:31:20+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > geometric custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > patterned custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search cotton",
			"Search curtains",
			"Search Pinch pleat"
		],
		"price": 10400,
		"price_min": 10400,
		"price_max": 10400,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319459463418,
				"title": "Grid",
				"option1": "Grid",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR410-C-Grid",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037229183226,
					"product_id": 8780124455162,
					"position": 8,
					"created_at": "2025-05-22T17:45:02+08:00",
					"updated_at": "2025-08-26T16:26:21+08:00",
					"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-1_resolution-standardv2-2x.jpg?v=1756196781",
					"variant_ids": [
						47319459463418
					]
				},
				"available": true,
				"name": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - Grid",
				"public_title": "Grid",
				"options": [
					"Grid"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
					"id": 36071426523386,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-AGrid-1_resolution-standardv2-2x.jpg?v=1756196781"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-AGrid-7_resolution-standardv2-2x_1024x1024.jpg?v=1761276270"
			},
			{
				"id": 47319459496186,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR410-C-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037229674746,
					"product_id": 8780124455162,
					"position": 15,
					"created_at": "2025-05-22T17:45:03+08:00",
					"updated_at": "2025-10-24T11:24:30+08:00",
					"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250208-AIvory-1-1_resolution-standardv2-2x.jpg?v=1761276270",
					"variant_ids": [
						47319459496186
					]
				},
				"available": true,
				"name": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
					"id": 36071426851066,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250208-AIvory-1-1_resolution-standardv2-2x.jpg?v=1761276270"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-AIvory-1-1_resolution-standardv2-2x_1024x1024.jpg?v=1761276270"
			},
			{
				"id": 47319459397882,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR410-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037223710970,
					"product_id": 8780124455162,
					"position": 16,
					"created_at": "2025-05-22T17:44:49+08:00",
					"updated_at": "2025-10-24T11:24:30+08:00",
					"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250208-AGrey-1-2_resolution-standardv2-2x.jpg?v=1761276270",
					"variant_ids": [
						47319459397882
					]
				},
				"available": true,
				"name": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
					"id": 36071423574266,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250208-AGrey-1-2_resolution-standardv2-2x.jpg?v=1761276270"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-AGrey-1-2_resolution-standardv2-2x_1024x1024.jpg?v=1761276270"
			},
			{
				"id": 47319459430650,
				"title": "Circuit",
				"option1": "Circuit",
				"option2": null,
				"option3": null,
				"sku": "THC-138LB-TR410-C-Circuit",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037223612666,
					"product_id": 8780124455162,
					"position": 3,
					"created_at": "2025-05-22T17:44:49+08:00",
					"updated_at": "2025-10-24T11:24:30+08:00",
					"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-1_resolution-standardv2-2x.jpg?v=1761276270",
					"variant_ids": [
						47319459430650
					]
				},
				"available": true,
				"name": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - Circuit",
				"public_title": "Circuit",
				"options": [
					"Circuit"
				],
				"price": 10400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
					"id": 36071423508730,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-1_resolution-standardv2-2x.jpg?v=1761276270"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250208-ACircuit-1_resolution-standardv2-2x_1024x1024.jpg?v=1761276270"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250208-Acircuit-1-1_resolution-standardv2-2x.jpg?v=1756196780",
			"//thehues.com/cdn/shop/files/20250208-ACircuit-3_resolution-standardv2-2x.jpg?v=1756196780",
			"//thehues.com/cdn/shop/files/20250208-ACircuit-1_resolution-standardv2-2x.jpg?v=1761276270",
			"//thehues.com/cdn/shop/files/20250208-ACircuit-2_resolution-standardv2-2x.jpg?v=1756196780",
			"//thehues.com/cdn/shop/files/20250208-ACircuit-4_resolution-standardv2-2x.jpg?v=1756196781",
			"//thehues.com/cdn/shop/files/20250208-ACircuit-5_resolution-standardv2-2x.jpg?v=1761276143",
			"//thehues.com/cdn/shop/files/20250208-ACircuit-6_resolution-standardv2-2x.jpg?v=1756196781",
			"//thehues.com/cdn/shop/files/20250516-AGrid-1_resolution-standardv2-2x.jpg?v=1756196781",
			"//thehues.com/cdn/shop/files/20250516-AGrid-2_resolution-standardv2-2x.jpg?v=1756196781",
			"//thehues.com/cdn/shop/files/20250516-AGrid-6_resolution-standardv2-2x.jpg?v=1756196781",
			"//thehues.com/cdn/shop/files/20250516-AGrid-3_resolution-standardv2-2x.jpg?v=1761276143",
			"//thehues.com/cdn/shop/files/20250516-AGrid-4_resolution-standardv2-2x.jpg?v=1756196781",
			"//thehues.com/cdn/shop/files/20250516-AGrid-5_resolution-standardv2-2x.jpg?v=1761276143",
			"//thehues.com/cdn/shop/files/20250208-AGrid-7_resolution-standardv2-2x.jpg?v=1761276270",
			"//thehues.com/cdn/shop/files/20250208-AIvory-1-1_resolution-standardv2-2x.jpg?v=1761276270",
			"//thehues.com/cdn/shop/files/20250208-AGrey-1-2_resolution-standardv2-2x.jpg?v=1761276270"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250208-Acircuit-1-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196780",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071423312122,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-Acircuit-1-1_resolution-standardv2-2x.jpg?v=1756196780"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-Acircuit-1-1_resolution-standardv2-2x.jpg?v=1756196780",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071423377658,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-3_resolution-standardv2-2x.jpg?v=1756196780"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-3_resolution-standardv2-2x.jpg?v=1756196780",
				"width": 1999
			},
			{
				"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
				"id": 36071423508730,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-1_resolution-standardv2-2x.jpg?v=1761276270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-1_resolution-standardv2-2x.jpg?v=1761276270",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071423344890,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-2_resolution-standardv2-2x.jpg?v=1756196780"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-2_resolution-standardv2-2x.jpg?v=1756196780",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071423410426,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-4_resolution-standardv2-2x.jpg?v=1756196781"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-4_resolution-standardv2-2x.jpg?v=1756196781",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071423443194,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-5_resolution-standardv2-2x.jpg?v=1761276143"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-5_resolution-standardv2-2x.jpg?v=1761276143",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071423475962,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-6_resolution-standardv2-2x.jpg?v=1756196781"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-ACircuit-6_resolution-standardv2-2x.jpg?v=1756196781",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071426523386,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-1_resolution-standardv2-2x.jpg?v=1756196781"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AGrid-1_resolution-standardv2-2x.jpg?v=1756196781",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071426588922,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-2_resolution-standardv2-2x.jpg?v=1756196781"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AGrid-2_resolution-standardv2-2x.jpg?v=1756196781",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071426359546,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-6_resolution-standardv2-2x.jpg?v=1756196781"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AGrid-6_resolution-standardv2-2x.jpg?v=1756196781",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071426654458,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-3_resolution-standardv2-2x.jpg?v=1761276143"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AGrid-3_resolution-standardv2-2x.jpg?v=1761276143",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071426719994,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-4_resolution-standardv2-2x.jpg?v=1756196781"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AGrid-4_resolution-standardv2-2x.jpg?v=1756196781",
				"width": 1999
			},
			{
				"alt": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain - TheHues",
				"id": 36071426785530,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AGrid-5_resolution-standardv2-2x.jpg?v=1761276143"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AGrid-5_resolution-standardv2-2x.jpg?v=1761276143",
				"width": 1999
			},
			{
				"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
				"id": 36071426457850,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-AGrid-7_resolution-standardv2-2x.jpg?v=1761276270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-AGrid-7_resolution-standardv2-2x.jpg?v=1761276270",
				"width": 1999
			},
			{
				"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
				"id": 36071426851066,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-AIvory-1-1_resolution-standardv2-2x.jpg?v=1761276270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-AIvory-1-1_resolution-standardv2-2x.jpg?v=1761276270",
				"width": 1999
			},
			{
				"alt": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain - TheHues",
				"id": 36071423574266,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250208-AGrey-1-2_resolution-standardv2-2x.jpg?v=1761276270"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250208-AGrey-1-2_resolution-standardv2-2x.jpg?v=1761276270",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Made from a soft yet durable cotton blend, these curtains provide soundproofing, blackout and insulation ensuring a peaceful and quiet environment.</p>",
		"url": "/products/chelsea-cotton-blend-geometric-golden-grid-patterned-custom-curtain",
		"regular_price": "$104.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/cotton-curtains",
				"title": "Cotton Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			}
		]
	},
	{
		"id": 8780124225786,
		"title": "Aspen Wool Blend Sweater Soft Textured Custom Curtain",
		"handle": "aspen-wool-blend-sweater-soft-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 95% Polyester &amp; 5% cotton<br>Features: Unique Meteor Fabric<br>Weight: Regular (360g/㎡)<br>Softness: Hard</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Safe to Iron</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Feel the relaxing embrace and ambient with wool blend curtain gance</p>",
		"published_at": "2025-05-30T14:22:48+08:00",
		"created_at": "2025-05-07T16:31:14+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > Textured Curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains > Wool Curtains",
			"fall sale",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search cotton",
			"Search curtains",
			"Search Pinch pleat"
		],
		"price": 14700,
		"price_min": 14700,
		"price_max": 14700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319464182010,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-138FC-CR450-C-Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037267292410,
					"product_id": 8780124225786,
					"position": 1,
					"created_at": "2025-05-22T17:48:33+08:00",
					"updated_at": "2025-09-17T19:43:46+08:00",
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250227-Ataupe1_resolution-standardv2-2x.jpg?v=1758109426",
					"variant_ids": [
						47319464182010
					]
				},
				"available": true,
				"name": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"id": 36071447265530,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250227-Ataupe1_resolution-standardv2-2x.jpg?v=1758109426"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/taupe_c6ace116-07dc-435a-af45-e85348a91077_1024x1024.png?v=1751352864"
			},
			{
				"id": 47319464149242,
				"title": "Ashy PInk",
				"option1": "Ashy PInk",
				"option2": null,
				"option3": null,
				"sku": "THC-138FC-CR450-C-Ashy PInk",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037260935418,
					"product_id": 8780124225786,
					"position": 7,
					"created_at": "2025-05-22T17:48:05+08:00",
					"updated_at": "2025-09-17T19:43:46+08:00",
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250227-Aashypink_resolution-standardv2-2x.jpg?v=1758109426",
					"variant_ids": [
						47319464149242
					]
				},
				"available": true,
				"name": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - Ashy PInk",
				"public_title": "Ashy PInk",
				"options": [
					"Ashy PInk"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"id": 36071444218106,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250227-Aashypink_resolution-standardv2-2x.jpg?v=1758109426"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ashypink_1024x1024.png?v=1751352864"
			},
			{
				"id": 47319464214778,
				"title": "Green Grey",
				"option1": "Green Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-138FC-CR450-C-Green Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037262639354,
					"product_id": 8780124225786,
					"position": 19,
					"created_at": "2025-05-22T17:48:19+08:00",
					"updated_at": "2025-09-17T19:43:46+08:00",
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250227-Agreengrey_resolution-standardv2-2x.jpg?v=1758109426",
					"variant_ids": [
						47319464214778
					]
				},
				"available": true,
				"name": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - Green Grey",
				"public_title": "Green Grey",
				"options": [
					"Green Grey"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"id": 36071445070074,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250227-Agreengrey_resolution-standardv2-2x.jpg?v=1758109426"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/greengrey_1024x1024.png?v=1751352864"
			},
			{
				"id": 47319464247546,
				"title": "Moonwalk",
				"option1": "Moonwalk",
				"option2": null,
				"option3": null,
				"sku": "THC-138FC-CR450-C-Moonwalk",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037263884538,
					"product_id": 8780124225786,
					"position": 25,
					"created_at": "2025-05-22T17:48:26+08:00",
					"updated_at": "2025-09-17T19:43:46+08:00",
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250227-Amoonwalk_resolution-standardv2-2x.jpg?v=1758109426",
					"variant_ids": [
						47319464247546
					]
				},
				"available": true,
				"name": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - Moonwalk",
				"public_title": "Moonwalk",
				"options": [
					"Moonwalk"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"id": 36071445692666,
					"position": 25,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250227-Amoonwalk_resolution-standardv2-2x.jpg?v=1758109426"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/moonwalk_1024x1024.png?v=1751352864"
			},
			{
				"id": 47319464280314,
				"title": "Camel",
				"option1": "Camel",
				"option2": null,
				"option3": null,
				"sku": "THC-138FC-CR450-C-Camel",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037261918458,
					"product_id": 8780124225786,
					"position": 13,
					"created_at": "2025-05-22T17:48:13+08:00",
					"updated_at": "2025-09-17T19:43:46+08:00",
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250227-Acamel-1_resolution-standardv2-2x.jpg?v=1758109426",
					"variant_ids": [
						47319464280314
					]
				},
				"available": true,
				"name": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - Camel",
				"public_title": "Camel",
				"options": [
					"Camel"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
					"id": 36071444742394,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250227-Acamel-1_resolution-standardv2-2x.jpg?v=1758109426"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250227-Ataupe1_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-ATaupe-4_resolution-standardv2-2x.jpg?v=1761210336",
			"//thehues.com/cdn/shop/files/20250213-ATaupe-6_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-ATaupe-2_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-ATaupe-5_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-ATaupe-3_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250227-Aashypink_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Aashypink-3_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Aashypink-1-6_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Aashypink-4_resolution-standardv2-2x.jpg?v=1761210336",
			"//thehues.com/cdn/shop/files/20250213-Aashypink-2_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Aashypink-5_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250227-Acamel-1_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Acamel-5_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Acamel-4_resolution-standardv2-2x.jpg?v=1761210336",
			"//thehues.com/cdn/shop/files/20250213-Acamel-3_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Acamel-1-4_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Acamel-2_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250227-Agreengrey_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Agreengrey-6_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Agreengrey-14_resolution-standardv2-2x.jpg?v=1761210336",
			"//thehues.com/cdn/shop/files/20250213-Agreengrey-3_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Agreengrey-2_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Agreengrey-5_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250227-Amoonwalk_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Amoonwalk-6_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Amoonwalk-4_resolution-standardv2-2x.jpg?v=1761210336",
			"//thehues.com/cdn/shop/files/20250213-Amoonwalk-3_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Amoonwalk-2_resolution-standardv2-2x.jpg?v=1758109426",
			"//thehues.com/cdn/shop/files/20250213-Amoonwalk-5_resolution-standardv2-2x.jpg?v=1758109426"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250227-Ataupe1_resolution-standardv2-2x_1024x1024.jpg?v=1758109426",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071447265530,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250227-Ataupe1_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250227-Ataupe1_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071447167226,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-4_resolution-standardv2-2x.jpg?v=1761210336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-4_resolution-standardv2-2x.jpg?v=1761210336",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071447232762,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-6_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-6_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071447363834,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-2_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-2_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071447199994,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-5_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-5_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071447134458,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-3_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-ATaupe-3_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444218106,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250227-Aashypink_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250227-Aashypink_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444119802,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-3_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-3_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444054266,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-1-6_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-1-6_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444152570,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-4_resolution-standardv2-2x.jpg?v=1761210336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-4_resolution-standardv2-2x.jpg?v=1761210336",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444087034,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-2_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-2_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444185338,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-5_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Aashypink-5_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444742394,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250227-Acamel-1_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250227-Acamel-1_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444709626,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Acamel-5_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Acamel-5_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444676858,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Acamel-4_resolution-standardv2-2x.jpg?v=1761210336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Acamel-4_resolution-standardv2-2x.jpg?v=1761210336",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444644090,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Acamel-3_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Acamel-3_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444578554,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Acamel-1-4_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Acamel-1-4_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444611322,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Acamel-2_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Acamel-2_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445070074,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250227-Agreengrey_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250227-Agreengrey_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445004538,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-6_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-6_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445037306,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-14_resolution-standardv2-2x.jpg?v=1761210336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-14_resolution-standardv2-2x.jpg?v=1761210336",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444939002,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-3_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-3_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444906234,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-2_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-2_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071444971770,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-5_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Agreengrey-5_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445692666,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250227-Amoonwalk_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250227-Amoonwalk_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445659898,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-6_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-6_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 2000
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445594362,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-4_resolution-standardv2-2x.jpg?v=1761210336"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-4_resolution-standardv2-2x.jpg?v=1761210336",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445561594,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-3_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-3_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445725434,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-2_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-2_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			},
			{
				"alt": "Aspen Wool Blend Sweater Soft Textured Custom Curtain - TheHues",
				"id": 36071445627130,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-5_resolution-standardv2-2x.jpg?v=1758109426"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250213-Amoonwalk-5_resolution-standardv2-2x.jpg?v=1758109426",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Feel the relaxing embrace and ambient with wool blend curtain gance</p>",
		"url": "/products/aspen-wool-blend-sweater-soft-textured-custom-curtain",
		"regular_price": "$147.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/cotton-curtains",
				"title": "Cotton Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			},
			{
				"url": "/collections/woolen-curtains",
				"title": "Woolen Curtains"
			}
		]
	},
	{
		"id": 8780123013370,
		"title": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "zen-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do not bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>This foil printed velvet fabric brings a harmonious balance of beauty and simplicity to any room, offering both a sense of serenity and style.</p>",
		"published_at": "2025-05-07T16:30:36+08:00",
		"created_at": "2025-05-07T16:30:36+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Velvet Pattern Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"Custom Blackout Curtains > Patterned Curtains",
			"fall sale",
			"flash_categories",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"upcoming fall"
		],
		"price": 13400,
		"price_min": 13400,
		"price_max": 13400,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319394320634,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF509-5-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037165580538,
					"product_id": 8780123013370,
					"position": 15,
					"created_at": "2025-05-22T17:38:42+08:00",
					"updated_at": "2025-09-04T17:40:59+08:00",
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-ABF509-3_resolution-standardv2-2x.jpg?v=1756978859",
					"variant_ids": [
						47319394320634
					]
				},
				"available": true,
				"name": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 13400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071391854842,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-ABF509-3_resolution-standardv2-2x.jpg?v=1756978859"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005879_resolution-standardv2-2x_1024x1024.jpg?v=1756978859"
			},
			{
				"id": 47319394189562,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF509-5-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011446366458,
					"product_id": 8780123013370,
					"position": 8,
					"created_at": "2025-09-04T17:39:45+08:00",
					"updated_at": "2025-10-23T18:09:52+08:00",
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 4552,
					"height": 5690,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-white.jpg?v=1761214192",
					"variant_ids": [
						47319394189562
					]
				},
				"available": true,
				"name": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 13400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36732983640314,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5690,
						"width": 4552,
						"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-white.jpg?v=1761214192"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005875_resolution-standardv2-2x_1024x1024.jpg?v=1756979031"
			},
			{
				"id": 47319394222330,
				"title": "Gold",
				"option1": "Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF509-5-C-Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011445481722,
					"product_id": 8780123013370,
					"position": 6,
					"created_at": "2025-09-04T17:39:32+08:00",
					"updated_at": "2025-10-23T18:09:52+08:00",
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 4552,
					"height": 5690,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold_742b564d-64d5-4051-b75d-b60854115462.jpg?v=1761214192",
					"variant_ids": [
						47319394222330
					]
				},
				"available": true,
				"name": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Gold",
				"public_title": "Gold",
				"options": [
					"Gold"
				],
				"price": 13400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36732982755578,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5690,
						"width": 4552,
						"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold_742b564d-64d5-4051-b75d-b60854115462.jpg?v=1761214192"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005876_resolution-standardv2-2x_1024x1024.jpg?v=1756979031"
			},
			{
				"id": 47319394255098,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF509-5-C-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011446399226,
					"product_id": 8780123013370,
					"position": 4,
					"created_at": "2025-09-04T17:39:45+08:00",
					"updated_at": "2025-10-23T18:09:52+08:00",
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 4552,
					"height": 5690,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown_6e6e33c6-8de8-47ac-9eca-8ed874c1e8d0.jpg?v=1761214192",
					"variant_ids": [
						47319394255098
					]
				},
				"available": true,
				"name": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 13400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36732983673082,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 5690,
						"width": 4552,
						"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown_6e6e33c6-8de8-47ac-9eca-8ed874c1e8d0.jpg?v=1761214192"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005877_resolution-standardv2-2x_1024x1024.jpg?v=1756979031"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-8.jpg?v=1756979031",
			"//thehues.com/cdn/shop/files/20240524-ABlack-4111_resolution-standardv2-2x.jpg?v=1756979031",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black_1c04176d-be48-4fee-913e-00b18bb33e01.jpg?v=1761214192",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown_6e6e33c6-8de8-47ac-9eca-8ed874c1e8d0.jpg?v=1761214192",
			"//thehues.com/cdn/shop/files/20250516-AFrame-1000005877_resolution-standardv2-2x.jpg?v=1756979031",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold_742b564d-64d5-4051-b75d-b60854115462.jpg?v=1761214192",
			"//thehues.com/cdn/shop/files/20250516-AFrame-1000005876_resolution-standardv2-2x.jpg?v=1756979031",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-white.jpg?v=1761214192",
			"//thehues.com/cdn/shop/files/20250516-AFrame-1000005875_resolution-standardv2-2x.jpg?v=1756979031",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/20250516-AFrame-1000005879_resolution-standardv2-2x.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/20250516-ABF509-3_resolution-standardv2-2x.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/20250516-ABlack-1-2_resolution-standardv2-2x.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/20240524-ABlack-3-2_resolution-standardv2-2x.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/20240524-ABlack-2-2_resolution-standardv2-2x.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-silver.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-1.jpg?v=1756978859",
			"//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-9.jpg?v=1756978859"
		],
		"featured_image": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-8_1024x1024.jpg?v=1756979031",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711245807866,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-8.jpg?v=1756979031"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-8.jpg?v=1756979031",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071392215290,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-ABlack-4111_resolution-standardv2-2x.jpg?v=1756979031"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-ABlack-4111_resolution-standardv2-2x.jpg?v=1756979031",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36732983509242,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5690,
					"width": 4552,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black_1c04176d-be48-4fee-913e-00b18bb33e01.jpg?v=1761214192"
				},
				"aspect_ratio": 0.8,
				"height": 5690,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black_1c04176d-be48-4fee-913e-00b18bb33e01.jpg?v=1761214192",
				"width": 4552
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36732983673082,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5690,
					"width": 4552,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown_6e6e33c6-8de8-47ac-9eca-8ed874c1e8d0.jpg?v=1761214192"
				},
				"aspect_ratio": 0.8,
				"height": 5690,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown_6e6e33c6-8de8-47ac-9eca-8ed874c1e8d0.jpg?v=1761214192",
				"width": 4552
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071391985914,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005877_resolution-standardv2-2x.jpg?v=1756979031"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005877_resolution-standardv2-2x.jpg?v=1756979031",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36732982755578,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5690,
					"width": 4552,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold_742b564d-64d5-4051-b75d-b60854115462.jpg?v=1761214192"
				},
				"aspect_ratio": 0.8,
				"height": 5690,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold_742b564d-64d5-4051-b75d-b60854115462.jpg?v=1761214192",
				"width": 4552
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071391953146,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005876_resolution-standardv2-2x.jpg?v=1756979031"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005876_resolution-standardv2-2x.jpg?v=1756979031",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36732983640314,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 5690,
					"width": 4552,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-white.jpg?v=1761214192"
				},
				"aspect_ratio": 0.8,
				"height": 5690,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-white.jpg?v=1761214192",
				"width": 4552
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071391920378,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005875_resolution-standardv2-2x.jpg?v=1756979031"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005875_resolution-standardv2-2x.jpg?v=1756979031",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711240204538,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-brown.jpg?v=1756978859",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711240139002,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1756978859",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711240007930,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1756978859",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071392018682,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005879_resolution-standardv2-2x.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005879_resolution-standardv2-2x.jpg?v=1756978859",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711240171770,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1756978859",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071391854842,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABF509-3_resolution-standardv2-2x.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABF509-3_resolution-standardv2-2x.jpg?v=1756978859",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071391887610,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABlack-1-2_resolution-standardv2-2x.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABlack-1-2_resolution-standardv2-2x.jpg?v=1756978859",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071392149754,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-ABlack-3-2_resolution-standardv2-2x.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-ABlack-3-2_resolution-standardv2-2x.jpg?v=1756978859",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071392051450,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-ABlack-2-2_resolution-standardv2-2x.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-ABlack-2-2_resolution-standardv2-2x.jpg?v=1756978859",
				"width": 1999
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711240237306,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-silver.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-silver.jpg?v=1756978859",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711245873402,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-1.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-1.jpg?v=1756978859",
				"width": 2000
			},
			{
				"alt": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36711245840634,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-9.jpg?v=1756978859"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zen-foil-printed-velvet-patterned-custom-curtain-black-9.jpg?v=1756978859",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>This foil printed velvet fabric brings a harmonious balance of beauty and simplicity to any room, offering both a sense of serenity and style.</p>",
		"url": "/products/zen-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$134.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780124651770,
		"title": "Flora Velvet Emboidered Floral Pattern Custom Curtain",
		"handle": "flora-velvet-emboidered-floral-pattern-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>This fabric brings a harmonious balance of beauty and simplicity to any room, offering both a sense of serenity and style.</p>",
		"published_at": "2025-05-07T16:31:26+08:00",
		"created_at": "2025-05-07T16:31:26+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > black custom curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > floral custom curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Velvet Pattern Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"Custom Blackout Curtains > Patterned Curtains",
			"fall sale",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Search curtains",
			"Search Foil Print",
			"Search velvet"
		],
		"price": 14700,
		"price_min": 14700,
		"price_max": 14700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319449960698,
				"title": "Light Taupe",
				"option1": "Light Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-137BE-1806-C-Light Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037302747386,
					"product_id": 8780124651770,
					"position": 1,
					"created_at": "2025-05-22T17:50:47+08:00",
					"updated_at": "2025-09-04T18:14:01+08:00",
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"width": 2000,
					"height": 2498,
					"src": "//thehues.com/cdn/shop/files/20240729-A1-1_resolution-standardv2-2x.jpg?v=1756980841",
					"variant_ids": [
						47319449960698
					]
				},
				"available": true,
				"name": "Flora Velvet Emboidered Floral Pattern Custom Curtain - Light Taupe",
				"public_title": "Light Taupe",
				"options": [
					"Light Taupe"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"id": 36071465287930,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.801,
						"height": 2498,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20240729-A1-1_resolution-standardv2-2x.jpg?v=1756980841"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ABE-1806-2_resolution-standardv2-2x_1024x1024.jpg?v=1756980619"
			},
			{
				"id": 47319450059002,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BE-1806-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037302911226,
					"product_id": 8780124651770,
					"position": 15,
					"created_at": "2025-05-22T17:50:47+08:00",
					"updated_at": "2025-09-04T18:10:19+08:00",
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-7_resolution-standardv2-2x.jpg?v=1756980619",
					"variant_ids": [
						47319450059002
					]
				},
				"available": true,
				"name": "Flora Velvet Emboidered Floral Pattern Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"id": 36071465255162,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-7_resolution-standardv2-2x.jpg?v=1756980619"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ABE-1806-5_resolution-standardv2-2x_1024x1024.jpg?v=1756980841"
			},
			{
				"id": 47319449927930,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-137BE-1806-C-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011576881402,
					"product_id": 8780124651770,
					"position": 14,
					"created_at": "2025-09-04T18:08:04+08:00",
					"updated_at": "2025-10-23T16:23:49+08:00",
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-beige.jpg?v=1761207829",
					"variant_ids": [
						47319449927930
					]
				},
				"available": true,
				"name": "Flora Velvet Emboidered Floral Pattern Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"id": 36733114155258,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-beige.jpg?v=1761207829"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ABE-1806-1_resolution-standardv2-2x_1024x1024.jpg?v=1756980619"
			},
			{
				"id": 47319449993466,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-137BE-1806-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011577438458,
					"product_id": 8780124651770,
					"position": 7,
					"created_at": "2025-09-04T18:08:10+08:00",
					"updated_at": "2025-10-23T16:23:49+08:00",
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-grey.jpg?v=1761207829",
					"variant_ids": [
						47319449993466
					]
				},
				"available": true,
				"name": "Flora Velvet Emboidered Floral Pattern Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"id": 36733114712314,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-grey.jpg?v=1761207829"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ABE-1806-3_resolution-standardv2-2x_1024x1024.jpg?v=1756980841"
			},
			{
				"id": 47319450026234,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-137BE-1806-C-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45011577372922,
					"product_id": 8780124651770,
					"position": 5,
					"created_at": "2025-09-04T18:08:07+08:00",
					"updated_at": "2025-10-23T16:23:49+08:00",
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-blue.jpg?v=1761207829",
					"variant_ids": [
						47319450026234
					]
				},
				"available": true,
				"name": "Flora Velvet Emboidered Floral Pattern Custom Curtain - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 14700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
					"id": 36733114646778,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-blue.jpg?v=1761207829"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240729-A1-1_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-lighttaupe.jpg?v=1761207829",
			"//thehues.com/cdn/shop/files/20250516-ABE-1806-5_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-black.jpg?v=1761207829",
			"//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-blue.jpg?v=1761207829",
			"//thehues.com/cdn/shop/files/20250516-ABE-1806-4_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-grey.jpg?v=1761207829",
			"//thehues.com/cdn/shop/files/20250516-ABE-1806-3_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x_0757f2b2-fe9f-44be-939b-9f6be00014a9.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/20250516-A3-1_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/20250516-A4-1_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/20250516-A5-1_resolution-standardv2-2x.jpg?v=1756980841",
			"//thehues.com/cdn/shop/files/20250516-A6-1_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-beige.jpg?v=1761207829",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-7_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-4_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-1_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-2_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-3_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-6_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-AFlora-Black-5_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-ABE-1806-2_resolution-standardv2-2x.jpg?v=1756980619",
			"//thehues.com/cdn/shop/files/20250516-ABE-1806-1_resolution-standardv2-2x.jpg?v=1756980619"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240729-A1-1_resolution-standardv2-2x_1024x1024.jpg?v=1756980841",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465287930,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.801,
					"height": 2498,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240729-A1-1_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.801,
				"height": 2498,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240729-A1-1_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 2000
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36733115072762,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-lighttaupe.jpg?v=1761207829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-lighttaupe.jpg?v=1761207829",
				"width": 2000
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071464993018,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-5_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-5_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36733114188026,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-black.jpg?v=1761207829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-black.jpg?v=1761207829",
				"width": 2000
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36733114646778,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-blue.jpg?v=1761207829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-blue.jpg?v=1761207829",
				"width": 2000
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071464927482,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-4_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-4_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36733114712314,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-grey.jpg?v=1761207829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-grey.jpg?v=1761207829",
				"width": 2000
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071464894714,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-3_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-3_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465320698,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x_0757f2b2-fe9f-44be-939b-9f6be00014a9.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x_0757f2b2-fe9f-44be-939b-9f6be00014a9.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465353466,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A3-1_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A3-1_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465386234,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A4-1_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A4-1_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465419002,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A5-1_resolution-standardv2-2x.jpg?v=1756980841"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A5-1_resolution-standardv2-2x.jpg?v=1756980841",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465451770,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-A6-1_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A6-1_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36733114155258,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-beige.jpg?v=1761207829"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/flora-velvet-emboidered-floral-pattern-custom-curtain-beige.jpg?v=1761207829",
				"width": 2000
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465255162,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-7_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-7_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465156858,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-4_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-4_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465058554,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-1_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-1_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465091322,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-2_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-2_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465124090,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-3_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-3_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465222394,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-6_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-6_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465189626,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-5_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFlora-Black-5_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465517306,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-2_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-2_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			},
			{
				"alt": "Flora Velvet Emboidered Floral Pattern Custom Curtain - TheHues",
				"id": 36071465484538,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-1_resolution-standardv2-2x.jpg?v=1756980619"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABE-1806-1_resolution-standardv2-2x.jpg?v=1756980619",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>This fabric brings a harmonious balance of beauty and simplicity to any room, offering both a sense of serenity and style.</p>",
		"url": "/products/flora-velvet-emboidered-floral-pattern-custom-curtain",
		"regular_price": "$147.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780122652922,
		"title": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain",
		"handle": "tide-linen-blend-heavyweight-golden-threads-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 90% Polyester 3% Linen 7% Acrylic</p><p>Features: Unique Linen Blend Fabric</p><p>Weight: Heavy Weight (420g/㎡)</p><p>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do not bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Captures the serenity of ocean tides, draping with gentle sophistication and infusing your home with timeless, natural beauty.</p>",
		"published_at": "2025-06-06T19:08:09+08:00",
		"created_at": "2025-05-07T16:30:25+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > Textured Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer"
		],
		"price": 11700,
		"price_min": 11700,
		"price_max": 11700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319403528442,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR3302-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44133185454330,
					"product_id": 8780122652922,
					"position": 1,
					"created_at": "2025-06-06T19:00:52+08:00",
					"updated_at": "2025-08-26T16:27:58+08:00",
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_57.jpg?v=1756196878",
					"variant_ids": [
						47319403528442
					]
				},
				"available": true,
				"name": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"id": 36138986373370,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_57.jpg?v=1756196878"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/FB-CR3303_1024x1024.png?v=1754472134"
			},
			{
				"id": 47319403561210,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR3302-C-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44133199741178,
					"product_id": 8780122652922,
					"position": 3,
					"created_at": "2025-06-06T19:02:36+08:00",
					"updated_at": "2025-10-24T10:54:35+08:00",
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_64.jpg?v=1761274475",
					"variant_ids": [
						47319403561210
					]
				},
				"available": true,
				"name": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"id": 36138999218426,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_64.jpg?v=1761274475"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/FotoJet_64_1024x1024.jpg?v=1761274475"
			},
			{
				"id": 47319403495674,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR3302-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44133482070266,
					"product_id": 8780122652922,
					"position": 5,
					"created_at": "2025-06-06T19:32:22+08:00",
					"updated_at": "2025-10-24T10:54:35+08:00",
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_65_bf6f4dae-3ed2-4039-b7b1-5e7ee6be1fd6.jpg?v=1761274475",
					"variant_ids": [
						47319403495674
					]
				},
				"available": true,
				"name": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"id": 36139229085946,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_65_bf6f4dae-3ed2-4039-b7b1-5e7ee6be1fd6.jpg?v=1761274475"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/FotoJet_65_bf6f4dae-3ed2-4039-b7b1-5e7ee6be1fd6_1024x1024.jpg?v=1761274475"
			},
			{
				"id": 47319403593978,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-138FB-CR3302-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44133199708410,
					"product_id": 8780122652922,
					"position": 4,
					"created_at": "2025-06-06T19:02:36+08:00",
					"updated_at": "2025-10-24T10:54:35+08:00",
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_63.jpg?v=1761274475",
					"variant_ids": [
						47319403593978
					]
				},
				"available": true,
				"name": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
					"id": 36138999185658,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_63.jpg?v=1761274475"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/FotoJet_63_1024x1024.jpg?v=1761274475"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/FotoJet_57.jpg?v=1756196878",
			"//thehues.com/cdn/shop/files/FotoJet_59.jpg?v=1761274475",
			"//thehues.com/cdn/shop/files/FotoJet_64.jpg?v=1761274475",
			"//thehues.com/cdn/shop/files/FotoJet_63.jpg?v=1761274475",
			"//thehues.com/cdn/shop/files/FotoJet_65_bf6f4dae-3ed2-4039-b7b1-5e7ee6be1fd6.jpg?v=1761274475",
			"//thehues.com/cdn/shop/files/FotoJet_58.jpg?v=1756196878",
			"//thehues.com/cdn/shop/files/FotoJet_60.jpg?v=1756196878",
			"//thehues.com/cdn/shop/files/FotoJet_62.jpg?v=1756196878",
			"//thehues.com/cdn/shop/files/FotoJet_61.jpg?v=1756196879"
		],
		"featured_image": "//thehues.com/cdn/shop/files/FotoJet_57_1024x1024.jpg?v=1756196878",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138986373370,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_57.jpg?v=1756196878"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_57.jpg?v=1756196878",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138986406138,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_59.jpg?v=1761274475"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_59.jpg?v=1761274475",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138999218426,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_64.jpg?v=1761274475"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_64.jpg?v=1761274475",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138999185658,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_63.jpg?v=1761274475"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_63.jpg?v=1761274475",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36139229085946,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_65_bf6f4dae-3ed2-4039-b7b1-5e7ee6be1fd6.jpg?v=1761274475"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_65_bf6f4dae-3ed2-4039-b7b1-5e7ee6be1fd6.jpg?v=1761274475",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138986504442,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_58.jpg?v=1756196878"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_58.jpg?v=1756196878",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138986307834,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_60.jpg?v=1756196878"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_60.jpg?v=1756196878",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138986537210,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_62.jpg?v=1756196878"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_62.jpg?v=1756196878",
				"width": 2000
			},
			{
				"alt": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain - TheHues",
				"id": 36138986340602,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_61.jpg?v=1756196879"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_61.jpg?v=1756196879",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Captures the serenity of ocean tides, draping with gentle sophistication and infusing your home with timeless, natural beauty.</p>",
		"url": "/products/tide-linen-blend-heavyweight-golden-threads-textured-custom-curtain",
		"regular_price": "$117.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			}
		]
	},
	{
		"id": 8780124586234,
		"title": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "klimt-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester</p><p>Features: Unique Foil Printed Velvet Fabric</p><p>Weight: Regular (365g/㎡)</p><p>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>Inspired by the gilded drama of its namesake, Klimt is a velvet layered in light¡ªits foil-printed surface rich with shimmer, depth, and bold elegance.</p>",
		"published_at": "2025-06-06T19:34:54+08:00",
		"created_at": "2025-05-07T16:31:24+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Solid Velvet Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"fall sale",
			"Halloween",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet",
			"upcoming fall"
		],
		"price": 15900,
		"price_min": 15900,
		"price_max": 15900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319436230906,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF354-C",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44133462868218,
					"product_id": 8780124586234,
					"position": 1,
					"created_at": "2025-06-06T19:28:38+08:00",
					"updated_at": "2025-08-26T16:26:14+08:00",
					"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_71.jpg?v=1756196774",
					"variant_ids": [
						47319436230906
					]
				},
				"available": true,
				"name": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 15900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36139212144890,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_71.jpg?v=1756196774"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aklimt_black_1024x1024.png?v=1751341914"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/FotoJet_71.jpg?v=1756196774",
			"//thehues.com/cdn/shop/files/FotoJet_77.jpg?v=1756196774",
			"//thehues.com/cdn/shop/files/FotoJet_72.jpg?v=1756196774",
			"//thehues.com/cdn/shop/files/FotoJet_73.jpg?v=1756196774",
			"//thehues.com/cdn/shop/files/FotoJet_74.jpg?v=1756196774",
			"//thehues.com/cdn/shop/files/FotoJet_75.jpg?v=1756196774",
			"//thehues.com/cdn/shop/files/FotoJet_76.jpg?v=1756196774"
		],
		"featured_image": "//thehues.com/cdn/shop/files/FotoJet_71_1024x1024.jpg?v=1756196774",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212144890,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_71.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_71.jpg?v=1756196774",
				"width": 2000
			},
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212341498,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_77.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_77.jpg?v=1756196774",
				"width": 2000
			},
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212177658,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_72.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_72.jpg?v=1756196774",
				"width": 2000
			},
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212210426,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_73.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_73.jpg?v=1756196774",
				"width": 2000
			},
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212243194,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_74.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_74.jpg?v=1756196774",
				"width": 2000
			},
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212275962,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_75.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_75.jpg?v=1756196774",
				"width": 2000
			},
			{
				"alt": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36139212308730,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_76.jpg?v=1756196774"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_76.jpg?v=1756196774",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Inspired by the gilded drama of its namesake, Klimt is a velvet layered in light¡ªits foil-printed surface rich with shimmer, depth, and bold elegance.</p>",
		"url": "/products/klimt-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$159.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780123177210,
		"title": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
		"handle": "luxor-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Features: Unique Foil Printed Velvet Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>The Tuscany Foil-Printed Velvet Curtains command attention with their striking patterns, shimmering with metallic allure.</p>",
		"published_at": "2025-05-07T16:30:43+08:00",
		"created_at": "2025-05-07T16:30:43+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Foil Printed Velvet Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > velvet custom curtains",
			"All Curtains > vintage custom curtains",
			"All Curtains > winter custom curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Velvet Curtains",
			"Curtains > Custom Velvet Curtains > Velvet Pattern Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Synthetic Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Foil Print Cutains",
			"Custom Blackout Curtains > Patterned Curtains",
			"fall sale",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Foil Print",
			"Search Pinch pleat",
			"Search velvet"
		],
		"price": 13800,
		"price_min": 13800,
		"price_max": 13800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319431250170,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037595103482,
					"product_id": 8780123177210,
					"position": 15,
					"created_at": "2025-05-22T18:20:15+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240523-ACream-4-3_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431250170
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622508794,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20240523-ACream-4-3_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005880_resolution-standardv2-2x_1024x1024.jpg?v=1756978650"
			},
			{
				"id": 47319431479546,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44999675511034,
					"product_id": 8780123177210,
					"position": 10,
					"created_at": "2025-09-03T09:12:55+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 3833,
					"height": 5750,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-3.jpg?v=1756978663",
					"variant_ids": [
						47319431479546
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36721271406842,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.667,
						"height": 5750,
						"width": 3833,
						"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-3.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319431282938,
				"title": "Silver",
				"option1": "Silver",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Silver",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037594906874,
					"product_id": 8780123177210,
					"position": 5,
					"created_at": "2025-05-22T18:20:16+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431282938
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Silver",
				"public_title": "Silver",
				"options": [
					"Silver"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622902010,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x_1024x1024.jpg?v=1756978663"
			},
			{
				"id": 47319431315706,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Ash",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037595037946,
					"product_id": 8780123177210,
					"position": 6,
					"created_at": "2025-05-22T18:20:15+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Aash_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431315706
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622541562,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Aash_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Aash_resolution-standardv2-2x_1024x1024.jpg?v=1756978663"
			},
			{
				"id": 47319431348474,
				"title": "Gold",
				"option1": "Gold",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Gold",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037595169018,
					"product_id": 8780123177210,
					"position": 7,
					"created_at": "2025-05-22T18:20:16+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431348474
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Gold",
				"public_title": "Gold",
				"options": [
					"Gold"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622836474,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Acarrot_resolution-standardv2-2x_1024x1024.jpg?v=1756978663"
			},
			{
				"id": 47319431381242,
				"title": "Carrot",
				"option1": "Carrot",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Carrot",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037595234554,
					"product_id": 8780123177210,
					"position": 8,
					"created_at": "2025-05-22T18:20:15+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Acarrot_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431381242
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Carrot",
				"public_title": "Carrot",
				"options": [
					"Carrot"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622607098,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Acarrot_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319431414010,
				"title": "Misty",
				"option1": "Misty",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Misty",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037595201786,
					"product_id": 8780123177210,
					"position": 14,
					"created_at": "2025-05-22T18:20:16+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Amisty_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431414010
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Misty",
				"public_title": "Misty",
				"options": [
					"Misty"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622869242,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Amisty_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319431446778,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-137BF-TERRA-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037595332858,
					"product_id": 8780123177210,
					"position": 9,
					"created_at": "2025-05-22T18:20:15+08:00",
					"updated_at": "2025-09-04T17:37:43+08:00",
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x.jpg?v=1756978663",
					"variant_ids": [
						47319431446778
					]
				},
				"available": true,
				"name": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 13800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
					"id": 36071622476026,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x.jpg?v=1756978663"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-2.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-ACream-2-3_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-ACream-3-2_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-ACream-1-3_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-Aash_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-Acarrot_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-3.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-2.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-1.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-AFrame-1000005887_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-Amisty_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20240523-ACream-4-3_resolution-standardv2-2x.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1756978663",
			"//thehues.com/cdn/shop/files/20250516-AFrame-1000005880_resolution-standardv2-2x.jpg?v=1756978650",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/20250516-ACream-2-3_resolution-standardv2-2x-2.jpg?v=1756978650",
			"//thehues.com/cdn/shop/files/20250516-ABF-TERRA-_resolution-standardv2-2x.jpg?v=1756978650",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-ash.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-carrot.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-4.jpg?v=1756862842",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-silver.jpg?v=1761275994",
			"//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761275994"
		],
		"featured_image": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-2_1024x1024.jpg?v=1756978663",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721274814714,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-2.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-2.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622672634,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.753,
					"height": 2500,
					"width": 1883,
					"src": "//thehues.com/cdn/shop/files/20250516-ACream-2-3_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.753,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ACream-2-3_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 1883
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622738170,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ACream-3-2_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ACream-3-2_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622639866,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ACream-1-3_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ACream-1-3_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622902010,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Asilver_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622541562,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Aash_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Aash_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622836474,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Agold_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622607098,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Acarrot_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Acarrot_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622476026,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Ateal_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271406842,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5750,
					"width": 3833,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-3.jpg?v=1756978663"
				},
				"aspect_ratio": 0.667,
				"height": 5750,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-3.jpg?v=1756978663",
				"width": 3833
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271374074,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5708,
					"width": 3806,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-2.jpg?v=1756978663"
				},
				"aspect_ratio": 0.667,
				"height": 5708,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-2.jpg?v=1756978663",
				"width": 3806
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271079162,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5703,
					"width": 3802,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-1.jpg?v=1756978663"
				},
				"aspect_ratio": 0.667,
				"height": 5703,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-1.jpg?v=1756978663",
				"width": 3802
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622803706,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.753,
					"height": 2500,
					"width": 1883,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005887_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.753,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005887_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 1883
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622869242,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Amisty_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Amisty_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622508794,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240523-ACream-4-3_resolution-standardv2-2x.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-ACream-4-3_resolution-standardv2-2x.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721274781946,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1756978663"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream-1.jpg?v=1756978663",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622770938,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005880_resolution-standardv2-2x.jpg?v=1756978650"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFrame-1000005880_resolution-standardv2-2x.jpg?v=1756978650",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271144698,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-cream.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271275770,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-black.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622705402,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ACream-2-3_resolution-standardv2-2x-2.jpg?v=1756978650"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ACream-2-3_resolution-standardv2-2x-2.jpg?v=1756978650",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36071622574330,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABF-TERRA-_resolution-standardv2-2x.jpg?v=1756978650"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABF-TERRA-_resolution-standardv2-2x.jpg?v=1756978650",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271210234,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-ash.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-ash.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271046394,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 1.025,
					"height": 1952,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-carrot.jpg?v=1761275994"
				},
				"aspect_ratio": 1.025,
				"height": 1952,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-carrot.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271308538,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-gold.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271243002,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 5750,
					"width": 3833,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-4.jpg?v=1756862842"
				},
				"aspect_ratio": 0.667,
				"height": 5750,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty-4.jpg?v=1756862842",
				"width": 3833
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271177466,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-misty.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271111930,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-silver.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-silver.jpg?v=1761275994",
				"width": 2000
			},
			{
				"alt": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy - TheHues",
				"id": 36721271341306,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761275994"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luxor-foil-printed-velvet-patterned-custom-curtain-teal.jpg?v=1761275994",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Tuscany Foil-Printed Velvet Curtains command attention with their striking patterns, shimmering with metallic allure.</p>",
		"url": "/products/luxor-foil-printed-velvet-patterned-custom-curtain-designed-in-italy",
		"regular_price": "$138.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/foil-printed-curtains",
				"title": "Foil Printed Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/velvet-curtains",
				"title": "Velvet Curtains"
			}
		]
	},
	{
		"id": 8780122882298,
		"title": "Glint Linen Blend Shimmering Textured Custom Curtain",
		"handle": "glint-linen-blend-shimmering-textured-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 90% Polyester &amp; 10% Linen<br>Features: Unique Textured Fabric<br>Weight: Regular (365g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dry on Low Heat</p><p>Do Not Bleach</p><p>Iron on Medium Temp</p><p>Dry Clean Allowed, Any Solvent</p>`,
		"description": "<p>The Glint Linen Blend curtains bring a sophisticated weight to your space, with a rich, textured weave that adds depth and character to any room.</p>",
		"published_at": "2025-05-07T16:30:31+08:00",
		"created_at": "2025-05-07T16:30:31+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > Solid Curtains",
			"All Curtains > Textured Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Custom Blackout Curtains > Patterned Curtains",
			"Extra 10%",
			"Independence Day",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat",
			"Summer"
		],
		"price": 12500,
		"price_min": 12500,
		"price_max": 12500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319447208186,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-BD440-C-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037319622906,
					"product_id": 8780122882298,
					"position": 9,
					"created_at": "2025-05-22T17:52:46+08:00",
					"updated_at": "2025-08-26T16:27:46+08:00",
					"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg?v=1756196866",
					"variant_ids": [
						47319447208186
					]
				},
				"available": true,
				"name": "Glint Linen Blend Shimmering Textured Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
					"id": 36071474364666,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg?v=1756196866"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250116-ACream-glint_resolution-standardv2-2x_1024x1024.jpg?v=1761275536"
			},
			{
				"id": 47319447240954,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-BD440-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037318770938,
					"product_id": 8780122882298,
					"position": 1,
					"created_at": "2025-05-22T17:52:27+08:00",
					"updated_at": "2025-08-26T16:27:45+08:00",
					"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-1_resolution-standardv2-2x.jpg?v=1756196865",
					"variant_ids": [
						47319447240954
					]
				},
				"available": true,
				"name": "Glint Linen Blend Shimmering Textured Custom Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
					"id": 36071473545466,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-1_resolution-standardv2-2x.jpg?v=1756196865"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-Aglint-2-3_resolution-standardv2-2x_1024x1024.jpg?v=1761275536"
			},
			{
				"id": 47319447273722,
				"title": "Sesame",
				"option1": "Sesame",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-BD440-C-Sesame",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037319917818,
					"product_id": 8780122882298,
					"position": 6,
					"created_at": "2025-05-22T17:52:47+08:00",
					"updated_at": "2025-10-24T11:12:16+08:00",
					"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250207-ASesame-1_resolution-standardv2-2x.jpg?v=1761275536",
					"variant_ids": [
						47319447273722
					]
				},
				"available": true,
				"name": "Glint Linen Blend Shimmering Textured Custom Curtain - Sesame",
				"public_title": "Sesame",
				"options": [
					"Sesame"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
					"id": 36071474659578,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20250207-ASesame-1_resolution-standardv2-2x.jpg?v=1761275536"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250207-ASesame-1_resolution-standardv2-2x_1024x1024.jpg?v=1761275536"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250516-Aglint-2-1_resolution-standardv2-2x.jpg?v=1756196865",
			"//thehues.com/cdn/shop/files/20250516-Aglint-2-3_resolution-standardv2-2x.jpg?v=1761275536",
			"//thehues.com/cdn/shop/files/20250516-Aglint-2-2_resolution-standardv2-2x-2.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20250516-Aglint-2-4_resolution-standardv2-2x.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20240622-Aglint-2-2_resolution-standardv2-2x.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20250207-ASesame-1_resolution-standardv2-2x.jpg?v=1761275536",
			"//thehues.com/cdn/shop/files/20240526-ACream-4-1_resolution-standardv2-2x.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20240526-ACream-5-1_resolution-standardv2-2x.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20250116-ACream-3_resolution-standardv2-2x.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20250116-ACream-3-1_resolution-standardv2-2x.jpg?v=1756196866",
			"//thehues.com/cdn/shop/files/20240523-ACream-2-1_resolution-standardv2-2x.jpg?v=1756196867",
			"//thehues.com/cdn/shop/files/20250116-ACream-1-1_resolution-standardv2-2x.jpg?v=1756196867",
			"//thehues.com/cdn/shop/files/20250116-ACream-1-1_resolution-standardv2-2x-2.jpg?v=1756196867",
			"//thehues.com/cdn/shop/files/20250116-ACream-glint_resolution-standardv2-2x.jpg?v=1761275536"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250516-Aglint-2-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196865",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071473545466,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-1_resolution-standardv2-2x.jpg?v=1756196865"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-1_resolution-standardv2-2x.jpg?v=1756196865",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071473611002,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-3_resolution-standardv2-2x.jpg?v=1761275536"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-3_resolution-standardv2-2x.jpg?v=1761275536",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071473578234,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-2_resolution-standardv2-2x-2.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-2_resolution-standardv2-2x-2.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071473643770,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-4_resolution-standardv2-2x.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Aglint-2-4_resolution-standardv2-2x.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071473676538,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240622-Aglint-2-2_resolution-standardv2-2x.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240622-Aglint-2-2_resolution-standardv2-2x.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474659578,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250207-ASesame-1_resolution-standardv2-2x.jpg?v=1761275536"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250207-ASesame-1_resolution-standardv2-2x.jpg?v=1761275536",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474528506,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240526-ACream-4-1_resolution-standardv2-2x.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240526-ACream-4-1_resolution-standardv2-2x.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474561274,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240526-ACream-5-1_resolution-standardv2-2x.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240526-ACream-5-1_resolution-standardv2-2x.jpg?v=1756196866",
				"width": 2000
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474364666,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474397434,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-3_resolution-standardv2-2x.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ACream-3_resolution-standardv2-2x.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474430202,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-3-1_resolution-standardv2-2x.jpg?v=1756196866"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ACream-3-1_resolution-standardv2-2x.jpg?v=1756196866",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474495738,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240523-ACream-2-1_resolution-standardv2-2x.jpg?v=1756196867"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240523-ACream-2-1_resolution-standardv2-2x.jpg?v=1756196867",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474594042,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-1-1_resolution-standardv2-2x.jpg?v=1756196867"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ACream-1-1_resolution-standardv2-2x.jpg?v=1756196867",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474626810,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-1-1_resolution-standardv2-2x-2.jpg?v=1756196867"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ACream-1-1_resolution-standardv2-2x-2.jpg?v=1756196867",
				"width": 1999
			},
			{
				"alt": "Glint Linen Blend Shimmering Textured Custom Curtain - TheHues",
				"id": 36071474462970,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-ACream-glint_resolution-standardv2-2x.jpg?v=1761275536"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-ACream-glint_resolution-standardv2-2x.jpg?v=1761275536",
				"width": 1999
			},
			{
				"alt": null,
				"id": 36106607198458,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1920,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/1148fc2b02dc4c0eb2dfdb1c71109d46.thumbnail.0000000000.jpg?v=1748511045"
				},
				"aspect_ratio": 0.563,
				"duration": 16830,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/1148fc2b02dc4c0eb2dfdb1c71109d46/1148fc2b02dc4c0eb2dfdb1c71109d46.SD-480p-0.9Mbps-48442951.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/1148fc2b02dc4c0eb2dfdb1c71109d46/1148fc2b02dc4c0eb2dfdb1c71109d46.HD-1080p-2.5Mbps-48442951.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/1148fc2b02dc4c0eb2dfdb1c71109d46/1148fc2b02dc4c0eb2dfdb1c71109d46.HD-720p-1.6Mbps-48442951.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/1148fc2b02dc4c0eb2dfdb1c71109d46/1148fc2b02dc4c0eb2dfdb1c71109d46.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>The Glint Linen Blend curtains bring a sophisticated weight to your space, with a rich, textured weave that adds depth and character to any room.</p>",
		"url": "/products/glint-linen-blend-shimmering-textured-custom-curtain",
		"regular_price": "$125.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish",
				"title": "swatch finish"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			}
		]
	}
];
const curtainsList2 = [
	{
		"id": 8785118036218,
		"title": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain",
		"handle": "fadeshield-canvas-waterproof-lightweight-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester</p><p>Weight: 220 g/m²Light </p><p>Filtration: UV Protection</p><p>Features: Waterproof</p><p>Panel Included<strong>: </strong>1<br><br></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Airy with striking patterns, these waterproof curtains transform your outdoor space into a stylish retreat, rain or shine.</p>",
		"published_at": "2025-05-13T14:29:47+08:00",
		"created_at": "2025-05-13T14:29:47+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Bestseller",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"Extra 10%",
			"Factory products",
			"Fall Collection",
			"flash_categories",
			"Independence Day",
			"New Content",
			"Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain",
			"Spring Time Sale",
			"summer best seller",
			"Summer Collection",
			"Summer Outdoor Decor"
		],
		"price": 9600,
		"price_min": 9600,
		"price_max": 9600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47317128216826,
				"title": "PureWhite",
				"option1": "PureWhite",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-PureWhite",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44425143714042,
					"product_id": 8785118036218,
					"position": 22,
					"created_at": "2025-07-04T15:08:18+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 3024,
					"height": 4032,
					"src": "//thehues.com/cdn/shop/files/IMG_0893_copy_2.jpg?v=1756710408",
					"variant_ids": [
						47317128216826
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - PureWhite",
				"public_title": "PureWhite",
				"options": [
					"PureWhite"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36318683889914,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.75,
						"height": 4032,
						"width": 3024,
						"src": "//thehues.com/cdn/shop/files/IMG_0893_copy_2.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AODC-10_resolution-standardv2-2x_1024x1024.jpg?v=1756710408"
			},
			{
				"id": 47319452123386,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025425887482,
					"product_id": 8785118036218,
					"position": 66,
					"created_at": "2025-05-21T15:17:57+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABegie_resolution-standardv2-2x.jpg?v=1756710408",
					"variant_ids": [
						47319452123386
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064185614586,
					"position": 66,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABegie_resolution-standardv2-2x.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DM_20250729160805_001_1024x1024.png?v=1753776556"
			},
			{
				"id": 47317128118522,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Taupe",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025447973114,
					"product_id": 8785118036218,
					"position": 1,
					"created_at": "2025-05-21T15:21:19+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ATaupe_resolution-standardv2-2x.jpg?v=1756710408",
					"variant_ids": [
						47317128118522
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064199737594,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ATaupe_resolution-standardv2-2x.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATaupe-5_resolution-standardv2-2x_7a24f792-9be2-4f29-8db7-848bd253c3d2_1024x1024.jpg?v=1756710408"
			},
			{
				"id": 47317128151290,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025435324666,
					"product_id": 8785118036218,
					"position": 8,
					"created_at": "2025-05-21T15:19:52+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x_32997830-ba67-464f-9927-c4662c341fe5.jpg?v=1756710408",
					"variant_ids": [
						47317128151290
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064192168186,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x_32997830-ba67-464f-9927-c4662c341fe5.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AGrey-51_resolution-standardv2-2x_1024x1024.jpg?v=1756710408"
			},
			{
				"id": 47319452090618,
				"title": "Royal Blue",
				"option1": "Royal Blue",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Royal Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025447579898,
					"product_id": 8785118036218,
					"position": 15,
					"created_at": "2025-05-21T15:21:17+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue_resolution-standardv2-2x.jpg?v=1756710408",
					"variant_ids": [
						47319452090618
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Royal Blue",
				"public_title": "Royal Blue",
				"options": [
					"Royal Blue"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064199540986,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARoyal-Blue_resolution-standardv2-2x.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ARoyal-Blue-5_resolution-standardv2-2x_1024x1024.jpg?v=1756710408"
			},
			{
				"id": 47317128249594,
				"title": "Orange",
				"option1": "Orange",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Orange",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025438503162,
					"product_id": 8785118036218,
					"position": 31,
					"created_at": "2025-05-21T15:20:10+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x_6080fb83-904e-4140-9d65-a9b0df28f515.jpg?v=1756710408",
					"variant_ids": [
						47317128249594
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Orange",
				"public_title": "Orange",
				"options": [
					"Orange"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064193970426,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x_6080fb83-904e-4140-9d65-a9b0df28f515.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AOrange-5_resolution-standardv2-2x_1024x1024.jpg?v=1756710408"
			},
			{
				"id": 47317128282362,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025434898682,
					"product_id": 8785118036218,
					"position": 38,
					"created_at": "2025-05-21T15:19:47+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGreen-1_resolution-standardv2-2x_70e71ae6-33ef-4144-9627-fe9d60cb309e.jpg?v=1756710408",
					"variant_ids": [
						47317128282362
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064191742202,
					"position": 38,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGreen-1_resolution-standardv2-2x_70e71ae6-33ef-4144-9627-fe9d60cb309e.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128315130,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025429590266,
					"product_id": 8785118036218,
					"position": 45,
					"created_at": "2025-05-21T15:19:00+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABlue_resolution-standardv2-2x_77c9ffe6-0b47-41c9-bb82-413b616fa8b4.jpg?v=1756710408",
					"variant_ids": [
						47317128315130
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064188530938,
					"position": 45,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABlue_resolution-standardv2-2x_77c9ffe6-0b47-41c9-bb82-413b616fa8b4.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128347898,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025446007034,
					"product_id": 8785118036218,
					"position": 52,
					"created_at": "2025-05-21T15:21:03+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARed-2_resolution-standardv2-2x_3e5513da-e58f-41a2-887c-d1647e6da572.jpg?v=1756710408",
					"variant_ids": [
						47317128347898
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064198361338,
					"position": 52,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARed-2_resolution-standardv2-2x_3e5513da-e58f-41a2-887c-d1647e6da572.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128380666,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025427919098,
					"product_id": 8785118036218,
					"position": 59,
					"created_at": "2025-05-21T15:18:42+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_86c4ade8-ddc6-44d7-b74e-3a9caddafccb.jpg?v=1756710408",
					"variant_ids": [
						47317128380666
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064187449594,
					"position": 59,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_86c4ade8-ddc6-44d7-b74e-3a9caddafccb.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128446202,
				"title": "CharcoalGray",
				"option1": "CharcoalGray",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-CharcoalGray",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025432113402,
					"product_id": 8785118036218,
					"position": 73,
					"created_at": "2025-05-21T15:19:22+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey_resolution-standardv2-2x.jpg?v=1756710408",
					"variant_ids": [
						47317128446202
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - CharcoalGray",
				"public_title": "CharcoalGray",
				"options": [
					"CharcoalGray"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064189907194,
					"position": 73,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey_resolution-standardv2-2x.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128478970,
				"title": "GrayishBlue",
				"option1": "GrayishBlue",
				"option2": null,
				"option3": null,
				"sku": "THOC-10-OD-GrayishBlue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025433391354,
					"product_id": 8785118036218,
					"position": 80,
					"created_at": "2025-05-21T15:19:40+08:00",
					"updated_at": "2025-09-01T15:06:48+08:00",
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue_resolution-standardv2-2x.jpg?v=1756710408",
					"variant_ids": [
						47317128478970
					]
				},
				"available": true,
				"name": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - GrayishBlue",
				"public_title": "GrayishBlue",
				"options": [
					"GrayishBlue"
				],
				"price": 9600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064190890234,
					"position": 80,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGrayish-Blue_resolution-standardv2-2x.jpg?v=1756710408"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ATaupe_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ATaupe-1_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ATaupe-2_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ATaupe-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-taupe.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ATaupe-5_resolution-standardv2-2x_7a24f792-9be2-4f29-8db7-848bd253c3d2.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ATaupe-4_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x_32997830-ba67-464f-9927-c4662c341fe5.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_8ea9b4ca-b9a3-488a-a309-6cf28f2e448b.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrey-2_resolution-standardv2-2x_c1383a32-8022-4968-8229-e4fd4ba83483.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrey-3_resolution-standardv2-2x_b07f1380-6e05-46f8-8394-6918f3488734.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-grey.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/AGrey-51_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrey-4_resolution-standardv2-2x_cb7da427-a7d8-4b06-affb-8eebfb13345b.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARoyal-Blue_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-1_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-2_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-royalblue.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-5_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-4_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/IMG_0893_copy_2.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/IMG_0919_copy.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AWHite_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/APure-White-1_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/APure-White-2_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/APure-White-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-purewhite.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/AODC-10_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/APure-White-4_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x_6080fb83-904e-4140-9d65-a9b0df28f515.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AOrange-1_resolution-standardv2-2x_8c41a5f8-3f1e-4d4b-b094-b3945f97488f.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AOrange-2_resolution-standardv2-2x_f83fa47c-5614-4413-8106-d1c6a4ff081f.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AOrange-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-orange.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/AOrange-5_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AOrange-4_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGreen-1_resolution-standardv2-2x_70e71ae6-33ef-4144-9627-fe9d60cb309e.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGreen-11_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGreen-2_resolution-standardv2-2x_848e86a1-0307-4811-b1c1-40f63cfc7851.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGreen-3_resolution-standardv2-2x_8407d19d-3642-4154-837f-cb498aa691c7.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-green.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/AGreen-5_resolution-standardv2-2x_789a8ed2-1e3f-4641-b129-ca090c2e1971.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGreen-4_resolution-standardv2-2x_516b60b2-729b-46de-a34e-25b855e838ea.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlue_resolution-standardv2-2x_77c9ffe6-0b47-41c9-bb82-413b616fa8b4.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlue-1_resolution-standardv2-2x_a124483e-e377-48ea-94c0-e5589ed7a0ff.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlue-2_resolution-standardv2-2x_f18014ea-5fe2-4a57-b5cd-d9c02a108675.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlue-3_resolution-standardv2-2x_b9e75c12-35e2-4dca-96da-7faa960530ef.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-blue.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ABlue-5_resolution-standardv2-2x_6cbe0e46-18d2-4811-ad06-059dc2b53ae7.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlue-4_resolution-standardv2-2x_50644231-8485-4f85-b610-dcfb3e05f42b.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARed-2_resolution-standardv2-2x_3e5513da-e58f-41a2-887c-d1647e6da572.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARed-1_resolution-standardv2-2x_abc26038-9253-4eda-a33c-48dc1ebf85c7.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARed-21_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARed-3_resolution-standardv2-2x_ea4b7c34-c658-4824-9a3b-7b62caead4eb.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-red.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ARed-5_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ARed-4_resolution-standardv2-2x_0dcb0498-e355-440c-990c-0e3dbb81fad0.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_86c4ade8-ddc6-44d7-b74e-3a9caddafccb.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x_79fca351-6ba9-43a3-8712-7c8eae273806.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlack-2_resolution-standardv2-2x_9b11e9e9-70b2-4949-a834-8bb48ab10b6a.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlack-3_resolution-standardv2-2x_d12f5062-d305-4d2b-b869-0b06ea77e915.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-black.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ABlack-51_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABlack-4_resolution-standardv2-2x_8bee92af-75df-4d55-9e55-30155affdb9b.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABegie_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABegie-1_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABegie-2_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABegie-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-beige.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ABegie-5_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ABegie-4_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ACharcoal-Gray-1_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ACharcoal-Gray-2_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ACharcoal-Gray-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-charcoalgray.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/ACharcoal-Gray-5_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/ACharcoal-Gray-4_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrayish-Blue_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrayish-Blue-1_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrayish-Blue-2_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrayish-Blue-3_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-grayishblue.jpg?v=1761284434",
			"//thehues.com/cdn/shop/files/AGrayish-Blue-5_resolution-standardv2-2x.jpg?v=1756710408",
			"//thehues.com/cdn/shop/files/AGrayish-Blue-4_resolution-standardv2-2x.jpg?v=1756710408"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ATaupe_resolution-standardv2-2x_1024x1024.jpg?v=1756710408",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199737594,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATaupe_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATaupe_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199770362,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATaupe-1_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATaupe-1_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199803130,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATaupe-2_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATaupe-2_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199835898,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATaupe-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATaupe-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700322693370,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-taupe.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-taupe.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199704826,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATaupe-5_resolution-standardv2-2x_7a24f792-9be2-4f29-8db7-848bd253c3d2.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATaupe-5_resolution-standardv2-2x_7a24f792-9be2-4f29-8db7-848bd253c3d2.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199868666,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATaupe-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATaupe-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064192168186,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x_32997830-ba67-464f-9927-c4662c341fe5.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x_32997830-ba67-464f-9927-c4662c341fe5.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064192037114,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_8ea9b4ca-b9a3-488a-a309-6cf28f2e448b.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-1_resolution-standardv2-2x_8ea9b4ca-b9a3-488a-a309-6cf28f2e448b.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064192069882,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-2_resolution-standardv2-2x_c1383a32-8022-4968-8229-e4fd4ba83483.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-2_resolution-standardv2-2x_c1383a32-8022-4968-8229-e4fd4ba83483.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064192102650,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-3_resolution-standardv2-2x_b07f1380-6e05-46f8-8394-6918f3488734.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-3_resolution-standardv2-2x_b07f1380-6e05-46f8-8394-6918f3488734.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700322431226,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-grey.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-grey.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064192004346,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-51_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-51_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064192135418,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-4_resolution-standardv2-2x_cb7da427-a7d8-4b06-affb-8eebfb13345b.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-4_resolution-standardv2-2x_cb7da427-a7d8-4b06-affb-8eebfb13345b.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199540986,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199573754,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-1_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-1_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199606522,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-2_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-2_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199639290,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700322660602,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-royalblue.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-royalblue.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199508218,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-5_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-5_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064199672058,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36318683889914,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 4032,
					"width": 3024,
					"src": "//thehues.com/cdn/shop/files/IMG_0893_copy_2.jpg?v=1756710408"
				},
				"aspect_ratio": 0.75,
				"height": 4032,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_0893_copy_2.jpg?v=1756710408",
				"width": 3024
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36318683758842,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 4032,
					"width": 3024,
					"src": "//thehues.com/cdn/shop/files/IMG_0919_copy.jpg?v=1756710408"
				},
				"aspect_ratio": 0.75,
				"height": 4032,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/IMG_0919_copy.jpg?v=1756710408",
				"width": 3024
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064197345530,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWHite_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWHite_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064197411066,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-1_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-1_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064197443834,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-2_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-2_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064197476602,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700321841402,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-purewhite.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-purewhite.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064197378298,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AODC-10_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AODC-10_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064197312762,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APure-White-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APure-White-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064193970426,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x_6080fb83-904e-4140-9d65-a9b0df28f515.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x_6080fb83-904e-4140-9d65-a9b0df28f515.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064194003194,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-1_resolution-standardv2-2x_8c41a5f8-3f1e-4d4b-b094-b3945f97488f.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-1_resolution-standardv2-2x_8c41a5f8-3f1e-4d4b-b094-b3945f97488f.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064194035962,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-2_resolution-standardv2-2x_f83fa47c-5614-4413-8106-d1c6a4ff081f.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-2_resolution-standardv2-2x_f83fa47c-5614-4413-8106-d1c6a4ff081f.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064194068730,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700531032314,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-orange.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-orange.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064194134266,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-5_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-5_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064194101498,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064191742202,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-1_resolution-standardv2-2x_70e71ae6-33ef-4144-9627-fe9d60cb309e.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-1_resolution-standardv2-2x_70e71ae6-33ef-4144-9627-fe9d60cb309e.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064191709434,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-11_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-11_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064191774970,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-2_resolution-standardv2-2x_848e86a1-0307-4811-b1c1-40f63cfc7851.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-2_resolution-standardv2-2x_848e86a1-0307-4811-b1c1-40f63cfc7851.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064191807738,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-3_resolution-standardv2-2x_8407d19d-3642-4154-837f-cb498aa691c7.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-3_resolution-standardv2-2x_8407d19d-3642-4154-837f-cb498aa691c7.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700524609786,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-green.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-green.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064191873274,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-5_resolution-standardv2-2x_789a8ed2-1e3f-4641-b129-ca090c2e1971.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-5_resolution-standardv2-2x_789a8ed2-1e3f-4641-b129-ca090c2e1971.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064191840506,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-4_resolution-standardv2-2x_516b60b2-729b-46de-a34e-25b855e838ea.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-4_resolution-standardv2-2x_516b60b2-729b-46de-a34e-25b855e838ea.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064188530938,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue_resolution-standardv2-2x_77c9ffe6-0b47-41c9-bb82-413b616fa8b4.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue_resolution-standardv2-2x_77c9ffe6-0b47-41c9-bb82-413b616fa8b4.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064188596474,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-1_resolution-standardv2-2x_a124483e-e377-48ea-94c0-e5589ed7a0ff.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-1_resolution-standardv2-2x_a124483e-e377-48ea-94c0-e5589ed7a0ff.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064188629242,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-2_resolution-standardv2-2x_f18014ea-5fe2-4a57-b5cd-d9c02a108675.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-2_resolution-standardv2-2x_f18014ea-5fe2-4a57-b5cd-d9c02a108675.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064188694778,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-3_resolution-standardv2-2x_b9e75c12-35e2-4dca-96da-7faa960530ef.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-3_resolution-standardv2-2x_b9e75c12-35e2-4dca-96da-7faa960530ef.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700525887738,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-blue.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-blue.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064188465402,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-5_resolution-standardv2-2x_6cbe0e46-18d2-4811-ad06-059dc2b53ae7.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-5_resolution-standardv2-2x_6cbe0e46-18d2-4811-ad06-059dc2b53ae7.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064188760314,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlue-4_resolution-standardv2-2x_50644231-8485-4f85-b610-dcfb3e05f42b.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlue-4_resolution-standardv2-2x_50644231-8485-4f85-b610-dcfb3e05f42b.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064198361338,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARed-2_resolution-standardv2-2x_3e5513da-e58f-41a2-887c-d1647e6da572.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARed-2_resolution-standardv2-2x_3e5513da-e58f-41a2-887c-d1647e6da572.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064198328570,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARed-1_resolution-standardv2-2x_abc26038-9253-4eda-a33c-48dc1ebf85c7.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARed-1_resolution-standardv2-2x_abc26038-9253-4eda-a33c-48dc1ebf85c7.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064198295802,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARed-21_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARed-21_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064198394106,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARed-3_resolution-standardv2-2x_ea4b7c34-c658-4824-9a3b-7b62caead4eb.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARed-3_resolution-standardv2-2x_ea4b7c34-c658-4824-9a3b-7b62caead4eb.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700525920506,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-red.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-red.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064198459642,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARed-5_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARed-5_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064198426874,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARed-4_resolution-standardv2-2x_0dcb0498-e355-440c-990c-0e3dbb81fad0.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARed-4_resolution-standardv2-2x_0dcb0498-e355-440c-990c-0e3dbb81fad0.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064187449594,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_86c4ade8-ddc6-44d7-b74e-3a9caddafccb.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_86c4ade8-ddc6-44d7-b74e-3a9caddafccb.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064187318522,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x_79fca351-6ba9-43a3-8712-7c8eae273806.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x_79fca351-6ba9-43a3-8712-7c8eae273806.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064187351290,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-2_resolution-standardv2-2x_9b11e9e9-70b2-4949-a834-8bb48ab10b6a.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-2_resolution-standardv2-2x_9b11e9e9-70b2-4949-a834-8bb48ab10b6a.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064187384058,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-3_resolution-standardv2-2x_d12f5062-d305-4d2b-b869-0b06ea77e915.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-3_resolution-standardv2-2x_d12f5062-d305-4d2b-b869-0b06ea77e915.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700322201850,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-black.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-black.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064187285754,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-51_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-51_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064187416826,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-4_resolution-standardv2-2x_8bee92af-75df-4d55-9e55-30155affdb9b.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-4_resolution-standardv2-2x_8bee92af-75df-4d55-9e55-30155affdb9b.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064185614586,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABegie_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABegie_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064185647354,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABegie-1_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABegie-1_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064185680122,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABegie-2_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABegie-2_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064185712890,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABegie-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABegie-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700320891130,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-beige.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-beige.jpg?v=1761284434",
				"width": 1365
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064185778426,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABegie-5_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABegie-5_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064185745658,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABegie-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABegie-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064189907194,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064189939962,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-1_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-1_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064189972730,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-2_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-2_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190005498,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700524871930,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-charcoalgray.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-charcoalgray.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064189874426,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-5_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-5_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190038266,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Gray-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190890234,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrayish-Blue_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190923002,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-1_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-1_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190955770,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-2_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-2_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190791930,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-3_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-3_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36700530114810,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4551,
					"width": 3034,
					"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-grayishblue.jpg?v=1761284434"
				},
				"aspect_ratio": 0.667,
				"height": 4551,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/fadeshield--canvas-waterproof-lightweight-custom-outdoor-curtain-grayishblue.jpg?v=1761284434",
				"width": 3034
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190857466,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-5_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-5_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064190824698,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-4_resolution-standardv2-2x.jpg?v=1756710408"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrayish-Blue-4_resolution-standardv2-2x.jpg?v=1756710408",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36347070710010,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/7ef63d741aba4c7c91557ead8bc4078a.thumbnail.0000000000.jpg?v=1752127182"
				},
				"aspect_ratio": 0.563,
				"duration": 42000,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/7ef63d741aba4c7c91557ead8bc4078a/7ef63d741aba4c7c91557ead8bc4078a.SD-480p-0.9Mbps-50958560.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/7ef63d741aba4c7c91557ead8bc4078a/7ef63d741aba4c7c91557ead8bc4078a.HD-1080p-2.5Mbps-50958560.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/7ef63d741aba4c7c91557ead8bc4078a/7ef63d741aba4c7c91557ead8bc4078a.HD-720p-1.6Mbps-50958560.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/7ef63d741aba4c7c91557ead8bc4078a/7ef63d741aba4c7c91557ead8bc4078a.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Airy with striking patterns, these waterproof curtains transform your outdoor space into a stylish retreat, rain or shine.</p>",
		"url": "/products/fadeshield-canvas-waterproof-lightweight-custom-outdoor-curtain",
		"regular_price": "$96.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	},
	{
		"id": 8785117446394,
		"title": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain",
		"handle": "fadeshield-pro-fade-resistant-waterproof-lightweight-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester</p><p>Weight: 215 g/m²</p><p>Light Filtration: Room Darkening &amp; UV Protection</p><p>Features: Waterproof &amp; Anti-fading</p><p>Panel Included: 1<br></p><h3><br>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Lightweight outdoor curtains with anti-fading technology, ensuring lasting color and charm for any outdoor setting, from gazebos to balconies.</p>",
		"published_at": "2025-05-13T14:29:16+08:00",
		"created_at": "2025-05-13T14:29:16+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Bestsellers",
			"All Curtains",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"flash_categories",
			"New Content",
			"Outsourced products",
			"Sale > All Curtain Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain",
			"Summer Collection",
			"Summer Outdoor Decor"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319450616058,
				"title": "Caramel",
				"option1": "Caramel",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Caramel",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352766574842,
					"product_id": 8785117446394,
					"position": 1,
					"created_at": "2025-06-26T10:53:32+08:00",
					"updated_at": "2025-08-26T16:22:55+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ACaramel-3_resolution-standardv2-2x_93022b4b-39a8-4007-8ace-7f757197dccf.jpg?v=1756196575",
					"variant_ids": [
						47319450616058
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Caramel",
				"public_title": "Caramel",
				"options": [
					"Caramel"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271617868026,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ACaramel-3_resolution-standardv2-2x_93022b4b-39a8-4007-8ace-7f757197dccf.jpg?v=1756196575"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afadeshieldpro_caramel_1024x1024.jpg?v=1751276786"
			},
			{
				"id": 47319450648826,
				"title": "PrussianBlue",
				"option1": "PrussianBlue",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-PrussianBlue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352891814138,
					"product_id": 8785117446394,
					"position": 3,
					"created_at": "2025-06-26T11:41:21+08:00",
					"updated_at": "2025-08-26T16:22:55+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/APrussian-Blue-3_resolution-standardv2-2x_0713b157-59b4-4a8c-b6b0-793a397c7510.jpg?v=1756196575",
					"variant_ids": [
						47319450648826
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - PrussianBlue",
				"public_title": "PrussianBlue",
				"options": [
					"PrussianBlue"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271712862458,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/APrussian-Blue-3_resolution-standardv2-2x_0713b157-59b4-4a8c-b6b0-793a397c7510.jpg?v=1756196575"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afadeshieldpro_prussianblue_1024x1024.jpg?v=1751276786"
			},
			{
				"id": 47319450681594,
				"title": "Cerulean",
				"option1": "Cerulean",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Cerulean",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352770310394,
					"product_id": 8785117446394,
					"position": 91,
					"created_at": "2025-06-26T10:54:41+08:00",
					"updated_at": "2025-08-26T16:23:01+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ACerulean-3_resolution-standardv2-2x_771d6bfd-7822-4e48-9409-28ec2677a8b4.jpg?v=1756196581",
					"variant_ids": [
						47319450681594
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Cerulean",
				"public_title": "Cerulean",
				"options": [
					"Cerulean"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271620653306,
					"position": 91,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ACerulean-3_resolution-standardv2-2x_771d6bfd-7822-4e48-9409-28ec2677a8b4.jpg?v=1756196581"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afadeshieldpro_cerulean_1024x1024.jpg?v=1751276786"
			},
			{
				"id": 47319450714362,
				"title": "Forest Green",
				"option1": "Forest Green",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Forest Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352799342842,
					"product_id": 8785117446394,
					"position": 83,
					"created_at": "2025-06-26T11:05:20+08:00",
					"updated_at": "2025-08-26T16:23:01+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AForest-Green-3_resolution-standardv2-2x_24340308-d824-472d-b7fe-1084763eb6cd.jpg?v=1756196581",
					"variant_ids": [
						47319450714362
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Forest Green",
				"public_title": "Forest Green",
				"options": [
					"Forest Green"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271646146810,
					"position": 83,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AForest-Green-3_resolution-standardv2-2x_24340308-d824-472d-b7fe-1084763eb6cd.jpg?v=1756196581"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Afadeshieldpro_forestgreen_1024x1024.jpg?v=1751276787"
			},
			{
				"id": 47319450747130,
				"title": "MatchaTea",
				"option1": "MatchaTea",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-MatchaTea",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025253265658,
					"product_id": 8785117446394,
					"position": 11,
					"created_at": "2025-05-21T14:46:44+08:00",
					"updated_at": "2025-08-26T16:22:55+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-3_resolution-standardv2-2x.jpg?v=1756196575",
					"variant_ids": [
						47319450747130
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - MatchaTea",
				"public_title": "MatchaTea",
				"options": [
					"MatchaTea"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36064075088122,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-3_resolution-standardv2-2x.jpg?v=1756196575"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450779898,
				"title": "Chocolate",
				"option1": "Chocolate",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Chocolate",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352793280762,
					"product_id": 8785117446394,
					"position": 99,
					"created_at": "2025-06-26T11:03:52+08:00",
					"updated_at": "2025-08-26T16:23:02+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AChocolate-3_resolution-standardv2-2x_cb01f297-9d44-48a7-9b13-fdda6069aac9.jpg?v=1756196582",
					"variant_ids": [
						47319450779898
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Chocolate",
				"public_title": "Chocolate",
				"options": [
					"Chocolate"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271641657594,
					"position": 99,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/AChocolate-3_resolution-standardv2-2x_cb01f297-9d44-48a7-9b13-fdda6069aac9.jpg?v=1756196582"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450812666,
				"title": "Berry",
				"option1": "Berry",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Berry",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352762249466,
					"product_id": 8785117446394,
					"position": 19,
					"created_at": "2025-06-26T10:52:46+08:00",
					"updated_at": "2025-08-26T16:22:56+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2499,
					"src": "//thehues.com/cdn/shop/files/ABerry-3_resolution-standardv2-2x_cc2919e6-559e-4a02-9d72-62606a1955e9.jpg?v=1756196576",
					"variant_ids": [
						47319450812666
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Berry",
				"public_title": "Berry",
				"options": [
					"Berry"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271614820602,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2499,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABerry-3_resolution-standardv2-2x_cc2919e6-559e-4a02-9d72-62606a1955e9.jpg?v=1756196576"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450845434,
				"title": "Pumpkin",
				"option1": "Pumpkin",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Pumpkin",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352892207354,
					"product_id": 8785117446394,
					"position": 27,
					"created_at": "2025-06-26T11:41:59+08:00",
					"updated_at": "2025-08-26T16:22:57+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/APumpkin-3_resolution-standardv2-2x_0fdc6693-c649-41ad-88d9-7917c31c8653.jpg?v=1756196577",
					"variant_ids": [
						47319450845434
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Pumpkin",
				"public_title": "Pumpkin",
				"options": [
					"Pumpkin"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271713157370,
					"position": 27,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/APumpkin-3_resolution-standardv2-2x_0fdc6693-c649-41ad-88d9-7917c31c8653.jpg?v=1756196577"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450878202,
				"title": "Honey Yellow",
				"option1": "Honey Yellow",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Honey Yellow",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352922550522,
					"product_id": 8785117446394,
					"position": 75,
					"created_at": "2025-06-26T11:56:40+08:00",
					"updated_at": "2025-08-26T16:23:00+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-3_resolution-standardv2-2x_4f94541f-053e-4c49-a3a7-54a215d02ec9.jpg?v=1756196580",
					"variant_ids": [
						47319450878202
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Honey Yellow",
				"public_title": "Honey Yellow",
				"options": [
					"Honey Yellow"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271736029434,
					"position": 75,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-3_resolution-standardv2-2x_4f94541f-053e-4c49-a3a7-54a215d02ec9.jpg?v=1756196580"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450910970,
				"title": "Charcoal Grey",
				"option1": "Charcoal Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Charcoal Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352789217530,
					"product_id": 8785117446394,
					"position": 113,
					"created_at": "2025-06-26T11:02:24+08:00",
					"updated_at": "2025-08-26T16:23:03+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-3_resolution-standardv2-2x_a4b6d8a7-0492-4291-85d2-6dba0bfb5e34.jpg?v=1756196583",
					"variant_ids": [
						47319450910970
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Charcoal Grey",
				"public_title": "Charcoal Grey",
				"options": [
					"Charcoal Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271638479098,
					"position": 113,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-3_resolution-standardv2-2x_a4b6d8a7-0492-4291-85d2-6dba0bfb5e34.jpg?v=1756196583"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450943738,
				"title": "Tree Bark",
				"option1": "Tree Bark",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Tree Bark",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352913670394,
					"product_id": 8785117446394,
					"position": 35,
					"created_at": "2025-06-26T11:54:06+08:00",
					"updated_at": "2025-08-26T16:22:57+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-3_resolution-standardv2-2x_3630fe75-6052-49b9-95db-c8145b4e0b0f.jpg?v=1756196577",
					"variant_ids": [
						47319450943738
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Tree Bark",
				"public_title": "Tree Bark",
				"options": [
					"Tree Bark"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271728460026,
					"position": 35,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ATree-Bark-3_resolution-standardv2-2x_3630fe75-6052-49b9-95db-c8145b4e0b0f.jpg?v=1756196577"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319450976506,
				"title": "Koala Gray",
				"option1": "Koala Gray",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Koala Gray",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352832831738,
					"product_id": 8785117446394,
					"position": 43,
					"created_at": "2025-06-26T11:17:43+08:00",
					"updated_at": "2025-08-26T16:22:58+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2499,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-3_resolution-standardv2-2x_b91089f6-e7fb-4189-ac8f-5ceb7d5cb69d.jpg?v=1756196578",
					"variant_ids": [
						47319450976506
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Koala Gray",
				"public_title": "Koala Gray",
				"options": [
					"Koala Gray"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271673147642,
					"position": 43,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2499,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AKoala-Gray-3_resolution-standardv2-2x_b91089f6-e7fb-4189-ac8f-5ceb7d5cb69d.jpg?v=1756196578"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319451042042,
				"title": "Apple Red",
				"option1": "Apple Red",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Apple Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352750321914,
					"product_id": 8785117446394,
					"position": 59,
					"created_at": "2025-06-26T10:50:09+08:00",
					"updated_at": "2025-08-26T16:22:59+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2499,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-3_resolution-standardv2-2x_179ebd82-101e-44d9-afb9-f7ace6dae422.jpg?v=1756196579",
					"variant_ids": [
						47319451042042
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Apple Red",
				"public_title": "Apple Red",
				"options": [
					"Apple Red"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271605809402,
					"position": 59,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2499,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AApple-Red-3_resolution-standardv2-2x_179ebd82-101e-44d9-afb9-f7ace6dae422.jpg?v=1756196579"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47319451074810,
				"title": "Midnight Black",
				"option1": "Midnight Black",
				"option2": null,
				"option3": null,
				"sku": "THOC-88-OD-Midnight Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44352885817594,
					"product_id": 8785117446394,
					"position": 67,
					"created_at": "2025-06-26T11:37:27+08:00",
					"updated_at": "2025-08-26T16:22:59+08:00",
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-3_resolution-standardv2-2x_8449902e-0781-4d2a-92a2-e8281bc0ca15.jpg?v=1756196579",
					"variant_ids": [
						47319451074810
					]
				},
				"available": true,
				"name": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - Midnight Black",
				"public_title": "Midnight Black",
				"options": [
					"Midnight Black"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
					"id": 36271707652346,
					"position": 67,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AMidnight-Black-3_resolution-standardv2-2x_8449902e-0781-4d2a-92a2-e8281bc0ca15.jpg?v=1756196579"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ACaramel-3_resolution-standardv2-2x_93022b4b-39a8-4007-8ace-7f757197dccf.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/Acaramel-4_resolution-standardv2-2x_b443d1e5-8a15-46b7-b22d-f827f3271335.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/APrussian-Blue-3_resolution-standardv2-2x_0713b157-59b4-4a8c-b6b0-793a397c7510.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/APrussian-Blue-2_resolution-standardv2-2x_41043007-76f8-43fb-8db5-1d496021c76f.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/APrussian-Blue-1_resolution-standardv2-2x_02df06ea-1552-4510-b6bf-a9a8452c8518.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/ANavy-1-1_resolution-standardv2-2x_13d89e46-987c-4399-bb08-e3bf95c9cc86.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/APrussian-Blue-4_resolution-standardv2-2x_8d9daa12-553c-4fa2-ba7d-212ed92968a3.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/APrussian-Blue-5_resolution-standardv2-2x_0b3587f3-f4ae-49b4-9d10-6216d6816980.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ANavy_resolution-standardv2-2x.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/ANavy-3-1_resolution-standardv2-2x.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/AMatcha-Tea-3_resolution-standardv2-2x.jpg?v=1756196575",
			"//thehues.com/cdn/shop/files/AMatcha-Tea-2_resolution-standardv2-2x.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/AMatcha-Tea-1_resolution-standardv2-2x_7a660a38-a456-41f8-abf0-d97e9c4feb85.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/AGass-Green1_resolution-standardv2-2x_9d1d12c7-722f-428d-96be-b8360b9e5533.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/AMatchaTea-3_resolution-standardv2-2x_4d130186-dfa2-4042-ac63-e04ba58417f6.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/AMatchaTea-2_resolution-standardv2-2x_9a1116af-a21f-4ac9-b4ba-cc43c3c55ea9.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/Agrass-green_resolution-standardv2-2x.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/AGass-Green_resolution-standardv2-2x.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/ABerry-3_resolution-standardv2-2x_cc2919e6-559e-4a02-9d72-62606a1955e9.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/ABerry-2_resolution-standardv2-2x_158caad7-67d1-499e-952b-35da107ee9c9.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/ABerry-1_resolution-standardv2-2x_0687d921-4e37-47ee-98cd-da103c31bb29.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/ABerry-4_2__resolution-standardv2-2x_18230f2b-0188-4d79-8d1d-7a961c1f2caf.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/ABerry-4_resolution-standardv2-2x_7d91bdaf-a1c1-4abb-9314-595134a50579.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/ABerry-5_resolution-standardv2-2x_076536a2-878d-4645-a8f9-bf3a12ea3191.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/rose-red-3.jpg?v=1756196576",
			"//thehues.com/cdn/shop/files/Rose-Red-2-1.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/APumpkin-3_resolution-standardv2-2x_0fdc6693-c649-41ad-88d9-7917c31c8653.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/APumpkin-2_resolution-standardv2-2x_b0a85ed4-a971-4612-9b27-94540261e5cc.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/APumpkin-1_resolution-standardv2-2x_d20ffc69-6765-4574-9d57-83517b4adf7f.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/AOrange-1_resolution-standardv2-2x_9182ee40-6cae-4a0e-a0ce-bdaea2fd9fa3.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/APumpkin-4_resolution-standardv2-2x_cc1caf46-b607-417d-bb52-a9bc908fb598.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/APumpkin-5_resolution-standardv2-2x_6b0cea19-eb1a-4b39-878a-e4666ec884e0.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/AOrange-2_resolution-standardv2-2x.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/ATree-Bark-3_resolution-standardv2-2x_3630fe75-6052-49b9-95db-c8145b4e0b0f.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/Tree-Bark-2.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/ATree-Bark-1_resolution-standardv2-2x_8870ab18-341f-4e2b-be83-46fd530849ff.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/tree-bark-1_0152b64e-fd06-4fb2-a65f-4dc685c14b86.jpg?v=1756196577",
			"//thehues.com/cdn/shop/files/ATree-Bark-4_resolution-standardv2-2x_b343ac92-da76-41b1-a12a-e01afca5f45b.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/ATree-Bark-5_resolution-standardv2-2x_67763127-2a5c-49b6-b7f1-e1305b48fd3a.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ATree-Bark-2_1__resolution-standardv2-2x_f94d8b6d-431b-4d58-910e-2c572cf03e58.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/ATree-Bark-2_resolution-standardv2-2x_40100dfd-6e9b-4a44-940c-4d5efb19ffbd.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/AKoala-Gray-3_resolution-standardv2-2x_b91089f6-e7fb-4189-ac8f-5ceb7d5cb69d.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/Koala-Gray-2.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/AKoala-Gray-1_resolution-standardv2-2x_3064c264-abc3-4ae1-a498-1cdecc91dec3.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/AKOALA-GRAY-1_1__resolution-standardv2-2x_3e9763b2-1e4b-4e30-9bab-b3b73f6c61bd.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/AKoala-Gray-4_resolution-standardv2-2x_08e1f222-a728-4bee-9521-3d3a653cf08a.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/AKoala-Gray-5_resolution-standardv2-2x_53b7829b-2eb9-427d-9610-e7e75195d186.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/AKoala-Gray-21_resolution-standardv2-2x_1c9ae6fb-10a0-4177-8b00-8090488c36b5.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/AKoala-Gray-2_resolution-standardv2-2x_0d95ade8-2cac-460b-bc2f-d6230765c635.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/ASoft-Purple-3_resolution-standardv2-2x_e4b838e3-4edb-4dc3-9c19-3b26b68ec618.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/ASoft-Purple-2_resolution-standardv2-2x_4bf0d90a-edb8-4465-870a-536f2e54c06e.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/ASoft-Purple-1_resolution-standardv2-2x_02f56a6a-1583-4b3d-a457-f89ebec4037d.jpg?v=1756196578",
			"//thehues.com/cdn/shop/files/ASoft-Purple-21_resolution-standardv2-2x_90e0e438-0c0e-4971-b222-5b5ab84c0fbb.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/ASoft-Purple-4_resolution-standardv2-2x_d2aacb96-22ae-40ce-9551-16e12bf70183.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/ASoft-Purple-5_resolution-standardv2-2x_e123aeda-5e23-4593-aabd-c18043ee825c.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ASoft-Purple-11_resolution-standardv2-2x_04ea87bd-9d8b-44fb-8545-1ca86d67ac3e.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/ASoft-Purple-31_resolution-standardv2-2x_850a6a96-fadd-4b25-9b92-16799d30f951.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-3_resolution-standardv2-2x_179ebd82-101e-44d9-afb9-f7ace6dae422.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-2_resolution-standardv2-2x_967f4199-d6b1-4c33-91da-84c1290900aa.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-1_resolution-standardv2-2x_77c973ac-3e0c-4c65-a554-d69ce3010f7f.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-21_resolution-standardv2-2x_a4730047-2287-4a44-bf18-82d538d49ecd.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-4_resolution-standardv2-2x_9a98f23c-b4b3-4df2-a476-6680329fb7df.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-5_resolution-standardv2-2x_37122997-238d-44d2-855d-1f4613248158.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/AApple-Red-11_resolution-standardv2-2x_652fc898-2a1e-4ef8-831e-b258fbc4ec61.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AApple-Red-31_resolution-standardv2-2x_23be0364-3df8-43dc-b6f1-3d0cfbe24c03.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AMidnight-Black-3_resolution-standardv2-2x_8449902e-0781-4d2a-92a2-e8281bc0ca15.jpg?v=1756196579",
			"//thehues.com/cdn/shop/files/AMidnight-Black-2_resolution-standardv2-2x_695fa4a3-586c-4fea-9c0a-13bc7922e93b.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AMidnight-Black-1_resolution-standardv2-2x_47e368f4-110a-4117-ae97-ed9ecb2f3271.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AMidnight-Black-21_resolution-standardv2-2x_d45f2646-9064-4032-bca2-3a318d8d7147.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AMidnight-Black-4_resolution-standardv2-2x_279f9384-0260-4c0b-97d2-89d9c951d921.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AMidnight-Black-5_resolution-standardv2-2x_d6010fe3-a58e-490b-9f10-dfb33c4f55c9.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/AMidnight-Black-11_resolution-standardv2-2x_7796042a-76ec-43f8-83f7-8d661d9f3150.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AMidnight-Black-31_resolution-standardv2-2x_c0cd9b57-b387-4351-a4e3-30b1d7ef4d45.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AHoney-Yellow-3_resolution-standardv2-2x_4f94541f-053e-4c49-a3a7-54a215d02ec9.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AHoney-Yellow-2_resolution-standardv2-2x_c645370f-ebb7-4adc-b2a6-7ed1444a0710.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AHoney-Yellow-1_resolution-standardv2-2x_0b3916f0-5b45-4afe-ac5a-9181efc97755.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_e5509b1c-5495-4ac0-9307-56779b80d195.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AHoney-Yellow-4_resolution-standardv2-2x_cd7e02ff-4a72-455f-9666-b95ac4c4ae2c.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AHoney-Yellow-5_resolution-standardv2-2x_0c80cfaa-a18b-496e-a415-9ad0586b289d.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/AYellow-1_resolution-standardv2-2x_0ed559ac-e9df-418f-a953-a7392e393c6c.jpg?v=1756196580",
			"//thehues.com/cdn/shop/files/AYellew_resolution-standardv2-2x_fc9d05aa-5fbc-4336-be19-5d2393b14cb0.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AForest-Green-3_resolution-standardv2-2x_24340308-d824-472d-b7fe-1084763eb6cd.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AForest-Green-2_resolution-standardv2-2x_3dfb46f6-7de7-42a9-9fd1-b457ff7a215b.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AForest-Green-1_resolution-standardv2-2x_5b188020-311d-4486-92b1-b879a2677aa0.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AGreen_resolution-standardv2-2x_e3756c9f-fd4d-40a8-b142-ec89490e7a42.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AForestGreen-4_resolution-standardv2-2x_9700c35f-e4f9-49ac-b0e4-6a62eace5538.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AForestGreen-3_resolution-standardv2-2x_3ed7fa87-6fa8-4a0c-93e3-531cb42cd42b.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/AGreen1_resolution-standardv2-2x_3ecc671c-9f84-4fa2-a502-b8734a071270.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/AGreen-2_resolution-standardv2-2x_46cb648a-d995-499f-a4a3-c0c8139b3a58.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/ACerulean-3_resolution-standardv2-2x_771d6bfd-7822-4e48-9409-28ec2677a8b4.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/ACerulean-2_resolution-standardv2-2x_069c515d-cef2-4a50-9b37-ae39bb1530bd.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/ACerulean-1_resolution-standardv2-2x_d63828c2-908a-4d1d-b8ae-7181ea592cff.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/ACerulean-4_resolution-standardv2-2x_0ddd4eb4-c009-4f56-90d3-bd6f8b5c2d1d.jpg?v=1756196581",
			"//thehues.com/cdn/shop/files/ACerulean-3_2__resolution-standardv2-2x_5b92e21b-6eee-45f1-9f64-889f4f8a6429.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/ACerulean-2_2__resolution-standardv2-2x_e56ad539-71bc-4036-abc4-c8c576d76110.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ACerulean-5_resolution-standardv2-2x_693bd79d-77f4-4f04-a3fe-6187c07f0916.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/ACerulean-6_resolution-standardv2-2x_07051759-9134-4206-b428-a587bb9ce5eb.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/AChocolate-3_resolution-standardv2-2x_cb01f297-9d44-48a7-9b13-fdda6069aac9.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/AChocolate-2_resolution-standardv2-2x_836a9d16-82bd-4e96-bbc9-1f0610b0b748.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/AChocolate-1_resolution-standardv2-2x_6f38c86f-b031-4246-a5a9-e41b55564f25.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/AChocolate-4_2__resolution-standardv2-2x_b1da3f2a-22b6-4149-b613-6a00ffa1239a.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/AChocolate-4_resolution-standardv2-2x_2d2549a2-1927-49d8-8de3-02c4612af085.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/AChocolate-5_resolution-standardv2-2x_ec12fa53-8087-4e92-86d1-4c5f6b50b4f4.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ABrown_resolution-standardv2-2x_b463043a-1bdd-4d80-bf87-c94e737c682e.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/ABrown-2-2_resolution-standardv2-2x_14624407-27a0-488a-8a73-2a161d5f2526.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/ACaramel-2_resolution-standardv2-2x_c7361965-bafd-4f12-99da-8bad7d8ae801.jpg?v=1756196582",
			"//thehues.com/cdn/shop/files/ACaramel-1_resolution-standardv2-2x_564ebd7d-e742-4d28-9414-8ac2b09495a4.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACaramel-2_2__resolution-standardv2-2x_b09732c0-b8ed-4e39-bca7-c18273a57a2d.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ACaramel-3_2__resolution-standardv2-2x_0f1a33c1-1a05-491f-a299-5a493c718835.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/Acaramel-5_resolution-standardv2-2x_a75611fd-00c4-477d-8060-013669cdada7.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/Acaramel-6_resolution-standardv2-2x_08d9ade0-d700-46e3-a3b3-5bbb1c8c130b.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-3_resolution-standardv2-2x_a4b6d8a7-0492-4291-85d2-6dba0bfb5e34.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-2_resolution-standardv2-2x_98924b93-1794-4755-ab2e-62848884e5f0.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-1_resolution-standardv2-2x_59e50846-835f-4e14-9053-bd885b29ff26.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-1_1_-1_resolution-standardv2-2x.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-4_resolution-standardv2-2x_f672b157-486d-4c3a-8378-e36722d8ba47.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-5_resolution-standardv2-2x_3594452d-c081-4110-99a8-debd6c7e502f.jpg?v=1761284844",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-1-1_resolution-standardv2-2x_33906062-17aa-4de1-a469-9cb32a2da9ec.jpg?v=1756196583",
			"//thehues.com/cdn/shop/files/ACharcoal-Grey-2-1_resolution-standardv2-2x_639d195d-7425-4f0f-9023-e2bdb474e3d6.jpg?v=1756196583"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ACaramel-3_resolution-standardv2-2x_93022b4b-39a8-4007-8ace-7f757197dccf_1024x1024.jpg?v=1756196575",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271617868026,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACaramel-3_resolution-standardv2-2x_93022b4b-39a8-4007-8ace-7f757197dccf.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACaramel-3_resolution-standardv2-2x_93022b4b-39a8-4007-8ace-7f757197dccf.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271617900794,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acaramel-4_resolution-standardv2-2x_b443d1e5-8a15-46b7-b22d-f827f3271335.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-4_resolution-standardv2-2x_b443d1e5-8a15-46b7-b22d-f827f3271335.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271712862458,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APrussian-Blue-3_resolution-standardv2-2x_0713b157-59b4-4a8c-b6b0-793a397c7510.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APrussian-Blue-3_resolution-standardv2-2x_0713b157-59b4-4a8c-b6b0-793a397c7510.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271712829690,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APrussian-Blue-2_resolution-standardv2-2x_41043007-76f8-43fb-8db5-1d496021c76f.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APrussian-Blue-2_resolution-standardv2-2x_41043007-76f8-43fb-8db5-1d496021c76f.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271712796922,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/APrussian-Blue-1_resolution-standardv2-2x_02df06ea-1552-4510-b6bf-a9a8452c8518.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APrussian-Blue-1_resolution-standardv2-2x_02df06ea-1552-4510-b6bf-a9a8452c8518.jpg?v=1756196575",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064089342202,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANavy-1-1_resolution-standardv2-2x_13d89e46-987c-4399-bb08-e3bf95c9cc86.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANavy-1-1_resolution-standardv2-2x_13d89e46-987c-4399-bb08-e3bf95c9cc86.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271712895226,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APrussian-Blue-4_resolution-standardv2-2x_8d9daa12-553c-4fa2-ba7d-212ed92968a3.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APrussian-Blue-4_resolution-standardv2-2x_8d9daa12-553c-4fa2-ba7d-212ed92968a3.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271712927994,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APrussian-Blue-5_resolution-standardv2-2x_0b3587f3-f4ae-49b4-9d10-6216d6816980.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APrussian-Blue-5_resolution-standardv2-2x_0b3587f3-f4ae-49b4-9d10-6216d6816980.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064089309434,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANavy_resolution-standardv2-2x.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANavy_resolution-standardv2-2x.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064089374970,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ANavy-3-1_resolution-standardv2-2x.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANavy-3-1_resolution-standardv2-2x.jpg?v=1756196575",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075088122,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-3_resolution-standardv2-2x.jpg?v=1756196575"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-3_resolution-standardv2-2x.jpg?v=1756196575",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075055354,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-2_resolution-standardv2-2x.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-2_resolution-standardv2-2x.jpg?v=1756196576",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075022586,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-1_resolution-standardv2-2x_7a660a38-a456-41f8-abf0-d97e9c4feb85.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMatcha-Tea-1_resolution-standardv2-2x_7a660a38-a456-41f8-abf0-d97e9c4feb85.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075153658,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/AGass-Green1_resolution-standardv2-2x_9d1d12c7-722f-428d-96be-b8360b9e5533.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGass-Green1_resolution-standardv2-2x_9d1d12c7-722f-428d-96be-b8360b9e5533.jpg?v=1756196576",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075251962,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMatchaTea-3_resolution-standardv2-2x_4d130186-dfa2-4042-ac63-e04ba58417f6.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMatchaTea-3_resolution-standardv2-2x_4d130186-dfa2-4042-ac63-e04ba58417f6.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075219194,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMatchaTea-2_resolution-standardv2-2x_9a1116af-a21f-4ac9-b4ba-cc43c3c55ea9.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMatchaTea-2_resolution-standardv2-2x_9a1116af-a21f-4ac9-b4ba-cc43c3c55ea9.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075186426,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrass-green_resolution-standardv2-2x.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrass-green_resolution-standardv2-2x.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064075120890,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGass-Green_resolution-standardv2-2x.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGass-Green_resolution-standardv2-2x.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271614820602,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABerry-3_resolution-standardv2-2x_cc2919e6-559e-4a02-9d72-62606a1955e9.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABerry-3_resolution-standardv2-2x_cc2919e6-559e-4a02-9d72-62606a1955e9.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271614787834,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABerry-2_resolution-standardv2-2x_158caad7-67d1-499e-952b-35da107ee9c9.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABerry-2_resolution-standardv2-2x_158caad7-67d1-499e-952b-35da107ee9c9.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271614755066,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABerry-1_resolution-standardv2-2x_0687d921-4e37-47ee-98cd-da103c31bb29.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABerry-1_resolution-standardv2-2x_0687d921-4e37-47ee-98cd-da103c31bb29.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271614853370,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ABerry-4_2__resolution-standardv2-2x_18230f2b-0188-4d79-8d1d-7a961c1f2caf.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABerry-4_2__resolution-standardv2-2x_18230f2b-0188-4d79-8d1d-7a961c1f2caf.jpg?v=1756196576",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271614886138,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABerry-4_resolution-standardv2-2x_7d91bdaf-a1c1-4abb-9314-595134a50579.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABerry-4_resolution-standardv2-2x_7d91bdaf-a1c1-4abb-9314-595134a50579.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271614722298,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABerry-5_resolution-standardv2-2x_076536a2-878d-4645-a8f9-bf3a12ea3191.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABerry-5_resolution-standardv2-2x_076536a2-878d-4645-a8f9-bf3a12ea3191.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064029868282,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/rose-red-3.jpg?v=1756196576"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/rose-red-3.jpg?v=1756196576",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064029901050,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Rose-Red-2-1.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Rose-Red-2-1.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271713157370,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APumpkin-3_resolution-standardv2-2x_0fdc6693-c649-41ad-88d9-7917c31c8653.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APumpkin-3_resolution-standardv2-2x_0fdc6693-c649-41ad-88d9-7917c31c8653.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271713124602,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/APumpkin-2_resolution-standardv2-2x_b0a85ed4-a971-4612-9b27-94540261e5cc.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APumpkin-2_resolution-standardv2-2x_b0a85ed4-a971-4612-9b27-94540261e5cc.jpg?v=1756196577",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271713091834,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APumpkin-1_resolution-standardv2-2x_d20ffc69-6765-4574-9d57-83517b4adf7f.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APumpkin-1_resolution-standardv2-2x_d20ffc69-6765-4574-9d57-83517b4adf7f.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064092422394,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-1_resolution-standardv2-2x_9182ee40-6cae-4a0e-a0ce-bdaea2fd9fa3.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-1_resolution-standardv2-2x_9182ee40-6cae-4a0e-a0ce-bdaea2fd9fa3.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271713190138,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APumpkin-4_resolution-standardv2-2x_cc1caf46-b607-417d-bb52-a9bc908fb598.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APumpkin-4_resolution-standardv2-2x_cc1caf46-b607-417d-bb52-a9bc908fb598.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271713222906,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/APumpkin-5_resolution-standardv2-2x_6b0cea19-eb1a-4b39-878a-e4666ec884e0.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/APumpkin-5_resolution-standardv2-2x_6b0cea19-eb1a-4b39-878a-e4666ec884e0.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064092389626,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange_resolution-standardv2-2x.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064092455162,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOrange-2_resolution-standardv2-2x.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOrange-2_resolution-standardv2-2x.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271728460026,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-3_resolution-standardv2-2x_3630fe75-6052-49b9-95db-c8145b4e0b0f.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATree-Bark-3_resolution-standardv2-2x_3630fe75-6052-49b9-95db-c8145b4e0b0f.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064103268602,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Tree-Bark-2.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Tree-Bark-2.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271728361722,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-1_resolution-standardv2-2x_8870ab18-341f-4e2b-be83-46fd530849ff.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATree-Bark-1_resolution-standardv2-2x_8870ab18-341f-4e2b-be83-46fd530849ff.jpg?v=1756196577",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064103235834,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/tree-bark-1_0152b64e-fd06-4fb2-a65f-4dc685c14b86.jpg?v=1756196577"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/tree-bark-1_0152b64e-fd06-4fb2-a65f-4dc685c14b86.jpg?v=1756196577",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271728492794,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-4_resolution-standardv2-2x_b343ac92-da76-41b1-a12a-e01afca5f45b.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATree-Bark-4_resolution-standardv2-2x_b343ac92-da76-41b1-a12a-e01afca5f45b.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271728525562,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-5_resolution-standardv2-2x_67763127-2a5c-49b6-b7f1-e1305b48fd3a.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATree-Bark-5_resolution-standardv2-2x_67763127-2a5c-49b6-b7f1-e1305b48fd3a.jpg?v=1761284844",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271728394490,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-2_1__resolution-standardv2-2x_f94d8b6d-431b-4d58-910e-2c572cf03e58.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATree-Bark-2_1__resolution-standardv2-2x_f94d8b6d-431b-4d58-910e-2c572cf03e58.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271728427258,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATree-Bark-2_resolution-standardv2-2x_40100dfd-6e9b-4a44-940c-4d5efb19ffbd.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATree-Bark-2_resolution-standardv2-2x_40100dfd-6e9b-4a44-940c-4d5efb19ffbd.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673147642,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-3_resolution-standardv2-2x_b91089f6-e7fb-4189-ac8f-5ceb7d5cb69d.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKoala-Gray-3_resolution-standardv2-2x_b91089f6-e7fb-4189-ac8f-5ceb7d5cb69d.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36064073875706,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Koala-Gray-2.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Koala-Gray-2.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673082106,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-1_resolution-standardv2-2x_3064c264-abc3-4ae1-a498-1cdecc91dec3.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKoala-Gray-1_resolution-standardv2-2x_3064c264-abc3-4ae1-a498-1cdecc91dec3.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673049338,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKOALA-GRAY-1_1__resolution-standardv2-2x_3e9763b2-1e4b-4e30-9bab-b3b73f6c61bd.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKOALA-GRAY-1_1__resolution-standardv2-2x_3e9763b2-1e4b-4e30-9bab-b3b73f6c61bd.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673180410,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-4_resolution-standardv2-2x_08e1f222-a728-4bee-9521-3d3a653cf08a.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKoala-Gray-4_resolution-standardv2-2x_08e1f222-a728-4bee-9521-3d3a653cf08a.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673213178,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-5_resolution-standardv2-2x_53b7829b-2eb9-427d-9610-e7e75195d186.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKoala-Gray-5_resolution-standardv2-2x_53b7829b-2eb9-427d-9610-e7e75195d186.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673016570,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-21_resolution-standardv2-2x_1c9ae6fb-10a0-4177-8b00-8090488c36b5.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKoala-Gray-21_resolution-standardv2-2x_1c9ae6fb-10a0-4177-8b00-8090488c36b5.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271673114874,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AKoala-Gray-2_resolution-standardv2-2x_0d95ade8-2cac-460b-bc2f-d6230765c635.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AKoala-Gray-2_resolution-standardv2-2x_0d95ade8-2cac-460b-bc2f-d6230765c635.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726428410,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-3_resolution-standardv2-2x_e4b838e3-4edb-4dc3-9c19-3b26b68ec618.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-3_resolution-standardv2-2x_e4b838e3-4edb-4dc3-9c19-3b26b68ec618.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726395642,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-2_resolution-standardv2-2x_4bf0d90a-edb8-4465-870a-536f2e54c06e.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-2_resolution-standardv2-2x_4bf0d90a-edb8-4465-870a-536f2e54c06e.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726362874,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-1_resolution-standardv2-2x_02f56a6a-1583-4b3d-a457-f89ebec4037d.jpg?v=1756196578"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-1_resolution-standardv2-2x_02f56a6a-1583-4b3d-a457-f89ebec4037d.jpg?v=1756196578",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726559482,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-21_resolution-standardv2-2x_90e0e438-0c0e-4971-b222-5b5ab84c0fbb.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-21_resolution-standardv2-2x_90e0e438-0c0e-4971-b222-5b5ab84c0fbb.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726461178,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-4_resolution-standardv2-2x_d2aacb96-22ae-40ce-9551-16e12bf70183.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-4_resolution-standardv2-2x_d2aacb96-22ae-40ce-9551-16e12bf70183.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726493946,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-5_resolution-standardv2-2x_e123aeda-5e23-4593-aabd-c18043ee825c.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-5_resolution-standardv2-2x_e123aeda-5e23-4593-aabd-c18043ee825c.jpg?v=1761284844",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726526714,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-11_resolution-standardv2-2x_04ea87bd-9d8b-44fb-8545-1ca86d67ac3e.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-11_resolution-standardv2-2x_04ea87bd-9d8b-44fb-8545-1ca86d67ac3e.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271726592250,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASoft-Purple-31_resolution-standardv2-2x_850a6a96-fadd-4b25-9b92-16799d30f951.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASoft-Purple-31_resolution-standardv2-2x_850a6a96-fadd-4b25-9b92-16799d30f951.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605809402,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-3_resolution-standardv2-2x_179ebd82-101e-44d9-afb9-f7ace6dae422.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-3_resolution-standardv2-2x_179ebd82-101e-44d9-afb9-f7ace6dae422.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605776634,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-2_resolution-standardv2-2x_967f4199-d6b1-4c33-91da-84c1290900aa.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-2_resolution-standardv2-2x_967f4199-d6b1-4c33-91da-84c1290900aa.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605743866,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-1_resolution-standardv2-2x_77c973ac-3e0c-4c65-a554-d69ce3010f7f.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-1_resolution-standardv2-2x_77c973ac-3e0c-4c65-a554-d69ce3010f7f.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605678330,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-21_resolution-standardv2-2x_a4730047-2287-4a44-bf18-82d538d49ecd.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-21_resolution-standardv2-2x_a4730047-2287-4a44-bf18-82d538d49ecd.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605842170,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-4_resolution-standardv2-2x_9a98f23c-b4b3-4df2-a476-6680329fb7df.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-4_resolution-standardv2-2x_9a98f23c-b4b3-4df2-a476-6680329fb7df.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605612794,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-5_resolution-standardv2-2x_37122997-238d-44d2-855d-1f4613248158.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-5_resolution-standardv2-2x_37122997-238d-44d2-855d-1f4613248158.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605645562,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-11_resolution-standardv2-2x_652fc898-2a1e-4ef8-831e-b258fbc4ec61.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-11_resolution-standardv2-2x_652fc898-2a1e-4ef8-831e-b258fbc4ec61.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271605711098,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AApple-Red-31_resolution-standardv2-2x_23be0364-3df8-43dc-b6f1-3d0cfbe24c03.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AApple-Red-31_resolution-standardv2-2x_23be0364-3df8-43dc-b6f1-3d0cfbe24c03.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707652346,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-3_resolution-standardv2-2x_8449902e-0781-4d2a-92a2-e8281bc0ca15.jpg?v=1756196579"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-3_resolution-standardv2-2x_8449902e-0781-4d2a-92a2-e8281bc0ca15.jpg?v=1756196579",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707619578,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-2_resolution-standardv2-2x_695fa4a3-586c-4fea-9c0a-13bc7922e93b.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-2_resolution-standardv2-2x_695fa4a3-586c-4fea-9c0a-13bc7922e93b.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707586810,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-1_resolution-standardv2-2x_47e368f4-110a-4117-ae97-ed9ecb2f3271.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-1_resolution-standardv2-2x_47e368f4-110a-4117-ae97-ed9ecb2f3271.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707783418,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-21_resolution-standardv2-2x_d45f2646-9064-4032-bca2-3a318d8d7147.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-21_resolution-standardv2-2x_d45f2646-9064-4032-bca2-3a318d8d7147.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707685114,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-4_resolution-standardv2-2x_279f9384-0260-4c0b-97d2-89d9c951d921.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-4_resolution-standardv2-2x_279f9384-0260-4c0b-97d2-89d9c951d921.jpg?v=1756196580",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707717882,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-5_resolution-standardv2-2x_d6010fe3-a58e-490b-9f10-dfb33c4f55c9.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-5_resolution-standardv2-2x_d6010fe3-a58e-490b-9f10-dfb33c4f55c9.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707750650,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-11_resolution-standardv2-2x_7796042a-76ec-43f8-83f7-8d661d9f3150.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-11_resolution-standardv2-2x_7796042a-76ec-43f8-83f7-8d661d9f3150.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271707816186,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AMidnight-Black-31_resolution-standardv2-2x_c0cd9b57-b387-4351-a4e3-30b1d7ef4d45.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AMidnight-Black-31_resolution-standardv2-2x_c0cd9b57-b387-4351-a4e3-30b1d7ef4d45.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271736029434,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-3_resolution-standardv2-2x_4f94541f-053e-4c49-a3a7-54a215d02ec9.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-3_resolution-standardv2-2x_4f94541f-053e-4c49-a3a7-54a215d02ec9.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271735996666,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-2_resolution-standardv2-2x_c645370f-ebb7-4adc-b2a6-7ed1444a0710.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-2_resolution-standardv2-2x_c645370f-ebb7-4adc-b2a6-7ed1444a0710.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271735963898,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-1_resolution-standardv2-2x_0b3916f0-5b45-4afe-ac5a-9181efc97755.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-1_resolution-standardv2-2x_0b3916f0-5b45-4afe-ac5a-9181efc97755.jpg?v=1756196580",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271735931130,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_e5509b1c-5495-4ac0-9307-56779b80d195.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_e5509b1c-5495-4ac0-9307-56779b80d195.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271736062202,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-4_resolution-standardv2-2x_cd7e02ff-4a72-455f-9666-b95ac4c4ae2c.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-4_resolution-standardv2-2x_cd7e02ff-4a72-455f-9666-b95ac4c4ae2c.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271735832826,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-5_resolution-standardv2-2x_0c80cfaa-a18b-496e-a415-9ad0586b289d.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHoney-Yellow-5_resolution-standardv2-2x_0c80cfaa-a18b-496e-a415-9ad0586b289d.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271735898362,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-1_resolution-standardv2-2x_0ed559ac-e9df-418f-a953-a7392e393c6c.jpg?v=1756196580"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-1_resolution-standardv2-2x_0ed559ac-e9df-418f-a953-a7392e393c6c.jpg?v=1756196580",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271735865594,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellew_resolution-standardv2-2x_fc9d05aa-5fbc-4336-be19-5d2393b14cb0.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellew_resolution-standardv2-2x_fc9d05aa-5fbc-4336-be19-5d2393b14cb0.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646146810,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AForest-Green-3_resolution-standardv2-2x_24340308-d824-472d-b7fe-1084763eb6cd.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AForest-Green-3_resolution-standardv2-2x_24340308-d824-472d-b7fe-1084763eb6cd.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646114042,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AForest-Green-2_resolution-standardv2-2x_3dfb46f6-7de7-42a9-9fd1-b457ff7a215b.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AForest-Green-2_resolution-standardv2-2x_3dfb46f6-7de7-42a9-9fd1-b457ff7a215b.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646081274,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AForest-Green-1_resolution-standardv2-2x_5b188020-311d-4486-92b1-b879a2677aa0.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AForest-Green-1_resolution-standardv2-2x_5b188020-311d-4486-92b1-b879a2677aa0.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646179578,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen_resolution-standardv2-2x_e3756c9f-fd4d-40a8-b142-ec89490e7a42.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen_resolution-standardv2-2x_e3756c9f-fd4d-40a8-b142-ec89490e7a42.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646048506,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/AForestGreen-4_resolution-standardv2-2x_9700c35f-e4f9-49ac-b0e4-6a62eace5538.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AForestGreen-4_resolution-standardv2-2x_9700c35f-e4f9-49ac-b0e4-6a62eace5538.jpg?v=1756196581",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646015738,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AForestGreen-3_resolution-standardv2-2x_3ed7fa87-6fa8-4a0c-93e3-531cb42cd42b.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AForestGreen-3_resolution-standardv2-2x_3ed7fa87-6fa8-4a0c-93e3-531cb42cd42b.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646212346,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen1_resolution-standardv2-2x_3ecc671c-9f84-4fa2-a502-b8734a071270.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen1_resolution-standardv2-2x_3ecc671c-9f84-4fa2-a502-b8734a071270.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271646245114,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-2_resolution-standardv2-2x_46cb648a-d995-499f-a4a3-c0c8139b3a58.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-2_resolution-standardv2-2x_46cb648a-d995-499f-a4a3-c0c8139b3a58.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620653306,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-3_resolution-standardv2-2x_771d6bfd-7822-4e48-9409-28ec2677a8b4.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-3_resolution-standardv2-2x_771d6bfd-7822-4e48-9409-28ec2677a8b4.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620587770,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-2_resolution-standardv2-2x_069c515d-cef2-4a50-9b37-ae39bb1530bd.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-2_resolution-standardv2-2x_069c515d-cef2-4a50-9b37-ae39bb1530bd.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620784378,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-1_resolution-standardv2-2x_d63828c2-908a-4d1d-b8ae-7181ea592cff.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-1_resolution-standardv2-2x_d63828c2-908a-4d1d-b8ae-7181ea592cff.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620686074,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-4_resolution-standardv2-2x_0ddd4eb4-c009-4f56-90d3-bd6f8b5c2d1d.jpg?v=1756196581"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-4_resolution-standardv2-2x_0ddd4eb4-c009-4f56-90d3-bd6f8b5c2d1d.jpg?v=1756196581",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620620538,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ACerulean-3_2__resolution-standardv2-2x_5b92e21b-6eee-45f1-9f64-889f4f8a6429.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-3_2__resolution-standardv2-2x_5b92e21b-6eee-45f1-9f64-889f4f8a6429.jpg?v=1756196582",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620555002,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-2_2__resolution-standardv2-2x_e56ad539-71bc-4036-abc4-c8c576d76110.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-2_2__resolution-standardv2-2x_e56ad539-71bc-4036-abc4-c8c576d76110.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620718842,
				"position": 97,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-5_resolution-standardv2-2x_693bd79d-77f4-4f04-a3fe-6187c07f0916.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-5_resolution-standardv2-2x_693bd79d-77f4-4f04-a3fe-6187c07f0916.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271620751610,
				"position": 98,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACerulean-6_resolution-standardv2-2x_07051759-9134-4206-b428-a587bb9ce5eb.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACerulean-6_resolution-standardv2-2x_07051759-9134-4206-b428-a587bb9ce5eb.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271641657594,
				"position": 99,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/AChocolate-3_resolution-standardv2-2x_cb01f297-9d44-48a7-9b13-fdda6069aac9.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AChocolate-3_resolution-standardv2-2x_cb01f297-9d44-48a7-9b13-fdda6069aac9.jpg?v=1756196582",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271641526522,
				"position": 100,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AChocolate-2_resolution-standardv2-2x_836a9d16-82bd-4e96-bbc9-1f0610b0b748.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AChocolate-2_resolution-standardv2-2x_836a9d16-82bd-4e96-bbc9-1f0610b0b748.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271641231610,
				"position": 101,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AChocolate-1_resolution-standardv2-2x_6f38c86f-b031-4246-a5a9-e41b55564f25.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AChocolate-1_resolution-standardv2-2x_6f38c86f-b031-4246-a5a9-e41b55564f25.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271641690362,
				"position": 102,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AChocolate-4_2__resolution-standardv2-2x_b1da3f2a-22b6-4149-b613-6a00ffa1239a.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AChocolate-4_2__resolution-standardv2-2x_b1da3f2a-22b6-4149-b613-6a00ffa1239a.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271640871162,
				"position": 103,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AChocolate-4_resolution-standardv2-2x_2d2549a2-1927-49d8-8de3-02c4612af085.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AChocolate-4_resolution-standardv2-2x_2d2549a2-1927-49d8-8de3-02c4612af085.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271640936698,
				"position": 104,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AChocolate-5_resolution-standardv2-2x_ec12fa53-8087-4e92-86d1-4c5f6b50b4f4.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AChocolate-5_resolution-standardv2-2x_ec12fa53-8087-4e92-86d1-4c5f6b50b4f4.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271731540218,
				"position": 105,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown_resolution-standardv2-2x_b463043a-1bdd-4d80-bf87-c94e737c682e.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown_resolution-standardv2-2x_b463043a-1bdd-4d80-bf87-c94e737c682e.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271731572986,
				"position": 106,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown-2-2_resolution-standardv2-2x_14624407-27a0-488a-8a73-2a161d5f2526.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown-2-2_resolution-standardv2-2x_14624407-27a0-488a-8a73-2a161d5f2526.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271618064634,
				"position": 107,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACaramel-2_resolution-standardv2-2x_c7361965-bafd-4f12-99da-8bad7d8ae801.jpg?v=1756196582"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACaramel-2_resolution-standardv2-2x_c7361965-bafd-4f12-99da-8bad7d8ae801.jpg?v=1756196582",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271617999098,
				"position": 108,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ACaramel-1_resolution-standardv2-2x_564ebd7d-e742-4d28-9414-8ac2b09495a4.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACaramel-1_resolution-standardv2-2x_564ebd7d-e742-4d28-9414-8ac2b09495a4.jpg?v=1756196583",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271618031866,
				"position": 109,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACaramel-2_2__resolution-standardv2-2x_b09732c0-b8ed-4e39-bca7-c18273a57a2d.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACaramel-2_2__resolution-standardv2-2x_b09732c0-b8ed-4e39-bca7-c18273a57a2d.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271618097402,
				"position": 110,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACaramel-3_2__resolution-standardv2-2x_0f1a33c1-1a05-491f-a299-5a493c718835.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACaramel-3_2__resolution-standardv2-2x_0f1a33c1-1a05-491f-a299-5a493c718835.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271617933562,
				"position": 111,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/Acaramel-5_resolution-standardv2-2x_a75611fd-00c4-477d-8060-013669cdada7.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-5_resolution-standardv2-2x_a75611fd-00c4-477d-8060-013669cdada7.jpg?v=1756196583",
				"width": 1999
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271617966330,
				"position": 112,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Acaramel-6_resolution-standardv2-2x_08d9ade0-d700-46e3-a3b3-5bbb1c8c130b.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Acaramel-6_resolution-standardv2-2x_08d9ade0-d700-46e3-a3b3-5bbb1c8c130b.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638479098,
				"position": 113,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-3_resolution-standardv2-2x_a4b6d8a7-0492-4291-85d2-6dba0bfb5e34.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-3_resolution-standardv2-2x_a4b6d8a7-0492-4291-85d2-6dba0bfb5e34.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638413562,
				"position": 114,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-2_resolution-standardv2-2x_98924b93-1794-4755-ab2e-62848884e5f0.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-2_resolution-standardv2-2x_98924b93-1794-4755-ab2e-62848884e5f0.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638348026,
				"position": 115,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-1_resolution-standardv2-2x_59e50846-835f-4e14-9053-bd885b29ff26.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-1_resolution-standardv2-2x_59e50846-835f-4e14-9053-bd885b29ff26.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638315258,
				"position": 116,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-1_1_-1_resolution-standardv2-2x.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-1_1_-1_resolution-standardv2-2x.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638511866,
				"position": 117,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-4_resolution-standardv2-2x_f672b157-486d-4c3a-8378-e36722d8ba47.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-4_resolution-standardv2-2x_f672b157-486d-4c3a-8378-e36722d8ba47.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638544634,
				"position": 118,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-5_resolution-standardv2-2x_3594452d-c081-4110-99a8-debd6c7e502f.jpg?v=1761284844"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-5_resolution-standardv2-2x_3594452d-c081-4110-99a8-debd6c7e502f.jpg?v=1761284844",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638380794,
				"position": 119,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-1-1_resolution-standardv2-2x_33906062-17aa-4de1-a469-9cb32a2da9ec.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-1-1_resolution-standardv2-2x_33906062-17aa-4de1-a469-9cb32a2da9ec.jpg?v=1756196583",
				"width": 2000
			},
			{
				"alt": "FadeShield Pro™ Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain - TheHues",
				"id": 36271638446330,
				"position": 120,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-2-1_resolution-standardv2-2x_639d195d-7425-4f0f-9023-e2bdb474e3d6.jpg?v=1756196583"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ACharcoal-Grey-2-1_resolution-standardv2-2x_639d195d-7425-4f0f-9023-e2bdb474e3d6.jpg?v=1756196583",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Lightweight outdoor curtains with anti-fading technology, ensuring lasting color and charm for any outdoor setting, from gazebos to balconies.</p>",
		"url": "/products/fadeshield-pro-fade-resistant-waterproof-lightweight-custom-outdoor-curtain",
		"regular_price": "$109.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	},
	{
		"id": 8780116754682,
		"title": "Wengen Linen & Cotton Blend Airy Sheer Custom Curtain",
		"handle": "wengen-linen-cotton-blend-airy-sheer-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 80% Cotton &amp; 20% Linen<br>Features: Sheer<br>Weight: Sheer (133g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Crafted from a cotton-linen blend, Wengen sheer curtains offer a soft, light-diffusing drape. Custom sizes and versatile headers make them a perfect fit for any space, effortlessly pairing with other styles.</p>",
		"published_at": "2025-05-07T16:27:47+08:00",
		"created_at": "2025-05-07T16:27:47+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"Black Friday",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Easter Sale",
			"Fall Collection",
			"fall sale",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"sale top 10",
			"Search cotton",
			"Search curtains",
			"Search sheer",
			"Summer Collection"
		],
		"price": 12500,
		"price_min": 12500,
		"price_max": 12500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319396516090,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-84-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44016570171642,
					"product_id": 8780116754682,
					"position": 1,
					"created_at": "2025-05-20T14:45:12+08:00",
					"updated_at": "2025-08-26T16:32:29+08:00",
					"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7-2_1__resolution-standardv2-2x.jpg?v=1756197149",
					"variant_ids": [
						47319396516090
					]
				},
				"available": true,
				"name": "Wengen Linen & Cotton Blend Airy Sheer Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Curtain - TheHues",
					"id": 36058958364922,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7-2_1__resolution-standardv2-2x.jpg?v=1756197149"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC01200_copy1_1024x1024.jpg?v=1754036557"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250515-Awhite-7-2_1__resolution-standardv2-2x.jpg?v=1756197149",
			"//thehues.com/cdn/shop/files/DSC01215_copy1.jpg?v=1756279883",
			"//thehues.com/cdn/shop/files/DSC01161_copy1.jpg?v=1756279883",
			"//thehues.com/cdn/shop/files/20250515-Awhite-3-2_3__resolution-standardv2-2x.jpg?v=1756279883",
			"//thehues.com/cdn/shop/files/white-wengen.jpg?v=1756279883",
			"//thehues.com/cdn/shop/files/DSC01189_copy1.jpg?v=1756279883",
			"//thehues.com/cdn/shop/files/DSC01191_copy1.jpg?v=1756279883"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250515-Awhite-7-2_1__resolution-standardv2-2x_1024x1024.jpg?v=1756197149",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Curtain - TheHues",
				"id": 36058958364922,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7-2_1__resolution-standardv2-2x.jpg?v=1756197149"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-7-2_1__resolution-standardv2-2x.jpg?v=1756197149",
				"width": 2000
			},
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Cafe Curtain - TheHues",
				"id": 36464458727674,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC01215_copy1.jpg?v=1756279883"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC01215_copy1.jpg?v=1756279883",
				"width": 2000
			},
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Cafe Curtain - TheHues",
				"id": 36464458793210,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC01161_copy1.jpg?v=1756279883"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC01161_copy1.jpg?v=1756279883",
				"width": 2000
			},
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Cafe Curtain - TheHues",
				"id": 36058958299386,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Awhite-3-2_3__resolution-standardv2-2x.jpg?v=1756279883"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Awhite-3-2_3__resolution-standardv2-2x.jpg?v=1756279883",
				"width": 2000
			},
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Cafe Curtain - TheHues",
				"id": 36135117390074,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/white-wengen.jpg?v=1756279883"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/white-wengen.jpg?v=1756279883",
				"width": 2000
			},
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Cafe Curtain - TheHues",
				"id": 36464458694906,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC01189_copy1.jpg?v=1756279883"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC01189_copy1.jpg?v=1756279883",
				"width": 2000
			},
			{
				"alt": "Wengen Linen & Cotton Blend Airy Sheer Custom Cafe Curtain - TheHues",
				"id": 36464458760442,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC01191_copy1.jpg?v=1756279883"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC01191_copy1.jpg?v=1756279883",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Crafted from a cotton-linen blend, Wengen sheer curtains offer a soft, light-diffusing drape. Custom sizes and versatile headers make them a perfect fit for any space, effortlessly pairing with other styles.</p>",
		"url": "/products/wengen-linen-cotton-blend-airy-sheer-custom-curtain",
		"regular_price": "$125.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/cotton-curtains",
				"title": "Cotton Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8780117901562,
		"title": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain",
		"handle": "noah-linen-look-lightweight-waterproof-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 15% Linen &amp; 85% Polyester<br>Weight: 150 g/m²<br>Features: Waterproof &amp; UV protection</p><p>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>With a flowing, airy presence and a linen-like texture, these curtains bring effortless beauty to any outdoor setting.</p>",
		"published_at": "2025-05-07T16:28:33+08:00",
		"created_at": "2025-05-07T16:28:33+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"Bestseller",
			"Black Friday",
			"CHANGEHOVER",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Outdoor Sheer Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"Cyber Monday",
			"Easter Sale",
			"Factory products",
			"Fall Collection",
			"flash_categories",
			"New Content",
			"Sale",
			"Sale > All Curtain Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Summer",
			"Summer Collection",
			"Summer Outdoor Decor"
		],
		"price": 11800,
		"price_min": 11800,
		"price_max": 11800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319418732794,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THOC-38-OD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44016225485050,
					"product_id": 8780117901562,
					"position": 1,
					"created_at": "2025-05-20T13:53:53+08:00",
					"updated_at": "2025-08-26T16:31:36+08:00",
					"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250515-Aframe-2263_resolution-standardv2-2x.jpg?v=1756197096",
					"variant_ids": [
						47319418732794
					]
				},
				"available": true,
				"name": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 11800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36058772078842,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250515-Aframe-2263_resolution-standardv2-2x.jpg?v=1756197096"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250515-A3-9-1_7__resolution-standardv2-2x_1024x1024.jpg?v=1761203528"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250515-Aframe-2263_resolution-standardv2-2x.jpg?v=1756197096",
			"//thehues.com/cdn/shop/files/20250515-A3-8-1_6__resolution-standardv2-2x.jpg?v=1756197096",
			"//thehues.com/cdn/shop/files/20250515-A3-2-3_1_copy_resolution-standardv2-2x.jpg?v=1756197096",
			"//thehues.com/cdn/shop/files/20250515-A3-1-3_8_copy_resolution-standardv2-2x.jpg?v=1756197096",
			"//thehues.com/cdn/shop/files/noah-outdoor.jpg?v=1756197096",
			"//thehues.com/cdn/shop/files/20250515-A3-5-2_4_copy_resolution-standardv2-2x.jpg?v=1756197096",
			"//thehues.com/cdn/shop/files/20250515-A3-6-2_5_copy_resolution-standardv2-2x.jpg?v=1756197097",
			"//thehues.com/cdn/shop/files/20250515-A3-9-1_7__resolution-standardv2-2x.jpg?v=1761203528",
			"//thehues.com/cdn/shop/files/20250515-Anoah_resolution-standardv2-2x.jpg?v=1756197097"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250515-Aframe-2263_resolution-standardv2-2x_1024x1024.jpg?v=1756197096",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058772078842,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Aframe-2263_resolution-standardv2-2x.jpg?v=1756197096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Aframe-2263_resolution-standardv2-2x.jpg?v=1756197096",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058772013306,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-A3-8-1_6__resolution-standardv2-2x.jpg?v=1756197096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-A3-8-1_6__resolution-standardv2-2x.jpg?v=1756197096",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058772209914,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-A3-2-3_1_copy_resolution-standardv2-2x.jpg?v=1756197096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-A3-2-3_1_copy_resolution-standardv2-2x.jpg?v=1756197096",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058772177146,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-A3-1-3_8_copy_resolution-standardv2-2x.jpg?v=1756197096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-A3-1-3_8_copy_resolution-standardv2-2x.jpg?v=1756197096",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36396568150266,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.94,
					"height": 3378,
					"width": 3175,
					"src": "//thehues.com/cdn/shop/files/noah-outdoor.jpg?v=1756197096"
				},
				"aspect_ratio": 0.94,
				"height": 3378,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/noah-outdoor.jpg?v=1756197096",
				"width": 3175
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058771947770,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-A3-5-2_4_copy_resolution-standardv2-2x.jpg?v=1756197096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-A3-5-2_4_copy_resolution-standardv2-2x.jpg?v=1756197096",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058771980538,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-A3-6-2_5_copy_resolution-standardv2-2x.jpg?v=1756197097"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-A3-6-2_5_copy_resolution-standardv2-2x.jpg?v=1756197097",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058772046074,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-A3-9-1_7__resolution-standardv2-2x.jpg?v=1761203528"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-A3-9-1_7__resolution-standardv2-2x.jpg?v=1761203528",
				"width": 2000
			},
			{
				"alt": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36058772111610,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250515-Anoah_resolution-standardv2-2x.jpg?v=1756197097"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250515-Anoah_resolution-standardv2-2x.jpg?v=1756197097",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36106653171962,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1920,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/054d082ca5fe499cac9be3fda600780a.thumbnail.0000000000.jpg?v=1748511427"
				},
				"aspect_ratio": 0.563,
				"duration": 17300,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/054d082ca5fe499cac9be3fda600780a/054d082ca5fe499cac9be3fda600780a.SD-480p-0.9Mbps-48443319.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/054d082ca5fe499cac9be3fda600780a/054d082ca5fe499cac9be3fda600780a.HD-1080p-2.5Mbps-48443319.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/054d082ca5fe499cac9be3fda600780a/054d082ca5fe499cac9be3fda600780a.HD-720p-1.6Mbps-48443319.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/054d082ca5fe499cac9be3fda600780a/054d082ca5fe499cac9be3fda600780a.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With a flowing, airy presence and a linen-like texture, these curtains bring effortless beauty to any outdoor setting.</p>",
		"url": "/products/noah-linen-look-lightweight-waterproof-custom-outdoor-curtain",
		"regular_price": "$118.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/frontpage",
				"title": "Home page"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/outdoor-sheer-curtains",
				"title": "Outdoor Sheer Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8780116623610,
		"title": "Nara Linen & Cotton Blend Lightweight Custom Curtain",
		"handle": "nara-linen-cotton-blend-lightweight-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 15% Linen &amp; 85% Polyester<br>Weight: 150 g/m²<br>Features: Waterproof &amp; UV protection</p><p>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Nara lightweight curtains drape with effortless grace, their subtle texture catching the light and creating a soft, ethereal glow. With each fold, they transform the space, allowing natural light to filter through and infuse the room with a tranquil, serene elegance.</p>",
		"published_at": "2025-05-07T16:27:43+08:00",
		"created_at": "2025-05-07T16:27:43+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Black Friday",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search cotton",
			"Search curtains",
			"Search linen"
		],
		"price": 11200,
		"price_min": 11200,
		"price_max": 11200,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319420371194,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-72-SD-Ivory",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037072158970,
					"product_id": 8780116623610,
					"position": 12,
					"created_at": "2025-05-22T17:26:12+08:00",
					"updated_at": "2025-08-26T16:32:36+08:00",
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-Alinen-55-1_resolution-standardv2-2x.jpg?v=1756197156",
					"variant_ids": [
						47319420371194
					]
				},
				"available": true,
				"name": "Nara Linen & Cotton Blend Lightweight Custom Curtain - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"id": 36071343718650,
					"position": 12,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-Alinen-55-1_resolution-standardv2-2x.jpg?v=1756197156"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x-2_1024x1024.jpg?v=1756197157"
			},
			{
				"id": 47319420403962,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-72-SD-Natural",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037075304698,
					"product_id": 8780116623610,
					"position": 14,
					"created_at": "2025-05-22T17:26:22+08:00",
					"updated_at": "2025-08-26T16:32:36+08:00",
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-A1-1_resolution-standardv2-2x.jpg?v=1756197156",
					"variant_ids": [
						47319420403962
					]
				},
				"available": true,
				"name": "Nara Linen & Cotton Blend Lightweight Custom Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"id": 36071344701690,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-A1-1_resolution-standardv2-2x.jpg?v=1756197156"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Anaralinencotton_natural_1024x1024.png?v=1751350069"
			},
			{
				"id": 47319420436730,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-72-SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037078450426,
					"product_id": 8780116623610,
					"position": 6,
					"created_at": "2025-05-22T17:26:29+08:00",
					"updated_at": "2025-08-26T16:32:36+08:00",
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x.jpg?v=1756197156",
					"variant_ids": [
						47319420436730
					]
				},
				"available": true,
				"name": "Nara Linen & Cotton Blend Lightweight Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"id": 36071346503930,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x.jpg?v=1756197156"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x-2_1024x1024.jpg?v=1756197156"
			},
			{
				"id": 47319420469498,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-72-SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037071503610,
					"product_id": 8780116623610,
					"position": 4,
					"created_at": "2025-05-22T17:26:07+08:00",
					"updated_at": "2025-08-26T16:32:35+08:00",
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20250516-ABeige-1-4_resolution-standardv2-2x.jpg?v=1756197155",
					"variant_ids": [
						47319420469498
					]
				},
				"available": true,
				"name": "Nara Linen & Cotton Blend Lightweight Custom Curtain - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 11200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
					"id": 36071342964986,
					"position": 4,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/20250516-ABeige-1-4_resolution-standardv2-2x.jpg?v=1756197155"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/20250516-ABeige-3-2_resolution-standardv2-2x_1024x1024.jpg?v=1756197155"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20250516-ABeige-3-4_resolution-standardv2-2x.jpg?v=1756197155",
			"//thehues.com/cdn/shop/files/20250516-ABeige-2-2_resolution-standardv2-2x.jpg?v=1756197155",
			"//thehues.com/cdn/shop/files/20250516-ABeige-3-2_resolution-standardv2-2x.jpg?v=1756197155",
			"//thehues.com/cdn/shop/files/20250516-ABeige-1-4_resolution-standardv2-2x.jpg?v=1756197155",
			"//thehues.com/cdn/shop/files/20250516-ABeige-2-4_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A2-2_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x-2.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A2-2_resolution-standardv2-2x-2.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x-2.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-Alinen-55-1_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-AHoneyview_1112-2_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A1-1_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20250516-A1-2_resolution-standardv2-2x.jpg?v=1756197156",
			"//thehues.com/cdn/shop/files/20240927-A1-1_resolution-standardv2-2x-2.jpg?v=1756197157",
			"//thehues.com/cdn/shop/files/20250516-A1-2_resolution-standardv2-2x-2.jpg?v=1756197157",
			"//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x-2.jpg?v=1756197157"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20250516-ABeige-3-4_resolution-standardv2-2x_1024x1024.jpg?v=1756197155",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071342932218,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABeige-3-4_resolution-standardv2-2x.jpg?v=1756197155"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABeige-3-4_resolution-standardv2-2x.jpg?v=1756197155",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071343063290,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABeige-2-2_resolution-standardv2-2x.jpg?v=1756197155"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABeige-2-2_resolution-standardv2-2x.jpg?v=1756197155",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071342866682,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABeige-3-2_resolution-standardv2-2x.jpg?v=1756197155"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABeige-3-2_resolution-standardv2-2x.jpg?v=1756197155",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071342964986,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABeige-1-4_resolution-standardv2-2x.jpg?v=1756197155"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABeige-1-4_resolution-standardv2-2x.jpg?v=1756197155",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071342833914,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-ABeige-2-4_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ABeige-2-4_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071346503930,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071346372858,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071346274554,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-2_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-2_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071346241786,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x-2.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-1_resolution-standardv2-2x-2.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071346307322,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-2_resolution-standardv2-2x-2.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-2_resolution-standardv2-2x-2.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071346438394,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x-2.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A2-3_resolution-standardv2-2x-2.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071343718650,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Alinen-55-1_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Alinen-55-1_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071343685882,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-AHoneyview_1112-2_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AHoneyview_1112-2_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071344701690,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A1-1_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A1-1_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071344799994,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071344734458,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A1-2_resolution-standardv2-2x.jpg?v=1756197156"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A1-2_resolution-standardv2-2x.jpg?v=1756197156",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071344865530,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20240927-A1-1_resolution-standardv2-2x-2.jpg?v=1756197157"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240927-A1-1_resolution-standardv2-2x-2.jpg?v=1756197157",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071344767226,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A1-2_resolution-standardv2-2x-2.jpg?v=1756197157"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A1-2_resolution-standardv2-2x-2.jpg?v=1756197157",
				"width": 2000
			},
			{
				"alt": "Nara Linen & Cotton Blend Lightweight Custom Curtain - TheHues",
				"id": 36071344832762,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x-2.jpg?v=1756197157"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-A1-3_resolution-standardv2-2x-2.jpg?v=1756197157",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Nara lightweight curtains drape with effortless grace, their subtle texture catching the light and creating a soft, ethereal glow. With each fold, they transform the space, allowing natural light to filter through and infuse the room with a tranquil, serene elegance.</p>",
		"url": "/products/nara-linen-cotton-blend-lightweight-custom-curtain",
		"regular_price": "$112.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/cotton-curtains",
				"title": "Cotton Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8780116361466,
		"title": "Frisian Custom Flame Retardant Curtain",
		"handle": "frisian-custom-flame-retardant-curtain",
		"product_details": `<h3>Specifications</h3><p>Materia: 100% Polyester<br>Features: Flame Retardant<br>Weight: Light Weight (220g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Flame-retardant curtains offering peace of mind without compromising on design, keeping your space safe and stylish.</p>",
		"published_at": "2025-05-07T16:27:32+08:00",
		"created_at": "2025-05-07T16:27:32+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Flame Retardant Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Cyber Monday",
			"Factory products",
			"Fall Collection",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"Search curtains",
			"Search Pinch pleat",
			"Spring Time Sale"
		],
		"price": 11900,
		"price_min": 11900,
		"price_max": 11900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319448158458,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-1-FR-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996623307002,
					"product_id": 8780116361466,
					"position": 1,
					"created_at": "2025-05-17T17:24:26+08:00",
					"updated_at": "2025-09-01T14:04:32+08:00",
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame1_resolution-standardv2-2x.jpg?v=1756706672",
					"variant_ids": [
						47319448158458
					]
				},
				"available": true,
				"name": "Frisian Custom Flame Retardant Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"id": 36046493647098,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame1_resolution-standardv2-2x.jpg?v=1756706672"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ablack-10_5__resolution-standardv2-2x_1024x1024.jpg?v=1756706735"
			},
			{
				"id": 47319448191226,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THC-1-FR-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996640903418,
					"product_id": 8780116361466,
					"position": 6,
					"created_at": "2025-05-17T17:25:47+08:00",
					"updated_at": "2025-09-01T14:04:32+08:00",
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x.jpg?v=1756706672",
					"variant_ids": [
						47319448191226
					]
				},
				"available": true,
				"name": "Frisian Custom Flame Retardant Curtain - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"id": 36046504657146,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x.jpg?v=1756706672"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Ared-7_4__resolution-standard_v2-2x_1024x1024.jpg?v=1756706672"
			},
			{
				"id": 47319448223994,
				"title": "Dark Blue",
				"option1": "Dark Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-1-FR-Dark Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996633825530,
					"product_id": 8780116361466,
					"position": 11,
					"created_at": "2025-05-17T17:25:27+08:00",
					"updated_at": "2025-09-01T14:04:32+08:00",
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x.jpg?v=1756706672",
					"variant_ids": [
						47319448223994
					]
				},
				"available": true,
				"name": "Frisian Custom Flame Retardant Curtain - Dark Blue",
				"public_title": "Dark Blue",
				"options": [
					"Dark Blue"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"id": 36046500299002,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x.jpg?v=1756706672"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Adarkblue_4__resolution-standard_v2-2x_1024x1024.jpg?v=1756706672"
			},
			{
				"id": 47319448256762,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-1-FR-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996639166714,
					"product_id": 8780116361466,
					"position": 16,
					"created_at": "2025-05-17T17:25:42+08:00",
					"updated_at": "2025-09-01T14:04:32+08:00",
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x.jpg?v=1756706672",
					"variant_ids": [
						47319448256762
					]
				},
				"available": true,
				"name": "Frisian Custom Flame Retardant Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"id": 36046503510266,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x.jpg?v=1756706672"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Agrey-6_4__resolution-standard_v2-2x_1024x1024.jpg?v=1756706672"
			},
			{
				"id": 47319448289530,
				"title": "Greyish White",
				"option1": "Greyish White",
				"option2": null,
				"option3": null,
				"sku": "THC-1-FR-Greyish White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 43996640936186,
					"product_id": 8780116361466,
					"position": 21,
					"created_at": "2025-05-17T17:25:48+08:00",
					"updated_at": "2025-09-01T14:04:32+08:00",
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x.jpg?v=1756706672",
					"variant_ids": [
						47319448289530
					]
				},
				"available": true,
				"name": "Frisian Custom Flame Retardant Curtain - Greyish White",
				"public_title": "Greyish White",
				"options": [
					"Greyish White"
				],
				"price": 11900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
					"id": 36046504689914,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x.jpg?v=1756706672"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/AFrame1_resolution-standardv2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-black.jpg?v=1761198582",
			"//thehues.com/cdn/shop/files/Ablack-2-2_3__resolution-standardv2-2x.jpg?v=1756706735",
			"//thehues.com/cdn/shop/files/Ablack-1-1_4__resolution-standardv2-2x.jpg?v=1756706735",
			"//thehues.com/cdn/shop/files/Ablack-10_5__resolution-standardv2-2x.jpg?v=1756706735",
			"//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Ared-2-1_2__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Ared-1-6_3__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Ared-7_4__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-red.jpg?v=1761198582",
			"//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Adark-blue-2_2__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Adarkblue-1_3__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Adarkblue_4__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-darkblue.jpg?v=1761198582",
			"//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Agrey-2-3_2__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Agrey-1-3_3__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Agrey-6_4__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-grey.jpg?v=1761198582",
			"//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Awhite-1-2_3__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Awhite-3_4__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Awhite-3-2_5__resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-greyishwhite.jpg?v=1761198582",
			"//thehues.com/cdn/shop/files/Ablack-9_resolution-standardv2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Adark-blue_resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Agrey-5_resolution-standard_v2-2x_1fe1ec24-daa5-4e80-a69d-ac0cdee99244.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Agreyishwhite_resolution-standard_v2-2x.jpg?v=1756706672",
			"//thehues.com/cdn/shop/files/Ared-6_resolution-standard_v2-2x.jpg?v=1756706672"
		],
		"featured_image": "//thehues.com/cdn/shop/files/AFrame1_resolution-standardv2-2x_1024x1024.jpg?v=1756706672",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046493647098,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame1_resolution-standardv2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame1_resolution-standardv2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36700243525882,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 3990,
					"width": 2660,
					"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-black.jpg?v=1761198582"
				},
				"aspect_ratio": 0.667,
				"height": 3990,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-black.jpg?v=1761198582",
				"width": 2660
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046493548794,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-2-2_3__resolution-standardv2-2x.jpg?v=1756706735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-2-2_3__resolution-standardv2-2x.jpg?v=1756706735",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046493516026,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-1-1_4__resolution-standardv2-2x.jpg?v=1756706735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-1-1_4__resolution-standardv2-2x.jpg?v=1756706735",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046493614330,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-10_5__resolution-standardv2-2x.jpg?v=1756706735"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-10_5__resolution-standardv2-2x.jpg?v=1756706735",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504657146,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_5_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504296698,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-2-1_2__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-2-1_2__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504263930,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-1-6_3__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-1-6_3__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504591610,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-7_4__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-7_4__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36700243493114,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-red.jpg?v=1761198582"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-red.jpg?v=1761198582",
				"width": 1365
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046500299002,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_2_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046499283194,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-blue-2_2__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-blue-2_2__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046499315962,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adarkblue-1_3__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adarkblue-1_3__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046499709178,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adarkblue_4__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adarkblue_4__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36700243460346,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-darkblue.jpg?v=1761198582"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-darkblue.jpg?v=1761198582",
				"width": 1365
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046503510266,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_3_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046502428922,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-2-3_2__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-2-3_2__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046502985978,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-1-3_3__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-1-3_3__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504624378,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-6_4__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-6_4__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36700243427578,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 2048,
					"width": 1365,
					"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-grey.jpg?v=1761198582"
				},
				"aspect_ratio": 0.667,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-grey.jpg?v=1761198582",
				"width": 1365
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504689914,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AFrame_4_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504558842,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-1-2_3__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-1-2_3__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046503149818,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-3_4__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-3_4__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046504722682,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Awhite-3-2_5__resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Awhite-3-2_5__resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36700243558650,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 3990,
					"width": 2660,
					"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-greyishwhite.jpg?v=1761198582"
				},
				"aspect_ratio": 0.667,
				"height": 3990,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/frisian-custom-flame-retardant-curtain-greyishwhite.jpg?v=1761198582",
				"width": 2660
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046493581562,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ablack-9_resolution-standardv2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ablack-9_resolution-standardv2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046497972474,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Adark-blue_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Adark-blue_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046499741946,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agrey-5_resolution-standard_v2-2x_1fe1ec24-daa5-4e80-a69d-ac0cdee99244.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agrey-5_resolution-standard_v2-2x_1fe1ec24-daa5-4e80-a69d-ac0cdee99244.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046502789370,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Agreyishwhite_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Agreyishwhite_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			},
			{
				"alt": "Frisian Custom Flame Retardant Curtain - TheHues",
				"id": 36046502691066,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Ared-6_resolution-standard_v2-2x.jpg?v=1756706672"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Ared-6_resolution-standard_v2-2x.jpg?v=1756706672",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Flame-retardant curtains offering peace of mind without compromising on design, keeping your space safe and stylish.</p>",
		"url": "/products/frisian-custom-flame-retardant-curtain",
		"regular_price": "$119.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8864677298426,
		"title": "Milano Flat Fold Linen Blend Striped Custom Roman Shade",
		"handle": "milo-flat-fold-linen-blend-striped-custom-roman-shade",
		"product_details": `<h3>Specifications</h3><p>Material: 15% Linen &amp; 85% Polyester<br>Features: Light filtering<br>Weight: Regular (482g/㎡)<br>Softness: Soft</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Striped Roman shade in durable linen blend with crisp flat folds, custom-made to your window¡¯s exact measurements. Mount on the wall or ceiling, with a complete installation kit included. Upgrade to blackout lining for total light control or motorized operation for effortless elegance.</p>",
		"published_at": "2025-07-25T17:38:30+08:00",
		"created_at": "2025-07-21T17:29:38+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains > striped custom curtains",
			"fall sale",
			"Halloween",
			"july sale",
			"New Arrival",
			"New Arrivals",
			"Roman Shade",
			"sale top 10",
			"summer best seller",
			"Thanksgiving sale"
		],
		"price": 24200,
		"price_min": 24200,
		"price_max": 24200,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47529489400058,
				"title": "Blueberry",
				"option1": "Blueberry",
				"option2": null,
				"option3": null,
				"sku": "THRS-YKB-WuJi-10-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44596334395642,
					"product_id": 8864677298426,
					"position": 1,
					"created_at": "2025-07-25T18:20:07+08:00",
					"updated_at": "2025-09-19T17:32:21+08:00",
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/d0b3eb357b7eccbce4dd83d2b27951ea.jpg?v=1758274341",
					"variant_ids": [
						47529489400058
					]
				},
				"available": true,
				"name": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - Blueberry",
				"public_title": "Blueberry",
				"options": [
					"Blueberry"
				],
				"price": 24200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"id": 36429903102202,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/d0b3eb357b7eccbce4dd83d2b27951ea.jpg?v=1758274341"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/wuji_BLACK_1024x1024.jpg?v=1753840464"
			},
			{
				"id": 47529531080954,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THRS-YKB-WuJi-6-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 45112710234362,
					"product_id": 8864677298426,
					"position": 3,
					"created_at": "2025-09-18T10:40:49+08:00",
					"updated_at": "2025-09-19T17:32:21+08:00",
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"width": 896,
					"height": 1152,
					"src": "//thehues.com/cdn/shop/files/milo-linen-blend-striped-custom-cafe-curtain-halloween-1.png?v=1758274341",
					"variant_ids": [
						47529531080954
					]
				},
				"available": true,
				"name": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 24200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"id": 36833384726778,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.778,
						"height": 1152,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/milo-linen-blend-striped-custom-cafe-curtain-halloween-1.png?v=1758274341"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/wuji_SAND_1024x1024.jpg?v=1753840469"
			},
			{
				"id": 47529531113722,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THRS-YKB-WuJi-7-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44587106599162,
					"product_id": 8864677298426,
					"position": 9,
					"created_at": "2025-07-24T12:01:20+08:00",
					"updated_at": "2025-09-19T17:32:21+08:00",
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_BROWN3.jpg?v=1758274341",
					"variant_ids": [
						47529531113722
					]
				},
				"available": true,
				"name": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 24200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"id": 36424720875770,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_BROWN3.jpg?v=1758274341"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/wuji_BROWN_1024x1024.jpg?v=1753840469"
			},
			{
				"id": 47529531146490,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THRS-YKB-WuJi-8-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44587107352826,
					"product_id": 8864677298426,
					"position": 14,
					"created_at": "2025-07-24T12:01:36+08:00",
					"updated_at": "2025-09-19T17:32:21+08:00",
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_GREEN3.jpg?v=1758274341",
					"variant_ids": [
						47529531146490
					]
				},
				"available": true,
				"name": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 24200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"id": 36424721629434,
					"position": 14,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_GREEN3.jpg?v=1758274341"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/wuji_GREEN_1024x1024.jpg?v=1753840469"
			},
			{
				"id": 47529531179258,
				"title": "Gray",
				"option1": "Gray",
				"option2": null,
				"option3": null,
				"sku": "THRS-YKB-WuJi-9-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44587106828538,
					"product_id": 8864677298426,
					"position": 19,
					"created_at": "2025-07-24T12:01:30+08:00",
					"updated_at": "2025-09-19T17:32:21+08:00",
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/wuji_GRAY3.jpg?v=1758274341",
					"variant_ids": [
						47529531179258
					]
				},
				"available": true,
				"name": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - Gray",
				"public_title": "Gray",
				"options": [
					"Gray"
				],
				"price": 24200,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
					"id": 36424721105146,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/wuji_GRAY3.jpg?v=1758274341"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/wuji_GRAY_1024x1024.jpg?v=1753840469"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/d0b3eb357b7eccbce4dd83d2b27951ea.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BLACK5_copy.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/milo-linen-blend-striped-custom-cafe-curtain-halloween-1.png?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_SAND5.jpg?v=1758274351",
			"//thehues.com/cdn/shop/files/wuji_SAND3.jpg?v=1758274351",
			"//thehues.com/cdn/shop/files/wuji_SAND1.jpg?v=1758274351",
			"//thehues.com/cdn/shop/files/wuji_SAND6.jpg?v=1758274351",
			"//thehues.com/cdn/shop/files/wuji_SAND2.jpg?v=1758274351",
			"//thehues.com/cdn/shop/files/wuji_BROWN3.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BROWN1.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BROWN6.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BROWN2.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BROWN5.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GREEN3.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GREEN1.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GREEN6.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GREEN2.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GREEN5.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GRAY3.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GRAY1.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GRAY6.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GRAY2.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_GRAY5.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BLACK1_copy.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BLACK6_copy.jpg?v=1758274341",
			"//thehues.com/cdn/shop/files/wuji_BLACK2_copy.jpg?v=1758274341"
		],
		"featured_image": "//thehues.com/cdn/shop/files/d0b3eb357b7eccbce4dd83d2b27951ea_1024x1024.jpg?v=1758274341",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36429903102202,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/d0b3eb357b7eccbce4dd83d2b27951ea.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/d0b3eb357b7eccbce4dd83d2b27951ea.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36429903003898,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BLACK5_copy.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BLACK5_copy.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36833384726778,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.778,
					"height": 1152,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/milo-linen-blend-striped-custom-cafe-curtain-halloween-1.png?v=1758274341"
				},
				"aspect_ratio": 0.778,
				"height": 1152,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/milo-linen-blend-striped-custom-cafe-curtain-halloween-1.png?v=1758274341",
				"width": 896
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722186490,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_SAND5.jpg?v=1758274351"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_SAND5.jpg?v=1758274351",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722383098,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_SAND3.jpg?v=1758274351"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_SAND3.jpg?v=1758274351",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722415866,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_SAND1.jpg?v=1758274351"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_SAND1.jpg?v=1758274351",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722481402,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_SAND6.jpg?v=1758274351"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_SAND6.jpg?v=1758274351",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722317562,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_SAND2.jpg?v=1758274351"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_SAND2.jpg?v=1758274351",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424720875770,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BROWN3.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BROWN3.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424720908538,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BROWN1.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BROWN1.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722284794,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BROWN6.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BROWN6.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424720941306,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BROWN2.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BROWN2.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424720843002,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BROWN5.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BROWN5.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424721629434,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GREEN3.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GREEN3.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722219258,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GREEN1.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GREEN1.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722448634,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GREEN6.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GREEN6.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722252026,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GREEN2.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GREEN2.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722153722,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GREEN5.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GREEN5.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424721105146,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GRAY3.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GRAY3.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424721137914,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GRAY1.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GRAY1.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424722350330,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GRAY6.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GRAY6.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424721072378,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GRAY2.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GRAY2.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36424721039610,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_GRAY5.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_GRAY5.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36429903495418,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BLACK1_copy.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BLACK1_copy.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36429903528186,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BLACK6_copy.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BLACK6_copy.jpg?v=1758274341",
				"width": 2000
			},
			{
				"alt": "Milano Flat Fold Linen Blend Striped Custom Roman Shade - TheHues",
				"id": 36429903298810,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/wuji_BLACK2_copy.jpg?v=1758274341"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/wuji_BLACK2_copy.jpg?v=1758274341",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Striped Roman shade in durable linen blend with crisp flat folds, custom-made to your window¡¯s exact measurements. Mount on the wall or ceiling, with a complete installation kit included. Upgrade to blackout lining for total light control or motorized operation for effortless elegance.</p>",
		"url": "/products/milo-flat-fold-linen-blend-striped-custom-roman-shade",
		"regular_price": "$242.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/roman-shade",
				"title": "Roman Shades"
			},
			{
				"url": "/collections/striped-curtain",
				"title": "Striped Curtain"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8794305790202,
		"title": "Hana Bamboo Woven Shade - Tan",
		"handle": "hana-bamboo-woven-shade-tan",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Bamboo<br>Features: Room Darkening<br>Weight: Heavyweight (1070g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Slender bamboo ribbons weave sunlight into geometry, casting rooms in the quiet choreography of shadow and grace.</p>",
		"published_at": "2025-05-28T15:49:29+08:00",
		"created_at": "2025-05-28T14:05:42+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Bestseller",
			"fall sale",
			"Indoor Woven Shade",
			"july sale",
			"No-drill",
			"Thanksgiving sale",
			"Woven shade"
		],
		"price": 12900,
		"price_min": 12900,
		"price_max": 12900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 18900,
		"compare_at_price_min": 18900,
		"compare_at_price_max": 18900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347576602874,
				"title": "Tan",
				"option1": "Tan",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW301-03-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077733970170,
					"product_id": 8794305790202,
					"position": 1,
					"created_at": "2025-05-28T14:16:35+08:00",
					"updated_at": "2025-08-26T16:21:50+08:00",
					"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW301_3_03.jpg?v=1756196510",
					"variant_ids": [
						47347576602874
					]
				},
				"available": true,
				"name": "Hana Bamboo Woven Shade - Tan - Tan",
				"public_title": "Tan",
				"options": [
					"Tan"
				],
				"price": 12900,
				"weight": 0,
				"compare_at_price": 18900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
					"id": 36099003515130,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW301_3_03.jpg?v=1756196510"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC04122_-62_1024x1024.jpg?v=1756196510"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW301_3_03.jpg?v=1756196510",
			"//thehues.com/cdn/shop/files/DSC04120_-60.jpg?v=1756196510",
			"//thehues.com/cdn/shop/files/SW301_1_3.jpg?v=1756196510",
			"//thehues.com/cdn/shop/files/SW301_2_03.jpg?v=1756196510",
			"//thehues.com/cdn/shop/files/DSC04122_-62.jpg?v=1756196510",
			"//thehues.com/cdn/shop/files/DSC04139_-64.jpg?v=1756196511",
			"//thehues.com/cdn/shop/files/DSC04118_-58.jpg?v=1756196511"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW301_3_03_1024x1024.jpg?v=1756196510",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
				"id": 36099003515130,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_3_03.jpg?v=1756196510"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_3_03.jpg?v=1756196510",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
				"id": 36099518923002,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04120_-60.jpg?v=1756196510"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04120_-60.jpg?v=1756196510",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Woven Shade - Tan - TheHues",
				"id": 36099003449594,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_1_3.jpg?v=1756196510"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_1_3.jpg?v=1756196510",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Woven Shade - Tan - TheHues",
				"id": 36099003482362,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_2_03.jpg?v=1756196510"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_2_03.jpg?v=1756196510",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
				"id": 36099518824698,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04122_-62.jpg?v=1756196510"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04122_-62.jpg?v=1756196510",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
				"id": 36099518857466,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04139_-64.jpg?v=1756196511"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04139_-64.jpg?v=1756196511",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Tan - TheHues",
				"id": 36099518890234,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04118_-58.jpg?v=1756196511"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04118_-58.jpg?v=1756196511",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Slender bamboo ribbons weave sunlight into geometry, casting rooms in the quiet choreography of shadow and grace.</p>",
		"url": "/products/hana-bamboo-woven-shade-tan",
		"regular_price": "$129.00",
		"sale_price": "$189.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8785117610234,
		"title": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail",
		"handle": "uvshield-waterproof-quadrati-custom-rectangle-sun-shade-sail",
		"product_details": ``,
		"description": "<p>Stay cool and protected with our custom waterproof Rectangle Sun Shade Sail for outdoor patios. Enjoy shade and comfort in style.</p>",
		"published_at": "2025-05-13T14:29:22+08:00",
		"created_at": "2025-05-13T14:29:22+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Bestsellers",
			"Bestseller",
			"Black Friday",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"Custom Outdoor Curtains & Sun Shade Sails Collection > Sun Shade Sail",
			"Custom Outdoor Curtains & Sun Shade Sails Collection > Sun Shade Sail > UVShield? Sun Shades",
			"Custom Outdoor Curtains & Sun Shade Sails Collection > Sun Shade Sail > Waterproof Sun Shades",
			"Cyber Monday",
			"Extra 10%",
			"Factory products",
			"Fall Collection",
			"flash_categories",
			"Independence Day",
			"july sale",
			"New Content",
			"New Year's Day",
			"Sale",
			"Search outdoor",
			"Search sail",
			"Spring Time Sale",
			"Summer",
			"Summer Collection",
			"Summer Outdoor Decor"
		],
		"price": 13900,
		"price_min": 13900,
		"price_max": 13900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47317128511738,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Beige",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44066098577658,
					"product_id": 8785117610234,
					"position": 1,
					"created_at": "2025-05-26T15:48:15+08:00",
					"updated_at": "2025-08-26T16:22:30+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 819,
					"height": 1024,
					"src": "//thehues.com/cdn/shop/files/image5copy2.jpg?v=1756196550",
					"variant_ids": [
						47317128511738
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36090060865786,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1024,
						"width": 819,
						"src": "//thehues.com/cdn/shop/files/image5copy2.jpg?v=1756196550"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Beige-300x300_1024x1024.png?v=1751424847"
			},
			{
				"id": 47317128610042,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44066102542586,
					"product_id": 8785117610234,
					"position": 16,
					"created_at": "2025-05-26T15:50:50+08:00",
					"updated_at": "2025-08-26T16:22:32+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 1984,
					"height": 2400,
					"src": "//thehues.com/cdn/shop/files/white1_a0df6422-c417-4b63-98b4-ae88ccf70a4f.jpg?v=1756196552",
					"variant_ids": [
						47317128610042
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36090064568570,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.827,
						"height": 2400,
						"width": 1984,
						"src": "//thehues.com/cdn/shop/files/white1_a0df6422-c417-4b63-98b4-ae88ccf70a4f.jpg?v=1756196552"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/white-300x300_1024x1024.png?v=1751424847"
			},
			{
				"id": 47317128708346,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44066102509818,
					"product_id": 8785117610234,
					"position": 38,
					"created_at": "2025-05-26T15:50:50+08:00",
					"updated_at": "2025-08-26T16:22:33+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 1984,
					"height": 2400,
					"src": "//thehues.com/cdn/shop/files/grey1_e2254d2b-368b-44f3-9141-6d7a4e8b6eb1.jpg?v=1756196553",
					"variant_ids": [
						47317128708346
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36090064503034,
					"position": 38,
					"preview_image": {
						"aspect_ratio": 0.827,
						"height": 2400,
						"width": 1984,
						"src": "//thehues.com/cdn/shop/files/grey1_e2254d2b-368b-44f3-9141-6d7a4e8b6eb1.jpg?v=1756196553"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/grey-300x300_1024x1024.png?v=1751424847"
			},
			{
				"id": 47317128839418,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Cream",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024946491642,
					"product_id": 8785117610234,
					"position": 67,
					"created_at": "2025-05-21T13:50:19+08:00",
					"updated_at": "2025-08-26T16:22:36+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-5_resolution-standardv2-2x.jpg?v=1756196556",
					"variant_ids": [
						47317128839418
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063875334394,
					"position": 67,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-5_resolution-standardv2-2x.jpg?v=1756196556"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/1-2_1024x1024.png?v=1751424847"
			},
			{
				"id": 47317128577274,
				"title": "Burgundy",
				"option1": "Burgundy",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Burgundy",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024944427258,
					"product_id": 8785117610234,
					"position": 9,
					"created_at": "2025-05-21T13:49:56+08:00",
					"updated_at": "2025-08-26T16:22:31+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-2_resolution-standardv2-2x.jpg?v=1756196551",
					"variant_ids": [
						47317128577274
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Burgundy",
				"public_title": "Burgundy",
				"options": [
					"Burgundy"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063873499386,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-2_resolution-standardv2-2x.jpg?v=1756196551"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128642810,
				"title": "Hunter Green",
				"option1": "Hunter Green",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Hunter Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024966611194,
					"product_id": 8785117610234,
					"position": 24,
					"created_at": "2025-05-21T13:55:37+08:00",
					"updated_at": "2025-08-26T16:22:32+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-3-1_resolution-standardv2-2x.jpg?v=1756196552",
					"variant_ids": [
						47317128642810
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Hunter Green",
				"public_title": "Hunter Green",
				"options": [
					"Hunter Green"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063890538746,
					"position": 24,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AHunter-Green-3-1_resolution-standardv2-2x.jpg?v=1756196552"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128675578,
				"title": "Royal Blue",
				"option1": "Royal Blue",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Royal Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024943476986,
					"product_id": 8785117610234,
					"position": 31,
					"created_at": "2025-05-21T13:49:42+08:00",
					"updated_at": "2025-08-26T16:22:33+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-1_resolution-standardv2-2x.jpg?v=1756196553",
					"variant_ids": [
						47317128675578
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Royal Blue",
				"public_title": "Royal Blue",
				"options": [
					"Royal Blue"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063872844026,
					"position": 31,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-1_resolution-standardv2-2x.jpg?v=1756196553"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128741114,
				"title": "Forest Green",
				"option1": "Forest Green",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Forest Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024958419194,
					"product_id": 8785117610234,
					"position": 46,
					"created_at": "2025-05-21T13:53:08+08:00",
					"updated_at": "2025-08-26T16:22:34+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-1_resolution-standardv2-2x.jpg?v=1756196554",
					"variant_ids": [
						47317128741114
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Forest Green",
				"public_title": "Forest Green",
				"options": [
					"Forest Green"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063884935418,
					"position": 46,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-1_resolution-standardv2-2x.jpg?v=1756196554"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128773882,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024969920762,
					"product_id": 8785117610234,
					"position": 53,
					"created_at": "2025-05-21T13:56:39+08:00",
					"updated_at": "2025-08-26T16:22:35+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-3-1_resolution-standardv2-2x.jpg?v=1756196555",
					"variant_ids": [
						47317128773882
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063893029114,
					"position": 53,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-3-1_resolution-standardv2-2x.jpg?v=1756196555"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128806650,
				"title": "Olive",
				"option1": "Olive",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Olive",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024967495930,
					"product_id": 8785117610234,
					"position": 60,
					"created_at": "2025-05-21T13:55:47+08:00",
					"updated_at": "2025-08-26T16:22:35+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-1_resolution-standardv2-2x.jpg?v=1756196555",
					"variant_ids": [
						47317128806650
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Olive",
				"public_title": "Olive",
				"options": [
					"Olive"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063890931962,
					"position": 60,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-1_resolution-standardv2-2x.jpg?v=1756196555"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128544506,
				"title": "Red",
				"option1": "Red",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Red",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024968544506,
					"product_id": 8785117610234,
					"position": 88,
					"created_at": "2025-05-21T13:56:07+08:00",
					"updated_at": "2025-08-26T16:22:37+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-1_resolution-standardv2-2x.jpg?v=1756196557",
					"variant_ids": [
						47317128544506
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Red",
				"public_title": "Red",
				"options": [
					"Red"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063892111610,
					"position": 88,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-1_resolution-standardv2-2x.jpg?v=1756196557"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128872186,
				"title": "Carrot",
				"option1": "Carrot",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Carrot",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024945606906,
					"product_id": 8785117610234,
					"position": 74,
					"created_at": "2025-05-21T13:50:10+08:00",
					"updated_at": "2025-08-26T16:22:36+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-1_resolution-standardv2-2x.jpg?v=1756196556",
					"variant_ids": [
						47317128872186
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Carrot",
				"public_title": "Carrot",
				"options": [
					"Carrot"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063874744570,
					"position": 74,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-1_resolution-standardv2-2x.jpg?v=1756196556"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47317128904954,
				"title": "Yellow",
				"option1": "Yellow",
				"option2": null,
				"option3": null,
				"sku": "THZYFQS139SD-Yellow",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44024971362554,
					"product_id": 8785117610234,
					"position": 81,
					"created_at": "2025-05-21T13:57:02+08:00",
					"updated_at": "2025-08-26T16:22:37+08:00",
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-1_resolution-standardv2-2x.jpg?v=1756196557",
					"variant_ids": [
						47317128904954
					]
				},
				"available": true,
				"name": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - Yellow",
				"public_title": "Yellow",
				"options": [
					"Yellow"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
					"id": 36063893946618,
					"position": 81,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-1_resolution-standardv2-2x.jpg?v=1756196557"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/image5copy2.jpg?v=1756196550",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/khaki1_52c4ceca-cafb-4ac9-8d7e-d0042ac8a189.jpg?v=1756196551",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-4_resolution-standardv2-2x.jpg?v=1756196551",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-6_resolution-standardv2-2x.jpg?v=1756196551",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-2_resolution-standardv2-2x.jpg?v=1756196551",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-3_resolution-standardv2-2x.jpg?v=1756196551",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-1_resolution-standardv2-2x.jpg?v=1756196551",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/white1_a0df6422-c417-4b63-98b4-ae88ccf70a4f.jpg?v=1756196552",
			"//thehues.com/cdn/shop/files/AWhite-3-1_resolution-standardv2-2x.jpg?v=1756196552",
			"//thehues.com/cdn/shop/files/AWhite-5-1_resolution-standardv2-2x.jpg?v=1756196552",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-White2_resolution-standardv2-2x.jpg?v=1756196552",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/AHunter-Green-3-1_resolution-standardv2-2x.jpg?v=1756196552",
			"//thehues.com/cdn/shop/files/AHunter-Green-5-1_resolution-standardv2-2x.jpg?v=1756196552",
			"//thehues.com/cdn/shop/files/AHunter-Green-4-1_resolution-standardv2-2x.jpg?v=1756196553",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-1_resolution-standardv2-2x.jpg?v=1756196553",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-3_resolution-standardv2-2x.jpg?v=1756196553",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-2_resolution-standardv2-2x.jpg?v=1756196553",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/grey1_e2254d2b-368b-44f3-9141-6d7a4e8b6eb1.jpg?v=1756196553",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-6_resolution-standardv2-2x.jpg?v=1756196554",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-4_resolution-standardv2-2x.jpg?v=1756196554",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-5_resolution-standardv2-2x.jpg?v=1756196554",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-1_resolution-standardv2-2x.jpg?v=1756196554",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-3_resolution-standardv2-2x.jpg?v=1756196554",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-2_resolution-standardv2-2x.jpg?v=1756196554",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-3-1_resolution-standardv2-2x.jpg?v=1756196555",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-5-1_resolution-standardv2-2x.jpg?v=1756196555",
			"//thehues.com/cdn/shop/files/ARoyal-Blue-4-1_resolution-standardv2-2x.jpg?v=1756196555",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Detail.jpg?v=1760062791",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Installation.jpg?v=1760062791",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Connect_Hook.jpg?v=1760062791",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-1_resolution-standardv2-2x.jpg?v=1756196555",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-3_resolution-standardv2-2x.jpg?v=1756196555",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-2_resolution-standardv2-2x.jpg?v=1756196555",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-5_resolution-standardv2-2x.jpg?v=1756196556",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-3_resolution-standardv2-2x.jpg?v=1756196556",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-4_resolution-standardv2-2x.jpg?v=1756196556",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-1_resolution-standardv2-2x.jpg?v=1756196556",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-3_resolution-standardv2-2x.jpg?v=1756196556",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-2_resolution-standardv2-2x.jpg?v=1756196556",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-1_resolution-standardv2-2x.jpg?v=1756196557",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-3_resolution-standardv2-2x.jpg?v=1756196557",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-2_resolution-standardv2-2x.jpg?v=1756196557",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-1_resolution-standardv2-2x.jpg?v=1756196557",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-3_resolution-standardv2-2x.jpg?v=1756196557",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-2_resolution-standardv2-2x.jpg?v=1756196557",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Detail.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Close-up.jpg?v=1761284277",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Installation.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Connect_Hook.jpg?v=1760062790",
			"//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-5_resolution-standardv2-2x.jpg?v=1756196558",
			"//thehues.com/cdn/shop/files/6481b97c390d3a778a021a3546f4146b_a197b619-8b21-4ee2-9d07-b2f3341e1c5b.jpg?v=1756196558"
		],
		"featured_image": "//thehues.com/cdn/shop/files/image5copy2_1024x1024.jpg?v=1756196550",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36090060865786,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1024,
					"width": 819,
					"src": "//thehues.com/cdn/shop/files/image5copy2.jpg?v=1756196550"
				},
				"aspect_ratio": 0.8,
				"height": 1024,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image5copy2.jpg?v=1756196550",
				"width": 819
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063836569850,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36090064535802,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.827,
					"height": 2400,
					"width": 1984,
					"src": "//thehues.com/cdn/shop/files/khaki1_52c4ceca-cafb-4ac9-8d7e-d0042ac8a189.jpg?v=1756196551"
				},
				"aspect_ratio": 0.827,
				"height": 2400,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/khaki1_52c4ceca-cafb-4ac9-8d7e-d0042ac8a189.jpg?v=1756196551",
				"width": 1984
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063853904122,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-4_resolution-standardv2-2x.jpg?v=1756196551"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-4_resolution-standardv2-2x.jpg?v=1756196551",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063853969658,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-6_resolution-standardv2-2x.jpg?v=1756196551"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-6_resolution-standardv2-2x.jpg?v=1756196551",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063836602618,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063836504314,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063836635386,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Beige_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063873499386,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-2_resolution-standardv2-2x.jpg?v=1756196551"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-2_resolution-standardv2-2x.jpg?v=1756196551",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063873433850,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-3_resolution-standardv2-2x.jpg?v=1756196551"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-3_resolution-standardv2-2x.jpg?v=1756196551",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063873466618,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-1_resolution-standardv2-2x.jpg?v=1756196551"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Burgundy-1_resolution-standardv2-2x.jpg?v=1756196551",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063841943802,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063842074874,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063842042106,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063842009338,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Burgundy_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36090064568570,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.827,
					"height": 2400,
					"width": 1984,
					"src": "//thehues.com/cdn/shop/files/white1_a0df6422-c417-4b63-98b4-ae88ccf70a4f.jpg?v=1756196552"
				},
				"aspect_ratio": 0.827,
				"height": 2400,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/white1_a0df6422-c417-4b63-98b4-ae88ccf70a4f.jpg?v=1756196552",
				"width": 1984
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893684474,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWhite-3-1_resolution-standardv2-2x.jpg?v=1756196552"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWhite-3-1_resolution-standardv2-2x.jpg?v=1756196552",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893717242,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWhite-5-1_resolution-standardv2-2x.jpg?v=1756196552"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWhite-5-1_resolution-standardv2-2x.jpg?v=1756196552",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893750010,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-White2_resolution-standardv2-2x.jpg?v=1756196552"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-White2_resolution-standardv2-2x.jpg?v=1756196552",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847022842,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846990074,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846924538,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847055610,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_White_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063890538746,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-3-1_resolution-standardv2-2x.jpg?v=1756196552"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHunter-Green-3-1_resolution-standardv2-2x.jpg?v=1756196552",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063890604282,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-5-1_resolution-standardv2-2x.jpg?v=1756196552"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHunter-Green-5-1_resolution-standardv2-2x.jpg?v=1756196552",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063890571514,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AHunter-Green-4-1_resolution-standardv2-2x.jpg?v=1756196553"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AHunter-Green-4-1_resolution-standardv2-2x.jpg?v=1756196553",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846727930,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846891770,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846859002,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846826234,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Hunter_Green_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063872844026,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-1_resolution-standardv2-2x.jpg?v=1756196553"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-1_resolution-standardv2-2x.jpg?v=1756196553",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063872811258,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-3_resolution-standardv2-2x.jpg?v=1756196553"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-3_resolution-standardv2-2x.jpg?v=1756196553",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063872876794,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-2_resolution-standardv2-2x.jpg?v=1756196553"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Blue-2_resolution-standardv2-2x.jpg?v=1756196553",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847776506,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847743738,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847842042,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847809274,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Navy_Blue_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36090064503034,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.827,
					"height": 2400,
					"width": 1984,
					"src": "//thehues.com/cdn/shop/files/grey1_e2254d2b-368b-44f3-9141-6d7a4e8b6eb1.jpg?v=1756196553"
				},
				"aspect_ratio": 0.827,
				"height": 2400,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/grey1_e2254d2b-368b-44f3-9141-6d7a4e8b6eb1.jpg?v=1756196553",
				"width": 1984
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063886475514,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-6_resolution-standardv2-2x.jpg?v=1756196554"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-6_resolution-standardv2-2x.jpg?v=1756196554",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063886508282,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-4_resolution-standardv2-2x.jpg?v=1756196554"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-4_resolution-standardv2-2x.jpg?v=1756196554",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063886541050,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-5_resolution-standardv2-2x.jpg?v=1756196554"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Grey-5_resolution-standardv2-2x.jpg?v=1756196554",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845581050,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845679354,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845712122,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845613818,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Grey_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063884935418,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-1_resolution-standardv2-2x.jpg?v=1756196554"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-1_resolution-standardv2-2x.jpg?v=1756196554",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063884902650,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-3_resolution-standardv2-2x.jpg?v=1756196554"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-3_resolution-standardv2-2x.jpg?v=1756196554",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063884968186,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-2_resolution-standardv2-2x.jpg?v=1756196554"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Forest-Green-2_resolution-standardv2-2x.jpg?v=1756196554",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846564090,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846695162,
				"position": 50,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846662394,
				"position": 51,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846629626,
				"position": 52,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Forest_Green_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893029114,
				"position": 53,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-3-1_resolution-standardv2-2x.jpg?v=1756196555"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-3-1_resolution-standardv2-2x.jpg?v=1756196555",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893094650,
				"position": 54,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-5-1_resolution-standardv2-2x.jpg?v=1756196555"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-5-1_resolution-standardv2-2x.jpg?v=1756196555",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893061882,
				"position": 55,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-4-1_resolution-standardv2-2x.jpg?v=1756196555"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARoyal-Blue-4-1_resolution-standardv2-2x.jpg?v=1756196555",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063844696314,
				"position": 56,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Detail.jpg?v=1760062791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Detail.jpg?v=1760062791",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063844663546,
				"position": 57,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063844630778,
				"position": 58,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Installation.jpg?v=1760062791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Installation.jpg?v=1760062791",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063844598010,
				"position": 59,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Connect_Hook.jpg?v=1760062791"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Blue_Connect_Hook.jpg?v=1760062791",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063890931962,
				"position": 60,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-1_resolution-standardv2-2x.jpg?v=1756196555"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-1_resolution-standardv2-2x.jpg?v=1756196555",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063890899194,
				"position": 61,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-3_resolution-standardv2-2x.jpg?v=1756196555"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-3_resolution-standardv2-2x.jpg?v=1756196555",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063890964730,
				"position": 62,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-2_resolution-standardv2-2x.jpg?v=1756196555"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Olive-2_resolution-standardv2-2x.jpg?v=1756196555",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847284986,
				"position": 63,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847252218,
				"position": 64,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847219450,
				"position": 65,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847186682,
				"position": 66,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Olive_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063875334394,
				"position": 67,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-5_resolution-standardv2-2x.jpg?v=1756196556"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-5_resolution-standardv2-2x.jpg?v=1756196556",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063875268858,
				"position": 68,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-3_resolution-standardv2-2x.jpg?v=1756196556"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-3_resolution-standardv2-2x.jpg?v=1756196556",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063875301626,
				"position": 69,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-4_resolution-standardv2-2x.jpg?v=1756196556"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Cream-4_resolution-standardv2-2x.jpg?v=1756196556",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846400250,
				"position": 70,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846498554,
				"position": 71,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846433018,
				"position": 72,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063846465786,
				"position": 73,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Cream_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063874744570,
				"position": 74,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-1_resolution-standardv2-2x.jpg?v=1756196556"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-1_resolution-standardv2-2x.jpg?v=1756196556",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063874711802,
				"position": 75,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-3_resolution-standardv2-2x.jpg?v=1756196556"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-3_resolution-standardv2-2x.jpg?v=1756196556",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063874777338,
				"position": 76,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-2_resolution-standardv2-2x.jpg?v=1756196556"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Carrot-2_resolution-standardv2-2x.jpg?v=1756196556",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845941498,
				"position": 77,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845908730,
				"position": 78,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845875962,
				"position": 79,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063845843194,
				"position": 80,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Carrot_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893946618,
				"position": 81,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-1_resolution-standardv2-2x.jpg?v=1756196557"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-1_resolution-standardv2-2x.jpg?v=1756196557",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063894012154,
				"position": 82,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-3_resolution-standardv2-2x.jpg?v=1756196557"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-3_resolution-standardv2-2x.jpg?v=1756196557",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063893979386,
				"position": 83,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-2_resolution-standardv2-2x.jpg?v=1756196557"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Yellow-2_resolution-standardv2-2x.jpg?v=1756196557",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847383290,
				"position": 84,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847514362,
				"position": 85,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847448826,
				"position": 86,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847416058,
				"position": 87,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Yellow_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063892111610,
				"position": 88,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-1_resolution-standardv2-2x.jpg?v=1756196557"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-1_resolution-standardv2-2x.jpg?v=1756196557",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063892177146,
				"position": 89,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-3_resolution-standardv2-2x.jpg?v=1756196557"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-3_resolution-standardv2-2x.jpg?v=1756196557",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063892144378,
				"position": 90,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-2_resolution-standardv2-2x.jpg?v=1756196557"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-Red-2_resolution-standardv2-2x.jpg?v=1756196557",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847547130,
				"position": 91,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Detail.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Detail.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847678202,
				"position": 92,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Close-up.jpg?v=1761284277"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Close-up.jpg?v=1761284277",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847612666,
				"position": 93,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Installation.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Installation.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063847579898,
				"position": 94,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Connect_Hook.jpg?v=1760062790"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/UVShield_Waterproof_Triangle_Sun_Shade_Sail_Red_Connect_Hook.jpg?v=1760062790",
				"width": 2001
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063853936890,
				"position": 95,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-5_resolution-standardv2-2x.jpg?v=1756196558"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ARectangle-Sun-Shade-Sail-beige-5_resolution-standardv2-2x.jpg?v=1756196558",
				"width": 2000
			},
			{
				"alt": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail - TheHues",
				"id": 36063894864122,
				"position": 96,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/6481b97c390d3a778a021a3546f4146b_a197b619-8b21-4ee2-9d07-b2f3341e1c5b.jpg?v=1756196558"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/6481b97c390d3a778a021a3546f4146b_a197b619-8b21-4ee2-9d07-b2f3341e1c5b.jpg?v=1756196558",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Stay cool and protected with our custom waterproof Rectangle Sun Shade Sail for outdoor patios. Enjoy shade and comfort in style.</p>",
		"url": "/products/uvshield-waterproof-quadrati-custom-rectangle-sun-shade-sail",
		"regular_price": "$139.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/frontpage",
				"title": "Home page"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sun-shade-sail",
				"title": "Sun Shade Sail"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/uv-shield",
				"title": "UV Shield"
			}
		]
	},
	{
		"id": 8794291962106,
		"title": "Yuki Linen Woven Shade - White",
		"handle": "yuki-linen-woven-shade-white",
		"product_details": `<h3>Specifications</h3><p>Material: 60% Linen &amp; 40% Jute<br>Features: Room Darkening<br>Weight: Lightweight (230g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Linen spun to airy perfection, filtering sunlight into a soft, sun-bleached glow.</p>",
		"published_at": "2025-05-28T15:49:22+08:00",
		"created_at": "2025-05-28T13:42:21+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"fall sale",
			"Indoor Woven Shade",
			"july sale",
			"No-drill",
			"Thanksgiving sale",
			"Woven shade"
		],
		"price": 17300,
		"price_min": 17300,
		"price_max": 17300,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347501990138,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THRS-SWY. M1-8-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077760676090,
					"product_id": 8794291962106,
					"position": 1,
					"created_at": "2025-05-28T14:20:43+08:00",
					"updated_at": "2025-08-26T16:22:09+08:00",
					"alt": "Yuki Linen Woven Shade - White - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SWYM1_8_1copy.jpg?v=1756196529",
					"variant_ids": [
						47347501990138
					]
				},
				"available": true,
				"name": "Yuki Linen Woven Shade - White - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 17300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Yuki Linen Woven Shade - White - TheHues",
					"id": 36099029729530,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SWYM1_8_1copy.jpg?v=1756196529"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06631_-70_1024x1024.jpg?v=1756196529"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SWYM1_8_1copy.jpg?v=1756196529",
			"//thehues.com/cdn/shop/files/DSC06631_-70.jpg?v=1756196529",
			"//thehues.com/cdn/shop/files/SWYM1_8_2copy.jpg?v=1756196529",
			"//thehues.com/cdn/shop/files/DSC06647_-72.jpg?v=1756196530",
			"//thehues.com/cdn/shop/files/DSC06650_-74.jpg?v=1756196530",
			"//thehues.com/cdn/shop/files/DSC06654_-75.jpg?v=1756196530",
			"//thehues.com/cdn/shop/files/DSC06633_-71.jpg?v=1756196530",
			"//thehues.com/cdn/shop/files/DSC06648_-73.jpg?v=1756196530"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SWYM1_8_1copy_1024x1024.jpg?v=1756196529",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Yuki Linen Woven Shade - White - TheHues",
				"id": 36099029729530,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_8_1copy.jpg?v=1756196529"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_8_1copy.jpg?v=1756196529",
				"width": 2000
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099541369082,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06631_-70.jpg?v=1756196529"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06631_-70.jpg?v=1756196529",
				"width": 1667
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099029762298,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_8_2copy.jpg?v=1756196529"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_8_2copy.jpg?v=1756196529",
				"width": 2000
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099541434618,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06647_-72.jpg?v=1756196530"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06647_-72.jpg?v=1756196530",
				"width": 1667
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099541303546,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06650_-74.jpg?v=1756196530"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06650_-74.jpg?v=1756196530",
				"width": 1667
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099541336314,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06654_-75.jpg?v=1756196530"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06654_-75.jpg?v=1756196530",
				"width": 1667
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099541401850,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06633_-71.jpg?v=1756196530"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06633_-71.jpg?v=1756196530",
				"width": 1667
			},
			{
				"alt": "Yuki Linen Motorized Woven Shade - White - TheHues",
				"id": 36099541467386,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06648_-73.jpg?v=1756196530"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06648_-73.jpg?v=1756196530",
				"width": 1667
			},
			{
				"alt": null,
				"id": 36552782512378,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/78d304c8b0084461b4321106b04c7061.thumbnail.0000000000.jpg?v=1755221806"
				},
				"aspect_ratio": 0.563,
				"duration": 9570,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/78d304c8b0084461b4321106b04c7061/78d304c8b0084461b4321106b04c7061.SD-480p-0.9Mbps-54932855.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/78d304c8b0084461b4321106b04c7061/78d304c8b0084461b4321106b04c7061.HD-1080p-2.5Mbps-54932855.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/78d304c8b0084461b4321106b04c7061/78d304c8b0084461b4321106b04c7061.HD-720p-1.6Mbps-54932855.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/78d304c8b0084461b4321106b04c7061/78d304c8b0084461b4321106b04c7061.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Linen spun to airy perfection, filtering sunlight into a soft, sun-bleached glow.</p>",
		"url": "/products/yuki-linen-woven-shade-white",
		"regular_price": "$173.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8830964957434,
		"title": "Liam Striped Linen Blend Custom Curtain",
		"handle": "liam-striped-custom-linen-blend-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 10% Linen &amp; 90% Polyester<br>Features: Room Darkening<br>Weight: Heavy Weight (440g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Safe To Wash</p><p>Tumble Dry</p><p>Iron-Safe</p><p>Dry Clean Allowed</p><p>Do Not Bleach</p>`,
		"description": "<p>With its clean lines and natural texture, Liam brings a quiet rhythm to your space¡ªwoven from a breathable linen blend for a timeless look.</p>",
		"published_at": "2025-06-18T19:05:37+08:00",
		"created_at": "2025-06-11T18:32:14+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Designer Curtains",
			"All Curtains > striped custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"fall sale",
			"Halloween",
			"indoor curtain",
			"New Arrivals",
			"Outsourced products",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 15900,
		"compare_at_price_min": 15900,
		"compare_at_price_max": 15900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47405503480058,
				"title": "Zebra",
				"option1": "Zebra",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-ZG-6-207-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44248737087738,
					"product_id": 8830964957434,
					"position": 1,
					"created_at": "2025-06-17T19:50:55+08:00",
					"updated_at": "2025-08-26T16:19:41+08:00",
					"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_13_5e8cdf4e-6a1d-407a-b9d2-070cb8345555.jpg?v=1756196381",
					"variant_ids": [
						47405503480058
					]
				},
				"available": true,
				"name": "Liam Striped Linen Blend Custom Curtain - Zebra",
				"public_title": "Zebra",
				"options": [
					"Zebra"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 15900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
					"id": 36208681124090,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_13_5e8cdf4e-6a1d-407a-b9d2-070cb8345555.jpg?v=1756196381"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aliam_zebra_1024x1024.jpg?v=1751277762"
			},
			{
				"id": 47405503447290,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THC-YKB-ZG-2-207-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44183841177850,
					"product_id": 8830964957434,
					"position": 3,
					"created_at": "2025-06-11T18:35:15+08:00",
					"updated_at": "2025-08-26T16:19:41+08:00",
					"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
					"width": 2583,
					"height": 3229,
					"src": "//thehues.com/cdn/shop/files/DSC04318_copy.jpg?v=1756196381",
					"variant_ids": [
						47405503447290
					]
				},
				"available": true,
				"name": "Liam Striped Linen Blend Custom Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 15900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
					"id": 36168516632826,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 3229,
						"width": 2583,
						"src": "//thehues.com/cdn/shop/files/DSC04318_copy.jpg?v=1756196381"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aliam_brown_1024x1024.jpg?v=1751277762"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/FotoJet_13_5e8cdf4e-6a1d-407a-b9d2-070cb8345555.jpg?v=1756196381",
			"//thehues.com/cdn/shop/files/ADSC04579_-standardv2-2000w.jpg?v=1756196381",
			"//thehues.com/cdn/shop/files/DSC04318_copy.jpg?v=1756196381",
			"//thehues.com/cdn/shop/files/DSC04351.jpg?v=1756196381",
			"//thehues.com/cdn/shop/files/DSC04312_copy.jpg?v=1756196382",
			"//thehues.com/cdn/shop/files/DSC04334.jpg?v=1756196382",
			"//thehues.com/cdn/shop/files/Zebra_caa563f7-016d-4cb4-827c-3887feaf616a.jpg?v=1756196382",
			"//thehues.com/cdn/shop/files/ADSC04551_-standardv2-2000w.jpg?v=1756196382",
			"//thehues.com/cdn/shop/files/ADSC04576_-standardv2-2000w.jpg?v=1756196382",
			"//thehues.com/cdn/shop/files/ADSC04528_-standardv2-2000w.jpg?v=1756196382",
			"//thehues.com/cdn/shop/files/DSC04299_copy.jpg?v=1756196382"
		],
		"featured_image": "//thehues.com/cdn/shop/files/FotoJet_13_5e8cdf4e-6a1d-407a-b9d2-070cb8345555_1024x1024.jpg?v=1756196381",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36208681124090,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_13_5e8cdf4e-6a1d-407a-b9d2-070cb8345555.jpg?v=1756196381"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_13_5e8cdf4e-6a1d-407a-b9d2-070cb8345555.jpg?v=1756196381",
				"width": 2000
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168511455482,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04579_-standardv2-2000w.jpg?v=1756196381"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04579_-standardv2-2000w.jpg?v=1756196381",
				"width": 2000
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168516632826,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3229,
					"width": 2583,
					"src": "//thehues.com/cdn/shop/files/DSC04318_copy.jpg?v=1756196381"
				},
				"aspect_ratio": 0.8,
				"height": 3229,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04318_copy.jpg?v=1756196381",
				"width": 2583
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168516534522,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3797,
					"width": 3037,
					"src": "//thehues.com/cdn/shop/files/DSC04351.jpg?v=1756196381"
				},
				"aspect_ratio": 0.8,
				"height": 3797,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04351.jpg?v=1756196381",
				"width": 3037
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168516600058,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3855,
					"width": 3084,
					"src": "//thehues.com/cdn/shop/files/DSC04312_copy.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 3855,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04312_copy.jpg?v=1756196382",
				"width": 3084
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168516501754,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3840,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04334.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 3840,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04334.jpg?v=1756196382",
				"width": 3072
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36232060829946,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3712,
					"width": 2969,
					"src": "//thehues.com/cdn/shop/files/Zebra_caa563f7-016d-4cb4-827c-3887feaf616a.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 3712,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Zebra_caa563f7-016d-4cb4-827c-3887feaf616a.jpg?v=1756196382",
				"width": 2969
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168511684858,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04551_-standardv2-2000w.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04551_-standardv2-2000w.jpg?v=1756196382",
				"width": 2000
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168511750394,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04576_-standardv2-2000w.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04576_-standardv2-2000w.jpg?v=1756196382",
				"width": 2000
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168511521018,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04528_-standardv2-2000w.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04528_-standardv2-2000w.jpg?v=1756196382",
				"width": 2000
			},
			{
				"alt": "Liam Striped Linen Blend Custom Curtain - TheHues",
				"id": 36168516567290,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2408,
					"width": 1927,
					"src": "//thehues.com/cdn/shop/files/DSC04299_copy.jpg?v=1756196382"
				},
				"aspect_ratio": 0.8,
				"height": 2408,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04299_copy.jpg?v=1756196382",
				"width": 1927
			},
			{
				"alt": null,
				"id": 36215577379066,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1920,
					"width": 1536,
					"src": "//thehues.com/cdn/shop/files/preview_images/d34266036c3d41c7a210dbd85bf6a206.thumbnail.0000000000.jpg?v=1750240924"
				},
				"aspect_ratio": 0.8,
				"duration": 8500,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/d34266036c3d41c7a210dbd85bf6a206/d34266036c3d41c7a210dbd85bf6a206.SD-480p-1.5Mbps-49607126.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/d34266036c3d41c7a210dbd85bf6a206/d34266036c3d41c7a210dbd85bf6a206.HD-1080p-7.2Mbps-49607126.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/d34266036c3d41c7a210dbd85bf6a206/d34266036c3d41c7a210dbd85bf6a206.HD-720p-4.5Mbps-49607126.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/d34266036c3d41c7a210dbd85bf6a206/d34266036c3d41c7a210dbd85bf6a206.m3u8?v=0",
						"width": 864
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With its clean lines and natural texture, Liam brings a quiet rhythm to your space¡ªwoven from a breathable linen blend for a timeless look.</p>",
		"url": "/products/liam-striped-custom-linen-blend-curtain",
		"regular_price": "$109.00",
		"sale_price": "$159.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/designer-curtains",
				"title": "Designer Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/striped-curtain",
				"title": "Striped Curtain"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8794305036538,
		"title": "Mia Jute Woven Shade - Ecru",
		"handle": "mia-jute-woven-shade-ecru",
		"product_details": `<h3>Specifications</h3><p>Material: 10% Linen &amp; 90% Polyester<br>Features: Room Darkening<br>Weight: Heavy Weight (440g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Safe To Wash</p><p>Tumble Dry</p><p>Iron-Safe</p><p>Dry Clean Allowed</p><p>Do Not Bleach</p>`,
		"description": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"published_at": "2025-05-28T15:49:25+08:00",
		"created_at": "2025-05-28T14:04:43+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"fall sale",
			"Indoor Woven Shade",
			"july sale",
			"No-drill",
			"Thanksgiving sale",
			"Woven shade"
		],
		"price": 15900,
		"price_min": 15900,
		"price_max": 15900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 17900,
		"compare_at_price_min": 17900,
		"compare_at_price_max": 17900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347573653754,
				"title": "Ecru",
				"option1": "Ecru",
				"option2": null,
				"option3": null,
				"sku": "THRS-SWY.M1-6-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077713195258,
					"product_id": 8794305036538,
					"position": 1,
					"created_at": "2025-05-28T14:13:26+08:00",
					"updated_at": "2025-08-29T16:00:51+08:00",
					"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SWYM1_2_6.jpg?v=1756454451",
					"variant_ids": [
						47347573653754
					]
				},
				"available": true,
				"name": "Mia Jute Woven Shade - Ecru - Ecru",
				"public_title": "Ecru",
				"options": [
					"Ecru"
				],
				"price": 15900,
				"weight": 0,
				"compare_at_price": 17900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
					"id": 36098985230586,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SWYM1_2_6.jpg?v=1756454451"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC03467_-47_1024x1024.jpg?v=1756454451"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SWYM1_2_6.jpg?v=1756454451",
			"//thehues.com/cdn/shop/files/DSC03467_-47.jpg?v=1756454451",
			"//thehues.com/cdn/shop/files/SWYM1_1_6.jpg?v=1756454451",
			"//thehues.com/cdn/shop/files/SWYM1_3_6.jpg?v=1756454451",
			"//thehues.com/cdn/shop/files/DSC03931_-49.jpg?v=1756196519",
			"//thehues.com/cdn/shop/files/DSC03938_-50.jpg?v=1756196519",
			"//thehues.com/cdn/shop/files/DSC03468_-48.jpg?v=1756454451"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SWYM1_2_6_1024x1024.jpg?v=1756454451",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36098985230586,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_2_6.jpg?v=1756454451"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_2_6.jpg?v=1756454451",
				"width": 2000
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36099546710266,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03467_-47.jpg?v=1756454451"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03467_-47.jpg?v=1756454451",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36098985197818,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_1_6.jpg?v=1756454451"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_1_6.jpg?v=1756454451",
				"width": 2000
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36098985165050,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_3_6.jpg?v=1756454451"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_3_6.jpg?v=1756454451",
				"width": 2000
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36099546775802,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03931_-49.jpg?v=1756196519"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03931_-49.jpg?v=1756196519",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36099546677498,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03938_-50.jpg?v=1756196519"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03938_-50.jpg?v=1756196519",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Ecru - TheHues",
				"id": 36099546743034,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03468_-48.jpg?v=1756454451"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03468_-48.jpg?v=1756454451",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"url": "/products/mia-jute-woven-shade-ecru",
		"regular_price": "$159.00",
		"sale_price": "$179.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8780129894650,
		"title": "Sahara Linen Blend Patterned Custom Curtain",
		"handle": "sahara-linen-blend-patterned-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 16% Linen &amp; 84% Polyester<br>Features: Room Darkening<br>Weight: Heavy Weight (379g/㎡)<br>Softness: Soft</p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p>`,
		"description": "<p>Sahara is where linen meets the horizon-its airy jacquard motif opens up the room like a landscape without edges.</p>",
		"published_at": "2025-05-07T16:34:07+08:00",
		"created_at": "2025-05-07T16:34:07+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > patterned custom curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains > Room Darkening Curtains",
			"Curtains Memory Training",
			"Fall Collection",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"sale top 10",
			"Search curtains",
			"Search linen",
			"Search Linen blend curtains",
			"Search Pinch pleat",
			"Summer Collection"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 12900,
		"compare_at_price_min": 12900,
		"compare_at_price_max": 12900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319408673018,
				"title": "Sandstone",
				"option1": "Sandstone",
				"option2": null,
				"option3": null,
				"sku": "THC-138-SNAKE5-2-SD-1-Sandstone",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44246104932602,
					"product_id": 8780129894650,
					"position": 1,
					"created_at": "2025-06-17T15:44:13+08:00",
					"updated_at": "2025-08-26T16:23:26+08:00",
					"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2sahara_sandston.jpg?v=1756196606",
					"variant_ids": [
						47319408673018
					]
				},
				"available": true,
				"name": "Sahara Linen Blend Patterned Custom Curtain - Sandstone",
				"public_title": "Sandstone",
				"options": [
					"Sandstone"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
					"id": 36206970568954,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2sahara_sandston.jpg?v=1756196606"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asahara_sandstone_1024x1024.jpg?v=1751335529"
			},
			{
				"id": 47319408705786,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-138-SNAKE5-2-SD-1-Ash",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44246104441082,
					"product_id": 8780129894650,
					"position": 9,
					"created_at": "2025-06-17T15:44:01+08:00",
					"updated_at": "2025-08-26T16:23:27+08:00",
					"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2sahara_ash.jpg?v=1756196607",
					"variant_ids": [
						47319408705786
					]
				},
				"available": true,
				"name": "Sahara Linen Blend Patterned Custom Curtain - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": 12900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
					"id": 36206970110202,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2sahara_ash.jpg?v=1756196607"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Asahara_ash_1024x1024.jpg?v=1751335528"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/2sahara_sandston.jpg?v=1756196606",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02755copy2_resolution-standardv2-2x.jpg?v=1756196606",
			"//thehues.com/cdn/shop/files/sahara_sandstone.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/FotoJet_11.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02757copy2_resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01683copy2_resolution-standardv2-2x.jpg?v=1761203778",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01681copy2_resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01213copy2_resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/2sahara_ash.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/sahara_ash.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02790copy2_resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01757copy2_resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC01766copy2_resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-Asahara16Y__resolution-standardv2-2x.jpg?v=1756196607",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02744copy2_resolution-standardv2-2x.jpg?v=1756196608"
		],
		"featured_image": "//thehues.com/cdn/shop/files/2sahara_sandston_1024x1024.jpg?v=1756196606",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206970568954,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sahara_sandston.jpg?v=1756196606"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sahara_sandston.jpg?v=1756196606",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811973370,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02755copy2_resolution-standardv2-2x.jpg?v=1756196606"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02755copy2_resolution-standardv2-2x.jpg?v=1756196606",
				"width": 2000
			},
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206970601722,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sahara_sandstone.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sahara_sandstone.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 35997160440058,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.75,
					"height": 900,
					"width": 675,
					"src": "//thehues.com/cdn/shop/files/FotoJet_11.jpg?v=1756196607"
				},
				"aspect_ratio": 0.75,
				"height": 900,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_11.jpg?v=1756196607",
				"width": 675
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071812006138,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02757copy2_resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02757copy2_resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811907834,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01683copy2_resolution-standardv2-2x.jpg?v=1761203778"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01683copy2_resolution-standardv2-2x.jpg?v=1761203778",
				"width": 2000
			},
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811875066,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01681copy2_resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01681copy2_resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811842298,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01213copy2_resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01213copy2_resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206970110202,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2sahara_ash.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2sahara_ash.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206970142970,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/sahara_ash.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/sahara_ash.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811612922,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02790copy2_resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02790copy2_resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811678458,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01757copy2_resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01757copy2_resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811711226,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01766copy2_resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC01766copy2_resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811645690,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-Asahara16Y__resolution-standardv2-2x.jpg?v=1756196607"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-Asahara16Y__resolution-standardv2-2x.jpg?v=1756196607",
				"width": 2000
			},
			{
				"alt": "Sahara 100% Blackout Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071811940602,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02744copy2_resolution-standardv2-2x.jpg?v=1756196608"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02744copy2_resolution-standardv2-2x.jpg?v=1756196608",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36134431326458,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1080,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/2fdfae07c5c943a2b232286a9656b82a.thumbnail.0000000000.jpg?v=1749101921"
				},
				"aspect_ratio": 1,
				"duration": 8610,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2fdfae07c5c943a2b232286a9656b82a/2fdfae07c5c943a2b232286a9656b82a.SD-480p-1.5Mbps-48853043.mp4?v=0",
						"width": 480
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2fdfae07c5c943a2b232286a9656b82a/2fdfae07c5c943a2b232286a9656b82a.HD-1080p-7.2Mbps-48853043.mp4?v=0",
						"width": 1080
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2fdfae07c5c943a2b232286a9656b82a/2fdfae07c5c943a2b232286a9656b82a.HD-720p-4.5Mbps-48853043.mp4?v=0",
						"width": 720
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/2fdfae07c5c943a2b232286a9656b82a/2fdfae07c5c943a2b232286a9656b82a.m3u8?v=0",
						"width": 1080
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Sahara is where linen meets the horizon-its airy jacquard motif opens up the room like a landscape without edges.</p>",
		"url": "/products/sahara-linen-blend-patterned-custom-curtain",
		"regular_price": "$109.00",
		"sale_price": "$129.00",
		"collections": [
			{
				"url": "/collections/advert-room-darkning-curtains",
				"title": "Advert Room Darkning Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-favorites",
				"title": "Fall Favorites"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/room-darkening",
				"title": "Room Darkening Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8794305593594,
		"title": "Rumi Jute Woven Shade - Straw",
		"handle": "rumi-jute-woven-shade-straw",
		"product_details": `<h3>Specifications</h3><p>Material: 16% Linen &amp; 84% Polyester<br>Features: Room Darkening<br>Weight: Heavy Weight (379g/㎡)<br>Softness: Soft</p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p>`,
		"description": "<p>Coarse, knotted, alive¡ªcrafting natural textures and light into something unique and polished.</p>",
		"published_at": "2025-05-28T15:49:28+08:00",
		"created_at": "2025-05-28T14:05:28+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"july sale",
			"No-drill",
			"Woven shade"
		],
		"price": 16600,
		"price_min": 16600,
		"price_max": 16600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347576013050,
				"title": "Straw",
				"option1": "Straw",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW4126-S-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44079210004730,
					"product_id": 8794305593594,
					"position": 1,
					"created_at": "2025-05-28T17:48:02+08:00",
					"updated_at": "2025-08-26T16:21:52+08:00",
					"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/FotoJet_40.jpg?v=1756196512",
					"variant_ids": [
						47347576013050
					]
				},
				"available": true,
				"name": "Rumi Jute Woven Shade - Straw - Straw",
				"public_title": "Straw",
				"options": [
					"Straw"
				],
				"price": 16600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
					"id": 36100361060602,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/FotoJet_40.jpg?v=1756196512"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06418copy-22_1024x1024.jpg?v=1756196513"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/FotoJet_40.jpg?v=1756196512",
			"//thehues.com/cdn/shop/files/DSC06402copy-20.jpg?v=1756196512",
			"//thehues.com/cdn/shop/files/SW41_2_26.jpg?v=1756196512",
			"//thehues.com/cdn/shop/files/SW41_1_26.jpg?v=1756196512",
			"//thehues.com/cdn/shop/files/DSC06492copy-24.jpg?v=1756196512",
			"//thehues.com/cdn/shop/files/DSC06462copy-23.jpg?v=1756196512",
			"//thehues.com/cdn/shop/files/DSC06410copy-21.jpg?v=1756196513",
			"//thehues.com/cdn/shop/files/DSC06418copy-22.jpg?v=1756196513"
		],
		"featured_image": "//thehues.com/cdn/shop/files/FotoJet_40_1024x1024.jpg?v=1756196512",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36100361060602,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_40.jpg?v=1756196512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_40.jpg?v=1756196512",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099529474298,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06402copy-20.jpg?v=1756196512"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06402copy-20.jpg?v=1756196512",
				"width": 1667
			},
			{
				"alt": "Rumi Jute Woven Shade - Straw - TheHues",
				"id": 36099002597626,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW41_2_26.jpg?v=1756196512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW41_2_26.jpg?v=1756196512",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099002564858,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW41_1_26.jpg?v=1756196512"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW41_1_26.jpg?v=1756196512",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099529408762,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06492copy-24.jpg?v=1756196512"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06492copy-24.jpg?v=1756196512",
				"width": 1667
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099529769210,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06462copy-23.jpg?v=1756196512"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06462copy-23.jpg?v=1756196512",
				"width": 1667
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099529572602,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06410copy-21.jpg?v=1756196513"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06410copy-21.jpg?v=1756196513",
				"width": 1667
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099529670906,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06418copy-22.jpg?v=1756196513"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06418copy-22.jpg?v=1756196513",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Coarse, knotted, alive¡ªcrafting natural textures and light into something unique and polished.</p>",
		"url": "/products/rumi-jute-woven-shade-straw",
		"regular_price": "$166.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8780122751226,
		"title": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain",
		"handle": "unwind-linen-blend-grid-like-woven-sheer-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Kenaf<br>Features: Room Darkening<br>Weight: Heavyweight (600g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>With every flutter of light through the woven threads, the Unwind Sheer Curtains offer a soft embrace, filling your space with the gentle rhythm of calm and serenity.</p>",
		"published_at": "2025-05-07T16:30:27+08:00",
		"created_at": "2025-05-07T16:30:27+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > geometric custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > New Sheer Curtains",
			"All Curtains > pinch pleat custom curtains",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Extra 10%",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search sheer",
			"Summer"
		],
		"price": 13100,
		"price_min": 13100,
		"price_max": 13100,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319400808698,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-FT0301-C",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037219352826,
					"product_id": 8780122751226,
					"position": 1,
					"created_at": "2025-05-22T17:44:06+08:00",
					"updated_at": "2025-08-26T16:27:56+08:00",
					"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240522-AUnwind-FT0301-2_resolution-standardv2-2x.jpg?v=1756196876",
					"variant_ids": [
						47319400808698
					]
				},
				"available": true,
				"name": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 13100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
					"id": 36071420657914,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240522-AUnwind-FT0301-2_resolution-standardv2-2x.jpg?v=1756196876"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aunwind_winter_1024x1024.png?v=1751349044"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240522-AUnwind-FT0301-2_resolution-standardv2-2x.jpg?v=1756196876",
			"//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-6_resolution-standardv2-2x.jpg?v=1756196876",
			"//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-3_resolution-standardv2-2x.jpg?v=1756196876",
			"//thehues.com/cdn/shop/files/20240716-AUnwind-White-4_resolution-standardv2-2x.jpg?v=1756196877",
			"//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-4_resolution-standardv2-2x.jpg?v=1756196877",
			"//thehues.com/cdn/shop/files/20240716-AUnwind-White-5_resolution-standardv2-2x.jpg?v=1756196877",
			"//thehues.com/cdn/shop/files/20250516-AFA-FT0301-display_resolution-standardv2-2x.jpg?v=1756196877"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240522-AUnwind-FT0301-2_resolution-standardv2-2x_1024x1024.jpg?v=1756196876",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420657914,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240522-AUnwind-FT0301-2_resolution-standardv2-2x.jpg?v=1756196876"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240522-AUnwind-FT0301-2_resolution-standardv2-2x.jpg?v=1756196876",
				"width": 1999
			},
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420592378,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-6_resolution-standardv2-2x.jpg?v=1756196876"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-6_resolution-standardv2-2x.jpg?v=1756196876",
				"width": 1999
			},
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420756218,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-3_resolution-standardv2-2x.jpg?v=1756196876"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-3_resolution-standardv2-2x.jpg?v=1756196876",
				"width": 1999
			},
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420690682,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240716-AUnwind-White-4_resolution-standardv2-2x.jpg?v=1756196877"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240716-AUnwind-White-4_resolution-standardv2-2x.jpg?v=1756196877",
				"width": 1999
			},
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420788986,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-4_resolution-standardv2-2x.jpg?v=1756196877"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250116-AUnwind-FT0301-4_resolution-standardv2-2x.jpg?v=1756196877",
				"width": 1999
			},
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420723450,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240716-AUnwind-White-5_resolution-standardv2-2x.jpg?v=1756196877"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240716-AUnwind-White-5_resolution-standardv2-2x.jpg?v=1756196877",
				"width": 1999
			},
			{
				"alt": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain - TheHues",
				"id": 36071420625146,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-AFA-FT0301-display_resolution-standardv2-2x.jpg?v=1756196877"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-AFA-FT0301-display_resolution-standardv2-2x.jpg?v=1756196877",
				"width": 1999
			},
			{
				"alt": null,
				"id": 36106722803962,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/c76cd05863544e91ae731521767c5306.thumbnail.0000000000.jpg?v=1748512055"
				},
				"aspect_ratio": 0.563,
				"duration": 7290,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c76cd05863544e91ae731521767c5306/c76cd05863544e91ae731521767c5306.SD-480p-0.9Mbps-48443958.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c76cd05863544e91ae731521767c5306/c76cd05863544e91ae731521767c5306.HD-1080p-2.5Mbps-48443958.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c76cd05863544e91ae731521767c5306/c76cd05863544e91ae731521767c5306.HD-720p-1.6Mbps-48443958.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c76cd05863544e91ae731521767c5306/c76cd05863544e91ae731521767c5306.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With every flutter of light through the woven threads, the Unwind Sheer Curtains offer a soft embrace, filling your space with the gentle rhythm of calm and serenity.</p>",
		"url": "/products/unwind-linen-blend-grid-like-woven-sheer-custom-curtain",
		"regular_price": "$131.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8794304872698,
		"title": "Mia Jute Woven Shade - Straw",
		"handle": "mia-jute-woven-shade-straw",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Kenaf<br>Features: Room Darkening<br>Weight: Heavyweight (600g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"published_at": "2025-05-28T15:49:24+08:00",
		"created_at": "2025-05-28T14:04:25+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"No-drill",
			"Thanksgiving sale",
			"Woven shade"
		],
		"price": 16000,
		"price_min": 16000,
		"price_max": 16000,
		"available": true,
		"price_varies": false,
		"compare_at_price": 18900,
		"compare_at_price_min": 18900,
		"compare_at_price_max": 18900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347573489914,
				"title": "Straw",
				"option1": "Straw",
				"option2": null,
				"option3": null,
				"sku": "THRS-SWY.M1-5-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077711327482,
					"product_id": 8794304872698,
					"position": 1,
					"created_at": "2025-05-28T14:13:01+08:00",
					"updated_at": "2025-08-26T16:22:01+08:00",
					"alt": "Mia Jute Woven Shade - Straw - TheHues",
					"width": 960,
					"height": 1200,
					"src": "//thehues.com/cdn/shop/files/swym1_5.jpg?v=1756196521",
					"variant_ids": [
						47347573489914
					]
				},
				"available": true,
				"name": "Mia Jute Woven Shade - Straw - Straw",
				"public_title": "Straw",
				"options": [
					"Straw"
				],
				"price": 16000,
				"weight": 0,
				"compare_at_price": 18900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mia Jute Woven Shade - Straw - TheHues",
					"id": 36098983067898,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1200,
						"width": 960,
						"src": "//thehues.com/cdn/shop/files/swym1_5.jpg?v=1756196521"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC04093_-57_1024x1024.jpg?v=1756196521"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/swym1_5.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/DSC04087_-55.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/SWYM1_1_5.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/SWYM1_2_5.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/image00001.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/image00002_1.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/DSC04084_-54.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/DSC04093_-57.jpg?v=1756196521",
			"//thehues.com/cdn/shop/files/DSC04091_-56.jpg?v=1756196522"
		],
		"featured_image": "//thehues.com/cdn/shop/files/swym1_5_1024x1024.jpg?v=1756196521",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Mia Jute Woven Shade - Straw - TheHues",
				"id": 36098983067898,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1200,
					"width": 960,
					"src": "//thehues.com/cdn/shop/files/swym1_5.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 1200,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/swym1_5.jpg?v=1756196521",
				"width": 960
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099548938490,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04087_-55.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04087_-55.jpg?v=1756196521",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36098983100666,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_1_5.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_1_5.jpg?v=1756196521",
				"width": 2000
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36098983002362,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_2_5.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_2_5.jpg?v=1756196521",
				"width": 2000
			},
			{
				"alt": "Mia Jute Woven Shade - Straw - TheHues",
				"id": 36454234685690,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/image00001.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image00001.jpg?v=1756196521",
				"width": 1638
			},
			{
				"alt": "Mia Jute Woven Shade - Straw - TheHues",
				"id": 36454234718458,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/image00002_1.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/image00002_1.jpg?v=1756196521",
				"width": 1638
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099548905722,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04084_-54.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04084_-54.jpg?v=1756196521",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099548872954,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04093_-57.jpg?v=1756196521"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04093_-57.jpg?v=1756196521",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Straw - TheHues",
				"id": 36099549036794,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04091_-56.jpg?v=1756196522"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04091_-56.jpg?v=1756196522",
				"width": 1667
			},
			{
				"alt": null,
				"id": 36454234751226,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/ea8c68f6c3c84675bc5a94b87b082c0f.thumbnail.0000000000.jpg?v=1753838667"
				},
				"aspect_ratio": 0.563,
				"duration": 20540,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ea8c68f6c3c84675bc5a94b87b082c0f/ea8c68f6c3c84675bc5a94b87b082c0f.SD-480p-1.2Mbps-53339682.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ea8c68f6c3c84675bc5a94b87b082c0f/ea8c68f6c3c84675bc5a94b87b082c0f.HD-1080p-4.8Mbps-53339682.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ea8c68f6c3c84675bc5a94b87b082c0f/ea8c68f6c3c84675bc5a94b87b082c0f.HD-720p-3.0Mbps-53339682.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/ea8c68f6c3c84675bc5a94b87b082c0f/ea8c68f6c3c84675bc5a94b87b082c0f.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"url": "/products/mia-jute-woven-shade-straw",
		"regular_price": "$160.00",
		"sale_price": "$189.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8780129927418,
		"title": "Liwa Linen Blend Patterned Custom Curtain",
		"handle": "liwa-linen-blend-patterned-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Materia: 15% Linen &amp; 85% Polyester<br>Features: Room Darkening<br>Weight: Regular (345g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Wash At 30° Or Below</p><p>Do Not Bleach</p><p>Iron At Low Temperature</p><p>Pce Only Delicate Cleaning</p><p>Do Not Tumble Dry</p>`,
		"description": "<p>Textured with fine jacquard and made from a soft linen blend, Liwa brings earthy refinement to interiors with its desert-toned palette and dotted rhythm.</p>",
		"published_at": "2025-05-07T16:34:07+08:00",
		"created_at": "2025-05-07T16:34:07+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > beige custom curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > Textured Curtains",
			"Bestseller",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"Search curtains",
			"Search linen",
			"Summer Collection"
		],
		"price": 12700,
		"price_min": 12700,
		"price_max": 12700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319432298746,
				"title": "Dune",
				"option1": "Dune",
				"option2": null,
				"option3": null,
				"sku": "THC-138-SNAKE5-1-SD-Dune",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246095692026,
					"product_id": 8780129927418,
					"position": 1,
					"created_at": "2025-06-17T15:40:42+08:00",
					"updated_at": "2025-08-26T16:23:24+08:00",
					"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2liwa_dune.jpg?v=1756196604",
					"variant_ids": [
						47319432298746
					]
				},
				"available": true,
				"name": "Liwa Linen Blend Patterned Custom Curtain - Dune",
				"public_title": "Dune",
				"options": [
					"Dune"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
					"id": 36206962049274,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2liwa_dune.jpg?v=1756196604"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aliwa_dune_1024x1024.jpg?v=1751333643"
			},
			{
				"id": 47319432331514,
				"title": "Oat",
				"option1": "Oat",
				"option2": null,
				"option3": null,
				"sku": "THC-138-SNAKE5-1-SD-Oat",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44246095823098,
					"product_id": 8780129927418,
					"position": 9,
					"created_at": "2025-06-17T15:40:43+08:00",
					"updated_at": "2025-08-26T16:23:24+08:00",
					"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/2liwa_oat.jpg?v=1756196604",
					"variant_ids": [
						47319432331514
					]
				},
				"available": true,
				"name": "Liwa Linen Blend Patterned Custom Curtain - Oat",
				"public_title": "Oat",
				"options": [
					"Oat"
				],
				"price": 12700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
					"id": 36206962114810,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/2liwa_oat.jpg?v=1756196604"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aliwa_oat_1024x1024.jpg?v=1751333643"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/2liwa_dune.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18Y-4copy_resolution-standardv2-2x.jpg?v=1761203870",
			"//thehues.com/cdn/shop/files/liwa_dune.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02526copy2_resolution-standardv2-2x.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02522copy2_resolution-standardv2-2x.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02467copy2_resolution-standardv2-2x.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18Y-3copy_resolution-standardv2-2x.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18Y-2copy_resolution-standardv2-2x.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/2liwa_oat.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/liwa_oat.jpg?v=1756196604",
			"//thehues.com/cdn/shop/files/20250522-20250520-ADSC02987-copy2-scaled_resolution-standardv2-2x.jpg?v=1756196605",
			"//thehues.com/cdn/shop/files/20250522-20250520-A17Y-1copy_resolution-standardv2-2x.jpg?v=1761203870",
			"//thehues.com/cdn/shop/files/20250522-20250520-A17Y-4copy_resolution-standardv2-2x.jpg?v=1756196605",
			"//thehues.com/cdn/shop/files/20250522-20250520-A17Y-3copy_resolution-standardv2-2x.jpg?v=1756196605",
			"//thehues.com/cdn/shop/files/20250522-20250520-A18Y-1copy_resolution-standardv2-2x.jpg?v=1756196605"
		],
		"featured_image": "//thehues.com/cdn/shop/files/2liwa_dune_1024x1024.jpg?v=1756196604",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206962049274,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2liwa_dune.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2liwa_dune.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848018170,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-4copy_resolution-standardv2-2x.jpg?v=1761203870"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-4copy_resolution-standardv2-2x.jpg?v=1761203870",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206962016506,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/liwa_dune.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/liwa_dune.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848083706,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02526copy2_resolution-standardv2-2x.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02526copy2_resolution-standardv2-2x.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848247546,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02522copy2_resolution-standardv2-2x.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02522copy2_resolution-standardv2-2x.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848050938,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02467copy2_resolution-standardv2-2x.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02467copy2_resolution-standardv2-2x.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071847985402,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-3copy_resolution-standardv2-2x.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-3copy_resolution-standardv2-2x.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071847952634,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-2copy_resolution-standardv2-2x.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-2copy_resolution-standardv2-2x.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206962114810,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/2liwa_oat.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/2liwa_oat.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36206962147578,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/liwa_oat.jpg?v=1756196604"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/liwa_oat.jpg?v=1756196604",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848182010,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02987-copy2-scaled_resolution-standardv2-2x.jpg?v=1756196605"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-ADSC02987-copy2-scaled_resolution-standardv2-2x.jpg?v=1756196605",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848214778,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A17Y-1copy_resolution-standardv2-2x.jpg?v=1761203870"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A17Y-1copy_resolution-standardv2-2x.jpg?v=1761203870",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848149242,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A17Y-4copy_resolution-standardv2-2x.jpg?v=1756196605"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A17Y-4copy_resolution-standardv2-2x.jpg?v=1756196605",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071848116474,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A17Y-3copy_resolution-standardv2-2x.jpg?v=1756196605"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A17Y-3copy_resolution-standardv2-2x.jpg?v=1756196605",
				"width": 2000
			},
			{
				"alt": "Liwa Linen Blend Patterned Custom Curtain - TheHues",
				"id": 36071847919866,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2499,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-1copy_resolution-standardv2-2x.jpg?v=1756196605"
				},
				"aspect_ratio": 0.8,
				"height": 2499,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250522-20250520-A18Y-1copy_resolution-standardv2-2x.jpg?v=1756196605",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36133408899322,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 1,
					"height": 1080,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/05e5ce797f8740a8975067f9b90aee06.thumbnail.0000000000.jpg?v=1749088704"
				},
				"aspect_ratio": 1,
				"duration": 7340,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/05e5ce797f8740a8975067f9b90aee06/05e5ce797f8740a8975067f9b90aee06.SD-480p-1.5Mbps-48845418.mp4?v=0",
						"width": 480
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/05e5ce797f8740a8975067f9b90aee06/05e5ce797f8740a8975067f9b90aee06.HD-1080p-7.2Mbps-48845418.mp4?v=0",
						"width": 1080
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/05e5ce797f8740a8975067f9b90aee06/05e5ce797f8740a8975067f9b90aee06.HD-720p-4.5Mbps-48845418.mp4?v=0",
						"width": 720
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/05e5ce797f8740a8975067f9b90aee06/05e5ce797f8740a8975067f9b90aee06.m3u8?v=0",
						"width": 1080
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Textured with fine jacquard and made from a soft linen blend, Liwa brings earthy refinement to interiors with its desert-toned palette and dotted rhythm.</p>",
		"url": "/products/liwa-linen-blend-patterned-custom-curtain",
		"regular_price": "$127.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/textured-curtains",
				"title": "Textured Curtains"
			}
		]
	},
	{
		"id": 8794306248954,
		"title": "Toni Bamboo Woven Shade - Light",
		"handle": "toni-bamboo-woven-shade-light",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Bamboo<br>Features: Room Darkening<br>Weight: Heavyweight (710g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Bamboo's sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth's raw geometry.</p>",
		"published_at": "2025-05-28T15:49:31+08:00",
		"created_at": "2025-05-28T14:06:10+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 17300,
		"price_min": 17300,
		"price_max": 17300,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347578503418,
				"title": "Light",
				"option1": "Light",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW304-01-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077744161018,
					"product_id": 8794306248954,
					"position": 1,
					"created_at": "2025-05-28T14:17:45+08:00",
					"updated_at": "2025-08-26T16:21:44+08:00",
					"alt": "Toni Bamboo Woven Shade - Light - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW304_1_01.jpg?v=1756196504",
					"variant_ids": [
						47347578503418
					]
				},
				"available": true,
				"name": "Toni Bamboo Woven Shade - Light - Light",
				"public_title": "Light",
				"options": [
					"Light"
				],
				"price": 17300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Toni Bamboo Woven Shade - Light - TheHues",
					"id": 36099013279994,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW304_1_01.jpg?v=1756196504"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06329_2_-13_1024x1024.jpg?v=1756196504"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW304_1_01.jpg?v=1756196504",
			"//thehues.com/cdn/shop/files/DSC06325_2-11.jpg?v=1756196504",
			"//thehues.com/cdn/shop/files/SW304_2_01.jpg?v=1756196504",
			"//thehues.com/cdn/shop/files/DSC06329_2_-13.jpg?v=1756196504",
			"//thehues.com/cdn/shop/files/DSC06365_2-15.jpg?v=1756196504",
			"//thehues.com/cdn/shop/files/DSC06377_2-17.jpg?v=1756196504",
			"//thehues.com/cdn/shop/files/DSC06383_2-18.jpg?v=1756196504"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW304_1_01_1024x1024.jpg?v=1756196504",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099013279994,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_1_01.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_1_01.jpg?v=1756196504",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099498213626,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06325_2-11.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06325_2-11.jpg?v=1756196504",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099013312762,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_2_01.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_2_01.jpg?v=1756196504",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099498246394,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06329_2_-13.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06329_2_-13.jpg?v=1756196504",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099498279162,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06365_2-15.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06365_2-15.jpg?v=1756196504",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099498311930,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06377_2-17.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06377_2-17.jpg?v=1756196504",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Light - TheHues",
				"id": 36099498344698,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06383_2-18.jpg?v=1756196504"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06383_2-18.jpg?v=1756196504",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bamboo's sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth's raw geometry.</p>",
		"url": "/products/toni-bamboo-woven-shade-light",
		"regular_price": "$173.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794306085114,
		"title": "Hana Bamboo Woven Shade - Bark",
		"handle": "hana-bamboo-woven-shade-bark",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Bamboo<br>Features: Room Darkening<br>Weight: Heavyweight (1070g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Slender bamboo ribbons weave sunlight into geometry, casting rooms in the quiet choreography of shadow and grace.</p>",
		"published_at": "2025-05-28T15:49:30+08:00",
		"created_at": "2025-05-28T14:05:59+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"fall sale",
			"Halloween",
			"Indoor Woven Shade",
			"july sale",
			"No-drill",
			"Thanksgiving sale",
			"Woven shade"
		],
		"price": 13900,
		"price_min": 13900,
		"price_max": 13900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 18900,
		"compare_at_price_min": 18900,
		"compare_at_price_max": 18900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347577618682,
				"title": "Bark",
				"option1": "Bark",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW301-26-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": null,
				"available": true,
				"name": "Hana Bamboo Woven Shade - Bark - Bark",
				"public_title": "Bark",
				"options": [
					"Bark"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": 18900,
				"inventory_management": null,
				"barcode": null,
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC04122_2-63_1024x1024.jpg?v=1756196506"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/FotoJet_75_9a5a23aa-d6d6-4cc4-bbc8-21468d6d70e8.jpg?v=1756196505",
			"//thehues.com/cdn/shop/files/DSC04120_2-61.jpg?v=1756196505",
			"//thehues.com/cdn/shop/files/SW301_2_26.jpg?v=1756196505",
			"//thehues.com/cdn/shop/files/SW301_1_26.jpg?v=1756196506",
			"//thehues.com/cdn/shop/files/DSC04118_2-59.jpg?v=1756196506",
			"//thehues.com/cdn/shop/files/DSC04122_2-63.jpg?v=1756196506",
			"//thehues.com/cdn/shop/files/DSC04139_2-65.jpg?v=1756196506"
		],
		"featured_image": "//thehues.com/cdn/shop/files/FotoJet_75_9a5a23aa-d6d6-4cc4-bbc8-21468d6d70e8_1024x1024.jpg?v=1756196505",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Hana Bamboo Woven Shade - Bark - TheHues",
				"id": 36429688439034,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/FotoJet_75_9a5a23aa-d6d6-4cc4-bbc8-21468d6d70e8.jpg?v=1756196505"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/FotoJet_75_9a5a23aa-d6d6-4cc4-bbc8-21468d6d70e8.jpg?v=1756196505",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Bark - TheHues",
				"id": 36099465445626,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04120_2-61.jpg?v=1756196505"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04120_2-61.jpg?v=1756196505",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Bark - TheHues",
				"id": 36099005579514,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_2_26.jpg?v=1756196505"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_2_26.jpg?v=1756196505",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Bark - TheHues",
				"id": 36099005546746,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_1_26.jpg?v=1756196506"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_1_26.jpg?v=1756196506",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Bark - TheHues",
				"id": 36099465412858,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04118_2-59.jpg?v=1756196506"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04118_2-59.jpg?v=1756196506",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Bark - TheHues",
				"id": 36099465478394,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04122_2-63.jpg?v=1756196506"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04122_2-63.jpg?v=1756196506",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Motorized Woven Shade - Bark - TheHues",
				"id": 36099465511162,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04139_2-65.jpg?v=1756196506"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04139_2-65.jpg?v=1756196506",
				"width": 1667
			},
			{
				"alt": null,
				"id": 36399369158906,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1920,
					"width": 1080,
					"src": "//thehues.com/cdn/shop/files/preview_images/c13cb8b65e2446e98782be184edecdfc.thumbnail.0000000000.jpg?v=1752836026"
				},
				"aspect_ratio": 0.563,
				"duration": 17020,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c13cb8b65e2446e98782be184edecdfc/c13cb8b65e2446e98782be184edecdfc.SD-480p-1.5Mbps-51484976.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c13cb8b65e2446e98782be184edecdfc/c13cb8b65e2446e98782be184edecdfc.HD-1080p-7.2Mbps-51484976.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c13cb8b65e2446e98782be184edecdfc/c13cb8b65e2446e98782be184edecdfc.HD-720p-4.5Mbps-51484976.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/c13cb8b65e2446e98782be184edecdfc/c13cb8b65e2446e98782be184edecdfc.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Slender bamboo ribbons weave sunlight into geometry, casting rooms in the quiet choreography of shadow and grace.</p>",
		"url": "/products/hana-bamboo-woven-shade-bark",
		"regular_price": "$139.00",
		"sale_price": "$189.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794305954042,
		"title": "Hana Bamboo Woven Shade - Green",
		"handle": "hana-bamboo-woven-shade-green",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Bamboo<br>Features: Room Darkening<br>Weight: Heavyweight (1070g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Slender bamboo ribbons weave sunlight into geometry, casting rooms in the quiet choreography of shadow and grace.</p>",
		"published_at": "2025-05-28T15:49:30+08:00",
		"created_at": "2025-05-28T14:05:50+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 13900,
		"price_min": 13900,
		"price_max": 13900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 18900,
		"compare_at_price_min": 18900,
		"compare_at_price_max": 18900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347577127162,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW301-25-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077734887674,
					"product_id": 8794305954042,
					"position": 1,
					"created_at": "2025-05-28T14:16:42+08:00",
					"updated_at": "2025-08-26T16:21:48+08:00",
					"alt": "Hana Bamboo Woven Shade - Green - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW301_1_25.jpg?v=1756196508",
					"variant_ids": [
						47347577127162
					]
				},
				"available": true,
				"name": "Hana Bamboo Woven Shade - Green - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 13900,
				"weight": 0,
				"compare_at_price": 18900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Hana Bamboo Woven Shade - Green - TheHues",
					"id": 36099004596474,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW301_1_25.jpg?v=1756196508"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06524_-25_1024x1024.jpg?v=1756196509"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW301_1_25.jpg?v=1756196508",
			"//thehues.com/cdn/shop/files/DSC06549_-28.jpg?v=1756196509",
			"//thehues.com/cdn/shop/files/SW301_3copy2.jpg?v=1756196509",
			"//thehues.com/cdn/shop/files/SW301_2_25.jpg?v=1756196509",
			"//thehues.com/cdn/shop/files/DSC06548_-27.jpg?v=1756196509",
			"//thehues.com/cdn/shop/files/DSC06524_-25.jpg?v=1756196509",
			"//thehues.com/cdn/shop/files/DSC06544_-26.jpg?v=1756196509"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW301_1_25_1024x1024.jpg?v=1756196508",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099004596474,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_1_25.jpg?v=1756196508"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_1_25.jpg?v=1756196508",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099501129978,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06549_-28.jpg?v=1756196509"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06549_-28.jpg?v=1756196509",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099004760314,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_3copy2.jpg?v=1756196509"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_3copy2.jpg?v=1756196509",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099004727546,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW301_2_25.jpg?v=1756196509"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW301_2_25.jpg?v=1756196509",
				"width": 2000
			},
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099501097210,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06548_-27.jpg?v=1756196509"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06548_-27.jpg?v=1756196509",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099501162746,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06524_-25.jpg?v=1756196509"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06524_-25.jpg?v=1756196509",
				"width": 1667
			},
			{
				"alt": "Hana Bamboo Woven Shade - Green - TheHues",
				"id": 36099501195514,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06544_-26.jpg?v=1756196509"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06544_-26.jpg?v=1756196509",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Slender bamboo ribbons weave sunlight into geometry, casting rooms in the quiet choreography of shadow and grace.</p>",
		"url": "/products/hana-bamboo-woven-shade-green",
		"regular_price": "$139.00",
		"sale_price": "$189.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8819312689402,
		"title": "Cate 100% Linen Striped Custom Cafe Curtain",
		"handle": "cate-100-linen-striped-custom-cafe-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Linen<br>Features: Light Filtering<br>Weight: Regular (210g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Sunlight. Soft stripes. Slow mornings. These pure linen caf¨¦ curtains get it.</p>",
		"published_at": "2025-06-06T12:05:17+08:00",
		"created_at": "2025-06-06T11:43:02+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > striped custom curtains",
			"Bestseller",
			"Cafe Curtains",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Faux Linen Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 7600,
		"price_min": 7600,
		"price_max": 7600,
		"available": true,
		"price_varies": false,
		"compare_at_price": 8900,
		"compare_at_price_min": 8900,
		"compare_at_price_max": 8900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47385628279034,
				"title": "Brown",
				"option1": "Brown",
				"option2": null,
				"option3": null,
				"sku": "THCF-2506CATE-SD-Brown",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44131449929978,
					"product_id": 8819312689402,
					"position": 1,
					"created_at": "2025-06-06T11:43:35+08:00",
					"updated_at": "2025-08-26T16:20:52+08:00",
					"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/DSC04037_-13_68286b1c-aa18-4328-bf79-9357b04827c1.jpg?v=1756196452",
					"variant_ids": [
						47385628279034
					]
				},
				"available": true,
				"name": "Cate 100% Linen Striped Custom Cafe Curtain - Brown",
				"public_title": "Brown",
				"options": [
					"Brown"
				],
				"price": 7600,
				"weight": 0,
				"compare_at_price": 8900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
					"id": 36137805611258,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/DSC04037_-13_68286b1c-aa18-4328-bf79-9357b04827c1.jpg?v=1756196452"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/brown_c1abda51-3ecd-45bd-9ec6-2e4c13bde83a_1024x1024.jpg?v=1761277017"
			},
			{
				"id": 47385628311802,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THCF-2506CATE-SD-Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44131449012474,
					"product_id": 8819312689402,
					"position": 10,
					"created_at": "2025-06-06T11:43:31+08:00",
					"updated_at": "2025-08-26T16:20:53+08:00",
					"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/DSC04076_-16_53790f96-b962-4140-9716-9a624fc0351d.jpg?v=1756196453",
					"variant_ids": [
						47385628311802
					]
				},
				"available": true,
				"name": "Cate 100% Linen Striped Custom Cafe Curtain - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 7600,
				"weight": 0,
				"compare_at_price": 8900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
					"id": 36137805119738,
					"position": 10,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/DSC04076_-16_53790f96-b962-4140-9716-9a624fc0351d.jpg?v=1756196453"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/blue_a395fd0e-e8ef-4917-9576-d1e01fb22177_1024x1024.jpg?v=1761277017"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/DSC04037_-13_68286b1c-aa18-4328-bf79-9357b04827c1.jpg?v=1756196452",
			"//thehues.com/cdn/shop/files/DSC04026_-10_5619e607-c6b5-4212-a9c7-575afe46e77b.jpg?v=1756196452",
			"//thehues.com/cdn/shop/files/DSC04020_-8_6289fbd4-5270-44b4-93cb-9f2a8e3e404f.jpg?v=1756196452",
			"//thehues.com/cdn/shop/files/DSC04030_-11_f9dd5d62-511c-4013-9103-8c7c1a8c4d13.jpg?v=1756196452",
			"//thehues.com/cdn/shop/files/DSC04012_-6_67d770d5-b868-428e-aabd-cbbad9dc633b.jpg?v=1756196452",
			"//thehues.com/cdn/shop/files/DSC04024_-9_31b200cd-a24b-4f1f-97f6-7ec93499e1b8.jpg?v=1756196452",
			"//thehues.com/cdn/shop/files/9596ac9e7c739f3f8369dbf349bf2139_cabe7833-1d5b-41c5-89c7-083f4e2ad47b.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04014_-7_163efcdb-d5aa-4700-81a5-2428a4601735.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/brown_c1abda51-3ecd-45bd-9ec6-2e4c13bde83a.jpg?v=1761277017",
			"//thehues.com/cdn/shop/files/DSC04076_-16_53790f96-b962-4140-9716-9a624fc0351d.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04069_-15_67378c80-cd77-4464-a066-bf7c883bb552.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC03998_-1_421f48f5-42e6-4085-874f-950f44b51680.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04011_-5_f21f1316-32bc-4f82-afd5-6703aee6583d.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04008_-4_7dbd3262-33a0-43cd-80ac-ea619266e4ce.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04005_-3_f9dfaf9a-6b0f-4e9a-ae0d-2acd59ec2ddf.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/blue_a395fd0e-e8ef-4917-9576-d1e01fb22177.jpg?v=1761277017",
			"//thehues.com/cdn/shop/files/DSC04042_-14_3fdd87ca-6293-4c27-82a8-a2cbfebe7983.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04003_-2_08581391-85ba-4f77-83e3-ec9bdb0f1397.jpg?v=1756196453",
			"//thehues.com/cdn/shop/files/DSC04034_-12_86c2e361-a11b-41b8-b9c0-4cdc3197debf.jpg?v=1756196454"
		],
		"featured_image": "//thehues.com/cdn/shop/files/DSC04037_-13_68286b1c-aa18-4328-bf79-9357b04827c1_1024x1024.jpg?v=1756196452",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805611258,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04037_-13_68286b1c-aa18-4328-bf79-9357b04827c1.jpg?v=1756196452"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04037_-13_68286b1c-aa18-4328-bf79-9357b04827c1.jpg?v=1756196452",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805512954,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04026_-10_5619e607-c6b5-4212-a9c7-575afe46e77b.jpg?v=1756196452"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04026_-10_5619e607-c6b5-4212-a9c7-575afe46e77b.jpg?v=1756196452",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805447418,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04020_-8_6289fbd4-5270-44b4-93cb-9f2a8e3e404f.jpg?v=1756196452"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04020_-8_6289fbd4-5270-44b4-93cb-9f2a8e3e404f.jpg?v=1756196452",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805545722,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04030_-11_f9dd5d62-511c-4013-9103-8c7c1a8c4d13.jpg?v=1756196452"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04030_-11_f9dd5d62-511c-4013-9103-8c7c1a8c4d13.jpg?v=1756196452",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805381882,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04012_-6_67d770d5-b868-428e-aabd-cbbad9dc633b.jpg?v=1756196452"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04012_-6_67d770d5-b868-428e-aabd-cbbad9dc633b.jpg?v=1756196452",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805480186,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04024_-9_31b200cd-a24b-4f1f-97f6-7ec93499e1b8.jpg?v=1756196452"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04024_-9_31b200cd-a24b-4f1f-97f6-7ec93499e1b8.jpg?v=1756196452",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805316346,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.715,
					"height": 730,
					"width": 522,
					"src": "//thehues.com/cdn/shop/files/9596ac9e7c739f3f8369dbf349bf2139_cabe7833-1d5b-41c5-89c7-083f4e2ad47b.jpg?v=1756196453"
				},
				"aspect_ratio": 0.715,
				"height": 730,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/9596ac9e7c739f3f8369dbf349bf2139_cabe7833-1d5b-41c5-89c7-083f4e2ad47b.jpg?v=1756196453",
				"width": 522
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805414650,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04014_-7_163efcdb-d5aa-4700-81a5-2428a4601735.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04014_-7_163efcdb-d5aa-4700-81a5-2428a4601735.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805349114,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/brown_c1abda51-3ecd-45bd-9ec6-2e4c13bde83a.jpg?v=1761277017"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/brown_c1abda51-3ecd-45bd-9ec6-2e4c13bde83a.jpg?v=1761277017",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805119738,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04076_-16_53790f96-b962-4140-9716-9a624fc0351d.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04076_-16_53790f96-b962-4140-9716-9a624fc0351d.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805086970,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04069_-15_67378c80-cd77-4464-a066-bf7c883bb552.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04069_-15_67378c80-cd77-4464-a066-bf7c883bb552.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137804923130,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC03998_-1_421f48f5-42e6-4085-874f-950f44b51680.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03998_-1_421f48f5-42e6-4085-874f-950f44b51680.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805054202,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04011_-5_f21f1316-32bc-4f82-afd5-6703aee6583d.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04011_-5_f21f1316-32bc-4f82-afd5-6703aee6583d.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805021434,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04008_-4_7dbd3262-33a0-43cd-80ac-ea619266e4ce.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04008_-4_7dbd3262-33a0-43cd-80ac-ea619266e4ce.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137804988666,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04005_-3_f9dfaf9a-6b0f-4e9a-ae0d-2acd59ec2ddf.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04005_-3_f9dfaf9a-6b0f-4e9a-ae0d-2acd59ec2ddf.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805152506,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/blue_a395fd0e-e8ef-4917-9576-d1e01fb22177.jpg?v=1761277017"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/blue_a395fd0e-e8ef-4917-9576-d1e01fb22177.jpg?v=1761277017",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805644026,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04042_-14_3fdd87ca-6293-4c27-82a8-a2cbfebe7983.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04042_-14_3fdd87ca-6293-4c27-82a8-a2cbfebe7983.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137804955898,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04003_-2_08581391-85ba-4f77-83e3-ec9bdb0f1397.jpg?v=1756196453"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04003_-2_08581391-85ba-4f77-83e3-ec9bdb0f1397.jpg?v=1756196453",
				"width": 2000
			},
			{
				"alt": "Cate 100% Linen Striped Custom Cafe Curtain - TheHues",
				"id": 36137805578490,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/DSC04034_-12_86c2e361-a11b-41b8-b9c0-4cdc3197debf.jpg?v=1756196454"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04034_-12_86c2e361-a11b-41b8-b9c0-4cdc3197debf.jpg?v=1756196454",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Sunlight. Soft stripes. Slow mornings. These pure linen caf¨¦ curtains get it.</p>",
		"url": "/products/cate-100-linen-striped-custom-cafe-curtain",
		"regular_price": "$76.00",
		"sale_price": "$89.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cafe-curtains",
				"title": "Cafe Curtains"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/striped-curtain",
				"title": "Striped Curtain"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8865035059450,
		"title": "Thistle Sheer Flat Fold Custom Roman Shade",
		"handle": "thistle-sheer-flat-fold-custom-roman-shade",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Linen<br>Features: Light Filtering<br>Weight: Regular (210g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Sheer Roman shade in a soft yet rigidly structured fabric with a sleek flat fold, custom-made to your window¡¯s exact measurements. Mount on the wall or ceiling, with a complete installation kit included. ?Add motorized operation for smooth motion control.</p>",
		"published_at": "2025-07-25T17:38:31+08:00",
		"created_at": "2025-07-22T17:43:09+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"fall sale",
			"New Arrival",
			"New Arrivals",
			"Roman Shade",
			"Thanksgiving sale"
		],
		"price": 24100,
		"price_min": 24100,
		"price_max": 24100,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47531933335802,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THRS-MBH-DKS-H2-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44588588302586,
					"product_id": 8865035059450,
					"position": 1,
					"created_at": "2025-07-24T17:28:46+08:00",
					"updated_at": "2025-08-26T16:18:16+08:00",
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Thistle_Beige5_dca139bb-7480-4095-9506-1f069105b985.jpg?v=1756196296",
					"variant_ids": [
						47531933335802
					]
				},
				"available": true,
				"name": "Thistle Sheer Flat Fold Custom Roman Shade - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 24100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"id": 36425738682618,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Thistle_Beige5_dca139bb-7480-4095-9506-1f069105b985.jpg?v=1756196296"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Thistle_Beige_1024x1024.jpg?v=1753840926"
			},
			{
				"id": 47531933303034,
				"title": "Dark Beige",
				"option1": "Dark Beige",
				"option2": null,
				"option3": null,
				"sku": "THRS-MBH-DKS-H1-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44588589449466,
					"product_id": 8865035059450,
					"position": 3,
					"created_at": "2025-07-24T17:29:11+08:00",
					"updated_at": "2025-08-26T16:18:16+08:00",
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige5_afac327a-84ca-4d88-9db8-0e122aa5546c.jpg?v=1756196296",
					"variant_ids": [
						47531933303034
					]
				},
				"available": true,
				"name": "Thistle Sheer Flat Fold Custom Roman Shade - Dark Beige",
				"public_title": "Dark Beige",
				"options": [
					"Dark Beige"
				],
				"price": 24100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"id": 36425739829498,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige5_afac327a-84ca-4d88-9db8-0e122aa5546c.jpg?v=1756196296"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Thistle_DARKBeige_1024x1024.jpg?v=1753840925"
			},
			{
				"id": 47531933368570,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THRS-MBH-DKS-H3-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44588589252858,
					"product_id": 8865035059450,
					"position": 11,
					"created_at": "2025-07-24T17:29:07+08:00",
					"updated_at": "2025-08-26T16:18:17+08:00",
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Thistle_BLUE5_b2c2ba90-ead8-465e-bd1c-ecdd2474b73a.jpg?v=1756196297",
					"variant_ids": [
						47531933368570
					]
				},
				"available": true,
				"name": "Thistle Sheer Flat Fold Custom Roman Shade - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 24100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"id": 36425739632890,
					"position": 11,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Thistle_BLUE5_b2c2ba90-ead8-465e-bd1c-ecdd2474b73a.jpg?v=1756196297"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Thistle_BLUE_1024x1024.jpg?v=1753840926"
			},
			{
				"id": 47531933401338,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THRS-MBH-DKS-H4-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44588591972602,
					"product_id": 8865035059450,
					"position": 16,
					"created_at": "2025-07-24T17:29:18+08:00",
					"updated_at": "2025-08-26T16:18:18+08:00",
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE5_4004324a-8ec7-47d0-83d8-83988e5ce0ea.jpg?v=1756196298",
					"variant_ids": [
						47531933401338
					]
				},
				"available": true,
				"name": "Thistle Sheer Flat Fold Custom Roman Shade - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 24100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"id": 36425742352634,
					"position": 16,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE5_4004324a-8ec7-47d0-83d8-83988e5ce0ea.jpg?v=1756196298"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Thistle_TAUPE_1024x1024.jpg?v=1753840926"
			},
			{
				"id": 47531933434106,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THRS-MBH-DKS-H5-SD",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44588594921722,
					"product_id": 8865035059450,
					"position": 21,
					"created_at": "2025-07-24T17:29:57+08:00",
					"updated_at": "2025-08-26T16:18:18+08:00",
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/Thistle_WHITE5_acca6624-209a-4bc4-8e8d-39cf65604a86.jpg?v=1756196298",
					"variant_ids": [
						47531933434106
					]
				},
				"available": true,
				"name": "Thistle Sheer Flat Fold Custom Roman Shade - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 24100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
					"id": 36425743270138,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/Thistle_WHITE5_acca6624-209a-4bc4-8e8d-39cf65604a86.jpg?v=1756196298"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Thistle_WHITE_1024x1024.jpg?v=1753840926"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/Thistle_Beige5_dca139bb-7480-4095-9506-1f069105b985.jpg?v=1756196296",
			"//thehues.com/cdn/shop/files/Thistle_Beige1_7d18b09b-d7e4-4edd-8595-3b5f6de88e85.jpg?v=1756196296",
			"//thehues.com/cdn/shop/files/Thistle_DARKBeige5_afac327a-84ca-4d88-9db8-0e122aa5546c.jpg?v=1756196296",
			"//thehues.com/cdn/shop/files/Thistle_DARKBeige4_ed35c7ae-475d-4b6c-8803-9b2865139c4c.jpg?v=1756196296",
			"//thehues.com/cdn/shop/files/Thistle_DARKBeige3_46fecda2-228c-43fe-b88c-882dc4f2ab70.jpg?v=1756196296",
			"//thehues.com/cdn/shop/files/Thistle_DARKBeige1_67e6b768-631a-4a7a-9502-8ce85b2e2471.jpg?v=1756196296",
			"//thehues.com/cdn/shop/files/Thistle_DARKBeige2_d840bb5f-1e38-40f0-8836-b1e02013f075.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_Beige4_1304fa20-652e-47e2-b622-bd0c609071c9.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_Beige3_cc65bff5-8c48-48ca-957a-fcd8ef29c43f.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_Beige2_95274699-4d62-4176-bd79-8ae28cc2c0d4.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_BLUE5_b2c2ba90-ead8-465e-bd1c-ecdd2474b73a.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_BLUE4_d6f9a0e2-6800-4c8c-b1d4-fb83a9d14680.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_BLUE3_2e688a86-3c0b-40ec-b622-e91ee2ba3677.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_BLUE1_35a437d4-cf11-43a9-a2b7-ed701f2e0b5a.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_BLUE2_e30b94e8-6eb9-4410-981d-4471f94646f1.jpg?v=1756196297",
			"//thehues.com/cdn/shop/files/Thistle_TAUPE5_4004324a-8ec7-47d0-83d8-83988e5ce0ea.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_TAUPE4_e808254d-9557-475d-9eb8-9f411b03714b.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_TAUPE3_51707cea-7ac7-4bcc-bd6a-3e9c0d1187de.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_TAUPE1_8a1cc979-61cd-49b3-97c0-ba011bc0ba25.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_TAUPE2_5df69523-ebd9-466c-928e-f3cb475b613f.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_WHITE5_acca6624-209a-4bc4-8e8d-39cf65604a86.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_WHITE4_ad7dde95-ceb4-4fd3-969f-61c070ce165b.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_WHITE3_f5da81f7-ef9d-47ba-b624-ca68a235d09f.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_WHITE1_3ccd9b08-0da0-4409-a2ff-07d02a9e2d82.jpg?v=1756196298",
			"//thehues.com/cdn/shop/files/Thistle_WHITE2_aef02b53-6504-464d-a9f4-c5d08d24ba27.jpg?v=1756196298"
		],
		"featured_image": "//thehues.com/cdn/shop/files/Thistle_Beige5_dca139bb-7480-4095-9506-1f069105b985_1024x1024.jpg?v=1756196296",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425738682618,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_Beige5_dca139bb-7480-4095-9506-1f069105b985.jpg?v=1756196296"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_Beige5_dca139bb-7480-4095-9506-1f069105b985.jpg?v=1756196296",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425738551546,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_Beige1_7d18b09b-d7e4-4edd-8595-3b5f6de88e85.jpg?v=1756196296"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_Beige1_7d18b09b-d7e4-4edd-8595-3b5f6de88e85.jpg?v=1756196296",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739829498,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige5_afac327a-84ca-4d88-9db8-0e122aa5546c.jpg?v=1756196296"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige5_afac327a-84ca-4d88-9db8-0e122aa5546c.jpg?v=1756196296",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739796730,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige4_ed35c7ae-475d-4b6c-8803-9b2865139c4c.jpg?v=1756196296"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige4_ed35c7ae-475d-4b6c-8803-9b2865139c4c.jpg?v=1756196296",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739763962,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige3_46fecda2-228c-43fe-b88c-882dc4f2ab70.jpg?v=1756196296"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige3_46fecda2-228c-43fe-b88c-882dc4f2ab70.jpg?v=1756196296",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739698426,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige1_67e6b768-631a-4a7a-9502-8ce85b2e2471.jpg?v=1756196296"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige1_67e6b768-631a-4a7a-9502-8ce85b2e2471.jpg?v=1756196296",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739731194,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige2_d840bb5f-1e38-40f0-8836-b1e02013f075.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_DARKBeige2_d840bb5f-1e38-40f0-8836-b1e02013f075.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425738649850,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_Beige4_1304fa20-652e-47e2-b622-bd0c609071c9.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_Beige4_1304fa20-652e-47e2-b622-bd0c609071c9.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425738617082,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_Beige3_cc65bff5-8c48-48ca-957a-fcd8ef29c43f.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_Beige3_cc65bff5-8c48-48ca-957a-fcd8ef29c43f.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425738584314,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_Beige2_95274699-4d62-4176-bd79-8ae28cc2c0d4.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_Beige2_95274699-4d62-4176-bd79-8ae28cc2c0d4.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739632890,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_BLUE5_b2c2ba90-ead8-465e-bd1c-ecdd2474b73a.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_BLUE5_b2c2ba90-ead8-465e-bd1c-ecdd2474b73a.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739567354,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_BLUE4_d6f9a0e2-6800-4c8c-b1d4-fb83a9d14680.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_BLUE4_d6f9a0e2-6800-4c8c-b1d4-fb83a9d14680.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739600122,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_BLUE3_2e688a86-3c0b-40ec-b622-e91ee2ba3677.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_BLUE3_2e688a86-3c0b-40ec-b622-e91ee2ba3677.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739534586,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_BLUE1_35a437d4-cf11-43a9-a2b7-ed701f2e0b5a.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_BLUE1_35a437d4-cf11-43a9-a2b7-ed701f2e0b5a.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425739501818,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_BLUE2_e30b94e8-6eb9-4410-981d-4471f94646f1.jpg?v=1756196297"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_BLUE2_e30b94e8-6eb9-4410-981d-4471f94646f1.jpg?v=1756196297",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425742352634,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE5_4004324a-8ec7-47d0-83d8-83988e5ce0ea.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE5_4004324a-8ec7-47d0-83d8-83988e5ce0ea.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425742319866,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE4_e808254d-9557-475d-9eb8-9f411b03714b.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE4_e808254d-9557-475d-9eb8-9f411b03714b.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425742418170,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE3_51707cea-7ac7-4bcc-bd6a-3e9c0d1187de.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE3_51707cea-7ac7-4bcc-bd6a-3e9c0d1187de.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425742287098,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE1_8a1cc979-61cd-49b3-97c0-ba011bc0ba25.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE1_8a1cc979-61cd-49b3-97c0-ba011bc0ba25.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425742385402,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE2_5df69523-ebd9-466c-928e-f3cb475b613f.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_TAUPE2_5df69523-ebd9-466c-928e-f3cb475b613f.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425743270138,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_WHITE5_acca6624-209a-4bc4-8e8d-39cf65604a86.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_WHITE5_acca6624-209a-4bc4-8e8d-39cf65604a86.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425743302906,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_WHITE4_ad7dde95-ceb4-4fd3-969f-61c070ce165b.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_WHITE4_ad7dde95-ceb4-4fd3-969f-61c070ce165b.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425743237370,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_WHITE3_f5da81f7-ef9d-47ba-b624-ca68a235d09f.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_WHITE3_f5da81f7-ef9d-47ba-b624-ca68a235d09f.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425743335674,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_WHITE1_3ccd9b08-0da0-4409-a2ff-07d02a9e2d82.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_WHITE1_3ccd9b08-0da0-4409-a2ff-07d02a9e2d82.jpg?v=1756196298",
				"width": 2000
			},
			{
				"alt": "Thistle Sheer Flat Fold Custom Roman Shade - TheHues",
				"id": 36425743204602,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/Thistle_WHITE2_aef02b53-6504-464d-a9f4-c5d08d24ba27.jpg?v=1756196298"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/Thistle_WHITE2_aef02b53-6504-464d-a9f4-c5d08d24ba27.jpg?v=1756196298",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Sheer Roman shade in a soft yet rigidly structured fabric with a sleek flat fold, custom-made to your window¡¯s exact measurements. Mount on the wall or ceiling, with a complete installation kit included. ?Add motorized operation for smooth motion control.</p>",
		"url": "/products/thistle-sheer-flat-fold-custom-roman-shade",
		"regular_price": "$241.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/popular-product",
				"title": "Popular Product"
			},
			{
				"url": "/collections/roman-shade",
				"title": "Roman Shades"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			}
		]
	},
	{
		"id": 8780122915066,
		"title": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain",
		"handle": "raw-linen-blend-striped-patterned-semi-sheer-custom-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 95% Polyester &amp; 5% Linen<br>Features: Raw Rustic Linen Sheer Fabric<br>Weight: Sheer (140g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Dry wash only</p><p>Do Not Dry</p><p>Do not bleach</p><p>Safe to Iron</p><p>Dry Clean Allowed</p>`,
		"description": "<p>With their striped pattern in soothing neutral colors, Raw curtains provide a gentle, translucent elegance that enhances your space with a quiet, natural beauty.</p>",
		"published_at": "2025-05-07T16:30:32+08:00",
		"created_at": "2025-05-07T16:30:32+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > farmhouse custom curtains",
			"All Curtains > mid century custom curtains",
			"All Curtains > New Sheer Curtains",
			"All Curtains > patterned custom curtains",
			"All Curtains > pinch pleat custom curtains",
			"All Curtains > striped custom curtains",
			"Bestseller",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Sheer Curtains",
			"Curtains > Faux Linen Curtains",
			"Curtains > Light Filtering Curtains",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Blend Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"Easter Sale",
			"Extra 10%",
			"flash_categories",
			"Independence Day",
			"indoor curtain",
			"Indoor Sheer Curtains",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search faux linen blackout",
			"Search linen",
			"Search Linen blend curtains",
			"Search sheer"
		],
		"price": 9800,
		"price_min": 9800,
		"price_max": 9800,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319411917050,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-138FA-KFW090-C",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44037682462970,
					"product_id": 8780122915066,
					"position": 1,
					"created_at": "2025-05-22T18:26:36+08:00",
					"updated_at": "2025-08-26T16:27:44+08:00",
					"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
					"width": 1999,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/20240526-ANatural-4_resolution-standardv2-2x.jpg?v=1756196864",
					"variant_ids": [
						47319411917050
					]
				},
				"available": true,
				"name": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 9800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
					"id": 36071668187386,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 1999,
						"src": "//thehues.com/cdn/shop/files/20240526-ANatural-4_resolution-standardv2-2x.jpg?v=1756196864"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/raw_Natural_1024x1024.jpg?v=1751335608"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/20240526-ANatural-4_resolution-standardv2-2x.jpg?v=1756196864",
			"//thehues.com/cdn/shop/files/20240524-ANatural-1_resolution-standardv2-2x.jpg?v=1756196864",
			"//thehues.com/cdn/shop/files/20250516-ANatural-3_resolution-standardv2-2x-2.jpg?v=1756196864",
			"//thehues.com/cdn/shop/files/20250516-Group-1000005883.jpg?v=1756196864",
			"//thehues.com/cdn/shop/files/20250516-ANatural-2_resolution-standardv2-2x-2.jpg?v=1756196864",
			"//thehues.com/cdn/shop/files/20250516-ANatural-3_resolution-standardv2-2x_654ed54b-564e-4d0b-bfce-65062c18a8d9.jpg?v=1756196864",
			"//thehues.com/cdn/shop/files/20250516-ANatural-1_resolution-standardv2-2x-2.jpg?v=1756196864"
		],
		"featured_image": "//thehues.com/cdn/shop/files/20240526-ANatural-4_resolution-standardv2-2x_1024x1024.jpg?v=1756196864",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
				"id": 36071668187386,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240526-ANatural-4_resolution-standardv2-2x.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240526-ANatural-4_resolution-standardv2-2x.jpg?v=1756196864",
				"width": 1999
			},
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Cafe Curtain - TheHues",
				"id": 36071668154618,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20240524-ANatural-1_resolution-standardv2-2x.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20240524-ANatural-1_resolution-standardv2-2x.jpg?v=1756196864",
				"width": 1999
			},
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
				"id": 36071668089082,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ANatural-3_resolution-standardv2-2x-2.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ANatural-3_resolution-standardv2-2x-2.jpg?v=1756196864",
				"width": 1999
			},
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
				"id": 36071668121850,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/20250516-Group-1000005883.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-Group-1000005883.jpg?v=1756196864",
				"width": 2000
			},
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
				"id": 36071668285690,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ANatural-2_resolution-standardv2-2x-2.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ANatural-2_resolution-standardv2-2x-2.jpg?v=1756196864",
				"width": 1999
			},
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain - TheHues",
				"id": 36071668351226,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ANatural-3_resolution-standardv2-2x_654ed54b-564e-4d0b-bfce-65062c18a8d9.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ANatural-3_resolution-standardv2-2x_654ed54b-564e-4d0b-bfce-65062c18a8d9.jpg?v=1756196864",
				"width": 1999
			},
			{
				"alt": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Cafe Curtain - TheHues",
				"id": 36071668252922,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 1999,
					"src": "//thehues.com/cdn/shop/files/20250516-ANatural-1_resolution-standardv2-2x-2.jpg?v=1756196864"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/20250516-ANatural-1_resolution-standardv2-2x-2.jpg?v=1756196864",
				"width": 1999
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With their striped pattern in soothing neutral colors, Raw curtains provide a gentle, translucent elegance that enhances your space with a quiet, natural beauty.</p>",
		"url": "/products/raw-linen-blend-striped-patterned-semi-sheer-custom-curtain",
		"regular_price": "$98.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-light-filtering-curtains",
				"title": "Advert Light Filtering Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/light-filtering-curtains",
				"title": "Light Filtering Curtains"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/patterned-curtains",
				"title": "Patterned Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sheer-curtains",
				"title": "Sheer Curtains"
			},
			{
				"url": "/collections/striped-curtain",
				"title": "Striped Curtain"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8794306412794,
		"title": "Toni Bamboo Woven Shade - Tan",
		"handle": "toni-bamboo-woven-shade-tan",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Bamboo<br>Features: Room Darkening<br>Weight: Heavyweight (710g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Bamboo's sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth's raw geometry.</p>",
		"published_at": "2025-05-28T15:49:32+08:00",
		"created_at": "2025-05-28T14:06:18+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 17300,
		"price_min": 17300,
		"price_max": 17300,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347578667258,
				"title": "Tan",
				"option1": "Tan",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW304-03-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44078220017914,
					"product_id": 8794306412794,
					"position": 1,
					"created_at": "2025-05-28T15:27:45+08:00",
					"updated_at": "2025-08-26T16:21:42+08:00",
					"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
					"width": 1667,
					"height": 2084,
					"src": "//thehues.com/cdn/shop/files/DSC06383_-19.jpg?v=1756196502",
					"variant_ids": [
						47347578667258
					]
				},
				"available": true,
				"name": "Toni Bamboo Woven Shade - Tan - Tan",
				"public_title": "Tan",
				"options": [
					"Tan"
				],
				"price": 17300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
					"id": 36099453550842,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2084,
						"width": 1667,
						"src": "//thehues.com/cdn/shop/files/DSC06383_-19.jpg?v=1756196502"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06365_-14_1024x1024.jpg?v=1756196503"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/DSC06383_-19.jpg?v=1756196502",
			"//thehues.com/cdn/shop/files/DSC06325_-10.jpg?v=1756196502",
			"//thehues.com/cdn/shop/files/SW304_1_03.jpg?v=1756196502",
			"//thehues.com/cdn/shop/files/SW304_2_03.jpg?v=1756196502",
			"//thehues.com/cdn/shop/files/DSC06377_-16.jpg?v=1756196502",
			"//thehues.com/cdn/shop/files/DSC06329_-12.jpg?v=1756196502",
			"//thehues.com/cdn/shop/files/DSC06365_-14.jpg?v=1756196503"
		],
		"featured_image": "//thehues.com/cdn/shop/files/DSC06383_-19_1024x1024.jpg?v=1756196502",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099453550842,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06383_-19.jpg?v=1756196502"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06383_-19.jpg?v=1756196502",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099453387002,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06325_-10.jpg?v=1756196502"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06325_-10.jpg?v=1756196502",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099013837050,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_1_03.jpg?v=1756196502"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_1_03.jpg?v=1756196502",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099013869818,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_2_03.jpg?v=1756196502"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_2_03.jpg?v=1756196502",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099453518074,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06377_-16.jpg?v=1756196502"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06377_-16.jpg?v=1756196502",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099453419770,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06329_-12.jpg?v=1756196502"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06329_-12.jpg?v=1756196502",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Tan - TheHues",
				"id": 36099453485306,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06365_-14.jpg?v=1756196503"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06365_-14.jpg?v=1756196503",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bamboo's sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth's raw geometry.</p>",
		"url": "/products/toni-bamboo-woven-shade-tan",
		"regular_price": "$173.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794301497594,
		"title": "Mia Jute Woven Shade - Sand",
		"handle": "mia-jute-woven-shade-sand",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Kenaf<br>Features: Room Darkening<br>Weight: Heavyweight (426g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"published_at": "2025-05-28T15:49:23+08:00",
		"created_at": "2025-05-28T13:59:00+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 15900,
		"price_min": 15900,
		"price_max": 15900,
		"available": true,
		"price_varies": false,
		"compare_at_price": 17900,
		"compare_at_price_min": 17900,
		"compare_at_price_max": 17900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347556221178,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THRS-SWY.M1-4-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44595470336250,
					"product_id": 8794301497594,
					"position": 1,
					"created_at": "2025-07-25T14:52:51+08:00",
					"updated_at": "2025-08-26T16:22:03+08:00",
					"alt": "Mia Jute Woven Shade - Sand - TheHues",
					"width": 2790,
					"height": 3487,
					"src": "//thehues.com/cdn/shop/files/1753423100204_lQDPKH1vv0TKvJ3NDZ_NCuawKsRzLgpb6LYIYDYZ5kQ0AA_2790_3487_copy.jpg?v=1756196523",
					"variant_ids": [
						47347556221178
					]
				},
				"available": true,
				"name": "Mia Jute Woven Shade - Sand - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 15900,
				"weight": 0,
				"compare_at_price": 17900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mia Jute Woven Shade - Sand - TheHues",
					"id": 36429318127866,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 3487,
						"width": 2790,
						"src": "//thehues.com/cdn/shop/files/1753423100204_lQDPKH1vv0TKvJ3NDZ_NCuawKsRzLgpb6LYIYDYZ5kQ0AA_2790_3487_copy.jpg?v=1756196523"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC03453_-46_1024x1024.jpg?v=1756196524"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/1753423100204_lQDPKH1vv0TKvJ3NDZ_NCuawKsRzLgpb6LYIYDYZ5kQ0AA_2790_3487_copy.jpg?v=1756196523",
			"//thehues.com/cdn/shop/files/SWYM1_2_4.jpg?v=1756196524",
			"//thehues.com/cdn/shop/files/SWYM1_3_4.jpg?v=1756196524",
			"//thehues.com/cdn/shop/files/DSC04238_-67.jpg?v=1756196524",
			"//thehues.com/cdn/shop/files/DSC03429_-45.jpg?v=1756196524",
			"//thehues.com/cdn/shop/files/DSC03453_-46.jpg?v=1756196524",
			"//thehues.com/cdn/shop/files/DSC04229_-66.jpg?v=1756196524"
		],
		"featured_image": "//thehues.com/cdn/shop/files/1753423100204_lQDPKH1vv0TKvJ3NDZ_NCuawKsRzLgpb6LYIYDYZ5kQ0AA_2790_3487_copy_1024x1024.jpg?v=1756196523",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Mia Jute Woven Shade - Sand - TheHues",
				"id": 36429318127866,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 3487,
					"width": 2790,
					"src": "//thehues.com/cdn/shop/files/1753423100204_lQDPKH1vv0TKvJ3NDZ_NCuawKsRzLgpb6LYIYDYZ5kQ0AA_2790_3487_copy.jpg?v=1756196523"
				},
				"aspect_ratio": 0.8,
				"height": 3487,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/1753423100204_lQDPKH1vv0TKvJ3NDZ_NCuawKsRzLgpb6LYIYDYZ5kQ0AA_2790_3487_copy.jpg?v=1756196523",
				"width": 2790
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Sand - TheHues",
				"id": 36099034743034,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_2_4.jpg?v=1756196524"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_2_4.jpg?v=1756196524",
				"width": 2000
			},
			{
				"alt": "Mia Jute Woven Shade - Sand - TheHues",
				"id": 36099034775802,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_3_4.jpg?v=1756196524"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_3_4.jpg?v=1756196524",
				"width": 2000
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Sand - TheHues",
				"id": 36099546939642,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04238_-67.jpg?v=1756196524"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04238_-67.jpg?v=1756196524",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Sand - TheHues",
				"id": 36099547005178,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03429_-45.jpg?v=1756196524"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03429_-45.jpg?v=1756196524",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Sand - TheHues",
				"id": 36099547037946,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03453_-46.jpg?v=1756196524"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03453_-46.jpg?v=1756196524",
				"width": 1667
			},
			{
				"alt": "Mia Jute Motorized Woven Shade - Sand - TheHues",
				"id": 36099547070714,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04229_-66.jpg?v=1756196524"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04229_-66.jpg?v=1756196524",
				"width": 1667
			},
			{
				"alt": null,
				"id": 36409968296186,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.563,
					"height": 1280,
					"width": 720,
					"src": "//thehues.com/cdn/shop/files/preview_images/64f1ba22066a4e79bcc59aacd1803d72.thumbnail.0000000000.jpg?v=1753090841"
				},
				"aspect_ratio": 0.563,
				"duration": 23520,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/64f1ba22066a4e79bcc59aacd1803d72/64f1ba22066a4e79bcc59aacd1803d72.SD-480p-0.9Mbps-51618092.mp4?v=0",
						"width": 270
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/64f1ba22066a4e79bcc59aacd1803d72/64f1ba22066a4e79bcc59aacd1803d72.HD-1080p-2.5Mbps-51618092.mp4?v=0",
						"width": 606
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/64f1ba22066a4e79bcc59aacd1803d72/64f1ba22066a4e79bcc59aacd1803d72.HD-720p-1.6Mbps-51618092.mp4?v=0",
						"width": 404
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/64f1ba22066a4e79bcc59aacd1803d72/64f1ba22066a4e79bcc59aacd1803d72.m3u8?v=0",
						"width": 606
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"url": "/products/mia-jute-woven-shade-sand",
		"regular_price": "$159.00",
		"sale_price": "$179.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8830959091962,
		"title": "Tahiti 100% Linen Custom Curtain",
		"handle": "tahiti-100-custom-linen-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Linen<br>Features: Light Filtering<br>Weight: Regular (300g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Tahiti is 100% pure linen at its finest¡ªlight, breathable, and effortlessly elegant, like a breeze drifting through open windows.</p>",
		"published_at": "2025-06-18T19:05:36+08:00",
		"created_at": "2025-06-11T18:19:43+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"flash_categories",
			"indoor curtain",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat"
		],
		"price": 18900,
		"price_min": 18900,
		"price_max": 18900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47405474971898,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THC-DMG-3A160-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287879774458,
					"product_id": 8830959091962,
					"position": 9,
					"created_at": "2025-06-20T18:49:42+08:00",
					"updated_at": "2025-08-26T16:19:45+08:00",
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2501,
					"src": "//thehues.com/cdn/shop/files/A017_5_CREAMcopy.png?v=1756196385",
					"variant_ids": [
						47405474971898
					]
				},
				"available": true,
				"name": "Tahiti 100% Linen Custom Curtain - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 18900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"id": 36232249573626,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2501,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A017_5_CREAMcopy.png?v=1756196385"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Atahiti_cream_1024x1024.png?v=1751338461"
			},
			{
				"id": 47405486473466,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THC-DMG-3A160-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44425940795642,
					"product_id": 8830959091962,
					"position": 1,
					"created_at": "2025-07-04T18:18:27+08:00",
					"updated_at": "2025-08-26T16:19:44+08:00",
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2501,
					"src": "//thehues.com/cdn/shop/files/A017_5_SAND_copy.png?v=1756196384",
					"variant_ids": [
						47405486473466
					]
				},
				"available": true,
				"name": "Tahiti 100% Linen Custom Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 18900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"id": 36319218729210,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2501,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A017_5_SAND_copy.png?v=1756196384"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Atahiti_sand_1024x1024.png?v=1751338461"
			},
			{
				"id": 47405486571770,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THC-DMG-3A160-7-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44425940828410,
					"product_id": 8830959091962,
					"position": 5,
					"created_at": "2025-07-04T18:18:28+08:00",
					"updated_at": "2025-08-26T16:19:44+08:00",
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2501,
					"src": "//thehues.com/cdn/shop/files/A017_5_grey_copy.png?v=1756196384",
					"variant_ids": [
						47405486571770
					]
				},
				"available": true,
				"name": "Tahiti 100% Linen Custom Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 18900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"id": 36319218761978,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2501,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A017_5_grey_copy.png?v=1756196384"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Atahiti_grey_1024x1024.png?v=1751338461"
			},
			{
				"id": 47405486440698,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-DMG-3A160-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44287879086330,
					"product_id": 8830959091962,
					"position": 13,
					"created_at": "2025-06-20T18:49:23+08:00",
					"updated_at": "2025-08-26T16:19:45+08:00",
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2501,
					"src": "//thehues.com/cdn/shop/files/A017_5_ASHcopy.png?v=1756196385",
					"variant_ids": [
						47405486440698
					]
				},
				"available": true,
				"name": "Tahiti 100% Linen Custom Curtain - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 18900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"id": 36232248983802,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2501,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A017_5_ASHcopy.png?v=1756196385"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Atahiti_ash_1024x1024.png?v=1751338461"
			},
			{
				"id": 47405486506234,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THC-DMG-3A160-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44425941451002,
					"product_id": 8830959091962,
					"position": 17,
					"created_at": "2025-07-04T18:18:30+08:00",
					"updated_at": "2025-08-26T16:19:45+08:00",
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2501,
					"src": "//thehues.com/cdn/shop/files/A017_5_TEAL_copy.png?v=1756196385",
					"variant_ids": [
						47405486506234
					]
				},
				"available": true,
				"name": "Tahiti 100% Linen Custom Curtain - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 18900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"id": 36319219155194,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2501,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A017_5_TEAL_copy.png?v=1756196385"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			},
			{
				"id": 47405486539002,
				"title": "Grey Blue",
				"option1": "Grey Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-DMG-3A160-9-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44425940762874,
					"product_id": 8830959091962,
					"position": 21,
					"created_at": "2025-07-04T18:18:24+08:00",
					"updated_at": "2025-08-26T16:19:46+08:00",
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2501,
					"src": "//thehues.com/cdn/shop/files/A017_5_DENIUM_copy.png?v=1756196386",
					"variant_ids": [
						47405486539002
					]
				},
				"available": true,
				"name": "Tahiti 100% Linen Custom Curtain - Grey Blue",
				"public_title": "Grey Blue",
				"options": [
					"Grey Blue"
				],
				"price": 18900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
					"id": 36319218696442,
					"position": 21,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2501,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/A017_5_DENIUM_copy.png?v=1756196386"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_1024x1024.gif"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/A017_5_SAND_copy.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_2_SAND_54246867-c957-4015-bff2-bdb1c4be8ee9.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_3_SAND_543b13a5-fd17-49b0-aa6a-2c040762ebb7.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_1_SAND_b92e360a-cec9-40ef-aea7-2429112f8cbe.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_5_grey_copy.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_3_grey_e94bcc23-0514-4348-8db8-6cc07c5319a4.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_2_grey_0986328c-fbb2-4344-b017-ab2f0c88efb4.png?v=1756196384",
			"//thehues.com/cdn/shop/files/A017_1_grey_80e80bc0-860e-4bf7-aea3-fa88a112551b.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_5_CREAMcopy.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_3_CREAM.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_2_CREAM.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_1_CREAM.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_5_ASHcopy.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_3_ASH.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_2_ASH.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_1_ASH.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_5_TEAL_copy.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_3_TEAL_9d435cb1-a8f4-4fbd-a202-a0369384bb5a.png?v=1756196385",
			"//thehues.com/cdn/shop/files/A017_2_TEAL_6e7bb6dc-530f-4990-a956-ac1ef290470e.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_1_TEAL_df10d77f-1226-46e2-9639-22f17b20b7f1.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_5_DENIUM_copy.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_3_DENIUM_6b4ebf5c-17b6-4daf-bb20-5d86604fa27d.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_2_DENIUM_5d85ec92-e446-4017-9da2-df87e529ae6e.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_1_DENIUM_2b21c8c4-e00e-4f5a-a131-95b793fa5911.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_5_SANDcopy.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_3_SAND.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_2_SAND.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_1_SAND.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_5_greycopy.png?v=1756196386",
			"//thehues.com/cdn/shop/files/A017_3_grey.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_2_grey.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_5_TEALcopy.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_3_TEAL.jpg?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_2_TEAL.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_1_TEAL.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_5_DENIUMcopy.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_3_DENIUM.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_2_DENIUM.png?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_1_DENIUM.png?v=1756196387",
			"//thehues.com/cdn/shop/files/dc017FAMILY.jpg?v=1756196387",
			"//thehues.com/cdn/shop/files/A017_5_DENIUMcopy_f4024a2d-0605-4253-9e9b-1c5a861a6a32.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_1_DENIUM_5961ef51-28de-4de3-94bc-bbf0bf04eb4c.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_2_DENIUM_c4432935-350c-401e-b944-577c894e6a39.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_3_DENIUM_3d302bb8-e1df-4c97-80a4-5677edd5d3cc.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_2_ASH_c0c68394-f4ca-474b-86f2-7031a4568ce0.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_1_ASH_71179670-e57b-48bd-b94d-e980d891141c.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_5_ash_8510cd4c-c96e-4dcc-a956-3d135d72fbdf.png?v=1756196388",
			"//thehues.com/cdn/shop/files/A017_3_ASH_0e0c9430-bcc7-4704-b659-dbd019fefbb7.png?v=1756196388"
		],
		"featured_image": "//thehues.com/cdn/shop/files/A017_5_SAND_copy_1024x1024.png?v=1756196384",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218729210,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_SAND_copy.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_SAND_copy.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217942778,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_SAND_54246867-c957-4015-bff2-bdb1c4be8ee9.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_SAND_54246867-c957-4015-bff2-bdb1c4be8ee9.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319219319034,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_SAND_543b13a5-fd17-49b0-aa6a-2c040762ebb7.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_SAND_543b13a5-fd17-49b0-aa6a-2c040762ebb7.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218794746,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_SAND_b92e360a-cec9-40ef-aea7-2429112f8cbe.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_SAND_b92e360a-cec9-40ef-aea7-2429112f8cbe.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218761978,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_grey_copy.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_grey_copy.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319219351802,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_grey_e94bcc23-0514-4348-8db8-6cc07c5319a4.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_grey_e94bcc23-0514-4348-8db8-6cc07c5319a4.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217910010,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_grey_0986328c-fbb2-4344-b017-ab2f0c88efb4.png?v=1756196384"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_grey_0986328c-fbb2-4344-b017-ab2f0c88efb4.png?v=1756196384",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218827514,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_grey_80e80bc0-860e-4bf7-aea3-fa88a112551b.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_grey_80e80bc0-860e-4bf7-aea3-fa88a112551b.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249573626,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_CREAMcopy.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_CREAMcopy.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249671930,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_CREAM.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_CREAM.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249639162,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_CREAM.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_CREAM.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249606394,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_CREAM.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_CREAM.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232248983802,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_ASHcopy.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_ASHcopy.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249082106,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_ASH.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_ASH.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249049338,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_ASH.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_ASH.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249016570,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_ASH.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_ASH.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319219155194,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_TEAL_copy.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_TEAL_copy.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319219384570,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_TEAL_9d435cb1-a8f4-4fbd-a202-a0369384bb5a.png?v=1756196385"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_TEAL_9d435cb1-a8f4-4fbd-a202-a0369384bb5a.png?v=1756196385",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217975546,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_TEAL_6e7bb6dc-530f-4990-a956-ac1ef290470e.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_TEAL_6e7bb6dc-530f-4990-a956-ac1ef290470e.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218860282,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_TEAL_df10d77f-1226-46e2-9639-22f17b20b7f1.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_TEAL_df10d77f-1226-46e2-9639-22f17b20b7f1.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218696442,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_DENIUM_copy.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_DENIUM_copy.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319219253498,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_DENIUM_6b4ebf5c-17b6-4daf-bb20-5d86604fa27d.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_DENIUM_6b4ebf5c-17b6-4daf-bb20-5d86604fa27d.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217746170,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_DENIUM_5d85ec92-e446-4017-9da2-df87e529ae6e.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_DENIUM_5d85ec92-e446-4017-9da2-df87e529ae6e.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319218663674,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_DENIUM_2b21c8c4-e00e-4f5a-a131-95b793fa5911.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_DENIUM_2b21c8c4-e00e-4f5a-a131-95b793fa5911.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249999610,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_SANDcopy.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_SANDcopy.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232250097914,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_SAND.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_SAND.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232250065146,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_SAND.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_SAND.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232250032378,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_SAND.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_SAND.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232268939514,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_greycopy.png?v=1756196386"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_greycopy.png?v=1756196386",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232268906746,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_grey.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_grey.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232268873978,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_grey.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_grey.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232250163450,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_TEALcopy.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_TEALcopy.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36199298171130,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_TEAL.jpg?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_TEAL.jpg?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232250228986,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_TEAL.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_TEAL.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232250196218,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_TEAL.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_TEAL.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249901306,
				"position": 36,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_DENIUMcopy.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_DENIUMcopy.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249868538,
				"position": 37,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_DENIUM.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_DENIUM.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249966842,
				"position": 38,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_DENIUM.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_DENIUM.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36232249934074,
				"position": 39,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_DENIUM.png?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_DENIUM.png?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36207237857530,
				"position": 40,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/dc017FAMILY.jpg?v=1756196387"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/dc017FAMILY.jpg?v=1756196387",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319200444666,
				"position": 41,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_DENIUMcopy_f4024a2d-0605-4253-9e9b-1c5a861a6a32.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_DENIUMcopy_f4024a2d-0605-4253-9e9b-1c5a861a6a32.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319200477434,
				"position": 42,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_DENIUM_5961ef51-28de-4de3-94bc-bbf0bf04eb4c.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_DENIUM_5961ef51-28de-4de3-94bc-bbf0bf04eb4c.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319200510202,
				"position": 43,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_DENIUM_c4432935-350c-401e-b944-577c894e6a39.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_DENIUM_c4432935-350c-401e-b944-577c894e6a39.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319200542970,
				"position": 44,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_DENIUM_3d302bb8-e1df-4c97-80a4-5677edd5d3cc.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_DENIUM_3d302bb8-e1df-4c97-80a4-5677edd5d3cc.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217221882,
				"position": 45,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_2_ASH_c0c68394-f4ca-474b-86f2-7031a4568ce0.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_2_ASH_c0c68394-f4ca-474b-86f2-7031a4568ce0.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217287418,
				"position": 46,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_1_ASH_71179670-e57b-48bd-b94d-e980d891141c.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_1_ASH_71179670-e57b-48bd-b94d-e980d891141c.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217254650,
				"position": 47,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2501,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_5_ash_8510cd4c-c96e-4dcc-a956-3d135d72fbdf.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2501,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_5_ash_8510cd4c-c96e-4dcc-a956-3d135d72fbdf.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": "Tahiti 100% Linen Custom Curtain - TheHues",
				"id": 36319217320186,
				"position": 48,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/A017_3_ASH_0e0c9430-bcc7-4704-b659-dbd019fefbb7.png?v=1756196388"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/A017_3_ASH_0e0c9430-bcc7-4704-b659-dbd019fefbb7.png?v=1756196388",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36215577411834,
				"position": 49,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1920,
					"width": 1536,
					"src": "//thehues.com/cdn/shop/files/preview_images/0843702357434bc5bf07e99b8488c6ac.thumbnail.0000000000.jpg?v=1750240926"
				},
				"aspect_ratio": 0.8,
				"duration": 9150,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0843702357434bc5bf07e99b8488c6ac/0843702357434bc5bf07e99b8488c6ac.SD-480p-1.5Mbps-49607125.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0843702357434bc5bf07e99b8488c6ac/0843702357434bc5bf07e99b8488c6ac.HD-1080p-7.2Mbps-49607125.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0843702357434bc5bf07e99b8488c6ac/0843702357434bc5bf07e99b8488c6ac.HD-720p-4.5Mbps-49607125.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0843702357434bc5bf07e99b8488c6ac/0843702357434bc5bf07e99b8488c6ac.m3u8?v=0",
						"width": 864
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Tahiti is 100% pure linen at its finest¡ªlight, breathable, and effortlessly elegant, like a breeze drifting through open windows.</p>",
		"url": "/products/tahiti-100-custom-linen-curtain",
		"regular_price": "$189.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8794306773242,
		"title": "Toni Bamboo Woven Shade - Black",
		"handle": "toni-bamboo-woven-shade-black",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Linen<br>Features: Light Filtering<br>Weight: Regular (300g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Bamboo is sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth is raw geometry.</p>",
		"published_at": "2025-05-28T15:49:33+08:00",
		"created_at": "2025-05-28T14:06:37+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 17300,
		"price_min": 17300,
		"price_max": 17300,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347580371194,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW304-88-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44079540502778,
					"product_id": 8794306773242,
					"position": 1,
					"created_at": "2025-05-28T18:29:50+08:00",
					"updated_at": "2025-08-26T16:21:39+08:00",
					"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/88_-118.jpg?v=1756196499",
					"variant_ids": [
						47347580371194
					]
				},
				"available": true,
				"name": "Toni Bamboo Woven Shade - Black - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 17300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
					"id": 36100670128378,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/88_-118.jpg?v=1756196499"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06581_-33_1024x1024.jpg?v=1756196499"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/88_-118.jpg?v=1756196499",
			"//thehues.com/cdn/shop/files/DSC06581_-33.jpg?v=1756196499",
			"//thehues.com/cdn/shop/files/SW304_1_88.jpg?v=1756196499",
			"//thehues.com/cdn/shop/files/DSC06568_-29.jpg?v=1756196499",
			"//thehues.com/cdn/shop/files/DSC06573_-31.jpg?v=1756196499",
			"//thehues.com/cdn/shop/files/DSC06613_-37.jpg?v=1756196499",
			"//thehues.com/cdn/shop/files/DSC06603_-35.jpg?v=1756196499"
		],
		"featured_image": "//thehues.com/cdn/shop/files/88_-118_1024x1024.jpg?v=1756196499",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
				"id": 36100670128378,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/88_-118.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/88_-118.jpg?v=1756196499",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
				"id": 36099437986042,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06581_-33.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06581_-33.jpg?v=1756196499",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Black - TheHues",
				"id": 36099028451578,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_1_88.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_1_88.jpg?v=1756196499",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
				"id": 36099437920506,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06568_-29.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06568_-29.jpg?v=1756196499",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
				"id": 36099437953274,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06573_-31.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06573_-31.jpg?v=1756196499",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
				"id": 36099438084346,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06613_-37.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06613_-37.jpg?v=1756196499",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Motorized Woven Shade - Black - TheHues",
				"id": 36099438018810,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06603_-35.jpg?v=1756196499"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06603_-35.jpg?v=1756196499",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bamboo is sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth is raw geometry.</p>",
		"url": "/products/toni-bamboo-woven-shade-black",
		"regular_price": "$173.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794306543866,
		"title": "Toni Bamboo Woven Shade - Hazel",
		"handle": "toni-bamboo-woven-shade-hazel",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Linen<br>Features: Light Filtering<br>Weight: Regular (300g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Bamboo's sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth's raw geometry.</p>",
		"published_at": "2025-05-28T15:49:33+08:00",
		"created_at": "2025-05-28T14:06:27+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 17300,
		"price_min": 17300,
		"price_max": 17300,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347579551994,
				"title": "Hazel",
				"option1": "Hazel",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW304-26-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077746815226,
					"product_id": 8794306543866,
					"position": 1,
					"created_at": "2025-05-28T14:18:05+08:00",
					"updated_at": "2025-08-26T16:21:40+08:00",
					"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW304_2_26.jpg?v=1756196500",
					"variant_ids": [
						47347579551994
					]
				},
				"available": true,
				"name": "Toni Bamboo Woven Shade - Hazel - Hazel",
				"public_title": "Hazel",
				"options": [
					"Hazel"
				],
				"price": 17300,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
					"id": 36099015147770,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW304_2_26.jpg?v=1756196500"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC06603_2-36_1024x1024.jpg?v=1756196501"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW304_2_26.jpg?v=1756196500",
			"//thehues.com/cdn/shop/files/DSC06581_2-34.jpg?v=1756196500",
			"//thehues.com/cdn/shop/files/SW304_1_26.jpg?v=1756196501",
			"//thehues.com/cdn/shop/files/DSC06568_2-30.jpg?v=1756196501",
			"//thehues.com/cdn/shop/files/DSC06573_2-32.jpg?v=1756196501",
			"//thehues.com/cdn/shop/files/DSC06603_2-36.jpg?v=1756196501",
			"//thehues.com/cdn/shop/files/DSC06613_2-38.jpg?v=1756196501"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW304_2_26_1024x1024.jpg?v=1756196500",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099015147770,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_2_26.jpg?v=1756196500"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_2_26.jpg?v=1756196500",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099441656058,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06581_2-34.jpg?v=1756196500"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06581_2-34.jpg?v=1756196500",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099014885626,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW304_1_26.jpg?v=1756196501"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW304_1_26.jpg?v=1756196501",
				"width": 2000
			},
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099441590522,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06568_2-30.jpg?v=1756196501"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06568_2-30.jpg?v=1756196501",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099441623290,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06573_2-32.jpg?v=1756196501"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06573_2-32.jpg?v=1756196501",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099441688826,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06603_2-36.jpg?v=1756196501"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06603_2-36.jpg?v=1756196501",
				"width": 1667
			},
			{
				"alt": "Toni Bamboo Woven Shade - Hazel - TheHues",
				"id": 36099441721594,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC06613_2-38.jpg?v=1756196501"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC06613_2-38.jpg?v=1756196501",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bamboo's sunlit stripes, interlaced with the quiet precision of tides, weave light into a silken dance of order and earth's raw geometry.</p>",
		"url": "/products/toni-bamboo-woven-shade-hazel",
		"regular_price": "$173.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794305429754,
		"title": "Rumi Jute Woven Shade - Hay",
		"handle": "rumi-jute-woven-shade-hay",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Jute<br>Features: Room Darkening<br>Weight: Heavyweight (600g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Coarse, knotted, alive¡ªcrafting natural textures and light into something unique and polished.</p>",
		"published_at": "2025-05-28T15:49:27+08:00",
		"created_at": "2025-05-28T14:05:15+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"No-drill",
			"Thanksgiving sale",
			"Woven shade"
		],
		"price": 16600,
		"price_min": 16600,
		"price_max": 16600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347575128314,
				"title": "Hay",
				"option1": "Hay",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW4112-S-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077727678714,
					"product_id": 8794305429754,
					"position": 1,
					"created_at": "2025-05-28T14:15:23+08:00",
					"updated_at": "2025-08-26T16:21:54+08:00",
					"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW41_2_12_22315b07-3553-49c2-bc72-e4677ceed67c.jpg?v=1756196514",
					"variant_ids": [
						47347575128314
					]
				},
				"available": true,
				"name": "Rumi Jute Woven Shade - Hay - Hay",
				"public_title": "Hay",
				"options": [
					"Hay"
				],
				"price": 16600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
					"id": 36098998108410,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW41_2_12_22315b07-3553-49c2-bc72-e4677ceed67c.jpg?v=1756196514"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC03968copy-53_1024x1024.jpg?v=1756196514"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW41_2_12_22315b07-3553-49c2-bc72-e4677ceed67c.jpg?v=1756196514",
			"//thehues.com/cdn/shop/files/DSC03968copy-53.jpg?v=1756196514",
			"//thehues.com/cdn/shop/files/SW41_1_12.jpg?v=1756196514",
			"//thehues.com/cdn/shop/files/DSC03957copy-51.jpg?v=1756196514",
			"//thehues.com/cdn/shop/files/DSC03967copy-52.jpg?v=1756196514"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW41_2_12_22315b07-3553-49c2-bc72-e4677ceed67c_1024x1024.jpg?v=1756196514",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
				"id": 36098998108410,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW41_2_12_22315b07-3553-49c2-bc72-e4677ceed67c.jpg?v=1756196514"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW41_2_12_22315b07-3553-49c2-bc72-e4677ceed67c.jpg?v=1756196514",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
				"id": 36099543007482,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03968copy-53.jpg?v=1756196514"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03968copy-53.jpg?v=1756196514",
				"width": 1667
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
				"id": 36098998075642,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW41_1_12.jpg?v=1756196514"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW41_1_12.jpg?v=1756196514",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
				"id": 36099543040250,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03957copy-51.jpg?v=1756196514"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03957copy-51.jpg?v=1756196514",
				"width": 1667
			},
			{
				"alt": "Rumi Jute Motorized Woven Shade - Hay - TheHues",
				"id": 36099543073018,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03967copy-52.jpg?v=1756196514"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03967copy-52.jpg?v=1756196514",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Coarse, knotted, alive¡ªcrafting natural textures and light into something unique and polished.</p>",
		"url": "/products/rumi-jute-woven-shade-hay",
		"regular_price": "$166.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794305331450,
		"title": "Rumi Jute Woven Shade - Cream",
		"handle": "rumi-jute-woven-shade-cream",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Kenaf<br>Features: Room Darkening<br>Weight: Heavyweight (600g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Coarse, knotted, alive¡ªcrafting natural textures and light into something unique and polished.</p>",
		"published_at": "2025-05-28T15:49:26+08:00",
		"created_at": "2025-05-28T14:05:05+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 16600,
		"price_min": 16600,
		"price_max": 16600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347574669562,
				"title": "Cream",
				"option1": "Cream",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW4102-S-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077727711482,
					"product_id": 8794305331450,
					"position": 1,
					"created_at": "2025-05-28T14:15:25+08:00",
					"updated_at": "2025-08-26T16:21:56+08:00",
					"alt": "Rumi Jute Woven Shade - Cream - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW41_1_2.jpg?v=1756196516",
					"variant_ids": [
						47347574669562
					]
				},
				"available": true,
				"name": "Rumi Jute Woven Shade - Cream - Cream",
				"public_title": "Cream",
				"options": [
					"Cream"
				],
				"price": 16600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Rumi Jute Woven Shade - Cream - TheHues",
					"id": 36098998337786,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW41_1_2.jpg?v=1756196516"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC04685copy_1024x1024.jpg?v=1756196516"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW41_1_2.jpg?v=1756196516",
			"//thehues.com/cdn/shop/files/DSC04698copy.jpg?v=1756196516",
			"//thehues.com/cdn/shop/files/SW41_2_02.jpg?v=1756196516",
			"//thehues.com/cdn/shop/files/DSC04675copy.jpg?v=1756196516",
			"//thehues.com/cdn/shop/files/DSC04685copy.jpg?v=1756196516",
			"//thehues.com/cdn/shop/files/DSC04686copy.jpg?v=1756196516",
			"//thehues.com/cdn/shop/files/DSC04703copy.jpg?v=1756196516"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW41_1_2_1024x1024.jpg?v=1756196516",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998337786,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW41_1_2.jpg?v=1756196516"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW41_1_2.jpg?v=1756196516",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998272250,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04698copy.jpg?v=1756196516"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04698copy.jpg?v=1756196516",
				"width": 3072
			},
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998370554,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW41_2_02.jpg?v=1756196516"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW41_2_02.jpg?v=1756196516",
				"width": 2000
			},
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998173946,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04675copy.jpg?v=1756196516"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04675copy.jpg?v=1756196516",
				"width": 3072
			},
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998206714,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04685copy.jpg?v=1756196516"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04685copy.jpg?v=1756196516",
				"width": 3072
			},
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998239482,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04686copy.jpg?v=1756196516"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04686copy.jpg?v=1756196516",
				"width": 3072
			},
			{
				"alt": "Rumi Jute Woven Shade - Cream - TheHues",
				"id": 36098998305018,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04703copy.jpg?v=1756196516"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04703copy.jpg?v=1756196516",
				"width": 3072
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Coarse, knotted, alive¡ªcrafting natural textures and light into something unique and polished.</p>",
		"url": "/products/rumi-jute-woven-shade-cream",
		"regular_price": "$166.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794305200378,
		"title": "Mia Jute Woven Shade - Grey",
		"handle": "mia-jute-woven-shade-grey",
		"product_details": `<h3>Specifications</h3><p>Material: 70% Kenaf &amp; 30% Jute <br>Features: Room Darkening<br>Weight: Heavyweight (426g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"published_at": "2025-05-28T15:49:26+08:00",
		"created_at": "2025-05-28T14:04:54+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 17300,
		"price_min": 17300,
		"price_max": 17300,
		"available": true,
		"price_varies": false,
		"compare_at_price": 19900,
		"compare_at_price_min": 19900,
		"compare_at_price_max": 19900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347574538490,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THRS-SWY.M1-18-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077715456250,
					"product_id": 8794305200378,
					"position": 1,
					"created_at": "2025-05-28T14:13:38+08:00",
					"updated_at": "2025-08-26T16:21:57+08:00",
					"alt": "Mia Jute Woven Shade - Grey - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SWYM1_3_18.jpg?v=1756196517",
					"variant_ids": [
						47347574538490
					]
				},
				"available": true,
				"name": "Mia Jute Woven Shade - Grey - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 17300,
				"weight": 0,
				"compare_at_price": 19900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Mia Jute Woven Shade - Grey - TheHues",
					"id": 36098987524346,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SWYM1_3_18.jpg?v=1756196517"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC03382_-42_1024x1024.jpg?v=1756196517"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SWYM1_3_18.jpg?v=1756196517",
			"//thehues.com/cdn/shop/files/DSC03382_-42.jpg?v=1756196517",
			"//thehues.com/cdn/shop/files/SWYM1_1_18.jpg?v=1756196518",
			"//thehues.com/cdn/shop/files/SWYM1_2_18.jpg?v=1756196518",
			"//thehues.com/cdn/shop/files/DSC03354_-39.jpg?v=1756196518",
			"//thehues.com/cdn/shop/files/DSC03369_-40.jpg?v=1756196518",
			"//thehues.com/cdn/shop/files/DSC03377_-41.jpg?v=1756196518"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SWYM1_3_18_1024x1024.jpg?v=1756196517",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36098987524346,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_3_18.jpg?v=1756196517"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_3_18.jpg?v=1756196517",
				"width": 2000
			},
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36099543564538,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03382_-42.jpg?v=1756196517"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03382_-42.jpg?v=1756196517",
				"width": 1667
			},
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36098987557114,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_1_18.jpg?v=1756196518"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_1_18.jpg?v=1756196518",
				"width": 2000
			},
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36098987589882,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SWYM1_2_18.jpg?v=1756196518"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SWYM1_2_18.jpg?v=1756196518",
				"width": 2000
			},
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36099543597306,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03354_-39.jpg?v=1756196518"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03354_-39.jpg?v=1756196518",
				"width": 1667
			},
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36099543630074,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03369_-40.jpg?v=1756196518"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03369_-40.jpg?v=1756196518",
				"width": 1667
			},
			{
				"alt": "Mia Jute Woven Shade - Grey - TheHues",
				"id": 36099543662842,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03377_-41.jpg?v=1756196518"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03377_-41.jpg?v=1756196518",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Where every thread tells a story of weather and time, woven into shades that wear their rustic charm like a second skin.</p>",
		"url": "/products/mia-jute-woven-shade-grey",
		"regular_price": "$173.00",
		"sale_price": "$199.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8794295632122,
		"title": "Kaia Linen Bamboo Woven Shade - White",
		"handle": "kaia-linen-bamboo-woven-shade-white",
		"product_details": `<h3>Specifications</h3><p>Material: 70% Kenaf &amp; 30% Jute <br>Features: Room Darkening<br>Weight: Heavyweight (426g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Where bamboo writes its poetry into linen¡¯s loom, each thread a stanza of organic contrast and harmony.</p>",
		"published_at": "2025-05-28T15:49:23+08:00",
		"created_at": "2025-05-28T13:48:48+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"bamboo shades",
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 17600,
		"price_min": 17600,
		"price_max": 17600,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47347525058810,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW8501-ZM-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44077766213882,
					"product_id": 8794295632122,
					"position": 1,
					"created_at": "2025-05-28T14:21:31+08:00",
					"updated_at": "2025-08-26T16:22:07+08:00",
					"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW8501_1copy.jpg?v=1756196527",
					"variant_ids": [
						47347525058810
					]
				},
				"available": true,
				"name": "Kaia Linen Bamboo Woven Shade - White - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 17600,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
					"id": 36099034644730,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW8501_1copy.jpg?v=1756196527"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC04769_1024x1024.jpg?v=1756196528"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW8501_1copy.jpg?v=1756196527",
			"//thehues.com/cdn/shop/files/DSC04771.jpg?v=1756196527",
			"//thehues.com/cdn/shop/files/SW8501_2copy.jpg?v=1756196527",
			"//thehues.com/cdn/shop/files/DSC04763.jpg?v=1756196527",
			"//thehues.com/cdn/shop/files/DSC04767.jpg?v=1756196527",
			"//thehues.com/cdn/shop/files/DSC04769.jpg?v=1756196528"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW8501_1copy_1024x1024.jpg?v=1756196527",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
				"id": 36099034644730,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW8501_1copy.jpg?v=1756196527"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW8501_1copy.jpg?v=1756196527",
				"width": 2000
			},
			{
				"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
				"id": 36099034611962,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04771.jpg?v=1756196527"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04771.jpg?v=1756196527",
				"width": 3072
			},
			{
				"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
				"id": 36099034677498,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW8501_2copy.jpg?v=1756196527"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW8501_2copy.jpg?v=1756196527",
				"width": 2000
			},
			{
				"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
				"id": 36099034513658,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04763.jpg?v=1756196527"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04763.jpg?v=1756196527",
				"width": 3072
			},
			{
				"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
				"id": 36099034546426,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04767.jpg?v=1756196527"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04767.jpg?v=1756196527",
				"width": 3072
			},
			{
				"alt": "Kaia Linen Bamboo Woven Shade - White - TheHues",
				"id": 36099034579194,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/DSC04769.jpg?v=1756196528"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04769.jpg?v=1756196528",
				"width": 3072
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Where bamboo writes its poetry into linen¡¯s loom, each thread a stanza of organic contrast and harmony.</p>",
		"url": "/products/kaia-linen-bamboo-woven-shade-white",
		"regular_price": "$176.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/bamboo-shades",
				"title": "Bamboo Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8792867635450,
		"title": "Nico Jute Woven Shade - Natural",
		"handle": "nico-jute-woven-shade-natural",
		"product_details": `<h3>Specifications</h3><p>Material: 70% Kenaf &amp; 30% Jute <br>Features: Room Darkening<br>Weight: Heavyweight (426g/㎡)</p><h3>Care</h3><p><strong>Do not wash or machine wash.</strong></p><p><strong>For regular dust removal</strong>, use a feather duster or vacuum with a soft brush attachment.</p><p><strong>For small stains</strong>, gently scrub the area with a toothbrush dipped in foam cleaner or mild soap solution (following the direction of the weave). Wipe clean with a damp cloth and let air dry in a shaded, well-ventilated area.</p><p><strong>Avoid direct sunlight or heat when drying.<br></strong></p>`,
		"description": "<p>Hand-woven from sun-bleached jute, this ethereal veil captures dawn¡¯s first breath, draping rooms in softly spun gold.</p>",
		"published_at": "2025-05-28T15:49:21+08:00",
		"created_at": "2025-05-26T17:58:15+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"Indoor Woven Shade",
			"No-drill",
			"Woven shade"
		],
		"price": 21400,
		"price_min": 21400,
		"price_max": 21400,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47342466924794,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THRS-SW77-01-MH-ND",
				"requires_shipping": true,
				"taxable": false,
				"featured_image": {
					"id": 44078323990778,
					"product_id": 8792867635450,
					"position": 1,
					"created_at": "2025-05-28T15:38:25+08:00",
					"updated_at": "2025-08-26T16:22:13+08:00",
					"alt": "Nico Jute Woven Shade - Natural - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/SW77_3copy-9.jpg?v=1756196533",
					"variant_ids": [
						47342466924794
					]
				},
				"available": true,
				"name": "Nico Jute Woven Shade - Natural - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 21400,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Nico Jute Woven Shade - Natural - TheHues",
					"id": 36099548315898,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/SW77_3copy-9.jpg?v=1756196533"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/DSC04271_-69_1024x1024.jpg?v=1756196533"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/SW77_3copy-9.jpg?v=1756196533",
			"//thehues.com/cdn/shop/files/DSC04271_-69.jpg?v=1756196533",
			"//thehues.com/cdn/shop/files/SW77_1copy-7.jpg?v=1756290074",
			"//thehues.com/cdn/shop/files/SW77_2copy-8.jpg?v=1756290074",
			"//thehues.com/cdn/shop/files/DSC04270_-68.jpg?v=1756290074",
			"//thehues.com/cdn/shop/files/DSC03393_-43.jpg?v=1756290074",
			"//thehues.com/cdn/shop/files/DSC03402_-44.jpg?v=1756290074"
		],
		"featured_image": "//thehues.com/cdn/shop/files/SW77_3copy-9_1024x1024.jpg?v=1756196533",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548315898,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW77_3copy-9.jpg?v=1756196533"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW77_3copy-9.jpg?v=1756196533",
				"width": 2000
			},
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548217594,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04271_-69.jpg?v=1756196533"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04271_-69.jpg?v=1756196533",
				"width": 1667
			},
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548250362,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW77_1copy-7.jpg?v=1756290074"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW77_1copy-7.jpg?v=1756290074",
				"width": 2000
			},
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548283130,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/SW77_2copy-8.jpg?v=1756290074"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/SW77_2copy-8.jpg?v=1756290074",
				"width": 2000
			},
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548184826,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC04270_-68.jpg?v=1756290074"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC04270_-68.jpg?v=1756290074",
				"width": 1667
			},
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548119290,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03393_-43.jpg?v=1756290074"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03393_-43.jpg?v=1756290074",
				"width": 1667
			},
			{
				"alt": "Nico Jute Woven Shade - Natural - TheHues",
				"id": 36099548152058,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2084,
					"width": 1667,
					"src": "//thehues.com/cdn/shop/files/DSC03402_-44.jpg?v=1756290074"
				},
				"aspect_ratio": 0.8,
				"height": 2084,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/DSC03402_-44.jpg?v=1756290074",
				"width": 1667
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Hand-woven from sun-bleached jute, this ethereal veil captures dawn¡¯s first breath, draping rooms in softly spun gold.</p>",
		"url": "/products/nico-jute-woven-shade-natural",
		"regular_price": "$214.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/all-shades",
				"title": "All Shades"
			},
			{
				"url": "/collections/indoor-woven-shade",
				"title": "Indoor Woven Shade"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-in",
				"title": "NEW IN"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/woven-shades",
				"title": "Woven Shades"
			}
		]
	},
	{
		"id": 8780124193018,
		"title": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain",
		"handle": "boston-high-performing-fade-resistant-waterproof-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Weight: 380 g/m²<br>Features: UV protection, Fade &amp; Water resistant<br>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Bohemia curtains feature a unified pattern that brings together a harmonious blend of shapes and textures.</p>",
		"published_at": "2025-05-07T16:31:13+08:00",
		"created_at": "2025-05-07T16:31:13+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > New Outdoor Curtains",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"Extra 10%",
			"flash_categories",
			"Independence Day",
			"New Content",
			"Outsourced products",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain"
		],
		"price": 10900,
		"price_min": 10900,
		"price_max": 10900,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319462445306,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-136-1523855-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025356386554,
					"product_id": 8780124193018,
					"position": 1,
					"created_at": "2025-05-21T15:07:46+08:00",
					"updated_at": "2025-08-26T16:26:37+08:00",
					"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABrown-1-1_resolution-standardv2-2x.jpg?v=1756196797",
					"variant_ids": [
						47319462445306
					]
				},
				"available": true,
				"name": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064142262522,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABrown-1-1_resolution-standardv2-2x.jpg?v=1756196797"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aboston_grey_1024x1024.png?v=1751336068"
			},
			{
				"id": 47319462478074,
				"title": "Dark Grey",
				"option1": "Dark Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-136-1523855-C-Dark Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025355862266,
					"product_id": 8780124193018,
					"position": 6,
					"created_at": "2025-05-21T15:07:42+08:00",
					"updated_at": "2025-08-26T16:26:38+08:00",
					"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABlack-1-3_resolution-standardv2-2x.jpg?v=1756196798",
					"variant_ids": [
						47319462478074
					]
				},
				"available": true,
				"name": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - Dark Grey",
				"public_title": "Dark Grey",
				"options": [
					"Dark Grey"
				],
				"price": 10900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064142098682,
					"position": 6,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABlack-1-3_resolution-standardv2-2x.jpg?v=1756196798"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Aboston_darkgrey_1024x1024.png?v=1751336067"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ABrown-1-1_resolution-standardv2-2x.jpg?v=1756196797",
			"//thehues.com/cdn/shop/files/ABrown-3_resolution-standardv2-2x.jpg?v=1761272252",
			"//thehues.com/cdn/shop/files/ABrown-1_resolution-standardv2-2x.jpg?v=1756196798",
			"//thehues.com/cdn/shop/files/ABrown-2_resolution-standardv2-2x.jpg?v=1756196798",
			"//thehues.com/cdn/shop/files/ABrown-4_resolution-standardv2-2x.jpg?v=1756196798",
			"//thehues.com/cdn/shop/files/ABlack-1-3_resolution-standardv2-2x.jpg?v=1756196798",
			"//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x.jpg?v=1756196798",
			"//thehues.com/cdn/shop/files/ABlack-2-2_resolution-standardv2-2x.jpg?v=1756196798",
			"//thehues.com/cdn/shop/files/ABlack-3-1_resolution-standardv2-2x.jpg?v=1761272252",
			"//thehues.com/cdn/shop/files/ABlack-4-2_resolution-standardv2-2x.jpg?v=1756196798"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ABrown-1-1_resolution-standardv2-2x_1024x1024.jpg?v=1756196797",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142262522,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown-1-1_resolution-standardv2-2x.jpg?v=1756196797"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown-1-1_resolution-standardv2-2x.jpg?v=1756196797",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142328058,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown-3_resolution-standardv2-2x.jpg?v=1761272252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown-3_resolution-standardv2-2x.jpg?v=1761272252",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142229754,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown-1_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown-1_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142295290,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown-2_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown-2_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142196986,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABrown-4_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABrown-4_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142098682,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-1-3_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-1-3_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142065914,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142131450,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-2-2_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-2-2_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142164218,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-3-1_resolution-standardv2-2x.jpg?v=1761272252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-3-1_resolution-standardv2-2x.jpg?v=1761272252",
				"width": 2000
			},
			{
				"alt": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064142033146,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-4-2_resolution-standardv2-2x.jpg?v=1756196798"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-4-2_resolution-standardv2-2x.jpg?v=1756196798",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bohemia curtains feature a unified pattern that brings together a harmonious blend of shapes and textures.</p>",
		"url": "/products/boston-high-performing-fade-resistant-waterproof-custom-outdoor-curtain",
		"regular_price": "$109.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	},
	{
		"id": 8891361722618,
		"title": "Cleo Textured Custom Curtain with Trim",
		"handle": "cleo-textured-custom-curtain-with-trim",
		"product_details": `<h3>Specifications</h3><p><strong>Material </strong>100% Polyester</p><p><strong>Features</strong> Room Darkening</p><p><strong>Weight</strong> Regular (454g/㎡)</p><p><strong>Softness</strong> Soft</p><p></p><h3>Care</h3><p>Hand-washing only at temperature below 30°C</p><p>Iron safe (below 110℃)</p><p>Avoid bleaching</p><p>Dry clean safe</p>`,
		"description": "<p>Cleo’s textured herringbone pattern dances gently across the linen blend, accented by a delicate faux leather trim that catches the eye with understated elegance.</p>",
		"published_at": "2025-09-04T13:42:22+08:00",
		"created_at": "2025-08-18T10:12:22+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains Memory Training",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Arrival",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"ruichi",
			"ruichi curtain",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Pinch pleat"
		],
		"price": 21900,
		"price_min": 21900,
		"price_max": 21900,
		"available": false,
		"price_varies": false,
		"compare_at_price": 26900,
		"compare_at_price_min": 26900,
		"compare_at_price_max": 26900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47622101663994,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-BLF1053-1A-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45002751115514,
					"product_id": 8891361722618,
					"position": 1,
					"created_at": "2025-09-03T18:04:54+08:00",
					"updated_at": "2025-09-03T18:06:01+08:00",
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory-20.png?v=1756893961",
					"variant_ids": [
						47622101663994
					]
				},
				"available": false,
				"name": "Cleo Textured Custom Curtain with Trim - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 21900,
				"weight": 0,
				"compare_at_price": 26900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"id": 36724324303098,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory-20.png?v=1756893961"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige_1024x1024.jpg?v=1756965819"
			},
			{
				"id": 47622101696762,
				"title": "Silver",
				"option1": "Silver",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-BLF1053-1B-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45002751082746,
					"product_id": 8891361722618,
					"position": 3,
					"created_at": "2025-09-03T18:04:53+08:00",
					"updated_at": "2025-09-04T14:03:39+08:00",
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver-20.png?v=1756965819",
					"variant_ids": [
						47622101696762
					]
				},
				"available": false,
				"name": "Cleo Textured Custom Curtain with Trim - Silver",
				"public_title": "Silver",
				"options": [
					"Silver"
				],
				"price": 21900,
				"weight": 0,
				"compare_at_price": 26900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"id": 36724324270330,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver-20.png?v=1756965819"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver_1024x1024.jpg?v=1756965819"
			},
			{
				"id": 47622101729530,
				"title": "Sesame",
				"option1": "Sesame",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-BLF1053-1C-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45002751181050,
					"product_id": 8891361722618,
					"position": 5,
					"created_at": "2025-09-03T18:04:54+08:00",
					"updated_at": "2025-09-04T14:03:39+08:00",
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame-20.png?v=1756965819",
					"variant_ids": [
						47622101729530
					]
				},
				"available": false,
				"name": "Cleo Textured Custom Curtain with Trim - Sesame",
				"public_title": "Sesame",
				"options": [
					"Sesame"
				],
				"price": 21900,
				"weight": 0,
				"compare_at_price": 26900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"id": 36724324368634,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame-20.png?v=1756965819"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame_1024x1024.jpg?v=1756965819"
			},
			{
				"id": 47622101762298,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-BLF1053-1D-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 45002751213818,
					"product_id": 8891361722618,
					"position": 7,
					"created_at": "2025-09-03T18:04:54+08:00",
					"updated_at": "2025-09-04T14:03:39+08:00",
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"width": 896,
					"height": 1120,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige-20.png?v=1756965819",
					"variant_ids": [
						47622101762298
					]
				},
				"available": false,
				"name": "Cleo Textured Custom Curtain with Trim - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 21900,
				"weight": 0,
				"compare_at_price": 26900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
					"id": 36724324401402,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 1120,
						"width": 896,
						"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige-20.png?v=1756965819"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame_1024x1024.jpg?v=1756965819"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory-20.png?v=1756893961",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory.jpg?v=1756964661",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver-20.png?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame-20.png?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige-20.png?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-1.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-4.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-3.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-5.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-1.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-4.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-3.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-5.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-1.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-4.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-3.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-5.jpg?v=1756965819",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-1.jpg?v=1756964661",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-4.jpg?v=1756964661",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-3.jpg?v=1756964661",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-5.jpg?v=1756964661",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-2.jpg?v=1756893961",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-2.jpg?v=1756893961",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-2.jpg?v=1756893961",
			"//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-2.jpg?v=1756893961"
		],
		"featured_image": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory-20_1024x1024.png?v=1756893961",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36724324303098,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory-20.png?v=1756893961"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory-20.png?v=1756893961",
				"width": 896
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36641416282362,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2042,
					"width": 1633,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory.jpg?v=1756964661"
				},
				"aspect_ratio": 0.8,
				"height": 2042,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-ivory.jpg?v=1756964661",
				"width": 1633
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36724324270330,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver-20.png?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver-20.png?v=1756965819",
				"width": 896
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36641416249594,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2042,
					"width": 1633,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2042,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-silver.jpg?v=1756965819",
				"width": 1633
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36724324368634,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame-20.png?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame-20.png?v=1756965819",
				"width": 896
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36641416315130,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2038,
					"width": 1630,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2038,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-sesame.jpg?v=1756965819",
				"width": 1630
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36724324401402,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1120,
					"width": 896,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige-20.png?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 1120,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige-20.png?v=1756965819",
				"width": 896
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36641416347898,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2042,
					"width": 1633,
					"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2042,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-textured-custom-curtain-with-trim-beige.jpg?v=1756965819",
				"width": 1633
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547111162,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-1.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-1.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547209466,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-4.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-4.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547176698,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-3.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-3.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Fabric Swatches - TheHues",
				"id": 36576547242234,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-5.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-5.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547438842,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-1.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-1.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547537146,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-4.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-4.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547504378,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-3.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-3.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Fabric Swatches - TheHues",
				"id": 36576547569914,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-5.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-5.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547275002,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-1.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-1.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547373306,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-4.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-4.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547340538,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-3.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-3.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Fabric Swatches - TheHues",
				"id": 36576547406074,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-5.jpg?v=1756965819"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-5.jpg?v=1756965819",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576546914554,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-1.jpg?v=1756964661"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-1.jpg?v=1756964661",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547012858,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-4.jpg?v=1756964661"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-4.jpg?v=1756964661",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576546980090,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-3.jpg?v=1756964661"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-3.jpg?v=1756964661",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Fabric Swatches - TheHues",
				"id": 36576547045626,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-5.jpg?v=1756964661"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-5.jpg?v=1756964661",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547143930,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-2.jpg?v=1756893961"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-ivory-2.jpg?v=1756893961",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547471610,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-2.jpg?v=1756893961"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-silver-2.jpg?v=1756893961",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576547307770,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-2.jpg?v=1756893961"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-sesame-2.jpg?v=1756893961",
				"width": 2001
			},
			{
				"alt": "Cleo Textured Custom Curtain with Trim - TheHues",
				"id": 36576546947322,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-2.jpg?v=1756893961"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/cleo-custom-curtains-beige-2.jpg?v=1756893961",
				"width": 2001
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Cleo’s textured herringbone pattern dances gently across the linen blend, accented by a delicate faux leather trim that catches the eye with understated elegance.</p>",
		"url": "/products/cleo-textured-custom-curtain-with-trim",
		"regular_price": "$219.00",
		"sale_price": "$269.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/charm-curtains",
				"title": "Charm Collection Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-arrival-curtains",
				"title": "New Arrival Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/the-charm-collection",
				"title": "The Charm Collection"
			},
			{
				"url": "/collections/the-charm-collection-uk",
				"title": "the charm collection -uk"
			}
		]
	},
	{
		"id": 8891360575738,
		"title": "Zane Textured Custom Curtain with Trim",
		"handle": "zane-textured-custom-curtain-with-trim",
		"product_details": `<h3>Specifications</h3><p><strong>Material </strong>60% Polyester &amp; 20% Spandex &amp; 20% Viscose</p><p><strong>Features</strong> Room Darkening</p><p><strong>Weight</strong> Regular (454g/㎡)</p><p><strong>Softness</strong> Soft</p><p></p><h3>Care</h3><p>Hand-washing only at temperature below 30°C</p><p>Iron safe (below 110℃)</p><p>Avoid bleaching</p><p>Dry clean safe</p>`,
		"description": "<p>Elevated craft meets sophisticated details. Zane fabric combining a yarn-stitched curtain trim, creating a piece with a balanced structure and presence.</p>",
		"published_at": "2025-09-04T13:42:20+08:00",
		"created_at": "2025-08-18T10:11:44+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains Memory Training",
			"fall sale",
			"flash_categories",
			"Halloween",
			"indoor curtain",
			"New Arrival",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"ruichi",
			"ruichi curtain",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Pinch pleat"
		],
		"price": 26900,
		"price_min": 26900,
		"price_max": 26900,
		"available": false,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47622099599610,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-YR-HF29-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44836933468410,
					"product_id": 8891360575738,
					"position": 1,
					"created_at": "2025-08-18T11:26:37+08:00",
					"updated_at": "2025-09-04T10:54:27+08:00",
					"alt": "Zane Textured Custom Curtain with Trim - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-1.png?v=1756954467",
					"variant_ids": [
						47622099599610
					]
				},
				"available": false,
				"name": "Zane Textured Custom Curtain with Trim - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 26900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Zane Textured Custom Curtain with Trim - TheHues",
					"id": 36576328876282,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-1.png?v=1756954467"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-ivory-33_1024x1024.jpg?v=1756967593"
			},
			{
				"id": 47622104219898,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-YR-HF29-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44836933140730,
					"product_id": 8891360575738,
					"position": 3,
					"created_at": "2025-08-18T11:26:37+08:00",
					"updated_at": "2025-09-04T14:33:13+08:00",
					"alt": "Zane Textured Custom Curtain with Trim - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-1.png?v=1756967593",
					"variant_ids": [
						47622104219898
					]
				},
				"available": false,
				"name": "Zane Textured Custom Curtain with Trim - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 26900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Zane Textured Custom Curtain with Trim - TheHues",
					"id": 36576328548602,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-1.png?v=1756967593"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-beige-33_1024x1024.jpg?v=1756967593"
			},
			{
				"id": 47622104252666,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-YR-HF29-16-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44836933304570,
					"product_id": 8891360575738,
					"position": 5,
					"created_at": "2025-08-18T11:26:37+08:00",
					"updated_at": "2025-09-04T14:33:13+08:00",
					"alt": "Zane Textured Custom Curtain with Trim - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-1.png?v=1756967593",
					"variant_ids": [
						47622104252666
					]
				},
				"available": false,
				"name": "Zane Textured Custom Curtain with Trim - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 26900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Zane Textured Custom Curtain with Trim - TheHues",
					"id": 36576328712442,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-1.png?v=1756967593"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-black33_1024x1024.jpg?v=1756967593"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-1.png?v=1756954467",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-3.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-beige-1.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-beige-3.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-black-1.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-black-3.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-2.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-4.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-beige-2.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-beige-4.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-beige-33.jpg?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-black-2.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-black-4.png?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-black33.jpg?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-ivory-33.jpg?v=1756967593",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-5.png?v=1756954467",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-beige-5.png?v=1756954467",
			"//thehues.com/cdn/shop/files/zane-custom-curtains-black-5.png?v=1756954467"
		],
		"featured_image": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-1_1024x1024.png?v=1756954467",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328876282,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-1.png?v=1756954467"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-1.png?v=1756954467",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328941818,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-3.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-3.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328548602,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-1.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-1.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328614138,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-3.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-3.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328712442,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-1.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-1.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328777978,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-3.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-3.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328909050,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-2.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-2.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328974586,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-4.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-4.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328581370,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-2.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-2.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328646906,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-4.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-4.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36731882504442,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2769,
					"width": 2215,
					"src": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-beige-33.jpg?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2769,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-beige-33.jpg?v=1756967593",
				"width": 2215
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328745210,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-2.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-2.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328810746,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-4.png?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-4.png?v=1756967593",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36731882438906,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2053,
					"width": 1642,
					"src": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-black33.jpg?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2053,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-black33.jpg?v=1756967593",
				"width": 1642
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36731882471674,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2097,
					"width": 1677,
					"src": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-ivory-33.jpg?v=1756967593"
				},
				"aspect_ratio": 0.8,
				"height": 2097,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-textured-custom-curtain-with-trim-ivory-33.jpg?v=1756967593",
				"width": 1677
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576329007354,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-5.png?v=1756954467"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-ivory-5.png?v=1756954467",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328679674,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-5.png?v=1756954467"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-beige-5.png?v=1756954467",
				"width": 2000
			},
			{
				"alt": "Zane Textured Custom Curtain with Trim - TheHues",
				"id": 36576328843514,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-5.png?v=1756954467"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/zane-custom-curtains-black-5.png?v=1756954467",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Elevated craft meets sophisticated details. Zane fabric combining a yarn-stitched curtain trim, creating a piece with a balanced structure and presence.</p>",
		"url": "/products/zane-textured-custom-curtain-with-trim",
		"regular_price": "$269.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/charm-curtains",
				"title": "Charm Collection Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/halloween",
				"title": "Halloween"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-arrival-curtains",
				"title": "New Arrival Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/the-charm-collection",
				"title": "The Charm Collection"
			},
			{
				"url": "/collections/the-charm-collection-uk",
				"title": "the charm collection -uk"
			}
		]
	},
	{
		"id": 8891360968954,
		"title": "Arden Textured Custom Curtain with Trim",
		"handle": "arden-textured-custom-curtain-with-trim",
		"product_details": `<h3>Specifications</h3><p><strong>Material </strong>100% Polyester</p><p><strong>Features</strong> Room Darkening</p><p><strong>Weight</strong> Regular (454g/㎡)</p><p><strong>Softness</strong> Soft</p><p></p><h3>Care</h3><p>Hand-washing only at temperature below 30°C</p><p>Iron safe (below 110℃)</p><p>Avoid bleaching</p><p>Dry clean safe</p>`,
		"description": "<p>Bold yet tactile, Arden uses crossed yarns to craft a curtain with trim that’s both visually striking and richly textured.</p>",
		"published_at": "2025-09-04T13:42:21+08:00",
		"created_at": "2025-08-18T10:11:57+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains Memory Training",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Arrival",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"ruichi",
			"ruichi curtain",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Pinch pleat"
		],
		"price": 26900,
		"price_min": 26900,
		"price_max": 26900,
		"available": false,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47622100254970,
				"title": "Beige",
				"option1": "Beige",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-535-3-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837115953402,
					"product_id": 8891360968954,
					"position": 1,
					"created_at": "2025-08-18T11:42:16+08:00",
					"updated_at": "2025-08-27T11:55:15+08:00",
					"alt": "Arden Textured Custom Curtain with Trim - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-2.png?v=1756266915",
					"variant_ids": [
						47622100254970
					]
				},
				"available": false,
				"name": "Arden Textured Custom Curtain with Trim - Beige",
				"public_title": "Beige",
				"options": [
					"Beige"
				],
				"price": 26900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Arden Textured Custom Curtain with Trim - TheHues",
					"id": 36576509952250,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-2.png?v=1756266915"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-beige_1024x1024.jpg?v=1756981392"
			},
			{
				"id": 47622364037370,
				"title": "Taupe",
				"option1": "Taupe",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-535-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837116150010,
					"product_id": 8891360968954,
					"position": 2,
					"created_at": "2025-08-18T11:42:16+08:00",
					"updated_at": "2025-09-04T18:23:12+08:00",
					"alt": "Arden Textured Custom Curtain with Trim - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-2.png?v=1756981392",
					"variant_ids": [
						47622364037370
					]
				},
				"available": false,
				"name": "Arden Textured Custom Curtain with Trim - Taupe",
				"public_title": "Taupe",
				"options": [
					"Taupe"
				],
				"price": 26900,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Arden Textured Custom Curtain with Trim - TheHues",
					"id": 36576510148858,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-2.png?v=1756981392"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-taupe_1024x1024.jpg?v=1756981392"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/arden-custom-curtains-beige-2.png?v=1756266915",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-2.png?v=1756981392",
			"//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-taupe.jpg?v=1756981392",
			"//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-beige.jpg?v=1756981392",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-beige-1.png?v=1756980062",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-beige-6.png?v=1756980062",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-beige-4.png?v=1756980062",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-1.png?v=1756980062",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-6.png?v=1756980062",
			"//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-4.png?v=1756980062"
		],
		"featured_image": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-2_1024x1024.png?v=1756266915",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576509952250,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-2.png?v=1756266915"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-2.png?v=1756266915",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36733048291578,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1080,
					"width": 864,
					"src": "//thehues.com/cdn/shop/files/preview_images/0e1c97273d8142ee8106d05459396c89.thumbnail.0000000000.jpg?v=1756979434"
				},
				"aspect_ratio": 0.8,
				"duration": 9330,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0e1c97273d8142ee8106d05459396c89/0e1c97273d8142ee8106d05459396c89.SD-480p-1.0Mbps-56789005.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0e1c97273d8142ee8106d05459396c89/0e1c97273d8142ee8106d05459396c89.HD-1080p-3.3Mbps-56789005.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0e1c97273d8142ee8106d05459396c89/0e1c97273d8142ee8106d05459396c89.HD-720p-2.1Mbps-56789005.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/0e1c97273d8142ee8106d05459396c89/0e1c97273d8142ee8106d05459396c89.m3u8?v=0",
						"width": 864
					}
				]
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576510148858,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-2.png?v=1756981392"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-2.png?v=1756981392",
				"width": 2000
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36640620773626,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1807,
					"width": 1446,
					"src": "//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-taupe.jpg?v=1756981392"
				},
				"aspect_ratio": 0.8,
				"height": 1807,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-taupe.jpg?v=1756981392",
				"width": 1446
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36640620806394,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1807,
					"width": 1446,
					"src": "//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-beige.jpg?v=1756981392"
				},
				"aspect_ratio": 0.8,
				"height": 1807,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-textured-curtain-with-trim-beige.jpg?v=1756981392",
				"width": 1446
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576509919482,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-1.png?v=1756980062"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-1.png?v=1756980062",
				"width": 2000
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576510083322,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-6.png?v=1756980062"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-6.png?v=1756980062",
				"width": 2000
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576510017786,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-4.png?v=1756980062"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-beige-4.png?v=1756980062",
				"width": 2000
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576510116090,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-1.png?v=1756980062"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-1.png?v=1756980062",
				"width": 2000
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576510279930,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-6.png?v=1756980062"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-6.png?v=1756980062",
				"width": 2000
			},
			{
				"alt": "Arden Textured Custom Curtain with Trim - TheHues",
				"id": 36576510214394,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-4.png?v=1756980062"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/arden-custom-curtains-taupe-4.png?v=1756980062",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bold yet tactile, Arden uses crossed yarns to craft a curtain with trim that’s both visually striking and richly textured.</p>",
		"url": "/products/arden-textured-custom-curtain-with-trim",
		"regular_price": "$269.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/charm-curtains",
				"title": "Charm Collection Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-arrival-curtains",
				"title": "New Arrival Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/the-charm-collection",
				"title": "The Charm Collection"
			},
			{
				"url": "/collections/the-charm-collection-uk",
				"title": "the charm collection -uk"
			}
		]
	},
	{
		"id": 8780124094714,
		"title": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain",
		"handle": "new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 70% Polyester 30% Acrylic</p><p>Weight: 316 g/m²<br>Features: UV Protection, Fade &amp; Water resistant<br>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Featuring a textured grid pattern, they provide excellent sun protection and are perfect for enhancing the look of outdoor spaces while ensuring long-lasting performance in all weather conditions.</p>",
		"published_at": "2025-05-07T16:31:10+08:00",
		"created_at": "2025-05-07T16:31:10+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > New Outdoor Curtains",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Patterned Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"flash_categories",
			"Independence Day",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain"
		],
		"price": 12500,
		"price_min": 12500,
		"price_max": 12500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319419126010,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH50021-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025410158842,
					"product_id": 8780124094714,
					"position": 1,
					"created_at": "2025-05-21T15:15:00+08:00",
					"updated_at": "2025-09-02T16:02:12+08:00",
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Black-1_resolution-standardv2-2x.jpg?v=1756800132",
					"variant_ids": [
						47319419126010
					]
				},
				"available": true,
				"name": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064174801146,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ANew-York-Black-1_resolution-standardv2-2x.jpg?v=1756800132"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AOFH50021-10-_resolution-standardv2-2x_1024x1024.jpg?v=1756800132"
			},
			{
				"id": 47319419158778,
				"title": "White",
				"option1": "White",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH50021-C-White",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025415074042,
					"product_id": 8780124094714,
					"position": 7,
					"created_at": "2025-05-21T15:15:35+08:00",
					"updated_at": "2025-09-02T16:02:12+08:00",
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ANew-York-White-1_resolution-standardv2-2x.jpg?v=1756800132",
					"variant_ids": [
						47319419158778
					]
				},
				"available": true,
				"name": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - White",
				"public_title": "White",
				"options": [
					"White"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064178176250,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ANew-York-White-1_resolution-standardv2-2x.jpg?v=1756800132"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AOFH50021-9_resolution-standardv2-2x_1024x1024.jpg?v=1756800132"
			},
			{
				"id": 47319419191546,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH50021-C-Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025413599482,
					"product_id": 8780124094714,
					"position": 13,
					"created_at": "2025-05-21T15:15:24+08:00",
					"updated_at": "2025-09-02T16:02:12+08:00",
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Green-5_resolution-standardv2-2x.jpg?v=1756800132",
					"variant_ids": [
						47319419191546
					]
				},
				"available": true,
				"name": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064177062138,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ANew-York-Green-5_resolution-standardv2-2x.jpg?v=1756800132"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AOFH50021-8-_resolution-standardv2-2x_1024x1024.jpg?v=1756800132"
			},
			{
				"id": 47319419224314,
				"title": "Dark Grey",
				"option1": "Dark Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH50021-C-Dark Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025412255994,
					"product_id": 8780124094714,
					"position": 19,
					"created_at": "2025-05-21T15:15:16+08:00",
					"updated_at": "2025-09-02T16:02:12+08:00",
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-1_resolution-standardv2-2x.jpg?v=1756800132",
					"variant_ids": [
						47319419224314
					]
				},
				"available": true,
				"name": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - Dark Grey",
				"public_title": "Dark Grey",
				"options": [
					"Dark Grey"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064176341242,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-1_resolution-standardv2-2x.jpg?v=1756800132"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AOFH50021-7-_resolution-standardv2-2x_1024x1024.jpg?v=1756800132"
			},
			{
				"id": 47319419257082,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH50021-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025414516986,
					"product_id": 8780124094714,
					"position": 25,
					"created_at": "2025-05-21T15:15:32+08:00",
					"updated_at": "2025-09-02T16:02:12+08:00",
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-1_resolution-standardv2-2x.jpg?v=1756800132",
					"variant_ids": [
						47319419257082
					]
				},
				"available": true,
				"name": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064177914106,
					"position": 25,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-1_resolution-standardv2-2x.jpg?v=1756800132"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AOFH50021-5-_resolution-standardv2-2x_1024x1024.jpg?v=1756800132"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ANew-York-Black-1_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-black.jpg?v=1761205825",
			"//thehues.com/cdn/shop/files/ANew-York-Black-2_resolution-standardv2-2x.jpg?v=1756801148",
			"//thehues.com/cdn/shop/files/ANew-York-Black-4_resolution-standardv2-2x.jpg?v=1756801148",
			"//thehues.com/cdn/shop/files/ANew-York-Black-5_resolution-standardv2-2x.jpg?v=1756801148",
			"//thehues.com/cdn/shop/files/ANew-York-Black-3_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-White-1_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-White-2_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-White-4_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-White-5_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-ivory.jpg?v=1761205825",
			"//thehues.com/cdn/shop/files/ANew-York-White-3_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Green-5_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Green-1_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Green-3_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Green-4_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-green.jpg?v=1761205825",
			"//thehues.com/cdn/shop/files/ANew-York-Green-2_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-1_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-2_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-6_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-3_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-grey.jpg?v=1761205825",
			"//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-5_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Grey-1_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Grey-2_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Grey-4_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/ANew-York-Grey-5_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-darkgrey.jpg?v=1761205825",
			"//thehues.com/cdn/shop/files/ANew-York-Grey-3_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/AOFH50021-10-_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/AOFH50021-9_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/AOFH50021-8-_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/AOFH50021-7-_resolution-standardv2-2x.jpg?v=1756800132",
			"//thehues.com/cdn/shop/files/AOFH50021-5-_resolution-standardv2-2x.jpg?v=1756800132"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ANew-York-Black-1_resolution-standardv2-2x_1024x1024.jpg?v=1756800132",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064174801146,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Black-1_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Black-1_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710610305274,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-black.jpg?v=1761205825"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-black.jpg?v=1761205825",
				"width": 3072
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064174833914,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Black-2_resolution-standardv2-2x.jpg?v=1756801148"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Black-2_resolution-standardv2-2x.jpg?v=1756801148",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064174899450,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Black-4_resolution-standardv2-2x.jpg?v=1756801148"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Black-4_resolution-standardv2-2x.jpg?v=1756801148",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064174932218,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Black-5_resolution-standardv2-2x.jpg?v=1756801148"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Black-5_resolution-standardv2-2x.jpg?v=1756801148",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064174866682,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Black-3_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Black-3_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178176250,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-White-1_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-White-1_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178209018,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-White-2_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-White-2_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178274554,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-White-4_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-White-4_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178307322,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-White-5_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-White-5_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710610534650,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-ivory.jpg?v=1761205825"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-ivory.jpg?v=1761205825",
				"width": 3072
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178241786,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-White-3_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-White-3_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064177062138,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Green-5_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Green-5_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176931066,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Green-1_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Green-1_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176996602,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Green-3_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Green-3_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064177029370,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Green-4_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Green-4_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710610600186,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-green.jpg?v=1761205825"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-green.jpg?v=1761205825",
				"width": 3072
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176963834,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Green-2_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Green-2_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176341242,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-1_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-1_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176374010,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-2_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-2_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176505082,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-6_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-6_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176406778,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-3_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-3_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710610501882,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-grey.jpg?v=1761205825"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-grey.jpg?v=1761205825",
				"width": 3072
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176472314,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-5_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Dark-Grey-5_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064177914106,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-1_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-1_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064177946874,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-2_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-2_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178045178,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-4_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-4_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178077946,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-5_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-5_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710610403578,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-darkgrey.jpg?v=1761205825"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain-darkgrey.jpg?v=1761205825",
				"width": 3072
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064177979642,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-3_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ANew-York-Grey-3_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064174768378,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOFH50021-10-_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOFH50021-10-_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064178143482,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOFH50021-9_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOFH50021-9_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176898298,
				"position": 33,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOFH50021-8-_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOFH50021-8-_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064176308474,
				"position": 34,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOFH50021-7-_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOFH50021-7-_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			},
			{
				"alt": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064177881338,
				"position": 35,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AOFH50021-5-_resolution-standardv2-2x.jpg?v=1756800132"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AOFH50021-5-_resolution-standardv2-2x.jpg?v=1756800132",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Featuring a textured grid pattern, they provide excellent sun protection and are perfect for enhancing the look of outdoor spaces while ensuring long-lasting performance in all weather conditions.</p>",
		"url": "/products/new-york-grid-patterned-textured-waterproof-custom-outdoor-curtain",
		"regular_price": "$125.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	},
	{
		"id": 8888506482938,
		"title": "Luna Linen Blend Textured Custom Curtain with Trim",
		"handle": "luna-linen-blend-textured-custom-curtain-with-trim",
		"product_details": `<h3>Specifications</h3><p>Material: 70% Polyester 30% Acrylic</p><p>Weight: 316 g/m²<br>Features: UV Protection, Fade &amp; Water resistant<br>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>With delicate texture and subtle faux leather accents, Luna’s linen blend transforms a curtain with trim into a statement of understated elegance.</p>",
		"published_at": "2025-09-04T13:42:16+08:00",
		"created_at": "2025-08-14T09:37:51+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Arrival",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"ruichi",
			"ruichi curtain",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat"
		],
		"price": 24900,
		"price_min": 24900,
		"price_max": 24900,
		"available": false,
		"price_varies": false,
		"compare_at_price": 28900,
		"compare_at_price_min": 28900,
		"compare_at_price_max": 28900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47613095477498,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-68219-13-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44924357509370,
					"product_id": 8888506482938,
					"position": 1,
					"created_at": "2025-08-26T17:59:15+08:00",
					"updated_at": "2025-09-04T14:41:27+08:00",
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2002,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-3.jpg?v=1756968087",
					"variant_ids": [
						47613095477498
					]
				},
				"available": false,
				"name": "Luna Linen Blend Textured Custom Curtain with Trim - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 24900,
				"weight": 0,
				"compare_at_price": 28900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36652422299898,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.801,
						"height": 2500,
						"width": 2002,
						"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-3.jpg?v=1756968087"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-1_1024x1024.jpg?v=1756102519"
			},
			{
				"id": 47613095510266,
				"title": "Ash",
				"option1": "Ash",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-68219-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44924357116154,
					"product_id": 8888506482938,
					"position": 2,
					"created_at": "2025-08-26T17:59:14+08:00",
					"updated_at": "2025-09-04T18:27:21+08:00",
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-3.jpg?v=1756981641",
					"variant_ids": [
						47613095510266
					]
				},
				"available": false,
				"name": "Luna Linen Blend Textured Custom Curtain with Trim - Ash",
				"public_title": "Ash",
				"options": [
					"Ash"
				],
				"price": 24900,
				"weight": 0,
				"compare_at_price": 28900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36652421906682,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-3.jpg?v=1756981641"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-1_1024x1024.jpg?v=1756102474"
			},
			{
				"id": 47613095543034,
				"title": "Stone",
				"option1": "Stone",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-68219-4-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44924357574906,
					"product_id": 8888506482938,
					"position": 4,
					"created_at": "2025-08-26T17:59:15+08:00",
					"updated_at": "2025-09-04T18:27:21+08:00",
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-1.jpg?v=1756981641",
					"variant_ids": [
						47613095543034
					]
				},
				"available": false,
				"name": "Luna Linen Blend Textured Custom Curtain with Trim - Stone",
				"public_title": "Stone",
				"options": [
					"Stone"
				],
				"price": 24900,
				"weight": 0,
				"compare_at_price": 28900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36652422365434,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-1.jpg?v=1756981641"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-1_1024x1024.jpg?v=1756102474"
			},
			{
				"id": 47613095575802,
				"title": "Gray",
				"option1": "Gray",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-68219-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44924357312762,
					"product_id": 8888506482938,
					"position": 6,
					"created_at": "2025-08-26T17:59:14+08:00",
					"updated_at": "2025-09-04T18:27:21+08:00",
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-1.jpg?v=1756981641",
					"variant_ids": [
						47613095575802
					]
				},
				"available": false,
				"name": "Luna Linen Blend Textured Custom Curtain with Trim - Gray",
				"public_title": "Gray",
				"options": [
					"Gray"
				],
				"price": 24900,
				"weight": 0,
				"compare_at_price": 28900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36652422103290,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-1.jpg?v=1756981641"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-grey-1_1024x1024.jpg?v=1756102474"
			},
			{
				"id": 47613095608570,
				"title": "Blue",
				"option1": "Blue",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-68219-10-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44924357247226,
					"product_id": 8888506482938,
					"position": 8,
					"created_at": "2025-08-26T17:59:14+08:00",
					"updated_at": "2025-09-04T18:27:21+08:00",
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-3.jpg?v=1756981641",
					"variant_ids": [
						47613095608570
					]
				},
				"available": false,
				"name": "Luna Linen Blend Textured Custom Curtain with Trim - Blue",
				"public_title": "Blue",
				"options": [
					"Blue"
				],
				"price": 24900,
				"weight": 0,
				"compare_at_price": 28900,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36652422037754,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-3.jpg?v=1756981641"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue_1024x1024.jpg?v=1756102474"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-3.jpg?v=1756968087",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-3.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-40.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-1.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-40.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-1.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-grey-40.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-3.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-blue-40.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-40.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-4.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-2.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-4.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-2.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-4.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-2.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-4.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-2.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-4.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-2.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-1.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-1.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-3.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-3.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-1.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-7.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-7.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-7.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-gray-7.jpg?v=1756981641",
			"//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-blue-7.jpg?v=1756981641"
		],
		"featured_image": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-3_1024x1024.jpg?v=1756968087",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422299898,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.801,
					"height": 2500,
					"width": 2002,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-3.jpg?v=1756968087"
				},
				"aspect_ratio": 0.801,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-3.jpg?v=1756968087",
				"width": 2002
			},
			{
				"alt": null,
				"id": 36733109436666,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1200,
					"width": 960,
					"src": "//thehues.com/cdn/shop/files/preview_images/b762390fc7a444858a24d6809ee89231.thumbnail.0000000000.jpg?v=1756980240"
				},
				"aspect_ratio": 0.8,
				"duration": 5850,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/b762390fc7a444858a24d6809ee89231/b762390fc7a444858a24d6809ee89231.SD-480p-1.5Mbps-56789906.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/b762390fc7a444858a24d6809ee89231/b762390fc7a444858a24d6809ee89231.HD-1080p-7.2Mbps-56789906.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/b762390fc7a444858a24d6809ee89231/b762390fc7a444858a24d6809ee89231.HD-720p-4.5Mbps-56789906.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/b762390fc7a444858a24d6809ee89231/b762390fc7a444858a24d6809ee89231.m3u8?v=0",
						"width": 864
					}
				]
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652421906682,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-3.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-3.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36732390211834,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-40.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-40.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422365434,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-1.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-1.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36732390277370,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-40.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-40.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422103290,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-1.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-1.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36732390179066,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-grey-40.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-grey-40.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422037754,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-3.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-3.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36732390244602,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-blue-40.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-blue-40.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36732390146298,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-40.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-40.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422332666,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-4.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-4.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422267130,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-2.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ivory-2.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652421939450,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-4.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-4.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652421873914,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-2.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-ash-2.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422463738,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.801,
					"height": 2500,
					"width": 2002,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-4.jpg?v=1756981641"
				},
				"aspect_ratio": 0.801,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-4.jpg?v=1756981641",
				"width": 2002
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422398202,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-2.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-2.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422201594,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-4.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-4.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422136058,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.801,
					"height": 2500,
					"width": 2002,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-2.jpg?v=1756981641"
				},
				"aspect_ratio": 0.801,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-2.jpg?v=1756981641",
				"width": 2002
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422070522,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-4.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-4.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422004986,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-2.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-2.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422234362,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-1.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-1.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652421841146,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-1.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-1.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422430970,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-3.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-stone-3.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652422168826,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-3.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-gray-3.jpg?v=1756981641",
				"width": 2001
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36652421972218,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.801,
					"height": 2500,
					"width": 2002,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-1.jpg?v=1756981641"
				},
				"aspect_ratio": 0.801,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-curtain-with-trim-blue-1.jpg?v=1756981641",
				"width": 2002
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36658551226618,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-7.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ivory-7.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36658551161082,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-7.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-ash-7.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36658551259386,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-7.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-stone-7.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36658551193850,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-gray-7.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-gray-7.jpg?v=1756981641",
				"width": 2000
			},
			{
				"alt": "Luna Linen Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36658551128314,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-blue-7.jpg?v=1756981641"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/luna-linen-blend-textured-custom-curtain-with-trim-blue-7.jpg?v=1756981641",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With delicate texture and subtle faux leather accents, Luna’s linen blend transforms a curtain with trim into a statement of understated elegance.</p>",
		"url": "/products/luna-linen-blend-textured-custom-curtain-with-trim",
		"regular_price": "$249.00",
		"sale_price": "$289.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/charm-curtains",
				"title": "Charm Collection Curtains"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/new-arrival-curtains",
				"title": "New Arrival Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/the-charm-collection",
				"title": "The Charm Collection"
			},
			{
				"url": "/collections/the-charm-collection-uk",
				"title": "the charm collection -uk"
			}
		]
	},
	{
		"id": 8780124127482,
		"title": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain",
		"handle": "bohemia-crisscross-woven-patterned-textured-waterproof-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Weight: 445 g/m²<br>Features: UV protection, Fade &amp; Water resistant<br>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Bohemia waterproof and UV blocking outdoor curtains feature a unified pattern that brings together a harmonious blend of shapes and textures.</p>",
		"published_at": "2025-05-07T16:31:11+08:00",
		"created_at": "2025-05-07T16:31:11+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > New Outdoor Curtains",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"flash_categories",
			"Independence Day",
			"july sale",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain"
		],
		"price": 12500,
		"price_min": 12500,
		"price_max": 12500,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319462772986,
				"title": "Wheat",
				"option1": "Wheat",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18045-C-Wheat",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025353666810,
					"product_id": 8780124127482,
					"position": 1,
					"created_at": "2025-05-21T15:07:25+08:00",
					"updated_at": "2025-08-26T16:26:43+08:00",
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AWheat-2_resolution-standardv2-2x.jpg?v=1756196803",
					"variant_ids": [
						47319462772986
					]
				},
				"available": true,
				"name": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - Wheat",
				"public_title": "Wheat",
				"options": [
					"Wheat"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064140296442,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AWheat-2_resolution-standardv2-2x.jpg?v=1756196803"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AWheat-6-1_resolution-standardv2-2x_1024x1024.jpg?v=1761207210"
			},
			{
				"id": 47319462805754,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18045-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025352192250,
					"product_id": 8780124127482,
					"position": 7,
					"created_at": "2025-05-21T15:07:14+08:00",
					"updated_at": "2025-08-26T16:26:44+08:00",
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGrey-2-2_resolution-standardv2-2x.jpg?v=1756196804",
					"variant_ids": [
						47319462805754
					]
				},
				"available": true,
				"name": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064139772154,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGrey-2-2_resolution-standardv2-2x.jpg?v=1756196804"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AGrey-6-5_resolution-standardv2-2x_1024x1024.jpg?v=1761207210"
			},
			{
				"id": 47319462838522,
				"title": "Yellow",
				"option1": "Yellow",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18045-C-Yellow",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025354813690,
					"product_id": 8780124127482,
					"position": 13,
					"created_at": "2025-05-21T15:07:28+08:00",
					"updated_at": "2025-08-26T16:26:45+08:00",
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_322be7d6-cd0e-4c3f-bffc-8b3cc9205938.jpg?v=1756196805",
					"variant_ids": [
						47319462838522
					]
				},
				"available": true,
				"name": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - Yellow",
				"public_title": "Yellow",
				"options": [
					"Yellow"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064140886266,
					"position": 13,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_322be7d6-cd0e-4c3f-bffc-8b3cc9205938.jpg?v=1756196805"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AYellow-6-1_resolution-standardv2-2x_1024x1024.jpg?v=1761207210"
			},
			{
				"id": 47319462871290,
				"title": "Green",
				"option1": "Green",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18045-C-Green",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025350783226,
					"product_id": 8780124127482,
					"position": 19,
					"created_at": "2025-05-21T15:07:02+08:00",
					"updated_at": "2025-08-26T16:26:46+08:00",
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGreen-2-1_resolution-standardv2-2x.jpg?v=1756196806",
					"variant_ids": [
						47319462871290
					]
				},
				"available": true,
				"name": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - Green",
				"public_title": "Green",
				"options": [
					"Green"
				],
				"price": 12500,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064138756346,
					"position": 19,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGreen-2-1_resolution-standardv2-2x.jpg?v=1756196806"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AGreen-6-3_resolution-standardv2-2x_1024x1024.jpg?v=1761207210"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/AWheat-2_resolution-standardv2-2x.jpg?v=1756196803",
			"//thehues.com/cdn/shop/files/AWheat-5_resolution-standardv2-2x.jpg?v=1756196803",
			"//thehues.com/cdn/shop/files/AWheat-1-1_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AWheat-3_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AWheat-6-1_resolution-standardv2-2x.jpg?v=1761207210",
			"//thehues.com/cdn/shop/files/AWheat-4_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AGrey-2-2_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AGrey-1-3_resolution-standardv2-2x_7c06fca4-cc85-41f6-8eec-687ab60003d1.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AGrey-3-2_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AGrey-6-5_resolution-standardv2-2x.jpg?v=1761207210",
			"//thehues.com/cdn/shop/files/AGrey-4-2_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AGrey-5-2_resolution-standardv2-2x.jpg?v=1756196804",
			"//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_322be7d6-cd0e-4c3f-bffc-8b3cc9205938.jpg?v=1756196805",
			"//thehues.com/cdn/shop/files/AYellow-1_resolution-standardv2-2x_079d0c9b-5a44-43e9-8309-13f68d08ce6e.jpg?v=1756196805",
			"//thehues.com/cdn/shop/files/AYellow-3_resolution-standardv2-2x_212aa542-5736-4081-a6e2-44312567cd37.jpg?v=1756196805",
			"//thehues.com/cdn/shop/files/AYellow-6-1_resolution-standardv2-2x.jpg?v=1761207210",
			"//thehues.com/cdn/shop/files/AYellow-4_resolution-standardv2-2x_8d357e7f-785c-4d35-be33-0b87e35cea8c.jpg?v=1756196805",
			"//thehues.com/cdn/shop/files/AYellow-5_resolution-standardv2-2x.jpg?v=1756196805",
			"//thehues.com/cdn/shop/files/AGreen-2-1_resolution-standardv2-2x.jpg?v=1756196806",
			"//thehues.com/cdn/shop/files/AGreen-1-1_resolution-standardv2-2x_ae7925d3-a913-4c72-b48a-eabecbec0e29.jpg?v=1756196806",
			"//thehues.com/cdn/shop/files/AGreen-3-1_resolution-standardv2-2x.jpg?v=1756196806",
			"//thehues.com/cdn/shop/files/AGreen-6-3_resolution-standardv2-2x.jpg?v=1761207210",
			"//thehues.com/cdn/shop/files/AGreen-4-1_resolution-standardv2-2x.jpg?v=1756196806",
			"//thehues.com/cdn/shop/files/AGreen-5-1_resolution-standardv2-2x.jpg?v=1756196807"
		],
		"featured_image": "//thehues.com/cdn/shop/files/AWheat-2_resolution-standardv2-2x_1024x1024.jpg?v=1756196803",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140296442,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-2_resolution-standardv2-2x.jpg?v=1756196803"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-2_resolution-standardv2-2x.jpg?v=1756196803",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140394746,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-5_resolution-standardv2-2x.jpg?v=1756196803"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-5_resolution-standardv2-2x.jpg?v=1756196803",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140263674,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-1-1_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-1-1_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140329210,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-3_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-3_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140230906,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-6-1_resolution-standardv2-2x.jpg?v=1761207210"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-6-1_resolution-standardv2-2x.jpg?v=1761207210",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140361978,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-4_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-4_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064139772154,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-2-2_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-2-2_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064139739386,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-1-3_resolution-standardv2-2x_7c06fca4-cc85-41f6-8eec-687ab60003d1.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-1-3_resolution-standardv2-2x_7c06fca4-cc85-41f6-8eec-687ab60003d1.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064139804922,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-3-2_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-3-2_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064139706618,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-6-5_resolution-standardv2-2x.jpg?v=1761207210"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-6-5_resolution-standardv2-2x.jpg?v=1761207210",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064139837690,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-4-2_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-4-2_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064139870458,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-5-2_resolution-standardv2-2x.jpg?v=1756196804"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-5-2_resolution-standardv2-2x.jpg?v=1756196804",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140886266,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_322be7d6-cd0e-4c3f-bffc-8b3cc9205938.jpg?v=1756196805"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-2_resolution-standardv2-2x_322be7d6-cd0e-4c3f-bffc-8b3cc9205938.jpg?v=1756196805",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140853498,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-1_resolution-standardv2-2x_079d0c9b-5a44-43e9-8309-13f68d08ce6e.jpg?v=1756196805"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-1_resolution-standardv2-2x_079d0c9b-5a44-43e9-8309-13f68d08ce6e.jpg?v=1756196805",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140919034,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-3_resolution-standardv2-2x_212aa542-5736-4081-a6e2-44312567cd37.jpg?v=1756196805"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-3_resolution-standardv2-2x_212aa542-5736-4081-a6e2-44312567cd37.jpg?v=1756196805",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140820730,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-6-1_resolution-standardv2-2x.jpg?v=1761207210"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-6-1_resolution-standardv2-2x.jpg?v=1761207210",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140951802,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-4_resolution-standardv2-2x_8d357e7f-785c-4d35-be33-0b87e35cea8c.jpg?v=1756196805"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-4_resolution-standardv2-2x_8d357e7f-785c-4d35-be33-0b87e35cea8c.jpg?v=1756196805",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064140984570,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AYellow-5_resolution-standardv2-2x.jpg?v=1756196805"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AYellow-5_resolution-standardv2-2x.jpg?v=1756196805",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064138756346,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-2-1_resolution-standardv2-2x.jpg?v=1756196806"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-2-1_resolution-standardv2-2x.jpg?v=1756196806",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064138723578,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-1-1_resolution-standardv2-2x_ae7925d3-a913-4c72-b48a-eabecbec0e29.jpg?v=1756196806"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-1-1_resolution-standardv2-2x_ae7925d3-a913-4c72-b48a-eabecbec0e29.jpg?v=1756196806",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064138789114,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-3-1_resolution-standardv2-2x.jpg?v=1756196806"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-3-1_resolution-standardv2-2x.jpg?v=1756196806",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064138690810,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-6-3_resolution-standardv2-2x.jpg?v=1761207210"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-6-3_resolution-standardv2-2x.jpg?v=1761207210",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064138821882,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-4-1_resolution-standardv2-2x.jpg?v=1756196806"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-4-1_resolution-standardv2-2x.jpg?v=1756196806",
				"width": 2000
			},
			{
				"alt": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064138854650,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreen-5-1_resolution-standardv2-2x.jpg?v=1756196807"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreen-5-1_resolution-standardv2-2x.jpg?v=1756196807",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Bohemia waterproof and UV blocking outdoor curtains feature a unified pattern that brings together a harmonious blend of shapes and textures.</p>",
		"url": "/products/bohemia-crisscross-woven-patterned-textured-waterproof-custom-outdoor-curtain",
		"regular_price": "$125.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	},
	{
		// "id": 8830916919546,
		"title": "Brittany 100% Linen Custom Curtain",
		"handle": "brittany-pure-custom-linen-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Linen<br>Features: Light Filtering<br>Weight: Light Weight (210g/㎡)<br>Softness: Soft</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Do Not Dry</p><p>Do Not Bleach</p><p>Iron Back Side Only</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Brittany is 100% linen, woven with a rhythm like falling rain¡ªeach thread a soft echo of nature¡¯s quiet moments.</p>",
		"description": "<p>Brittany is 100% linen, woven with a rhythm like falling rain¡ªeach thread a soft echo of nature¡¯s quiet moments.</p>",
		"published_at": "2025-06-18T19:05:34+08:00",
		"created_at": "2025-06-11T15:39:02+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Bestseller",
			"Blackout available",
			"can't memory",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Linen & Cotton Curtains",
			"Curtains > Linen & Cotton Curtains > Linen Curtains",
			"Curtains Memory Training",
			"flash_categories",
			"indoor curtain",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search linen",
			"Search Pinch pleat"
		],
		"price": 11300,
		"price_min": 11300,
		"price_max": 11300,
		"available": true,
		"price_varies": false,
		"compare_at_price": 15900,
		"compare_at_price_min": 15900,
		"compare_at_price_max": 15900,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47405259653370,
				"title": "Natural",
				"option1": "Natural",
				"option2": null,
				"option3": null,
				"sku": "THC-JY1-YLM8010-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44182709338362,
					"product_id": 8830916919546,
					"position": 1,
					"created_at": "2025-06-11T16:09:44+08:00",
					"updated_at": "2025-08-26T16:20:00+08:00",
					"alt": "Brittany 100% Linen Custom Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ADSC04477_copy-standardv2-2000w.jpg?v=1756196400",
					"variant_ids": [
						47405259653370
					]
				},
				"available": true,
				"name": "Brittany 100% Linen Custom Curtain - Natural",
				"public_title": "Natural",
				"options": [
					"Natural"
				],
				"price": 11300,
				"weight": 0,
				"compare_at_price": 15900,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Brittany 100% Linen Custom Curtain - TheHues",
					"id": 36167768277242,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ADSC04477_copy-standardv2-2000w.jpg?v=1756196400"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/Abrittany_natural_1024x1024.jpg?v=1751333875"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ADSC04477_copy-standardv2-2000w.jpg?v=1756196400",
			"//thehues.com/cdn/shop/files/ADSC04508_-standardv2-2000w.jpg?v=1756196400",
			"//thehues.com/cdn/shop/files/ADSC04510_-standardv2-2000w.jpg?v=1756196400",
			"//thehues.com/cdn/shop/files/ADSC04490_-standardv2-2000w.jpg?v=1756196400"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ADSC04477_copy-standardv2-2000w_1024x1024.jpg?v=1756196400",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Brittany 100% Linen Custom Curtain - TheHues",
				"id": 36167768277242,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04477_copy-standardv2-2000w.jpg?v=1756196400"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04477_copy-standardv2-2000w.jpg?v=1756196400",
				"width": 2000
			},
			{
				"alt": "Brittany 100% Linen Custom Curtain - TheHues",
				"id": 36167768342778,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04508_-standardv2-2000w.jpg?v=1756196400"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04508_-standardv2-2000w.jpg?v=1756196400",
				"width": 2000
			},
			{
				"alt": "Brittany 100% Linen Custom Curtain - TheHues",
				"id": 36167768375546,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04510_-standardv2-2000w.jpg?v=1756196400"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04510_-standardv2-2000w.jpg?v=1756196400",
				"width": 2000
			},
			{
				"alt": "Brittany 100% Linen Custom Curtain - TheHues",
				"id": 36167768310010,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADSC04490_-standardv2-2000w.jpg?v=1756196400"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADSC04490_-standardv2-2000w.jpg?v=1756196400",
				"width": 2000
			},
			{
				"alt": null,
				"id": 36215570137338,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 1920,
					"width": 1536,
					"src": "//thehues.com/cdn/shop/files/preview_images/8cc58618321d4454be571dabb8ed6053.thumbnail.0000000000.jpg?v=1750240847"
				},
				"aspect_ratio": 0.8,
				"duration": 8800,
				"media_type": "video",
				"sources": [
					{
						"format": "mp4",
						"height": 480,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8cc58618321d4454be571dabb8ed6053/8cc58618321d4454be571dabb8ed6053.SD-480p-1.5Mbps-49607047.mp4?v=0",
						"width": 384
					},
					{
						"format": "mp4",
						"height": 1080,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8cc58618321d4454be571dabb8ed6053/8cc58618321d4454be571dabb8ed6053.HD-1080p-7.2Mbps-49607047.mp4?v=0",
						"width": 864
					},
					{
						"format": "mp4",
						"height": 720,
						"mime_type": "video/mp4",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8cc58618321d4454be571dabb8ed6053/8cc58618321d4454be571dabb8ed6053.HD-720p-4.5Mbps-49607047.mp4?v=0",
						"width": 576
					},
					{
						"format": "m3u8",
						"height": 1080,
						"mime_type": "application/x-mpegURL",
						"url": "//thehues.com/cdn/shop/videos/c/vp/8cc58618321d4454be571dabb8ed6053/8cc58618321d4454be571dabb8ed6053.m3u8?v=0",
						"width": 864
					}
				]
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Brittany is 100% linen, woven with a rhythm like falling rain¡ªeach thread a soft echo of nature¡¯s quiet moments.</p>",
		"url": "/products/brittany-pure-custom-linen-curtain",
		"regular_price": "$113.00",
		"sale_price": "$159.00",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/cant-memory-trained",
				"title": "can't memory trained"
			},
			{
				"url": "/collections/cotton-linen-curtains",
				"title": "Cotton & Linen Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/linen-curtains",
				"title": "Linen Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/best-product",
				"title": "Room Curtains"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			}
		]
	},
	{
		"id": 8905616982266,
		"title": "Juliette Wool Blend Textured Custom Curtain with Trim",
		"handle": "juliette-wool-blend-textured-custom-curtain-with-trim",
		"product_details": `<h3>Specifications</h3><p><strong>Material </strong>5% Wool &amp; 95% Polyester</p><p><strong>Features</strong> Room Darkening</p><p><strong>Weight</strong> Regular (454g/㎡)</p><p><strong>Softness</strong> Heavy Weight</p><p></p><h3>Care</h3><p>Hand-washing only at temperature below 30°C</p><p>Iron safe (below 110℃)</p><p>Avoid bleaching</p><p>Dry clean safe</p>`,
		"description": "<p>With its rich wool texture and substantial faux leather edging, Juliette balances warmth and sophistication in every fold.</p>",
		"published_at": "2025-09-04T13:42:30+08:00",
		"created_at": "2025-08-28T09:32:54+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > Solid Curtains",
			"Blackout available",
			"Curtain Measurement",
			"Curtains",
			"Curtains & Shades",
			"Curtains Memory Training",
			"fall sale",
			"flash_categories",
			"indoor curtain",
			"New Arrival",
			"New Arrivals",
			"New Content",
			"Outsourced products",
			"ruichi",
			"ruichi curtain",
			"Sale",
			"Sale > All Curtain Sale",
			"Search curtains",
			"Search Pinch pleat",
			"thanksgiving BS",
			"Thanksgiving sale"
		],
		"price": 25800,
		"price_min": 25800,
		"price_max": 25800,
		"available": false,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47657981083898,
				"title": "Ivory",
				"option1": "Ivory",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-1661-1-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837211177210,
					"product_id": 8905616982266,
					"position": 1,
					"created_at": "2025-08-18T11:57:28+08:00",
					"updated_at": "2025-08-29T14:09:11+08:00",
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-6.png?v=1756447751",
					"variant_ids": [
						47657981083898
					]
				},
				"available": false,
				"name": "Juliette Wool Blend Textured Custom Curtain with Trim - Ivory",
				"public_title": "Ivory",
				"options": [
					"Ivory"
				],
				"price": 25800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36576603472122,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-6.png?v=1756447751"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-ivory_1024x1024.png?v=1756447930"
			},
			{
				"id": 47657981149434,
				"title": "Sesame",
				"option1": "Sesame",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-1661-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837210980602,
					"product_id": 8905616982266,
					"position": 3,
					"created_at": "2025-08-18T11:57:28+08:00",
					"updated_at": "2025-09-04T14:10:52+08:00",
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-4.png?v=1756966252",
					"variant_ids": [
						47657981149434
					]
				},
				"available": false,
				"name": "Juliette Wool Blend Textured Custom Curtain with Trim - Sesame",
				"public_title": "Sesame",
				"options": [
					"Sesame"
				],
				"price": 25800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36576603275514,
					"position": 3,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-4.png?v=1756966252"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-1_1024x1024.png?v=1756966252"
			},
			{
				"id": 47657981116666,
				"title": "Gold Green",
				"option1": "Gold Green",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-1661-2-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837210849530,
					"product_id": 8905616982266,
					"position": 5,
					"created_at": "2025-08-18T11:57:28+08:00",
					"updated_at": "2025-09-04T14:10:52+08:00",
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-3.png?v=1756966252",
					"variant_ids": [
						47657981116666
					]
				},
				"available": false,
				"name": "Juliette Wool Blend Textured Custom Curtain with Trim - Gold Green",
				"public_title": "Gold Green",
				"options": [
					"Gold Green"
				],
				"price": 25800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36576603144442,
					"position": 5,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-3.png?v=1756966252"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-2_1024x1024.png?v=1756447751"
			},
			{
				"id": 47657981182202,
				"title": "Botanic",
				"option1": "Botanic",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-1661-5-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837211209978,
					"product_id": 8905616982266,
					"position": 7,
					"created_at": "2025-08-18T11:57:28+08:00",
					"updated_at": "2025-09-04T14:10:52+08:00",
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-seasame-2.png?v=1756966252",
					"variant_ids": [
						47657981182202
					]
				},
				"available": false,
				"name": "Juliette Wool Blend Textured Custom Curtain with Trim - Botanic",
				"public_title": "Botanic",
				"options": [
					"Botanic"
				],
				"price": 25800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36576603504890,
					"position": 7,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-seasame-2.png?v=1756966252"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic-17_1024x1024.jpg?v=1756966252"
			},
			{
				"id": 47657983901946,
				"title": "Marble",
				"option1": "Marble",
				"option2": null,
				"option3": null,
				"sku": "THC-Ruichi-1661-6-SD",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44837210685690,
					"product_id": 8905616982266,
					"position": 9,
					"created_at": "2025-08-18T11:57:27+08:00",
					"updated_at": "2025-09-04T14:10:52+08:00",
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"width": 2001,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-1.png?v=1756966252",
					"variant_ids": [
						47657983901946
					]
				},
				"available": false,
				"name": "Juliette Wool Blend Textured Custom Curtain with Trim - Marble",
				"public_title": "Marble",
				"options": [
					"Marble"
				],
				"price": 25800,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": "",
				"featured_media": {
					"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
					"id": 36576602980602,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2001,
						"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-1.png?v=1756966252"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-3_1024x1024.png?v=1756966252"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-6.png?v=1756447751",
			"//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-ivory.png?v=1756447930",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-4.png?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-1.png?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-3.png?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-goldengreen.jpg?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-seasame-2.png?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic-17.jpg?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-1.png?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-3.png?v=1756966252",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-5.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-1.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-2.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-3.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-4.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-2.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-1.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-sesame-1.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-sesame-3.png?v=1756966096",
			"//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic.jpg?v=1756447751",
			"//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-2.png?v=1756447751"
		],
		"featured_image": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-6_1024x1024.png?v=1756447751",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603472122,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-6.png?v=1756447751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-6.png?v=1756447751",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36641763262714,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-ivory.png?v=1756447930"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-ivory.png?v=1756447930",
				"width": 1638
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603275514,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-4.png?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-4.png?v=1756966252",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603177210,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-1.png?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-green-1.png?v=1756966252",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603144442,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-3.png?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-3.png?v=1756966252",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36641763229946,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-goldengreen.jpg?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-goldengreen.jpg?v=1756966252",
				"width": 1638
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603504890,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-seasame-2.png?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-seasame-2.png?v=1756966252",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36677626626298,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic-17.jpg?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic-17.jpg?v=1756966252",
				"width": 1638
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576602980602,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-1.png?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-1.png?v=1756966252",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603046138,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-3.png?v=1756966252"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-3.png?v=1756966252",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603439354,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-5.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-5.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603308282,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-1.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-1.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603341050,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-2.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-2.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603373818,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-3.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-3.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603406586,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-4.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-ivory-4.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603013370,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-2.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-black-2.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603078906,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-1.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-1.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603537658,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-sesame-1.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-sesame-1.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603570426,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-sesame-3.png?v=1756966096"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-sesame-3.png?v=1756966096",
				"width": 2001
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36641763197178,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2048,
					"width": 1638,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic.jpg?v=1756447751"
				},
				"aspect_ratio": 0.8,
				"height": 2048,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-blend-textured-custom-curtain-with-trim-Botanic.jpg?v=1756447751",
				"width": 1638
			},
			{
				"alt": "Juliette Wool Blend Textured Custom Curtain with Trim - TheHues",
				"id": 36576603111674,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2001,
					"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-2.png?v=1756447751"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/juliette-wool-custom-curtains-golden-2.png?v=1756447751",
				"width": 2001
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>With its rich wool texture and substantial faux leather edging, Juliette balances warmth and sophistication in every fold.</p>",
		"url": "/products/juliette-wool-blend-textured-custom-curtain-with-trim",
		"regular_price": "$258.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/charm-curtains",
				"title": "Charm Collection Curtains"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/fall-sale",
				"title": "Fall Sale"
			},
			{
				"url": "/collections/indoor-curtains",
				"title": "Indoor Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/new-arrival-curtains",
				"title": "New Arrival Curtains"
			},
			{
				"url": "/collections/new-arrivals",
				"title": "New Arrivals"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/solid-curtains",
				"title": "Solid Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/thanksgiving-curtain",
				"title": "Thanksgiving Curtain"
			},
			{
				"url": "/collections/thanksgiving-edit",
				"title": "Thanksgiving Edit"
			},
			{
				"url": "/collections/the-charm-collection",
				"title": "The Charm Collection"
			},
			{
				"url": "/collections/the-charm-collection-uk",
				"title": "the charm collection -uk"
			}
		]
	},
	{
		"id": 8780124061946,
		"title": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain",
		"handle": "miami-fishtail-patterned-waterproof-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Weight: 255 g/m²<br>Features: UV protection, Fade &amp; Water resistant<br>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Miami waterproof UV-protective outdoor curtains combine functionality with style.</p>",
		"published_at": "2025-05-07T16:31:09+08:00",
		"created_at": "2025-05-07T16:31:09+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"All Curtains",
			"All Curtains > New Outdoor Curtains",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"flash_categories",
			"Independence Day",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain",
			"Summer"
		],
		"price": 11700,
		"price_min": 11700,
		"price_max": 11700,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319427547386,
				"title": "Sand",
				"option1": "Sand",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH18035-C-Sand",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025363661050,
					"product_id": 8780124061946,
					"position": 1,
					"created_at": "2025-05-21T15:09:38+08:00",
					"updated_at": "2025-09-01T16:49:52+08:00",
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ASand-1_resolution-standardv2-2x.jpg?v=1756716592",
					"variant_ids": [
						47319427547386
					]
				},
				"available": true,
				"name": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - Sand",
				"public_title": "Sand",
				"options": [
					"Sand"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064147374330,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ASand-1_resolution-standardv2-2x.jpg?v=1756716592"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ASand-6-1_resolution-standardv2-2x_1024x1024.jpg?v=1756716592"
			},
			{
				"id": 47319427580154,
				"title": "Greyish Blue",
				"option1": "Greyish Blue",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH18035-C-Greyish Blue",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025362350330,
					"product_id": 8780124061946,
					"position": 8,
					"created_at": "2025-05-21T15:09:25+08:00",
					"updated_at": "2025-09-01T16:49:52+08:00",
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-1_resolution-standardv2-2x.jpg?v=1756716592",
					"variant_ids": [
						47319427580154
					]
				},
				"available": true,
				"name": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - Greyish Blue",
				"public_title": "Greyish Blue",
				"options": [
					"Greyish Blue"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064146489594,
					"position": 8,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-1_resolution-standardv2-2x.jpg?v=1756716592"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AGreyish-Blue-6_resolution-standardv2-2x_1024x1024.jpg?v=1756716592"
			},
			{
				"id": 47319427612922,
				"title": "Dark Grey",
				"option1": "Dark Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH18035-C-Dark Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025361891578,
					"product_id": 8780124061946,
					"position": 15,
					"created_at": "2025-05-21T15:09:22+08:00",
					"updated_at": "2025-09-01T16:49:52+08:00",
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-1_resolution-standardv2-2x.jpg?v=1756716592",
					"variant_ids": [
						47319427612922
					]
				},
				"available": true,
				"name": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - Dark Grey",
				"public_title": "Dark Grey",
				"options": [
					"Dark Grey"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064146260218,
					"position": 15,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ADark-Grey-1_resolution-standardv2-2x.jpg?v=1756716592"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ADark-Grey-6-1_resolution-standardv2-2x_1024x1024.jpg?v=1756716592"
			},
			{
				"id": 47319427645690,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFH18035-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025364185338,
					"product_id": 8780124061946,
					"position": 22,
					"created_at": "2025-05-21T15:09:44+08:00",
					"updated_at": "2025-09-01T16:49:52+08:00",
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ATeal-1_resolution-standardv2-2x.jpg?v=1756716592",
					"variant_ids": [
						47319427645690
					]
				},
				"available": true,
				"name": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 11700,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064147603706,
					"position": 22,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ATeal-1_resolution-standardv2-2x.jpg?v=1756716592"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATeal-6-3_resolution-standardv2-2x_1024x1024.jpg?v=1756716592"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/ASand-1_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-beige.jpg?v=1761211508",
			"//thehues.com/cdn/shop/files/ASand-2_resolution-standardv2-2x.jpg?v=1756716628",
			"//thehues.com/cdn/shop/files/ASand-3_resolution-standardv2-2x.jpg?v=1756716628",
			"//thehues.com/cdn/shop/files/ASand-4_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ASand-5_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ASand-6-1_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/AGreyish-Blue-1_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/AGreyish-Blue-2_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/AGreyish-Blue-3_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-grayishblue.jpg?v=1761211508",
			"//thehues.com/cdn/shop/files/AGreyish-Blue-4_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/AGreyish-Blue-5_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/AGreyish-Blue-6_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ADark-Grey-1_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ADark-Grey-2_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ADark-Grey-3_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-black.jpg?v=1761211508",
			"//thehues.com/cdn/shop/files/ADark-Grey-4_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ADark-Grey-5_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ADark-Grey-6-1_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ATeal-1_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ATeal-2_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ATeal-3_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-teal.jpg?v=1761211508",
			"//thehues.com/cdn/shop/files/ATeal-4_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ATeal-5_resolution-standardv2-2x.jpg?v=1756716592",
			"//thehues.com/cdn/shop/files/ATeal-6-3_resolution-standardv2-2x.jpg?v=1756716592"
		],
		"featured_image": "//thehues.com/cdn/shop/files/ASand-1_resolution-standardv2-2x_1024x1024.jpg?v=1756716592",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147374330,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-1_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-1_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36701172203770,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-beige.jpg?v=1761211508"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-beige.jpg?v=1761211508",
				"width": 3072
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147407098,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-2_resolution-standardv2-2x.jpg?v=1756716628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-2_resolution-standardv2-2x.jpg?v=1756716628",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147439866,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-3_resolution-standardv2-2x.jpg?v=1756716628"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-3_resolution-standardv2-2x.jpg?v=1756716628",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147472634,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-4_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-4_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147505402,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-5_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-5_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147341562,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ASand-6-1_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ASand-6-1_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146489594,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-1_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-1_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146555130,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-2_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-2_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146587898,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-3_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-3_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36701172171002,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-grayishblue.jpg?v=1761211508"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-grayishblue.jpg?v=1761211508",
				"width": 3072
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146620666,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-4_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-4_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146653434,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-5_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-5_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146456826,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-6_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGreyish-Blue-6_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146260218,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-1_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADark-Grey-1_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146292986,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-2_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADark-Grey-2_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146325754,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-3_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADark-Grey-3_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36701172138234,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-black.jpg?v=1761211508"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-black.jpg?v=1761211508",
				"width": 3072
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146358522,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-4_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADark-Grey-4_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146391290,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-5_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADark-Grey-5_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064146227450,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ADark-Grey-6-1_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ADark-Grey-6-1_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147603706,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-1_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-1_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147636474,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-2_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-2_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147669242,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-3_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-3_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36701172236538,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-teal.jpg?v=1761211508"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/miami-fishtail-patterned-waterproof-custom-outdoor-curtain-teal.jpg?v=1761211508",
				"width": 3072
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147702010,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-4_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-4_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147734778,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-5_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-5_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			},
			{
				"alt": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064147570938,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-6-3_resolution-standardv2-2x.jpg?v=1756716592"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-6-3_resolution-standardv2-2x.jpg?v=1756716592",
				"width": 2000
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Miami waterproof UV-protective outdoor curtains combine functionality with style.</p>",
		"url": "/products/miami-fishtail-patterned-waterproof-custom-outdoor-curtain",
		"regular_price": "$117.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	},
	{
		"id": 8780124160250,
		"title": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain",
		"handle": "munich-woven-patterned-textured-waterproof-custom-outdoor-curtain",
		"product_details": `<h3>Specifications</h3><p>Material: 100% Polyester<br>Weight: 350 g/m²<br>Features: UV protection, Fade &amp; Water resistant<br>One Panel Included: Yes</p><p></p><h3>Care</h3><p>Do Not Wash</p><p>Dryer Safe</p><p>Do Not Bleach</p><p>Iron on Low Temp</p><p>Dry Clean Allowed</p>`,
		"description": "<p>Munich waterproof UV-protective outdoor curtains with a tightly woven texture combine durability and elegance.</p>",
		"published_at": "2025-05-07T16:31:12+08:00",
		"created_at": "2025-05-07T16:31:12+08:00",
		"vendor": "TheHues",
		"type": "",
		"tags": [
			"20% Off Sale",
			"All Curtains",
			"All Curtains > New Outdoor Curtains",
			"Bestseller",
			"Curtains",
			"Curtains & Shades",
			"Curtains > Custom Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Solid Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Synthetic Outdoor Curtains",
			"Curtains > Custom Outdoor Curtains > Waterproof Curtains",
			"Curtains > Synthetic Curtains",
			"Custom Outdoor Curtains & Sun Shade Sails Collection",
			"Extra 10%",
			"flash_categories",
			"Independence Day",
			"july sale",
			"New Content",
			"Outsourced products",
			"Sale",
			"Sale > All Curtain Sale",
			"Sale > All Outdoor Curtains Sale",
			"Search curtains",
			"Search outdoor",
			"Search outdoor curtains",
			"Search waterproof curtain"
		],
		"price": 12100,
		"price_min": 12100,
		"price_max": 12100,
		"available": true,
		"price_varies": false,
		"compare_at_price": null,
		"compare_at_price_min": 0,
		"compare_at_price_max": 0,
		"compare_at_price_varies": false,
		"variants": [
			{
				"id": 47319420829946,
				"title": "Wheat",
				"option1": "Wheat",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18043-C-Wheat",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025386172666,
					"product_id": 8780124160250,
					"position": 1,
					"created_at": "2025-05-21T15:11:36+08:00",
					"updated_at": "2025-09-02T16:19:51+08:00",
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AWheat-13_resolution-standardv2-2x.jpg?v=1756801191",
					"variant_ids": [
						47319420829946
					]
				},
				"available": true,
				"name": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - Wheat",
				"public_title": "Wheat",
				"options": [
					"Wheat"
				],
				"price": 12100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064159727866,
					"position": 1,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AWheat-13_resolution-standardv2-2x.jpg?v=1756801191"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AWheat-12_resolution-standardv2-2x_1024x1024.jpg?v=1756801287"
			},
			{
				"id": 47319420862714,
				"title": "Grey",
				"option1": "Grey",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18043-C-Grey",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025383551226,
					"product_id": 8780124160250,
					"position": 9,
					"created_at": "2025-05-21T15:11:21+08:00",
					"updated_at": "2025-09-02T16:19:51+08:00",
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/AGrey-7_resolution-standardv2-2x.jpg?v=1756801191",
					"variant_ids": [
						47319420862714
					]
				},
				"available": true,
				"name": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - Grey",
				"public_title": "Grey",
				"options": [
					"Grey"
				],
				"price": 12100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064158155002,
					"position": 9,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/AGrey-7_resolution-standardv2-2x.jpg?v=1756801191"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/AGrey-6_resolution-standardv2-2x_1024x1024.jpg?v=1756801191"
			},
			{
				"id": 47319420895482,
				"title": "Teal",
				"option1": "Teal",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18043-C-Teal",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025385582842,
					"product_id": 8780124160250,
					"position": 17,
					"created_at": "2025-05-21T15:11:34+08:00",
					"updated_at": "2025-09-02T16:19:51+08:00",
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ATeal-7_resolution-standardv2-2x.jpg?v=1756801191",
					"variant_ids": [
						47319420895482
					]
				},
				"available": true,
				"name": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - Teal",
				"public_title": "Teal",
				"options": [
					"Teal"
				],
				"price": 12100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064159269114,
					"position": 17,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ATeal-7_resolution-standardv2-2x.jpg?v=1756801191"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ATeal-6-1_resolution-standardv2-2x_1024x1024.jpg?v=1756801191"
			},
			{
				"id": 47319420928250,
				"title": "Black",
				"option1": "Black",
				"option2": null,
				"option3": null,
				"sku": "THOC-142OFS18043-C-Black",
				"requires_shipping": true,
				"taxable": true,
				"featured_image": {
					"id": 44025379258618,
					"product_id": 8780124160250,
					"position": 25,
					"created_at": "2025-05-21T15:11:02+08:00",
					"updated_at": "2025-09-02T16:19:51+08:00",
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"width": 2000,
					"height": 2500,
					"src": "//thehues.com/cdn/shop/files/ABlack-7_resolution-standardv2-2x.jpg?v=1756801191",
					"variant_ids": [
						47319420928250
					]
				},
				"available": true,
				"name": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - Black",
				"public_title": "Black",
				"options": [
					"Black"
				],
				"price": 12100,
				"weight": 0,
				"compare_at_price": null,
				"inventory_management": null,
				"barcode": null,
				"featured_media": {
					"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
					"id": 36064155664634,
					"position": 25,
					"preview_image": {
						"aspect_ratio": 0.8,
						"height": 2500,
						"width": 2000,
						"src": "//thehues.com/cdn/shop/files/ABlack-7_resolution-standardv2-2x.jpg?v=1756801191"
					}
				},
				"requires_selling_plan": false,
				"selling_plan_allocations": [],
				"quantity_rule": {
					"min": 1,
					"max": null,
					"increment": 1
				},
				"product_fabric_color": "//thehues.com/cdn/shop/files/ABlack-6_resolution-standardv2-2x_1024x1024.jpg?v=1756801191"
			}
		],
		"images": [
			"//thehues.com/cdn/shop/files/AWheat-13_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-wheat.jpg?v=1761205880",
			"//thehues.com/cdn/shop/files/AWheat-1_resolution-standardv2-2x.jpg?v=1756801287",
			"//thehues.com/cdn/shop/files/AWheat-8_resolution-standardv2-2x.jpg?v=1756801287",
			"//thehues.com/cdn/shop/files/AWheat-9_resolution-standardv2-2x.jpg?v=1756801287",
			"//thehues.com/cdn/shop/files/AWheat-10_resolution-standardv2-2x.jpg?v=1756801287",
			"//thehues.com/cdn/shop/files/AWheat-11_resolution-standardv2-2x.jpg?v=1756801287",
			"//thehues.com/cdn/shop/files/AWheat-12_resolution-standardv2-2x.jpg?v=1756801287",
			"//thehues.com/cdn/shop/files/AGrey-7_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/AGrey-1-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/AGrey-2_resolution-standardv2-2x_4a9dbb35-1a33-4abd-88ee-a550a396b7cf.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/AGrey-3_resolution-standardv2-2x_0dd4c225-4ff9-40c5-97d7-a4aeaccb68af.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/AGrey-4_resolution-standardv2-2x_d8bf01e9-e7e7-4627-83cf-dc8f2ce02ee8.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/AGrey-6_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-grey.jpg?v=1761205880",
			"//thehues.com/cdn/shop/files/ATeal-7_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ATeal-1-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ATeal-2-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ATeal-3-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ATeal-4-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ATeal-5-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ATeal-6-1_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-green.jpg?v=1761205880",
			"//thehues.com/cdn/shop/files/ABlack-7_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x_b1dd4fe1-207f-4bcc-8a3b-00421d7049df.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ABlack-2_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ABlack-3_resolution-standardv2-2x_fec6b0e6-75e9-477e-9fce-b4638cd6bbe8.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ABlack-4_resolution-standardv2-2x_6a7e4796-9e19-42dd-920c-9fc9d381296c.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_4d6d7d7e-092c-4d34-9c63-101dba18d223.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/ABlack-6_resolution-standardv2-2x.jpg?v=1756801191",
			"//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-black.jpg?v=1761205880"
		],
		"featured_image": "//thehues.com/cdn/shop/files/AWheat-13_resolution-standardv2-2x_1024x1024.jpg?v=1756801191",
		"options": [
			"SELECT COLOR"
		],
		"media": [
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159727866,
				"position": 1,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-13_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-13_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710765560058,
				"position": 2,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-wheat.jpg?v=1761205880"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-wheat.jpg?v=1761205880",
				"width": 3072
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159793402,
				"position": 3,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-1_resolution-standardv2-2x.jpg?v=1756801287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-1_resolution-standardv2-2x.jpg?v=1756801287",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159826170,
				"position": 4,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-8_resolution-standardv2-2x.jpg?v=1756801287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-8_resolution-standardv2-2x.jpg?v=1756801287",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159858938,
				"position": 5,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-9_resolution-standardv2-2x.jpg?v=1756801287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-9_resolution-standardv2-2x.jpg?v=1756801287",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159891706,
				"position": 6,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-10_resolution-standardv2-2x.jpg?v=1756801287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-10_resolution-standardv2-2x.jpg?v=1756801287",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159924474,
				"position": 7,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-11_resolution-standardv2-2x.jpg?v=1756801287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-11_resolution-standardv2-2x.jpg?v=1756801287",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159695098,
				"position": 8,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AWheat-12_resolution-standardv2-2x.jpg?v=1756801287"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AWheat-12_resolution-standardv2-2x.jpg?v=1756801287",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158155002,
				"position": 9,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-7_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-7_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158187770,
				"position": 10,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-1-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-1-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158220538,
				"position": 11,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-2_resolution-standardv2-2x_4a9dbb35-1a33-4abd-88ee-a550a396b7cf.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-2_resolution-standardv2-2x_4a9dbb35-1a33-4abd-88ee-a550a396b7cf.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158253306,
				"position": 12,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-3_resolution-standardv2-2x_0dd4c225-4ff9-40c5-97d7-a4aeaccb68af.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-3_resolution-standardv2-2x_0dd4c225-4ff9-40c5-97d7-a4aeaccb68af.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158286074,
				"position": 13,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-4_resolution-standardv2-2x_d8bf01e9-e7e7-4627-83cf-dc8f2ce02ee8.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-4_resolution-standardv2-2x_d8bf01e9-e7e7-4627-83cf-dc8f2ce02ee8.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158318842,
				"position": 14,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-5_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064158122234,
				"position": 15,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/AGrey-6_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/AGrey-6_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710765363450,
				"position": 16,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-grey.jpg?v=1761205880"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-grey.jpg?v=1761205880",
				"width": 3072
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159269114,
				"position": 17,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-7_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-7_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159301882,
				"position": 18,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-1-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-1-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159334650,
				"position": 19,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-2-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-2-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159367418,
				"position": 20,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-3-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-3-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159400186,
				"position": 21,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-4-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-4-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159432954,
				"position": 22,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-5-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-5-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064159236346,
				"position": 23,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ATeal-6-1_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ATeal-6-1_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710764871930,
				"position": 24,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-green.jpg?v=1761205880"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-green.jpg?v=1761205880",
				"width": 3072
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155664634,
				"position": 25,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-7_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-7_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155697402,
				"position": 26,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x_b1dd4fe1-207f-4bcc-8a3b-00421d7049df.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-1_resolution-standardv2-2x_b1dd4fe1-207f-4bcc-8a3b-00421d7049df.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155730170,
				"position": 27,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-2_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-2_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155762938,
				"position": 28,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-3_resolution-standardv2-2x_fec6b0e6-75e9-477e-9fce-b4638cd6bbe8.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-3_resolution-standardv2-2x_fec6b0e6-75e9-477e-9fce-b4638cd6bbe8.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155795706,
				"position": 29,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-4_resolution-standardv2-2x_6a7e4796-9e19-42dd-920c-9fc9d381296c.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-4_resolution-standardv2-2x_6a7e4796-9e19-42dd-920c-9fc9d381296c.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155828474,
				"position": 30,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_4d6d7d7e-092c-4d34-9c63-101dba18d223.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-5_resolution-standardv2-2x_4d6d7d7e-092c-4d34-9c63-101dba18d223.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36064155861242,
				"position": 31,
				"preview_image": {
					"aspect_ratio": 0.8,
					"height": 2500,
					"width": 2000,
					"src": "//thehues.com/cdn/shop/files/ABlack-6_resolution-standardv2-2x.jpg?v=1756801191"
				},
				"aspect_ratio": 0.8,
				"height": 2500,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/ABlack-6_resolution-standardv2-2x.jpg?v=1756801191",
				"width": 2000
			},
			{
				"alt": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain - TheHues",
				"id": 36710763036922,
				"position": 32,
				"preview_image": {
					"aspect_ratio": 0.667,
					"height": 4608,
					"width": 3072,
					"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-black.jpg?v=1761205880"
				},
				"aspect_ratio": 0.667,
				"height": 4608,
				"media_type": "image",
				"src": "//thehues.com/cdn/shop/files/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain-black.jpg?v=1761205880",
				"width": 3072
			}
		],
		"requires_selling_plan": false,
		"selling_plan_groups": [],
		"content": "<p>Munich waterproof UV-protective outdoor curtains with a tightly woven texture combine durability and elegance.</p>",
		"url": "/products/munich-woven-patterned-textured-waterproof-custom-outdoor-curtain",
		"regular_price": "$121.00",
		"sale_price": "",
		"collections": [
			{
				"url": "/collections/advert-waterproof-curtains",
				"title": "Advert Waterproof Curtains"
			},
			{
				"url": "/collections/all-products",
				"title": "All Products"
			},
			{
				"url": "/collections/best-seller",
				"title": "Best Seller"
			},
			{
				"url": "/collections/blackout-summer",
				"title": "Blackout Summer Sale"
			},
			{
				"url": "/collections/custom-curtains",
				"title": "Custom Curtains"
			},
			{
				"url": "/collections/labor-sale",
				"title": "Labor Sale"
			},
			{
				"url": "/collections/outdoor",
				"title": "Outdoor"
			},
			{
				"url": "/collections/outdoor-curtains",
				"title": "Outdoor Curtains"
			},
			{
				"url": "/collections/quiz",
				"title": "Product Selection Quiz"
			},
			{
				"url": "/collections/sale-curtains",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/sale",
				"title": "Sale Curtains"
			},
			{
				"url": "/collections/swatch-finish2",
				"title": "swatch finish2"
			},
			{
				"url": "/collections/synthetic-curtains",
				"title": "Synthetic Curtains"
			},
			{
				"url": "/collections/synthetic-outdoor-curtains",
				"title": "Synthetic Outdoor Curtains"
			}
		]
	}
];

var productList = [
	...curtainsList1,
	...curtainsList2
];